/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/public/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 93);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(94);
} else {
  module.exports = require('./cjs/react.development.js');
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;

var _BrowserRouter2 = __webpack_require__(108);

var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);

var _HashRouter2 = __webpack_require__(114);

var _HashRouter3 = _interopRequireDefault(_HashRouter2);

var _Link2 = __webpack_require__(64);

var _Link3 = _interopRequireDefault(_Link2);

var _MemoryRouter2 = __webpack_require__(116);

var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);

var _NavLink2 = __webpack_require__(119);

var _NavLink3 = _interopRequireDefault(_NavLink2);

var _Prompt2 = __webpack_require__(122);

var _Prompt3 = _interopRequireDefault(_Prompt2);

var _Redirect2 = __webpack_require__(124);

var _Redirect3 = _interopRequireDefault(_Redirect2);

var _Route2 = __webpack_require__(65);

var _Route3 = _interopRequireDefault(_Route2);

var _Router2 = __webpack_require__(50);

var _Router3 = _interopRequireDefault(_Router2);

var _StaticRouter2 = __webpack_require__(130);

var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);

var _Switch2 = __webpack_require__(132);

var _Switch3 = _interopRequireDefault(_Switch2);

var _matchPath2 = __webpack_require__(134);

var _matchPath3 = _interopRequireDefault(_matchPath2);

var _withRouter2 = __webpack_require__(135);

var _withRouter3 = _interopRequireDefault(_withRouter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BrowserRouter = _BrowserRouter3.default;
exports.HashRouter = _HashRouter3.default;
exports.Link = _Link3.default;
exports.MemoryRouter = _MemoryRouter3.default;
exports.NavLink = _NavLink3.default;
exports.Prompt = _Prompt3.default;
exports.Redirect = _Redirect3.default;
exports.Route = _Route3.default;
exports.Router = _Router3.default;
exports.StaticRouter = _StaticRouter3.default;
exports.Switch = _Switch3.default;
exports.matchPath = _matchPath3.default;
exports.withRouter = _withRouter3.default;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alt = __webpack_require__(139);

var _alt2 = _interopRequireDefault(_alt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _alt2.default();

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var menuAction = function menuAction() {
    _classCallCheck(this, menuAction);

    this.generateActions('pageNumber', 'activityShow', 'settingShow');
};

exports.default = _alt2.default.createActions(menuAction);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _menuStore = __webpack_require__(150);

var _menuStore2 = _interopRequireDefault(_menuStore);

var _modalGeneral = __webpack_require__(151);

var _modalGeneral2 = _interopRequireDefault(_modalGeneral);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SideMenu = function (_React$Component) {
    _inherits(SideMenu, _React$Component);

    function SideMenu(props) {
        _classCallCheck(this, SideMenu);

        var _this = _possibleConstructorReturn(this, (SideMenu.__proto__ || Object.getPrototypeOf(SideMenu)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleTitleClick = _this.handleTitleClick.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.state = {
            activities: [{ menuId: 1, title: "Attendance", url: "/attendance" }, { menuId: 2, title: "Journey Planner", url: "/journeyPlanner" }, { menuId: 3, title: "Estate Manager", url: "/estate" }, { menuId: 4, title: "Incident Report", url: "/report" }, { menuId: 5, title: "Leave Application", url: "/leave" }, { menuId: 6, title: "Leave Summary", url: "/leaveInfo" }, { menuId: 7, title: "Employee Detail", url: "/userProfile" }, { menuId: 8, title: "Contractor/Condo Detail", url: "/contractor" }],
            settings: [{ menuId: 9, title: "Journey Management", url: "/journeySetting", permissionId: 10 }, { menuId: 10, title: "Employee Management", url: "/userSetting", permissionId: 5 }, { menuId: 16, title: "Team Management", url: "/teamSetting", permissionId: 11 }, { menuId: 11, title: "Contractor/Condo Management", url: "/contractorSetting", permissionId: 6 }, { menuId: 12, title: "Master CheckList", url: "/checkListSetting", permissionId: 7 }, { menuId: 17, title: "Holiday Management", url: "/holidaySetting", permissionId: 8 }, { menuId: 13, title: "Leave Management", url: "/leaveSetting", permissionId: 8 }, { menuId: 15, title: "Location Management", url: "/checkPtsSetting", permissionId: 0 }, { menuId: 14, title: "Permission Management", url: "/permissionSetting", permissionId: 9 }],
            selectedId: _menuStore2.default.getState().selectedId,
            isActivityShow: _menuStore2.default.getState().isActivityShow,
            isSettingShow: _menuStore2.default.getState().isSettingShow,
            screenWidth: 500,
            screenHeight: 500,

            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId
        };
        return _this;
    }

    _createClass(SideMenu, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _menuStore2.default.listen(this.onChange);
            _userStore2.default.listen(this.onUserChange);
            this.setState({
                screenWidth: document.documentElement.clientWidth,
                screenHeight: document.documentElement.clientHeight
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _menuStore2.default.unlisten(this.onChange);
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                selectedId: state.selectedId,
                isActivityShow: state.isActivityShow,
                isSettingShow: state.isSettingShow
            });
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'handleTitleClick',
        value: function handleTitleClick(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            if (index == 0) {
                _menuAction2.default.activityShow(!this.state.isActivityShow);
            } else if (index == 1) {
                _menuAction2.default.settingShow(!this.state.isSettingShow);
            }
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var target = e.target;
            var selectedId = parseInt(target.getAttribute('data-id'));
            var url = target.getAttribute('data-url');
            if (this.state.selectedId != selectedId) {
                this.navigateOtherPage(url);
                _menuAction2.default.pageNumber(selectedId);
                _menuAction2.default.activityShow(false);
                _menuAction2.default.settingShow(false);
            }
        }
    }, {
        key: 'navigateOtherPage',
        value: function navigateOtherPage(url) {
            this.props.history.push(url);
        }
    }, {
        key: 'renderList',
        value: function renderList(data) {
            var _this2 = this;

            var userId = this.state.userId;

            if (userId && userId.includes("TG0") && userId != "ITG001") {
                data = data.filter(function (menu) {
                    return [1, 5, 6, 7].indexOf(menu.menuId) > -1;
                });
            } else if (userId == "ITG001") {
                data = data.filter(function (menu) {
                    return [1, 4, 5, 6, 7].indexOf(menu.menuId) > -1;
                });
            }
            data = data.filter(function (menu) {
                return _genFunction2.default.hasPermission(_this2.state.permission, menu.permissionId);
            });

            return data.map(function (menu, index) {
                var isSelected = _this2.state.selectedId == menu.menuId ? true : false;
                return _react2.default.createElement(
                    'a',
                    { className: "list-group-item " + (isSelected ? "active" : ""),
                        onClick: _this2.handleClick,
                        'data-id': menu.menuId,
                        'data-url': menu.url,
                        key: index },
                    menu.title
                );
            });
        }
    }, {
        key: 'renderSetList',
        value: function renderSetList(data, category) {
            var _this3 = this;

            data = data.filter(function (menu) {
                return _genFunction2.default.hasPermission(_this3.state.permission, menu.permissionId);
            });

            return data.map(function (menu, index) {
                var isSelected = _this3.state.selectedId == menu.menuId ? true : false;
                return _react2.default.createElement(
                    'a',
                    { className: "list-group-item " + (isSelected ? "active" : ""),
                        onClick: _this3.handleClick,
                        'data-id': menu.menuId,
                        'data-url': menu.url,
                        key: index },
                    menu.title
                );
            });
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(e) {
            e.preventDefault();
            e.stopPropagation();
            if (e.deltaY > 0) {
                //scroll down
                _reactDom2.default.findDOMNode(this.refs.sideNav).scrollTop += 50;
            } else {
                //scroll up
                _reactDom2.default.findDOMNode(this.refs.sideNav).scrollTop -= 50;
            }
        }
    }, {
        key: 'render',
        value: function render() {

            var styleActivity = '';
            var styleSetting = '';
            var menuHeight = "auto";
            var overflow = "visible";
            if (this.state.screenWidth < 768) {
                if (this.state.isSettingShow) {
                    styleSetting = this.props.active;
                } else {
                    styleSetting = this.props.inActive;
                }
                if (this.state.isActivityShow) {
                    styleActivity = this.props.active;
                } else {
                    styleActivity = this.props.inActive;
                }
            } else {
                menuHeight = this.state.screenHeight - 60 + "px";
                overflow = "auto";
            }
            var setting = this.renderSetList(this.state.settings, 1);
            var st = void 0;

            if (setting.length > 0) {
                st = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'setting-title', 'data-index': '1', onClick: this.handleTitleClick },
                        'Settings'
                    ),
                    _react2.default.createElement(
                        'div',
                        { id: 'nav-setting', className: 'sm-wp' },
                        _react2.default.createElement(
                            'div',
                            { className: 'list-group', style: { visibility: styleSetting.visibility, height: styleSetting.height } },
                            setting
                        )
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'col-sm-4 col-md-2 ' },
                _react2.default.createElement(
                    'div',
                    { className: 'a4-nav', ref: 'sideNav', onWheel: this.handleScroll,
                        style: { height: menuHeight, overflow: overflow } },
                    _react2.default.createElement(
                        'div',
                        { className: 'setting-title', 'data-index': '0', onClick: this.handleTitleClick },
                        'Activities'
                    ),
                    _react2.default.createElement(
                        'div',
                        { id: 'sm-categories', className: 'sm-wp' },
                        _react2.default.createElement(
                            'div',
                            { className: 'list-group', style: { visibility: styleActivity.visibility, height: styleActivity.height } },
                            this.renderList(this.state.activities, 0)
                        )
                    ),
                    st
                ),
                _react2.default.createElement(_modalGeneral2.default, null)
            );
        }
    }]);

    return SideMenu;
}(_react2.default.Component);

SideMenu.defaultProps = {
    active: {
        visibility: "visible",
        height: "100%"
    },
    inActive: {
        visibility: "hidden",
        height: "0"
    }
};
exports.default = SideMenu;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Loading = function (_React$Component) {
    _inherits(Loading, _React$Component);

    function Loading(props) {
        _classCallCheck(this, Loading);

        return _possibleConstructorReturn(this, (Loading.__proto__ || Object.getPrototypeOf(Loading)).call(this, props));
    }

    _createClass(Loading, [{
        key: 'render',
        value: function render() {
            var content = "";

            if (this.props.processing) {
                content = _react2.default.createElement(
                    'div',
                    { className: 'loading' },
                    _react2.default.createElement('div', { className: 'loader' })
                );
            }
            return _react2.default.createElement(
                'div',
                null,
                content
            );
        }
    }]);

    return Loading;
}(_react2.default.Component);

exports.default = Loading;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _userAction = __webpack_require__(21);

var _userAction2 = _interopRequireDefault(_userAction);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavBar = function (_React$Component) {
    _inherits(NavBar, _React$Component);

    function NavBar(props) {
        _classCallCheck(this, NavBar);

        var _this = _possibleConstructorReturn(this, (NavBar.__proto__ || Object.getPrototypeOf(NavBar)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleLogout = _this.handleLogout.bind(_this);
        _this.state = {
            userName: _userStore2.default.getState().userName,
            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            isUserLogin: _userStore2.default.getState().isUserLogin,
            staffId: _userStore2.default.getState().staffId,
            toggle: false
        };
        return _this;
    }

    _createClass(NavBar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _userStore2.default.listen(this.onChange);
            if (!sessionStorage.getItem('ui')) {
                this.props.history.push('/');
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _userStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevState, prevProps) {
            if (!sessionStorage.getItem('ui')) {
                console.log('pass here');
                this.props.history.push('/');
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                userName: state.userName,
                isUserLogin: state.isUserLogin,
                staffId: state.staffId,
                permission: state.permission,
                subordinate: state.subordinate
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick() {
            this.setState({ toggle: !this.state.toggle });
        }
    }, {
        key: 'handleLogout',
        value: function handleLogout() {
            _userAction2.default.logout();
        }
    }, {
        key: 'render',
        value: function render() {
            var loginCt = "";
            var display = this.state.toggle ? "block" : "none";

            if (this.state.isUserLogin) {
                loginCt = _react2.default.createElement(
                    'ul',
                    { className: 'nav navbar-nav navbar-right' },
                    _react2.default.createElement(
                        'li',
                        { className: 'dropdown', onClick: this.handleClick },
                        _react2.default.createElement(
                            'a',
                            { className: 'dropdown-toggle', 'data-toggle': 'dropdown', role: 'button' },
                            'Welcome, ',
                            this.state.userName,
                            ' ',
                            _react2.default.createElement('span', { className: 'glyphicon glyphicon-triangle-bottom' })
                        ),
                        _react2.default.createElement(
                            'ul',
                            { className: 'dropdown-menu', style: { display: display } },
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { to: '/leave/' + this.state.staffId },
                                    'Apply Leave'
                                )
                            ),
                            this.state.subordinate.length > 0 || _genFunction2.default.hasPermission(this.state.permission, 2) ? _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { to: '/apply/leaveAtd' },
                                    'Apply Attendance/Leave for Staff'
                                )
                            ) : "",
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { to: '/report/create' },
                                    'Create Incident Report'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { to: '/attendance/' + this.state.staffId },
                                    'Time In/Out'
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { to: '/changePassword' },
                                    'Change Password'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-default btn-lgout', onClick: this.handleLogout },
                            'Logout'
                        )
                    )
                );
            }
            return _react2.default.createElement(
                'nav',
                { className: 'nav navbar navbar-default navbar-fixed-top' },
                _react2.default.createElement(
                    'div',
                    { className: 'container-fluid' },
                    _react2.default.createElement(
                        'span',
                        { className: 'navbar-brand' },
                        'A4 International'
                    ),
                    loginCt
                )
            );
        }
    }]);

    return NavBar;
}(_react2.default.Component);

exports.default = NavBar;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _userAction = __webpack_require__(21);

var _userAction2 = _interopRequireDefault(_userAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var userStore = function () {
    function userStore() {
        _classCallCheck(this, userStore);

        this.bindActions(_userAction2.default);
        this.role = 0;
        this.staffId = 0;
        this.userName = "";
        this.userImage = "";
        this.warningMsg = "";
        this.token = "";
        this.subordinate = [];
        this.permission = [];
        this.processing = false;
        this.isUserLogin = false;
        this.isNewUser = false;
        this.isPwdReset = false;
        this.isfgPwdReset = false;
        this.isPasswordChange = false;
        this.isfgPwdSend = false;
    }

    _createClass(userStore, [{
        key: 'onProcessing',
        value: function onProcessing(data) {
            this.processing = data;
        }
    }, {
        key: 'onWarningMsg',
        value: function onWarningMsg(data) {
            this.warningMsg = data;
        }
    }, {
        key: 'onIsfgPwdSend',
        value: function onIsfgPwdSend(data) {
            this.isfgPwdSend = data;
        }
    }, {
        key: 'onUserLoginSuccess',
        value: function onUserLoginSuccess(data) {

            if (!data.isNewUser) {
                this.role = data.role;
                this.staffId = data.staffId;
                this.userName = data.userName;
                this.userImage = data.userImage;
                this.subordinate = data.subordinate;
                this.permission = data.permission;
                this.isUserLogin = true;
                this.isNewUser = false;

                sessionStorage.setItem('ui', data.token);
            } else {
                this.isUserLogin = true;
                this.isNewUser = data.isNewUser;
                this.token = data.token;
                this.staffId = data.staffId;
                this.userName = data.userName;
                this.userImage = data.userImage;
                this.subordinate = data.subordinate;
                this.permission = data.permission;
            }
        }
    }, {
        key: 'onUserLoginFail',
        value: function onUserLoginFail() {
            this.isUserLogin = false;
            sessionStorage.clear();
        }
    }, {
        key: 'onResetPasswordSuccess',
        value: function onResetPasswordSuccess(data) {
            this.warningMsg = "Password reset successfully";
            this.isPwdReset = true;
            this.isNewUser = false;
            sessionStorage.setItem('ui', data);
        }
    }, {
        key: 'onResetFgPasswordSuccess',
        value: function onResetFgPasswordSuccess(data) {
            this.warningMsg = "An email has sent to your mailbox";
            this.isfgPwdReset = true;
        }
    }, {
        key: 'onChangePasswordSuccess',
        value: function onChangePasswordSuccess(data) {
            this.warningMsg = "Password changed successfully";
            this.isPasswordChange = true;
        }
    }, {
        key: 'onLogout',
        value: function onLogout() {
            this.isUserLogin = false;
            this.isNewUser = false;
            sessionStorage.clear();
        }
    }]);

    return userStore;
}();

exports.default = _alt2.default.createStore(userStore, 'userStore');

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var filterAction = function () {
    function filterAction() {
        _classCallCheck(this, filterAction);

        this.generateActions('processing', 'employeeSuccess', 'condoSuccess', 'updateSuccess', 'addSuccess', 'removeSuccess', 'removeCondo', 'addCondo', 'contractorSuccess', 'removeContractorSuccess', 'addContractorSuccess', 'updateCondo', 'updateContractor', 'teamMember', 'teamCondo', 'holiday');
    }

    _createClass(filterAction, [{
        key: 'getHoliday',
        value: function getHoliday() {
            var _this = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/holiday', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var result = JSON.parse(xhttp.responseText);
                            _this.holiday(result);
                        } else {
                            //handle error
                        }
                        _this.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'getTeamCondo',
        value: function getTeamCondo() {
            var _this2 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/team/condo', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var result = JSON.parse(xhttp.responseText);
                            _this2.teamCondo(result);
                        } else {
                            //handle error
                        }
                        _this2.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'getTeamMember',
        value: function getTeamMember() {
            var _this3 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/team/member', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var result = JSON.parse(xhttp.responseText);
                            _this3.teamMember(result);
                        } else {
                            //handle error
                        }
                        _this3.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'getContractors',
        value: function getContractors() {
            var _this4 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/contractors', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var result = JSON.parse(xhttp.responseText);
                            _this4.contractorSuccess(result);
                        } else {
                            //handle error
                        }
                        _this4.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'getEmployee',
        value: function getEmployee() {
            var _this5 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/employee', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var result = JSON.parse(xhttp.responseText);
                            _this5.employeeSuccess(result);
                        } else {
                            //handle error
                        }
                        _this5.processing(false);
                    }
                };
                xhttp.send(null);
            }

            this.processing(false);
            return true;
        }
    }, {
        key: 'getCondoList',
        value: function getCondoList() {
            var _this6 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/condo', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var result = JSON.parse(xhttp.responseText);
                            _this6.condoSuccess(result);
                        } else {
                            //handle error
                        }
                        _this6.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }]);

    return filterAction;
}();

exports.default = _alt2.default.createActions(filterAction);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(98);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    hasPermission: function hasPermission(userPms, permission) {
        var len = userPms.length;
        var hasPermission = false;
        if ((permission == "" || permission == null) && typeof permission != 'number') return true;
        for (var i = 0; i < len; i++) {
            if (userPms[i] == permission) {
                hasPermission = true;
                break;
            }
        }
        return hasPermission;
    },
    isSubordinate: function isSubordinate(subordinate, staffId) {
        var isSubordinate = false;
        var len = subordinate.length;
        for (var i = 0; i < len; i++) {
            if (subordinate[i] == staffId) {
                isSubordinate = true;
                break;
            }
        }

        return isSubordinate;
    },
    isUser: function isUser(userId, staffId) {
        var isUser = false;
        if (userId == staffId) {
            isUser = true;
        }
        return isUser;
    },
    isMember: function isMember(teamMember, staffId) {
        var isMember = false;
        for (var i = 0; i < teamMember.length; i++) {
            if (teamMember[i] == staffId) {
                isMember = true;
                break;
            }
        }

        return isMember;
    },
    hasCondo: function hasCondo(teamCondo, mcst) {
        var hasCondo = false;
        var len = teamCondo.length;
        for (var i = 0; i < len; i++) {
            if (teamCondo[i].mcst == mcst) {
                hasCondo = true;
                break;
            }
        }
        return hasCondo;
    }
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var modalAction = function modalAction() {
    _classCallCheck(this, modalAction);

    this.generateActions('modalContent', 'modalClose');
};

exports.default = _alt2.default.createActions(modalAction);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var filterStore = function () {
    function filterStore() {
        _classCallCheck(this, filterStore);

        this.bindActions(_filterAction2.default);
        this.processing = false;
        this.iniLoadStaff = false;
        this.iniLoadCondo = false;
        this.iniLoadContractor = false;
        this.iniLoadTeamMember = false;
        this.iniLoadTeamCondo = false;
        this.iniLoadHoliday = false;
        this.staffs = [];
        this.condos = [];
        this.contractors = [];
        this.teamMember = [];
        this.teamCondo = [];
        this.holiday = {};
    }

    _createClass(filterStore, [{
        key: 'onEmployeeSuccess',
        value: function onEmployeeSuccess(data) {
            this.staffs = data;
            this.iniLoadStaff = true;
        }
    }, {
        key: 'onCondoSuccess',
        value: function onCondoSuccess(data) {
            this.condos = data;
            this.iniLoadCondo = true;
        }
    }, {
        key: 'onTeamCondo',
        value: function onTeamCondo(data) {
            this.teamCondo = data;
            this.iniLoadTeamCondo = true;
        }
    }, {
        key: 'onProcessing',
        value: function onProcessing(data) {
            this.processing = data;
        }
    }, {
        key: 'onHoliday',
        value: function onHoliday(data) {
            this.holiday = data;
            this.iniLoadHoliday = true;
        }
    }, {
        key: 'onUpdateSuccess',
        value: function onUpdateSuccess(data) {
            var len = this.staffs.length;
            for (var i = 0; i < len; i++) {
                if (this.staffs[i].staffId = data.staffId) {
                    this.staffs[i].role = data.role;
                    this.staffs[i].userName = data.userName;
                    this.staffs[i].userImage = data.userImage;
                    this.staffs[i].email = data.email;
                    break;
                }
            }
        }
    }, {
        key: 'onUpdateCondo',
        value: function onUpdateCondo(data) {
            var len = this.condos.length;
            for (var i = 0; i < len; i++) {
                if (this.condos[i].mcst == data.prevMCST) {
                    this.condos[i].mcst = data.newMCST;
                    this.condos[i].condoName = data.condoName;
                    break;
                }
            }
        }
    }, {
        key: 'onContractorSuccess',
        value: function onContractorSuccess(data) {
            this.contractors = data;
            this.iniLoadContractor = true;
        }
    }, {
        key: 'onAddSuccess',
        value: function onAddSuccess(data) {
            this.staffs = this.staffs.concat(data);
        }
    }, {
        key: 'onTeamMember',
        value: function onTeamMember(data) {
            this.teamMember = data;
            this.iniLoadTeamMember = true;
        }
    }, {
        key: 'onRemoveSuccess',
        value: function onRemoveSuccess(data) {
            var len = this.staffs.length,
                pos = -1;
            for (var i = 0; i < len; i++) {
                if (this.staffs[i].staffId = data) {
                    pos = i;
                    break;
                }
            }
            if (pos != -1) {
                this.staffs.splice(pos, 1);
            }
        }
    }, {
        key: 'onRemoveCondo',
        value: function onRemoveCondo(data) {
            var len = this.condos.length;
            for (var i = 0; i < len; i++) {
                if (this.condos[i].mcst = data) {
                    this.condos.splice(i, 1);
                    break;
                }
            }
        }
    }, {
        key: 'onAddCondo',
        value: function onAddCondo(data) {
            this.condos.push(data);
        }
    }, {
        key: 'onRemoveContractorSuccess',
        value: function onRemoveContractorSuccess(data) {
            var len = this.contractors.length;
            for (var i = 0; i < len; i++) {
                if (this.contractors[i]._id == data) {
                    this.contractors.splice(i, 1);
                    break;
                }
            }
        }
    }, {
        key: 'onAddContractorSuccess',
        value: function onAddContractorSuccess(data) {
            this.contractors.push({
                _id: data._id,
                contractorName: data.contractorName,
                contractorEmail: data.contractorEmail,
                telephone: data.telephone
            });
        }
    }, {
        key: 'onUpdateContractor',
        value: function onUpdateContractor(data) {
            var len = this.contractors.length;
            for (var i = 0; i < len; i++) {
                if (this.contractors[i]._id == data) {
                    this.contractors[i].contractorName = data.contractorName;
                    this.contractors[i].contractorEmail = data.contractorEmail;
                    this.contractors[i].telephone = data.telephone;
                }
            }
        }
    }]);

    return filterStore;
}();

exports.default = _alt2.default.createStore(filterStore, 'filterStore');

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function warning() {};

if (false) {
  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.length < 10 || /^[s\W]*$/.test(format)) {
      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}

module.exports = warning;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var contractorAction = function () {
    function contractorAction() {
        _classCallCheck(this, contractorAction);

        this.generateActions('processing', 'search', 'searchMode', 'mcst', 'staffId', 'warningMsg', 'contractorId', 'updating', 'contractorSuccess', 'contractorsSuccess', 'contractor', 'isNew', 'shouldListShow', 'shouldConListShow', 'addCondo', 'addWholeCondo', 'addService', 'removeCondo', 'removeWholeCondo', 'editService', 'removeService', 'clear', 'listClear', 'addAddress', 'editAddress', 'removeAddress', 'addContractorSuccess', 'removeContractorSuccess', 'updateContractorSuccess', 'updateWholeCondo', 'reset', 'staffReplaced', 'reminderEmail', 'condoSuccess');
    }

    _createClass(contractorAction, [{
        key: 'getContractor',
        value: function getContractor(contractorId) {
            var _this = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/contractor/' + contractorId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {

                            _this.contractorSuccess(result);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Message", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this.processing(false);
                    }
                };
                xhttp.send(null);
            }
            /*
            this.contractorSuccess(
                {
                    _id: "A124",
                    contractorName: "E&T Cleaning Services Pte Ltd",
                    contracts: [
                        { 
                            condoName: "Casa Jervois", 
                            mcst: "1645", 
                            contract: [
                                {
                                    service: "Cleaning", description: "Cleaning", remark: "", 
                                    contractStartDate: new Date("2016-11-15"),contractEndDate: new Date("2017-11-14"), 
                                    amount: 2400, firstReminder: new Date("2017-11-14"), secondReminder: new Date("2017-11-28")  
                                }, 
                                { 
                                    service: "Electric", description: "Electric", remark: "",
                                    contractStartDate: new Date("2016-11-15"),contractEndDate: new Date("2017-11-14"), 
                                    amount: 2400, firstReminder: new Date("2017-11-14"), secondReminder: new Date("2017-11-28")  
                                }
                            ] 
                        },
                        { 
                            condoName: "Casa Jervois2", 
                            mcst: "1646", 
                            contract: [
                                { 
                                    service: "Cleaning", description: "Cleaning", remark: "", 
                                    contractStartDate: new Date("2016-11-15"),contractEndDate: new Date("2017-11-14"), 
                                    amount: 2400, firstReminder: new Date("2017-11-14"), secondReminder: new Date("2017-11-28") 
                                }
                            ] 
                        },
                    ],
                    addresses: [
                        { address: "Blk 446 Hougang Ave 8", unitNo: "B1-1635", postal: "530446" }
                    ],
                    telephone: "",
                    fax: "",
                    contractorEmail: "crankpwr@singnet.com.sg",
                    contactName: "",
                    status: 0,
                }
            );
            this.processing(false);
            */
            return true;
        }
    }, {
        key: 'getReminder',
        value: function getReminder() {
            var _this2 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/reminder', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this2.reminderEmail(result);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Message", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this2.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'updateReminder',
        value: function updateReminder(reminderEmail) {
            var _this3 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/reminder', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            _modalAction2.default.modalContent({ title: "Successful", content: "Recipient successfully updated" });
                            _modalAction2.default.modalClose(true);
                            _this3.reminderEmail(reminderEmail);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            //handle error
                            _modalAction2.default.modalContent({ title: "Message", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this3.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({
                    reminderEmail: reminderEmail
                }));
            }
            return true;
        }
    }, {
        key: 'getCondoList',
        value: function getCondoList() {
            var _this4 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/condo/all', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var result = JSON.parse(xhttp.responseText);
                            _this4.condoSuccess(result);
                        } else {
                            //handle error
                        }
                        _this4.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
        /*
        getAllContractor() {
            if (sessionStorage.getItem('ui')) {
                const xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/contractor/all', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = () => {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            let result = JSON.parse(xhttp.responseText);
                            this.contractorsSuccess(result);
                        } else {
                            //handle error
                            modalAction.modalContent({ title: "Message", content: result.errorMsg });
                            modalAction.modalClose(true);
                        }
                        this.processing(false);
                    }
                };
                xhttp.send(null);
            }
              return true;
        }
        */

    }, {
        key: 'getContractorByFilter',
        value: function getContractorByFilter(mcst, staffId) {
            var _this5 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/contractor?mcst=' + mcst + '&staffId=' + staffId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this5.contractorsSuccess(result);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Message", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this5.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'getContractorByService',
        value: function getContractorByService(data) {
            var _this6 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/contractor/service?service=' + data, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this6.contractorsSuccess(result);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Message", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this6.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'getExpireContractor',
        value: function getExpireContractor(mcst, staffId) {
            var _this7 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/contractor/expire?mcst=' + mcst + '&staffId=' + staffId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var result = JSON.parse(xhttp.responseText);
                            _this7.contractorsSuccess(result);
                        } else {
                            //handle error
                        }
                        _this7.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'replaceStaff',
        value: function replaceStaff(oldStaffId, newStaffId, newStaffInfo) {
            var _this8 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/staff/contractor', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this8.staffReplaced(result);
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Employee has been replaced" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Message", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this8.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ oldStaffId: oldStaffId, newStaffId: newStaffId }));
            }

            return true;
        }
    }, {
        key: 'updateContractor',
        value: function updateContractor(contractor) {
            var _this9 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/contractor/' + contractor._id, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            _this9.updating(false);

                            _this9.updateContractorSuccess(contractor);
                            _filterAction2.default.updateContractor({ _id: contractor._id, contractorName: contractor.contractorName, contractorEmail: contractor.contractorEmail, telephone: contractor.telephone });
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Contractor has been updated" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this9.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ contractor: contractor }));
            }

            return true;
        }
    }, {
        key: 'removeContractor',
        value: function removeContractor(contractorId) {
            var _this10 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("DELETE", '/v1/api/contractor/' + contractorId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var result = JSON.parse(xhttp.responseText);
                            _this10.removeContractorSuccess(contractorId);
                            _filterAction2.default.removeContractorSuccess(contractorId);

                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Contractor has been removed" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            //handle error
                        }
                        _this10.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'addContractor',
        value: function addContractor(contractor) {
            var _this11 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/contractor', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var result = JSON.parse(xhttp.responseText);
                            _this11.addContractorSuccess(result);
                            _filterAction2.default.addContractorSuccess(result);

                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Contractor has been added" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            //handle error
                        }
                        _this11.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ contractor: contractor }));
            }
        }
    }, {
        key: 'getExportContractorList',
        value: function getExportContractorList(searchMode, mcst, staffId, service) {
            var _this12 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/export/contractors', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.responseType = "arraybuffer";
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            var blobUrl = URL.createObjectURL(blob);
                            var link = document.createElement("a"); // Or maybe get it from the current document
                            link.href = blobUrl;
                            link.download = "Contractor_List.xlsx";
                            document.body.appendChild(link); // Or append it whereever you 
                            link.click();
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this12.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ searchMode: searchMode, mcst: mcst, staffId: staffId, service: service }));
            }
        }
    }, {
        key: 'exportCondoCheckList',
        value: function exportCondoCheckList() {
            var _this13 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/condo/checklist/export', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.responseType = "arraybuffer";
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            var blobUrl = URL.createObjectURL(blob);
                            var link = document.createElement("a"); // Or maybe get it from the current document
                            link.href = blobUrl;
                            link.download = "CondoCheckList.xlsx";
                            document.body.appendChild(link); // Or append it whereever you 
                            link.click();
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this13.processing(false);
                    }
                };
                xhttp.send(null);
            }
        }
    }, {
        key: 'exportContractor',
        value: function exportContractor(contractorId) {
            var _this14 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/export/contractor/' + contractorId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.responseType = "arraybuffer";
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            var blobUrl = URL.createObjectURL(blob);
                            var link = document.createElement("a"); // Or maybe get it from the current document
                            link.href = blobUrl;
                            link.download = "Contractor.xlsx";
                            document.body.appendChild(link); // Or append it whereever you 
                            link.click();
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this14.processing(false);
                    }
                };
                xhttp.send(null);
            }
        }
    }]);

    return contractorAction;
}();

exports.default = _alt2.default.createActions(contractorAction);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var userSetAction = function () {
    function userSetAction() {
        _classCallCheck(this, userSetAction);

        this.generateActions('usMode', 'search', 'warningMsg', 'staffId', 'updateUser', 'userImage', 'processing', 'updateSuccess', 'addSuccess', 'removeSuccess', 'isSucceed', 'userDetailSuccess', 'updating', 'updateUserDetail', 'clear', 'supervisor', 'permissionListSuccess', 'permission', 'team', 'removedTeam');
    }

    _createClass(userSetAction, [{
        key: 'addNewUser',
        value: function addNewUser(fd) {
            var _this = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/employee/', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {

                            _this.addSuccess(result);
                            _filterAction2.default.addSuccess(result);

                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "The employee detail has been added" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            //handle error

                            //show error message
                            _modalAction2.default.modalContent({ title: "Something Went Wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this.processing(false);
                    }
                };
                xhttp.send(fd);
            }
            return true;
        }
    }, {
        key: 'userDetail',
        value: function userDetail(staffId) {
            var _this2 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/employee/' + staffId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var result = JSON.parse(xhttp.responseText);
                            _this2.userDetailSuccess(result);
                        } else {
                            //handle error
                            //show error message
                            _modalAction2.default.modalContent({ title: "Something Went Wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this2.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'editUser',
        value: function editUser(staffId, fd) {
            var _this3 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/employee/' + staffId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var result = JSON.parse(xhttp.responseText);
                            _this3.updateSuccess(result);
                            _filterAction2.default.updateSuccess(result);

                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "The employee detail has been updated" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            //handle error
                            //show error message
                            _modalAction2.default.modalContent({ title: "Something Went Wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this3.processing(false);
                    }
                };
                xhttp.send(fd);
            }
            return true;
        }
    }, {
        key: 'removeUser',
        value: function removeUser(staffId) {
            var _this4 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("DELETE", '/v1/api/employee/' + staffId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {

                        if (xhttp.status == 200) {

                            _this4.removeSuccess(staffId);
                            _filterAction2.default.removeSuccess(staffId);

                            //show success message
                            _modalAction2.default.modalContent({ title: "Deleted", content: "The employee detail has been removed" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            //handle error
                            //show error message
                            _modalAction2.default.modalContent({ title: "Something Went Wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this4.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'getPermissionList',
        value: function getPermissionList() {
            var _this5 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/permission/list', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var result = JSON.parse(xhttp.responseText);
                            _this5.permissionListSuccess(result);
                        } else {
                            //handle error
                            //show error message
                            _modalAction2.default.modalContent({ title: "Something Went Wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this5.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'getTeam',
        value: function getTeam() {
            var _this6 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/team', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var result = JSON.parse(xhttp.responseText);
                            _this6.team(result);
                        } else {
                            //handle error
                            //show error message
                            _modalAction2.default.modalContent({ title: "Something Went Wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this6.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'updateTeam',
        value: function updateTeam(team, removedTeam) {
            var _this7 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/team', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            _modalAction2.default.modalContent({ title: "Successful", content: "Team updated successfully" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            //handle error
                            //show error message
                            _modalAction2.default.modalContent({ title: "Something Went Wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this7.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ team: team, removedTeam: removedTeam }));
            }

            return true;
        }
    }]);

    return userSetAction;
}();

exports.default = _alt2.default.createActions(userSetAction);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(109)();
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var attdAction = function () {
    function attdAction() {
        _classCallCheck(this, attdAction);

        this.generateActions('search', 'processing', 'getAllStaffAtdSuccess', 'getStaffAtdSuccess', 'selectedMonth', 'shouldListShow', 'shouldDDListShow', 'updateAttandanceSuccess', 'attendanceId', 'closeListShow', 'attendanceCheckSuccess', 'canSubmit');
    }

    _createClass(attdAction, [{
        key: 'checkInitAttendance',
        value: function checkInitAttendance() {
            var _this = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/attendance/officeCheck', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this.attendanceCheckSuccess(result);
                            _this.canSubmit(true);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this.processing(false);
                    }
                };
                xhttp.send(null);
            }
        }
    }, {
        key: 'timeIn',
        value: function timeIn(remark) {
            var _this2 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/attendance/officeIn', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this2.attendanceId(result);
                            _modalAction2.default.modalContent({ title: "Time In", content: "Done. Data recorded" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this2.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ remark: remark }));
            }
            return true;
        }
    }, {
        key: 'timeOut',
        value: function timeOut(attendanceId, remark) {
            var _this3 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/attendance/officeOut', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this3.attendanceId("");
                            _modalAction2.default.modalContent({ title: "Time Out", content: "Done. Data recorded" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this3.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ _id: attendanceId, remark: remark }));
            }
            return true;
        }
    }, {
        key: 'getAllStaffAttendance',
        value: function getAllStaffAttendance(year, month) {
            var _this4 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/allStaffAttendance?year=' + year + "&month=" + month, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {

                            _this4.getAllStaffAtdSuccess(result);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this4.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'getStaffAttendance',
        value: function getStaffAttendance(staffId, year, month) {
            var _this5 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/staffAttendance/' + staffId + "?year=" + year + "&month=" + month, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {

                            _this5.getStaffAtdSuccess(result);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this5.processing(false);
                    }
                };
                xhttp.send(null);
            }

            //this.processing(false);
            return true;
        }
    }, {
        key: 'exportAllStaffAttendance',
        value: function exportAllStaffAttendance(year, month) {
            var _this6 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/export/allStaffAttendance', true);
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));

                xhttp.responseType = "arraybuffer";
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            var blobUrl = URL.createObjectURL(blob);
                            var link = document.createElement("a"); // Or maybe get it from the current document
                            link.href = blobUrl;
                            link.download = "AttendanceReport_All_" + year + "-" + (month + 1) + ".xlsx";
                            document.body.appendChild(link); // Or append it whereever you 
                            link.click();
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this6.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ year: year, month: month }));
            }
            return true;
        }
    }, {
        key: 'exportStaffAttendance',
        value: function exportStaffAttendance(staffId, year, month) {
            var _this7 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/export/staffAttendance/' + staffId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.responseType = "arraybuffer";
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            var blobUrl = URL.createObjectURL(blob);
                            var link = document.createElement("a"); // Or maybe get it from the current document
                            link.href = blobUrl;
                            link.download = staffId + "AttendanceReport_" + staffId + "_" + year + "-" + (month + 1) + ".xlsx";
                            document.body.appendChild(link); // Or append it whereever you 
                            link.click();
                        } else {

                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }

                        _this7.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ year: year, month: month }));
            }
            return true;
        }
    }, {
        key: 'updateAttandance',
        value: function updateAttandance(_id, staffId, year, month, date, startTime, endTime, startRemark, endRemark) {
            var _this8 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/staffAttendance/' + staffId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this8.updateAttandanceSuccess(result);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this8.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({
                    _id: _id,
                    year: year,
                    month: month,
                    date: date,
                    startTime: startTime,
                    endTime: endTime,
                    startRemark: startRemark,
                    endRemark: endRemark
                }));
            }
            return true;
        }
    }]);

    return attdAction;
}();

exports.default = _alt2.default.createActions(attdAction);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var leaveAction = function () {
    function leaveAction() {
        _classCallCheck(this, leaveAction);

        this.generateActions('processing', 'getLASuccess', 'search', 'updateSM', 'updateEM', 'updateUI', 'summarySuccess', 'warningMsg', 'shouldListShow', 'changeStatusSuccess', 'clear', 'summaryClear', 'uploadMCSuccess', 'uploadRPSuccess', 'isLeaveSuccess', 'closeListShow');
    }

    _createClass(leaveAction, [{
        key: 'getLA',
        value: function getLA(staffId, startYear, startMonth, endYear, endMonth) {
            var _this = this;

            if (sessionStorage.getItem('ui')) {
                var queryParams = "?staffId=" + staffId + "&startYear=" + startYear + "&startMonth=" + startMonth + "&endYear=" + endYear + "&endMonth=" + endMonth;

                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/leave' + queryParams, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this.getLASuccess(result);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'changeStatus',
        value: function changeStatus(id, action, staffId) {
            var _this2 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/leave/status/' + id, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this2.changeStatusSuccess(result);
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "You have changed the status" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this2.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ action: action, staffId: staffId }));
            }
            return true;
        }
    }, {
        key: 'uploadMC',
        value: function uploadMC(id, fd) {
            var _this3 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/leave/mc/' + id, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));

                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this3.uploadMCSuccess(result);
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Your MC successfully uploaded" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this3.processing(false);
                    }
                };
                xhttp.send(fd);
            }
            return true;
        }
    }, {
        key: 'uploadReceipt',
        value: function uploadReceipt(id, fd) {
            var _this4 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/leave/receipt/' + id, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));

                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this4.uploadRPSuccess(result);
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Your receipt successfully uploaded" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this4.processing(false);
                    }
                };
                xhttp.send(fd);
            }
            return true;
        }
    }, {
        key: 'exportSummary',
        value: function exportSummary(staffId) {
            var _this5 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/export/leaveSummary', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.responseType = "arraybuffer";
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            var blobUrl = URL.createObjectURL(blob);
                            var link = document.createElement("a"); // Or maybe get it from the current document
                            link.href = blobUrl;
                            link.download = "Leave_Summary_" + staffId + ".xlsx";
                            document.body.appendChild(link); // Or append it whereever you 
                            link.click();
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this5.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ staffId: staffId }));
            }
            return true;
        }
    }, {
        key: 'exportAllSummary',
        value: function exportAllSummary() {
            var _this6 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/export/leaveSummary/all', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.responseType = "arraybuffer";
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            var blobUrl = URL.createObjectURL(blob);
                            var link = document.createElement("a"); // Or maybe get it from the current document
                            link.href = blobUrl;
                            link.download = "Leave_Summary_All.xlsx";
                            document.body.appendChild(link); // Or append it whereever you 
                            link.click();
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this6.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'exportLA',
        value: function exportLA(staffId, startYear, startMonth, endYear, endMonth) {
            var _this7 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/export/leave', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.responseType = "arraybuffer";
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            var blobUrl = URL.createObjectURL(blob);
                            var link = document.createElement("a"); // Or maybe get it from the current document
                            link.href = blobUrl;
                            link.download = "Leave_Application_Report_" + startYear + "-" + (startMonth + 1) + ".xlsx";
                            document.body.appendChild(link); // Or append it whereever you 
                            link.click();
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this7.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ staffId: staffId, startYear: startYear, startMonth: startMonth, endYear: endYear, endMonth: endYear }));
            }
            return true;
        }
    }, {
        key: 'getSummary',
        value: function getSummary(staffId) {
            var _this8 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/leave/summary/' + staffId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this8.summarySuccess(result);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this8.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'applyLeave',
        value: function applyLeave(fd) {
            var _this9 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/leave/apply', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));

                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {

                        if (xhttp.status == 200) {
                            _this9.isLeaveSuccess(true);
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Leave applied. The page will be refresh in 3 seconds" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this9.processing(false);
                    }
                };
                xhttp.send(fd);
            }
            return true;
        }
    }]);

    return leaveAction;
}();

exports.default = _alt2.default.createActions(leaveAction);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var userAction = function () {
    function userAction() {
        _classCallCheck(this, userAction);

        this.generateActions('warningMsg', 'processing', 'resetPasswordSuccess', 'changePasswordSuccess', 'resetFgPasswordSuccess', 'isfgPwdSend', 'userLoginSuccess', 'userLoginFail', 'logout');
    }

    _createClass(userAction, [{
        key: 'isUserLogin',
        value: function isUserLogin() {
            var _this = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/isUserLogin', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this.userLoginSuccess(result);
                        } else if (xhttp.status == 400) {
                            //handle Error
                            _this.warningMsg(result.errorMsg);
                            _this.userLoginFail();
                        }
                    }
                };
                xhttp.send(null);
            }
            /*
                 
            //simulate data
            this.userLoginSuccess({
               token: "abc",
               role: 0,
               staffId: "A0011d",
               userName: "Ho Kok Liang",
               userImage: "testing",
            });
            */
            return true;
        }
    }, {
        key: 'userLogin',
        value: function userLogin(staffId, pw) {
            var _this2 = this;

            var xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/userLogin', true);
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = function () {
                if (xhttp.readyState == 4) {
                    var result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        _this2.userLoginSuccess(result);
                    } else if (xhttp.status == 400) {
                        //handle Error
                        _this2.warningMsg(result.errorMsg);
                        _this2.userLoginFail();
                    }
                    _this2.processing(false);
                }
            };
            xhttp.send(JSON.stringify({
                staffId: staffId,
                password: pw
            }));

            /*
            //simulate login success
            this.userLoginSuccess({
                token: "abc",
                role: 0,
                staffId: "A0011d",
                userName: "Ho Kok Liang",
                userImage: "testing",
            });
            this.processing(false);
            */
            return true;
        }
    }, {
        key: 'forgotPassword',
        value: function forgotPassword(email) {
            var _this3 = this;

            var xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/forgotPassword', true);
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = function () {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        _this3.warningMsg("An email has sent to your emailbox. You will redirect to homepage in 3 second");
                        _this3.isfgPwdSend(true);
                    } else if (xhttp.status == 400) {
                        //handle Error
                        var result = JSON.parse(xhttp.responseText);
                        _this3.warningMsg(result.errorMsg);
                    }
                    _this3.processing(false);
                }
            };
            xhttp.send(JSON.stringify({ email: email }));

            return true;
        }
    }, {
        key: 'resetFgPassword',
        value: function resetFgPassword(token, password) {
            var _this4 = this;

            var xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/forgotPassword/' + token, true);
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = function () {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        _this4.warningMsg("Pasword reset successfully");
                        _this4.resetFgPasswordSuccess();
                    } else if (xhttp.status == 400) {
                        //handle Error
                        var result = JSON.parse(xhttp.responseText);
                        _this4.warningMsg(result.errorMsg);
                    }
                    _this4.processing(false);
                }
            };
            xhttp.send(JSON.stringify({
                password: password
            }));

            return true;
        }
    }, {
        key: 'resetPassword',
        value: function resetPassword(token, password) {
            var _this5 = this;

            var xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/resetPassword', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + token);
            xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhttp.onreadystatechange = function () {
                if (xhttp.readyState == 4) {

                    if (xhttp.status == 200) {
                        _this5.warningMsg("Pasword reset successfully");
                        _this5.resetPasswordSuccess(token);
                    } else if (xhttp.status == 400) {
                        //handle Error
                        var result = JSON.parse(xhttp.responseText);
                        _this5.warningMsg(result.errorMsg);
                    }
                    _this5.processing(false);
                }
            };
            xhttp.send(JSON.stringify({
                password: password
            }));

            return true;
        }
    }, {
        key: 'changePassword',
        value: function changePassword(currentPassword, newPassword) {
            var _this6 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/changePassword', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {

                        if (xhttp.status == 200) {
                            _this6.warningMsg("Password Changed. You will redicrect to home page in 3 seconds");
                            setTimeout(function () {
                                _this6.changePasswordSuccess();
                            }, 3000);
                        } else if (xhttp.status == 400) {
                            //handle Error
                            var result = JSON.parse(xhttp.responseText);
                            _this6.warningMsg(result.errorMsg);
                        }
                        _this6.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({
                    currentPassword: currentPassword,
                    newPassword: newPassword
                }));
            }
            return true;
        }
    }]);

    return userAction;
}();

exports.default = _alt2.default.createActions(userAction);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var leaveSetAction = function () {
    function leaveSetAction() {
        _classCallCheck(this, leaveSetAction);

        this.generateActions('search', 'processing', 'staffId', 'updating', 'leaveTotalSuccess', 'totalGain', 'isSucceed', 'bringFwd', 'updateLvTotalSuccess', 'removeLeaveSuccess', 'addLeaveSuccess', 'maxBringFwd', 'leaveGain', 'used', 'userName', 'holiday', 'isHolidayUpdated');
    }

    _createClass(leaveSetAction, [{
        key: 'getHoliday',
        value: function getHoliday() {
            var _this = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/holiday', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this.holiday(result);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'updateHoliday',
        value: function updateHoliday(holiday) {
            var _this2 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/holiday', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Holidays have been successfully updated. Page will refresh in 3 seconds." });
                            _modalAction2.default.modalClose(true);
                            _this2.isHolidayUpdated(true);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this2.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ holiday: holiday }));
            }
            return true;
        }
    }, {
        key: 'getMaxBringFwd',
        value: function getMaxBringFwd() {
            var _this3 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/leave/bringFwd', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this3.maxBringFwd(result.bringFwd);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this3.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'getLeaveTotal',
        value: function getLeaveTotal(staffId) {
            var _this4 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/leave/total/' + staffId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this4.leaveTotalSuccess(result);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this4.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'updateLeaveTotal',
        value: function updateLeaveTotal(staffId, leaves, maxBringFwd) {
            var _this5 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/leave/total/' + staffId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            _this5.updateLvTotalSuccess();
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "The employee's leave has been updated" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this5.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ leaves: leaves, bringFwd: maxBringFwd }));
            }
            return true;
        }
    }, {
        key: 'removeLeave',
        value: function removeLeave(type) {
            var _this6 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("DELETE", '/v1/api/leave/remove', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            _this6.removeLeaveSuccess(type);
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Leave have been removed" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this6.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ type: type }));
            }
            return true;
        }
    }, {
        key: 'addLeave',
        value: function addLeave(leaveTxt, totalGain) {
            var _this7 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/leave/new', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this7.addLeaveSuccess(result);
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "New Leave Type Added" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            var _result = JSON.parse(xhttp.responseText);
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: _result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this7.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ leaveTxt: leaveTxt, totalGain: totalGain }));
            }
            return true;
        }
    }]);

    return leaveSetAction;
}();

exports.default = _alt2.default.createActions(leaveSetAction);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _contractorAction = __webpack_require__(14);

var _contractorAction2 = _interopRequireDefault(_contractorAction);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var condoSetAction = function () {
    function condoSetAction() {
        _classCallCheck(this, condoSetAction);

        this.generateActions('processing', 'warningMsg', 'checkListSuccess', 'condoSuccess', 'addCondoSuccess', 'condo', 'checkList', 'addStaff', 'removeStaff', 'shouldListShow', 'shouldListShowCL', 'shouldListShowCL2', 'addContractor', 'addService', 'removeContractor', 'editService', 'removeService', 'clear', 'reset', 'condoRemoveSuccess', 'isCLUpdate');
    }

    _createClass(condoSetAction, [{
        key: 'getCondo',
        value: function getCondo(mcst) {
            var _this = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/condo/condo/' + mcst, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var _result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this.condoSuccess(_result);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: _result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this.processing(false);
                    }
                };
                xhttp.send(null);
            }
            /*
              this.condoSuccess({
                _id: "123",
                mcst: 1234,
                condoName: "Condo A",
                noUnit: 30,
                address: "99 Jervios Road",
                postal: 249055,
                geoLocation: { type: "Point", coordinates: [-73.856077, 40.848447] },
                manageBy: [{ staffId: "A0001", userName: "Ho Kok Liang", role: 0, email: "HKL@gmail.com" }, { staffId: "A0002", userName: "Tan Kai Lee", role: 1, email: "TKL@gmail.com" }],
                checkList: ["1234", "1236"],
                contractors: [
                    {
                        _id: "A124",
                        contractorName: "E&T Cleaning Services Pte Ltd",
                        contractorEmail: "crankpwr@singnet.com.sg",
                        telephone: 91112222,
                        contract: [
                            {
                                service: "Cleaning", description: "Cleaning", remark: "",
                                contractStartDate: new Date("2016-11-15"), contractEndDate: new Date("2017-11-14"),
                                amount: 2400, firstReminder: new Date("2017-11-14"), secondReminder: new Date("2017-11-28")
                            },
                            {
                                service: "Electric", description: "Electric", remark: "",
                                contractStartDate: new Date("2016-11-15"), contractEndDate: new Date("2017-11-14"),
                                amount: 400, firstReminder: new Date("2017-11-14"), secondReminder: new Date("2017-11-28")
                            }
                        ]
                    }
                ]
            });
            this.processing(false);
            */
            return true;
        }
    }, {
        key: 'removeCheckList',
        value: function removeCheckList(id) {
            var _this2 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("DELETE", '/v1/api/condo/checklist/' + id, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            _modalAction2.default.modalContent({ title: "Successful", content: "Facility has been deleted" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this2.processing(false);
                    }
                };
                xhttp.send(null);
            }
        }
    }, {
        key: 'getCheckList',
        value: function getCheckList() {
            var _this3 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/condo/checklist', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var _result2 = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this3.checkListSuccess(_result2);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: _result2.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this3.processing(false);
                    }
                };
                xhttp.send(null);
            }
            /*
            this.checkListSuccess([
                { facility: "Common Area", categories: [{ category: "Bin", description: ["Free of smell, cigarette butt, ashes, stickers, stains and dust"] }, { category: "Floor / Skirting", description: ["Tiles are free from grime, stains and mop mark.", "No stagnant water on tiles"] }] },
                { facility: "Lifts", categories: [{ category: "Lift Door", description: ["Close properly and without any hiccups.", "Lift car door has been polished"] }, { category: "Lift Button", description: ["All buttons are present, are working well and lights up when pressed"] }] },
                { facility: "Common Toilets", categories: [{ category: "Door surface / Frame / Closer", description: ["Free of dust and stain"] }, { category: "Light Diffuser", description: ["Check for any blown and/or flickering light bulbs"] }] },
            ]);
            this.processing(false);
            */
            return true;
        }
    }, {
        key: 'addCondo',
        value: function addCondo(condo) {
            var _this4 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/condo', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var _result3 = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {

                            _filterAction2.default.addCondo(_result3);
                            _contractorAction2.default.addWholeCondo(_result3);
                            _this4.addCondoSuccess();
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Condo has been added" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: _result3.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this4.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ condo: condo }));
            }
            return true;
        }
    }, {
        key: 'removeContractorFrDB',
        value: function removeContractorFrDB(contractorId, mcst) {
            var _this5 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/condo/contractor/' + contractorId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Contractor has been erased from this estate" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            var _result4 = JSON.parse(xhttp.responseText);
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: _result4.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this5.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ mcst: mcst }));
            }
            return true;
        }
    }, {
        key: 'updateCondo',
        value: function updateCondo(condo, prevMCST) {
            var _this6 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/condo/' + prevMCST, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var _result5 = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _contractorAction2.default.updateWholeCondo(_result5);
                            _filterAction2.default.updateCondo({ newMCST: condo.mcst, prevMCST: prevMCST, condoName: condo.condoName });
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Condo has been updated" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: _result5.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this6.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ condo: condo }));
            }
            return true;
        }
    }, {
        key: 'removeCondo',
        value: function removeCondo(condo) {
            var _this7 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("DELETE", '/v1/api/condo/' + condo.mcst, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var _result6 = JSON.parse(xhttp.responseText);
                            _this7.condoRemoveSuccess();
                            _filterAction2.default.removeCondo(condo.mcst);
                            _contractorAction2.default.removeWholeCondo(_result6);

                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Condo has been deleted" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this7.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'updateCheckList',
        value: function updateCheckList(checkList) {
            var _this8 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/condo/checklist', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var _result7 = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this8.checkListSuccess(_result7);
                            _this8.isCLUpdate(true);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: _result7.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this8.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ checkList: checkList }));
            }
            return true;
        }
    }, {
        key: 'exportCheckList',
        value: function exportCheckList() {
            var _this9 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/export/checkList', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {} else {
                            var _result8 = JSON.parse(xhttp.responseText);
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: _result8.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this9.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'exportCondo',
        value: function exportCondo(mcst) {
            var _this10 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/export/condo/' + mcst, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.responseType = "arraybuffer";
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            var blobUrl = URL.createObjectURL(blob);
                            var link = document.createElement("a"); // Or maybe get it from the current document
                            link.href = blobUrl;
                            link.download = "EstateDetail_" + mcst + ".xlsx";
                            document.body.appendChild(link); // Or append it whereever you 
                            link.click();
                        } else {
                            var _result9 = JSON.parse(xhttp.responseText);
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: _result9.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this10.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }]);

    return condoSetAction;
}();

exports.default = _alt2.default.createActions(condoSetAction);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMutableObject = isMutableObject;
exports.eachObject = eachObject;
exports.assign = assign;
var isFunction = exports.isFunction = function isFunction(x) {
  return typeof x === 'function';
};

function isMutableObject(target) {
  var Ctor = target.constructor;

  return !!target && Object.prototype.toString.call(target) === '[object Object]' && isFunction(Ctor) && !Object.isFrozen(target) && (Ctor instanceof Ctor || target.type === 'AltStore');
}

function eachObject(f, o) {
  o.forEach(function (from) {
    Object.keys(Object(from)).forEach(function (key) {
      f(key, from[key]);
    });
  });
}

function assign(target) {
  for (var _len = arguments.length, source = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    source[_key - 1] = arguments[_key];
  }

  eachObject(function (key, value) {
    return target[key] = value;
  }, source);
  return target;
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _attdAction = __webpack_require__(19);

var _attdAction2 = _interopRequireDefault(_attdAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var attdStore = function () {
    function attdStore() {
        _classCallCheck(this, attdStore);

        this.bindActions(_attdAction2.default);
        this.search = "";
        this.processing = false;
        this.selectedYear = new Date().getFullYear();
        this.selectedMonth = new Date().getMonth();
        this.iniLoad = false;
        this.staffAtd = {};
        this.staffsAtd = [];
        this.attendanceId = "";
        this.startWorkHr = 0;
        this.startWorkMin = 0;
        this.endWorkHr = 0;
        this.endWorkMin = 0;
        this.canSubmit = false;
    }

    _createClass(attdStore, [{
        key: 'onCanSubmit',
        value: function onCanSubmit(data) {
            this.canSubmit = data;
        }
    }, {
        key: 'onAttendanceId',
        value: function onAttendanceId(data) {
            this.attendanceId = data._id;
        }
    }, {
        key: 'onProcessing',
        value: function onProcessing(data) {
            this.processing = data;
        }
    }, {
        key: 'onGetAllStaffAtdSuccess',
        value: function onGetAllStaffAtdSuccess(data) {
            this.iniLoad = false;
            this.staffsAtd = data;
        }
    }, {
        key: 'onGetStaffAtdSuccess',
        value: function onGetStaffAtdSuccess(data) {
            this.staffAtd = data;
        }
    }, {
        key: 'onSearch',
        value: function onSearch(data) {
            this.search = data;
        }
    }, {
        key: 'onSelectedMonth',
        value: function onSelectedMonth(data) {
            this.selectedYear = data.selectedYear;
            this.selectedMonth = data.selectedMonth;
        }
    }, {
        key: 'onCloseListShow',
        value: function onCloseListShow() {

            if (this.staffsAtd) {
                for (var i = 0; i < this.staffsAtd.length; i++) {
                    for (var j = 0; j < this.staffsAtd[i].attendance.length; j++) {
                        this.staffsAtd[i].attendance[j].shouldDDListShow = false;
                    }
                }
            }
            if (this.staffAtd) {
                if (this.staffAtd.attendance) {
                    for (var _i = 0; _i < this.staffAtd.attendance.length; _i++) {
                        this.staffAtd.attendance[_i].shouldDDListShow = false;
                    }
                }
            }
        }
    }, {
        key: 'onShouldListShow',
        value: function onShouldListShow(data) {
            if (data.useFor == 0) {
                this.staffsAtd[data.index].shouldListShow = !this.staffsAtd[data.index].shouldListShow;
            } else {
                this.staffAtd.shouldListShow = !this.staffAtd.shouldListShow;
            }
        }
        ///to be verified

    }, {
        key: 'onShouldDDListShow',
        value: function onShouldDDListShow(data) {
            if (data.useFor == 0) {
                var len = this.staffsAtd.length;
                for (var i = 0; i < len; i++) {
                    if (this.staffsAtd[i].staffId == data.staffId) {
                        this.staffsAtd[i].attendance[data.index].shouldDDListShow = !this.staffsAtd[i].attendance[data.index].shouldDDListShow;
                        break;
                    }
                }
            } else {
                this.staffAtd.attendance[data.index].shouldDDListShow = !this.staffAtd.attendance[data.index].shouldDDListShow;
            }
        }
    }, {
        key: 'onAttendanceCheckSuccess',
        value: function onAttendanceCheckSuccess(data) {
            this.attendanceId = data._id;
            this.startWorkHr = data.startWorkHr;
            this.startWorkMin = data.startWorkMin;
            this.endWorkHr = data.endWorkHr;
            this.endWorkMin = data.endWorkMin;
        }
    }, {
        key: 'onUpdateAttandanceSuccess',
        value: function onUpdateAttandanceSuccess(data) {
            //alllist
            var len = this.staffsAtd.length;
            var diff = void 0;
            for (var i = 0; i < len; i++) {
                if (this.staffsAtd[i].staffId == data.staffId && this.staffsAtd[i].year == data.year && this.staffsAtd[i].month == data.month) {
                    this.staffsAtd[i].totalHours = data.totalHours;
                    for (var j = 0; j < this.staffsAtd[i].attendance.length; j++) {
                        if (this.staffsAtd[i].attendance[j]._id == data._id) {
                            for (var k = 0; k < data.attendance.length; k++) {
                                if (this.staffsAtd[i].attendance[j]._id == data.attendance[k]._id) {
                                    this.staffsAtd[i].attendance[j] = data.attendance[k];
                                    break;
                                }
                            }
                            break;
                        }
                    }
                    break;
                }
            }
            //individual
            if (this.staffAtd.staffId == data.staffId && this.staffAtd.year == data.year && this.staffAtd.month == data.month) {
                this.staffAtd.totalHours = data.totalHours;
                for (var _j = 0; _j < this.staffAtd.attendance.length; _j++) {
                    if (this.staffAtd.attendance[_j]._id == data._id) {
                        for (var _k = 0; _k < data.attendance.length; _k++) {
                            console.log(data);
                            console.log(data.attendance[_k]);
                            if (this.staffAtd.attendance[_j]._id == data.attendance[_k]._id) {
                                this.staffAtd.attendance[_j] = data.attendance[_k];
                                break;
                            }
                        }
                        break;
                    }
                }
            }
        }
    }]);

    return attdStore;
}();

exports.default = _alt2.default.createStore(attdStore, 'attdStore');

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function TempCtor() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  };
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var reportAction = function () {
    function reportAction() {
        _classCallCheck(this, reportAction);

        this.generateActions('processing', 'getReportSuccess', 'getReportByRNSuccess', 'getDetailSuccess', 'updateSM', 'updateEM', 'updateUI', 'updateCI', 'updateRN', 'warningMsg', 'shouldListShow', 'extendIncidentSuccess', 'resolveIncidentSuccess', 'addingRemarkSuccess', 'removeIncidentSuccess', 'closeListShow', 'facility', 'contractors', 'isReportCreated');
    }

    _createClass(reportAction, [{
        key: 'getReport',
        value: function getReport(staffId, mcst, startYear, startMonth, endYear, endMonth) {
            var _this = this;

            if (sessionStorage.getItem('ui')) {
                var queryParam = "?staffId=" + staffId + "&mcst=" + mcst + "&startYear=" + startYear + "&startMonth=" + startMonth + "&endYear=" + endYear + "&endMonth=" + endMonth;
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/report' + queryParam, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this.getReportSuccess(result);
                        } else {
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'getReportByRN',
        value: function getReportByRN(reportNo) {
            var _this2 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/report/' + reportNo, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this2.getReportByRNSuccess(result);
                        } else {
                            _modalAction2.default.modalContent({ title: "Warning", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this2.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'exportUnresolvedReport',
        value: function exportUnresolvedReport(staffId, mcst) {
            var _this3 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/export/report/unresolve', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.responseType = "arraybuffer";
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            var blobUrl = URL.createObjectURL(blob);
                            var link = document.createElement("a"); // Or maybe get it from the current document
                            link.href = blobUrl;
                            link.download = "Unresolved_Incident_report.xlsx";
                            document.body.appendChild(link); // Or append it whereever you 
                            link.click();
                        } else {
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this3.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({
                    staffId: staffId,
                    mcst: mcst
                }));
            }
            return true;
        }
    }, {
        key: 'exportReport',
        value: function exportReport(staffId, mcst, startYear, startMonth, endYear, endMonth) {
            var _this4 = this;

            if (sessionStorage.getItem('ui')) {
                var naming = void 0;
                if (staffId == "" && mcst == "") {
                    naming = "All";
                } else if (staffId == "") {
                    naming = mcst;
                } else {
                    naming = staffId;
                }
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/export/report', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.responseType = "arraybuffer";
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            var blobUrl = URL.createObjectURL(blob);
                            var link = document.createElement("a"); // Or maybe get it from the current document
                            link.href = blobUrl;
                            link.download = "Incident_report_" + naming + "_" + startYear + "-" + (startMonth + 1) + ".xlsx";
                            document.body.appendChild(link); // Or append it whereever you 
                            link.click();
                        } else {
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this4.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({
                    staffId: staffId,
                    mcst: mcst,
                    startYear: startYear,
                    startMonth: startMonth,
                    endYear: endYear,
                    endMonth: endYear
                }));
            }
            return true;
        }
    }, {
        key: 'downloadPDFfile',
        value: function downloadPDFfile(reportNo) {
            var _this5 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/report/pdf/' + reportNo, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.responseType = "arraybuffer";
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var blob = new Blob([xhttp.response], { type: 'application/pdf' });
                            var blobUrl = URL.createObjectURL(blob);
                            var link = document.createElement("a"); // Or maybe get it from the current document
                            link.href = blobUrl;
                            link.download = reportNo + "_incident_report.pdf";
                            document.body.appendChild(link); // Or append it whereever you 
                            link.click();
                        } else {
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this5.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'getDetailReport',
        value: function getDetailReport(reportId) {
            var _this6 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/reportDetail/' + reportId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this6.getDetailSuccess(result);
                        } else {
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg || "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this6.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'extendIncident',
        value: function extendIncident(reportId, fd) {
            var _this7 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/report/extend/' + reportId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this7.extendIncidentSuccess(result);
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Deadline has been extended" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg || "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this7.processing(false);
                    }
                };
                xhttp.send(fd);
            }
            return true;
        }
    }, {
        key: 'resolveIncident',
        value: function resolveIncident(reportId, fd) {
            var _this8 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/report/resolve/' + reportId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {

                            _this8.resolveIncidentSuccess(result);

                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Incident status updated" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg || "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this8.processing(false);
                    }
                };
                xhttp.send(fd);
            }
            return true;
        }
    }, {
        key: 'addingRemark',
        value: function addingRemark(reportId, fd) {
            var _this9 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/report/remark/' + reportId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this9.addingRemarkSuccess(result);
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Remark has been added" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg || "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }

                        _this9.processing(false);
                    }
                };
                xhttp.send(fd);
            }
            return true;
        }
    }, {
        key: 'removeIncident',
        value: function removeIncident(reportId, clientEmail, reason) {
            var _this10 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/report/status/' + reportId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this10.removeIncidentSuccess(result);
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "The incident has been removed" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg || "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this10.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({
                    clientEmail: clientEmail,
                    reason: reason
                }));
            }
            return true;
        }
    }, {
        key: 'getFacility',
        value: function getFacility(mcst) {
            var _this11 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/condo/facility?mcst=' + mcst, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this11.facility(result);
                        } else {
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg || "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this11.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'getContractor',
        value: function getContractor(mcst) {
            var _this12 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/contractor/report?mcst=' + mcst, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this12.contractors(result);
                        } else {
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg || "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this12.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'createReport',
        value: function createReport(fd) {
            var _this13 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/report', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            _modalAction2.default.modalContent({ title: "Successful", content: "Incident report created. Page will be refresh in 3 seconds" });
                            _modalAction2.default.modalClose(true);
                            _this13.isReportCreated(true);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg || "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this13.processing(false);
                    }
                };
                xhttp.send(fd);
            }

            return true;
        }
    }]);

    return reportAction;
}();

exports.default = _alt2.default.createActions(reportAction);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _contractorAction = __webpack_require__(14);

var _contractorAction2 = _interopRequireDefault(_contractorAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var contractorStore = function () {
    function contractorStore() {
        _classCallCheck(this, contractorStore);

        this.bindActions(_contractorAction2.default);
        this.processing = false;
        this.search = "";
        this.mcst = "";
        this.searchMode = "";
        this.staffId = "";
        this.warningMsg = "";
        this.contractorId = "";
        this.updating = false;
        this.iniLoadCondo = false;
        this.condos = [];
        this.isNew = false;
        this.iniEmailReminder = false;
        this.contractors = [];
        this.reminderEmail = [];
        this.contractor = {
            contractorName: "",
            contracts: [],
            streetName: "",
            blkNo: "",
            unitNo: "",
            postal: "",
            telephone: "",
            fax: "",
            contractorEmail: "",
            contactName: "",
            status: 0,
            totalAmount: 0
        };
    }

    _createClass(contractorStore, [{
        key: 'onCondoSuccess',
        value: function onCondoSuccess(data) {
            this.condos = data;
            this.iniLoadCondo = true;
        }
    }, {
        key: 'onClear',
        value: function onClear() {
            this.contractor = {
                contractorName: "",
                contracts: [],
                streetName: "",
                blkNo: "",
                unitNo: "",
                postal: "",
                telephone: "",
                fax: "",
                contractorEmail: "",
                contactName: "",
                status: 0,
                totalAmount: 0
            };
        }
    }, {
        key: 'onListClear',
        value: function onListClear() {
            this.contractors = [];
        }
    }, {
        key: 'onReset',
        value: function onReset() {
            this.updating = false;
            this.searchMode = "";
        }
    }, {
        key: 'onReminderEmail',
        value: function onReminderEmail(data) {
            this.reminderEmail = data;
            this.iniEmailReminder = true;
        }
    }, {
        key: 'onProcessing',
        value: function onProcessing(data) {
            this.processing = data;
        }
    }, {
        key: 'onSearch',
        value: function onSearch(data) {
            this.search = data;
        }
    }, {
        key: 'onMcst',
        value: function onMcst(data) {
            this.mcst = data;
        }
    }, {
        key: 'onContractorId',
        value: function onContractorId(data) {
            this.contractorId = data;
        }
    }, {
        key: 'onUpdating',
        value: function onUpdating(data) {
            this.updating = data;
        }
    }, {
        key: 'onContractorsSuccess',
        value: function onContractorsSuccess(data) {
            this.contractors = data;
        }
    }, {
        key: 'onContractorSuccess',
        value: function onContractorSuccess(data) {
            this.contractor = data;
        }
    }, {
        key: 'onWarningMsg',
        value: function onWarningMsg(data) {
            this.warningMsg = data;
        }
    }, {
        key: 'onContractor',
        value: function onContractor(data) {
            this.contractor = data;
        }
    }, {
        key: 'onIsNew',
        value: function onIsNew(data) {
            this.isNew = data;
        }
    }, {
        key: 'onStaffId',
        value: function onStaffId(data) {
            this.staffId = data;
        }
    }, {
        key: 'onShouldListShow',
        value: function onShouldListShow(data) {
            this.contractor.contracts[data].shouldListShow = !this.contractor.contracts[data].shouldListShow;
        }
    }, {
        key: 'onShouldConListShow',
        value: function onShouldConListShow(data) {
            this.contractors[data].shouldListShow = !this.contractors[data].shouldListShow;
        }
    }, {
        key: 'onSearchMode',
        value: function onSearchMode(data) {
            this.searchMode = data;
        }
    }, {
        key: 'onAddCondo',
        value: function onAddCondo(data) {
            this.contractor.contracts.push({
                mcst: data.mcst,
                condoName: data.condoName,
                contract: []
            });
        }
    }, {
        key: 'onAddWholeCondo',
        value: function onAddWholeCondo(data) {
            this.contractors.push(data);
        }
    }, {
        key: 'onAddService',
        value: function onAddService(data) {
            var len = this.contractor.contracts.length;
            var amount = void 0;
            var editCondo = void 0;
            for (var i = 0; i < len; i++) {
                if (this.contractor.contracts[i].mcst == data.mcst) {
                    amount = data.contract.amount;
                    this.contractor.contracts[i].contract.push(data.contract);
                    editCondo = { mcst: this.contractor.contracts[i].mcst, condoName: this.contractor.contracts[i].condoName };
                    break;
                }
            }
            this.updateContractAmount(amount);
        }
    }, {
        key: 'onRemoveCondo',
        value: function onRemoveCondo(data) {
            //remove condo from contractor list
            var amount = 0;
            for (var j = 0; j < this.contractor.contracts.length; j++) {
                if (this.contractor.contracts[j].mcst == data.mcst) {
                    if (this.contractor.contracts[j].contract) {
                        this.contractor.contracts[j].contract.forEach(function (ct) {
                            if (ct.amount) {
                                amount = ct.amount + amount;
                            }
                        });
                    }
                    this.contractor.contracts.splice(j, 1);
                    break;
                }
            }
            this.updateContractAmount(-amount);
        }
    }, {
        key: 'onUpdateWholeCondo',
        value: function onUpdateWholeCondo(data) {
            var len = this.contractors.length;
            for (var i = 0; i < len; i++) {
                if (this.contractors[i].mcst == data.mcst) {
                    this.contractors[i] = data;
                    break;
                }
            }
        }
    }, {
        key: 'onRemoveWholeCondo',
        value: function onRemoveWholeCondo(data) {
            var len = this.contractors.length;
            for (var i = 0; i < len; i++) {
                if (this.contractors[i].mcst == data.mcst) {
                    this.contractors.splice(i, 1);
                    break;
                }
            }
        }
    }, {
        key: 'updateContractAmount',
        value: function updateContractAmount(amount) {
            if (amount) {
                this.contractor.totalAmount = this.contractor.totalAmount + amount;
            }
        }
    }, {
        key: 'onEditService',
        value: function onEditService(data) {
            var len = this.contractor.contracts.length;
            var amount = void 0;
            var editCondo = void 0;
            for (var i = 0; i < len; i++) {
                if (this.contractor.contracts[i].mcst == data.mcst) {
                    amount = data.contract.amount - this.contractor.contracts[i].contract[data.index].amount;
                    this.contractor.contracts[i].contract[data.index] = data.contract;
                    editCondo = { mcst: this.contractor.contracts[i].mcst, condoName: this.contractor.contracts[i].condoName };
                    break;
                }
            }
            this.updateContractAmount(-amount);
        }
    }, {
        key: 'onRemoveService',
        value: function onRemoveService(data) {
            var len = this.contractor.contracts.length;
            var amount = void 0;
            for (var i = 0; i < len; i++) {
                if (this.contractor.contracts[i].mcst == data.mcst) {
                    amount = this.contractor.contracts[i].contract[data.index].amount;
                    this.contractor.contracts[i].contract.splice(data.index, 1);

                    break;
                }
            }
            this.updateContractAmount(-amount);
        }
    }, {
        key: 'onAddAddress',
        value: function onAddAddress(data) {
            this.contractor.addresses.push(data);
        }
    }, {
        key: 'onEditAddress',
        value: function onEditAddress(data) {
            this.contractor.addresses[data.index] = data.address;
        }
    }, {
        key: 'onRemoveAddress',
        value: function onRemoveAddress(data) {
            this.contractor.addresses.splice(data.index, 1);
        }
    }, {
        key: 'onRemoveContractorSuccess',
        value: function onRemoveContractorSuccess(data) {
            var len = this.contractors.length;
            for (var i = 0; i < len; i++) {
                for (var j = 0; j < this.contractors[i].contractors.length; j++) {
                    if (this.contractors[i].contractors[j]._id == data) {
                        this.contractors[i].contractors.splice(j, 1);
                        break;
                    }
                }
            }
        }
    }, {
        key: 'onUpdateContractorSuccess',
        value: function onUpdateContractorSuccess(data) {
            var len = this.contractors.length;
            var ctrLen = data.contracts.length;
            for (var i = 0; i < len; i++) {
                if (this.contractors[i].contractors) {
                    for (var k = 0; k < this.contractors[i].contractors.length; k++) {
                        var isExist = false;
                        var contract = [];
                        if (this.contractors[i].contractors[k]._id == data._id) {
                            isExist = true;
                            for (var j = 0; j < ctrLen; j++) {
                                if (this.contractors[i].mcst == data.contracts[j].mcst) {
                                    contract = contract.concat(data.contracts[j].contract);
                                }
                            }
                        }

                        if (isExist) {
                            if (contract.length == 0) {
                                this.contractors[i].contractors.splice(k, 1);
                                break;
                            } else {
                                this.contractors[i].contractors[k].contract = contract;
                            }
                        }
                    }
                }
            }
        }
    }, {
        key: 'onAddContractorSuccess',
        value: function onAddContractorSuccess(data) {
            var len = this.contractors.length;
            var ctrLen = data.contracts.length;
            for (var i = 0; i < len; i++) {
                for (var j = 0; j < ctrLen; j++) {
                    if (this.contractors[i].mcst = data.contracts[j].mcst) {
                        var isRepeat = false;
                        var index = -1;
                        for (var k = 0; k < this.contractors[i].contractors.length; k++) {
                            if (this.contractors[i].contractors[k]._id == data._id) {
                                isRepeat = true;
                                index = k;
                            }
                        }
                        if (!isRepeat) {
                            //if new contractor
                            this.contractors[i].contractors.push({
                                _id: data._id,
                                contractorName: data.contractorName,
                                contractorEmail: data.contractorEmail,
                                telephone: data.telephone,
                                contactName: data.contactName,
                                fax: data.fax,
                                streetName: data.streetName,
                                blkNo: data.blkNo,
                                unitNo: data.unitNo,
                                postal: data.postal,
                                status: data.status,
                                contract: data.contract[j]
                            });
                        } else {

                            //if exist contractor
                            this.contractors[i].contractors[index].contract.push(data.contract[j]);
                        }
                    }
                }
            }
            this.onClear();
        }
    }, {
        key: 'onStaffReplaced',
        value: function onStaffReplaced(data) {
            var len = this.contractors.length;
            for (var i = 0; i < len; i++) {
                if (this.contractors[i].manageBy.staffId == data.oldStaffId) {
                    this.contractors[i].manageBy = {
                        staffId: data.staffId,
                        userName: data.userName,
                        role: data.role,
                        email: data.email,
                        handPhone: data.handPhone
                    };
                }
                if (this.contractors[i].supervisor.staffId == data.oldStaffId) {
                    this.contractors[i].supervisor = {
                        staffId: data.staffId,
                        userName: data.userName,
                        role: data.role,
                        email: data.email,
                        handPhone: data.handPhone
                    };
                }
            }
        }
    }]);

    return contractorStore;
}();

exports.default = _alt2.default.createStore(contractorStore, 'contractorStore');

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var processNextTick = __webpack_require__(41);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(37);
util.inherits = __webpack_require__(27);
/*</replacement>*/

var Readable = __webpack_require__(74);
var Writable = __webpack_require__(78);

util.inherits(Duplex, Readable);

var keys = objectKeys(Writable.prototype);
for (var v = 0; v < keys.length; v++) {
  var method = keys[v];
  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  processNextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  processNextTick(cb, err);
};

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _reportAction = __webpack_require__(28);

var _reportAction2 = _interopRequireDefault(_reportAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var reportStore = function () {
    function reportStore() {
        _classCallCheck(this, reportStore);

        this.bindActions(_reportAction2.default);
        this.processing = false;
        this.warningMsg = "";
        this.startYear = new Date().getFullYear();
        this.startMonth = new Date().getMonth();
        this.endYear = new Date().getFullYear();
        this.endMonth = new Date().getMonth();
        this.staffId = "";
        this.mcst = "";
        this.reportNo = '';
        this.reports = [];
        this.facility = "";
        this.contractors = "";
        this.isReportCreated = false;
        this.reportDetail = {};
    }

    _createClass(reportStore, [{
        key: 'onProcessing',
        value: function onProcessing(data) {
            this.processing = data;
        }
    }, {
        key: 'onUpdateSM',
        value: function onUpdateSM(data) {
            this.startYear = data.startYear;
            this.startMonth = data.startMonth;
        }
    }, {
        key: 'onUpdateEM',
        value: function onUpdateEM(data) {
            this.endMonth = data.endMonth;
            this.endYear = data.endYear;
        }
    }, {
        key: 'onUpdateUI',
        value: function onUpdateUI(data) {
            this.staffId = data.staffId;
        }
    }, {
        key: 'onUpdateCI',
        value: function onUpdateCI(data) {
            this.mcst = data.mcst;
        }
    }, {
        key: 'onUpdateRN',
        value: function onUpdateRN(data) {
            this.reportNo = data.reportNo;
        }
    }, {
        key: 'onShouldListShow',
        value: function onShouldListShow(data) {
            this.reports[data].shouldListShow = !this.reports[data].shouldListShow;
        }
    }, {
        key: 'onCloseListShow',
        value: function onCloseListShow() {
            for (var i = 0; i < this.reports.length; i++) {
                this.reports[i].shouldListShow = false;
            }
        }
    }, {
        key: 'onGetReportSuccess',
        value: function onGetReportSuccess(data) {
            this.reports = data;
        }
    }, {
        key: 'onGetReportByRNSuccess',
        value: function onGetReportByRNSuccess(data) {
            this.reports = data;
        }
    }, {
        key: 'onFacility',
        value: function onFacility(data) {
            this.facility = data;
        }
    }, {
        key: 'onContractors',
        value: function onContractors(data) {
            this.contractors = data;
        }
    }, {
        key: 'onExtendIncidentSuccess',
        value: function onExtendIncidentSuccess(data) {
            if (this.reportDetail._id == data._id) {
                this.reportDetail.extend = data.extend;
                this.reportDetail.reportImage = data.reportImage;
                this.reportDetail.targetDate = data.targetDate;
            }
            var len = this.reports.length;
            for (var i = 0; i < len; i++) {
                if (this.reports[i]._id == data._id) {
                    this.reports[i].extend = data.extend;
                    this.reports[i].reportImage = data.reportImage;
                    this.reports[i].targetDate = data.targetDate;
                    break;
                }
            }
        }
    }, {
        key: 'onResolveIncidentSuccess',
        value: function onResolveIncidentSuccess(data) {
            if (this.reportDetail._id == data._id) {
                this.reportDetail.resolution = data.resolution;
                this.reportDetail.resolvedBy = data.resolvedBy;
                this.reportDetail.status = 0;
                this.reportDetail.completionDate = data.completionDate;
                this.reportDetail.reportImage = data.reportImage;
            }
            var len = this.reports.length;
            for (var i = 0; i < len; i++) {
                if (this.reports[i]._id == data._id) {
                    this.reports[i].resolution = data.resolution;
                    this.reports[i].resolvedBy = data.resolvedBy;
                    this.reports[i].completionDate = data.completionDate;
                    this.reports[i].reportImage = data.reportImage;
                    this.reports[i].status = 0;
                    break;
                }
            }
        }
    }, {
        key: 'onAddingRemarkSuccess',
        value: function onAddingRemarkSuccess(data) {
            if (this.reportDetail._id == data._id) {
                this.reportDetail.remarks = data.remarks;
                this.reportDetail.reportImage = data.reportImage;
            }
            var len = this.reports.length;
            for (var i = 0; i < len; i++) {
                if (this.reports[i]._id == data._id) {
                    this.reports[i].remarks = data.remarks;
                    this.reports[i].reportImage = data.reportImage;
                    break;
                }
            }
        }
    }, {
        key: 'onRemoveIncidentSuccess',
        value: function onRemoveIncidentSuccess(data) {

            var len = this.reports.length;
            if (this.reportDetail._id == data._id) {
                this.reportDetail.status = 2;
                this.reportDetail.resolution = data.resolution;
                this.reportDetail.resolvedBy = data.resolvedBy;
            }
            for (var i = 0; i < len; i++) {
                if (this.reports[i]._id == data._id) {
                    this.reports[i].status = 2;
                    this.reports[i].resolution = data.resolution;
                    this.reports[i].resolvedBy = data.resolvedBy;
                    break;
                }
            }
        }

        // to be verified

    }, {
        key: 'onGetDetailSuccess',
        value: function onGetDetailSuccess(data) {
            this.reportDetail = data;
        }
    }, {
        key: 'onIsReportCreated',
        value: function onIsReportCreated(data) {
            this.isReportCreated = data;
        }
    }]);

    return reportStore;
}();

exports.default = _alt2.default.createStore(reportStore, 'reportStore');

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _leaveAction = __webpack_require__(20);

var _leaveAction2 = _interopRequireDefault(_leaveAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var leaveStore = function () {
    function leaveStore() {
        _classCallCheck(this, leaveStore);

        this.bindActions(_leaveAction2.default);
        this.search = "";
        this.processing = false;
        this.startYear = new Date().getFullYear();
        this.startMonth = new Date().getMonth();
        this.endYear = new Date().getFullYear();
        this.endMonth = new Date().getMonth();
        this.isLeaveSuccess = false;
        this.warningMsg = '';
        this.staffId = "";

        this.leaves = [];
        /*
            { _id: "1234", date: new Date(), submittedBy: "Ho Kok Liang", startDate: new Date(), endDate: new Date(), apmStart: 0, apmEnd: 0, type: 1, duration: 2.5, status: 0, leaveImage: "/public/img/profile-pic.jpg" },
            { _id: "1236", date: new Date(), submittedBy: "Loh Jik Nen", startDate: new Date(), endDate: new Date(), apmStart: 1, apmEnd: 0, type: 0, duration: 2.5, status: 1 },
            { _id: "1237", date: new Date(), submittedBy: "Tan Kai Lee", startDate: new Date(), endDate: new Date(), apmStart: 2, apmEnd: 0, type: 4, duration: 2.5, status: 0, remark: "remark 1" },
            { _id: "1239", date: new Date(), submittedBy: "Tan Kai Lee", startDate: new Date(), endDate: new Date(), apmStart: 0, apmEnd: 0, type: 0, duration: 2.5, status: 0 },
        */
        this.summary = {};
        /*
            staffId: "1234",
            userName: "Ho Kok Liang",
            summary: [
                { type: 0, bringFwd: 4.0, leaveGain: 3.0, used: 2.0 },
                { type: 1, bringFwd: 0.0, leaveGain: 3.0, used: 0.0 },
                { type: 2, bringFwd: 4.0, leaveGain: 3.0, used: 2.0 },
                { type: 3, bringFwd: 4.0, leaveGain: 3.0, used: 2.0 },
                { type: 4, bringFwd: 0, leaveGain: 0, used: 2.0 },
                { type: 5, bringFwd: 4.0, leaveGain: 3.0, used: 2.0 },
                { type: 6, bringFwd: 0, leaveGain: 0, used: 0 },
                { type: 7, bringFwd: 0, leaveGain: 0, used: 0 },
                { type: 8, bringFwd: 0, leaveGain: 0, used: 0 },
                
            ]
        */
        /*
        "Annual Leave", 
        "Medical Leave", 
        "Reservist", 
        "Childcare leave", 
        "Unpaid leave", 
        "Compassionate leave",
        "Other Leave", 
        "Time-off", 
        "Tele-commuting",
            */
    }

    _createClass(leaveStore, [{
        key: 'onProcessing',
        value: function onProcessing(data) {
            this.processing = data;
        }
    }, {
        key: 'onUploadMCSuccess',
        value: function onUploadMCSuccess(data) {
            var len = this.leaves.length;
            for (var i = 0; i < len; i++) {
                if (this.leaves[i]._id == data._id) {
                    this.leaves[i].leaveImage = data.leaveImage;
                }
            }
        }
    }, {
        key: 'uploadRPSuccess',
        value: function uploadRPSuccess(data) {
            var len = this.leaves.length;
            for (var i = 0; i < len; i++) {
                if (this.leaves[i]._id == data._id) {
                    this.leaves[i].receiptImage = data.receiptImage;
                }
            }
        }
    }, {
        key: 'onGetLASuccess',
        value: function onGetLASuccess(data) {
            this.leaves = data;
        }
    }, {
        key: 'onUpdateSM',
        value: function onUpdateSM(data) {
            this.startYear = data.startYear;
            this.startMonth = data.startMonth;
        }
    }, {
        key: 'onUpdateEM',
        value: function onUpdateEM(data) {
            this.endMonth = data.endMonth;
            this.endYear = data.endYear;
        }
    }, {
        key: 'onUpdateUI',
        value: function onUpdateUI(data) {
            this.staffId = data.staffId;
        }
    }, {
        key: 'onClear',
        value: function onClear() {
            this.leaves = [];
        }
    }, {
        key: 'onSummaryClear',
        value: function onSummaryClear() {
            this.summary = {};
        }
    }, {
        key: 'onSearch',
        value: function onSearch(data) {
            this.search = data;
        }
    }, {
        key: 'onSummarySuccess',
        value: function onSummarySuccess(data) {
            this.summary = data;
        }
    }, {
        key: 'onShouldListShow',
        value: function onShouldListShow(data) {
            this.leaves[data].shouldListShow = !this.leaves[data].shouldListShow;
        }
    }, {
        key: 'onCloseListShow',
        value: function onCloseListShow() {
            if (this.leaves) {
                for (var i = 0; i < this.leaves.length; i++) {
                    this.leaves[i].shouldListShow = false;
                }
            }
        }
    }, {
        key: 'onChangeStatusSuccess',
        value: function onChangeStatusSuccess(data) {
            var len = this.leaves.length;
            for (var i = 0; i < len; i++) {
                if (this.leaves[i]._id == data._id) {
                    this.leaves[i].status = data.status;
                    break;
                }
            }
        }
    }, {
        key: 'onIsLeaveSuccess',
        value: function onIsLeaveSuccess(data) {
            this.isLeaveSuccess = data;
        }
    }]);

    return leaveStore;
}();

exports.default = _alt2.default.createStore(leaveStore, 'leaveStore');

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var employeeAction = function () {
    function employeeAction() {
        _classCallCheck(this, employeeAction);

        this.generateActions('warningMsg', 'processing', 'search', 'displayDetail', 'staffId', 'userDetailSuccess', 'employeeSuccess', 'clear');
    }

    _createClass(employeeAction, [{
        key: 'getEmployee',
        value: function getEmployee() {
            var _this = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/employee/all', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var result = JSON.parse(xhttp.responseText);
                            _this.employeeSuccess(result);
                        } else {
                            //handle error
                        }
                        _this.processing(false);
                    }
                };
                xhttp.send(null);
            }

            this.processing(false);
            return true;
        }
    }, {
        key: 'userDetail',
        value: function userDetail(staffId) {
            var _this2 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/employee/' + staffId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this2.userDetailSuccess(result);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Message", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this2.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'getEmployeeExport',
        value: function getEmployeeExport(staffId) {
            var _this3 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/export/employee/' + staffId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.responseType = "arraybuffer";
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            var blobUrl = URL.createObjectURL(blob);
                            var link = document.createElement("a"); // Or maybe get it from the current document
                            link.href = blobUrl;
                            link.download = "EmployeeProfile_" + staffId + ".xlsx";
                            document.body.appendChild(link); // Or append it whereever you 
                            link.click();
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this3.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'exportProfile',
        value: function exportProfile() {
            var _this4 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/export/employee', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.responseType = "arraybuffer";
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            var blobUrl = URL.createObjectURL(blob);
                            var link = document.createElement("a"); // Or maybe get it from the current document
                            link.href = blobUrl;
                            link.download = "EmployeeProfile_All.xlsx";
                            document.body.appendChild(link); // Or append it whereever you 
                            link.click();
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this4.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }]);

    return employeeAction;
}();

exports.default = _alt2.default.createActions(employeeAction);

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(165);
var ieee754 = __webpack_require__(166);
var isArray = __webpack_require__(71);

exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength();

function typedArraySupport() {
  try {
    var arr = new Uint8Array(1);
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function foo() {
        return 42;
      } };
    return arr.foo() === 42 && // typed array instances can be augmented
    typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
    arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
  } catch (e) {
    return false;
  }
}

function kMaxLength() {
  return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}

function createBuffer(that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length');
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length);
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length);
    }
    that.length = length;
  }

  return that;
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer(arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length);
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error('If encoding is specified then the first argument must be a string');
    }
    return allocUnsafe(this, arg);
  }
  return from(this, arg, encodingOrOffset, length);
}

Buffer.poolSize = 8192; // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype;
  return arr;
};

function from(that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number');
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length);
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset);
  }

  return fromObject(that, value);
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length);
};

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype;
  Buffer.__proto__ = Uint8Array;
  if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    });
  }
}

function assertSize(size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number');
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative');
  }
}

function alloc(that, size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(that, size);
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
  }
  return createBuffer(that, size);
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding);
};

function allocUnsafe(that, size) {
  assertSize(size);
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0;
    }
  }
  return that;
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size);
};

function fromString(that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding');
  }

  var length = byteLength(string, encoding) | 0;
  that = createBuffer(that, length);

  var actual = that.write(string, encoding);

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
  }

  return that;
}

function fromArrayLike(that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  that = createBuffer(that, length);
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255;
  }
  return that;
}

function fromArrayBuffer(that, array, byteOffset, length) {
  array.byteLength; // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds');
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds');
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array);
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset);
  } else {
    array = new Uint8Array(array, byteOffset, length);
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array;
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
  }
  return that;
}

function fromObject(that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0;
    that = createBuffer(that, len);

    if (that.length === 0) {
      return that;
    }

    obj.copy(that, 0, 0, len);
    return that;
  }

  if (obj) {
    if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0);
      }
      return fromArrayLike(that, obj);
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data);
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}

function checked(length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
  }
  return length | 0;
}

function SlowBuffer(length) {
  if (+length != length) {
    // eslint-disable-line eqeqeq
    length = 0;
  }
  return Buffer.alloc(+length);
}

Buffer.isBuffer = function isBuffer(b) {
  return !!(b != null && b._isBuffer);
};

Buffer.compare = function compare(a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers');
  }

  if (a === b) return 0;

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

Buffer.isEncoding = function isEncoding(encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true;
    default:
      return false;
  }
};

Buffer.concat = function concat(list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }

  if (list.length === 0) {
    return Buffer.alloc(0);
  }

  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }

  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    buf.copy(buffer, pos);
    pos += buf.length;
  }
  return buffer;
};

function byteLength(string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length;
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength;
  }
  if (typeof string !== 'string') {
    string = '' + string;
  }

  var len = string.length;
  if (len === 0) return 0;

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len;
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length;
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2;
      case 'hex':
        return len >>> 1;
      case 'base64':
        return base64ToBytes(string).length;
      default:
        if (loweredCase) return utf8ToBytes(string).length; // assume utf8
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;

function slowToString(encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return '';
  }

  if (end === undefined || end > this.length) {
    end = this.length;
  }

  if (end <= 0) {
    return '';
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;

  if (end <= start) {
    return '';
  }

  if (!encoding) encoding = 'utf8';

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end);

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end);

      case 'ascii':
        return asciiSlice(this, start, end);

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end);

      case 'base64':
        return base64Slice(this, start, end);

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end);

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;

function swap(b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}

Buffer.prototype.swap16 = function swap16() {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits');
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this;
};

Buffer.prototype.swap32 = function swap32() {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits');
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this;
};

Buffer.prototype.swap64 = function swap64() {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits');
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this;
};

Buffer.prototype.toString = function toString() {
  var length = this.length | 0;
  if (length === 0) return '';
  if (arguments.length === 0) return utf8Slice(this, 0, length);
  return slowToString.apply(this, arguments);
};

Buffer.prototype.equals = function equals(b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
  if (this === b) return true;
  return Buffer.compare(this, b) === 0;
};

Buffer.prototype.inspect = function inspect() {
  var str = '';
  var max = exports.INSPECT_MAX_BYTES;
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
    if (this.length > max) str += ' ... ';
  }
  return '<Buffer ' + str + '>';
};

Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer');
  }

  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index');
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0;
  }
  if (thisStart >= thisEnd) {
    return -1;
  }
  if (start >= end) {
    return 1;
  }

  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;

  if (this === target) return 0;

  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);

  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }

  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1;

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset; // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1;else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;else return -1;
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1;
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
  }

  throw new TypeError('val must be string, number or Buffer');
}

function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }

  function read(buf, i) {
    if (indexSize === 1) {
      return buf[i];
    } else {
      return buf.readUInt16BE(i * indexSize);
    }
  }

  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
  }

  return -1;
}

Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};

Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};

Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};

function hexWrite(buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }

  // must be an even number of digits
  var strLen = string.length;
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');

  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (isNaN(parsed)) return i;
    buf[offset + i] = parsed;
  }
  return i;
}

function utf8Write(buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}

function asciiWrite(buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length);
}

function latin1Write(buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length);
}

function base64Write(buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length);
}

function ucs2Write(buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}

Buffer.prototype.write = function write(string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
    // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0;
    if (isFinite(length)) {
      length = length | 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
    // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
  }

  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;

  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds');
  }

  if (!encoding) encoding = 'utf8';

  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length);

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length);

      case 'ascii':
        return asciiWrite(this, string, offset, length);

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length);

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length);

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length);

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};

Buffer.prototype.toJSON = function toJSON() {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};

function base64Slice(buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf);
  } else {
    return base64.fromByteArray(buf.slice(start, end));
  }
}

function utf8Slice(buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];

  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }

    res.push(codePoint);
    i += bytesPerSequence;
  }

  return decodeCodePointsArray(res);
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;

function decodeCodePointsArray(codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
  }
  return res;
}

function asciiSlice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret;
}

function latin1Slice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret;
}

function hexSlice(buf, start, end) {
  var len = buf.length;

  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;

  var out = '';
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i]);
  }
  return out;
}

function utf16leSlice(buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res;
}

Buffer.prototype.slice = function slice(start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;

  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }

  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }

  if (end < start) end = start;

  var newBuf;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end);
    newBuf.__proto__ = Buffer.prototype;
  } else {
    var sliceLen = end - start;
    newBuf = new Buffer(sliceLen, undefined);
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start];
    }
  }

  return newBuf;
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset(offset, ext, length) {
  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}

Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }

  return val;
};

Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }

  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }

  return val;
};

Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset];
};

Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | this[offset + 1] << 8;
};

Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] << 8 | this[offset + 1];
};

Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};

Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};

Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val;
};

Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val;
};

Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return this[offset];
  return (0xff - this[offset] + 1) * -1;
};

Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | this[offset + 1] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};

Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | this[offset] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};

Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};

Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};

Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, true, 23, 4);
};

Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, false, 23, 4);
};

Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, true, 52, 8);
};

Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, false, 52, 8);
};

function checkInt(buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
}

Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  this[offset] = value & 0xff;
  return offset + 1;
};

function objectWriteUInt16(buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2;
};

Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2;
};

function objectWriteUInt32(buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4;
};

Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4;
};

Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = value & 0xff;
  return offset + 1;
};

Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2;
};

Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2;
};

Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4;
};

Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4;
};

function checkIEEE754(buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
  if (offset < 0) throw new RangeError('Index out of range');
}

function writeFloat(buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4;
}

Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert);
};

Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert);
};

function writeDouble(buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8;
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert);
};

Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert);
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0;
  if (target.length === 0 || this.length === 0) return 0;

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds');
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
  if (end < 0) throw new RangeError('sourceEnd out of bounds');

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }

  var len = end - start;
  var i;

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start];
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start];
    }
  } else {
    Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
  }

  return len;
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (code < 256) {
        val = code;
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string');
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding);
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index');
  }

  if (end <= start) {
    return this;
  }

  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;

  if (!val) val = 0;

  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
    var len = bytes.length;
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }

  return this;
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

function base64clean(str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return '';
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str;
}

function stringtrim(str) {
  if (str.trim) return str.trim();
  return str.replace(/^\s+|\s+$/g, '');
}

function toHex(n) {
  if (n < 16) return '0' + n.toString(16);
  return n.toString(16);
}

function utf8ToBytes(string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        }

        // valid lead
        leadSurrogate = codePoint;

        continue;
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue;
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }

    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break;
      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break;
      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break;
      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else {
      throw new Error('Invalid code point');
    }
  }

  return bytes;
}

function asciiToBytes(str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray;
}

function utf16leToBytes(str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;

    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }

  return byteArray;
}

function base64ToBytes(str) {
  return base64.toByteArray(base64clean(str));
}

function blitBuffer(src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if (i + offset >= dst.length || i >= src.length) break;
    dst[i + offset] = src[i];
  }
  return i;
}

function isnan(val) {
  return val !== val; // eslint-disable-line no-self-compare
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return objectToString(e) === '[object Error]' || e instanceof Error;
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'symbol' || // ES6 symbol
  typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36).Buffer))

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var emAction = function () {
    function emAction() {
        _classCallCheck(this, emAction);

        this.generateActions('processing', 'warningMsg', 'mcst', 'selectMonth', 'staffId', 'estateSuccess', 'shouldListShow', 'sortByStatus');
    }

    _createClass(emAction, [{
        key: 'getEstate',
        value: function getEstate(staffId, mcst, year, month) {
            var _this = this;

            if (sessionStorage.getItem('ui')) {
                var queryParams = "?staffId=" + staffId + "&mcst=" + mcst + "&year=" + year + "&month=" + month;

                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/estate' + queryParams, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this.estateSuccess(result);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'exportEstate',
        value: function exportEstate(staffId, mcst, year, month) {
            var _this2 = this;

            if (sessionStorage.getItem('ui')) {
                var naming = void 0;
                if (staffId == -1 && mcst == "") {
                    naming = "All";
                } else if (staffId == -1) {
                    naming = mcst;
                } else {
                    naming = staffId;
                }
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/export/estate', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.responseType = "arraybuffer";
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            var blobUrl = URL.createObjectURL(blob);
                            var link = document.createElement("a"); // Or maybe get it from the current document
                            link.href = blobUrl;
                            link.download = "EstateReport_" + naming + "_" + year + "-" + (month + 1) + ".xlsx";
                            document.body.appendChild(link); // Or append it whereever you 
                            link.click();
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this2.processing(false);
                    }
                };

                xhttp.send(JSON.stringify({
                    staffId: staffId,
                    mcst: mcst,
                    year: year,
                    month: month
                }));
            }
            return true;
        }
    }]);

    return emAction;
}();

exports.default = _alt2.default.createActions(emAction);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _condoSetAction = __webpack_require__(23);

var _condoSetAction2 = _interopRequireDefault(_condoSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var condoSetStore = function () {
    function condoSetStore() {
        _classCallCheck(this, condoSetStore);

        this.bindActions(_condoSetAction2.default);
        this.processing = false;
        this.isCLUpdate = false;
        this.editContractor = [];
        this.removeContractor = [];
        this.warningMsg = "";
        this.checkList = [];
        this.prevMCST = "";
        this.condo = {
            _id: "",
            mcst: "",
            condoName: "",
            noUnit: "",
            address: "",
            postal: "",
            geoLocation: { type: "Point", coordinates: ["", ""] },
            manageBy: {},
            supervisor: {},
            checkList: [],
            contractors: [],
            status: 0
        };
    }

    _createClass(condoSetStore, [{
        key: 'onReset',
        value: function onReset() {
            this.updating = false;
            this.search = "";
            this.isNew = false;
            this.filterByCriteria = false;
            this.csMode = 1;
        }
    }, {
        key: 'onClear',
        value: function onClear() {
            this.condo = {
                _id: "",
                mcst: "",
                condoName: "",
                noUnit: "",
                address: "",
                postal: "",
                radius: 0,
                geoLocation: { type: "Point", coordinates: ["", ""] },
                manageBy: { staffId: "" },
                supervisor: { staffId: "" },
                checkList: [],
                contractors: [],
                status: 0

            };
            this.editContractor = [];
            this.removeContractor = [];
            this.editCheckList = [];
            this.newFacility = [];
            this.isCLUpdate = false;
        }
    }, {
        key: 'onProcessing',
        value: function onProcessing(data) {
            this.processing = data;
        }
    }, {
        key: 'onUpdating',
        value: function onUpdating(data) {
            this.updating = data;
        }
    }, {
        key: 'onWarningMsg',
        value: function onWarningMsg(data) {
            this.warningMsg = data;
        }
    }, {
        key: 'onCheckListSuccess',
        value: function onCheckListSuccess(data) {
            this.checkList = data;
        }
    }, {
        key: 'onCondoSuccess',
        value: function onCondoSuccess(data) {
            this.condo = data;
            this.prevMCST = data.mcst;
        }
    }, {
        key: 'onAddCondoSuccess',
        value: function onAddCondoSuccess() {
            this.onClear();
        }
    }, {
        key: 'onCondo',
        value: function onCondo(data) {
            this.condo = data;
        }
    }, {
        key: 'onCheckList',
        value: function onCheckList(data) {
            this.checkList = data;
        }
    }, {
        key: 'onAddStaff',
        value: function onAddStaff(data) {
            this.condo.manageBy.push(data);
        }
    }, {
        key: 'onRemoveStaff',
        value: function onRemoveStaff(data) {
            this.condo.manageBy.splice(data.index, 1);
        }
    }, {
        key: 'onShouldListShow',
        value: function onShouldListShow(data) {
            this.condo.contractors[data].shouldListShow = !this.condo.contractors[data].shouldListShow;
        }
    }, {
        key: 'onShouldListShowCL',
        value: function onShouldListShowCL(data) {
            this.condo.checkList[data].shouldListShow = !this.condo.checkList[data].shouldListShow;
        }
    }, {
        key: 'onShouldListShowCL2',
        value: function onShouldListShowCL2(data) {
            this.checkList[data].shouldListShow = !this.checkList[data].shouldListShow;
        }
    }, {
        key: 'onAddContractor',
        value: function onAddContractor(data) {
            data.contract = [];
            this.condo.contractors.push(data);
            //add to editContractor
            this.editContractor.push(data._id);

            //clear removeContractor
            var len = this.removeContractor.length;
            var pos = -1;
            for (var i = 0; i < len; i++) {
                if (this.removeContractor[i] == data._id) {
                    pos = i;
                    break;
                }
            }
            if (pos != -1) {
                this.removeContractor.splice(pos, 1);
            }
        }
    }, {
        key: 'onAddService',
        value: function onAddService(data) {
            var len = this.condo.contractors.length;
            for (var i = 0; i < len; i++) {
                if (this.condo.contractors[i]._id == data.contractorId) {
                    this.condo.contractors[i].contract.push(data.contract);
                }
            }
            //add to editContractor
            var isRepeat = false;
            var conLen = this.editContractor.length;
            for (var j = 0; j < conLen; j++) {
                if (this.editContractor[j] == data.contractorId) {
                    isRepeat = true;
                    break;
                }
            }
            if (!isRepeat) {
                this.editContractor.push(data.contractorId);
            }
        }
    }, {
        key: 'onRemoveContractor',
        value: function onRemoveContractor(data) {
            this.removeContractor.push(data.contractorId);
            //check editContractor
            var len = this.editContractor.length;

            for (var i = 0; i < len; i++) {
                if (this.editContractor[i] == data.contractorId) {
                    this.editContractor.splice(i, 1);
                    break;
                }
            }

            //splice condo
            var conLen = this.condo.contractors.length;
            for (var j = 0; j < conLen; j++) {
                if (this.condo.contractors[j]._id == data.contractorId) {
                    this.condo.contractors.splice(j, 1);
                    break;
                }
            }
        }
    }, {
        key: 'onEditService',
        value: function onEditService(data) {
            var len = this.editContractor.length;
            var isRepeat = false;
            for (var i = 0; i < len; i++) {
                if (this.editContractor[i] == data.contractorId) {
                    isRepeat = true;
                    break;
                }
            }
            if (!isRepeat) {
                this.editContractor.push(data.contractorId);
            }

            //splice condo
            var conLen = this.condo.contractors.length;
            for (var j = 0; j < conLen; j++) {
                if (this.condo.contractors[j]._id == data.contractorId) {
                    this.condo.contractors[j].contract[data.index] = data.contract;
                    break;
                }
            }
        }
    }, {
        key: 'onRemoveService',
        value: function onRemoveService(data) {
            var len = this.editContractor.length;
            var isRepeat = false;
            for (var i = 0; i < len; i++) {
                if (this.editContractor[i] == data.contractorId) {
                    isRepeat = true;
                    break;
                }
            }
            if (!isRepeat) {
                this.editContractor.push(data.contractorId);
            }
            //splice condo
            var conLen = this.condo.contractors.length;
            for (var j = 0; j < conLen; j++) {
                if (this.condo.contractors[j]._id == data.contractorId) {
                    this.condo.contractors[j].contract.splice(data.index, 1);
                    break;
                }
            }
        }
    }, {
        key: 'onCondoRemoveSuccess',
        value: function onCondoRemoveSuccess(data) {
            this.updating = false;
        }
    }, {
        key: 'onIsCLUpdate',
        value: function onIsCLUpdate(data) {
            this.isCLUpdate = data;
        }
    }]);

    return condoSetStore;
}();

exports.default = _alt2.default.createStore(condoSetStore, 'condoSetStore');

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locationsAreEqual = exports.createLocation = undefined;

var _resolvePathname = __webpack_require__(61);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(62);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version || process.version.indexOf('v0.') === 0 || process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = nextTick;
} else {
  module.exports = process.nextTick;
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
    case 0:
    case 1:
      return process.nextTick(fn);
    case 2:
      return process.nextTick(function afterTickOne() {
        fn.call(null, arg1);
      });
    case 3:
      return process.nextTick(function afterTickTwo() {
        fn.call(null, arg1, arg2);
      });
    case 4:
      return process.nextTick(function afterTickThree() {
        fn.call(null, arg1, arg2, arg3);
      });
    default:
      args = new Array(len - 1);
      i = 0;
      while (i < args.length) {
        args[i++] = arguments[i];
      }
      return process.nextTick(function afterTick() {
        fn.apply(null, args);
      });
  }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(36);
var Buffer = buffer.Buffer;

// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
  for (var key in src) {
    dst[key] = src[key];
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer;
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports);
  exports.Buffer = SafeBuffer;
}

function SafeBuffer(arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length);
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number');
  }
  return Buffer(arg, encodingOrOffset, length);
};

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number');
  }
  var buf = Buffer(size);
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding);
    } else {
      buf.fill(fill);
    }
  } else {
    buf.fill(0);
  }
  return buf;
};

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number');
  }
  return Buffer(size);
};

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number');
  }
  return buffer.SlowBuffer(size);
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var jpAction = function () {
    function jpAction() {
        _classCallCheck(this, jpAction);

        this.generateActions('processing', 'getJourneyPlannerSuccess', 'selectMonth', 'staffId', 'updateEM', 'warningMsg', 'shouldListShow', 'updateERPSuccess', 'updateParkingSuccess', 'updateMileageSuccess', 'removeJPSuccess', 'updateStatusSuccess', 'updateReceiptSuccess', 'updateErpReceiptSuccess', 'updateRemarkSuccess', 'clear', 'closeListShow', 'submitRecord', 'approveAllSuccess');
    }

    _createClass(jpAction, [{
        key: 'claimSubmit',
        value: function claimSubmit(year, month) {
            var _this = this;

            if (sessionStorage.getItem('ui')) {
                var queryParam = "?year=" + year + "&month=" + month;
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/journeyPlanner/notify' + queryParam, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            //show success message
                            _modalAction2.default.modalContent({ title: "Message", content: "Claim successfully submitted" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            _modalAction2.default.modalContent({ title: "Message", content: "Something went wrong. Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'getJourneyPlanner',
        value: function getJourneyPlanner(staffId, year, month) {
            var _this2 = this;

            if (sessionStorage.getItem('ui')) {
                var queryParam = "?staffId=" + staffId + "&year=" + year + "&month=" + month;

                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/journeyPlanner' + queryParam, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {

                            _this2.getJourneyPlannerSuccess(result);
                        } else {
                            //show success message
                            _modalAction2.default.modalContent({ title: "Message", content: "Viewing is restricted" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this2.processing(false);
                    }
                };
                xhttp.send(null);
            }

            return true;
        }
    }, {
        key: 'exportJourneyPlanner',
        value: function exportJourneyPlanner(staffId, year, month) {
            var _this3 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/export/journeyPlanner', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.responseType = "arraybuffer";
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            var blobUrl = URL.createObjectURL(blob);
                            var link = document.createElement("a"); // Or maybe get it from the current document
                            link.href = blobUrl;
                            link.download = "JPReport_" + staffId + "_" + year + "-" + (month + 1) + ".xlsx";
                            document.body.appendChild(link); // Or append it whereever you 
                            link.click();
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: "Please contact admin" });
                            _modalAction2.default.modalClose(true);
                        }
                        _this3.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ staffId: staffId, year: year, month: month }));
            }
            return true;
        }
    }, {
        key: 'updateERP',
        value: function updateERP(id, value) {
            var _this4 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/journeyPlanner/ERP/' + id, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {

                            _this4.updateERPSuccess(result);

                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "The ERP fare has been updated" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this4.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ erp: value }));
            }
            return true;
        }
    }, {
        key: 'uploadReceipt',
        value: function uploadReceipt(id, fd) {
            var _this5 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/journeyPlanner/parking/receipt/' + id, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));

                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {

                            _this5.updateReceiptSuccess(result);

                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Receipt has been uploaded" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this5.processing(false);
                    }
                };
                xhttp.send(fd);
            }
            return true;
        }
    }, {
        key: 'uploadERPReceipt',
        value: function uploadERPReceipt(id, fd) {
            var _this6 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/journeyPlanner/erp/receipt/' + id, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));

                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {

                            _this6.updateErpReceiptSuccess(result);

                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Receipt has been uploaded" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this6.processing(false);
                    }
                };
                xhttp.send(fd);
            }
            return true;
        }
    }, {
        key: 'updateParking',
        value: function updateParking(id, value) {
            var _this7 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/journeyPlanner/parking/' + id, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {

                            _this7.updateParkingSuccess(result);

                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Parking fare has been updated" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this7.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ parking: value }));
            }
            return true;
        }
        /*
        updateMileage(id, value) {
            if (sessionStorage.getItem('ui')) {
                const xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/journeyPlanner/mileage/' + id, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = () => {
                    if (xhttp.readyState == 4) {
                        let result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            this.updateMileageSuccess(result);
                              //show success message
                            modalAction.modalContent({ title: "Successful", content: "Updated the mileage claim amount" });
                            modalAction.modalClose(true);
                        }else{
                            modalAction.modalContent({ title: "Error", content: result.errorMsg });
                            modalAction.modalClose(true);
                        }
                        this.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ mileageClaim: value }));
            }
            return true;
            
        }
        */

    }, {
        key: 'updateDistance',
        value: function updateDistance(id, value, googleStart, googleEnd) {
            var _this8 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/journeyPlanner/distance/' + id, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this8.updateMileageSuccess(result);

                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Updated the mileage distance & claim amount" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this8.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ distance: value, googleStart: googleStart, googleEnd: googleEnd }));
            }
            return true;
        }
    }, {
        key: 'updateRemark',
        value: function updateRemark(id, value) {
            var _this9 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/journeyPlanner/remark/' + id, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this9.updateRemarkSuccess(result);

                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Remark successfully added" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this9.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ remark: value }));
            }
            return true;
        }
    }, {
        key: 'removeJp',
        value: function removeJp(id) {
            var _this10 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("DELETE", '/v1/api/journeyPlanner/' + id, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));

                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            //this.removeJPSuccess(id);
                            _this10.updateStatusSuccess({ id: id, status: 4 });
                            //show success message
                            _modalAction2.default.modalContent({ title: "Removed", content: "Status has changed to removed" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this10.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'updateStatus',
        value: function updateStatus(id, status) {
            var _this11 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/journeyPlanner/status/' + id, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            _this11.updateStatusSuccess({ id: id, status: status });

                            //show success message
                            //modalAction.modalContent({ title: "Successful", content: "Status has been updated" });
                            //modalAction.modalClose(true);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this11.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ status: status }));
            }
            return true;
        }
    }, {
        key: 'emailJustification',
        value: function emailJustification(staffId, year, month) {
            var _this12 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/email/journeyPlanner/justification', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            //let result = JSON.parse(xhttp.responseText);

                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Email successfully sent" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this12.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ staffId: staffId, year: year, month: month }));
            }
            return true;
        }
    }, {
        key: 'emailApproved',
        value: function emailApproved(staffId, year, month) {
            var _this13 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/email/journeyPlanner/approved', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            //let result = JSON.parse(xhttp.responseText);
                            //show success message
                            _modalAction2.default.modalContent({ title: "Approved", content: "Email successfully sent" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this13.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ staffId: staffId, year: year, month: month }));
            }
            return true;
        }
    }, {
        key: 'emailReject',
        value: function emailReject(staffId, year, month) {
            var _this14 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/email/journeyPlanner/reject', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            //show success message
                            _modalAction2.default.modalContent({ title: "Rejected", content: "Email successfully sent" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this14.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ staffId: staffId, year: year, month: month }));
            }
            return true;
        }
    }, {
        key: 'getSubmitRecord',
        value: function getSubmitRecord(staffId, year, month) {
            var _this15 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                var queryParam = "?staffId=" + staffId + "&year=" + year + "&month=" + month;
                xhttp.open("GET", '/v1/api/journeyPlanner/submitRecord' + queryParam, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            //show success message
                            _this15.submitRecord(result);
                        } else {

                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this15.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'approveAll',
        value: function approveAll(staffId, year, month) {
            var _this16 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/journeyPlanner/status/all', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            //show success message
                            _modalAction2.default.modalContent({ title: "Approved", content: "Claims approved successfully" });
                            _modalAction2.default.modalClose(true);
                            _this16.approveAllSuccess({ staffId: staffId, year: year, month: month });
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this16.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ staffId: staffId, year: year, month: month }));
            }
        }
    }]);

    return jpAction;
}();

exports.default = _alt2.default.createActions(jpAction);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _userSetAction = __webpack_require__(15);

var _userSetAction2 = _interopRequireDefault(_userSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var userSetStore = function () {
    function userSetStore() {
        _classCallCheck(this, userSetStore);

        this.bindActions(_userSetAction2.default);
        //userDetail
        this.userDetail = { supervisor: [], comHandphone: {}, comLaptop: {}, comCabcard: {} };
        //to determine whether user is communicate with server
        this.processing = false;

        this.isSucceed = false;
        //to determine whether it is add or edit user
        this.usMode = 0;
        this.warningMsg = "";
        this.search = "";
        //to edit staff
        this.staffId = "";
        this.permissionList = [];
        this.updating = false;
        this.team = [];
        this.removedTeam = [];
    }

    _createClass(userSetStore, [{
        key: 'onUsMode',
        value: function onUsMode(data) {
            this.usMode = data;
        }
    }, {
        key: 'onWarningMsg',
        value: function onWarningMsg(data) {
            this.warningMsg = data;
        }
    }, {
        key: 'onStaffId',
        value: function onStaffId(data) {
            this.staffId = data;
        }
    }, {
        key: 'onClear',
        value: function onClear() {
            this.userDetail = { supervisor: [], comHandphone: {}, comLaptop: {}, comCabcard: {} };
        }
    }, {
        key: 'onUserImage',
        value: function onUserImage(url) {
            this.userImage = url;
        }
    }, {
        key: 'onProcessing',
        value: function onProcessing(data) {
            this.processing = data;
        }
    }, {
        key: 'onUpdateSuccess',
        value: function onUpdateSuccess(data) {
            this.isSucceed = true;
        }
    }, {
        key: 'onAddSuccess',
        value: function onAddSuccess(data) {
            this.isSucceed = true;
        }
    }, {
        key: 'userDetailSuccess',
        value: function userDetailSuccess(data) {
            this.userDetail = data;
        }
    }, {
        key: 'onRemoveSuccess',
        value: function onRemoveSuccess(data) {
            this.isSucceed = true;
        }
    }, {
        key: 'onIsSucceed',
        value: function onIsSucceed(data) {
            this.isSucceed = data;
        }
    }, {
        key: 'onSearch',
        value: function onSearch(data) {
            this.search = data;
        }
    }, {
        key: 'onUpdating',
        value: function onUpdating(data) {
            this.updating = data;
        }
    }, {
        key: 'onUpdateUserDetail',
        value: function onUpdateUserDetail(data) {
            console.log(data);
            this.userDetail = data;
        }
    }, {
        key: 'onSupervisor',
        value: function onSupervisor(data) {
            console.log('pass here');
            this.userDetail.supervisor = data;
        }
    }, {
        key: 'onPermissionListSuccess',
        value: function onPermissionListSuccess(data) {
            this.permissionList = data;
        }
    }, {
        key: 'onPermission',
        value: function onPermission(data) {
            this.userDetail.permission = data;
        }
    }, {
        key: 'onTeam',
        value: function onTeam(data) {
            this.team = data;
        }
    }, {
        key: 'onRemovedTeam',
        value: function onRemovedTeam(data) {
            this.removedTeam = data;
        }
    }]);

    return userSetStore;
}();

exports.default = _alt2.default.createStore(userSetStore, 'userSetStore');

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _employeeAction = __webpack_require__(33);

var _employeeAction2 = _interopRequireDefault(_employeeAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var employeeStore = function () {
    function employeeStore() {
        _classCallCheck(this, employeeStore);

        this.bindActions(_employeeAction2.default);
        this.processing = false;
        this.warningMsg = "";
        this.userDetail = { comHandphone: {}, comLaptop: {}, comCabcard: {} };
        this.search = "";
        this.staffId = "";
        this.displayDetail = false;
        this.staffs = [];
        this.iniLoadStaff = false;
    }

    _createClass(employeeStore, [{
        key: 'onEmployeeSuccess',
        value: function onEmployeeSuccess(data) {
            this.staffs = data;
            this.iniLoadStaff = true;
        }
    }, {
        key: 'onProcessing',
        value: function onProcessing(data) {
            this.processing = data;
        }
    }, {
        key: 'onWarningMsg',
        value: function onWarningMsg(data) {
            this.warningMsg = data;
        }
    }, {
        key: 'onSearch',
        value: function onSearch(data) {
            this.search = data;
        }
    }, {
        key: 'onDisplayDetail',
        value: function onDisplayDetail(data) {
            this.displayDetail = data;
        }
    }, {
        key: 'onStaffId',
        value: function onStaffId(data) {
            this.staffId = data;
        }
    }, {
        key: 'onUserDetailSuccess',
        value: function onUserDetailSuccess(data) {
            this.userDetail = data;
        }
    }, {
        key: 'onClear',
        value: function onClear() {
            this.userDetail = { comHandphone: {}, comLaptop: {}, comCabcard: {} };
        }
    }]);

    return employeeStore;
}();

exports.default = _alt2.default.createStore(employeeStore, 'employeeStore');

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _leaveSetAction = __webpack_require__(22);

var _leaveSetAction2 = _interopRequireDefault(_leaveSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var leaveSetStore = function () {
    function leaveSetStore() {
        _classCallCheck(this, leaveSetStore);

        this.bindActions(_leaveSetAction2.default);
        this.search = "";
        this.leaves = [];
        this.processing = false;
        this.staffId = "";
        this.userName = "";
        this.maxBringFwd = 0;
        this.updating = false;
        this.isSucceed = false;
        this.holiday = {};
        this.isHolidayUpdated = false;
    }

    _createClass(leaveSetStore, [{
        key: 'onSearch',
        value: function onSearch(data) {
            this.search = data;
        }
    }, {
        key: 'onProcessing',
        value: function onProcessing(data) {
            this.processing = data;
        }
    }, {
        key: 'onStaffId',
        value: function onStaffId(data) {
            this.staffId = data;
        }
    }, {
        key: 'onHoliday',
        value: function onHoliday(data) {
            this.holiday = data;
        }
    }, {
        key: 'onIsHolidayUpdated',
        value: function onIsHolidayUpdated(data) {
            this.isHolidayUpdated = data;
        }
    }, {
        key: 'onUserName',
        value: function onUserName(data) {
            this.userName = data;
        }
    }, {
        key: 'onUpdating',
        value: function onUpdating(data) {
            this.updating = data;
        }
    }, {
        key: 'onLeaveTotalSuccess',
        value: function onLeaveTotalSuccess(data) {
            this.leaves = data;
        }
    }, {
        key: 'onTotalGain',
        value: function onTotalGain(data) {
            var len = this.leaves.length;
            for (var i = 0; i < len; i++) {
                if (this.leaves[i].type == data.type) {
                    this.leaves[i].totalGain = data.value;
                    break;
                }
            }
        }
    }, {
        key: 'onUsed',
        value: function onUsed(data) {
            var len = this.leaves.length;
            for (var i = 0; i < len; i++) {
                if (this.leaves[i].type == data.type) {
                    this.leaves[i].used = data.value;
                    break;
                }
            }
        }
    }, {
        key: 'onBringFwd',
        value: function onBringFwd(data) {
            var len = this.leaves.length;
            for (var i = 0; i < len; i++) {
                if (this.leaves[i].type == data.type) {
                    this.leaves[i].bringFwd = data.value;
                    break;
                }
            }
        }
    }, {
        key: 'onIsSucceed',
        value: function onIsSucceed(data) {
            this.isSucceed = data;
        }
    }, {
        key: 'onUpdateLvTotalSuccess',
        value: function onUpdateLvTotalSuccess(data) {
            this.isSucceed = true;
        }
    }, {
        key: 'onRemoveLeaveSuccess',
        value: function onRemoveLeaveSuccess(data) {
            var len = this.leaves.length;
            for (var i = 0; i < len; i++) {
                if (this.leaves[i].type == data) {
                    this.leaves.splice(i, 1);
                }
            }
        }
    }, {
        key: 'onAddLeaveSuccess',
        value: function onAddLeaveSuccess(data) {
            this.leaves = this.leaves.concat(data);
        }
    }, {
        key: 'onMaxBringFwd',
        value: function onMaxBringFwd(data) {
            this.maxBringFwd = data;
        }
    }, {
        key: 'onLeaveGain',
        value: function onLeaveGain(data) {
            var len = this.leaves.length;
            for (var i = 0; i < len; i++) {
                if (this.leaves[i].type == data.type) {
                    this.leaves[i].leaveGain = data.value;
                    break;
                }
            }
        }
    }]);

    return leaveSetStore;
}();

exports.default = _alt2.default.createStore(leaveSetStore, 'leaveSetStore');

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var checkPtsAction = function () {
    function checkPtsAction() {
        _classCallCheck(this, checkPtsAction);

        this.generateActions('processing', 'clear', 'radius', 'checkPoint', 'removedCheckPoint', 'ip', 'removedIP');
    }

    _createClass(checkPtsAction, [{
        key: 'getIP',
        value: function getIP() {
            var _this = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/attendance/ip', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            if (result) {
                                _this.ip(result);
                            }
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'getRadius',
        value: function getRadius() {
            var _this2 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/checkRadius', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this2.radius(result.radius);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this2.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
        /*
        updateRadius(radius){
            if (sessionStorage.getItem('ui')) {
                const xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/checkRadius', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = () => {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            modalAction.modalContent({ title: "Success", content: "The setting is updated" });
                            modalAction.modalClose(true);
                        } else {
                            //handle error
                            modalAction.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            modalAction.modalClose(true);
                        }
                        this.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({radius: radius}));
            }
            return true;
        }
        */

    }, {
        key: 'getCheckPoints',
        value: function getCheckPoints() {
            var _this3 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/checkPoint', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this3.checkPoint(result);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this3.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'updateCheckPoint',
        value: function updateCheckPoint(checkPoint, removedCheckPoint, IP, removedIP) {
            var _this4 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/checkPoint', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            _modalAction2.default.modalContent({ title: "Success", content: "The setting is updated" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this4.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({
                    checkPoint: checkPoint, removedCheckPoint: removedCheckPoint,
                    IP: IP, removedIP: removedIP
                }));
            }
            return true;
        }
    }]);

    return checkPtsAction;
}();

exports.default = _alt2.default.createActions(checkPtsAction);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _resolvePathname = __webpack_require__(61);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(62);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(34);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Router = __webpack_require__(51);

var _Router2 = _interopRequireDefault(_Router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(16);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;

    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? _react2.default.Children.only(children) : null;
  };

  return Router;
}(_react2.default.Component);

Router.propTypes = {
  history: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.node
};
Router.contextTypes = {
  router: _propTypes2.default.object
};
Router.childContextTypes = {
  router: _propTypes2.default.object.isRequired
};

exports.default = Router;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pathToRegexp = __webpack_require__(120);

var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

exports.default = matchPath;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.getInternalMethods = getInternalMethods;
exports.getPrototypeChain = getPrototypeChain;
exports.warn = warn;
exports.uid = uid;
exports.formatAsConstant = formatAsConstant;
exports.dispatchIdentity = dispatchIdentity;
exports.fsa = fsa;
exports.dispatch = dispatch;

var _functions = __webpack_require__(24);

var fn = _interopRequireWildcard(_functions);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

/*eslint-disable*/
var builtIns = Object.getOwnPropertyNames(NoopClass);
var builtInProto = Object.getOwnPropertyNames(NoopClass.prototype);
/*eslint-enable*/

function getInternalMethods(Obj, isProto) {
  var excluded = isProto ? builtInProto : builtIns;
  var obj = isProto ? Obj.prototype : Obj;
  return Object.getOwnPropertyNames(obj).reduce(function (value, m) {
    if (excluded.indexOf(m) !== -1) {
      return value;
    }

    value[m] = obj[m];
    return value;
  }, {});
}

function getPrototypeChain(Obj) {
  var methods = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return Obj === Function.prototype ? methods : getPrototypeChain(Object.getPrototypeOf(Obj), fn.assign(getInternalMethods(Obj, true), methods));
}

function warn(msg) {
  /* istanbul ignore else */
  /*eslint-disable*/
  if (typeof console !== 'undefined') {
    console.warn(new ReferenceError(msg));
  }
  /*eslint-enable*/
}

function uid(container, name) {
  var count = 0;
  var key = name;
  while (Object.hasOwnProperty.call(container, key)) {
    key = name + String(++count);
  }
  return key;
}

function formatAsConstant(name) {
  return name.replace(/[a-z]([A-Z])/g, function (i) {
    return String(i[0]) + '_' + String(i[1].toLowerCase());
  }).toUpperCase();
}

function dispatchIdentity(x) {
  if (x === undefined) return null;

  for (var _len = arguments.length, a = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    a[_key - 1] = arguments[_key];
  }

  return a.length ? [x].concat(a) : x;
}

function fsa(id, type, payload, details) {
  return {
    type: type,
    payload: payload,
    meta: _extends({
      dispatchId: id
    }, details),

    id: id,
    action: type,
    data: payload,
    details: details
  };
}

function dispatch(id, actionObj, payload, alt) {
  var data = actionObj.dispatch(payload);
  if (data === undefined) return null;

  var type = actionObj.id;
  var namespace = type;
  var name = type;
  var details = { id: type, namespace: namespace, name: name };

  var dispatchLater = function dispatchLater(x) {
    return alt.dispatch(type, x, details);
  };

  if (fn.isFunction(data)) return data(dispatchLater, alt);

  // XXX standardize this
  return alt.dispatcher.dispatch(fsa(id, type, data, details));
}

/* istanbul ignore next */
function NoopClass() {}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _jpAction = __webpack_require__(43);

var _jpAction2 = _interopRequireDefault(_jpAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var jpStore = function () {
    function jpStore() {
        _classCallCheck(this, jpStore);

        this.bindActions(_jpAction2.default);
        this.warningMsg = "";
        this.journeyList = [];
        /*
            { _id: "12345", staffId: "A0001", userName: "Ho Kok Liang", date: new Date(), startTime: new Date(), endTime: new Date(), startLocation: "Jurong East", endLocation: "Jurong Point", googleStart: "Ho Ching Road", googleEnd: "Ho Ching Road", parking: 10.2, parkingImage:"/public/img/parkingImage.jpg" , distance: "10km", mileageClaim: 6, totalClaim: 21.4, status: 0 },
            { _id: "12315", staffId: "A0001", userName: "Ho Kok Liang", date: new Date(), startTime: new Date(), endTime: new Date(), startLocation: "Jurong East", endLocation: "Jurong Point", googleStart: "Ho Ching Road", googleEnd: "Ho Ching Road", distance: "10km", mileageClaim: 6, totalClaim: 21.4, status: 1 },
            { _id: "12325", staffId: "A0001", userName: "Ho Kok Liang", date: new Date(), startTime: new Date(), endTime: new Date(), startLocation: "Jurong East", endLocation: "Jurong Point", googleStart: "Ho Ching Road", googleEnd: "Ho Ching Road", erp: 5.20, parking: 10.2, parkingImage:"/public/img/parkingImage.jpg" , distance: "10km", mileageClaim: 6, totalClaim: 21.4, status: 1 },
            { _id: "12335", staffId: "A0001", userName: "Ho Kok Liang", date: new Date(), startTime: new Date(), endTime: new Date(), startLocation: "Jurong East", endLocation: "Jurong Point", googleStart: "Ho Ching Road", googleEnd: "Ho Ching Road", erp: 5.20, parking: 10.2, parkingImage:"/public/img/parkingImage.jpg" , distance: "10km", mileageClaim: 6, totalClaim: 21.4, status: 0 },
            { _id: "12365", staffId: "A0001", userName: "Ho Kok Liang", date: new Date(), startTime: new Date(), endTime: new Date(), startLocation: "Jurong East", endLocation: "Jurong Point", googleStart: "Ho Ching Road", googleEnd: "Ho Ching Road", erp: 5.20, parking: 10.2, parkingImage:"/public/img/parkingImage.jpg" , distance: "10km", mileageClaim: 6, totalClaim: 21.4, status: 0 },
            { _id: "12344", staffId: "A0001", userName: "Ho Kok Liang", date: new Date(), startTime: new Date(), endTime: new Date(), startLocation: "Jurong East", endLocation: "Jurong Point", googleStart: "Ho Ching Road", googleEnd: "Ho Ching Road", erp: 5.20, parking: 10.2, parkingImage:"/public/img/parkingImage.jpg" , distance: "10km", mileageClaim: 6, totalClaim: 21.4, status: 0 },
            { _id: "12341", staffId: "A0001", userName: "Ho Kok Liang", date: new Date(), startTime: new Date(), endTime: new Date(), startLocation: "Jurong East", endLocation: "Jurong Point", googleStart: "Ho Ching Road", googleEnd: "Ho Ching Road", erp: 5.20, parking: 10.2, parkingImage:"/public/img/parkingImage.jpg" , distance: "10km", mileageClaim: 6, totalClaim: 21.4, status: 0 },
        */
        this.selectedYear = new Date().getFullYear();
        this.selectedMonth = new Date().getMonth();
        this.staffId = -1;
        this.processing = false;
        this.submitRecord = [];
    }

    _createClass(jpStore, [{
        key: 'onWarningMsg',
        value: function onWarningMsg(data) {
            this.warningMsg = data;
        }
    }, {
        key: 'onProcessing',
        value: function onProcessing(data) {
            this.processing = data;
        }
    }, {
        key: 'onSelectMonth',
        value: function onSelectMonth(data) {
            this.selectedYear = data.selectedYear;
            this.selectedMonth = data.selectedMonth;
        }
    }, {
        key: 'onStaffId',
        value: function onStaffId(data) {
            this.staffId = data.staffId;
        }
    }, {
        key: 'onClear',
        value: function onClear() {
            this.journeyList = [];
        }
    }, {
        key: 'onGetJourneyPlannerSuccess',
        value: function onGetJourneyPlannerSuccess(data) {
            this.journeyList = data;
        }
    }, {
        key: 'onShouldListShow',
        value: function onShouldListShow(data) {
            this.journeyList[data].shouldListShow = !this.journeyList[data].shouldListShow;
        }
    }, {
        key: 'onCloseListShow',
        value: function onCloseListShow() {
            for (var i = 0; i < this.journeyList.length; i++) {
                this.journeyList[i].shouldListShow = false;
            }
        }
    }, {
        key: 'onUpdateERPSuccess',
        value: function onUpdateERPSuccess(data) {
            var len = this.journeyList.length;
            for (var i = 0; i < len; i++) {
                if (this.journeyList[i]._id == data._id) {
                    this.journeyList[i].erp = data.erp;
                    this.journeyList[i].totalClaim = data.totalClaim;
                    break;
                }
            }
        }
    }, {
        key: 'updateReceiptSuccess',
        value: function updateReceiptSuccess(data) {
            var len = this.journeyList.length;
            for (var i = 0; i < len; i++) {
                if (this.journeyList[i]._id == data._id) {
                    this.journeyList[i].parkingImage = data.parkingImage;
                    break;
                }
            }
        }
    }, {
        key: 'updateErpReceiptSuccess',
        value: function updateErpReceiptSuccess(data) {
            var len = this.journeyList.length;
            for (var i = 0; i < len; i++) {
                if (this.journeyList[i]._id == data._id) {
                    this.journeyList[i].erpImage = data.erpImage;
                    break;
                }
            }
        }
    }, {
        key: 'onUpdateParkingSuccess',
        value: function onUpdateParkingSuccess(data) {
            var len = this.journeyList.length;
            for (var i = 0; i < len; i++) {
                if (this.journeyList[i]._id == data._id) {
                    this.journeyList[i].parking = data.parking;
                    this.journeyList[i].totalClaim = data.totalClaim;
                    break;
                }
            }
        }
    }, {
        key: 'onUpdateRemarkSuccess',
        value: function onUpdateRemarkSuccess(data) {
            var len = this.journeyList.length;
            for (var i = 0; i < len; i++) {
                if (this.journeyList[i]._id == data._id) {
                    this.journeyList[i].remark = data.remark;
                    break;
                }
            }
        }
    }, {
        key: 'onUpdateMileageSuccess',
        value: function onUpdateMileageSuccess(data) {
            var len = this.journeyList.length;
            for (var i = 0; i < len; i++) {
                if (this.journeyList[i]._id == data._id) {
                    this.journeyList[i].mileageClaim = data.mileageClaim;
                    this.journeyList[i].totalClaim = data.totalClaim;
                    this.journeyList[i].distance = data.distance;
                    this.journeyList[i].googleStart = data.googleStart;
                    this.journeyList[i].googleEnd = data.googleEnd;
                    break;
                }
            }
        }
    }, {
        key: 'onRemoveJPSuccess',
        value: function onRemoveJPSuccess(data) {
            var len = this.journeyList.length;
            var pos = -1;
            for (var i = 0; i < len; i++) {
                if (this.journeyList[i]._id == data._id) {
                    pos = i;
                    break;
                }
            }
            if (pos != -1) {
                this.journeyList.splice(pos, 1);
            }
        }
    }, {
        key: 'onUpdateStatusSuccess',
        value: function onUpdateStatusSuccess(data) {
            var len = this.journeyList.length;
            for (var i = 0; i < len; i++) {
                if (this.journeyList[i]._id == data.id) {
                    this.journeyList[i].status = data.status;
                    break;
                }
            }
        }
    }, {
        key: 'onSubmitRecord',
        value: function onSubmitRecord(data) {
            this.submitRecord = data;
        }
    }, {
        key: 'onApproveAllSuccess',
        value: function onApproveAllSuccess(data) {
            if (this.staffId == data.staffId && this.selectedMonth == data.month && this.selectedYear == data.year) {
                for (var i = 0; i < this.journeyList.length; i++) {
                    if (this.journeyList[i].status == 3) {
                        this.journeyList[i] = 0;
                    }
                }
            }
        }
    }]);

    return jpStore;
}();

exports.default = _alt2.default.createStore(jpStore, 'jpStore');

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var permissionAction = function () {
    function permissionAction() {
        _classCallCheck(this, permissionAction);

        this.generateActions('processing', 'permission');
    }

    _createClass(permissionAction, [{
        key: 'getPermission',
        value: function getPermission() {
            var _this = this;

            if (sessionStorage.getItem('ui')) {

                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/permission', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            var _result = JSON.parse(xhttp.responseText);
                            _this.permission(_result);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this.processing(false);
                    }
                };
                xhttp.send(null);
            }
            /*
            this.permission([
                { permissionId: 0, title: "Attendance", description: "Grant user permission to edit the startTime/EndTime and view All Staff atendance", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
                { permissionId: 1, title: "Journey Planner", description: "Grant user permission to approve/reject each journey and send the list to account department", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
                { permissionId: 2, title: "Leave Application", description: "Grant user permission to approve/reject leave application", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
                { permissionId: 3, title: "Leave Summary", description: "Grant user permission to view other users leave summary", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
                { permissionId: 4, title: "Employee Detail", description: "Grant user permission to view other employees detail", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
                { permissionId: 5, title: "Employee Management", description: "Grant user permission to edit/add/remove employee detail", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
                { permissionId: 6, title: "Contractor/Condo Management", description: "Grant user permission to edit/add/remove condos and contractors", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
                { permissionId: 7, title: "Master CheckList", description: "Grant user permission to edit master checklist", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
                { permissionId: 8, title: "Leave Management", description: "Grant user permission to edit employees annual leave", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
                { permissionId: 9, title: "Permission Management", description: "To Allow user to modify permission", staffIds: [{ staffId: "A0001", userName: "Ho Kok Liang" }, { staffId: "A0004", userName: "Loh Jik Nen" }] },
            ]);
            this.processing(false);
            */
            return true;
        }
    }, {
        key: 'updatePermission',
        value: function updatePermission(permission) {
            var _this2 = this;

            if (sessionStorage.getItem('ui')) {

                var xhttp = new XMLHttpRequest();
                xhttp.open("PUT", '/v1/api/permission', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "You have updated the permission. Please refresh the browser" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            var _result2 = JSON.parse(xhttp.responseText);
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: _result2.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this2.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ permission: permission }));
            }
            return true;
        }
    }]);

    return permissionAction;
}();

exports.default = _alt2.default.createActions(permissionAction);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var jpSetAction = function () {
    function jpSetAction() {
        _classCallCheck(this, jpSetAction);

        this.generateActions('processing', 'conversionRate', 'emails', 'removeEmail', 'addEmail');
    }

    _createClass(jpSetAction, [{
        key: 'getConversion',
        value: function getConversion() {
            var _this = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/journeyPlanner/setting', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {

                            _this.conversionRate(result.conversionRate);
                            _this.emails(result.emails);
                        } else {

                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }, {
        key: 'updateJourneySetting',
        value: function updateJourneySetting(conversionRate, emails) {
            var _this2 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/journeyPlanner/setting', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            _modalAction2.default.modalContent({ title: "Success", content: "The setting is updated" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this2.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({ conversionRate: conversionRate, emails: emails }));
            }
            return true;
        }
    }]);

    return jpSetAction;
}();

exports.default = _alt2.default.createActions(jpSetAction);

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _leaveAtdAction = __webpack_require__(59);

var _leaveAtdAction2 = _interopRequireDefault(_leaveAtdAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var leaveAtdStore = function () {
    function leaveAtdStore() {
        _classCallCheck(this, leaveAtdStore);

        this.bindActions(_leaveAtdAction2.default);
        this.processing = false;
        this.summary = [];
        this.isLeaveSuccess = false;
        this.isAtdSuccess = false;
        this.staffId = "";
    }

    _createClass(leaveAtdStore, [{
        key: 'onProcessing',
        value: function onProcessing(data) {
            this.processing = data;
        }
    }, {
        key: 'onStaffId',
        value: function onStaffId(data) {
            this.staffId = data;
        }
    }, {
        key: 'onIsAtdSuccess',
        value: function onIsAtdSuccess(data) {
            this.isAtdSuccess = data;
        }
    }, {
        key: 'onSummary',
        value: function onSummary(data) {
            this.summary = data;
        }
    }, {
        key: 'onIsLeaveSuccess',
        value: function onIsLeaveSuccess(data) {
            this.isLeaveSuccess = data;
        }
    }]);

    return leaveAtdStore;
}();

exports.default = _alt2.default.createStore(leaveAtdStore, 'leaveAtdStore');

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var leaveAtdAction = function () {
    function leaveAtdAction() {
        _classCallCheck(this, leaveAtdAction);

        this.generateActions('processing', 'staffId', 'summary', 'isLeaveSuccess', 'isAtdSuccess');
    }

    _createClass(leaveAtdAction, [{
        key: 'markAttendate',
        value: function markAttendate(staffId, year, month, date, startTime, startLocation, startRemark, endTime, endLocation, endRemark) {
            var _this = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/attendance/staff/apply', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');

                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        if (xhttp.status == 200) {
                            _this.isAtdSuccess(true);
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Attendance marked. Page will be refresh in 3 seconds" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this.processing(false);
                    }
                };
                xhttp.send(JSON.stringify({
                    staffId: staffId,
                    year: year,
                    month: month,
                    date: date,
                    startTime: startTime,
                    startLocation: startLocation,
                    startRemark: startRemark,
                    endTime: endTime,
                    endLocation: endLocation,
                    endRemark: endRemark
                }));
            }
            return true;
        }
    }, {
        key: 'applyStaffLeave',
        value: function applyStaffLeave(fd) {
            var _this2 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("POST", '/v1/api/leave/staff/apply', true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));

                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {

                        if (xhttp.status == 200) {
                            _this2.isLeaveSuccess(true);
                            //show success message
                            _modalAction2.default.modalContent({ title: "Successful", content: "Leave applied. Page will be refresh in 3 seconds" });
                            _modalAction2.default.modalClose(true);
                        } else {
                            var result = JSON.parse(xhttp.responseText);
                            _modalAction2.default.modalContent({ title: "Error", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this2.processing(false);
                    }
                };
                xhttp.send(fd);
            }
            return true;
        }
    }, {
        key: 'getSummary',
        value: function getSummary(staffId) {
            var _this3 = this;

            if (sessionStorage.getItem('ui')) {
                var xhttp = new XMLHttpRequest();
                xhttp.open("GET", '/v1/api/leave/summary/' + staffId, true);
                xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                xhttp.onreadystatechange = function () {
                    if (xhttp.readyState == 4) {
                        var result = JSON.parse(xhttp.responseText);
                        if (xhttp.status == 200) {
                            _this3.summary(result.summary);
                        } else {
                            //handle error
                            _modalAction2.default.modalContent({ title: "Something went wrong", content: result.errorMsg });
                            _modalAction2.default.modalClose(true);
                        }
                        _this3.processing(false);
                    }
                };
                xhttp.send(null);
            }
            return true;
        }
    }]);

    return leaveAtdAction;
}();

exports.default = _alt2.default.createActions(leaveAtdAction);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

exports.default = resolvePathname;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

exports.default = valueEqual;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(16);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;

          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    (0, _invariant2.default)(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(_react2.default.Component);

Link.propTypes = {
  onClick: _propTypes2.default.func,
  target: _propTypes2.default.string,
  replace: _propTypes2.default.bool,
  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: _propTypes2.default.shape({
    history: _propTypes2.default.shape({
      push: _propTypes2.default.func.isRequired,
      replace: _propTypes2.default.func.isRequired,
      createHref: _propTypes2.default.func.isRequired
    }).isRequired
  }).isRequired
};

exports.default = Link;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Route = __webpack_require__(66);

var _Route2 = _interopRequireDefault(_Route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(16);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _matchPath = __webpack_require__(52);

var _matchPath2 = _interopRequireDefault(_matchPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var isEmptyChildren = function isEmptyChildren(children) {
  return _react2.default.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    (0, _invariant2.default)(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    (0, _warning2.default)(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? _react2.default.Children.only(children) : null : null;
  };

  return Route;
}(_react2.default.Component);

Route.propTypes = {
  computedMatch: _propTypes2.default.object, // private, from <Switch>
  path: _propTypes2.default.string,
  exact: _propTypes2.default.bool,
  strict: _propTypes2.default.bool,
  sensitive: _propTypes2.default.bool,
  component: _propTypes2.default.func,
  render: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
  location: _propTypes2.default.object
};
Route.contextTypes = {
  router: _propTypes2.default.shape({
    history: _propTypes2.default.object.isRequired,
    route: _propTypes2.default.object.isRequired,
    staticContext: _propTypes2.default.object
  })
};
Route.childContextTypes = {
  router: _propTypes2.default.object.isRequired
};

exports.default = Route;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function transmitter() {
  var subscriptions = [];
  var nowDispatching = false;
  var toUnsubscribe = {};

  var unsubscribe = function unsubscribe(onChange) {
    var id = subscriptions.indexOf(onChange);
    if (id < 0) return;
    if (nowDispatching) {
      toUnsubscribe[id] = onChange;
      return;
    }
    subscriptions.splice(id, 1);
  };

  var subscribe = function subscribe(onChange) {
    var id = subscriptions.push(onChange);
    var dispose = function dispose() {
      return unsubscribe(onChange);
    };
    return { dispose: dispose };
  };

  var publish = function publish() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    nowDispatching = true;
    try {
      subscriptions.forEach(function (subscription, id) {
        return toUnsubscribe[id] || subscription.apply(undefined, args);
      });
    } finally {
      nowDispatching = false;
      Object.keys(toUnsubscribe).forEach(function (id) {
        return unsubscribe(toUnsubscribe[id]);
      });
      toUnsubscribe = {};
    }
  };

  return {
    publish: publish,
    subscribe: subscribe,
    $subscriptions: subscriptions
  };
}

module.exports = transmitter;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _allList = __webpack_require__(162);

var _allList2 = _interopRequireDefault(_allList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AllBody = function (_React$Component) {
    _inherits(AllBody, _React$Component);

    function AllBody(props) {
        _classCallCheck(this, AllBody);

        var _this = _possibleConstructorReturn(this, (AllBody.__proto__ || Object.getPrototypeOf(AllBody)).call(this, props));

        _this.onTouchStart = _this.onTouchStart.bind(_this);
        _this.onTouchMove = _this.onTouchMove.bind(_this);
        _this.onTouchEnd = _this.onTouchEnd.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleMouseScroll = _this.handleMouseScroll.bind(_this);
        _this.state = {
            tableWidth: 300,
            dragging: false,
            refX: 0,
            ini: 0,
            page: 0,
            contentNo: 15
        };
        return _this;
    }

    _createClass(AllBody, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var tableWidth = _reactDom2.default.findDOMNode(this.refs.atd).clientWidth;
            this.setState({
                tableWidth: tableWidth
            });
            if (document.body.clientWidth > 600) {
                var elem = _reactDom2.default.findDOMNode(this.refs.table);
                elem.addEventListener('mouseup', this.onTouchEnd);
                elem.addEventListener('mouseleave', this.onTouchEnd);
                elem.addEventListener('mousemove', this.onTouchMove);
                elem.addEventListener('mousedown', this.onTouchStart);
                window.addEventListener('wheel', this.handleMouseScroll);
            }
            window.addEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (document.body.clientWidth > 768) {
                var elem = _reactDom2.default.findDOMNode(this.refs.table);
                elem.removeEventListener('mouseup', this.onTouchEnd);
                elem.removeEventListener('mouseleave', this.onTouchEnd);
                elem.removeEventListener('mousemove', this.onTouchMove);
                elem.removeEventListener('mousedown', this.onTouchStart);
                window.removeEventListener('wheel', this.handleMouseScroll);
            }
            window.removeEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevProps.staffsAtd != this.props.staffsAtd) {
                this.setState({
                    page: 0
                });
            }
        }
    }, {
        key: 'handleMouseScroll',
        value: function handleMouseScroll(e) {
            e.preventDefault();

            if (e.deltaY > 0) {
                //scroll down
                window.scrollBy(0, 50);
            } else {
                //scroll up
                window.scrollBy(0, -50);
            }
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(e) {
            var elem1 = _reactDom2.default.findDOMNode(this.refs.atd);
            var elem2 = _reactDom2.default.findDOMNode(this.refs.table);
            if (elem2.getBoundingClientRect().top < 50) {

                elem1.style.position = "absolute";

                if (document.body.clientWidth > 768) {
                    elem2.style.paddingTop = "50px";
                    elem1.style.top = 50 - elem2.getBoundingClientRect().top + "px";
                } else {
                    elem2.style.paddingTop = "0px";
                    elem1.style.top = -elem2.getBoundingClientRect().top + "px";
                }
            } else {
                elem1.style.position = "relative";
                elem1.style.top = "0px";
                elem2.style.paddingTop = "0px";
            }
        }
    }, {
        key: 'onTouchStart',
        value: function onTouchStart(e) {
            if (!this.state.dragging) {
                var touches = e.changedTouches;
                var refX = void 0;
                if (e.touches) {
                    refX = e.touches[0].clientX;
                } else {
                    refX = e.clientX;
                }
                var ini = _reactDom2.default.findDOMNode(this.refs.table).scrollLeft;
                this.setState({
                    ini: ini,
                    refX: refX,
                    dragging: true
                });
            } else {
                this.setState({
                    dragging: false
                });
            }
        }
    }, {
        key: 'onTouchMove',
        value: function onTouchMove(e) {
            e.preventDefault();
            if (this.state.dragging && e.target) {
                var deltaX = void 0;
                if (e.touches) {
                    deltaX = parseInt(this.state.refX - e.touches[0].clientX);
                } else {
                    deltaX = parseInt(this.state.refX - e.clientX);
                }

                _reactDom2.default.findDOMNode(this.refs.table).scrollLeft = this.state.ini + deltaX;
            } else {
                this.setState({
                    dragging: false
                });
            }
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.currentTarget.getAttribute('data-index'));

            if (index != this.state.page) {
                this.setState({ page: index });
            }
        }
    }, {
        key: 'onTouchEnd',
        value: function onTouchEnd(e) {
            this.setState({
                dragging: false
            });
        }
    }, {
        key: 'renderPagination',
        value: function renderPagination() {
            if (!this.props.staffsAtd) return;
            if (this.props.staffsAtd.length == 0) return;

            var pageNo = Math.ceil(this.props.staffsAtd.length / this.state.contentNo);

            var pagination = [];
            for (var i = 0; i < pageNo; i++) {
                pagination = pagination.concat(_react2.default.createElement(
                    'li',
                    { className: this.state.page == i ? "active" : "", key: i, 'data-index': i, onClick: this.handleClick },
                    _react2.default.createElement(
                        'a',
                        { href: '#' },
                        i + 1
                    )
                ));
            }
            return _react2.default.createElement(
                'nav',
                { className: 'ctr-pg', style: { maxWidth: this.state.tableWidth + "px" } },
                _react2.default.createElement(
                    'ul',
                    { className: 'pagination' },
                    pagination
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'pagination-title' },
                    'page ',
                    this.state.page + 1 + " of " + pageNo
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var staffsAtd = [];
            for (var i = 0 + this.state.contentNo * this.state.page; i < this.state.contentNo + this.state.contentNo * this.state.page; i++) {
                if (i < this.props.staffsAtd.length) {
                    staffsAtd = staffsAtd.concat(this.props.staffsAtd[i]);
                }
            }
            return _react2.default.createElement(
                'div',
                null,
                this.renderPagination(),
                _react2.default.createElement(
                    'div',
                    { className: 'atd-bd-wp', ref: 'table' },
                    _react2.default.createElement(
                        'div',
                        { className: 'atd-em-lt' },
                        _react2.default.createElement(
                            'table',
                            { className: 'atd-a-tb tb-heading', ref: 'atd' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Staff Id'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Name'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Date'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Time In'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Time In Location'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Time In Remark'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Time Out'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Time Out Location'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Time Out Remark'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Remarks'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Total Hours'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'OT Hours'
                                    ),
                                    _react2.default.createElement('th', null)
                                )
                            )
                        ),
                        _react2.default.createElement(_allList2.default, { staffsAtd: staffsAtd, processing: this.props.processing, page: this.state.page, contentNo: this.state.contentNo,
                            tableWidth: this.state.tableWidth, useFor: this.props.useFor, role: this.props.role })
                    )
                ),
                this.renderPagination()
            );
        }
    }]);

    return AllBody;
}(_react2.default.Component);

exports.default = AllBody;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var ClientRequest = __webpack_require__(164);
var extend = __webpack_require__(175);
var statusCodes = __webpack_require__(176);
var url = __webpack_require__(177);

var http = exports;

http.request = function (opts, cb) {
	if (typeof opts === 'string') opts = url.parse(opts);else opts = extend(opts);

	// Normally, the page is loaded from http or https, so not specifying a protocol
	// will result in a (valid) protocol-relative url. However, this won't work if
	// the protocol is something else, like 'file:'
	var defaultProtocol = global.location.protocol.search(/^https?:$/) === -1 ? 'http:' : '';

	var protocol = opts.protocol || defaultProtocol;
	var host = opts.hostname || opts.host;
	var port = opts.port;
	var path = opts.path || '/';

	// Necessary for IPv6 addresses
	if (host && host.indexOf(':') !== -1) host = '[' + host + ']';

	// This may be a relative url. The browser should always be able to interpret it correctly.
	opts.url = (host ? protocol + '//' + host : '') + (port ? ':' + port : '') + path;
	opts.method = (opts.method || 'GET').toUpperCase();
	opts.headers = opts.headers || {};

	// Also valid opts.auth, opts.mode

	var req = new ClientRequest(opts);
	if (cb) req.on('response', cb);
	return req;
};

http.get = function get(opts, cb) {
	var req = http.request(opts, cb);
	req.end();
	return req;
};

http.Agent = function () {};
http.Agent.defaultMaxSockets = 4;

http.STATUS_CODES = statusCodes;

http.METHODS = ['CHECKOUT', 'CONNECT', 'COPY', 'DELETE', 'GET', 'HEAD', 'LOCK', 'M-SEARCH', 'MERGE', 'MKACTIVITY', 'MKCOL', 'MOVE', 'NOTIFY', 'OPTIONS', 'PATCH', 'POST', 'PROPFIND', 'PROPPATCH', 'PURGE', 'PUT', 'REPORT', 'SEARCH', 'SUBSCRIBE', 'TRACE', 'UNLOCK', 'UNSUBSCRIBE'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

exports.fetch = isFunction(global.fetch) && isFunction(global.ReadableStream);

exports.blobConstructor = false;
try {
	new Blob([new ArrayBuffer(1)]);
	exports.blobConstructor = true;
} catch (e) {}

// The xhr request to example.com may violate some restrictive CSP configurations,
// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
// and assume support for certain features below.
var xhr;
function getXHR() {
	// Cache the xhr value
	if (xhr !== undefined) return xhr;

	if (global.XMLHttpRequest) {
		xhr = new global.XMLHttpRequest();
		// If XDomainRequest is available (ie only, where xhr might not work
		// cross domain), use the page location. Otherwise use example.com
		// Note: this doesn't actually make an http request.
		try {
			xhr.open('GET', global.XDomainRequest ? '/' : 'https://example.com');
		} catch (e) {
			xhr = null;
		}
	} else {
		// Service workers don't have XHR
		xhr = null;
	}
	return xhr;
}

function checkTypeSupport(type) {
	var xhr = getXHR();
	if (!xhr) return false;
	try {
		xhr.responseType = type;
		return xhr.responseType === type;
	} catch (e) {}
	return false;
}

// For some strange reason, Safari 7.0 reports typeof global.ArrayBuffer === 'object'.
// Safari 7.1 appears to have fixed this bug.
var haveArrayBuffer = typeof global.ArrayBuffer !== 'undefined';
var haveSlice = haveArrayBuffer && isFunction(global.ArrayBuffer.prototype.slice);

// If fetch is supported, then arraybuffer will be supported too. Skip calling
// checkTypeSupport(), since that calls getXHR().
exports.arraybuffer = exports.fetch || haveArrayBuffer && checkTypeSupport('arraybuffer');

// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
exports.msstream = !exports.fetch && haveSlice && checkTypeSupport('ms-stream');
exports.mozchunkedarraybuffer = !exports.fetch && haveArrayBuffer && checkTypeSupport('moz-chunked-arraybuffer');

// If fetch is supported, then overrideMimeType will be supported too. Skip calling
// getXHR().
exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false);

exports.vbArray = isFunction(global.VBArray);

function isFunction(value) {
	return typeof value === 'function';
}

xhr = null; // Help gc
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(74);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(78);
exports.Duplex = __webpack_require__(30);
exports.Transform = __webpack_require__(80);
exports.PassThrough = __webpack_require__(173);

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var processNextTick = __webpack_require__(41);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(71);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(75).EventEmitter;

var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(76);
/*</replacement>*/

// TODO(bmeurer): Change this back to const once hole checks are
// properly optimized away early in Ignition+TurboFan.
/*<replacement>*/
var Buffer = __webpack_require__(42).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(37);
util.inherits = __webpack_require__(27);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(168);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = __webpack_require__(169);
var destroyImpl = __webpack_require__(77);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') {
    return emitter.prependListener(event, fn);
  } else {
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
  }
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(30);

  options = options || {};

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(79).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(30);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(79).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    processNextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        processNextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    processNextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], self.emit.bind(self, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    processNextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(26)))

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function (n) {
  if (!isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function (type) {
  var er, handler, len, args, i, listeners;

  if (!this._events) this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error || isObject(this._events.error) && !this._events.error.length) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler)) return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++) {
      listeners[i].apply(this, args);
    }
  }

  return true;
};

EventEmitter.prototype.addListener = function (type, listener) {
  var m;

  if (!isFunction(listener)) throw TypeError('listener must be a function');

  if (!this._events) this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener) this.emit('newListener', type, isFunction(listener.listener) ? listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' + 'leak detected. %d listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.', this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function (type, listener) {
  if (!isFunction(listener)) throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function (type, listener) {
  var list, position, length, i;

  if (!isFunction(listener)) throw TypeError('listener must be a function');

  if (!this._events || !this._events[type]) return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener || isFunction(list.listener) && list.listener === listener) {
    delete this._events[type];
    if (this._events.removeListener) this.emit('removeListener', type, listener);
  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener || list[i].listener && list[i].listener === listener) {
        position = i;
        break;
      }
    }

    if (position < 0) return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener) this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function (type) {
  var key, listeners;

  if (!this._events) return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0) this._events = {};else if (this._events[type]) delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length) {
      this.removeListener(type, listeners[listeners.length - 1]);
    }
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function (type) {
  var ret;
  if (!this._events || !this._events[type]) ret = [];else if (isFunction(this._events[type])) ret = [this._events[type]];else ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function (type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener)) return 1;else if (evlistener) return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function (emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(75).EventEmitter;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var processNextTick = __webpack_require__(41);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      processNextTick(emitErrorNT, this, err);
    }
    return;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      processNextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var processNextTick = __webpack_require__(41);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(37);
util.inherits = __webpack_require__(27);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(172)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(76);
/*</replacement>*/

/*<replacement>*/
var Buffer = __webpack_require__(42).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*</replacement>*/

var destroyImpl = __webpack_require__(77);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(30);

  options = options || {};

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(30);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  processNextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    processNextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = _isUint8Array(chunk) && !state.objectMode;

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    processNextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    processNextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequestCount = 0;
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      processNextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26), __webpack_require__(170).setImmediate, __webpack_require__(18)))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(42).Buffer;

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return -1;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// UTF-8 replacement characters ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\uFFFD'.repeat(p);
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\uFFFD'.repeat(p + 1);
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\uFFFD'.repeat(p + 2);
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character for each buffered byte of a (partial)
// character needs to be added to the output.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\uFFFD'.repeat(this.lastTotal - this.lastNeed);
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(30);

/*<replacement>*/
var util = __webpack_require__(37);
util.inherits = __webpack_require__(27);
/*</replacement>*/

util.inherits(Transform, Duplex);

function TransformState(stream) {
  this.afterTransform = function (er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
  this.writeencoding = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return stream.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data !== null && data !== undefined) stream.push(data);

  cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = new TransformState(this);

  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.once('prefinish', function () {
    if (typeof this._flush === 'function') this._flush(function (er, data) {
      done(stream, er, data);
    });else done(stream);
  });
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data !== null && data !== undefined) stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var ts = stream._transformState;

  if (ws.length) throw new Error('Calling transform done when ws.length != 0');

  if (ts.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportModal = function (_React$Component) {
    _inherits(ReportModal, _React$Component);

    function ReportModal(props) {
        _classCallCheck(this, ReportModal);

        var _this = _possibleConstructorReturn(this, (ReportModal.__proto__ || Object.getPrototypeOf(ReportModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.upLoadImg = _this.upLoadImg.bind(_this);
        _this.handleRemove = _this.handleRemove.bind(_this);
        _this.handleEmailChange = _this.handleEmailChange.bind(_this);
        _this.state = {
            txtValue1: "",
            txtValue2: "",
            reportImage: "",
            clientEmail: [],
            email: "",
            warningMsg: ""
        };
        return _this;
    }

    _createClass(ReportModal, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            if (this.props.clientEmail) {
                if (this.props.clientEmail.length > 0) {
                    this.setState({
                        clientEmail: this.props.clientEmail
                    });
                }
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {}
    }, {
        key: "upLoadImg",
        value: function upLoadImg(e) {
            e.preventDefault();
            var len = e.target.files.length;
            if (len > 3) {
                return this.setState({ warningMsg: "Maximum upload 3 pictures only" });
            } else {
                this.setState({ warningMsg: "" });
            }
            for (var i = 0; i < len; i++) {
                var file = e.target.files[i];
                this._previewImage(file, i);
            }
            //let file = e.target.files[0];
            //this._previewImage(file, 0);
        }
    }, {
        key: "_previewImage",
        value: function _previewImage(file, index) {
            var _this2 = this;

            //to be modified
            var fr = new FileReader();
            fr.onload = function (e) {
                var imgUrl = window.URL.createObjectURL(new Blob([e.target.result]));
                var img = new Image();

                img.onload = function () {
                    _this2.resizeImage(img, index);
                };

                img.src = imgUrl;
            };
            fr.readAsArrayBuffer(file);
        }
    }, {
        key: "dataURItoBlob",
        value: function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = window.atob(dataURI.split(',')[1]);else byteString = unescape(dataURI.split(',')[1]);

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], { type: mimeString });
        }
    }, {
        key: "resizeImage",
        value: function resizeImage(image, index) {
            var oHeight = image.naturalHeight;
            var oWidth = image.naturalWidth;
            var newImage = void 0,
                newSize = void 0;
            var oSize = { oHeight: oHeight, oWidth: oWidth };
            newSize = { width: 500, height: 500 * oHeight / oWidth };

            newImage = this._imgResize(image, newSize, oSize);
            var blobFile = this.state.reportImage;
            if (blobFile == "") blobFile = [];
            blobFile[index] = this.dataURItoBlob(newImage);
            this.setState({ reportImage: blobFile });
        }
    }, {
        key: "_imgResize",
        value: function _imgResize(img, newSize, oSize) {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext("2d");
            canvas.width = newSize.width;
            canvas.height = newSize.height;
            ctx.drawImage(img, 0, 0, oSize.oWidth, oSize.oHeight, 0, 0, newSize.width, newSize.height);
            return canvas.toDataURL('image/jpeg', 1);
        }
    }, {
        key: "handleRemove",
        value: function handleRemove(e) {
            e.preventDefault();
            var index = parseInt(e.currentTarget.getAttribute("data-index"));
            var clientEmail = this.state.clientEmail;
            clientEmail.splice(index, 1);
            this.setState({ clientEmail: clientEmail });
        }
    }, {
        key: "handleClick",
        value: function handleClick(e) {
            var clientEmail = this.state.clientEmail;
            clientEmail = clientEmail.concat(this.state.email);
            this.setState({ clientEmail: clientEmail, email: "" });
        }
    }, {
        key: "handleEmailChange",
        value: function handleEmailChange(e) {
            var value = e.target.value;
            this.setState({ email: value });
        }
    }, {
        key: "handleChange",
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var value = e.target.value;
            if (index == 0) {
                if (this.props.action == 0) {
                    value = parseInt(value);
                }
                this.setState({ txtValue1: value });
            } else {
                this.setState({ txtValue2: value });
            }
        }
    }, {
        key: "handleSubmit",
        value: function handleSubmit(e) {
            if (this.state.reportImage) {
                if (this.state.reportImage.length > 3) {
                    return this.setState({ warningMsg: "Maximum 3 picture only" });
                }
            }
            if (this.state.txtValue1 == "") {
                return this.setState({ warningMsg: "Please fill up all information" });
            }
            if (this.props.action == 0 && this.state.txtValue2 == "") {
                return this.setState({ warningMsg: "Please fill up all information" });
            }
            this.props.callBack(this.state.txtValue1, this.state.txtValue2, this.state.clientEmail, this.state.reportImage);
        }
    }, {
        key: "modalClose",
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: "renderEmailList",
        value: function renderEmailList() {
            var _this3 = this;

            return this.state.clientEmail.map(function (email, index) {
                return _react2.default.createElement(
                    "div",
                    { className: "rp-em", key: index },
                    _react2.default.createElement(
                        "div",
                        { className: "rp-em-1" },
                        email
                    ),
                    _react2.default.createElement(
                        "button",
                        { className: "rp-em-2 btn btn-xs btn-danger", "data-index": index, onClick: _this3.handleRemove },
                        "Remove"
                    )
                );
            });
        }
    }, {
        key: "renderEmail",
        value: function renderEmail() {
            return _react2.default.createElement(
                "form",
                { autoComplete: "on", style: { marginTop: "10px" } },
                _react2.default.createElement(
                    "div",
                    { className: "input-group", style: { marginBottom: "10px" } },
                    _react2.default.createElement("input", { type: "text", className: "form-control", placeholder: "Email", value: this.state.email,
                        onChange: this.handleEmailChange, autoComplete: "on" }),
                    _react2.default.createElement(
                        "span",
                        { className: "input-group-btn" },
                        _react2.default.createElement(
                            "button",
                            { className: "btn btn-default", type: "button", onClick: this.handleClick },
                            "Add"
                        )
                    )
                ),
                _react2.default.createElement(
                    "label",
                    null,
                    "Recipients"
                ),
                this.renderEmailList()
            );
        }
    }, {
        key: "renderBody",
        value: function renderBody() {
            var body = "";
            if (this.props.action == 0) {
                body = _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "form",
                        null,
                        _react2.default.createElement("input", { className: "form-control", placeholder: "Extend no of days", type: "number", "data-index": "0",
                            onChange: this.handleChange }),
                        _react2.default.createElement("textarea", { className: "form-control", rows: "3", placeholder: "Input reason here", type: "text", "data-index": "1",
                            onChange: this.handleChange }),
                        _react2.default.createElement("input", { className: "form-control", type: "file", name: "myImage", accept: "image/x-png,image/jpeg",
                            onChange: this.upLoadImg, multiple: true })
                    ),
                    this.renderEmail()
                );
            } else if (this.props.action == 1) {
                body = _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "form",
                        null,
                        _react2.default.createElement("textarea", { className: "form-control", rows: "3", placeholder: "Input resolution here", type: "text", "data-index": "0",
                            onChange: this.handleChange }),
                        _react2.default.createElement("input", { className: "form-control", type: "file", name: "myImage", accept: "image/x-png,image/jpeg",
                            onChange: this.upLoadImg, multiple: true })
                    ),
                    this.renderEmail()
                );
            } else if (this.props.action == 2) {
                body = _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "form",
                        null,
                        _react2.default.createElement("textarea", { className: "form-control", rows: "3", placeholder: "Add remark here", type: "text", "data-index": "0",
                            onChange: this.handleChange }),
                        _react2.default.createElement("input", { className: "form-control", type: "file", name: "myImage", accept: "image/x-png,image/jpeg",
                            onChange: this.upLoadImg, multiple: true })
                    ),
                    this.renderEmail()
                );
            } else {
                //remove incident report
                body = _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "form",
                        null,
                        _react2.default.createElement("textarea", { className: "form-control", rows: "3", placeholder: "Input reason to remove incident report", type: "text", "data-index": "0",
                            onChange: this.handleChange })
                    ),
                    this.renderEmail()
                );
            }
            return body;
        }
    }, {
        key: "render",
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            var content = void 0;

            return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement("div", { className: "report-shadow", style: style }),
                _react2.default.createElement(
                    "div",
                    { className: "report-modal", style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        "div",
                        { className: "modal-header" },
                        _react2.default.createElement(
                            "h4",
                            { className: "modal-title" },
                            this.props.title
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "modal-body" },
                        _react2.default.createElement(
                            "div",
                            { className: "warning" },
                            this.state.warningMsg
                        ),
                        this.renderBody()
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "modal-footer" },
                        _react2.default.createElement(
                            "button",
                            { type: "button", className: "btn " + (this.props.action == 3 ? " btn-danger" : "btn-warning"),
                                onClick: this.handleSubmit },
                            this.props.action == 3 ? "Remove" : "Update"
                        ),
                        _react2.default.createElement(
                            "button",
                            { type: "button", className: "btn btn-default", onClick: this.modalClose },
                            "Cancel"
                        )
                    )
                )
            );
        }
    }]);

    return ReportModal;
}(_react2.default.Component);

ReportModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = ReportModal;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    resizeImage: function resizeImage(uriData) {
        var newImg = this.createImage(uriData);
        var naturalHeight = newImg.naturalHeight;
        var naturalWidth = newImg.naturalWidth;
        var desireRatio = 150 / 200;
        var newHeight = void 0,
            newWidth = void 0;

        //calculate new Size
        if (naturalWidth / naturalHeight > desireRatio) {
            //fix height
            newHeight = 400;
            newWidth = newHeight * naturalWidth / naturalHeight;
        } else {
            newWidth = 300;
            newHeight = newWidth * naturalHeight / naturalWidth;
        }

        //crop image
        var dataURI = this.cropImage(newImg, naturalWidth, naturalHeight, newWidth, newHeight);
        //convert to blob data
        return this.dataURItoBlob(dataURI);
    },
    createImage: function createImage(img) {
        var createImage = void 0;
        createImage = new Image();
        createImage.src = img;
        return createImage;
    },
    cropImage: function cropImage(img, naturalWidth, naturalHeight, newWidth, newHeight) {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext("2d");
        canvas.width = newWidth;
        canvas.height = newHeight;
        ctx.drawImage(img, 0, 0, naturalWidth, naturalHeight, 0, 0, newWidth, newHeight);
        return canvas.toDataURL('image/jpeg', 0.9);
    },
    dataURItoBlob: function dataURItoBlob(dataURI) {
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = window.atob(dataURI.split(',')[1]);else byteString = unescape(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], { type: mimeString });
    }
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userSetAction = __webpack_require__(15);

var _userSetAction2 = _interopRequireDefault(_userSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserSetModal = function (_React$Component) {
    _inherits(UserSetModal, _React$Component);

    function UserSetModal(props) {
        _classCallCheck(this, UserSetModal);

        var _this = _possibleConstructorReturn(this, (UserSetModal.__proto__ || Object.getPrototypeOf(UserSetModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        return _this;
    }

    _createClass(UserSetModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {}
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
            _userSetAction2.default.isSucceed(false);
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            var content = void 0;
            if (this.props.usMode == 0) {
                content = "User Created";
            } else if (this.props.usMode == 3) {
                content = "User Updated";
            } else if (this.props.usMode == 4) {
                content = "User Removed";
            }
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'report-modal', style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            'Successful'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body' },
                        content
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-info single-btn', onClick: this.modalClose },
                            'Ok'
                        )
                    )
                )
            );
        }
    }]);

    return UserSetModal;
}(_react2.default.Component);

UserSetModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = UserSetModal;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _userSetAction = __webpack_require__(15);

var _userSetAction2 = _interopRequireDefault(_userSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SupervisorModal = function (_React$Component) {
    _inherits(SupervisorModal, _React$Component);

    function SupervisorModal(props) {
        _classCallCheck(this, SupervisorModal);

        var _this = _possibleConstructorReturn(this, (SupervisorModal.__proto__ || Object.getPrototypeOf(SupervisorModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleCheck = _this.handleCheck.bind(_this);
        _this.state = {
            staffIds: [],
            warningMsg: "",
            staffId: "",
            clientHeight: 200
        };
        return _this;
    }

    _createClass(SupervisorModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var clientHeight = _reactDom2.default.findDOMNode(this.refs.modal).clientHeight;
            this.setState({
                staffIds: this.props.staffIds,
                clientHeight: clientHeight
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            this.setState({
                staffId: e.target.value
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            _userSetAction2.default.supervisor(this.state.staffIds);
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'handleCheck',
        value: function handleCheck(e) {
            var checked = e.target.checked;
            var staffId = e.target.value;
            var userName = e.target.getAttribute('data-username');

            var staffIds = this.state.staffIds;
            if (checked) {
                if (staffIds) {
                    staffIds.push({
                        staffId: staffId,
                        userName: userName
                    });
                } else {
                    staffIds = [{
                        staffId: staffId,
                        userName: userName
                    }];
                }
            } else {
                //remove from list
                var len = staffIds.length;
                for (var i = 0; i < len; i++) {
                    if (staffIds[i].staffId == staffId) {
                        staffIds.splice(i, 1);
                        break;
                    }
                }
            }
            this.setState({
                staffIds: staffIds
            });
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'checkStaff',
        value: function checkStaff(staff) {
            var isCheck = false;
            console.log(this.state.staffIds);
            if (this.state.staffIds) {
                var len = this.state.staffIds.length;
                for (var i = 0; i < len; i++) {
                    if (this.state.staffIds[i].staffId == staff.staffId) {
                        isCheck = true;
                        break;
                    }
                }
            }
            return isCheck;
        }
    }, {
        key: 'renderDetail',
        value: function renderDetail(staff, index) {
            //check if this facility is included;
            var isCheck = this.checkStaff(staff);

            return _react2.default.createElement(
                'li',
                { className: 'pm-li-1', key: index },
                _react2.default.createElement(
                    'div',
                    { className: 'checkbox' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', { type: 'checkbox', value: staff.staffId, 'data-username': staff.userName, onChange: this.handleCheck, checked: isCheck }),
                        _react2.default.createElement('span', { className: 'checkmark' }),
                        staff.userName
                    )
                )
            );
        }
    }, {
        key: 'renderList',
        value: function renderList(staffs) {
            var _this2 = this;

            return staffs.map(function (staff, index) {
                return _this2.renderDetail(staff, index);
            });
        }
    }, {
        key: 'renderStaff',
        value: function renderStaff() {
            var _this3 = this;

            if (this.props.staffs.length > 0) {
                var staffs = this.props.staffs.filter(function (staff) {
                    return staff.userName.toLowerCase().indexOf(_this3.state.staffId.toLowerCase()) > -1 || staff.staffId.toLowerCase().indexOf(_this3.state.staffId.toLowerCase()) > -1;
                });

                return this.renderList(staffs);
            }
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'staffFilter' },
                            'Staff:'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'staffFilter', placeholder: 'Search By name or ID', onChange: this.handleChange })
                    )
                ),
                _react2.default.createElement('div', { className: 'divider' }),
                _react2.default.createElement(
                    'ul',
                    { className: 'pm-ul', style: { height: this.state.clientHeight - 200 + "px", overflow: "auto" } },
                    this.renderStaff()
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'permission-modal', style: { visibility: style.visibility }, ref: 'modal' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            this.props.title
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body', style: { height: this.state.clientHeight - 115 + "px" } },
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        ),
                        this.renderContent()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-warning', onClick: this.handleClick },
                            'Done'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return SupervisorModal;
}(_react2.default.Component);

SupervisorModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = SupervisorModal;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _contractorFilter = __webpack_require__(230);

var _contractorFilter2 = _interopRequireDefault(_contractorFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractorHeader = function (_React$Component) {
    _inherits(ContractorHeader, _React$Component);

    function ContractorHeader(props) {
        _classCallCheck(this, ContractorHeader);

        return _possibleConstructorReturn(this, (ContractorHeader.__proto__ || Object.getPrototypeOf(ContractorHeader)).call(this, props));
    }

    _createClass(ContractorHeader, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-hd' },
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(
                        'b',
                        null,
                        'Contractor Management'
                    )
                ),
                _react2.default.createElement(_contractorFilter2.default, this.props),
                _react2.default.createElement('div', { className: 'clear' })
            );
        }
    }]);

    return ContractorHeader;
}(_react2.default.Component);

exports.default = ContractorHeader;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _emAction = __webpack_require__(38);

var _emAction2 = _interopRequireDefault(_emAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var emStore = function () {
    function emStore() {
        _classCallCheck(this, emStore);

        this.bindActions(_emAction2.default);
        this.processing = false;
        this.selectedYear = new Date().getFullYear();
        this.selectedMonth = new Date().getMonth();
        this.staffId = "";
        this.mcst = "";
        this.warningMsg = "";
        this.estate = [];
        /*
            {
                mcst: "1234",
                condoName: "condo A",
                incident: 1,
                estate: [
                    { _id: "123", condoName: "Condo A", mcst: "1234", userName: "Ho Kok Liang", date: new Date(), time: new Date(), facility: "Swimming Pool", category: "Tile", status: 0 },
                    { _id: "124", condoName: "Condo A", mcst: "1234", userName: "Ho Kok Liang", date: new Date(), time: new Date(), facility: "Swimming Pool", category: "Tile", status: 1, report: "A001" },
                    { _id: "125", condoName: "Condo A", mcst: "1234", userName: "Ho Kok Liang", date: new Date(), time: new Date(), facility: "Swimming Pool", category: "Tile", status: 0 },
                ]
            },
            {
                mcst: "1235",
                condoName: "condo b",
                incident: 1,
                estate: [
                    { _id: "126", condoName: "Condo b", mcst: "1235", userName: "Tan Kai Lee", date: new Date(), time: new Date(), facility: "Swimming Pool", category: "Tile", status: 0 },
                    { _id: "127", condoName: "Condo b", mcst: "1235", userName: "Tan Kai Lee", date: new Date(), time: new Date(), facility: "Swimming Pool", category: "Tile", status: 1, report: "A002" },
                ]
            }
        */
    }

    _createClass(emStore, [{
        key: 'onWarningMsg',
        value: function onWarningMsg(data) {
            this.warningMsg = data;
        }
    }, {
        key: 'onProcessing',
        value: function onProcessing(data) {
            this.processing = data;
        }
    }, {
        key: 'onStaffId',
        value: function onStaffId(data) {
            this.staffId = data.staffId;
        }
    }, {
        key: 'onSelectMonth',
        value: function onSelectMonth(data) {
            this.selectedYear = data.selectedYear;
            this.selectedMonth = data.selectedMonth;
        }
    }, {
        key: 'onMcst',
        value: function onMcst(data) {
            this.mcst = data.mcst;
        }
    }, {
        key: 'onEstateSuccess',
        value: function onEstateSuccess(data) {
            this.estate = data;
            this.onSortByStatus();
        }
    }, {
        key: 'onShouldListShow',
        value: function onShouldListShow(data) {
            this.estate[data].shouldListShow = !this.estate[data].shouldListShow;
        }
    }, {
        key: 'onSortByStatus',
        value: function onSortByStatus(data) {

            var len = this.estate.length;
            for (var i = 0; i < len; i++) {
                this.estate[i].estate.sort(function (a, b) {
                    if (typeof data != 'number') {
                        return new Date(b.date).getTime() - new Date(a.date).getTime();
                    } else if (data == 0) {
                        if (a.status == b.status && a.status == 0) {
                            return new Date(b.date).getTime() - new Date(a.date).getTime();
                        } else if (a.status == 0) {
                            return -1;
                        } else if (a.status != 0 && b.status != 0) {
                            return new Date(b.date).getTime() - new Date(a.date).getTime();
                        } else {
                            return 1;
                        }
                    } else if (data == 1) {
                        if (a.status == b.status && a.status == 1) {
                            return new Date(b.date).getTime() - new Date(a.date).getTime();
                        } else if (a.status == 1) {
                            return -1;
                        } else if (a.status != 1 && b.status != 1) {
                            return new Date(b.date).getTime() - new Date(a.date).getTime();
                        } else {
                            return 1;
                        }
                    } else {
                        if (a.status == b.status && a.status == 2) {
                            return new Date(b.date).getTime() - new Date(a.date).getTime();
                        } else if (a.status == 2) {
                            return -1;
                        } else if (a.status != 2 && b.status != 2) {
                            return new Date(b.date).getTime() - new Date(a.date).getTime();
                        } else {
                            return 1;
                        }
                    }
                });
            }
        }
    }]);

    return emStore;
}();

exports.default = _alt2.default.createStore(emStore, 'emStore');

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _contractorAction = __webpack_require__(14);

var _contractorAction2 = _interopRequireDefault(_contractorAction);

var _contractorStore = __webpack_require__(29);

var _contractorStore2 = _interopRequireDefault(_contractorStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractorDisplay = function (_React$Component) {
    _inherits(ContractorDisplay, _React$Component);

    function ContractorDisplay(props) {
        _classCallCheck(this, ContractorDisplay);

        var _this = _possibleConstructorReturn(this, (ContractorDisplay.__proto__ || Object.getPrototypeOf(ContractorDisplay)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.state = {
            contractor: _contractorStore2.default.getState().contractor,
            processing: _contractorStore2.default.getState().processing,
            warningMsg: ""
        };
        return _this;
    }

    _createClass(ContractorDisplay, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _contractorStore2.default.listen(this.onChange);
            _menuAction2.default.pageNumber({ selectedActivity: -1, selectedCategory: 0 });
            _contractorAction2.default.clear();
            if (!this.state.processing) {
                _contractorAction2.default.processing(true);
                _contractorAction2.default.getContractor(this.props.match.params.id);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _contractorStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                contractor: state.contractor
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            if (index == 2) {
                this.props.history.push('/contractor');
            } else if (index == 0) {
                window.print();
            } else if (index == 1) {
                _contractorAction2.default.processing(true);
                _contractorAction2.default.exportContractor(this.state.contractor._id);
            }
        }
    }, {
        key: 'generateDateFormat',
        value: function generateDateFormat(date) {
            if (date) {
                return date.getDate() + "-" + this.props.mthTxt[date.getMonth()] + "-" + date.getFullYear();
            }
        }
    }, {
        key: 'renderDetail',
        value: function renderDetail(condo) {
            var _this2 = this;

            var content = condo.contract.map(function (detail, index) {
                var contractStartDate = detail.contractStartDate ? _this2.generateDateFormat(new Date(detail.contractStartDate)) : "";
                var contractEndDate = detail.contractEndDate ? _this2.generateDateFormat(new Date(detail.contractEndDate)) : "";
                var firstReminder = detail.firstReminder ? _this2.generateDateFormat(new Date(detail.firstReminder)) : "";
                var secReminder = detail.secondReminder ? _this2.generateDateFormat(new Date(detail.secondReminder)) : "";
                var lastVisit = detail.lastVisit ? _this2.generateDateFormat(new Date(detail.lastVisit)) : "";
                var dueDays = 0;
                if (detail.contractEndDate) {
                    dueDays = Math.ceil((new Date(detail.contractEndDate).getTime() - new Date().getTime()) / 1000 / 3600 / 24);
                }

                return _react2.default.createElement(
                    'li',
                    { key: index },
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-col-1' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Service:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                detail.service
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Description:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                detail.description
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Last Visit:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                lastVisit ? lastVisit : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Remark:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                detail.remark ? detail.remark : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Amount (SGD):'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                detail.amount ? "$" + detail.amount : "--"
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-col-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Status:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                typeof detail.status == 'number' ? _this2.props.statusTxt[detail.status] : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Contract Start Date:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                contractStartDate ? contractStartDate : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Contract End Date:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                contractEndDate ? contractEndDate : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Contract Due In (days):'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: "ct-li-ct " + (dueDays >= 0 ? "ct-green" : "ct-red") },
                                dueDays ? dueDays : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'First Reminder:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                firstReminder ? firstReminder : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Second Reminder:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                secReminder ? secReminder : "--"
                            )
                        )
                    )
                );
            });
            return _react2.default.createElement(
                'ul',
                { className: 'ct-cul ct-show' },
                content
            );
        }
    }, {
        key: 'renderCondo',
        value: function renderCondo() {
            var _this3 = this;

            var s = this.state.contractor;

            return s.contracts.map(function (condo, index) {
                return _react2.default.createElement(
                    'div',
                    { key: index },
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-cli' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-cn', 'data-mcst': condo.mcst, 'data-condoname': condo.condoName },
                            condo.condoName + " (" + condo.mcst + ")"
                        )
                    ),
                    _this3.renderDetail(condo)
                );
            });
        }
    }, {
        key: 'renderAddDetail',
        value: function renderAddDetail(streetName, blkNo, unitNo, postal) {
            //address: "Blk 446 Hougang Ave 8", unitNo: "B1-1635", postal: "530446"
            return _react2.default.createElement(
                'div',
                null,
                streetName ? streetName + ", " : "",
                blkNo ? blkNo + " " : "",
                unitNo ? unitNo + ", \n" : "",
                postal,
                ' Singapore'
            );
        }
    }, {
        key: 'renderAddress',
        value: function renderAddress() {
            var s = this.state.contractor;
            return this.renderAddDetail(s.streetName, s.blkNo, s.unitNo, s.postal);
        }
    }, {
        key: 'render',
        value: function render() {
            var s = this.state.contractor;

            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(_loading2.default, _extends({}, this.props, { processing: this.state.processing })),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 us-form' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-dis' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    _react2.default.createElement(
                                        'h4',
                                        null,
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            s.contractorName ? s.contractorName : "--"
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'contractorName' },
                                            'Contractor Detail'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'telephone' },
                                            'Telephone:'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'ct-item' },
                                            s.telephone ? s.telephone : "--"
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'fax' },
                                            'Fax:'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'ct-item' },
                                            s.fax ? s.fax : "--"
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'contractorEmail' },
                                            'Contractor Email:'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'ct-item' },
                                            s.contractorEmail ? s.contractorEmail : "--"
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'contactName' },
                                            'Contact Name:'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'ct-item' },
                                            s.contactName ? s.contactName : "--"
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'totalAmount' },
                                            'Total Contract Amount (SGD):'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'ct-item' },
                                            s.totalAmount
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'condoList' },
                                        _react2.default.createElement(
                                            'label',
                                            null,
                                            'Address:'
                                        ),
                                        this.renderAddress()
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'condoList' },
                                        _react2.default.createElement(
                                            'h5',
                                            null,
                                            _react2.default.createElement(
                                                'b',
                                                null,
                                                'Managing Estate'
                                            )
                                        ),
                                        this.renderCondo()
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-4' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'warning' },
                                        this.state.warningMsg
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-primary us-cr',
                                            'data-index': '0', onClick: this.handleClick },
                                        'Print'
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-primary us-cr',
                                            'data-index': '1', onClick: this.handleClick },
                                        'Export'
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-default us-cr',
                                            'data-index': '2', onClick: this.handleClick },
                                        'Cancel'
                                    )
                                ),
                                _react2.default.createElement('div', { className: 'clear' })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ContractorDisplay;
}(_react2.default.Component);

ContractorDisplay.defaultProps = {
    mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    statusTxt: ["Active", "In-Active", "Terminated", "Ad hoc"],
    roleTxt: ["Administrative Executive", "Property Executive", "Property Manager", "Human Resource Executive", "Contracts Management Executive", "Accounts Executive", "Accounts Manager", "Information Technology", "Managing Director", "Director", "Other", "Cleaner Supervisor", "Cleaner", "Landscaper", "Electrician", "Caretaker", "Portfolio Manager", "Team Manager", "Senior Admin Executive"]
};
exports.default = ContractorDisplay;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _contractorAction = __webpack_require__(14);

var _contractorAction2 = _interopRequireDefault(_contractorAction);

var _contractorStore = __webpack_require__(29);

var _contractorStore2 = _interopRequireDefault(_contractorStore);

var _modalCondo = __webpack_require__(262);

var _modalCondo2 = _interopRequireDefault(_modalCondo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractorCondoForm = function (_React$Component) {
    _inherits(ContractorCondoForm, _React$Component);

    function ContractorCondoForm(props) {
        _classCallCheck(this, ContractorCondoForm);

        var _this = _possibleConstructorReturn(this, (ContractorCondoForm.__proto__ || Object.getPrototypeOf(ContractorCondoForm)).call(this, props));

        _this.handleEditService = _this.handleEditService.bind(_this);
        _this.handleNewCondo = _this.handleNewCondo.bind(_this);
        _this.handleNewService = _this.handleNewService.bind(_this);
        _this.handleRemoveCondo = _this.handleRemoveCondo.bind(_this);
        _this.handleRemoveService = _this.handleRemoveService.bind(_this);
        _this.handleToggle = _this.handleToggle.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);

        _this.callBack = _this.callBack.bind(_this);
        _this.state = {
            modalClose: false,
            title: "",
            action: "",
            mcst: "",
            index: ""
        };
        return _this;
    }

    _createClass(ContractorCondoForm, [{
        key: 'callBack',
        value: function callBack(value1, value2, value3, value4, value5, value6, value7, value8) {
            if (this.state.action == 0) {
                _contractorAction2.default.addCondo({ mcst: value1, condoName: value2 });
            } else if (this.state.action == 1) {
                _contractorAction2.default.addService({
                    mcst: this.state.mcst, contract: {
                        service: value1, description: value2,
                        remark: value3, amount: value4, contractStartDate: value5, contractEndDate: value6,
                        lastVisit: value7, status: value8
                    }
                });
            } else if (this.state.action == 2) {
                _contractorAction2.default.removeCondo({ mcst: this.state.mcst });
            } else if (this.state.action == 3) {
                _contractorAction2.default.editService({
                    mcst: this.state.mcst, index: this.state.index, contract: {
                        service: value1,
                        description: value2, remark: value3, amount: value4, contractStartDate: value5,
                        contractEndDate: value6, lastVisit: value7, status: value8
                    }
                });
            } else {
                _contractorAction2.default.removeService({ mcst: this.state.mcst, index: this.state.index });
            }
            this.shouldModalClose(false);
        }
    }, {
        key: 'handleToggle',
        value: function handleToggle(e) {
            var index = parseInt(e.currentTarget.getAttribute('data-index'));
            _contractorAction2.default.shouldListShow(index);
        }
    }, {
        key: 'handleNewService',
        value: function handleNewService(e) {
            e.preventDefault();
            e.stopPropagation();
            var action = 1;
            var title = "Add New Service";
            var mcst = e.target.getAttribute("data-mcst");
            this.setState({
                action: action, title: title, mcst: mcst, modalClose: true
            });
        }
    }, {
        key: 'handleRemoveService',
        value: function handleRemoveService(e) {
            var action = 4;
            var title = "Remove Service";
            var mcst = e.target.getAttribute("data-mcst");
            var index = parseInt(e.target.getAttribute("data-index"));
            this.setState({
                action: action, title: title, mcst: mcst, index: index, modalClose: true
            });
        }
    }, {
        key: 'handleRemoveCondo',
        value: function handleRemoveCondo(e) {
            e.preventDefault();
            e.stopPropagation();
            var action = 2;
            var title = "Remove Estate";
            var mcst = e.target.getAttribute("data-mcst");
            this.setState({
                action: action, title: title, mcst: mcst, modalClose: true
            });
        }
    }, {
        key: 'handleEditService',
        value: function handleEditService(e) {
            var action = 3;
            var title = "Edit Service";
            var mcst = e.target.getAttribute("data-mcst");
            var index = parseInt(e.target.getAttribute("data-index"));
            this.setState({
                action: action, title: title, mcst: mcst, index: index, modalClose: true
            });
        }
    }, {
        key: 'handleNewCondo',
        value: function handleNewCondo(e) {
            var action = 0;
            var title = "Add Estate";
            this.setState({
                action: action, title: title, modalClose: true
            });
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({
                modalClose: data
            });
        }
    }, {
        key: 'generateDateFormat',
        value: function generateDateFormat(date) {
            if (date) {
                return date.getDate() + "-" + this.props.mthTxt[date.getMonth()] + "-" + date.getFullYear();
            }
        }
    }, {
        key: 'renderDetail',
        value: function renderDetail(condo) {
            var _this2 = this;

            var content = condo.contract.map(function (detail, index) {
                var contractStartDate = detail.contractStartDate ? _this2.generateDateFormat(new Date(detail.contractStartDate)) : "";
                var contractEndDate = detail.contractEndDate ? _this2.generateDateFormat(new Date(detail.contractEndDate)) : "";
                var lastVisit = detail.lastVisit ? _this2.generateDateFormat(new Date(detail.lastVisit)) : "";
                return _react2.default.createElement(
                    'li',
                    { key: index },
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-rev', 'data-index': index, 'data-mcst': condo.mcst, onClick: _this2.handleRemoveService },
                        'X'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Service:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            detail.service
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Description:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            detail.description
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Last Visit:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            lastVisit ? lastVisit : "--"
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Status'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            typeof detail.status == 'number' ? _this2.props.statusTxt[detail.status] : "--"
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Remark:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            detail.remark ? detail.remark : "--"
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Contract Start Date:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            contractStartDate ? contractStartDate : "--"
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Contract End Date:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            contractEndDate ? contractEndDate : "--"
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Amount (SGD):'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            detail.amount ? "$" + detail.amount : "--"
                        )
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'ct-li-edit btn btn-default btn-xs', 'data-index': index, 'data-mcst': condo.mcst, onClick: _this2.handleEditService },
                        'Edit'
                    )
                );
            });
            return _react2.default.createElement(
                'ul',
                { className: "ct-cul " + (condo.shouldListShow ? "ct-show" : "ct-hide") },
                content
            );
        }
    }, {
        key: 'renderCondo',
        value: function renderCondo() {
            var _this3 = this;

            var s = this.props.contractor;

            return s.contracts.map(function (condo, index) {
                return _react2.default.createElement(
                    'div',
                    { key: index },
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-cli', 'data-index': index, key: index, onClick: _this3.handleToggle },
                        _react2.default.createElement('span', { className: "ct-icon glyphicon " + (condo.shouldListShow ? "glyphicon-minus" : "glyphicon-plus") }),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-cn', 'data-mcst': condo.mcst, 'data-condoname': condo.condoName },
                            condo.condoName + " (" + condo.mcst + ")"
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-btn-grp' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-xs btn-default', 'data-mcst': condo.mcst, onClick: _this3.handleNewService },
                                'Add'
                            ),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-xs btn-danger', 'data-mcst': condo.mcst, onClick: _this3.handleRemoveCondo },
                                'Remove'
                            )
                        )
                    ),
                    _this3.renderDetail(condo)
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var modal = "";
            if (this.state.modalClose) {
                modal = _react2.default.createElement(_modalCondo2.default, {
                    shouldModalClose: this.shouldModalClose,
                    modalClose: this.state.modalClose,
                    title: this.state.title,
                    action: this.state.action,
                    condos: this.props.condos,
                    index: this.state.index,
                    mcst: this.state.mcst,
                    contracts: this.props.contractor.contracts,
                    callBack: this.callBack
                });
            }
            return _react2.default.createElement(
                'div',
                null,
                modal,
                _react2.default.createElement(
                    'div',
                    { className: 'condoList' },
                    _react2.default.createElement(
                        'h4',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Managing Estate'
                        )
                    ),
                    _react2.default.createElement(
                        'button',
                        { type: 'button', className: 'btn btn-default',
                            'data-index': '0', onClick: this.handleNewCondo, 'data-id': this.props.contractor._id },
                        'Add New Estate'
                    ),
                    this.renderCondo()
                )
            );
        }
    }]);

    return ContractorCondoForm;
}(_react2.default.Component);

ContractorCondoForm.defaultProps = {
    mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    statusTxt: ["Active", "In-Active", "Terminated", "Ad hoc"]

};
exports.default = ContractorCondoForm;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _condoSetAction = __webpack_require__(23);

var _condoSetAction2 = _interopRequireDefault(_condoSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CondoCheckListForm = function (_React$Component) {
    _inherits(CondoCheckListForm, _React$Component);

    function CondoCheckListForm(props) {
        _classCallCheck(this, CondoCheckListForm);

        var _this = _possibleConstructorReturn(this, (CondoCheckListForm.__proto__ || Object.getPrototypeOf(CondoCheckListForm)).call(this, props));

        _this.handleCategory = function (facilityId) {
            return function (e) {
                var category = e.target.value;
                var checked = e.target.checked;
                var condo = _this.props.condo;
                if (typeof condo.categories == "undefined") {
                    condo.categories = [];
                }

                if (checked) {
                    condo.categories.push({ facilityId: facilityId, category: category });
                } else {
                    var len = condo.categories.length;
                    for (var i = 0; i < len; i++) {
                        if (condo.categories[i].facilityId == facilityId && condo.categories[i].category == category) {
                            condo.categories.splice(i, 1);
                            break;
                        }
                    }
                }
                _condoSetAction2.default.condo(condo);
            };
        };

        _this.renderCategory = function (categories, facilityId) {
            if (!categories) return "";
            return categories.map(function (ct, index) {
                var isCheck = _this.checkCategory(facilityId, ct.category);
                return _react2.default.createElement(
                    'li',
                    { key: index, className: 'cl-li-2' },
                    _react2.default.createElement(
                        'div',
                        { className: 'checkbox' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', { type: 'checkbox', value: ct.category, onChange: _this.handleCategory(facilityId), checked: isCheck }),
                            _react2.default.createElement('span', { className: 'checkmark' }),
                            ct.category
                        )
                    )
                );
            });
        };

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(CondoCheckListForm, [{
        key: 'handleChange',
        value: function handleChange(e) {
            var checkListId = e.target.value;
            var checked = e.target.checked;
            var condo = this.props.condo;
            if (checked) {
                condo.checkList.push(checkListId);
            } else {
                //remove checklist
                var len = condo.checkList.length;
                for (var i = 0; i < len; i++) {
                    if (condo.checkList[i] == checkListId) {
                        condo.checkList.splice(i, 1);
                        break;
                    }
                }

                if (typeof condo.categories != "undefined") {
                    var _i = 0;
                    while (_i < condo.categories.length) {
                        if (condo.categories[_i].facilityId == checkListId) {
                            condo.categories.splice(_i, 1);
                        } else {
                            _i++;
                        }
                    }
                }
            }
            _condoSetAction2.default.condo(condo);
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {

            var condo = this.props.condo;
            var s = this.props.checkList;
            if (condo.checkList.length != s.length) {
                //check all
                condo.checkList = [];
                condo.categories = [];

                var _loop = function _loop(i) {
                    condo.checkList = condo.checkList.concat(s[i]._id);
                    if (typeof s[i].categories != 'undefined') {
                        s[i].categories.forEach(function (category) {
                            condo.categories = condo.categories.concat({
                                facilityId: s[i]._id, category: category.category
                            });
                        });
                    }
                };

                for (var i = 0; i < s.length; i++) {
                    _loop(i);
                }
            } else {
                condo.checkList = [];
                condo.categories = [];
            }
            _condoSetAction2.default.condo(condo);
        }
    }, {
        key: 'checkFacility',
        value: function checkFacility(checkList) {
            var isCheck = false;
            var condoLen = this.props.condo.checkList.length;
            for (var i = 0; i < condoLen; i++) {
                if (this.props.condo.checkList[i] == checkList._id) {
                    isCheck = true;
                    break;
                }
            }
            return isCheck;
        }
    }, {
        key: 'renderFacility',
        value: function renderFacility(checkList, index) {
            //check if this facility is included;
            var isCheck = this.checkFacility(checkList);

            return _react2.default.createElement(
                'div',
                { key: index },
                _react2.default.createElement(
                    'li',
                    { className: 'cl-li-1' },
                    _react2.default.createElement(
                        'div',
                        { className: 'checkbox' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', { type: 'checkbox', value: checkList._id, onChange: this.handleChange, checked: isCheck }),
                            _react2.default.createElement('span', { className: 'checkmark' }),
                            checkList.facility
                        )
                    )
                ),
                this.renderCategory(checkList.categories, checkList._id)
            );
        }
    }, {
        key: 'checkCategory',
        value: function checkCategory(facilityId, category) {
            var categories = this.props.condo.categories;
            if (typeof categories == "undefined") return false;

            if (categories != null && categories != "") {
                for (var i = 0; i < categories.length; i++) {
                    if (categories[i].facilityId == facilityId && categories[i].category == category) {
                        return true;
                    }
                }
            }
            return false;
        }
    }, {
        key: 'renderCheckList',
        value: function renderCheckList() {
            var _this2 = this;

            var s = this.props.checkList;
            var checkList = s.map(function (checkList, index) {
                return _this2.renderFacility(checkList, index);
            });

            return _react2.default.createElement(
                'ul',
                { className: 'cl-fc' },
                checkList
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(
                        'b',
                        null,
                        'Check List'
                    )
                ),
                _react2.default.createElement(
                    'button',
                    { className: 'btn btn-default btn-sm cl-btn-1', onClick: this.handleClick },
                    'Select/Deselect All'
                ),
                this.renderCheckList()
            );
        }
    }]);

    return CondoCheckListForm;
}(_react2.default.Component);

exports.default = CondoCheckListForm;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _condoSetAction = __webpack_require__(23);

var _condoSetAction2 = _interopRequireDefault(_condoSetAction);

var _condoSetStore = __webpack_require__(39);

var _condoSetStore2 = _interopRequireDefault(_condoSetStore);

var _modalContractor = __webpack_require__(264);

var _modalContractor2 = _interopRequireDefault(_modalContractor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractorForm = function (_React$Component) {
    _inherits(ContractorForm, _React$Component);

    function ContractorForm(props) {
        _classCallCheck(this, ContractorForm);

        var _this = _possibleConstructorReturn(this, (ContractorForm.__proto__ || Object.getPrototypeOf(ContractorForm)).call(this, props));

        _this.handleEditService = _this.handleEditService.bind(_this);
        _this.handleNewContractor = _this.handleNewContractor.bind(_this);
        _this.handleNewService = _this.handleNewService.bind(_this);
        _this.handleRemoveContractor = _this.handleRemoveContractor.bind(_this);
        _this.handleRemoveService = _this.handleRemoveService.bind(_this);
        _this.handleToggle = _this.handleToggle.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);

        _this.callBack = _this.callBack.bind(_this);
        _this.state = {
            modalClose: false,
            title: "",
            action: "",
            contractorId: "",
            index: ""
        };
        return _this;
    }

    _createClass(ContractorForm, [{
        key: 'callBack',
        value: function callBack(value1, value2, value3, value4, value5, value6, value7, value8) {
            if (this.state.action == 0) {
                _condoSetAction2.default.addContractor(value1);
            } else if (this.state.action == 1) {
                _condoSetAction2.default.addService({
                    contractorId: this.state.contractorId,
                    contract: {
                        service: value1, description: value2, remark: value3, amount: value4,
                        contractStartDate: value5, contractEndDate: value6, lastVisit: value7, status: value8
                    }
                });
            } else if (this.state.action == 2) {
                if (this.props.processing) return;

                _condoSetAction2.default.processing(true);
                _condoSetAction2.default.removeContractorFrDB(this.state.contractorId, this.props.condo.mcst);
                _condoSetAction2.default.removeContractor({ contractorId: this.state.contractorId });
            } else if (this.state.action == 3) {
                _condoSetAction2.default.editService({
                    contractorId: this.state.contractorId, index: this.state.index,
                    contract: {
                        service: value1, description: value2, remark: value3, amount: value4,
                        contractStartDate: value5, contractEndDate: value6, lastVisit: value7, status: value8
                    }
                });
            } else {
                _condoSetAction2.default.removeService({ contractorId: this.state.contractorId, index: this.state.index });
            }
            this.shouldModalClose(false);
        }
    }, {
        key: 'handleToggle',
        value: function handleToggle(e) {
            var index = parseInt(e.currentTarget.getAttribute('data-index'));
            _condoSetAction2.default.shouldListShow(index);
        }
    }, {
        key: 'handleNewService',
        value: function handleNewService(e) {
            e.preventDefault();
            e.stopPropagation();
            var action = 1;
            var title = "Add New Service";
            var contractorId = e.target.getAttribute("data-id");
            this.setState({
                action: action, title: title, contractorId: contractorId, modalClose: true
            });
        }
    }, {
        key: 'handleRemoveService',
        value: function handleRemoveService(e) {
            var action = 4;
            var title = "Remove Service";
            var contractorId = e.target.getAttribute("data-id");
            var index = parseInt(e.target.getAttribute("data-index"));
            this.setState({
                action: action, title: title, contractorId: contractorId, index: index, modalClose: true
            });
        }
    }, {
        key: 'handleRemoveContractor',
        value: function handleRemoveContractor(e) {
            e.preventDefault();
            e.stopPropagation();
            var action = 2;
            var title = "Remove Contractor";
            var contractorId = e.target.getAttribute("data-id");
            this.setState({
                action: action, title: title, contractorId: contractorId, modalClose: true
            });
        }
    }, {
        key: 'handleEditService',
        value: function handleEditService(e) {
            var action = 3;
            var title = "Edit Service";
            var contractorId = e.target.getAttribute("data-id");
            var index = parseInt(e.target.getAttribute("data-index"));
            this.setState({
                action: action, title: title, contractorId: contractorId, index: index, modalClose: true
            });
        }
    }, {
        key: 'handleNewContractor',
        value: function handleNewContractor(e) {
            var action = 0;
            var title = "Add Contractor";
            this.setState({
                action: action, title: title, modalClose: true
            });
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({
                modalClose: data
            });
        }
    }, {
        key: 'generateDateFormat',
        value: function generateDateFormat(date) {
            if (date) {
                return date.getDate() + "-" + this.props.mthTxt[date.getMonth()] + "-" + date.getFullYear();
            }
        }
    }, {
        key: 'renderDetail',
        value: function renderDetail(contractor) {
            var _this2 = this;

            var contentList = contractor.contract.map(function (detail, index) {
                var contractStartDate = detail.contractStartDate ? _this2.generateDateFormat(new Date(detail.contractStartDate)) : "";
                var contractEndDate = detail.contractStartDate ? _this2.generateDateFormat(new Date(detail.contractEndDate)) : "";
                var lastVisit = detail.lastVisit ? _this2.generateDateFormat(new Date(detail.lastVisit)) : "";
                return _react2.default.createElement(
                    'li',
                    { key: index },
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-rev', 'data-index': index, 'data-id': contractor._id, onClick: _this2.handleRemoveService },
                        'X'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Service'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            detail.service
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Description:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            detail.description
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Last Visit:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            lastVisit ? lastVisit : "--"
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Status'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            typeof detail.status == 'number' ? _this2.props.statusTxt[detail.status] : "--"
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Remark:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            detail.remark
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Contract Start Date:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            contractStartDate ? contractStartDate : "--"
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Contract End Date:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            contractEndDate ? contractEndDate : "--"
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'Amount (SGD):'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            detail.amount ? "$" + detail.amount : "--"
                        )
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'ct-li-edit btn btn-default btn-xs', 'data-index': index, 'data-id': contractor._id, onClick: _this2.handleEditService },
                        'Edit'
                    )
                );
            });
            return _react2.default.createElement(
                'div',
                { className: "cd-wp " + (contractor.shouldListShow ? "ct-show" : "ct-hide") },
                _react2.default.createElement(
                    'ul',
                    { className: 'ct-cul ' },
                    contentList
                )
            );
        }
    }, {
        key: 'renderContractor',
        value: function renderContractor() {
            var _this3 = this;

            var s = this.props.condo;

            return s.contractors.map(function (contractor, index) {
                return _react2.default.createElement(
                    'div',
                    { key: index },
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-cli', 'data-index': index, key: index, onClick: _this3.handleToggle },
                        _react2.default.createElement('span', { className: "ct-icon glyphicon " + (contractor.shouldListShow ? "glyphicon-minus" : "glyphicon-plus") }),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-cn', 'data-id': contractor._id, 'data-contractorname': contractor.contractorName },
                            contractor.contractorName
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-btn-grp' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-xs btn-default', 'data-id': contractor._id, onClick: _this3.handleNewService },
                                'Add'
                            ),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-xs btn-danger', 'data-id': contractor._id, onClick: _this3.handleRemoveContractor },
                                'Remove'
                            )
                        )
                    ),
                    _this3.renderDetail(contractor)
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var modal = "";
            if (this.state.modalClose) {
                modal = _react2.default.createElement(_modalContractor2.default, {
                    shouldModalClose: this.shouldModalClose,
                    modalClose: this.state.modalClose,
                    title: this.state.title,
                    action: this.state.action,
                    contractors: this.props.contractors,
                    index: this.state.index,
                    contractorId: this.state.contractorId,
                    condo: this.props.condo,
                    callBack: this.callBack
                });
            }
            return _react2.default.createElement(
                'div',
                null,
                modal,
                _react2.default.createElement(
                    'div',
                    { className: 'condoList' },
                    _react2.default.createElement(
                        'h4',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Contractors'
                        )
                    ),
                    _react2.default.createElement(
                        'button',
                        { type: 'button', className: 'btn btn-default',
                            'data-index': '0', onClick: this.handleNewContractor },
                        'Add New Contractor'
                    ),
                    this.renderContractor()
                )
            );
        }
    }]);

    return ContractorForm;
}(_react2.default.Component);

ContractorForm.defaultProps = {
    mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    statusTxt: ["Active", "In-Active", "Terminated", "Ad hoc"]
};
exports.default = ContractorForm;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalCondo = function (_React$Component) {
    _inherits(ModalCondo, _React$Component);

    function ModalCondo(props) {
        _classCallCheck(this, ModalCondo);

        var _this = _possibleConstructorReturn(this, (ModalCondo.__proto__ || Object.getPrototypeOf(ModalCondo)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        return _this;
    }

    _createClass(ModalCondo, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {}
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            this.props.callBack();
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'report-modal', style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            'Remove Estate'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body' },
                        'Estate information will be removed permanently. Are you sure?'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default btn-danger', onClick: this.handleSubmit },
                            'Delete'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return ModalCondo;
}(_react2.default.Component);

ModalCondo.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = ModalCondo;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(1);

var _app = __webpack_require__(138);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_reactDom2.default.hydrate(_react2.default.createElement(
    _reactRouterDom.BrowserRouter,
    null,
    _react2.default.createElement(_app2.default, null)
), document.getElementById('root'));

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var m = __webpack_require__(60),
    n = __webpack_require__(95),
    p = __webpack_require__(96),
    q = __webpack_require__(97),
    r = "function" === typeof Symbol && Symbol["for"],
    t = r ? Symbol["for"]("react.element") : 60103,
    u = r ? Symbol["for"]("react.portal") : 60106,
    v = r ? Symbol["for"]("react.fragment") : 60107,
    w = r ? Symbol["for"]("react.strict_mode") : 60108,
    x = r ? Symbol["for"]("react.provider") : 60109,
    y = r ? Symbol["for"]("react.context") : 60110,
    z = r ? Symbol["for"]("react.async_mode") : 60111,
    A = r ? Symbol["for"]("react.forward_ref") : 60112,
    B = "function" === typeof Symbol && Symbol.iterator;function C(a) {
  for (var b = arguments.length - 1, e = "http://reactjs.org/docs/error-decoder.html?invariant\x3d" + a, c = 0; c < b; c++) {
    e += "\x26args[]\x3d" + encodeURIComponent(arguments[c + 1]);
  }n(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", e);
}var D = { isMounted: function isMounted() {
    return !1;
  }, enqueueForceUpdate: function enqueueForceUpdate() {}, enqueueReplaceState: function enqueueReplaceState() {}, enqueueSetState: function enqueueSetState() {} };
function E(a, b, e) {
  this.props = a;this.context = b;this.refs = p;this.updater = e || D;
}E.prototype.isReactComponent = {};E.prototype.setState = function (a, b) {
  "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a)) && "function" !== typeof a && null != a ? C("85") : void 0;this.updater.enqueueSetState(this, a, b, "setState");
};E.prototype.forceUpdate = function (a) {
  this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};function F() {}F.prototype = E.prototype;function G(a, b, e) {
  this.props = a;this.context = b;this.refs = p;this.updater = e || D;
}var H = G.prototype = new F();
H.constructor = G;m(H, E.prototype);H.isPureReactComponent = !0;var I = { current: null },
    J = Object.prototype.hasOwnProperty,
    K = { key: !0, ref: !0, __self: !0, __source: !0 };
function L(a, b, e) {
  var c = void 0,
      d = {},
      g = null,
      h = null;if (null != b) for (c in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (g = "" + b.key), b) {
    J.call(b, c) && !K.hasOwnProperty(c) && (d[c] = b[c]);
  }var f = arguments.length - 2;if (1 === f) d.children = e;else if (1 < f) {
    for (var k = Array(f), l = 0; l < f; l++) {
      k[l] = arguments[l + 2];
    }d.children = k;
  }if (a && a.defaultProps) for (c in f = a.defaultProps, f) {
    void 0 === d[c] && (d[c] = f[c]);
  }return { $$typeof: t, type: a, key: g, ref: h, props: d, _owner: I.current };
}
function M(a) {
  return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a && a.$$typeof === t;
}function escape(a) {
  var b = { "\x3d": "\x3d0", ":": "\x3d2" };return "$" + ("" + a).replace(/[=:]/g, function (a) {
    return b[a];
  });
}var N = /\/+/g,
    O = [];function P(a, b, e, c) {
  if (O.length) {
    var d = O.pop();d.result = a;d.keyPrefix = b;d.func = e;d.context = c;d.count = 0;return d;
  }return { result: a, keyPrefix: b, func: e, context: c, count: 0 };
}function Q(a) {
  a.result = null;a.keyPrefix = null;a.func = null;a.context = null;a.count = 0;10 > O.length && O.push(a);
}
function R(a, b, e, c) {
  var d = typeof a === "undefined" ? "undefined" : _typeof(a);if ("undefined" === d || "boolean" === d) a = null;var g = !1;if (null === a) g = !0;else switch (d) {case "string":case "number":
      g = !0;break;case "object":
      switch (a.$$typeof) {case t:case u:
          g = !0;}}if (g) return e(c, a, "" === b ? "." + S(a, 0) : b), 1;g = 0;b = "" === b ? "." : b + ":";if (Array.isArray(a)) for (var h = 0; h < a.length; h++) {
    d = a[h];var f = b + S(d, h);g += R(d, f, e, c);
  } else if (null === a || "undefined" === typeof a ? f = null : (f = B && a[B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for (a = f.call(a), h = 0; !(d = a.next()).done;) {
    d = d.value, f = b + S(d, h++), g += R(d, f, e, c);
  } else "object" === d && (e = "" + a, C("31", "[object Object]" === e ? "object with keys {" + Object.keys(a).join(", ") + "}" : e, ""));return g;
}function S(a, b) {
  return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a && null != a.key ? escape(a.key) : b.toString(36);
}function T(a, b) {
  a.func.call(a.context, b, a.count++);
}
function U(a, b, e) {
  var c = a.result,
      d = a.keyPrefix;a = a.func.call(a.context, b, a.count++);Array.isArray(a) ? V(a, c, e, q.thatReturnsArgument) : null != a && (M(a) && (b = d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace(N, "$\x26/") + "/") + e, a = { $$typeof: t, type: a.type, key: b, ref: a.ref, props: a.props, _owner: a._owner }), c.push(a));
}function V(a, b, e, c, d) {
  var g = "";null != e && (g = ("" + e).replace(N, "$\x26/") + "/");b = P(b, g, c, d);null == a || R(a, "", U, b);Q(b);
}
var W = { Children: { map: function map(a, b, e) {
      if (null == a) return a;var c = [];V(a, c, null, b, e);return c;
    }, forEach: function forEach(a, b, e) {
      if (null == a) return a;b = P(null, null, b, e);null == a || R(a, "", T, b);Q(b);
    }, count: function count(a) {
      return null == a ? 0 : R(a, "", q.thatReturnsNull, null);
    }, toArray: function toArray(a) {
      var b = [];V(a, b, null, q.thatReturnsArgument);return b;
    }, only: function only(a) {
      M(a) ? void 0 : C("143");return a;
    } }, createRef: function createRef() {
    return { current: null };
  }, Component: E, PureComponent: G, createContext: function createContext(a, b) {
    void 0 === b && (b = null);a = { $$typeof: y,
      _calculateChangedBits: b, _defaultValue: a, _currentValue: a, _changedBits: 0, Provider: null, Consumer: null };a.Provider = { $$typeof: x, _context: a };return a.Consumer = a;
  }, forwardRef: function forwardRef(a) {
    return { $$typeof: A, render: a };
  }, Fragment: v, StrictMode: w, unstable_AsyncMode: z, createElement: L, cloneElement: function cloneElement(a, b, e) {
    null === a || void 0 === a ? C("267", a) : void 0;var c = void 0,
        d = m({}, a.props),
        g = a.key,
        h = a.ref,
        f = a._owner;if (null != b) {
      void 0 !== b.ref && (h = b.ref, f = I.current);void 0 !== b.key && (g = "" + b.key);var k = void 0;a.type && a.type.defaultProps && (k = a.type.defaultProps);for (c in b) {
        J.call(b, c) && !K.hasOwnProperty(c) && (d[c] = void 0 === b[c] && void 0 !== k ? k[c] : b[c]);
      }
    }c = arguments.length - 2;if (1 === c) d.children = e;else if (1 < c) {
      k = Array(c);for (var l = 0; l < c; l++) {
        k[l] = arguments[l + 2];
      }d.children = k;
    }return { $$typeof: t, type: a.type, key: g, ref: h, props: d, _owner: f };
  }, createFactory: function createFactory(a) {
    var b = L.bind(null, a);b.type = a;return b;
  }, isValidElement: M, version: "16.3.2", __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: { ReactCurrentOwner: I, assign: m } },
    X = Object.freeze({ default: W }),
    Y = X && W || X;module.exports = Y["default"] ? Y["default"] : Y;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var ba = __webpack_require__(99),
    ea = __webpack_require__(0),
    m = __webpack_require__(100),
    A = __webpack_require__(60),
    C = __webpack_require__(101),
    fa = __webpack_require__(102),
    ha = __webpack_require__(103),
    ja = __webpack_require__(104),
    ka = __webpack_require__(107);
function D(a) {
  for (var b = arguments.length - 1, c = "http://reactjs.org/docs/error-decoder.html?invariant\x3d" + a, d = 0; d < b; d++) {
    c += "\x26args[]\x3d" + encodeURIComponent(arguments[d + 1]);
  }ba(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", c);
}ea ? void 0 : D("227");
function ma(a, b, c, d, e, f, h, g, k) {
  this._hasCaughtError = !1;this._caughtError = null;var v = Array.prototype.slice.call(arguments, 3);try {
    b.apply(c, v);
  } catch (l) {
    this._caughtError = l, this._hasCaughtError = !0;
  }
}
var E = { _caughtError: null, _hasCaughtError: !1, _rethrowError: null, _hasRethrowError: !1, invokeGuardedCallback: function invokeGuardedCallback(a, b, c, d, e, f, h, g, k) {
    ma.apply(E, arguments);
  }, invokeGuardedCallbackAndCatchFirstError: function invokeGuardedCallbackAndCatchFirstError(a, b, c, d, e, f, h, g, k) {
    E.invokeGuardedCallback.apply(this, arguments);if (E.hasCaughtError()) {
      var v = E.clearCaughtError();E._hasRethrowError || (E._hasRethrowError = !0, E._rethrowError = v);
    }
  }, rethrowCaughtError: function rethrowCaughtError() {
    return na.apply(E, arguments);
  }, hasCaughtError: function hasCaughtError() {
    return E._hasCaughtError;
  }, clearCaughtError: function clearCaughtError() {
    if (E._hasCaughtError) {
      var a = E._caughtError;E._caughtError = null;E._hasCaughtError = !1;return a;
    }D("198");
  } };function na() {
  if (E._hasRethrowError) {
    var a = E._rethrowError;E._rethrowError = null;E._hasRethrowError = !1;throw a;
  }
}var oa = null,
    pa = {};
function qa() {
  if (oa) for (var a in pa) {
    var b = pa[a],
        c = oa.indexOf(a);-1 < c ? void 0 : D("96", a);if (!ra[c]) {
      b.extractEvents ? void 0 : D("97", a);ra[c] = b;c = b.eventTypes;for (var d in c) {
        var e = void 0;var f = c[d],
            h = b,
            g = d;sa.hasOwnProperty(g) ? D("99", g) : void 0;sa[g] = f;var k = f.phasedRegistrationNames;if (k) {
          for (e in k) {
            k.hasOwnProperty(e) && ta(k[e], h, g);
          }e = !0;
        } else f.registrationName ? (ta(f.registrationName, h, g), e = !0) : e = !1;e ? void 0 : D("98", d, a);
      }
    }
  }
}
function ta(a, b, c) {
  ua[a] ? D("100", a) : void 0;ua[a] = b;va[a] = b.eventTypes[c].dependencies;
}var ra = [],
    sa = {},
    ua = {},
    va = {};function wa(a) {
  oa ? D("101") : void 0;oa = Array.prototype.slice.call(a);qa();
}function xa(a) {
  var b = !1,
      c;for (c in a) {
    if (a.hasOwnProperty(c)) {
      var d = a[c];pa.hasOwnProperty(c) && pa[c] === d || (pa[c] ? D("102", c) : void 0, pa[c] = d, b = !0);
    }
  }b && qa();
}
var Ca = Object.freeze({ plugins: ra, eventNameDispatchConfigs: sa, registrationNameModules: ua, registrationNameDependencies: va, possibleRegistrationNames: null, injectEventPluginOrder: wa, injectEventPluginsByName: xa }),
    Da = null,
    Ea = null,
    Fa = null;function Ga(a, b, c, d) {
  b = a.type || "unknown-event";a.currentTarget = Fa(d);E.invokeGuardedCallbackAndCatchFirstError(b, c, void 0, a);a.currentTarget = null;
}
function Ha(a, b) {
  null == b ? D("30") : void 0;if (null == a) return b;if (Array.isArray(a)) {
    if (Array.isArray(b)) return a.push.apply(a, b), a;a.push(b);return a;
  }return Array.isArray(b) ? [a].concat(b) : [a, b];
}function Ia(a, b, c) {
  Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}var Ja = null;
function Ka(a, b) {
  if (a) {
    var c = a._dispatchListeners,
        d = a._dispatchInstances;if (Array.isArray(c)) for (var e = 0; e < c.length && !a.isPropagationStopped(); e++) {
      Ga(a, b, c[e], d[e]);
    } else c && Ga(a, b, c, d);a._dispatchListeners = null;a._dispatchInstances = null;a.isPersistent() || a.constructor.release(a);
  }
}function La(a) {
  return Ka(a, !0);
}function Ma(a) {
  return Ka(a, !1);
}var Na = { injectEventPluginOrder: wa, injectEventPluginsByName: xa };
function Oa(a, b) {
  var c = a.stateNode;if (!c) return null;var d = Da(c);if (!d) return null;c = d[b];a: switch (b) {case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":
      (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));a = !d;break a;default:
      a = !1;}if (a) return null;c && "function" !== typeof c ? D("231", b, typeof c === "undefined" ? "undefined" : _typeof(c)) : void 0;
  return c;
}function Pa(a, b) {
  null !== a && (Ja = Ha(Ja, a));a = Ja;Ja = null;a && (b ? Ia(a, La) : Ia(a, Ma), Ja ? D("95") : void 0, E.rethrowCaughtError());
}function Qa(a, b, c, d) {
  for (var e = null, f = 0; f < ra.length; f++) {
    var h = ra[f];h && (h = h.extractEvents(a, b, c, d)) && (e = Ha(e, h));
  }Pa(e, !1);
}var Ra = Object.freeze({ injection: Na, getListener: Oa, runEventsInBatch: Pa, runExtractedEventsInBatch: Qa }),
    Sa = Math.random().toString(36).slice(2),
    F = "__reactInternalInstance$" + Sa,
    Ta = "__reactEventHandlers$" + Sa;
function Ua(a) {
  if (a[F]) return a[F];for (; !a[F];) {
    if (a.parentNode) a = a.parentNode;else return null;
  }a = a[F];return 5 === a.tag || 6 === a.tag ? a : null;
}function Va(a) {
  if (5 === a.tag || 6 === a.tag) return a.stateNode;D("33");
}function Xa(a) {
  return a[Ta] || null;
}var bb = Object.freeze({ precacheFiberNode: function precacheFiberNode(a, b) {
    b[F] = a;
  }, getClosestInstanceFromNode: Ua, getInstanceFromNode: function getInstanceFromNode(a) {
    a = a[F];return !a || 5 !== a.tag && 6 !== a.tag ? null : a;
  }, getNodeFromInstance: Va, getFiberCurrentPropsFromNode: Xa, updateFiberProps: function updateFiberProps(a, b) {
    a[Ta] = b;
  } });
function L(a) {
  do {
    a = a["return"];
  } while (a && 5 !== a.tag);return a ? a : null;
}function cb(a, b, c) {
  for (var d = []; a;) {
    d.push(a), a = L(a);
  }for (a = d.length; 0 < a--;) {
    b(d[a], "captured", c);
  }for (a = 0; a < d.length; a++) {
    b(d[a], "bubbled", c);
  }
}function db(a, b, c) {
  if (b = Oa(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = Ha(c._dispatchListeners, b), c._dispatchInstances = Ha(c._dispatchInstances, a);
}function eb(a) {
  a && a.dispatchConfig.phasedRegistrationNames && cb(a._targetInst, db, a);
}
function fb(a) {
  if (a && a.dispatchConfig.phasedRegistrationNames) {
    var b = a._targetInst;b = b ? L(b) : null;cb(b, db, a);
  }
}function gb(a, b, c) {
  a && c && c.dispatchConfig.registrationName && (b = Oa(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = Ha(c._dispatchListeners, b), c._dispatchInstances = Ha(c._dispatchInstances, a));
}function hb(a) {
  a && a.dispatchConfig.registrationName && gb(a._targetInst, null, a);
}function ib(a) {
  Ia(a, eb);
}
function jb(a, b, c, d) {
  if (c && d) a: {
    var e = c;for (var f = d, h = 0, g = e; g; g = L(g)) {
      h++;
    }g = 0;for (var k = f; k; k = L(k)) {
      g++;
    }for (; 0 < h - g;) {
      e = L(e), h--;
    }for (; 0 < g - h;) {
      f = L(f), g--;
    }for (; h--;) {
      if (e === f || e === f.alternate) break a;e = L(e);f = L(f);
    }e = null;
  } else e = null;f = e;for (e = []; c && c !== f;) {
    h = c.alternate;if (null !== h && h === f) break;e.push(c);c = L(c);
  }for (c = []; d && d !== f;) {
    h = d.alternate;if (null !== h && h === f) break;c.push(d);d = L(d);
  }for (d = 0; d < e.length; d++) {
    gb(e[d], "bubbled", a);
  }for (a = c.length; 0 < a--;) {
    gb(c[a], "captured", b);
  }
}
var kb = Object.freeze({ accumulateTwoPhaseDispatches: ib, accumulateTwoPhaseDispatchesSkipTarget: function accumulateTwoPhaseDispatchesSkipTarget(a) {
    Ia(a, fb);
  }, accumulateEnterLeaveDispatches: jb, accumulateDirectDispatches: function accumulateDirectDispatches(a) {
    Ia(a, hb);
  } }),
    lb = null;function mb() {
  !lb && m.canUseDOM && (lb = "textContent" in document.documentElement ? "textContent" : "innerText");return lb;
}var M = { _root: null, _startText: null, _fallbackText: null };
function nb() {
  if (M._fallbackText) return M._fallbackText;var a,
      b = M._startText,
      c = b.length,
      d,
      e = ob(),
      f = e.length;for (a = 0; a < c && b[a] === e[a]; a++) {}var h = c - a;for (d = 1; d <= h && b[c - d] === e[f - d]; d++) {}M._fallbackText = e.slice(a, 1 < d ? 1 - d : void 0);return M._fallbackText;
}function ob() {
  return "value" in M._root ? M._root.value : M._root[mb()];
}
var pb = "dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),
    qb = { type: null, target: null, currentTarget: C.thatReturnsNull, eventPhase: null, bubbles: null, cancelable: null, timeStamp: function timeStamp(a) {
    return a.timeStamp || Date.now();
  }, defaultPrevented: null, isTrusted: null };
function N(a, b, c, d) {
  this.dispatchConfig = a;this._targetInst = b;this.nativeEvent = c;a = this.constructor.Interface;for (var e in a) {
    a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
  }this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? C.thatReturnsTrue : C.thatReturnsFalse;this.isPropagationStopped = C.thatReturnsFalse;return this;
}
A(N.prototype, { preventDefault: function preventDefault() {
    this.defaultPrevented = !0;var a = this.nativeEvent;a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = C.thatReturnsTrue);
  }, stopPropagation: function stopPropagation() {
    var a = this.nativeEvent;a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = C.thatReturnsTrue);
  }, persist: function persist() {
    this.isPersistent = C.thatReturnsTrue;
  }, isPersistent: C.thatReturnsFalse,
  destructor: function destructor() {
    var a = this.constructor.Interface,
        b;for (b in a) {
      this[b] = null;
    }for (a = 0; a < pb.length; a++) {
      this[pb[a]] = null;
    }
  } });N.Interface = qb;N.extend = function (a) {
  function b() {}function c() {
    return d.apply(this, arguments);
  }var d = this;b.prototype = d.prototype;var e = new b();A(e, c.prototype);c.prototype = e;c.prototype.constructor = c;c.Interface = A({}, d.Interface, a);c.extend = d.extend;rb(c);return c;
};rb(N);
function sb(a, b, c, d) {
  if (this.eventPool.length) {
    var e = this.eventPool.pop();this.call(e, a, b, c, d);return e;
  }return new this(a, b, c, d);
}function tb(a) {
  a instanceof this ? void 0 : D("223");a.destructor();10 > this.eventPool.length && this.eventPool.push(a);
}function rb(a) {
  a.eventPool = [];a.getPooled = sb;a.release = tb;
}var ub = N.extend({ data: null }),
    vb = N.extend({ data: null }),
    wb = [9, 13, 27, 32],
    xb = m.canUseDOM && "CompositionEvent" in window,
    yb = null;m.canUseDOM && "documentMode" in document && (yb = document.documentMode);
var zb = m.canUseDOM && "TextEvent" in window && !yb,
    Ab = m.canUseDOM && (!xb || yb && 8 < yb && 11 >= yb),
    Bb = String.fromCharCode(32),
    Kb = { beforeInput: { phasedRegistrationNames: { bubbled: "onBeforeInput", captured: "onBeforeInputCapture" }, dependencies: ["topCompositionEnd", "topKeyPress", "topTextInput", "topPaste"] }, compositionEnd: { phasedRegistrationNames: { bubbled: "onCompositionEnd", captured: "onCompositionEndCapture" }, dependencies: "topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ") }, compositionStart: { phasedRegistrationNames: { bubbled: "onCompositionStart",
      captured: "onCompositionStartCapture" }, dependencies: "topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ") }, compositionUpdate: { phasedRegistrationNames: { bubbled: "onCompositionUpdate", captured: "onCompositionUpdateCapture" }, dependencies: "topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ") } },
    Lb = !1;
function Mb(a, b) {
  switch (a) {case "topKeyUp":
      return -1 !== wb.indexOf(b.keyCode);case "topKeyDown":
      return 229 !== b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":
      return !0;default:
      return !1;}
}function Nb(a) {
  a = a.detail;return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && "data" in a ? a.data : null;
}var Ob = !1;function Pb(a, b) {
  switch (a) {case "topCompositionEnd":
      return Nb(b);case "topKeyPress":
      if (32 !== b.which) return null;Lb = !0;return Bb;case "topTextInput":
      return a = b.data, a === Bb && Lb ? null : a;default:
      return null;}
}
function Qb(a, b) {
  if (Ob) return "topCompositionEnd" === a || !xb && Mb(a, b) ? (a = nb(), M._root = null, M._startText = null, M._fallbackText = null, Ob = !1, a) : null;switch (a) {case "topPaste":
      return null;case "topKeyPress":
      if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
        if (b.char && 1 < b.char.length) return b.char;if (b.which) return String.fromCharCode(b.which);
      }return null;case "topCompositionEnd":
      return Ab ? null : b.data;default:
      return null;}
}
var Rb = { eventTypes: Kb, extractEvents: function extractEvents(a, b, c, d) {
    var e = void 0;var f = void 0;if (xb) b: {
      switch (a) {case "topCompositionStart":
          e = Kb.compositionStart;break b;case "topCompositionEnd":
          e = Kb.compositionEnd;break b;case "topCompositionUpdate":
          e = Kb.compositionUpdate;break b;}e = void 0;
    } else Ob ? Mb(a, c) && (e = Kb.compositionEnd) : "topKeyDown" === a && 229 === c.keyCode && (e = Kb.compositionStart);e ? (Ab && (Ob || e !== Kb.compositionStart ? e === Kb.compositionEnd && Ob && (f = nb()) : (M._root = d, M._startText = ob(), Ob = !0)), e = ub.getPooled(e, b, c, d), f ? e.data = f : (f = Nb(c), null !== f && (e.data = f)), ib(e), f = e) : f = null;(a = zb ? Pb(a, c) : Qb(a, c)) ? (b = vb.getPooled(Kb.beforeInput, b, c, d), b.data = a, ib(b)) : b = null;return null === f ? b : null === b ? f : [f, b];
  } },
    Sb = null,
    Tb = { injectFiberControlledHostComponent: function injectFiberControlledHostComponent(a) {
    Sb = a;
  } },
    Ub = null,
    Vb = null;function Wb(a) {
  if (a = Ea(a)) {
    Sb && "function" === typeof Sb.restoreControlledState ? void 0 : D("194");var b = Da(a.stateNode);Sb.restoreControlledState(a.stateNode, a.type, b);
  }
}function Xb(a) {
  Ub ? Vb ? Vb.push(a) : Vb = [a] : Ub = a;
}
function Yb() {
  return null !== Ub || null !== Vb;
}function Zb() {
  if (Ub) {
    var a = Ub,
        b = Vb;Vb = Ub = null;Wb(a);if (b) for (a = 0; a < b.length; a++) {
      Wb(b[a]);
    }
  }
}var $b = Object.freeze({ injection: Tb, enqueueStateRestore: Xb, needsStateRestore: Yb, restoreStateIfNeeded: Zb });function ac(a, b) {
  return a(b);
}function bc(a, b, c) {
  return a(b, c);
}function cc() {}var dc = !1;function ec(a, b) {
  if (dc) return a(b);dc = !0;try {
    return ac(a, b);
  } finally {
    dc = !1, Yb() && (cc(), Zb());
  }
}
var fc = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };function gc(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();return "input" === b ? !!fc[a.type] : "textarea" === b ? !0 : !1;
}function hc(a) {
  a = a.target || window;a.correspondingUseElement && (a = a.correspondingUseElement);return 3 === a.nodeType ? a.parentNode : a;
}
function ic(a, b) {
  if (!m.canUseDOM || b && !("addEventListener" in document)) return !1;a = "on" + a;b = a in document;b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);return b;
}function jc(a) {
  var b = a.type;return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function kc(a) {
  var b = jc(a) ? "checked" : "value",
      c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
      d = "" + a[b];if (!a.hasOwnProperty(b) && "function" === typeof c.get && "function" === typeof c.set) return Object.defineProperty(a, b, { configurable: !0, get: function get() {
      return c.get.call(this);
    }, set: function set(a) {
      d = "" + a;c.set.call(this, a);
    } }), Object.defineProperty(a, b, { enumerable: c.enumerable }), { getValue: function getValue() {
      return d;
    }, setValue: function setValue(a) {
      d = "" + a;
    }, stopTracking: function stopTracking() {
      a._valueTracker = null;delete a[b];
    } };
}
function lc(a) {
  a._valueTracker || (a._valueTracker = kc(a));
}function mc(a) {
  if (!a) return !1;var b = a._valueTracker;if (!b) return !0;var c = b.getValue();var d = "";a && (d = jc(a) ? a.checked ? "true" : "false" : a.value);a = d;return a !== c ? (b.setValue(a), !0) : !1;
}
var nc = ea.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    O = "function" === typeof Symbol && Symbol["for"],
    oc = O ? Symbol["for"]("react.element") : 60103,
    pc = O ? Symbol["for"]("react.call") : 60104,
    qc = O ? Symbol["for"]("react.return") : 60105,
    rc = O ? Symbol["for"]("react.portal") : 60106,
    sc = O ? Symbol["for"]("react.fragment") : 60107,
    tc = O ? Symbol["for"]("react.strict_mode") : 60108,
    uc = O ? Symbol["for"]("react.provider") : 60109,
    vc = O ? Symbol["for"]("react.context") : 60110,
    wc = O ? Symbol["for"]("react.async_mode") : 60111,
    xc = O ? Symbol["for"]("react.forward_ref") : 60112,
    yc = "function" === typeof Symbol && Symbol.iterator;function zc(a) {
  if (null === a || "undefined" === typeof a) return null;a = yc && a[yc] || a["@@iterator"];return "function" === typeof a ? a : null;
}
function Ac(a) {
  a = a.type;if ("function" === typeof a) return a.displayName || a.name;if ("string" === typeof a) return a;switch (a) {case sc:
      return "ReactFragment";case rc:
      return "ReactPortal";case pc:
      return "ReactCall";case qc:
      return "ReactReturn";}if ("object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a) switch (a.$$typeof) {case xc:
      return a = a.render.displayName || a.render.name || "", "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef";}return null;
}
function Bc(a) {
  var b = "";do {
    a: switch (a.tag) {case 0:case 1:case 2:case 5:
        var c = a._debugOwner,
            d = a._debugSource;var e = Ac(a);var f = null;c && (f = Ac(c));c = d;e = "\n    in " + (e || "Unknown") + (c ? " (at " + c.fileName.replace(/^.*[\\\/]/, "") + ":" + c.lineNumber + ")" : f ? " (created by " + f + ")" : "");break a;default:
        e = "";}b += e;a = a["return"];
  } while (a);return b;
}
var Cc = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    Dc = {},
    Ec = {};function Fc(a) {
  if (Ec.hasOwnProperty(a)) return !0;if (Dc.hasOwnProperty(a)) return !1;if (Cc.test(a)) return Ec[a] = !0;Dc[a] = !0;return !1;
}
function Gc(a, b, c, d) {
  if (null !== c && 0 === c.type) return !1;switch (typeof b === "undefined" ? "undefined" : _typeof(b)) {case "function":case "symbol":
      return !0;case "boolean":
      if (d) return !1;if (null !== c) return !c.acceptsBooleans;a = a.toLowerCase().slice(0, 5);return "data-" !== a && "aria-" !== a;default:
      return !1;}
}function Hc(a, b, c, d) {
  if (null === b || "undefined" === typeof b || Gc(a, b, c, d)) return !0;if (null !== c) switch (c.type) {case 3:
      return !b;case 4:
      return !1 === b;case 5:
      return isNaN(b);case 6:
      return isNaN(b) || 1 > b;}return !1;
}
function U(a, b, c, d, e) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;this.attributeName = d;this.attributeNamespace = e;this.mustUseProperty = c;this.propertyName = a;this.type = b;
}var V = {};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
  V[a] = new U(a, 0, !1, a, null);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
  var b = a[0];V[b] = new U(b, 1, !1, a[1], null);
});["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
  V[a] = new U(a, 2, !1, a.toLowerCase(), null);
});["autoReverse", "externalResourcesRequired", "preserveAlpha"].forEach(function (a) {
  V[a] = new U(a, 2, !1, a, null);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
  V[a] = new U(a, 3, !1, a.toLowerCase(), null);
});["checked", "multiple", "muted", "selected"].forEach(function (a) {
  V[a] = new U(a, 3, !0, a.toLowerCase(), null);
});["capture", "download"].forEach(function (a) {
  V[a] = new U(a, 4, !1, a.toLowerCase(), null);
});
["cols", "rows", "size", "span"].forEach(function (a) {
  V[a] = new U(a, 6, !1, a.toLowerCase(), null);
});["rowSpan", "start"].forEach(function (a) {
  V[a] = new U(a, 5, !1, a.toLowerCase(), null);
});var Sc = /[\-:]([a-z])/g;function Tc(a) {
  return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
  var b = a.replace(Sc, Tc);V[b] = new U(b, 1, !1, a, null);
});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
  var b = a.replace(Sc, Tc);V[b] = new U(b, 1, !1, a, "http://www.w3.org/1999/xlink");
});["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
  var b = a.replace(Sc, Tc);V[b] = new U(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace");
});V.tabIndex = new U("tabIndex", 1, !1, "tabindex", null);
function Uc(a, b, c, d) {
  var e = V.hasOwnProperty(b) ? V[b] : null;var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;f || (Hc(b, c, e, d) && (c = null), d || null === e ? Fc(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
function Vc(a, b) {
  var c = b.checked;return A({}, b, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != c ? c : a._wrapperState.initialChecked });
}function Wc(a, b) {
  var c = null == b.defaultValue ? "" : b.defaultValue,
      d = null != b.checked ? b.checked : b.defaultChecked;c = Xc(null != b.value ? b.value : c);a._wrapperState = { initialChecked: d, initialValue: c, controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value };
}function Yc(a, b) {
  b = b.checked;null != b && Uc(a, "checked", b, !1);
}
function Zc(a, b) {
  Yc(a, b);var c = Xc(b.value);if (null != c) if ("number" === b.type) {
    if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
  } else a.value !== "" + c && (a.value = "" + c);b.hasOwnProperty("value") ? $c(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c(a, b.type, Xc(b.defaultValue));null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function ad(a, b) {
  if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) "" === a.value && (a.value = "" + a._wrapperState.initialValue), a.defaultValue = "" + a._wrapperState.initialValue;b = a.name;"" !== b && (a.name = "");a.defaultChecked = !a.defaultChecked;a.defaultChecked = !a.defaultChecked;"" !== b && (a.name = b);
}function $c(a, b, c) {
  if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Xc(a) {
  switch (typeof a === "undefined" ? "undefined" : _typeof(a)) {case "boolean":case "number":case "object":case "string":case "undefined":
      return a;default:
      return "";}
}var bd = { change: { phasedRegistrationNames: { bubbled: "onChange", captured: "onChangeCapture" }, dependencies: "topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ") } };function cd(a, b, c) {
  a = N.getPooled(bd.change, a, b, c);a.type = "change";Xb(c);ib(a);return a;
}var dd = null,
    ed = null;function fd(a) {
  Pa(a, !1);
}
function gd(a) {
  var b = Va(a);if (mc(b)) return a;
}function hd(a, b) {
  if ("topChange" === a) return b;
}var id = !1;m.canUseDOM && (id = ic("input") && (!document.documentMode || 9 < document.documentMode));function jd() {
  dd && (dd.detachEvent("onpropertychange", kd), ed = dd = null);
}function kd(a) {
  "value" === a.propertyName && gd(ed) && (a = cd(ed, a, hc(a)), ec(fd, a));
}function ld(a, b, c) {
  "topFocus" === a ? (jd(), dd = b, ed = c, dd.attachEvent("onpropertychange", kd)) : "topBlur" === a && jd();
}
function md(a) {
  if ("topSelectionChange" === a || "topKeyUp" === a || "topKeyDown" === a) return gd(ed);
}function nd(a, b) {
  if ("topClick" === a) return gd(b);
}function od(a, b) {
  if ("topInput" === a || "topChange" === a) return gd(b);
}
var pd = { eventTypes: bd, _isInputEventSupported: id, extractEvents: function extractEvents(a, b, c, d) {
    var e = b ? Va(b) : window,
        f = void 0,
        h = void 0,
        g = e.nodeName && e.nodeName.toLowerCase();"select" === g || "input" === g && "file" === e.type ? f = hd : gc(e) ? id ? f = od : (f = md, h = ld) : (g = e.nodeName) && "input" === g.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (f = nd);if (f && (f = f(a, b))) return cd(f, c, d);h && h(a, e, b);"topBlur" === a && null != b && (a = b._wrapperState || e._wrapperState) && a.controlled && "number" === e.type && $c(e, "number", e.value);
  } },
    qd = N.extend({ view: null,
  detail: null }),
    rd = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };function sd(a) {
  var b = this.nativeEvent;return b.getModifierState ? b.getModifierState(a) : (a = rd[a]) ? !!b[a] : !1;
}function td() {
  return sd;
}
var ud = qd.extend({ screenX: null, screenY: null, clientX: null, clientY: null, pageX: null, pageY: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, getModifierState: td, button: null, buttons: null, relatedTarget: function relatedTarget(a) {
    return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
  } }),
    vd = { mouseEnter: { registrationName: "onMouseEnter", dependencies: ["topMouseOut", "topMouseOver"] }, mouseLeave: { registrationName: "onMouseLeave", dependencies: ["topMouseOut", "topMouseOver"] } },
    wd = { eventTypes: vd, extractEvents: function extractEvents(a, b, c, d) {
    if ("topMouseOver" === a && (c.relatedTarget || c.fromElement) || "topMouseOut" !== a && "topMouseOver" !== a) return null;var e = d.window === d ? d : (e = d.ownerDocument) ? e.defaultView || e.parentWindow : window;"topMouseOut" === a ? (a = b, b = (b = c.relatedTarget || c.toElement) ? Ua(b) : null) : a = null;if (a === b) return null;var f = null == a ? e : Va(a);e = null == b ? e : Va(b);var h = ud.getPooled(vd.mouseLeave, a, c, d);h.type = "mouseleave";h.target = f;h.relatedTarget = e;c = ud.getPooled(vd.mouseEnter, b, c, d);c.type = "mouseenter";c.target = e;c.relatedTarget = f;jb(h, c, a, b);return [h, c];
  } };function xd(a) {
  var b = a;if (a.alternate) for (; b["return"];) {
    b = b["return"];
  } else {
    if (0 !== (b.effectTag & 2)) return 1;for (; b["return"];) {
      if (b = b["return"], 0 !== (b.effectTag & 2)) return 1;
    }
  }return 3 === b.tag ? 2 : 3;
}function yd(a) {
  return (a = a._reactInternalFiber) ? 2 === xd(a) : !1;
}function zd(a) {
  2 !== xd(a) ? D("188") : void 0;
}
function Ad(a) {
  var b = a.alternate;if (!b) return b = xd(a), 3 === b ? D("188") : void 0, 1 === b ? null : a;for (var c = a, d = b;;) {
    var e = c["return"],
        f = e ? e.alternate : null;if (!e || !f) break;if (e.child === f.child) {
      for (var h = e.child; h;) {
        if (h === c) return zd(e), a;if (h === d) return zd(e), b;h = h.sibling;
      }D("188");
    }if (c["return"] !== d["return"]) c = e, d = f;else {
      h = !1;for (var g = e.child; g;) {
        if (g === c) {
          h = !0;c = e;d = f;break;
        }if (g === d) {
          h = !0;d = e;c = f;break;
        }g = g.sibling;
      }if (!h) {
        for (g = f.child; g;) {
          if (g === c) {
            h = !0;c = f;d = e;break;
          }if (g === d) {
            h = !0;d = f;c = e;break;
          }g = g.sibling;
        }h ? void 0 : D("189");
      }
    }c.alternate !== d ? D("190") : void 0;
  }3 !== c.tag ? D("188") : void 0;return c.stateNode.current === c ? a : b;
}function Bd(a) {
  a = Ad(a);if (!a) return null;for (var b = a;;) {
    if (5 === b.tag || 6 === b.tag) return b;if (b.child) b.child["return"] = b, b = b.child;else {
      if (b === a) break;for (; !b.sibling;) {
        if (!b["return"] || b["return"] === a) return null;b = b["return"];
      }b.sibling["return"] = b["return"];b = b.sibling;
    }
  }return null;
}
function Cd(a) {
  a = Ad(a);if (!a) return null;for (var b = a;;) {
    if (5 === b.tag || 6 === b.tag) return b;if (b.child && 4 !== b.tag) b.child["return"] = b, b = b.child;else {
      if (b === a) break;for (; !b.sibling;) {
        if (!b["return"] || b["return"] === a) return null;b = b["return"];
      }b.sibling["return"] = b["return"];b = b.sibling;
    }
  }return null;
}var Dd = N.extend({ animationName: null, elapsedTime: null, pseudoElement: null }),
    Ed = N.extend({ clipboardData: function clipboardData(a) {
    return "clipboardData" in a ? a.clipboardData : window.clipboardData;
  } }),
    Fd = qd.extend({ relatedTarget: null });
function Gd(a) {
  var b = a.keyCode;"charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;10 === a && (a = 13);return 32 <= a || 13 === a ? a : 0;
}
var Hd = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" },
    Id = { 8: "Backspace", 9: "Tab", 12: "Clear", 13: "Enter", 16: "Shift", 17: "Control", 18: "Alt", 19: "Pause", 20: "CapsLock", 27: "Escape", 32: " ", 33: "PageUp", 34: "PageDown", 35: "End", 36: "Home", 37: "ArrowLeft", 38: "ArrowUp", 39: "ArrowRight", 40: "ArrowDown", 45: "Insert", 46: "Delete", 112: "F1", 113: "F2", 114: "F3", 115: "F4",
  116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10", 122: "F11", 123: "F12", 144: "NumLock", 145: "ScrollLock", 224: "Meta" },
    Jd = qd.extend({ key: function key(a) {
    if (a.key) {
      var b = Hd[a.key] || a.key;if ("Unidentified" !== b) return b;
    }return "keypress" === a.type ? (a = Gd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Id[a.keyCode] || "Unidentified" : "";
  }, location: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, repeat: null, locale: null, getModifierState: td, charCode: function charCode(a) {
    return "keypress" === a.type ? Gd(a) : 0;
  }, keyCode: function keyCode(a) {
    return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  }, which: function which(a) {
    return "keypress" === a.type ? Gd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  } }),
    Kd = ud.extend({ dataTransfer: null }),
    Ld = qd.extend({ touches: null, targetTouches: null, changedTouches: null, altKey: null, metaKey: null, ctrlKey: null, shiftKey: null, getModifierState: td }),
    Md = N.extend({ propertyName: null, elapsedTime: null, pseudoElement: null }),
    Nd = ud.extend({ deltaX: function deltaX(a) {
    return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
  }, deltaY: function deltaY(a) {
    return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
  }, deltaZ: null, deltaMode: null }),
    Od = {},
    Pd = {};function Qd(a, b) {
  var c = a[0].toUpperCase() + a.slice(1),
      d = "on" + c;c = "top" + c;b = { phasedRegistrationNames: { bubbled: d, captured: d + "Capture" }, dependencies: [c], isInteractive: b };Od[a] = b;Pd[c] = b;
}
"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function (a) {
  Qd(a, !0);
});
"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function (a) {
  Qd(a, !1);
});
var Rd = { eventTypes: Od, isInteractiveTopLevelEventType: function isInteractiveTopLevelEventType(a) {
    a = Pd[a];return void 0 !== a && !0 === a.isInteractive;
  }, extractEvents: function extractEvents(a, b, c, d) {
    var e = Pd[a];if (!e) return null;switch (a) {case "topKeyPress":
        if (0 === Gd(c)) return null;case "topKeyDown":case "topKeyUp":
        a = Jd;break;case "topBlur":case "topFocus":
        a = Fd;break;case "topClick":
        if (2 === c.button) return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":
        a = ud;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":
        a = Kd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":
        a = Ld;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":
        a = Dd;break;case "topTransitionEnd":
        a = Md;break;case "topScroll":
        a = qd;break;case "topWheel":
        a = Nd;break;case "topCopy":case "topCut":case "topPaste":
        a = Ed;break;default:
        a = N;}b = a.getPooled(e, b, c, d);ib(b);return b;
  } },
    Sd = Rd.isInteractiveTopLevelEventType,
    Td = [];function Ud(a) {
  var b = a.targetInst;do {
    if (!b) {
      a.ancestors.push(b);break;
    }var c;for (c = b; c["return"];) {
      c = c["return"];
    }c = 3 !== c.tag ? null : c.stateNode.containerInfo;if (!c) break;a.ancestors.push(b);b = Ua(c);
  } while (b);for (c = 0; c < a.ancestors.length; c++) {
    b = a.ancestors[c], Qa(a.topLevelType, b, a.nativeEvent, hc(a.nativeEvent));
  }
}var Vd = !0;function Wd(a) {
  Vd = !!a;
}
function W(a, b, c) {
  if (!c) return null;a = (Sd(a) ? Xd : Yd).bind(null, a);c.addEventListener(b, a, !1);
}function Zd(a, b, c) {
  if (!c) return null;a = (Sd(a) ? Xd : Yd).bind(null, a);c.addEventListener(b, a, !0);
}function Xd(a, b) {
  bc(Yd, a, b);
}
function Yd(a, b) {
  if (Vd) {
    var c = hc(b);c = Ua(c);null !== c && "number" === typeof c.tag && 2 !== xd(c) && (c = null);if (Td.length) {
      var d = Td.pop();d.topLevelType = a;d.nativeEvent = b;d.targetInst = c;a = d;
    } else a = { topLevelType: a, nativeEvent: b, targetInst: c, ancestors: [] };try {
      ec(Ud, a);
    } finally {
      a.topLevelType = null, a.nativeEvent = null, a.targetInst = null, a.ancestors.length = 0, 10 > Td.length && Td.push(a);
    }
  }
}
var $d = Object.freeze({ get _enabled() {
    return Vd;
  }, setEnabled: Wd, isEnabled: function isEnabled() {
    return Vd;
  }, trapBubbledEvent: W, trapCapturedEvent: Zd, dispatchEvent: Yd });function ae(a, b) {
  var c = {};c[a.toLowerCase()] = b.toLowerCase();c["Webkit" + a] = "webkit" + b;c["Moz" + a] = "moz" + b;c["ms" + a] = "MS" + b;c["O" + a] = "o" + b.toLowerCase();return c;
}
var be = { animationend: ae("Animation", "AnimationEnd"), animationiteration: ae("Animation", "AnimationIteration"), animationstart: ae("Animation", "AnimationStart"), transitionend: ae("Transition", "TransitionEnd") },
    ce = {},
    de = {};m.canUseDOM && (de = document.createElement("div").style, "AnimationEvent" in window || (delete be.animationend.animation, delete be.animationiteration.animation, delete be.animationstart.animation), "TransitionEvent" in window || delete be.transitionend.transition);
function ee(a) {
  if (ce[a]) return ce[a];if (!be[a]) return a;var b = be[a],
      c;for (c in b) {
    if (b.hasOwnProperty(c) && c in de) return ce[a] = b[c];
  }return a;
}
var fe = { topAnimationEnd: ee("animationend"), topAnimationIteration: ee("animationiteration"), topAnimationStart: ee("animationstart"), topBlur: "blur", topCancel: "cancel", topChange: "change", topClick: "click", topClose: "close", topCompositionEnd: "compositionend", topCompositionStart: "compositionstart", topCompositionUpdate: "compositionupdate", topContextMenu: "contextmenu", topCopy: "copy", topCut: "cut", topDoubleClick: "dblclick", topDrag: "drag", topDragEnd: "dragend", topDragEnter: "dragenter", topDragExit: "dragexit", topDragLeave: "dragleave",
  topDragOver: "dragover", topDragStart: "dragstart", topDrop: "drop", topFocus: "focus", topInput: "input", topKeyDown: "keydown", topKeyPress: "keypress", topKeyUp: "keyup", topLoad: "load", topLoadStart: "loadstart", topMouseDown: "mousedown", topMouseMove: "mousemove", topMouseOut: "mouseout", topMouseOver: "mouseover", topMouseUp: "mouseup", topPaste: "paste", topScroll: "scroll", topSelectionChange: "selectionchange", topTextInput: "textInput", topToggle: "toggle", topTouchCancel: "touchcancel", topTouchEnd: "touchend", topTouchMove: "touchmove",
  topTouchStart: "touchstart", topTransitionEnd: ee("transitionend"), topWheel: "wheel" },
    ge = { topAbort: "abort", topCanPlay: "canplay", topCanPlayThrough: "canplaythrough", topDurationChange: "durationchange", topEmptied: "emptied", topEncrypted: "encrypted", topEnded: "ended", topError: "error", topLoadedData: "loadeddata", topLoadedMetadata: "loadedmetadata", topLoadStart: "loadstart", topPause: "pause", topPlay: "play", topPlaying: "playing", topProgress: "progress", topRateChange: "ratechange", topSeeked: "seeked", topSeeking: "seeking",
  topStalled: "stalled", topSuspend: "suspend", topTimeUpdate: "timeupdate", topVolumeChange: "volumechange", topWaiting: "waiting" },
    he = {},
    ie = 0,
    je = "_reactListenersID" + ("" + Math.random()).slice(2);function ke(a) {
  Object.prototype.hasOwnProperty.call(a, je) || (a[je] = ie++, he[a[je]] = {});return he[a[je]];
}function le(a) {
  for (; a && a.firstChild;) {
    a = a.firstChild;
  }return a;
}
function me(a, b) {
  var c = le(a);a = 0;for (var d; c;) {
    if (3 === c.nodeType) {
      d = a + c.textContent.length;if (a <= b && d >= b) return { node: c, offset: b - a };a = d;
    }a: {
      for (; c;) {
        if (c.nextSibling) {
          c = c.nextSibling;break a;
        }c = c.parentNode;
      }c = void 0;
    }c = le(c);
  }
}function ne(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();return b && ("input" === b && "text" === a.type || "textarea" === b || "true" === a.contentEditable);
}
var oe = m.canUseDOM && "documentMode" in document && 11 >= document.documentMode,
    pe = { select: { phasedRegistrationNames: { bubbled: "onSelect", captured: "onSelectCapture" }, dependencies: "topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ") } },
    qe = null,
    re = null,
    se = null,
    te = !1;
function ue(a, b) {
  if (te || null == qe || qe !== fa()) return null;var c = qe;"selectionStart" in c && ne(c) ? c = { start: c.selectionStart, end: c.selectionEnd } : window.getSelection ? (c = window.getSelection(), c = { anchorNode: c.anchorNode, anchorOffset: c.anchorOffset, focusNode: c.focusNode, focusOffset: c.focusOffset }) : c = void 0;return se && ha(se, c) ? null : (se = c, a = N.getPooled(pe.select, re, a, b), a.type = "select", a.target = qe, ib(a), a);
}
var ve = { eventTypes: pe, extractEvents: function extractEvents(a, b, c, d) {
    var e = d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument,
        f;if (!(f = !e)) {
      a: {
        e = ke(e);f = va.onSelect;for (var h = 0; h < f.length; h++) {
          var g = f[h];if (!e.hasOwnProperty(g) || !e[g]) {
            e = !1;break a;
          }
        }e = !0;
      }f = !e;
    }if (f) return null;e = b ? Va(b) : window;switch (a) {case "topFocus":
        if (gc(e) || "true" === e.contentEditable) qe = e, re = b, se = null;break;case "topBlur":
        se = re = qe = null;break;case "topMouseDown":
        te = !0;break;case "topContextMenu":case "topMouseUp":
        return te = !1, ue(c, d);case "topSelectionChange":
        if (oe) break;
      case "topKeyDown":case "topKeyUp":
        return ue(c, d);}return null;
  } };Na.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Da = bb.getFiberCurrentPropsFromNode;Ea = bb.getInstanceFromNode;Fa = bb.getNodeFromInstance;Na.injectEventPluginsByName({ SimpleEventPlugin: Rd, EnterLeaveEventPlugin: wd, ChangeEventPlugin: pd, SelectEventPlugin: ve, BeforeInputEventPlugin: Rb });
function xe(a, b, c, d) {
  this.tag = a;this.key = c;this.stateNode = this.type = null;this.sibling = this.child = this["return"] = null;this.index = 0;this.ref = null;this.pendingProps = b;this.memoizedState = this.updateQueue = this.memoizedProps = null;this.mode = d;this.effectTag = 0;this.lastEffect = this.firstEffect = this.nextEffect = null;this.expirationTime = 0;this.alternate = null;
}
function ze(a, b, c) {
  var d = a.alternate;null === d ? (d = new xe(a.tag, b, a.key, a.mode), d.type = a.type, d.stateNode = a.stateNode, d.alternate = a, a.alternate = d) : (d.pendingProps = b, d.effectTag = 0, d.nextEffect = null, d.firstEffect = null, d.lastEffect = null);d.expirationTime = c;d.child = a.child;d.memoizedProps = a.memoizedProps;d.memoizedState = a.memoizedState;d.updateQueue = a.updateQueue;d.sibling = a.sibling;d.index = a.index;d.ref = a.ref;return d;
}
function Ae(a, b, c) {
  var d = a.type,
      e = a.key;a = a.props;var f = void 0;if ("function" === typeof d) f = d.prototype && d.prototype.isReactComponent ? 2 : 0;else if ("string" === typeof d) f = 5;else switch (d) {case sc:
      return Be(a.children, b, c, e);case wc:
      f = 11;b |= 3;break;case tc:
      f = 11;b |= 2;break;case pc:
      f = 7;break;case qc:
      f = 9;break;default:
      if ("object" === (typeof d === "undefined" ? "undefined" : _typeof(d)) && null !== d) switch (d.$$typeof) {case uc:
          f = 13;break;case vc:
          f = 12;break;case xc:
          f = 14;break;default:
          if ("number" === typeof d.tag) return b = d, b.pendingProps = a, b.expirationTime = c, b;D("130", null == d ? d : typeof d === "undefined" ? "undefined" : _typeof(d), "");} else D("130", null == d ? d : typeof d === "undefined" ? "undefined" : _typeof(d), "");}b = new xe(f, a, e, b);b.type = d;b.expirationTime = c;return b;
}function Be(a, b, c, d) {
  a = new xe(10, a, d, b);a.expirationTime = c;return a;
}function Ce(a, b, c) {
  a = new xe(6, a, null, b);a.expirationTime = c;return a;
}function De(a, b, c) {
  b = new xe(4, null !== a.children ? a.children : [], a.key, b);b.expirationTime = c;b.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation };return b;
}var Ee = null,
    Fe = null;
function Ge(a) {
  return function (b) {
    try {
      return a(b);
    } catch (c) {}
  };
}function He(a) {
  if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;if (b.isDisabled || !b.supportsFiber) return !0;try {
    var c = b.inject(a);Ee = Ge(function (a) {
      return b.onCommitFiberRoot(c, a);
    });Fe = Ge(function (a) {
      return b.onCommitFiberUnmount(c, a);
    });
  } catch (d) {}return !0;
}function Ie(a) {
  "function" === typeof Ee && Ee(a);
}function Je(a) {
  "function" === typeof Fe && Fe(a);
}new Set();
function Ke(a) {
  return { baseState: a, expirationTime: 0, first: null, last: null, callbackList: null, hasForceUpdate: !1, isInitialized: !1, capturedValues: null };
}function Le(a, b) {
  null === a.last ? a.first = a.last = b : (a.last.next = b, a.last = b);if (0 === a.expirationTime || a.expirationTime > b.expirationTime) a.expirationTime = b.expirationTime;
}var Me = void 0,
    Ne = void 0;
function Oe(a) {
  Me = Ne = null;var b = a.alternate,
      c = a.updateQueue;null === c && (c = a.updateQueue = Ke(null));null !== b ? (a = b.updateQueue, null === a && (a = b.updateQueue = Ke(null))) : a = null;Me = c;Ne = a !== c ? a : null;
}function Pe(a, b) {
  Oe(a);a = Me;var c = Ne;null === c ? Le(a, b) : null === a.last || null === c.last ? (Le(a, b), Le(c, b)) : (Le(a, b), c.last = b);
}function Qe(a, b, c, d) {
  a = a.partialState;return "function" === typeof a ? a.call(b, c, d) : a;
}
function Re(a, b, c, d, e, f) {
  null !== a && a.updateQueue === c && (c = b.updateQueue = { baseState: c.baseState, expirationTime: c.expirationTime, first: c.first, last: c.last, isInitialized: c.isInitialized, capturedValues: c.capturedValues, callbackList: null, hasForceUpdate: !1 });c.expirationTime = 0;c.isInitialized ? a = c.baseState : (a = c.baseState = b.memoizedState, c.isInitialized = !0);for (var h = !0, g = c.first, k = !1; null !== g;) {
    var v = g.expirationTime;if (v > f) {
      var l = c.expirationTime;if (0 === l || l > v) c.expirationTime = v;k || (k = !0, c.baseState = a);
    } else {
      k || (c.first = g.next, null === c.first && (c.last = null));if (g.isReplace) a = Qe(g, d, a, e), h = !0;else if (v = Qe(g, d, a, e)) a = h ? A({}, a, v) : A(a, v), h = !1;g.isForced && (c.hasForceUpdate = !0);null !== g.callback && (v = c.callbackList, null === v && (v = c.callbackList = []), v.push(g));null !== g.capturedValue && (v = c.capturedValues, null === v ? c.capturedValues = [g.capturedValue] : v.push(g.capturedValue));
    }g = g.next;
  }null !== c.callbackList ? b.effectTag |= 32 : null !== c.first || c.hasForceUpdate || null !== c.capturedValues || (b.updateQueue = null);k || (c.baseState = a);
  return a;
}function Se(a, b) {
  var c = a.callbackList;if (null !== c) for (a.callbackList = null, a = 0; a < c.length; a++) {
    var d = c[a],
        e = d.callback;d.callback = null;"function" !== typeof e ? D("191", e) : void 0;e.call(b);
  }
}
function Te(a, b, c, d, e) {
  function f(a, b, c, d, e, f) {
    if (null === b || null !== a.updateQueue && a.updateQueue.hasForceUpdate) return !0;var n = a.stateNode;a = a.type;return "function" === typeof n.shouldComponentUpdate ? n.shouldComponentUpdate(c, e, f) : a.prototype && a.prototype.isPureReactComponent ? !ha(b, c) || !ha(d, e) : !0;
  }function h(a, b) {
    b.updater = r;a.stateNode = b;b._reactInternalFiber = a;
  }function g(a, b, c, d) {
    a = b.state;"function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);"function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);b.state !== a && r.enqueueReplaceState(b, b.state, null);
  }function k(a, b, c, d) {
    a = a.type;if ("function" === typeof a.getDerivedStateFromProps) return a.getDerivedStateFromProps.call(null, c, d);
  }var v = a.cacheContext,
      l = a.getMaskedContext,
      p = a.getUnmaskedContext,
      z = a.isContextConsumer,
      B = a.hasContextChanged,
      r = { isMounted: yd, enqueueSetState: function enqueueSetState(a, d, e) {
      a = a._reactInternalFiber;e = void 0 === e ? null : e;var f = c(a);Pe(a, { expirationTime: f, partialState: d, callback: e, isReplace: !1, isForced: !1,
        capturedValue: null, next: null });b(a, f);
    }, enqueueReplaceState: function enqueueReplaceState(a, d, e) {
      a = a._reactInternalFiber;e = void 0 === e ? null : e;var f = c(a);Pe(a, { expirationTime: f, partialState: d, callback: e, isReplace: !0, isForced: !1, capturedValue: null, next: null });b(a, f);
    }, enqueueForceUpdate: function enqueueForceUpdate(a, d) {
      a = a._reactInternalFiber;d = void 0 === d ? null : d;var e = c(a);Pe(a, { expirationTime: e, partialState: null, callback: d, isReplace: !1, isForced: !0, capturedValue: null, next: null });b(a, e);
    } };return { adoptClassInstance: h, callGetDerivedStateFromProps: k,
    constructClassInstance: function constructClassInstance(a, b) {
      var c = a.type,
          d = p(a),
          e = z(a),
          f = e ? l(a, d) : ka;c = new c(b, f);var n = null !== c.state && void 0 !== c.state ? c.state : null;h(a, c);a.memoizedState = n;b = k(a, c, b, n);null !== b && void 0 !== b && (a.memoizedState = A({}, a.memoizedState, b));e && v(a, d, f);return c;
    }, mountClassInstance: function mountClassInstance(a, b) {
      var c = a.type,
          d = a.alternate,
          e = a.stateNode,
          f = a.pendingProps,
          n = p(a);e.props = f;e.state = a.memoizedState;e.refs = ka;e.context = l(a, n);"function" === typeof c.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (c = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), c !== e.state && r.enqueueReplaceState(e, e.state, null), c = a.updateQueue, null !== c && (e.state = Re(d, a, c, e, f, b)));"function" === typeof e.componentDidMount && (a.effectTag |= 4);
    }, resumeMountClassInstance: function resumeMountClassInstance(a, b) {
      var c = a.type,
          n = a.stateNode;n.props = a.memoizedProps;n.state = a.memoizedState;var h = a.memoizedProps,
          r = a.pendingProps,
          z = n.context,
          q = p(a);q = l(a, q);(c = "function" === typeof c.getDerivedStateFromProps || "function" === typeof n.getSnapshotBeforeUpdate) || "function" !== typeof n.UNSAFE_componentWillReceiveProps && "function" !== typeof n.componentWillReceiveProps || (h !== r || z !== q) && g(a, n, r, q);z = a.memoizedState;b = null !== a.updateQueue ? Re(null, a, a.updateQueue, n, r, b) : z;var u = void 0;h !== r && (u = k(a, n, r, b));if (null !== u && void 0 !== u) {
        b = null === b || void 0 === b ? u : A({}, b, u);var t = a.updateQueue;
        null !== t && (t.baseState = A({}, t.baseState, u));
      }if (!(h !== r || z !== b || B() || null !== a.updateQueue && a.updateQueue.hasForceUpdate)) return "function" === typeof n.componentDidMount && (a.effectTag |= 4), !1;(h = f(a, h, r, z, b, q)) ? (c || "function" !== typeof n.UNSAFE_componentWillMount && "function" !== typeof n.componentWillMount || ("function" === typeof n.componentWillMount && n.componentWillMount(), "function" === typeof n.UNSAFE_componentWillMount && n.UNSAFE_componentWillMount()), "function" === typeof n.componentDidMount && (a.effectTag |= 4)) : ("function" === typeof n.componentDidMount && (a.effectTag |= 4), d(a, r), e(a, b));n.props = r;n.state = b;n.context = q;return h;
    }, updateClassInstance: function updateClassInstance(a, b, c) {
      var n = b.type,
          x = b.stateNode;x.props = b.memoizedProps;x.state = b.memoizedState;var h = b.memoizedProps,
          r = b.pendingProps,
          q = x.context,
          u = p(b);u = l(b, u);(n = "function" === typeof n.getDerivedStateFromProps || "function" === typeof x.getSnapshotBeforeUpdate) || "function" !== typeof x.UNSAFE_componentWillReceiveProps && "function" !== typeof x.componentWillReceiveProps || (h !== r || q !== u) && g(b, x, r, u);q = b.memoizedState;c = null !== b.updateQueue ? Re(a, b, b.updateQueue, x, r, c) : q;var t = void 0;h !== r && (t = k(b, x, r, c));if (null !== t && void 0 !== t) {
        c = null === c || void 0 === c ? t : A({}, c, t);var y = b.updateQueue;null !== y && (y.baseState = A({}, y.baseState, t));
      }if (!(h !== r || q !== c || B() || null !== b.updateQueue && b.updateQueue.hasForceUpdate)) return "function" !== typeof x.componentDidUpdate || h === a.memoizedProps && q === a.memoizedState || (b.effectTag |= 4), "function" !== typeof x.getSnapshotBeforeUpdate || h === a.memoizedProps && q === a.memoizedState || (b.effectTag |= 2048), !1;(t = f(b, h, r, q, c, u)) ? (n || "function" !== typeof x.UNSAFE_componentWillUpdate && "function" !== typeof x.componentWillUpdate || ("function" === typeof x.componentWillUpdate && x.componentWillUpdate(r, c, u), "function" === typeof x.UNSAFE_componentWillUpdate && x.UNSAFE_componentWillUpdate(r, c, u)), "function" === typeof x.componentDidUpdate && (b.effectTag |= 4), "function" === typeof x.getSnapshotBeforeUpdate && (b.effectTag |= 2048)) : ("function" !== typeof x.componentDidUpdate || h === a.memoizedProps && q === a.memoizedState || (b.effectTag |= 4), "function" !== typeof x.getSnapshotBeforeUpdate || h === a.memoizedProps && q === a.memoizedState || (b.effectTag |= 2048), d(b, r), e(b, c));x.props = r;x.state = c;x.context = u;return t;
    } };
}var Ue = Array.isArray;
function Ve(a, b, c) {
  a = c.ref;if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a))) {
    if (c._owner) {
      c = c._owner;var d = void 0;c && (2 !== c.tag ? D("110") : void 0, d = c.stateNode);d ? void 0 : D("147", a);var e = "" + a;if (null !== b && null !== b.ref && b.ref._stringRef === e) return b.ref;b = function b(a) {
        var b = d.refs === ka ? d.refs = {} : d.refs;null === a ? delete b[e] : b[e] = a;
      };b._stringRef = e;return b;
    }"string" !== typeof a ? D("148") : void 0;c._owner ? void 0 : D("254", a);
  }return a;
}
function We(a, b) {
  "textarea" !== a.type && D("31", "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, "");
}
function Xe(a) {
  function b(b, c) {
    if (a) {
      var d = b.lastEffect;null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;c.nextEffect = null;c.effectTag = 8;
    }
  }function c(c, d) {
    if (!a) return null;for (; null !== d;) {
      b(c, d), d = d.sibling;
    }return null;
  }function d(a, b) {
    for (a = new Map(); null !== b;) {
      null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
    }return a;
  }function e(a, b, c) {
    a = ze(a, b, c);a.index = 0;a.sibling = null;return a;
  }function f(b, c, d) {
    b.index = d;if (!a) return c;d = b.alternate;if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;b.effectTag = 2;return c;
  }function h(b) {
    a && null === b.alternate && (b.effectTag = 2);return b;
  }function g(a, b, c, d) {
    if (null === b || 6 !== b.tag) return b = Ce(c, a.mode, d), b["return"] = a, b;b = e(b, c, d);b["return"] = a;return b;
  }function k(a, b, c, d) {
    if (null !== b && b.type === c.type) return d = e(b, c.props, d), d.ref = Ve(a, b, c), d["return"] = a, d;d = Ae(c, a.mode, d);d.ref = Ve(a, b, c);d["return"] = a;return d;
  }function v(a, b, c, d) {
    if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = De(c, a.mode, d), b["return"] = a, b;b = e(b, c.children || [], d);b["return"] = a;return b;
  }function l(a, b, c, d, f) {
    if (null === b || 10 !== b.tag) return b = Be(c, a.mode, d, f), b["return"] = a, b;b = e(b, c, d);b["return"] = a;return b;
  }function p(a, b, c) {
    if ("string" === typeof b || "number" === typeof b) return b = Ce("" + b, a.mode, c), b["return"] = a, b;if ("object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) && null !== b) {
      switch (b.$$typeof) {case oc:
          return c = Ae(b, a.mode, c), c.ref = Ve(a, null, b), c["return"] = a, c;case rc:
          return b = De(b, a.mode, c), b["return"] = a, b;}if (Ue(b) || zc(b)) return b = Be(b, a.mode, c, null), b["return"] = a, b;We(a, b);
    }return null;
  }function z(a, b, c, d) {
    var e = null !== b ? b.key : null;if ("string" === typeof c || "number" === typeof c) return null !== e ? null : g(a, b, "" + c, d);if ("object" === (typeof c === "undefined" ? "undefined" : _typeof(c)) && null !== c) {
      switch (c.$$typeof) {case oc:
          return c.key === e ? c.type === sc ? l(a, b, c.props.children, d, e) : k(a, b, c, d) : null;case rc:
          return c.key === e ? v(a, b, c, d) : null;}if (Ue(c) || zc(c)) return null !== e ? null : l(a, b, c, d, null);We(a, c);
    }return null;
  }function B(a, b, c, d, e) {
    if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, g(b, a, "" + d, e);if ("object" === (typeof d === "undefined" ? "undefined" : _typeof(d)) && null !== d) {
      switch (d.$$typeof) {case oc:
          return a = a.get(null === d.key ? c : d.key) || null, d.type === sc ? l(b, a, d.props.children, e, d.key) : k(b, a, d, e);case rc:
          return a = a.get(null === d.key ? c : d.key) || null, v(b, a, d, e);}if (Ue(d) || zc(d)) return a = a.get(c) || null, l(b, a, d, e, null);We(b, d);
    }return null;
  }function r(e, l, g, h) {
    for (var r = null, k = null, q = l, u = l = 0, t = null; null !== q && u < g.length; u++) {
      q.index > u ? (t = q, q = null) : t = q.sibling;var n = z(e, q, g[u], h);if (null === n) {
        null === q && (q = t);break;
      }a && q && null === n.alternate && b(e, q);l = f(n, l, u);null === k ? r = n : k.sibling = n;k = n;q = t;
    }if (u === g.length) return c(e, q), r;if (null === q) {
      for (; u < g.length; u++) {
        if (q = p(e, g[u], h)) l = f(q, l, u), null === k ? r = q : k.sibling = q, k = q;
      }return r;
    }for (q = d(e, q); u < g.length; u++) {
      if (t = B(q, e, u, g[u], h)) {
        if (a && null !== t.alternate) q["delete"](null === t.key ? u : t.key);l = f(t, l, u);null === k ? r = t : k.sibling = t;k = t;
      }
    }a && q.forEach(function (a) {
      return b(e, a);
    });return r;
  }function Q(e, l, g, h) {
    var r = zc(g);"function" !== typeof r ? D("150") : void 0;g = r.call(g);null == g ? D("151") : void 0;for (var k = r = null, q = l, u = l = 0, t = null, n = g.next(); null !== q && !n.done; u++, n = g.next()) {
      q.index > u ? (t = q, q = null) : t = q.sibling;var H = z(e, q, n.value, h);if (null === H) {
        q || (q = t);break;
      }a && q && null === H.alternate && b(e, q);l = f(H, l, u);null === k ? r = H : k.sibling = H;k = H;q = t;
    }if (n.done) return c(e, q), r;if (null === q) {
      for (; !n.done; u++, n = g.next()) {
        n = p(e, n.value, h), null !== n && (l = f(n, l, u), null === k ? r = n : k.sibling = n, k = n);
      }return r;
    }for (q = d(e, q); !n.done; u++, n = g.next()) {
      if (n = B(q, e, u, n.value, h), null !== n) {
        if (a && null !== n.alternate) q["delete"](null === n.key ? u : n.key);
        l = f(n, l, u);null === k ? r = n : k.sibling = n;k = n;
      }
    }a && q.forEach(function (a) {
      return b(e, a);
    });return r;
  }return function (a, d, f, l) {
    "object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && null !== f && f.type === sc && null === f.key && (f = f.props.children);var g = "object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && null !== f;if (g) switch (f.$$typeof) {case oc:
        a: {
          var k = f.key;for (g = d; null !== g;) {
            if (g.key === k) {
              if (10 === g.tag ? f.type === sc : g.type === f.type) {
                c(a, g.sibling);d = e(g, f.type === sc ? f.props.children : f.props, l);d.ref = Ve(a, g, f);d["return"] = a;a = d;break a;
              } else {
                c(a, g);break;
              }
            } else b(a, g);g = g.sibling;
          }f.type === sc ? (d = Be(f.props.children, a.mode, l, f.key), d["return"] = a, a = d) : (l = Ae(f, a.mode, l), l.ref = Ve(a, d, f), l["return"] = a, a = l);
        }return h(a);case rc:
        a: {
          for (g = f.key; null !== d;) {
            if (d.key === g) {
              if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                c(a, d.sibling);d = e(d, f.children || [], l);d["return"] = a;a = d;break a;
              } else {
                c(a, d);break;
              }
            } else b(a, d);d = d.sibling;
          }d = De(f, a.mode, l);d["return"] = a;a = d;
        }return h(a);}if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f, l), d["return"] = a, a = d) : (c(a, d), d = Ce(f, a.mode, l), d["return"] = a, a = d), h(a);if (Ue(f)) return r(a, d, f, l);if (zc(f)) return Q(a, d, f, l);g && We(a, f);if ("undefined" === typeof f) switch (a.tag) {case 2:case 1:
        l = a.type, D("152", l.displayName || l.name || "Component");}return c(a, d);
  };
}var Ye = Xe(!0),
    Ze = Xe(!1);
function $e(a, b, c, d, e, f, h) {
  function g(a, b, c) {
    k(a, b, c, b.expirationTime);
  }function k(a, b, c, d) {
    b.child = null === a ? Ze(b, null, c, d) : Ye(b, a.child, c, d);
  }function v(a, b) {
    var c = b.ref;if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
  }function l(a, b, c, d, e, f) {
    v(a, b);if (!c && !e) return d && y(b, !1), r(a, b);c = b.stateNode;nc.current = b;var l = e ? null : c.render();b.effectTag |= 1;e && (k(a, b, null, f), b.child = null);k(a, b, l, f);b.memoizedState = c.state;b.memoizedProps = c.props;d && y(b, !0);return b.child;
  }function p(a) {
    var b = a.stateNode;
    b.pendingContext ? t(a, b.pendingContext, b.pendingContext !== b.context) : b.context && t(a, b.context, !1);Y(a, b.containerInfo);
  }function z(a, b, c, d) {
    var e = a.child;for (null !== e && (e["return"] = a); null !== e;) {
      switch (e.tag) {case 12:
          var f = e.stateNode | 0;if (e.type === b && 0 !== (f & c)) {
            for (f = e; null !== f;) {
              var l = f.alternate;if (0 === f.expirationTime || f.expirationTime > d) f.expirationTime = d, null !== l && (0 === l.expirationTime || l.expirationTime > d) && (l.expirationTime = d);else if (null !== l && (0 === l.expirationTime || l.expirationTime > d)) l.expirationTime = d;else break;f = f["return"];
            }f = null;
          } else f = e.child;break;case 13:
          f = e.type === a.type ? null : e.child;break;default:
          f = e.child;}if (null !== f) f["return"] = e;else for (f = e; null !== f;) {
        if (f === a) {
          f = null;break;
        }e = f.sibling;if (null !== e) {
          f = e;break;
        }f = f["return"];
      }e = f;
    }
  }function B(a, b, c) {
    var d = b.type._context,
        e = b.pendingProps,
        f = b.memoizedProps;if (!q() && f === e) return b.stateNode = 0, G(b), r(a, b);var l = e.value;b.memoizedProps = e;if (null === f) l = 1073741823;else if (f.value === e.value) {
      if (f.children === e.children) return b.stateNode = 0, G(b), r(a, b);l = 0;
    } else {
      var h = f.value;if (h === l && (0 !== h || 1 / h === 1 / l) || h !== h && l !== l) {
        if (f.children === e.children) return b.stateNode = 0, G(b), r(a, b);l = 0;
      } else if (l = "function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, l) : 1073741823, l |= 0, 0 === l) {
        if (f.children === e.children) return b.stateNode = 0, G(b), r(a, b);
      } else z(b, d, l, c);
    }b.stateNode = l;G(b);g(a, b, e.children);return b.child;
  }function r(a, b) {
    null !== a && b.child !== a.child ? D("153") : void 0;if (null !== b.child) {
      a = b.child;var c = ze(a, a.pendingProps, a.expirationTime);
      b.child = c;for (c["return"] = b; null !== a.sibling;) {
        a = a.sibling, c = c.sibling = ze(a, a.pendingProps, a.expirationTime), c["return"] = b;
      }c.sibling = null;
    }return b.child;
  }var Q = a.shouldSetTextContent,
      n = a.shouldDeprioritizeSubtree,
      x = b.pushHostContext,
      Y = b.pushHostContainer,
      G = d.pushProvider,
      R = c.getMaskedContext,
      S = c.getUnmaskedContext,
      q = c.hasContextChanged,
      u = c.pushContextProvider,
      t = c.pushTopLevelContextObject,
      y = c.invalidateContextProvider,
      H = e.enterHydrationState,
      Wa = e.resetHydrationState,
      Cb = e.tryToClaimNextHydratableInstance;
  a = Te(c, f, h, function (a, b) {
    a.memoizedProps = b;
  }, function (a, b) {
    a.memoizedState = b;
  });var Jc = a.adoptClassInstance,
      Kc = a.callGetDerivedStateFromProps,
      Lc = a.constructClassInstance,
      Db = a.mountClassInstance,
      Mc = a.resumeMountClassInstance,
      Eb = a.updateClassInstance;return { beginWork: function beginWork(a, b, c) {
      if (0 === b.expirationTime || b.expirationTime > c) {
        switch (b.tag) {case 3:
            p(b);break;case 2:
            u(b);break;case 4:
            Y(b, b.stateNode.containerInfo);break;case 13:
            G(b);}return null;
      }switch (b.tag) {case 0:
          null !== a ? D("155") : void 0;var d = b.type,
              e = b.pendingProps,
              f = S(b);f = R(b, f);d = d(e, f);b.effectTag |= 1;"object" === (typeof d === "undefined" ? "undefined" : _typeof(d)) && null !== d && "function" === typeof d.render && void 0 === d.$$typeof ? (f = b.type, b.tag = 2, b.memoizedState = null !== d.state && void 0 !== d.state ? d.state : null, "function" === typeof f.getDerivedStateFromProps && (e = Kc(b, d, e, b.memoizedState), null !== e && void 0 !== e && (b.memoizedState = A({}, b.memoizedState, e))), e = u(b), Jc(b, d), Db(b, c), a = l(a, b, !0, e, !1, c)) : (b.tag = 1, g(a, b, d), b.memoizedProps = e, a = b.child);return a;case 1:
          return e = b.type, c = b.pendingProps, q() || b.memoizedProps !== c ? (d = S(b), d = R(b, d), e = e(c, d), b.effectTag |= 1, g(a, b, e), b.memoizedProps = c, a = b.child) : a = r(a, b), a;case 2:
          e = u(b);null === a ? null === b.stateNode ? (Lc(b, b.pendingProps), Db(b, c), d = !0) : d = Mc(b, c) : d = Eb(a, b, c);f = !1;var h = b.updateQueue;null !== h && null !== h.capturedValues && (f = d = !0);return l(a, b, d, e, f, c);case 3:
          a: if (p(b), d = b.updateQueue, null !== d) {
            f = b.memoizedState;e = Re(a, b, d, null, null, c);b.memoizedState = e;d = b.updateQueue;if (null !== d && null !== d.capturedValues) d = null;else if (f === e) {
              Wa();a = r(a, b);break a;
            } else d = e.element;f = b.stateNode;(null === a || null === a.child) && f.hydrate && H(b) ? (b.effectTag |= 2, b.child = Ze(b, null, d, c)) : (Wa(), g(a, b, d));b.memoizedState = e;a = b.child;
          } else Wa(), a = r(a, b);return a;case 5:
          a: {
            x(b);null === a && Cb(b);e = b.type;h = b.memoizedProps;d = b.pendingProps;f = null !== a ? a.memoizedProps : null;if (!q() && h === d) {
              if (h = b.mode & 1 && n(e, d)) b.expirationTime = 1073741823;if (!h || 1073741823 !== c) {
                a = r(a, b);break a;
              }
            }h = d.children;Q(e, d) ? h = null : f && Q(e, f) && (b.effectTag |= 16);v(a, b);1073741823 !== c && b.mode & 1 && n(e, d) ? (b.expirationTime = 1073741823, b.memoizedProps = d, a = null) : (g(a, b, h), b.memoizedProps = d, a = b.child);
          }return a;case 6:
          return null === a && Cb(b), b.memoizedProps = b.pendingProps, null;case 8:
          b.tag = 7;case 7:
          return e = b.pendingProps, q() || b.memoizedProps !== e || (e = b.memoizedProps), d = e.children, b.stateNode = null === a ? Ze(b, b.stateNode, d, c) : Ye(b, a.stateNode, d, c), b.memoizedProps = e, b.stateNode;case 9:
          return null;case 4:
          return Y(b, b.stateNode.containerInfo), e = b.pendingProps, q() || b.memoizedProps !== e ? (null === a ? b.child = Ye(b, null, e, c) : g(a, b, e), b.memoizedProps = e, a = b.child) : a = r(a, b), a;case 14:
          return c = b.type.render, c = c(b.pendingProps, b.ref), g(a, b, c), b.memoizedProps = c, b.child;case 10:
          return c = b.pendingProps, q() || b.memoizedProps !== c ? (g(a, b, c), b.memoizedProps = c, a = b.child) : a = r(a, b), a;case 11:
          return c = b.pendingProps.children, q() || null !== c && b.memoizedProps !== c ? (g(a, b, c), b.memoizedProps = c, a = b.child) : a = r(a, b), a;case 13:
          return B(a, b, c);case 12:
          a: {
            d = b.type;f = b.pendingProps;h = b.memoizedProps;e = d._currentValue;var t = d._changedBits;if (q() || 0 !== t || h !== f) {
              b.memoizedProps = f;var k = f.unstable_observedBits;if (void 0 === k || null === k) k = 1073741823;b.stateNode = k;if (0 !== (t & k)) z(b, d, t, c);else if (h === f) {
                a = r(a, b);break a;
              }c = f.children;c = c(e);g(a, b, c);a = b.child;
            } else a = r(a, b);
          }return a;default:
          D("156");}
    } };
}
function af(a, b, c, d, e) {
  function f(a) {
    a.effectTag |= 4;
  }var h = a.createInstance,
      g = a.createTextInstance,
      k = a.appendInitialChild,
      v = a.finalizeInitialChildren,
      l = a.prepareUpdate,
      p = a.persistence,
      z = b.getRootHostContainer,
      B = b.popHostContext,
      r = b.getHostContext,
      Q = b.popHostContainer,
      n = c.popContextProvider,
      x = c.popTopLevelContextObject,
      Y = d.popProvider,
      G = e.prepareToHydrateHostInstance,
      R = e.prepareToHydrateHostTextInstance,
      S = e.popHydrationState,
      q = void 0,
      u = void 0,
      t = void 0;a.mutation ? (q = function q() {}, u = function u(a, b, c) {
    (b.updateQueue = c) && f(b);
  }, t = function t(a, b, c, d) {
    c !== d && f(b);
  }) : p ? D("235") : D("236");return { completeWork: function completeWork(a, b, c) {
      var d = b.pendingProps;switch (b.tag) {case 1:
          return null;case 2:
          return n(b), a = b.stateNode, d = b.updateQueue, null !== d && null !== d.capturedValues && (b.effectTag &= -65, "function" === typeof a.componentDidCatch ? b.effectTag |= 256 : d.capturedValues = null), null;case 3:
          Q(b);x(b);d = b.stateNode;d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);if (null === a || null === a.child) S(b), b.effectTag &= -3;q(b);a = b.updateQueue;
          null !== a && null !== a.capturedValues && (b.effectTag |= 256);return null;case 5:
          B(b);c = z();var e = b.type;if (null !== a && null != b.stateNode) {
            var p = a.memoizedProps,
                H = b.stateNode,
                y = r();H = l(H, e, p, d, c, y);u(a, b, H, e, p, d, c, y);a.ref !== b.ref && (b.effectTag |= 128);
          } else {
            if (!d) return null === b.stateNode ? D("166") : void 0, null;a = r();if (S(b)) G(b, c, a) && f(b);else {
              p = h(e, d, c, a, b);a: for (y = b.child; null !== y;) {
                if (5 === y.tag || 6 === y.tag) k(p, y.stateNode);else if (4 !== y.tag && null !== y.child) {
                  y.child["return"] = y;y = y.child;continue;
                }if (y === b) break;
                for (; null === y.sibling;) {
                  if (null === y["return"] || y["return"] === b) break a;y = y["return"];
                }y.sibling["return"] = y["return"];y = y.sibling;
              }v(p, e, d, c, a) && f(b);b.stateNode = p;
            }null !== b.ref && (b.effectTag |= 128);
          }return null;case 6:
          if (a && null != b.stateNode) t(a, b, a.memoizedProps, d);else {
            if ("string" !== typeof d) return null === b.stateNode ? D("166") : void 0, null;a = z();c = r();S(b) ? R(b) && f(b) : b.stateNode = g(d, a, c, b);
          }return null;case 7:
          (d = b.memoizedProps) ? void 0 : D("165");b.tag = 8;e = [];a: for ((p = b.stateNode) && (p["return"] = b); null !== p;) {
            if (5 === p.tag || 6 === p.tag || 4 === p.tag) D("247");else if (9 === p.tag) e.push(p.pendingProps.value);else if (null !== p.child) {
              p.child["return"] = p;p = p.child;continue;
            }for (; null === p.sibling;) {
              if (null === p["return"] || p["return"] === b) break a;p = p["return"];
            }p.sibling["return"] = p["return"];p = p.sibling;
          }p = d.handler;d = p(d.props, e);b.child = Ye(b, null !== a ? a.child : null, d, c);return b.child;case 8:
          return b.tag = 7, null;case 9:
          return null;case 14:
          return null;case 10:
          return null;case 11:
          return null;case 4:
          return Q(b), q(b), null;
        case 13:
          return Y(b), null;case 12:
          return null;case 0:
          D("167");default:
          D("156");}
    } };
}
function bf(a, b, c, d, e) {
  var f = a.popHostContainer,
      h = a.popHostContext,
      g = b.popContextProvider,
      k = b.popTopLevelContextObject,
      v = c.popProvider;return { throwException: function throwException(a, b, c) {
      b.effectTag |= 512;b.firstEffect = b.lastEffect = null;b = { value: c, source: b, stack: Bc(b) };do {
        switch (a.tag) {case 3:
            Oe(a);a.updateQueue.capturedValues = [b];a.effectTag |= 1024;return;case 2:
            if (c = a.stateNode, 0 === (a.effectTag & 64) && null !== c && "function" === typeof c.componentDidCatch && !e(c)) {
              Oe(a);c = a.updateQueue;var d = c.capturedValues;null === d ? c.capturedValues = [b] : d.push(b);a.effectTag |= 1024;return;
            }}a = a["return"];
      } while (null !== a);
    }, unwindWork: function unwindWork(a) {
      switch (a.tag) {case 2:
          g(a);var b = a.effectTag;return b & 1024 ? (a.effectTag = b & -1025 | 64, a) : null;case 3:
          return f(a), k(a), b = a.effectTag, b & 1024 ? (a.effectTag = b & -1025 | 64, a) : null;case 5:
          return h(a), null;case 4:
          return f(a), null;case 13:
          return v(a), null;default:
          return null;}
    }, unwindInterruptedWork: function unwindInterruptedWork(a) {
      switch (a.tag) {case 2:
          g(a);break;case 3:
          f(a);k(a);break;case 5:
          h(a);break;case 4:
          f(a);break;case 13:
          v(a);}
    } };
}
function cf(a, b) {
  var c = b.source;null === b.stack && Bc(c);null !== c && Ac(c);b = b.value;null !== a && 2 === a.tag && Ac(a);try {
    b && b.suppressReactErrorLogging || console.error(b);
  } catch (d) {
    d && d.suppressReactErrorLogging || console.error(d);
  }
}
function df(a, b, c, d, e) {
  function f(a) {
    var c = a.ref;if (null !== c) if ("function" === typeof c) try {
      c(null);
    } catch (t) {
      b(a, t);
    } else c.current = null;
  }function h(a) {
    "function" === typeof Je && Je(a);switch (a.tag) {case 2:
        f(a);var c = a.stateNode;if ("function" === typeof c.componentWillUnmount) try {
          c.props = a.memoizedProps, c.state = a.memoizedState, c.componentWillUnmount();
        } catch (t) {
          b(a, t);
        }break;case 5:
        f(a);break;case 7:
        g(a.stateNode);break;case 4:
        p && v(a);}
  }function g(a) {
    for (var b = a;;) {
      if (h(b), null === b.child || p && 4 === b.tag) {
        if (b === a) break;for (; null === b.sibling;) {
          if (null === b["return"] || b["return"] === a) return;b = b["return"];
        }b.sibling["return"] = b["return"];b = b.sibling;
      } else b.child["return"] = b, b = b.child;
    }
  }function k(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
  }function v(a) {
    for (var b = a, c = !1, d = void 0, e = void 0;;) {
      if (!c) {
        c = b["return"];a: for (;;) {
          null === c ? D("160") : void 0;switch (c.tag) {case 5:
              d = c.stateNode;e = !1;break a;case 3:
              d = c.stateNode.containerInfo;e = !0;break a;case 4:
              d = c.stateNode.containerInfo;e = !0;break a;}c = c["return"];
        }c = !0;
      }if (5 === b.tag || 6 === b.tag) g(b), e ? S(d, b.stateNode) : R(d, b.stateNode);else if (4 === b.tag ? d = b.stateNode.containerInfo : h(b), null !== b.child) {
        b.child["return"] = b;b = b.child;continue;
      }if (b === a) break;for (; null === b.sibling;) {
        if (null === b["return"] || b["return"] === a) return;b = b["return"];4 === b.tag && (c = !1);
      }b.sibling["return"] = b["return"];b = b.sibling;
    }
  }var l = a.getPublicInstance,
      p = a.mutation;a = a.persistence;p || (a ? D("235") : D("236"));var z = p.commitMount,
      B = p.commitUpdate,
      r = p.resetTextContent,
      Q = p.commitTextUpdate,
      n = p.appendChild,
      x = p.appendChildToContainer,
      Y = p.insertBefore,
      G = p.insertInContainerBefore,
      R = p.removeChild,
      S = p.removeChildFromContainer;return { commitBeforeMutationLifeCycles: function commitBeforeMutationLifeCycles(a, b) {
      switch (b.tag) {case 2:
          if (b.effectTag & 2048 && null !== a) {
            var c = a.memoizedProps,
                d = a.memoizedState;a = b.stateNode;a.props = b.memoizedProps;a.state = b.memoizedState;b = a.getSnapshotBeforeUpdate(c, d);a.__reactInternalSnapshotBeforeUpdate = b;
          }break;case 3:case 5:case 6:case 4:
          break;default:
          D("163");}
    }, commitResetTextContent: function commitResetTextContent(a) {
      r(a.stateNode);
    },
    commitPlacement: function commitPlacement(a) {
      a: {
        for (var b = a["return"]; null !== b;) {
          if (k(b)) {
            var c = b;break a;
          }b = b["return"];
        }D("160");c = void 0;
      }var d = b = void 0;switch (c.tag) {case 5:
          b = c.stateNode;d = !1;break;case 3:
          b = c.stateNode.containerInfo;d = !0;break;case 4:
          b = c.stateNode.containerInfo;d = !0;break;default:
          D("161");}c.effectTag & 16 && (r(b), c.effectTag &= -17);a: b: for (c = a;;) {
        for (; null === c.sibling;) {
          if (null === c["return"] || k(c["return"])) {
            c = null;break a;
          }c = c["return"];
        }c.sibling["return"] = c["return"];for (c = c.sibling; 5 !== c.tag && 6 !== c.tag;) {
          if (c.effectTag & 2) continue b;if (null === c.child || 4 === c.tag) continue b;else c.child["return"] = c, c = c.child;
        }if (!(c.effectTag & 2)) {
          c = c.stateNode;break a;
        }
      }for (var e = a;;) {
        if (5 === e.tag || 6 === e.tag) c ? d ? G(b, e.stateNode, c) : Y(b, e.stateNode, c) : d ? x(b, e.stateNode) : n(b, e.stateNode);else if (4 !== e.tag && null !== e.child) {
          e.child["return"] = e;e = e.child;continue;
        }if (e === a) break;for (; null === e.sibling;) {
          if (null === e["return"] || e["return"] === a) return;e = e["return"];
        }e.sibling["return"] = e["return"];e = e.sibling;
      }
    }, commitDeletion: function commitDeletion(a) {
      v(a);
      a["return"] = null;a.child = null;a.alternate && (a.alternate.child = null, a.alternate["return"] = null);
    }, commitWork: function commitWork(a, b) {
      switch (b.tag) {case 2:
          break;case 5:
          var c = b.stateNode;if (null != c) {
            var d = b.memoizedProps;a = null !== a ? a.memoizedProps : d;var e = b.type,
                f = b.updateQueue;b.updateQueue = null;null !== f && B(c, f, e, a, d, b);
          }break;case 6:
          null === b.stateNode ? D("162") : void 0;c = b.memoizedProps;Q(b.stateNode, null !== a ? a.memoizedProps : c, c);break;case 3:
          break;default:
          D("163");}
    }, commitLifeCycles: function commitLifeCycles(a, b, c) {
      switch (c.tag) {case 2:
          a = c.stateNode;if (c.effectTag & 4) if (null === b) a.props = c.memoizedProps, a.state = c.memoizedState, a.componentDidMount();else {
            var d = b.memoizedProps;b = b.memoizedState;a.props = c.memoizedProps;a.state = c.memoizedState;a.componentDidUpdate(d, b, a.__reactInternalSnapshotBeforeUpdate);
          }c = c.updateQueue;null !== c && Se(c, a);break;case 3:
          b = c.updateQueue;if (null !== b) {
            a = null;if (null !== c.child) switch (c.child.tag) {case 5:
                a = l(c.child.stateNode);break;case 2:
                a = c.child.stateNode;}Se(b, a);
          }break;case 5:
          a = c.stateNode;null === b && c.effectTag & 4 && z(a, c.type, c.memoizedProps, c);break;case 6:
          break;case 4:
          break;default:
          D("163");}
    }, commitErrorLogging: function commitErrorLogging(a, b) {
      switch (a.tag) {case 2:
          var c = a.type;b = a.stateNode;var d = a.updateQueue;null === d || null === d.capturedValues ? D("264") : void 0;var f = d.capturedValues;d.capturedValues = null;"function" !== typeof c.getDerivedStateFromCatch && e(b);b.props = a.memoizedProps;b.state = a.memoizedState;for (c = 0; c < f.length; c++) {
            d = f[c];var l = d.value,
                g = d.stack;cf(a, d);b.componentDidCatch(l, { componentStack: null !== g ? g : "" });
          }break;
        case 3:
          c = a.updateQueue;null === c || null === c.capturedValues ? D("264") : void 0;f = c.capturedValues;c.capturedValues = null;for (c = 0; c < f.length; c++) {
            d = f[c], cf(a, d), b(d.value);
          }break;default:
          D("265");}
    }, commitAttachRef: function commitAttachRef(a) {
      var b = a.ref;if (null !== b) {
        var c = a.stateNode;switch (a.tag) {case 5:
            a = l(c);break;default:
            a = c;}"function" === typeof b ? b(a) : b.current = a;
      }
    }, commitDetachRef: function commitDetachRef(a) {
      a = a.ref;null !== a && ("function" === typeof a ? a(null) : a.current = null);
    } };
}var ef = {};
function ff(a, b) {
  function c(a) {
    a === ef ? D("174") : void 0;return a;
  }var d = a.getChildHostContext,
      e = a.getRootHostContext;a = b.createCursor;var f = b.push,
      h = b.pop,
      g = a(ef),
      k = a(ef),
      v = a(ef);return { getHostContext: function getHostContext() {
      return c(g.current);
    }, getRootHostContainer: function getRootHostContainer() {
      return c(v.current);
    }, popHostContainer: function popHostContainer(a) {
      h(g, a);h(k, a);h(v, a);
    }, popHostContext: function popHostContext(a) {
      k.current === a && (h(g, a), h(k, a));
    }, pushHostContainer: function pushHostContainer(a, b) {
      f(v, b, a);f(k, a, a);f(g, ef, a);b = e(b);h(g, a);f(g, b, a);
    }, pushHostContext: function pushHostContext(a) {
      var b = c(v.current),
          e = c(g.current);b = d(e, a.type, b);e !== b && (f(k, a, a), f(g, b, a));
    } };
}
function gf(a) {
  function b(a, b) {
    var c = new xe(5, null, null, 0);c.type = "DELETED";c.stateNode = b;c["return"] = a;c.effectTag = 8;null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
  }function c(a, b) {
    switch (a.tag) {case 5:
        return b = f(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;case 6:
        return b = h(b, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;default:
        return !1;}
  }function d(a) {
    for (a = a["return"]; null !== a && 5 !== a.tag && 3 !== a.tag;) {
      a = a["return"];
    }p = a;
  }var e = a.shouldSetTextContent;
  a = a.hydration;if (!a) return { enterHydrationState: function enterHydrationState() {
      return !1;
    }, resetHydrationState: function resetHydrationState() {}, tryToClaimNextHydratableInstance: function tryToClaimNextHydratableInstance() {}, prepareToHydrateHostInstance: function prepareToHydrateHostInstance() {
      D("175");
    }, prepareToHydrateHostTextInstance: function prepareToHydrateHostTextInstance() {
      D("176");
    }, popHydrationState: function popHydrationState() {
      return !1;
    } };var f = a.canHydrateInstance,
      h = a.canHydrateTextInstance,
      g = a.getNextHydratableSibling,
      k = a.getFirstHydratableChild,
      v = a.hydrateInstance,
      l = a.hydrateTextInstance,
      p = null,
      z = null,
      B = !1;return { enterHydrationState: function enterHydrationState(a) {
      z = k(a.stateNode.containerInfo);p = a;return B = !0;
    }, resetHydrationState: function resetHydrationState() {
      z = p = null;B = !1;
    }, tryToClaimNextHydratableInstance: function tryToClaimNextHydratableInstance(a) {
      if (B) {
        var d = z;if (d) {
          if (!c(a, d)) {
            d = g(d);if (!d || !c(a, d)) {
              a.effectTag |= 2;B = !1;p = a;return;
            }b(p, z);
          }p = a;z = k(d);
        } else a.effectTag |= 2, B = !1, p = a;
      }
    }, prepareToHydrateHostInstance: function prepareToHydrateHostInstance(a, b, c) {
      b = v(a.stateNode, a.type, a.memoizedProps, b, c, a);a.updateQueue = b;return null !== b ? !0 : !1;
    }, prepareToHydrateHostTextInstance: function prepareToHydrateHostTextInstance(a) {
      return l(a.stateNode, a.memoizedProps, a);
    }, popHydrationState: function popHydrationState(a) {
      if (a !== p) return !1;if (!B) return d(a), B = !0, !1;var c = a.type;if (5 !== a.tag || "head" !== c && "body" !== c && !e(c, a.memoizedProps)) for (c = z; c;) {
        b(a, c), c = g(c);
      }d(a);z = p ? g(a.stateNode) : null;return !0;
    } };
}
function hf(a) {
  function b(a, b, c) {
    a = a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext = b;a.__reactInternalMemoizedMaskedChildContext = c;
  }function c(a) {
    return 2 === a.tag && null != a.type.childContextTypes;
  }function d(a, b) {
    var c = a.stateNode,
        d = a.type.childContextTypes;if ("function" !== typeof c.getChildContext) return b;c = c.getChildContext();for (var e in c) {
      e in d ? void 0 : D("108", Ac(a) || "Unknown", e);
    }return A({}, b, c);
  }var e = a.createCursor,
      f = a.push,
      h = a.pop,
      g = e(ka),
      k = e(!1),
      v = ka;return { getUnmaskedContext: function getUnmaskedContext(a) {
      return c(a) ? v : g.current;
    }, cacheContext: b, getMaskedContext: function getMaskedContext(a, c) {
      var d = a.type.contextTypes;if (!d) return ka;var e = a.stateNode;if (e && e.__reactInternalMemoizedUnmaskedChildContext === c) return e.__reactInternalMemoizedMaskedChildContext;var f = {},
          g;for (g in d) {
        f[g] = c[g];
      }e && b(a, c, f);return f;
    }, hasContextChanged: function hasContextChanged() {
      return k.current;
    }, isContextConsumer: function isContextConsumer(a) {
      return 2 === a.tag && null != a.type.contextTypes;
    }, isContextProvider: c, popContextProvider: function popContextProvider(a) {
      c(a) && (h(k, a), h(g, a));
    }, popTopLevelContextObject: function popTopLevelContextObject(a) {
      h(k, a);h(g, a);
    }, pushTopLevelContextObject: function pushTopLevelContextObject(a, b, c) {
      null != g.cursor ? D("168") : void 0;f(g, b, a);f(k, c, a);
    }, processChildContext: d, pushContextProvider: function pushContextProvider(a) {
      if (!c(a)) return !1;var b = a.stateNode;b = b && b.__reactInternalMemoizedMergedChildContext || ka;v = g.current;f(g, b, a);f(k, k.current, a);return !0;
    }, invalidateContextProvider: function invalidateContextProvider(a, b) {
      var c = a.stateNode;c ? void 0 : D("169");if (b) {
        var e = d(a, v);c.__reactInternalMemoizedMergedChildContext = e;h(k, a);h(g, a);f(g, e, a);
      } else h(k, a);f(k, b, a);
    }, findCurrentUnmaskedContext: function findCurrentUnmaskedContext(a) {
      for (2 !== xd(a) || 2 !== a.tag ? D("170") : void 0; 3 !== a.tag;) {
        if (c(a)) return a.stateNode.__reactInternalMemoizedMergedChildContext;(a = a["return"]) ? void 0 : D("171");
      }return a.stateNode.context;
    } };
}
function jf(a) {
  var b = a.createCursor,
      c = a.push,
      d = a.pop,
      e = b(null),
      f = b(null),
      h = b(0);return { pushProvider: function pushProvider(a) {
      var b = a.type._context;c(h, b._changedBits, a);c(f, b._currentValue, a);c(e, a, a);b._currentValue = a.pendingProps.value;b._changedBits = a.stateNode;
    }, popProvider: function popProvider(a) {
      var b = h.current,
          c = f.current;d(e, a);d(f, a);d(h, a);a = a.type._context;a._currentValue = c;a._changedBits = b;
    } };
}
function kf() {
  var a = [],
      b = -1;return { createCursor: function createCursor(a) {
      return { current: a };
    }, isEmpty: function isEmpty() {
      return -1 === b;
    }, pop: function pop(c) {
      0 > b || (c.current = a[b], a[b] = null, b--);
    }, push: function push(c, d) {
      b++;a[b] = c.current;c.current = d;
    }, checkThatStackIsEmpty: function checkThatStackIsEmpty() {}, resetStackAfterFatalErrorInDev: function resetStackAfterFatalErrorInDev() {} };
}
function lf(a) {
  function b() {
    if (null !== I) for (var a = I["return"]; null !== a;) {
      Lc(a), a = a["return"];
    }Ya = null;Z = 0;I = null;Nc = !1;
  }function c(a) {
    return null !== ya && ya.has(a);
  }function d(a) {
    for (;;) {
      var b = a.alternate,
          c = a["return"],
          d = a.sibling;if (0 === (a.effectTag & 512)) {
        b = Cb(b, a, Z);var e = a;if (1073741823 === Z || 1073741823 !== e.expirationTime) {
          b: switch (e.tag) {case 3:case 2:
              var f = e.updateQueue;f = null === f ? 0 : f.expirationTime;break b;default:
              f = 0;}for (var g = e.child; null !== g;) {
            0 !== g.expirationTime && (0 === f || f > g.expirationTime) && (f = g.expirationTime), g = g.sibling;
          }e.expirationTime = f;
        }if (null !== b) return b;null !== c && 0 === (c.effectTag & 512) && (null === c.firstEffect && (c.firstEffect = a.firstEffect), null !== a.lastEffect && (null !== c.lastEffect && (c.lastEffect.nextEffect = a.firstEffect), c.lastEffect = a.lastEffect), 1 < a.effectTag && (null !== c.lastEffect ? c.lastEffect.nextEffect = a : c.firstEffect = a, c.lastEffect = a));if (null !== d) return d;if (null !== c) a = c;else {
          Nc = !0;break;
        }
      } else {
        a = Kc(a);if (null !== a) return a.effectTag &= 2559, a;null !== c && (c.firstEffect = c.lastEffect = null, c.effectTag |= 512);if (null !== d) return d;if (null !== c) a = c;else break;
      }
    }return null;
  }function e(a) {
    var b = Wa(a.alternate, a, Z);null === b && (b = d(a));nc.current = null;return b;
  }function f(a, c, f) {
    ca ? D("243") : void 0;ca = !0;if (c !== Z || a !== Ya || null === I) b(), Ya = a, Z = c, I = ze(Ya.current, null, Z), a.pendingCommitExpirationTime = 0;var g = !1;do {
      try {
        if (f) for (; null !== I && !S();) {
          I = e(I);
        } else for (; null !== I;) {
          I = e(I);
        }
      } catch (Oc) {
        if (null === I) {
          g = !0;q(Oc);break;
        }f = I;var h = f["return"];if (null === h) {
          g = !0;q(Oc);break;
        }Jc(h, f, Oc);I = d(f);
      }break;
    } while (1);
    ca = !1;if (g || null !== I) return null;if (Nc) return a.pendingCommitExpirationTime = c, a.current.alternate;D("262");
  }function h(a, b, c, d) {
    a = { value: c, source: a, stack: Bc(a) };Pe(b, { expirationTime: d, partialState: null, callback: null, isReplace: !1, isForced: !1, capturedValue: a, next: null });v(b, d);
  }function g(a, b) {
    a: {
      ca && !Za ? D("263") : void 0;for (var d = a["return"]; null !== d;) {
        switch (d.tag) {case 2:
            var e = d.stateNode;if ("function" === typeof d.type.getDerivedStateFromCatch || "function" === typeof e.componentDidCatch && !c(e)) {
              h(a, d, b, 1);a = void 0;break a;
            }break;case 3:
            h(a, d, b, 1);a = void 0;break a;}d = d["return"];
      }3 === a.tag && h(a, a, b, 1);a = void 0;
    }return a;
  }function k(a) {
    a = 0 !== ia ? ia : ca ? Za ? 1 : Z : a.mode & 1 ? za ? 10 * (((l() + 15) / 10 | 0) + 1) : 25 * (((l() + 500) / 25 | 0) + 1) : 1;za && (0 === da || a > da) && (da = a);return a;
  }function v(a, c) {
    a: {
      for (; null !== a;) {
        if (0 === a.expirationTime || a.expirationTime > c) a.expirationTime = c;null !== a.alternate && (0 === a.alternate.expirationTime || a.alternate.expirationTime > c) && (a.alternate.expirationTime = c);if (null === a["return"]) if (3 === a.tag) {
          var d = a.stateNode;!ca && 0 !== Z && c < Z && b();ca && !Za && Ya === d || B(d, c);Fb > xg && D("185");
        } else {
          c = void 0;break a;
        }a = a["return"];
      }c = void 0;
    }return c;
  }function l() {
    ye = Ic() - Pc;return yg = (ye / 10 | 0) + 2;
  }function p(a, b, c, d, e) {
    var f = ia;ia = 1;try {
      return a(b, c, d, e);
    } finally {
      ia = f;
    }
  }function z(a) {
    if (0 !== Gb) {
      if (a > Gb) return;mg(Qc);
    }var b = Ic() - Pc;Gb = a;Qc = lg(Q, { timeout: 10 * (a - 2) - b });
  }function B(a, b) {
    if (null === a.nextScheduledRoot) a.remainingExpirationTime = b, null === K ? (la = K = a, a.nextScheduledRoot = a) : (K = K.nextScheduledRoot = a, K.nextScheduledRoot = la);else {
      var c = a.remainingExpirationTime;if (0 === c || b < c) a.remainingExpirationTime = b;
    }T || (J ? Hb && (aa = a, P = 1, G(a, 1, !1)) : 1 === b ? n() : z(b));
  }function r() {
    var a = 0,
        b = null;if (null !== K) for (var c = K, d = la; null !== d;) {
      var e = d.remainingExpirationTime;if (0 === e) {
        null === c || null === K ? D("244") : void 0;if (d === d.nextScheduledRoot) {
          la = K = d.nextScheduledRoot = null;break;
        } else if (d === la) la = e = d.nextScheduledRoot, K.nextScheduledRoot = e, d.nextScheduledRoot = null;else if (d === K) {
          K = c;K.nextScheduledRoot = la;d.nextScheduledRoot = null;break;
        } else c.nextScheduledRoot = d.nextScheduledRoot, d.nextScheduledRoot = null;d = c.nextScheduledRoot;
      } else {
        if (0 === a || e < a) a = e, b = d;if (d === K) break;c = d;d = d.nextScheduledRoot;
      }
    }c = aa;null !== c && c === b && 1 === a ? Fb++ : Fb = 0;aa = b;P = a;
  }function Q(a) {
    x(0, !0, a);
  }function n() {
    x(1, !1, null);
  }function x(a, b, c) {
    $a = c;r();if (b) for (; null !== aa && 0 !== P && (0 === a || a >= P) && (!Ib || l() >= P);) {
      G(aa, P, !Ib), r();
    } else for (; null !== aa && 0 !== P && (0 === a || a >= P);) {
      G(aa, P, !1), r();
    }null !== $a && (Gb = 0, Qc = -1);0 !== P && z(P);$a = null;Ib = !1;Y();
  }function Y() {
    Fb = 0;if (null !== Aa) {
      var a = Aa;Aa = null;for (var b = 0; b < a.length; b++) {
        var c = a[b];try {
          c._onComplete();
        } catch (wg) {
          Ba || (Ba = !0, Jb = wg);
        }
      }
    }if (Ba) throw a = Jb, Jb = null, Ba = !1, a;
  }function G(a, b, c) {
    T ? D("245") : void 0;T = !0;c ? (c = a.finishedWork, null !== c ? R(a, c, b) : (a.finishedWork = null, c = f(a, b, !0), null !== c && (S() ? a.finishedWork = c : R(a, c, b)))) : (c = a.finishedWork, null !== c ? R(a, c, b) : (a.finishedWork = null, c = f(a, b, !1), null !== c && R(a, c, b)));T = !1;
  }function R(a, b, c) {
    var d = a.firstBatch;if (null !== d && d._expirationTime <= c && (null === Aa ? Aa = [d] : Aa.push(d), d._defer)) {
      a.finishedWork = b;a.remainingExpirationTime = 0;return;
    }a.finishedWork = null;Za = ca = !0;c = b.stateNode;c.current === b ? D("177") : void 0;d = c.pendingCommitExpirationTime;0 === d ? D("261") : void 0;c.pendingCommitExpirationTime = 0;var e = l();nc.current = null;if (1 < b.effectTag) {
      if (null !== b.lastEffect) {
        b.lastEffect.nextEffect = b;var f = b.firstEffect;
      } else f = b;
    } else f = b.firstEffect;zg(c.containerInfo);for (w = f; null !== w;) {
      var h = !1,
          k = void 0;try {
        for (; null !== w;) {
          w.effectTag & 2048 && Db(w.alternate, w), w = w.nextEffect;
        }
      } catch (ab) {
        h = !0, k = ab;
      }h && (null === w ? D("178") : void 0, g(w, k), null !== w && (w = w.nextEffect));
    }for (w = f; null !== w;) {
      h = !1;k = void 0;try {
        for (; null !== w;) {
          var p = w.effectTag;p & 16 && Mc(w);if (p & 128) {
            var n = w.alternate;null !== n && kg(n);
          }switch (p & 14) {case 2:
              Eb(w);w.effectTag &= -3;break;case 6:
              Eb(w);w.effectTag &= -3;we(w.alternate, w);break;case 4:
              we(w.alternate, w);break;case 8:
              gg(w);}w = w.nextEffect;
        }
      } catch (ab) {
        h = !0, k = ab;
      }h && (null === w ? D("178") : void 0, g(w, k), null !== w && (w = w.nextEffect));
    }Ag(c.containerInfo);c.current = b;for (w = f; null !== w;) {
      p = !1;n = void 0;try {
        for (f = c, h = e, k = d; null !== w;) {
          var r = w.effectTag;
          r & 36 && hg(f, w.alternate, w, h, k);r & 256 && ig(w, q);r & 128 && jg(w);var t = w.nextEffect;w.nextEffect = null;w = t;
        }
      } catch (ab) {
        p = !0, n = ab;
      }p && (null === w ? D("178") : void 0, g(w, n), null !== w && (w = w.nextEffect));
    }ca = Za = !1;"function" === typeof Ie && Ie(b.stateNode);b = c.current.expirationTime;0 === b && (ya = null);a.remainingExpirationTime = b;
  }function S() {
    return null === $a || $a.timeRemaining() > Bg ? !1 : Ib = !0;
  }function q(a) {
    null === aa ? D("246") : void 0;aa.remainingExpirationTime = 0;Ba || (Ba = !0, Jb = a);
  }var u = kf(),
      t = ff(a, u),
      y = hf(u);u = jf(u);var H = gf(a),
      Wa = $e(a, t, y, u, H, v, k).beginWork,
      Cb = af(a, t, y, u, H).completeWork;t = bf(t, y, u, v, c);var Jc = t.throwException,
      Kc = t.unwindWork,
      Lc = t.unwindInterruptedWork;t = df(a, g, v, k, function (a) {
    null === ya ? ya = new Set([a]) : ya.add(a);
  }, l);var Db = t.commitBeforeMutationLifeCycles,
      Mc = t.commitResetTextContent,
      Eb = t.commitPlacement,
      gg = t.commitDeletion,
      we = t.commitWork,
      hg = t.commitLifeCycles,
      ig = t.commitErrorLogging,
      jg = t.commitAttachRef,
      kg = t.commitDetachRef,
      Ic = a.now,
      lg = a.scheduleDeferredCallback,
      mg = a.cancelDeferredCallback,
      zg = a.prepareForCommit,
      Ag = a.resetAfterCommit,
      Pc = Ic(),
      yg = 2,
      ye = Pc,
      Rc = 0,
      ia = 0,
      ca = !1,
      I = null,
      Ya = null,
      Z = 0,
      w = null,
      Za = !1,
      Nc = !1,
      ya = null,
      la = null,
      K = null,
      Gb = 0,
      Qc = -1,
      T = !1,
      aa = null,
      P = 0,
      da = 0,
      Ib = !1,
      Ba = !1,
      Jb = null,
      $a = null,
      J = !1,
      Hb = !1,
      za = !1,
      Aa = null,
      xg = 1E3,
      Fb = 0,
      Bg = 1;return { recalculateCurrentTime: l, computeExpirationForFiber: k, scheduleWork: v, requestWork: B, flushRoot: function flushRoot(a, b) {
      T ? D("253") : void 0;aa = a;P = b;G(a, b, !1);n();Y();
    }, batchedUpdates: function batchedUpdates(a, b) {
      var c = J;J = !0;try {
        return a(b);
      } finally {
        (J = c) || T || n();
      }
    }, unbatchedUpdates: function unbatchedUpdates(a, b) {
      if (J && !Hb) {
        Hb = !0;try {
          return a(b);
        } finally {
          Hb = !1;
        }
      }return a(b);
    }, flushSync: function flushSync(a, b) {
      T ? D("187") : void 0;var c = J;J = !0;try {
        return p(a, b);
      } finally {
        J = c, n();
      }
    }, flushControlled: function flushControlled(a) {
      var b = J;J = !0;try {
        p(a);
      } finally {
        (J = b) || T || x(1, !1, null);
      }
    }, deferredUpdates: function deferredUpdates(a) {
      var b = ia;ia = 25 * (((l() + 500) / 25 | 0) + 1);try {
        return a();
      } finally {
        ia = b;
      }
    }, syncUpdates: p, interactiveUpdates: function interactiveUpdates(a, b, c) {
      if (za) return a(b, c);J || T || 0 === da || (x(da, !1, null), da = 0);var d = za,
          e = J;J = za = !0;try {
        return a(b, c);
      } finally {
        za = d, (J = e) || T || n();
      }
    }, flushInteractiveUpdates: function flushInteractiveUpdates() {
      T || 0 === da || (x(da, !1, null), da = 0);
    }, computeUniqueAsyncExpiration: function computeUniqueAsyncExpiration() {
      var a = 25 * (((l() + 500) / 25 | 0) + 1);a <= Rc && (a = Rc + 1);return Rc = a;
    }, legacyContext: y };
}
function mf(a) {
  function b(a, b, c, d, e, h) {
    d = b.current;if (c) {
      c = c._reactInternalFiber;var l = g(c);c = k(c) ? v(c, l) : l;
    } else c = ka;null === b.context ? b.context = c : b.pendingContext = c;b = h;Pe(d, { expirationTime: e, partialState: { element: a }, callback: void 0 === b ? null : b, isReplace: !1, isForced: !1, capturedValue: null, next: null });f(d, e);return e;
  }var c = a.getPublicInstance;a = lf(a);var d = a.recalculateCurrentTime,
      e = a.computeExpirationForFiber,
      f = a.scheduleWork,
      h = a.legacyContext,
      g = h.findCurrentUnmaskedContext,
      k = h.isContextProvider,
      v = h.processChildContext;return { createContainer: function createContainer(a, b, c) {
      b = new xe(3, null, null, b ? 3 : 0);a = { current: b, containerInfo: a, pendingChildren: null, pendingCommitExpirationTime: 0, finishedWork: null, context: null, pendingContext: null, hydrate: c, remainingExpirationTime: 0, firstBatch: null, nextScheduledRoot: null };return b.stateNode = a;
    }, updateContainer: function updateContainer(a, c, f, h) {
      var g = c.current,
          k = d();g = e(g);return b(a, c, f, k, g, h);
    }, updateContainerAtExpirationTime: function updateContainerAtExpirationTime(a, c, e, f, g) {
      var h = d();return b(a, c, e, h, f, g);
    }, flushRoot: a.flushRoot,
    requestWork: a.requestWork, computeUniqueAsyncExpiration: a.computeUniqueAsyncExpiration, batchedUpdates: a.batchedUpdates, unbatchedUpdates: a.unbatchedUpdates, deferredUpdates: a.deferredUpdates, syncUpdates: a.syncUpdates, interactiveUpdates: a.interactiveUpdates, flushInteractiveUpdates: a.flushInteractiveUpdates, flushControlled: a.flushControlled, flushSync: a.flushSync, getPublicRootInstance: function getPublicRootInstance(a) {
      a = a.current;if (!a.child) return null;switch (a.child.tag) {case 5:
          return c(a.child.stateNode);default:
          return a.child.stateNode;}
    },
    findHostInstance: function findHostInstance(a) {
      var b = a._reactInternalFiber;void 0 === b && ("function" === typeof a.render ? D("188") : D("268", Object.keys(a)));a = Bd(b);return null === a ? null : a.stateNode;
    }, findHostInstanceWithNoPortals: function findHostInstanceWithNoPortals(a) {
      a = Cd(a);return null === a ? null : a.stateNode;
    }, injectIntoDevTools: function injectIntoDevTools(a) {
      var b = a.findFiberByHostInstance;return He(A({}, a, { findHostInstanceByFiber: function findHostInstanceByFiber(a) {
          a = Bd(a);return null === a ? null : a.stateNode;
        }, findFiberByHostInstance: function findFiberByHostInstance(a) {
          return b ? b(a) : null;
        } }));
    } };
}
var nf = Object.freeze({ default: mf }),
    of = nf && mf || nf,
    pf = of["default"] ? of["default"] : of;function qf(a, b, c) {
  var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;return { $$typeof: rc, key: null == d ? null : "" + d, children: a, containerInfo: b, implementation: c };
}var rf = "object" === (typeof performance === "undefined" ? "undefined" : _typeof(performance)) && "function" === typeof performance.now,
    sf = void 0;sf = rf ? function () {
  return performance.now();
} : function () {
  return Date.now();
};var tf = void 0,
    uf = void 0;
if (m.canUseDOM) {
  if ("function" !== typeof requestIdleCallback || "function" !== typeof cancelIdleCallback) {
    var vf = null,
        wf = !1,
        xf = -1,
        yf = !1,
        zf = 0,
        Af = 33,
        Bf = 33,
        Cf = void 0;Cf = rf ? { didTimeout: !1, timeRemaining: function timeRemaining() {
        var a = zf - performance.now();return 0 < a ? a : 0;
      } } : { didTimeout: !1, timeRemaining: function timeRemaining() {
        var a = zf - Date.now();return 0 < a ? a : 0;
      } };var Df = "__reactIdleCallback$" + Math.random().toString(36).slice(2);window.addEventListener("message", function (a) {
      if (a.source === window && a.data === Df) {
        wf = !1;a = sf();if (0 >= zf - a) {
          if (-1 !== xf && xf <= a) Cf.didTimeout = !0;else {
            yf || (yf = !0, requestAnimationFrame(Ef));return;
          }
        } else Cf.didTimeout = !1;xf = -1;a = vf;vf = null;null !== a && a(Cf);
      }
    }, !1);var Ef = function Ef(a) {
      yf = !1;var b = a - zf + Bf;b < Bf && Af < Bf ? (8 > b && (b = 8), Bf = b < Af ? Af : b) : Af = b;zf = a + Bf;wf || (wf = !0, window.postMessage(Df, "*"));
    };tf = function tf(a, b) {
      vf = a;null != b && "number" === typeof b.timeout && (xf = sf() + b.timeout);yf || (yf = !0, requestAnimationFrame(Ef));return 0;
    };uf = function uf() {
      vf = null;wf = !1;xf = -1;
    };
  } else tf = window.requestIdleCallback, uf = window.cancelIdleCallback;
} else tf = function tf(a) {
  return setTimeout(function () {
    a({ timeRemaining: function timeRemaining() {
        return Infinity;
      }, didTimeout: !1 });
  });
}, uf = function uf(a) {
  clearTimeout(a);
};function Ff(a) {
  var b = "";ea.Children.forEach(a, function (a) {
    null == a || "string" !== typeof a && "number" !== typeof a || (b += a);
  });return b;
}function Gf(a, b) {
  a = A({ children: void 0 }, b);if (b = Ff(b.children)) a.children = b;return a;
}
function Hf(a, b, c, d) {
  a = a.options;if (b) {
    b = {};for (var e = 0; e < c.length; e++) {
      b["$" + c[e]] = !0;
    }for (c = 0; c < a.length; c++) {
      e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    }
  } else {
    c = "" + c;b = null;for (e = 0; e < a.length; e++) {
      if (a[e].value === c) {
        a[e].selected = !0;d && (a[e].defaultSelected = !0);return;
      }null !== b || a[e].disabled || (b = a[e]);
    }null !== b && (b.selected = !0);
  }
}
function If(a, b) {
  var c = b.value;a._wrapperState = { initialValue: null != c ? c : b.defaultValue, wasMultiple: !!b.multiple };
}function Jf(a, b) {
  null != b.dangerouslySetInnerHTML ? D("91") : void 0;return A({}, b, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });
}function Kf(a, b) {
  var c = b.value;null == c && (c = b.defaultValue, b = b.children, null != b && (null != c ? D("92") : void 0, Array.isArray(b) && (1 >= b.length ? void 0 : D("93"), b = b[0]), c = "" + b), null == c && (c = ""));a._wrapperState = { initialValue: "" + c };
}
function Lf(a, b) {
  var c = b.value;null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && (a.defaultValue = c));null != b.defaultValue && (a.defaultValue = b.defaultValue);
}function Mf(a) {
  var b = a.textContent;b === a._wrapperState.initialValue && (a.value = b);
}var Nf = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
function Of(a) {
  switch (a) {case "svg":
      return "http://www.w3.org/2000/svg";case "math":
      return "http://www.w3.org/1998/Math/MathML";default:
      return "http://www.w3.org/1999/xhtml";}
}function Pf(a, b) {
  return null == a || "http://www.w3.org/1999/xhtml" === a ? Of(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Qf = void 0,
    Rf = function (a) {
  return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {
    MSApp.execUnsafeLocalFunction(function () {
      return a(b, c, d, e);
    });
  } : a;
}(function (a, b) {
  if (a.namespaceURI !== Nf.svg || "innerHTML" in a) a.innerHTML = b;else {
    Qf = Qf || document.createElement("div");Qf.innerHTML = "\x3csvg\x3e" + b + "\x3c/svg\x3e";for (b = Qf.firstChild; a.firstChild;) {
      a.removeChild(a.firstChild);
    }for (; b.firstChild;) {
      a.appendChild(b.firstChild);
    }
  }
});
function Sf(a, b) {
  if (b) {
    var c = a.firstChild;if (c && c === a.lastChild && 3 === c.nodeType) {
      c.nodeValue = b;return;
    }
  }a.textContent = b;
}
var Tf = { animationIterationCount: !0, borderImageOutset: !0, borderImageSlice: !0, borderImageWidth: !0, boxFlex: !0, boxFlexGroup: !0, boxOrdinalGroup: !0, columnCount: !0, columns: !0, flex: !0, flexGrow: !0, flexPositive: !0, flexShrink: !0, flexNegative: !0, flexOrder: !0, gridRow: !0, gridRowEnd: !0, gridRowSpan: !0, gridRowStart: !0, gridColumn: !0, gridColumnEnd: !0, gridColumnSpan: !0, gridColumnStart: !0, fontWeight: !0, lineClamp: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, tabSize: !0, widows: !0, zIndex: !0, zoom: !0, fillOpacity: !0, floodOpacity: !0,
  stopOpacity: !0, strokeDasharray: !0, strokeDashoffset: !0, strokeMiterlimit: !0, strokeOpacity: !0, strokeWidth: !0 },
    Uf = ["Webkit", "ms", "Moz", "O"];Object.keys(Tf).forEach(function (a) {
  Uf.forEach(function (b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);Tf[b] = Tf[a];
  });
});
function Vf(a, b) {
  a = a.style;for (var c in b) {
    if (b.hasOwnProperty(c)) {
      var d = 0 === c.indexOf("--");var e = c;var f = b[c];e = null == f || "boolean" === typeof f || "" === f ? "" : d || "number" !== typeof f || 0 === f || Tf.hasOwnProperty(e) && Tf[e] ? ("" + f).trim() : f + "px";"float" === c && (c = "cssFloat");d ? a.setProperty(c, e) : a[c] = e;
    }
  }
}var Wf = A({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
function Xf(a, b, c) {
  b && (Wf[a] && (null != b.children || null != b.dangerouslySetInnerHTML ? D("137", a, c()) : void 0), null != b.dangerouslySetInnerHTML && (null != b.children ? D("60") : void 0, "object" === _typeof(b.dangerouslySetInnerHTML) && "__html" in b.dangerouslySetInnerHTML ? void 0 : D("61")), null != b.style && "object" !== _typeof(b.style) ? D("62", c()) : void 0);
}
function Yf(a, b) {
  if (-1 === a.indexOf("-")) return "string" === typeof b.is;switch (a) {case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":
      return !1;default:
      return !0;}
}var Zf = C.thatReturns("");
function $f(a, b) {
  a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;var c = ke(a);b = va[b];for (var d = 0; d < b.length; d++) {
    var e = b[d];c.hasOwnProperty(e) && c[e] || ("topScroll" === e ? Zd("topScroll", "scroll", a) : "topFocus" === e || "topBlur" === e ? (Zd("topFocus", "focus", a), Zd("topBlur", "blur", a), c.topBlur = !0, c.topFocus = !0) : "topCancel" === e ? (ic("cancel", !0) && Zd("topCancel", "cancel", a), c.topCancel = !0) : "topClose" === e ? (ic("close", !0) && Zd("topClose", "close", a), c.topClose = !0) : fe.hasOwnProperty(e) && W(e, fe[e], a), c[e] = !0);
  }
}
function ag(a, b, c, d) {
  c = 9 === c.nodeType ? c : c.ownerDocument;d === Nf.html && (d = Of(a));d === Nf.html ? "script" === a ? (a = c.createElement("div"), a.innerHTML = "\x3cscript\x3e\x3c/script\x3e", a = a.removeChild(a.firstChild)) : a = "string" === typeof b.is ? c.createElement(a, { is: b.is }) : c.createElement(a) : a = c.createElementNS(d, a);return a;
}function bg(a, b) {
  return (9 === b.nodeType ? b : b.ownerDocument).createTextNode(a);
}
function cg(a, b, c, d) {
  var e = Yf(b, c);switch (b) {case "iframe":case "object":
      W("topLoad", "load", a);var f = c;break;case "video":case "audio":
      for (f in ge) {
        ge.hasOwnProperty(f) && W(f, ge[f], a);
      }f = c;break;case "source":
      W("topError", "error", a);f = c;break;case "img":case "image":case "link":
      W("topError", "error", a);W("topLoad", "load", a);f = c;break;case "form":
      W("topReset", "reset", a);W("topSubmit", "submit", a);f = c;break;case "details":
      W("topToggle", "toggle", a);f = c;break;case "input":
      Wc(a, c);f = Vc(a, c);W("topInvalid", "invalid", a);$f(d, "onChange");break;case "option":
      f = Gf(a, c);break;case "select":
      If(a, c);f = A({}, c, { value: void 0 });W("topInvalid", "invalid", a);$f(d, "onChange");break;case "textarea":
      Kf(a, c);f = Jf(a, c);W("topInvalid", "invalid", a);$f(d, "onChange");break;default:
      f = c;}Xf(b, f, Zf);var h = f,
      g;for (g in h) {
    if (h.hasOwnProperty(g)) {
      var k = h[g];"style" === g ? Vf(a, k, Zf) : "dangerouslySetInnerHTML" === g ? (k = k ? k.__html : void 0, null != k && Rf(a, k)) : "children" === g ? "string" === typeof k ? ("textarea" !== b || "" !== k) && Sf(a, k) : "number" === typeof k && Sf(a, "" + k) : "suppressContentEditableWarning" !== g && "suppressHydrationWarning" !== g && "autoFocus" !== g && (ua.hasOwnProperty(g) ? null != k && $f(d, g) : null != k && Uc(a, g, k, e));
    }
  }switch (b) {case "input":
      lc(a);ad(a, c);break;case "textarea":
      lc(a);Mf(a, c);break;case "option":
      null != c.value && a.setAttribute("value", c.value);break;case "select":
      a.multiple = !!c.multiple;b = c.value;null != b ? Hf(a, !!c.multiple, b, !1) : null != c.defaultValue && Hf(a, !!c.multiple, c.defaultValue, !0);break;default:
      "function" === typeof f.onClick && (a.onclick = C);}
}
function dg(a, b, c, d, e) {
  var f = null;switch (b) {case "input":
      c = Vc(a, c);d = Vc(a, d);f = [];break;case "option":
      c = Gf(a, c);d = Gf(a, d);f = [];break;case "select":
      c = A({}, c, { value: void 0 });d = A({}, d, { value: void 0 });f = [];break;case "textarea":
      c = Jf(a, c);d = Jf(a, d);f = [];break;default:
      "function" !== typeof c.onClick && "function" === typeof d.onClick && (a.onclick = C);}Xf(b, d, Zf);b = a = void 0;var h = null;for (a in c) {
    if (!d.hasOwnProperty(a) && c.hasOwnProperty(a) && null != c[a]) if ("style" === a) {
      var g = c[a];for (b in g) {
        g.hasOwnProperty(b) && (h || (h = {}), h[b] = "");
      }
    } else "dangerouslySetInnerHTML" !== a && "children" !== a && "suppressContentEditableWarning" !== a && "suppressHydrationWarning" !== a && "autoFocus" !== a && (ua.hasOwnProperty(a) ? f || (f = []) : (f = f || []).push(a, null));
  }for (a in d) {
    var k = d[a];g = null != c ? c[a] : void 0;if (d.hasOwnProperty(a) && k !== g && (null != k || null != g)) if ("style" === a) {
      if (g) {
        for (b in g) {
          !g.hasOwnProperty(b) || k && k.hasOwnProperty(b) || (h || (h = {}), h[b] = "");
        }for (b in k) {
          k.hasOwnProperty(b) && g[b] !== k[b] && (h || (h = {}), h[b] = k[b]);
        }
      } else h || (f || (f = []), f.push(a, h)), h = k;
    } else "dangerouslySetInnerHTML" === a ? (k = k ? k.__html : void 0, g = g ? g.__html : void 0, null != k && g !== k && (f = f || []).push(a, "" + k)) : "children" === a ? g === k || "string" !== typeof k && "number" !== typeof k || (f = f || []).push(a, "" + k) : "suppressContentEditableWarning" !== a && "suppressHydrationWarning" !== a && (ua.hasOwnProperty(a) ? (null != k && $f(e, a), f || g === k || (f = [])) : (f = f || []).push(a, k));
  }h && (f = f || []).push("style", h);return f;
}
function eg(a, b, c, d, e) {
  "input" === c && "radio" === e.type && null != e.name && Yc(a, e);Yf(c, d);d = Yf(c, e);for (var f = 0; f < b.length; f += 2) {
    var h = b[f],
        g = b[f + 1];"style" === h ? Vf(a, g, Zf) : "dangerouslySetInnerHTML" === h ? Rf(a, g) : "children" === h ? Sf(a, g) : Uc(a, h, g, d);
  }switch (c) {case "input":
      Zc(a, e);break;case "textarea":
      Lf(a, e);break;case "select":
      a._wrapperState.initialValue = void 0, b = a._wrapperState.wasMultiple, a._wrapperState.wasMultiple = !!e.multiple, c = e.value, null != c ? Hf(a, !!e.multiple, c, !1) : b !== !!e.multiple && (null != e.defaultValue ? Hf(a, !!e.multiple, e.defaultValue, !0) : Hf(a, !!e.multiple, e.multiple ? [] : "", !1));}
}
function fg(a, b, c, d, e) {
  switch (b) {case "iframe":case "object":
      W("topLoad", "load", a);break;case "video":case "audio":
      for (var f in ge) {
        ge.hasOwnProperty(f) && W(f, ge[f], a);
      }break;case "source":
      W("topError", "error", a);break;case "img":case "image":case "link":
      W("topError", "error", a);W("topLoad", "load", a);break;case "form":
      W("topReset", "reset", a);W("topSubmit", "submit", a);break;case "details":
      W("topToggle", "toggle", a);break;case "input":
      Wc(a, c);W("topInvalid", "invalid", a);$f(e, "onChange");break;case "select":
      If(a, c);W("topInvalid", "invalid", a);$f(e, "onChange");break;case "textarea":
      Kf(a, c), W("topInvalid", "invalid", a), $f(e, "onChange");}Xf(b, c, Zf);d = null;for (var h in c) {
    c.hasOwnProperty(h) && (f = c[h], "children" === h ? "string" === typeof f ? a.textContent !== f && (d = ["children", f]) : "number" === typeof f && a.textContent !== "" + f && (d = ["children", "" + f]) : ua.hasOwnProperty(h) && null != f && $f(e, h));
  }switch (b) {case "input":
      lc(a);ad(a, c);break;case "textarea":
      lc(a);Mf(a, c);break;case "select":case "option":
      break;default:
      "function" === typeof c.onClick && (a.onclick = C);}return d;
}function ng(a, b) {
  return a.nodeValue !== b;
}
var og = Object.freeze({ createElement: ag, createTextNode: bg, setInitialProperties: cg, diffProperties: dg, updateProperties: eg, diffHydratedProperties: fg, diffHydratedText: ng, warnForUnmatchedText: function warnForUnmatchedText() {}, warnForDeletedHydratableElement: function warnForDeletedHydratableElement() {}, warnForDeletedHydratableText: function warnForDeletedHydratableText() {}, warnForInsertedHydratedElement: function warnForInsertedHydratedElement() {}, warnForInsertedHydratedText: function warnForInsertedHydratedText() {}, restoreControlledState: function restoreControlledState(a, b, c) {
    switch (b) {case "input":
        Zc(a, c);b = c.name;if ("radio" === c.type && null != b) {
          for (c = a; c.parentNode;) {
            c = c.parentNode;
          }c = c.querySelectorAll("input[name\x3d" + JSON.stringify("" + b) + '][type\x3d"radio"]');for (b = 0; b < c.length; b++) {
            var d = c[b];if (d !== a && d.form === a.form) {
              var e = Xa(d);e ? void 0 : D("90");mc(d);Zc(d, e);
            }
          }
        }break;case "textarea":
        Lf(a, c);break;case "select":
        b = c.value, null != b && Hf(a, !!c.multiple, b, !1);}
  } });Tb.injectFiberControlledHostComponent(og);var pg = null,
    qg = null;
function rg(a) {
  this._expirationTime = X.computeUniqueAsyncExpiration();this._root = a;this._callbacks = this._next = null;this._hasChildren = this._didComplete = !1;this._children = null;this._defer = !0;
}rg.prototype.render = function (a) {
  this._defer ? void 0 : D("250");this._hasChildren = !0;this._children = a;var b = this._root._internalRoot,
      c = this._expirationTime,
      d = new sg();X.updateContainerAtExpirationTime(a, b, null, c, d._onCommit);return d;
};
rg.prototype.then = function (a) {
  if (this._didComplete) a();else {
    var b = this._callbacks;null === b && (b = this._callbacks = []);b.push(a);
  }
};
rg.prototype.commit = function () {
  var a = this._root._internalRoot,
      b = a.firstBatch;this._defer && null !== b ? void 0 : D("251");if (this._hasChildren) {
    var c = this._expirationTime;if (b !== this) {
      this._hasChildren && (c = this._expirationTime = b._expirationTime, this.render(this._children));for (var d = null, e = b; e !== this;) {
        d = e, e = e._next;
      }null === d ? D("251") : void 0;d._next = e._next;this._next = b;a.firstBatch = this;
    }this._defer = !1;X.flushRoot(a, c);b = this._next;this._next = null;b = a.firstBatch = b;null !== b && b._hasChildren && b.render(b._children);
  } else this._next = null, this._defer = !1;
};rg.prototype._onComplete = function () {
  if (!this._didComplete) {
    this._didComplete = !0;var a = this._callbacks;if (null !== a) for (var b = 0; b < a.length; b++) {
      (0, a[b])();
    }
  }
};function sg() {
  this._callbacks = null;this._didCommit = !1;this._onCommit = this._onCommit.bind(this);
}sg.prototype.then = function (a) {
  if (this._didCommit) a();else {
    var b = this._callbacks;null === b && (b = this._callbacks = []);b.push(a);
  }
};
sg.prototype._onCommit = function () {
  if (!this._didCommit) {
    this._didCommit = !0;var a = this._callbacks;if (null !== a) for (var b = 0; b < a.length; b++) {
      var c = a[b];"function" !== typeof c ? D("191", c) : void 0;c();
    }
  }
};function tg(a, b, c) {
  this._internalRoot = X.createContainer(a, b, c);
}tg.prototype.render = function (a, b) {
  var c = this._internalRoot,
      d = new sg();b = void 0 === b ? null : b;null !== b && d.then(b);X.updateContainer(a, c, null, d._onCommit);return d;
};
tg.prototype.unmount = function (a) {
  var b = this._internalRoot,
      c = new sg();a = void 0 === a ? null : a;null !== a && c.then(a);X.updateContainer(null, b, null, c._onCommit);return c;
};tg.prototype.legacy_renderSubtreeIntoContainer = function (a, b, c) {
  var d = this._internalRoot,
      e = new sg();c = void 0 === c ? null : c;null !== c && e.then(c);X.updateContainer(b, d, a, e._onCommit);return e;
};
tg.prototype.createBatch = function () {
  var a = new rg(this),
      b = a._expirationTime,
      c = this._internalRoot,
      d = c.firstBatch;if (null === d) c.firstBatch = a, a._next = null;else {
    for (c = null; null !== d && d._expirationTime <= b;) {
      c = d, d = d._next;
    }a._next = d;null !== c && (c._next = a);
  }return a;
};function ug(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function vg(a, b) {
  switch (a) {case "button":case "input":case "select":case "textarea":
      return !!b.autoFocus;}return !1;
}
var X = pf({ getRootHostContext: function getRootHostContext(a) {
    var b = a.nodeType;switch (b) {case 9:case 11:
        a = (a = a.documentElement) ? a.namespaceURI : Pf(null, "");break;default:
        b = 8 === b ? a.parentNode : a, a = b.namespaceURI || null, b = b.tagName, a = Pf(a, b);}return a;
  }, getChildHostContext: function getChildHostContext(a, b) {
    return Pf(a, b);
  }, getPublicInstance: function getPublicInstance(a) {
    return a;
  }, prepareForCommit: function prepareForCommit() {
    pg = Vd;var a = fa();if (ne(a)) {
      if ("selectionStart" in a) var b = { start: a.selectionStart, end: a.selectionEnd };else a: {
        var c = window.getSelection && window.getSelection();
        if (c && 0 !== c.rangeCount) {
          b = c.anchorNode;var d = c.anchorOffset,
              e = c.focusNode;c = c.focusOffset;try {
            b.nodeType, e.nodeType;
          } catch (B) {
            b = null;break a;
          }var f = 0,
              h = -1,
              g = -1,
              k = 0,
              v = 0,
              l = a,
              p = null;b: for (;;) {
            for (var z;;) {
              l !== b || 0 !== d && 3 !== l.nodeType || (h = f + d);l !== e || 0 !== c && 3 !== l.nodeType || (g = f + c);3 === l.nodeType && (f += l.nodeValue.length);if (null === (z = l.firstChild)) break;p = l;l = z;
            }for (;;) {
              if (l === a) break b;p === b && ++k === d && (h = f);p === e && ++v === c && (g = f);if (null !== (z = l.nextSibling)) break;l = p;p = l.parentNode;
            }l = z;
          }b = -1 === h || -1 === g ? null : { start: h, end: g };
        } else b = null;
      }b = b || { start: 0, end: 0 };
    } else b = null;qg = { focusedElem: a, selectionRange: b };Wd(!1);
  }, resetAfterCommit: function resetAfterCommit() {
    var a = qg,
        b = fa(),
        c = a.focusedElem,
        d = a.selectionRange;if (b !== c && ja(document.documentElement, c)) {
      if (ne(c)) if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);else if (window.getSelection) {
        b = window.getSelection();var e = c[mb()].length;a = Math.min(d.start, e);d = void 0 === d.end ? a : Math.min(d.end, e);!b.extend && a > d && (e = d, d = a, a = e);e = me(c, a);var f = me(c, d);if (e && f && (1 !== b.rangeCount || b.anchorNode !== e.node || b.anchorOffset !== e.offset || b.focusNode !== f.node || b.focusOffset !== f.offset)) {
          var h = document.createRange();h.setStart(e.node, e.offset);b.removeAllRanges();a > d ? (b.addRange(h), b.extend(f.node, f.offset)) : (h.setEnd(f.node, f.offset), b.addRange(h));
        }
      }b = [];for (a = c; a = a.parentNode;) {
        1 === a.nodeType && b.push({ element: a, left: a.scrollLeft, top: a.scrollTop });
      }c.focus();for (c = 0; c < b.length; c++) {
        a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
      }
    }qg = null;Wd(pg);pg = null;
  }, createInstance: function createInstance(a, b, c, d, e) {
    a = ag(a, b, c, d);a[F] = e;a[Ta] = b;return a;
  }, appendInitialChild: function appendInitialChild(a, b) {
    a.appendChild(b);
  }, finalizeInitialChildren: function finalizeInitialChildren(a, b, c, d) {
    cg(a, b, c, d);return vg(b, c);
  }, prepareUpdate: function prepareUpdate(a, b, c, d, e) {
    return dg(a, b, c, d, e);
  }, shouldSetTextContent: function shouldSetTextContent(a, b) {
    return "textarea" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === _typeof(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && "string" === typeof b.dangerouslySetInnerHTML.__html;
  }, shouldDeprioritizeSubtree: function shouldDeprioritizeSubtree(a, b) {
    return !!b.hidden;
  }, createTextInstance: function createTextInstance(a, b, c, d) {
    a = bg(a, b);a[F] = d;return a;
  }, now: sf, mutation: { commitMount: function commitMount(a, b, c) {
      vg(b, c) && a.focus();
    }, commitUpdate: function commitUpdate(a, b, c, d, e) {
      a[Ta] = e;eg(a, b, c, d, e);
    }, resetTextContent: function resetTextContent(a) {
      Sf(a, "");
    }, commitTextUpdate: function commitTextUpdate(a, b, c) {
      a.nodeValue = c;
    }, appendChild: function appendChild(a, b) {
      a.appendChild(b);
    }, appendChildToContainer: function appendChildToContainer(a, b) {
      8 === a.nodeType ? a.parentNode.insertBefore(b, a) : a.appendChild(b);
    },
    insertBefore: function insertBefore(a, b, c) {
      a.insertBefore(b, c);
    }, insertInContainerBefore: function insertInContainerBefore(a, b, c) {
      8 === a.nodeType ? a.parentNode.insertBefore(b, c) : a.insertBefore(b, c);
    }, removeChild: function removeChild(a, b) {
      a.removeChild(b);
    }, removeChildFromContainer: function removeChildFromContainer(a, b) {
      8 === a.nodeType ? a.parentNode.removeChild(b) : a.removeChild(b);
    } }, hydration: { canHydrateInstance: function canHydrateInstance(a, b) {
      return 1 !== a.nodeType || b.toLowerCase() !== a.nodeName.toLowerCase() ? null : a;
    }, canHydrateTextInstance: function canHydrateTextInstance(a, b) {
      return "" === b || 3 !== a.nodeType ? null : a;
    }, getNextHydratableSibling: function getNextHydratableSibling(a) {
      for (a = a.nextSibling; a && 1 !== a.nodeType && 3 !== a.nodeType;) {
        a = a.nextSibling;
      }return a;
    }, getFirstHydratableChild: function getFirstHydratableChild(a) {
      for (a = a.firstChild; a && 1 !== a.nodeType && 3 !== a.nodeType;) {
        a = a.nextSibling;
      }return a;
    }, hydrateInstance: function hydrateInstance(a, b, c, d, e, f) {
      a[F] = f;a[Ta] = c;return fg(a, b, c, e, d);
    }, hydrateTextInstance: function hydrateTextInstance(a, b, c) {
      a[F] = c;return ng(a, b);
    }, didNotMatchHydratedContainerTextInstance: function didNotMatchHydratedContainerTextInstance() {}, didNotMatchHydratedTextInstance: function didNotMatchHydratedTextInstance() {}, didNotHydrateContainerInstance: function didNotHydrateContainerInstance() {}, didNotHydrateInstance: function didNotHydrateInstance() {},
    didNotFindHydratableContainerInstance: function didNotFindHydratableContainerInstance() {}, didNotFindHydratableContainerTextInstance: function didNotFindHydratableContainerTextInstance() {}, didNotFindHydratableInstance: function didNotFindHydratableInstance() {}, didNotFindHydratableTextInstance: function didNotFindHydratableTextInstance() {} }, scheduleDeferredCallback: tf, cancelDeferredCallback: uf }),
    Cg = X;ac = Cg.batchedUpdates;bc = Cg.interactiveUpdates;cc = Cg.flushInteractiveUpdates;
function Dg(a, b) {
  b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));if (!b) for (var c; c = a.lastChild;) {
    a.removeChild(c);
  }return new tg(a, !1, b);
}
function Eg(a, b, c, d, e) {
  ug(c) ? void 0 : D("200");var f = c._reactRootContainer;if (f) {
    if ("function" === typeof e) {
      var h = e;e = function e() {
        var a = X.getPublicRootInstance(f._internalRoot);h.call(a);
      };
    }null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
  } else {
    f = c._reactRootContainer = Dg(c, d);if ("function" === typeof e) {
      var g = e;e = function e() {
        var a = X.getPublicRootInstance(f._internalRoot);g.call(a);
      };
    }X.unbatchedUpdates(function () {
      null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
    });
  }return X.getPublicRootInstance(f._internalRoot);
}
function Fg(a, b) {
  var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;ug(b) ? void 0 : D("200");return qf(a, b, null, c);
}
var Gg = { createPortal: Fg, findDOMNode: function findDOMNode(a) {
    return null == a ? null : 1 === a.nodeType ? a : X.findHostInstance(a);
  }, hydrate: function hydrate(a, b, c) {
    return Eg(null, a, b, !0, c);
  }, render: function render(a, b, c) {
    return Eg(null, a, b, !1, c);
  }, unstable_renderSubtreeIntoContainer: function unstable_renderSubtreeIntoContainer(a, b, c, d) {
    null == a || void 0 === a._reactInternalFiber ? D("38") : void 0;return Eg(a, b, c, !1, d);
  }, unmountComponentAtNode: function unmountComponentAtNode(a) {
    ug(a) ? void 0 : D("40");return a._reactRootContainer ? (X.unbatchedUpdates(function () {
      Eg(null, null, a, !1, function () {
        a._reactRootContainer = null;
      });
    }), !0) : !1;
  }, unstable_createPortal: function unstable_createPortal() {
    return Fg.apply(void 0, arguments);
  }, unstable_batchedUpdates: X.batchedUpdates, unstable_deferredUpdates: X.deferredUpdates, flushSync: X.flushSync, unstable_flushControlled: X.flushControlled, __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: { EventPluginHub: Ra, EventPluginRegistry: Ca, EventPropagators: kb, ReactControlledComponent: $b, ReactDOMComponentTree: bb, ReactDOMEventListener: $d }, unstable_createRoot: function unstable_createRoot(a, b) {
    return new tg(a, !0, null != b && !0 === b.hydrate);
  } };
X.injectIntoDevTools({ findFiberByHostInstance: Ua, bundleType: 0, version: "16.3.2", rendererPackageName: "react-dom" });var Hg = Object.freeze({ default: Gg }),
    Ig = Hg && Gg || Hg;module.exports = Ig["default"] ? Ig["default"] : Ig;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */

function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(105);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(106);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(16);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createBrowserHistory = __webpack_require__(113);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _Router = __webpack_require__(50);

var _Router2 = _interopRequireDefault(_Router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    (0, _warning2.default)(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(_react2.default.Component);

BrowserRouter.propTypes = {
  basename: _propTypes2.default.string,
  forceRefresh: _propTypes2.default.bool,
  getUserConfirmation: _propTypes2.default.func,
  keyLength: _propTypes2.default.number,
  children: _propTypes2.default.node
};

exports.default = BrowserRouter;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(110);
var invariant = __webpack_require__(111);
var ReactPropTypesSecret = __webpack_require__(112);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(48);

var _PathUtils = __webpack_require__(34);

var _createTransitionManager = __webpack_require__(49);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(63);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;

    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(16);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createHashHistory = __webpack_require__(115);

var _createHashHistory2 = _interopRequireDefault(_createHashHistory);

var _Router = __webpack_require__(50);

var _Router2 = _interopRequireDefault(_Router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    (0, _warning2.default)(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(_react2.default.Component);

HashRouter.propTypes = {
  basename: _propTypes2.default.string,
  getUserConfirmation: _propTypes2.default.func,
  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
  children: _propTypes2.default.node
};

exports.default = HashRouter;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(48);

var _PathUtils = __webpack_require__(34);

var _createTransitionManager = __webpack_require__(49);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(63);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MemoryRouter = __webpack_require__(117);

var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(16);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createMemoryHistory = __webpack_require__(118);

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

var _Router = __webpack_require__(51);

var _Router2 = _interopRequireDefault(_Router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createMemoryHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    (0, _warning2.default)(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(_react2.default.Component);

MemoryRouter.propTypes = {
  initialEntries: _propTypes2.default.array,
  initialIndex: _propTypes2.default.number,
  getUserConfirmation: _propTypes2.default.func,
  keyLength: _propTypes2.default.number,
  children: _propTypes2.default.node
};

exports.default = MemoryRouter;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(34);

var _LocationUtils = __webpack_require__(48);

var _createTransitionManager = __webpack_require__(49);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(16);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Route = __webpack_require__(65);

var _Route2 = _interopRequireDefault(_Route);

var _Link = __webpack_require__(64);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return _react2.default.createElement(_Route2.default, {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return _react2.default.createElement(_Link2.default, _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: _Link2.default.propTypes.to,
  exact: _propTypes2.default.bool,
  strict: _propTypes2.default.bool,
  location: _propTypes2.default.object,
  activeClassName: _propTypes2.default.string,
  className: _propTypes2.default.string,
  activeStyle: _propTypes2.default.object,
  style: _propTypes2.default.object,
  isActive: _propTypes2.default.func,
  ariaCurrent: _propTypes2.default.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

exports.default = NavLink;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isarray = __webpack_require__(121);

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
// Match escaped characters that would otherwise appear in future matches.
// This allows the user to escape special characters that won't transform.
'(\\\\.)',
// Match Express-style parameters and un-named parameters with a prefix
// and optional suffixes. Matches appear as:
//
// "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
// "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
// "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
'([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse(str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue;
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?'
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens;
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile(str, options) {
  return tokensToFunction(parse(str, options));
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty(str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk(str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction(tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (_typeof(tokens[i]) === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue;
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue;
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined');
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
        }

        if (value.length === 0) {
          if (token.optional) {
            continue;
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty');
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue;
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
      }

      path += token.prefix + segment;
    }

    return path;
  };
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString(str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup(group) {
  return group.replace(/([=!:$\/()])/g, '\\$1');
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys(re, keys) {
  re.keys = keys;
  return re;
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags(options) {
  return options.sensitive ? '' : 'i';
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp(path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys);
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp(path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys);
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp(path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options);
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp(tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys);
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp(path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */keys);
  }

  if (isarray(path)) {
    return arrayToRegexp( /** @type {!Array} */path, /** @type {!Array} */keys, options);
  }

  return stringToRegexp( /** @type {string} */path, /** @type {!Array} */keys, options);
}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Prompt = __webpack_require__(123);

var _Prompt2 = _interopRequireDefault(_Prompt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(16);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    (0, _invariant2.default)(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(_react2.default.Component);

Prompt.propTypes = {
  when: _propTypes2.default.bool,
  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: _propTypes2.default.shape({
    history: _propTypes2.default.shape({
      block: _propTypes2.default.func.isRequired
    }).isRequired
  }).isRequired
};

exports.default = Prompt;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Redirect = __webpack_require__(125);

var _Redirect2 = _interopRequireDefault(_Redirect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(16);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _history = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    (0, _invariant2.default)(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = (0, _history.createLocation)(prevProps.to);
    var nextTo = (0, _history.createLocation)(this.props.to);

    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
      (0, _warning2.default)(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(_react2.default.Component);

Redirect.propTypes = {
  push: _propTypes2.default.bool,
  from: _propTypes2.default.string,
  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: _propTypes2.default.shape({
    history: _propTypes2.default.shape({
      push: _propTypes2.default.func.isRequired,
      replace: _propTypes2.default.func.isRequired
    }).isRequired,
    staticContext: _propTypes2.default.object
  }).isRequired
};

exports.default = Redirect;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;

var _LocationUtils = __webpack_require__(40);

Object.defineProperty(exports, 'createLocation', {
  enumerable: true,
  get: function get() {
    return _LocationUtils.createLocation;
  }
});
Object.defineProperty(exports, 'locationsAreEqual', {
  enumerable: true,
  get: function get() {
    return _LocationUtils.locationsAreEqual;
  }
});

var _PathUtils = __webpack_require__(35);

Object.defineProperty(exports, 'parsePath', {
  enumerable: true,
  get: function get() {
    return _PathUtils.parsePath;
  }
});
Object.defineProperty(exports, 'createPath', {
  enumerable: true,
  get: function get() {
    return _PathUtils.createPath;
  }
});

var _createBrowserHistory2 = __webpack_require__(127);

var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);

var _createHashHistory2 = __webpack_require__(128);

var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);

var _createMemoryHistory2 = __webpack_require__(129);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createBrowserHistory = _createBrowserHistory3.default;
exports.createHashHistory = _createHashHistory3.default;
exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(40);

var _PathUtils = __webpack_require__(35);

var _createTransitionManager = __webpack_require__(53);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;

    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(40);

var _PathUtils = __webpack_require__(35);

var _createTransitionManager = __webpack_require__(53);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(35);

var _LocationUtils = __webpack_require__(40);

var _createTransitionManager = __webpack_require__(53);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StaticRouter = __webpack_require__(131);

var _StaticRouter2 = _interopRequireDefault(_StaticRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(16);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PathUtils = __webpack_require__(34);

var _Router = __webpack_require__(51);

var _Router2 = _interopRequireDefault(_Router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: (0, _PathUtils.addLeadingSlash)(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = (0, _PathUtils.addLeadingSlash)(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : (0, _PathUtils.createPath)(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    (0, _invariant2.default)(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return (0, _PathUtils.addLeadingSlash)(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    (0, _warning2.default)(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(_react2.default.Component);

StaticRouter.propTypes = {
  basename: _propTypes2.default.string,
  context: _propTypes2.default.object.isRequired,
  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: _propTypes2.default.object.isRequired
};

exports.default = StaticRouter;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Switch = __webpack_require__(133);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(16);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(13);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(17);

var _invariant2 = _interopRequireDefault(_invariant);

var _matchPath = __webpack_require__(52);

var _matchPath2 = _interopRequireDefault(_matchPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    (0, _invariant2.default)(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    _react2.default.Children.forEach(children, function (element) {
      if (!_react2.default.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(_react2.default.Component);

Switch.contextTypes = {
  router: _propTypes2.default.shape({
    route: _propTypes2.default.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.object
};

exports.default = Switch;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _matchPath = __webpack_require__(52);

var _matchPath2 = _interopRequireDefault(_matchPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withRouter = __webpack_require__(136);

var _withRouter2 = _interopRequireDefault(_withRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(16);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(137);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _Route = __webpack_require__(66);

var _Route2 = _interopRequireDefault(_Route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return _react2.default.createElement(_Route2.default, { render: function render(routeComponentProps) {
        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: _propTypes2.default.func
  };

  return (0, _hoistNonReactStatics2.default)(C, Component);
};

exports.default = withRouter;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _userAction = __webpack_require__(21);

var _userAction2 = _interopRequireDefault(_userAction);

var _attendance = __webpack_require__(149);

var _attendance2 = _interopRequireDefault(_attendance);

var _attendanceIndividual = __webpack_require__(157);

var _attendanceIndividual2 = _interopRequireDefault(_attendanceIndividual);

var _attendanceAll = __webpack_require__(184);

var _attendanceAll2 = _interopRequireDefault(_attendanceAll);

var _journeyPlanner = __webpack_require__(187);

var _journeyPlanner2 = _interopRequireDefault(_journeyPlanner);

var _report = __webpack_require__(194);

var _report2 = _interopRequireDefault(_report);

var _reportDetail = __webpack_require__(202);

var _reportDetail2 = _interopRequireDefault(_reportDetail);

var _leaveApp = __webpack_require__(204);

var _leaveApp2 = _interopRequireDefault(_leaveApp);

var _leaveInfo = __webpack_require__(213);

var _leaveInfo2 = _interopRequireDefault(_leaveInfo);

var _leaveSummary = __webpack_require__(218);

var _leaveSummary2 = _interopRequireDefault(_leaveSummary);

var _userSetting = __webpack_require__(221);

var _userSetting2 = _interopRequireDefault(_userSetting);

var _contractorSetting = __webpack_require__(229);

var _contractorSetting2 = _interopRequireDefault(_contractorSetting);

var _leaveSetting = __webpack_require__(235);

var _leaveSetting2 = _interopRequireDefault(_leaveSetting);

var _userLogin = __webpack_require__(242);

var _userLogin2 = _interopRequireDefault(_userLogin);

var _forgotPassword = __webpack_require__(243);

var _forgotPassword2 = _interopRequireDefault(_forgotPassword);

var _resetPassword = __webpack_require__(244);

var _resetPassword2 = _interopRequireDefault(_resetPassword);

var _changePassword = __webpack_require__(245);

var _changePassword2 = _interopRequireDefault(_changePassword);

var _estate = __webpack_require__(246);

var _estate2 = _interopRequireDefault(_estate);

var _employee = __webpack_require__(251);

var _employee2 = _interopRequireDefault(_employee);

var _contractor = __webpack_require__(257);

var _contractor2 = _interopRequireDefault(_contractor);

var _contractorDisplay = __webpack_require__(88);

var _contractorDisplay2 = _interopRequireDefault(_contractorDisplay);

var _condoDisplay = __webpack_require__(260);

var _condoDisplay2 = _interopRequireDefault(_condoDisplay);

var _contractorNewForm = __webpack_require__(261);

var _contractorNewForm2 = _interopRequireDefault(_contractorNewForm);

var _condoNewForm = __webpack_require__(263);

var _condoNewForm2 = _interopRequireDefault(_condoNewForm);

var _condoForm = __webpack_require__(265);

var _condoForm2 = _interopRequireDefault(_condoForm);

var _contractorForm = __webpack_require__(266);

var _contractorForm2 = _interopRequireDefault(_contractorForm);

var _checkListForm = __webpack_require__(267);

var _checkListForm2 = _interopRequireDefault(_checkListForm);

var _permissionSetting = __webpack_require__(270);

var _permissionSetting2 = _interopRequireDefault(_permissionSetting);

var _journeySetting = __webpack_require__(273);

var _journeySetting2 = _interopRequireDefault(_journeySetting);

var _resetForgotPassword = __webpack_require__(276);

var _resetForgotPassword2 = _interopRequireDefault(_resetForgotPassword);

var _checkPtsSetting = __webpack_require__(277);

var _checkPtsSetting2 = _interopRequireDefault(_checkPtsSetting);

var _attendanceCheck = __webpack_require__(281);

var _attendanceCheck2 = _interopRequireDefault(_attendanceCheck);

var _leaveApply = __webpack_require__(282);

var _leaveApply2 = _interopRequireDefault(_leaveApply);

var _reportCreate = __webpack_require__(283);

var _reportCreate2 = _interopRequireDefault(_reportCreate);

var _teamSetting = __webpack_require__(284);

var _teamSetting2 = _interopRequireDefault(_teamSetting);

var _leaveAtdApply = __webpack_require__(287);

var _leaveAtdApply2 = _interopRequireDefault(_leaveAtdApply);

var _holidaySetting = __webpack_require__(290);

var _holidaySetting2 = _interopRequireDefault(_holidaySetting);

var _policy = __webpack_require__(292);

var _policy2 = _interopRequireDefault(_policy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var App = function (_React$Component) {
    _inherits(App, _React$Component);

    function App(props) {
        _classCallCheck(this, App);

        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
    }

    _createClass(App, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (sessionStorage.getItem('ui')) {
                _userAction2.default.isUserLogin();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactRouterDom.Switch,
                    null,
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', component: _userLogin2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/forgotPassword', component: _forgotPassword2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/forgotPassword/:token', component: _resetForgotPassword2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/resetPassword/:token', component: _resetPassword2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/changePassword', component: _changePassword2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/attendance', render: function render(props) {
                            return _react2.default.createElement(_attendance2.default, props);
                        } }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/attendance/:id', component: _attendanceCheck2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/staff/:id', component: _attendanceIndividual2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/policy', component: _policy2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/staff', component: _attendanceAll2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/journeyPlanner', component: _journeyPlanner2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/estate', component: _estate2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/report/create', component: _reportCreate2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/report/:id', component: _reportDetail2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/report', component: _report2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/leave', component: _leaveApp2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/leaveInfo/:id', component: _leaveSummary2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/leaveInfo', component: _leaveInfo2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/leave/:staffId', component: _leaveApply2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/contractor', component: _contractor2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/contractor/:id', component: _contractorDisplay2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/contractorSet/:id', component: _contractorForm2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/newContractor', component: _contractorNewForm2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/condo/:id', component: _condoDisplay2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/condoSet/:id', component: _condoForm2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/newCondo', component: _condoNewForm2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/apply/leaveAtd', component: _leaveAtdApply2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/checkListSetting', component: _checkListForm2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/permissionSetting', component: _permissionSetting2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/holidaySetting', component: _holidaySetting2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/userSetting', component: _userSetting2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/contractorSetting', component: _contractorSetting2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/leaveSetting', component: _leaveSetting2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/journeySetting', component: _journeySetting2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/teamSetting', component: _teamSetting2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/checkPtsSetting', component: _checkPtsSetting2.default }),
                    _react2.default.createElement(_reactRouterDom.Route, { path: '/userProfile', component: _employee2.default })
                )
            );
        }
    }]);

    return App;
}(_react2.default.Component);

exports.default = App;
;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flux = __webpack_require__(140);

var _StateFunctions = __webpack_require__(143);

var StateFunctions = _interopRequireWildcard(_StateFunctions);

var _functions = __webpack_require__(24);

var fn = _interopRequireWildcard(_functions);

var _store = __webpack_require__(144);

var store = _interopRequireWildcard(_store);

var _AltUtils = __webpack_require__(54);

var utils = _interopRequireWildcard(_AltUtils);

var _actions = __webpack_require__(147);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
} /* global window */

var Alt = function () {
  function Alt() {
    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    _classCallCheck(this, Alt);

    this.config = config;
    this.serialize = config.serialize || JSON.stringify;
    this.deserialize = config.deserialize || JSON.parse;
    this.dispatcher = config.dispatcher || new _flux.Dispatcher();
    this.batchingFunction = config.batchingFunction || function (callback) {
      return callback();
    };
    this.actions = { global: {} };
    this.stores = {};
    this.storeTransforms = config.storeTransforms || [];
    this.trapAsync = false;
    this._actionsRegistry = {};
    this._initSnapshot = {};
    this._lastSnapshot = {};
  }

  Alt.prototype.dispatch = function () {
    function dispatch(action, data, details) {
      var _this = this;

      this.batchingFunction(function () {
        var id = Math.random().toString(18).substr(2, 16);

        // support straight dispatching of FSA-style actions
        if (action.hasOwnProperty('type') && action.hasOwnProperty('payload')) {
          var fsaDetails = {
            id: action.type,
            namespace: action.type,
            name: action.type
          };
          return _this.dispatcher.dispatch(utils.fsa(id, action.type, action.payload, fsaDetails));
        }

        if (action.id && action.dispatch) {
          return utils.dispatch(id, action, data, _this);
        }

        return _this.dispatcher.dispatch(utils.fsa(id, action, data, details));
      });
    }

    return dispatch;
  }();

  Alt.prototype.createUnsavedStore = function () {
    function createUnsavedStore(StoreModel) {
      var key = StoreModel.displayName || '';
      store.createStoreConfig(this.config, StoreModel);
      var Store = store.transformStore(this.storeTransforms, StoreModel);

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return fn.isFunction(Store) ? store.createStoreFromClass.apply(store, [this, Store, key].concat(args)) : store.createStoreFromObject(this, Store, key);
    }

    return createUnsavedStore;
  }();

  Alt.prototype.createStore = function () {
    function createStore(StoreModel, iden) {
      var key = iden || StoreModel.displayName || StoreModel.name || '';
      store.createStoreConfig(this.config, StoreModel);
      var Store = store.transformStore(this.storeTransforms, StoreModel);

      /* istanbul ignore next */
      if (false) delete this.stores[key];

      if (this.stores[key] || !key) {
        if (this.stores[key]) {
          utils.warn('A store named ' + String(key) + ' already exists, double check your store ' + 'names or pass in your own custom identifier for each store');
        } else {
          utils.warn('Store name was not specified');
        }

        key = utils.uid(this.stores, key);
      }

      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      var storeInstance = fn.isFunction(Store) ? store.createStoreFromClass.apply(store, [this, Store, key].concat(args)) : store.createStoreFromObject(this, Store, key);

      this.stores[key] = storeInstance;
      StateFunctions.saveInitialSnapshot(this, key);

      return storeInstance;
    }

    return createStore;
  }();

  Alt.prototype.generateActions = function () {
    function generateActions() {
      var actions = { name: 'global' };

      for (var _len3 = arguments.length, actionNames = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        actionNames[_key3] = arguments[_key3];
      }

      return this.createActions(actionNames.reduce(function (obj, action) {
        obj[action] = utils.dispatchIdentity;
        return obj;
      }, actions));
    }

    return generateActions;
  }();

  Alt.prototype.createAction = function () {
    function createAction(name, implementation, obj) {
      return (0, _actions2['default'])(this, 'global', name, implementation, obj);
    }

    return createAction;
  }();

  Alt.prototype.createActions = function () {
    function createActions(ActionsClass) {
      var _this3 = this;

      var exportObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

      var actions = {};
      var key = utils.uid(this._actionsRegistry, ActionsClass.displayName || ActionsClass.name || 'Unknown');

      if (fn.isFunction(ActionsClass)) {
        fn.assign(actions, utils.getPrototypeChain(ActionsClass));

        var ActionsGenerator = function (_ActionsClass) {
          _inherits(ActionsGenerator, _ActionsClass);

          function ActionsGenerator() {
            _classCallCheck(this, ActionsGenerator);

            for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
              args[_key5] = arguments[_key5];
            }

            return _possibleConstructorReturn(this, _ActionsClass.call.apply(_ActionsClass, [this].concat(args)));
          }

          ActionsGenerator.prototype.generateActions = function () {
            function generateActions() {
              for (var _len6 = arguments.length, actionNames = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                actionNames[_key6] = arguments[_key6];
              }

              actionNames.forEach(function (actionName) {
                actions[actionName] = utils.dispatchIdentity;
              });
            }

            return generateActions;
          }();

          return ActionsGenerator;
        }(ActionsClass);

        for (var _len4 = arguments.length, argsForConstructor = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
          argsForConstructor[_key4 - 2] = arguments[_key4];
        }

        fn.assign(actions, new (Function.prototype.bind.apply(ActionsGenerator, [null].concat(argsForConstructor)))());
      } else {
        fn.assign(actions, ActionsClass);
      }

      this.actions[key] = this.actions[key] || {};

      fn.eachObject(function (actionName, action) {
        if (!fn.isFunction(action)) {
          exportObj[actionName] = action;
          return;
        }

        // create the action
        exportObj[actionName] = (0, _actions2['default'])(_this3, key, actionName, action, exportObj);

        // generate a constant
        var constant = utils.formatAsConstant(actionName);
        exportObj[constant] = exportObj[actionName].id;
      }, [actions]);

      return exportObj;
    }

    return createActions;
  }();

  Alt.prototype.takeSnapshot = function () {
    function takeSnapshot() {
      for (var _len7 = arguments.length, storeNames = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        storeNames[_key7] = arguments[_key7];
      }

      var state = StateFunctions.snapshot(this, storeNames);
      fn.assign(this._lastSnapshot, state);
      return this.serialize(state);
    }

    return takeSnapshot;
  }();

  Alt.prototype.rollback = function () {
    function rollback() {
      StateFunctions.setAppState(this, this.serialize(this._lastSnapshot), function (storeInst) {
        storeInst.lifecycle('rollback');
        storeInst.emitChange();
      });
    }

    return rollback;
  }();

  Alt.prototype.recycle = function () {
    function recycle() {
      for (var _len8 = arguments.length, storeNames = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        storeNames[_key8] = arguments[_key8];
      }

      var initialSnapshot = storeNames.length ? StateFunctions.filterSnapshots(this, this._initSnapshot, storeNames) : this._initSnapshot;

      StateFunctions.setAppState(this, this.serialize(initialSnapshot), function (storeInst) {
        storeInst.lifecycle('init');
        storeInst.emitChange();
      });
    }

    return recycle;
  }();

  Alt.prototype.flush = function () {
    function flush() {
      var state = this.serialize(StateFunctions.snapshot(this));
      this.recycle();
      return state;
    }

    return flush;
  }();

  Alt.prototype.bootstrap = function () {
    function bootstrap(data) {
      StateFunctions.setAppState(this, data, function (storeInst, state) {
        storeInst.lifecycle('bootstrap', state);
        storeInst.emitChange();
      });
    }

    return bootstrap;
  }();

  Alt.prototype.prepare = function () {
    function prepare(storeInst, payload) {
      var data = {};
      if (!storeInst.displayName) {
        throw new ReferenceError('Store provided does not have a name');
      }
      data[storeInst.displayName] = payload;
      return this.serialize(data);
    }

    return prepare;
  }();

  // Instance type methods for injecting alt into your application as context

  Alt.prototype.addActions = function () {
    function addActions(name, ActionsClass) {
      for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
        args[_key9 - 2] = arguments[_key9];
      }

      this.actions[name] = Array.isArray(ActionsClass) ? this.generateActions.apply(this, ActionsClass) : this.createActions.apply(this, [ActionsClass].concat(args));
    }

    return addActions;
  }();

  Alt.prototype.addStore = function () {
    function addStore(name, StoreModel) {
      for (var _len10 = arguments.length, args = Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
        args[_key10 - 2] = arguments[_key10];
      }

      this.createStore.apply(this, [StoreModel, name].concat(args));
    }

    return addStore;
  }();

  Alt.prototype.getActions = function () {
    function getActions(name) {
      return this.actions[name];
    }

    return getActions;
  }();

  Alt.prototype.getStore = function () {
    function getStore(name) {
      return this.stores[name];
    }

    return getStore;
  }();

  Alt.debug = function () {
    function debug(name, alt, win) {
      var key = 'alt.js.org';
      var context = win;
      if (!context && typeof window !== 'undefined') {
        context = window;
      }
      if (typeof context !== 'undefined') {
        context[key] = context[key] || [];
        context[key].push({ name: name, alt: alt });
      }
      return alt;
    }

    return debug;
  }();

  return Alt;
}();

exports['default'] = Alt;
module.exports = exports['default'];

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

module.exports.Dispatcher = __webpack_require__(141);

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Dispatcher
 * 
 * @preventMunge
 */



exports.__esModule = true;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

var invariant = __webpack_require__(142);

var _prefix = 'ID_';

/**
 * Dispatcher is used to broadcast payloads to registered callbacks. This is
 * different from generic pub-sub systems in two ways:
 *
 *   1) Callbacks are not subscribed to particular events. Every payload is
 *      dispatched to every registered callback.
 *   2) Callbacks can be deferred in whole or part until other callbacks have
 *      been executed.
 *
 * For example, consider this hypothetical flight destination form, which
 * selects a default city when a country is selected:
 *
 *   var flightDispatcher = new Dispatcher();
 *
 *   // Keeps track of which country is selected
 *   var CountryStore = {country: null};
 *
 *   // Keeps track of which city is selected
 *   var CityStore = {city: null};
 *
 *   // Keeps track of the base flight price of the selected city
 *   var FlightPriceStore = {price: null}
 *
 * When a user changes the selected city, we dispatch the payload:
 *
 *   flightDispatcher.dispatch({
 *     actionType: 'city-update',
 *     selectedCity: 'paris'
 *   });
 *
 * This payload is digested by `CityStore`:
 *
 *   flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'city-update') {
 *       CityStore.city = payload.selectedCity;
 *     }
 *   });
 *
 * When the user selects a country, we dispatch the payload:
 *
 *   flightDispatcher.dispatch({
 *     actionType: 'country-update',
 *     selectedCountry: 'australia'
 *   });
 *
 * This payload is digested by both stores:
 *
 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'country-update') {
 *       CountryStore.country = payload.selectedCountry;
 *     }
 *   });
 *
 * When the callback to update `CountryStore` is registered, we save a reference
 * to the returned token. Using this token with `waitFor()`, we can guarantee
 * that `CountryStore` is updated before the callback that updates `CityStore`
 * needs to query its data.
 *
 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
 *     if (payload.actionType === 'country-update') {
 *       // `CountryStore.country` may not be updated.
 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
 *       // `CountryStore.country` is now guaranteed to be updated.
 *
 *       // Select the default city for the new country
 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
 *     }
 *   });
 *
 * The usage of `waitFor()` can be chained, for example:
 *
 *   FlightPriceStore.dispatchToken =
 *     flightDispatcher.register(function(payload) {
 *       switch (payload.actionType) {
 *         case 'country-update':
 *         case 'city-update':
 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
 *           FlightPriceStore.price =
 *             getFlightPriceStore(CountryStore.country, CityStore.city);
 *           break;
 *     }
 *   });
 *
 * The `country-update` payload will be guaranteed to invoke the stores'
 * registered callbacks in order: `CountryStore`, `CityStore`, then
 * `FlightPriceStore`.
 */

var Dispatcher = function () {
  function Dispatcher() {
    _classCallCheck(this, Dispatcher);

    this._callbacks = {};
    this._isDispatching = false;
    this._isHandled = {};
    this._isPending = {};
    this._lastID = 1;
  }

  /**
   * Registers a callback to be invoked with every dispatched payload. Returns
   * a token that can be used with `waitFor()`.
   */

  Dispatcher.prototype.register = function register(callback) {
    var id = _prefix + this._lastID++;
    this._callbacks[id] = callback;
    return id;
  };

  /**
   * Removes a callback based on its token.
   */

  Dispatcher.prototype.unregister = function unregister(id) {
    !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.unregister(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
    delete this._callbacks[id];
  };

  /**
   * Waits for the callbacks specified to be invoked before continuing execution
   * of the current callback. This method should only be used by a callback in
   * response to a dispatched payload.
   */

  Dispatcher.prototype.waitFor = function waitFor(ids) {
    !this._isDispatching ?  false ? invariant(false, 'Dispatcher.waitFor(...): Must be invoked while dispatching.') : invariant(false) : undefined;
    for (var ii = 0; ii < ids.length; ii++) {
      var id = ids[ii];
      if (this._isPending[id]) {
        !this._isHandled[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): Circular dependency detected while ' + 'waiting for `%s`.', id) : invariant(false) : undefined;
        continue;
      }
      !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
      this._invokeCallback(id);
    }
  };

  /**
   * Dispatches a payload to all registered callbacks.
   */

  Dispatcher.prototype.dispatch = function dispatch(payload) {
    !!this._isDispatching ?  false ? invariant(false, 'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.') : invariant(false) : undefined;
    this._startDispatching(payload);
    try {
      for (var id in this._callbacks) {
        if (this._isPending[id]) {
          continue;
        }
        this._invokeCallback(id);
      }
    } finally {
      this._stopDispatching();
    }
  };

  /**
   * Is this Dispatcher currently dispatching.
   */

  Dispatcher.prototype.isDispatching = function isDispatching() {
    return this._isDispatching;
  };

  /**
   * Call the callback stored with the given id. Also do some internal
   * bookkeeping.
   *
   * @internal
   */

  Dispatcher.prototype._invokeCallback = function _invokeCallback(id) {
    this._isPending[id] = true;
    this._callbacks[id](this._pendingPayload);
    this._isHandled[id] = true;
  };

  /**
   * Set up bookkeeping needed when dispatching.
   *
   * @internal
   */

  Dispatcher.prototype._startDispatching = function _startDispatching(payload) {
    for (var id in this._callbacks) {
      this._isPending[id] = false;
      this._isHandled[id] = false;
    }
    this._pendingPayload = payload;
    this._isDispatching = true;
  };

  /**
   * Clear bookkeeping used for dispatching.
   *
   * @internal
   */

  Dispatcher.prototype._stopDispatching = function _stopDispatching() {
    delete this._pendingPayload;
    this._isDispatching = false;
  };

  return Dispatcher;
}();

module.exports = Dispatcher;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule invariant
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAppState = setAppState;
exports.snapshot = snapshot;
exports.saveInitialSnapshot = saveInitialSnapshot;
exports.filterSnapshots = filterSnapshots;

var _functions = __webpack_require__(24);

var fn = _interopRequireWildcard(_functions);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

function setAppState(instance, data, onStore) {
  var obj = instance.deserialize(data);
  fn.eachObject(function (key, value) {
    var store = instance.stores[key];
    if (store) {
      (function () {
        var config = store.StoreModel.config;

        var state = store.state;
        if (config.onDeserialize) obj[key] = config.onDeserialize(value) || value;
        if (fn.isMutableObject(state)) {
          fn.eachObject(function (k) {
            return delete state[k];
          }, [state]);
          fn.assign(state, obj[key]);
        } else {
          store.state = obj[key];
        }
        onStore(store, store.state);
      })();
    }
  }, [obj]);
}

function snapshot(instance) {
  var storeNames = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];

  var stores = storeNames.length ? storeNames : Object.keys(instance.stores);
  return stores.reduce(function (obj, storeHandle) {
    var storeName = storeHandle.displayName || storeHandle;
    var store = instance.stores[storeName];
    var config = store.StoreModel.config;

    store.lifecycle('snapshot');
    var customSnapshot = config.onSerialize && config.onSerialize(store.state);
    obj[storeName] = customSnapshot ? customSnapshot : store.getState();
    return obj;
  }, {});
}

function saveInitialSnapshot(instance, key) {
  var state = instance.deserialize(instance.serialize(instance.stores[key].state));
  instance._initSnapshot[key] = state;
  instance._lastSnapshot[key] = state;
}

function filterSnapshots(instance, state, stores) {
  return stores.reduce(function (obj, store) {
    var storeName = store.displayName || store;
    if (!state[storeName]) {
      throw new ReferenceError(String(storeName) + ' is not a valid store');
    }
    obj[storeName] = state[storeName];
    return obj;
  }, {});
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStoreConfig = createStoreConfig;
exports.transformStore = transformStore;
exports.createStoreFromObject = createStoreFromObject;
exports.createStoreFromClass = createStoreFromClass;

var _AltUtils = __webpack_require__(54);

var utils = _interopRequireWildcard(_AltUtils);

var _functions = __webpack_require__(24);

var fn = _interopRequireWildcard(_functions);

var _AltStore = __webpack_require__(145);

var _AltStore2 = _interopRequireDefault(_AltStore);

var _StoreMixin = __webpack_require__(146);

var _StoreMixin2 = _interopRequireDefault(_StoreMixin);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function doSetState(store, storeInstance, state) {
  if (!state) {
    return;
  }

  var config = storeInstance.StoreModel.config;

  var nextState = fn.isFunction(state) ? state(storeInstance.state) : state;

  storeInstance.state = config.setState.call(store, storeInstance.state, nextState);

  if (!store.alt.dispatcher.isDispatching()) {
    store.emitChange();
  }
}

function createPrototype(proto, alt, key, extras) {
  return fn.assign(proto, _StoreMixin2['default'], {
    displayName: key,
    alt: alt,
    dispatcher: alt.dispatcher,
    preventDefault: function () {
      function preventDefault() {
        this.getInstance().preventDefault = true;
      }

      return preventDefault;
    }(),

    boundListeners: [],
    lifecycleEvents: {},
    actionListeners: {},
    publicMethods: {},
    handlesOwnErrors: false
  }, extras);
}

function createStoreConfig(globalConfig, StoreModel) {
  StoreModel.config = fn.assign({
    getState: function () {
      function getState(state) {
        if (Array.isArray(state)) {
          return state.slice();
        } else if (fn.isMutableObject(state)) {
          return fn.assign({}, state);
        }

        return state;
      }

      return getState;
    }(),
    setState: function () {
      function setState(currentState, nextState) {
        if (fn.isMutableObject(nextState)) {
          return fn.assign(currentState, nextState);
        }
        return nextState;
      }

      return setState;
    }()
  }, globalConfig, StoreModel.config);
}

function transformStore(transforms, StoreModel) {
  return transforms.reduce(function (Store, transform) {
    return transform(Store);
  }, StoreModel);
}

function createStoreFromObject(alt, StoreModel, key) {
  var storeInstance = void 0;

  var StoreProto = createPrototype({}, alt, key, fn.assign({
    getInstance: function () {
      function getInstance() {
        return storeInstance;
      }

      return getInstance;
    }(),
    setState: function () {
      function setState(nextState) {
        doSetState(this, storeInstance, nextState);
      }

      return setState;
    }()
  }, StoreModel));

  // bind the store listeners
  /* istanbul ignore else */
  if (StoreProto.bindListeners) {
    _StoreMixin2['default'].bindListeners.call(StoreProto, StoreProto.bindListeners);
  }
  /* istanbul ignore else */
  if (StoreProto.observe) {
    _StoreMixin2['default'].bindListeners.call(StoreProto, StoreProto.observe(alt));
  }

  // bind the lifecycle events
  /* istanbul ignore else */
  if (StoreProto.lifecycle) {
    fn.eachObject(function (eventName, event) {
      _StoreMixin2['default'].on.call(StoreProto, eventName, event);
    }, [StoreProto.lifecycle]);
  }

  // create the instance and fn.assign the public methods to the instance
  storeInstance = fn.assign(new _AltStore2['default'](alt, StoreProto, StoreProto.state !== undefined ? StoreProto.state : {}, StoreModel), StoreProto.publicMethods, {
    displayName: key,
    config: StoreModel.config
  });

  return storeInstance;
}

function createStoreFromClass(alt, StoreModel, key) {
  var storeInstance = void 0;
  var config = StoreModel.config;

  // Creating a class here so we don't overload the provided store's
  // prototype with the mixin behaviour and I'm extending from StoreModel
  // so we can inherit any extensions from the provided store.

  var Store = function (_StoreModel) {
    _inherits(Store, _StoreModel);

    function Store() {
      _classCallCheck(this, Store);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _possibleConstructorReturn(this, _StoreModel.call.apply(_StoreModel, [this].concat(args)));
    }

    return Store;
  }(StoreModel);

  createPrototype(Store.prototype, alt, key, {
    type: 'AltStore',
    getInstance: function () {
      function getInstance() {
        return storeInstance;
      }

      return getInstance;
    }(),
    setState: function () {
      function setState(nextState) {
        doSetState(this, storeInstance, nextState);
      }

      return setState;
    }()
  });

  for (var _len = arguments.length, argsForClass = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    argsForClass[_key - 3] = arguments[_key];
  }

  var store = new (Function.prototype.bind.apply(Store, [null].concat(argsForClass)))();

  /* istanbul ignore next */
  if (config.bindListeners) store.bindListeners(config.bindListeners);
  /* istanbul ignore next */
  if (config.datasource) store.registerAsync(config.datasource);

  storeInstance = fn.assign(new _AltStore2['default'](alt, store, store.state !== undefined ? store.state : store, StoreModel), utils.getInternalMethods(StoreModel), config.publicMethods, { displayName: key });

  return storeInstance;
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _functions = __webpack_require__(24);

var fn = _interopRequireWildcard(_functions);

var _transmitter = __webpack_require__(68);

var _transmitter2 = _interopRequireDefault(_transmitter);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var AltStore = function () {
  function AltStore(alt, model, state, StoreModel) {
    var _this = this;

    _classCallCheck(this, AltStore);

    var lifecycleEvents = model.lifecycleEvents;
    this.transmitter = (0, _transmitter2['default'])();
    this.lifecycle = function (event, x) {
      if (lifecycleEvents[event]) lifecycleEvents[event].publish(x);
    };
    this.state = state;

    this.alt = alt;
    this.preventDefault = false;
    this.displayName = model.displayName;
    this.boundListeners = model.boundListeners;
    this.StoreModel = StoreModel;
    this.reduce = model.reduce || function (x) {
      return x;
    };
    this.subscriptions = [];

    var output = model.output || function (x) {
      return x;
    };

    this.emitChange = function () {
      return _this.transmitter.publish(output(_this.state));
    };

    var handleDispatch = function handleDispatch(f, payload) {
      try {
        return f();
      } catch (e) {
        if (model.handlesOwnErrors) {
          _this.lifecycle('error', {
            error: e,
            payload: payload,
            state: _this.state
          });
          return false;
        }

        throw e;
      }
    };

    fn.assign(this, model.publicMethods);

    // Register dispatcher
    this.dispatchToken = alt.dispatcher.register(function (payload) {
      _this.preventDefault = false;

      _this.lifecycle('beforeEach', {
        payload: payload,
        state: _this.state
      });

      var actionHandlers = model.actionListeners[payload.action];

      if (actionHandlers || model.otherwise) {
        var result = void 0;

        if (actionHandlers) {
          result = handleDispatch(function () {
            return actionHandlers.filter(Boolean).every(function (handler) {
              return handler.call(model, payload.data, payload.action) !== false;
            });
          }, payload);
        } else {
          result = handleDispatch(function () {
            return model.otherwise(payload.data, payload.action);
          }, payload);
        }

        if (result !== false && !_this.preventDefault) _this.emitChange();
      }

      if (model.reduce) {
        handleDispatch(function () {
          var value = model.reduce(_this.state, payload);
          if (value !== undefined) _this.state = value;
        }, payload);
        if (!_this.preventDefault) _this.emitChange();
      }

      _this.lifecycle('afterEach', {
        payload: payload,
        state: _this.state
      });
    });

    this.lifecycle('init');
  }

  AltStore.prototype.listen = function () {
    function listen(cb) {
      var _this2 = this;

      if (!fn.isFunction(cb)) throw new TypeError('listen expects a function');

      var _transmitter$subscrib = this.transmitter.subscribe(cb);

      var dispose = _transmitter$subscrib.dispose;

      this.subscriptions.push({ cb: cb, dispose: dispose });
      return function () {
        _this2.lifecycle('unlisten');
        dispose();
      };
    }

    return listen;
  }();

  AltStore.prototype.unlisten = function () {
    function unlisten(cb) {
      this.lifecycle('unlisten');
      this.subscriptions.filter(function (subscription) {
        return subscription.cb === cb;
      }).forEach(function (subscription) {
        return subscription.dispose();
      });
    }

    return unlisten;
  }();

  AltStore.prototype.getState = function () {
    function getState() {
      return this.StoreModel.config.getState.call(this, this.state);
    }

    return getState;
  }();

  return AltStore;
}();

exports['default'] = AltStore;
module.exports = exports['default'];

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _transmitter = __webpack_require__(68);

var _transmitter2 = _interopRequireDefault(_transmitter);

var _functions = __webpack_require__(24);

var fn = _interopRequireWildcard(_functions);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var StoreMixin = {
  waitFor: function () {
    function waitFor() {
      for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
        sources[_key] = arguments[_key];
      }

      if (!sources.length) {
        throw new ReferenceError('Dispatch tokens not provided');
      }

      var sourcesArray = sources;
      if (sources.length === 1) {
        sourcesArray = Array.isArray(sources[0]) ? sources[0] : sources;
      }

      var tokens = sourcesArray.map(function (source) {
        return source.dispatchToken || source;
      });

      this.dispatcher.waitFor(tokens);
    }

    return waitFor;
  }(),
  exportAsync: function () {
    function exportAsync(asyncMethods) {
      this.registerAsync(asyncMethods);
    }

    return exportAsync;
  }(),
  registerAsync: function () {
    function registerAsync(asyncDef) {
      var _this = this;

      var loadCounter = 0;

      var asyncMethods = fn.isFunction(asyncDef) ? asyncDef(this.alt) : asyncDef;

      var toExport = Object.keys(asyncMethods).reduce(function (publicMethods, methodName) {
        var desc = asyncMethods[methodName];
        var spec = fn.isFunction(desc) ? desc(_this) : desc;

        var validHandlers = ['success', 'error', 'loading'];
        validHandlers.forEach(function (handler) {
          if (spec[handler] && !spec[handler].id) {
            throw new Error(String(handler) + ' handler must be an action function');
          }
        });

        publicMethods[methodName] = function () {
          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          var state = _this.getInstance().getState();
          var value = spec.local && spec.local.apply(spec, [state].concat(args));
          var shouldFetch = spec.shouldFetch ? spec.shouldFetch.apply(spec, [state].concat(args))
          /*eslint-disable*/
          : value == null;
          /*eslint-enable*/
          var intercept = spec.interceptResponse || function (x) {
            return x;
          };

          var makeActionHandler = function () {
            function makeActionHandler(action, isError) {
              return function (x) {
                var fire = function () {
                  function fire() {
                    loadCounter -= 1;
                    action(intercept(x, action, args));
                    if (isError) throw x;
                    return x;
                  }

                  return fire;
                }();
                return _this.alt.trapAsync ? function () {
                  return fire();
                } : fire();
              };
            }

            return makeActionHandler;
          }();

          // if we don't have it in cache then fetch it
          if (shouldFetch) {
            loadCounter += 1;
            /* istanbul ignore else */
            if (spec.loading) spec.loading(intercept(null, spec.loading, args));
            return spec.remote.apply(spec, [state].concat(args)).then(makeActionHandler(spec.success), makeActionHandler(spec.error, 1));
          }

          // otherwise emit the change now
          _this.emitChange();
          return value;
        };

        return publicMethods;
      }, {});

      this.exportPublicMethods(toExport);
      this.exportPublicMethods({
        isLoading: function () {
          function isLoading() {
            return loadCounter > 0;
          }

          return isLoading;
        }()
      });
    }

    return registerAsync;
  }(),
  exportPublicMethods: function () {
    function exportPublicMethods(methods) {
      var _this2 = this;

      fn.eachObject(function (methodName, value) {
        if (!fn.isFunction(value)) {
          throw new TypeError('exportPublicMethods expects a function');
        }

        _this2.publicMethods[methodName] = value;
      }, [methods]);
    }

    return exportPublicMethods;
  }(),
  emitChange: function () {
    function emitChange() {
      this.getInstance().emitChange();
    }

    return emitChange;
  }(),
  on: function () {
    function on(lifecycleEvent, handler) {
      if (lifecycleEvent === 'error') this.handlesOwnErrors = true;
      var bus = this.lifecycleEvents[lifecycleEvent] || (0, _transmitter2['default'])();
      this.lifecycleEvents[lifecycleEvent] = bus;
      return bus.subscribe(handler.bind(this));
    }

    return on;
  }(),
  bindAction: function () {
    function bindAction(symbol, handler) {
      if (!symbol) {
        throw new ReferenceError('Invalid action reference passed in');
      }
      if (!fn.isFunction(handler)) {
        throw new TypeError('bindAction expects a function');
      }

      // You can pass in the constant or the function itself
      var key = symbol.id ? symbol.id : symbol;
      this.actionListeners[key] = this.actionListeners[key] || [];
      this.actionListeners[key].push(handler.bind(this));
      this.boundListeners.push(key);
    }

    return bindAction;
  }(),
  bindActions: function () {
    function bindActions(actions) {
      var _this3 = this;

      fn.eachObject(function (action, symbol) {
        var matchFirstCharacter = /./;
        var assumedEventHandler = action.replace(matchFirstCharacter, function (x) {
          return 'on' + String(x[0].toUpperCase());
        });

        if (_this3[action] && _this3[assumedEventHandler]) {
          // If you have both action and onAction
          throw new ReferenceError('You have multiple action handlers bound to an action: ' + (String(action) + ' and ' + String(assumedEventHandler)));
        }

        var handler = _this3[action] || _this3[assumedEventHandler];
        if (handler) {
          _this3.bindAction(symbol, handler);
        }
      }, [actions]);
    }

    return bindActions;
  }(),
  bindListeners: function () {
    function bindListeners(obj) {
      var _this4 = this;

      fn.eachObject(function (methodName, symbol) {
        var listener = _this4[methodName];

        if (!listener) {
          throw new ReferenceError(String(methodName) + ' defined but does not exist in ' + String(_this4.displayName));
        }

        if (Array.isArray(symbol)) {
          symbol.forEach(function (action) {
            _this4.bindAction(action, listener);
          });
        } else {
          _this4.bindAction(symbol, listener);
        }
      }, [obj]);
    }

    return bindListeners;
  }()
};

exports['default'] = StoreMixin;
module.exports = exports['default'];

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = makeAction;

var _functions = __webpack_require__(24);

var fn = _interopRequireWildcard(_functions);

var _AltUtils = __webpack_require__(54);

var utils = _interopRequireWildcard(_AltUtils);

var _isPromise = __webpack_require__(148);

var _isPromise2 = _interopRequireDefault(_isPromise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

function makeAction(alt, namespace, name, implementation, obj) {
  var id = utils.uid(alt._actionsRegistry, String(namespace) + '.' + String(name));
  alt._actionsRegistry[id] = 1;

  var data = { id: id, namespace: namespace, name: name };

  var dispatch = function dispatch(payload) {
    return alt.dispatch(id, payload, data);
  };

  // the action itself
  var action = function action() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var invocationResult = implementation.apply(obj, args);
    var actionResult = invocationResult;

    // async functions that return promises should not be dispatched
    if (invocationResult !== undefined && !(0, _isPromise2['default'])(invocationResult)) {
      if (fn.isFunction(invocationResult)) {
        // inner function result should be returned as an action result
        actionResult = invocationResult(dispatch, alt);
      } else {
        dispatch(invocationResult);
      }
    }

    if (invocationResult === undefined) {
      utils.warn('An action was called but nothing was dispatched');
    }

    return actionResult;
  };
  action.defer = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return setTimeout(function () {
      return action.apply(null, args);
    });
  };
  action.id = id;
  action.data = data;

  // ensure each reference is unique in the namespace
  var container = alt.actions[namespace];
  var namespaceId = utils.uid(container, name);
  container[namespaceId] = action;

  // generate a constant
  var constant = utils.formatAsConstant(namespaceId);
  container[constant] = id;

  return action;
}
module.exports = exports['default'];

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _attdHeader = __webpack_require__(153);

var _attdHeader2 = _interopRequireDefault(_attdHeader);

var _attdBody = __webpack_require__(155);

var _attdBody2 = _interopRequireDefault(_attdBody);

var _attdAction = __webpack_require__(19);

var _attdAction2 = _interopRequireDefault(_attdAction);

var _attdStore = __webpack_require__(25);

var _attdStore2 = _interopRequireDefault(_attdStore);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Attendance = function (_React$Component) {
    _inherits(Attendance, _React$Component);

    function Attendance(props) {
        _classCallCheck(this, Attendance);

        var _this = _possibleConstructorReturn(this, (Attendance.__proto__ || Object.getPrototypeOf(Attendance)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.state = {
            staffs: _filterStore2.default.getState().staffs,
            processingFilter: _filterStore2.default.getState().processing,
            iniLoadStaff: _filterStore2.default.getState().iniLoadStaff,
            iniLoadTeamMember: _filterStore2.default.getState().iniLoadTeamMember,
            teamMember: _filterStore2.default.getState().teamMember,

            processing: _attdStore2.default.getState().processing,
            search: _attdStore2.default.getState().search,

            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId
        };
        return _this;
    }

    _createClass(Attendance, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _attdStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);
            _userStore2.default.listen(this.onUserChange);
            if (!this.state.processingFilter && !this.state.iniLoadStaff) {
                _filterAction2.default.processing.defer(true);
                _filterAction2.default.getEmployee.defer();
            }
            if (!this.state.iniLoadTeamMember) {
                _filterAction2.default.getTeamMember.defer();
            }
            _menuAction2.default.pageNumber.defer(1);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _attdStore2.default.unlisten(this.onChange);
            _filterStore2.default.unlisten(this.onFilterChange);
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                staffs: state.staffs,
                processingFilter: state.processing,
                iniLoadStaff: state.iniLoadStaff,
                iniLoadTeamMember: state.iniLoadTeamMember,
                teamMember: state.teamMember
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                search: state.search
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var staffs = this.state.staffs;

            if (this.state.staffs.length > 0) {
                //filter staffs;
                var isOutsider = this.state.userId && this.state.userId.includes("TG0");
                if (isOutsider) {
                    staffs = staffs.filter(function (staff) {
                        return staff.staffId && staff.staffId.includes("TG0");
                    });
                }
                staffs = staffs.filter(function (staff) {
                    return _genFunction2.default.hasPermission(_this2.state.permission, 0) || _genFunction2.default.isSubordinate(_this2.state.subordinate, staff.staffId) || _genFunction2.default.isUser(_this2.state.userId, staff.staffId) || _genFunction2.default.isMember(_this2.state.teamMember, staff.staffId);
                });
                staffs = staffs.filter(function (staff) {
                    return staff.userName.toLowerCase().indexOf(_this2.state.search.toLowerCase()) > -1 || staff.staffId.toLowerCase().indexOf(_this2.state.search.toLowerCase()) > -1;
                });
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_navBar2.default, this.props),
                _react2.default.createElement(
                    'div',
                    { className: 'container-fluid content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(_sideMenu2.default, this.props),
                        _react2.default.createElement(
                            'div',
                            { className: ' col-md-10  col-sm-8 atd' },
                            _react2.default.createElement(_attdHeader2.default, null),
                            _react2.default.createElement('div', { className: 'divider' }),
                            _react2.default.createElement(_attdBody2.default, _extends({ staffs: staffs }, this.props))
                        )
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.processingFilter })
            );
        }
    }]);

    return Attendance;
}(_react2.default.Component);

exports.default = Attendance;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var menuStore = function () {
    function menuStore() {
        _classCallCheck(this, menuStore);

        this.bindActions(_menuAction2.default);
        this.selectedId = 0;
        this.isActivityShow = false;
        this.isSettingShow = false;
    }

    _createClass(menuStore, [{
        key: 'onPageNumber',
        value: function onPageNumber(data) {
            this.selectedId = data;
        }
    }, {
        key: 'onActivityShow',
        value: function onActivityShow(data) {
            this.isActivityShow = data;
        }
    }, {
        key: 'onSettingShow',
        value: function onSettingShow(data) {
            this.isSettingShow = data;
        }
    }]);

    return menuStore;
}();

exports.default = _alt2.default.createStore(menuStore, 'menuStore');

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

var _modalStore = __webpack_require__(152);

var _modalStore2 = _interopRequireDefault(_modalStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalGeneral = function (_React$Component) {
    _inherits(ModalGeneral, _React$Component);

    function ModalGeneral(props) {
        _classCallCheck(this, ModalGeneral);

        var _this = _possibleConstructorReturn(this, (ModalGeneral.__proto__ || Object.getPrototypeOf(ModalGeneral)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.state = {
            title: _modalStore2.default.getState().title,
            content: _modalStore2.default.getState().content,
            modalClose: _modalStore2.default.getState().modalClose
        };
        return _this;
    }

    _createClass(ModalGeneral, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _modalStore2.default.listen(this.onChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _modalStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                title: state.title,
                content: state.content,
                modalClose: state.modalClose
            });
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            _modalAction2.default.modalClose(false);
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.state.modalClose ? this.props.styleShow : this.props.styleHide;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'report-modal', style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            this.state.title
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body' },
                        this.state.content
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default single-btn', onClick: this.modalClose },
                            'Ok'
                        )
                    )
                )
            );
        }
    }]);

    return ModalGeneral;
}(_react2.default.Component);

ModalGeneral.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = ModalGeneral;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var modalStore = function () {
    function modalStore() {
        _classCallCheck(this, modalStore);

        this.bindActions(_modalAction2.default);
        this.title = "";
        this.content = "";
        this.modalClose = "";
    }

    _createClass(modalStore, [{
        key: 'onModalClose',
        value: function onModalClose(data) {
            this.modalClose = data;
        }
    }, {
        key: 'onModalContent',
        value: function onModalContent(data) {
            this.title = data.title;
            this.content = data.content;
        }
    }]);

    return modalStore;
}();

exports.default = _alt2.default.createStore(modalStore, 'modalStore');

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _attdFilter = __webpack_require__(154);

var _attdFilter2 = _interopRequireDefault(_attdFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AttdHeader = function (_React$Component) {
    _inherits(AttdHeader, _React$Component);

    function AttdHeader(props) {
        _classCallCheck(this, AttdHeader);

        return _possibleConstructorReturn(this, (AttdHeader.__proto__ || Object.getPrototypeOf(AttdHeader)).call(this, props));
    }

    _createClass(AttdHeader, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-hd' },
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(
                        'b',
                        null,
                        'Summary of Employee Attendance'
                    )
                ),
                _react2.default.createElement(_attdFilter2.default, null),
                _react2.default.createElement('div', { className: 'clear' })
            );
        }
    }]);

    return AttdHeader;
}(_react2.default.Component);

exports.default = AttdHeader;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _attdAction = __webpack_require__(19);

var _attdAction2 = _interopRequireDefault(_attdAction);

var _attdStore = __webpack_require__(25);

var _attdStore2 = _interopRequireDefault(_attdStore);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AttdFilter = function (_React$Component) {
    _inherits(AttdFilter, _React$Component);

    function AttdFilter(props) {
        _classCallCheck(this, AttdFilter);

        var _this = _possibleConstructorReturn(this, (AttdFilter.__proto__ || Object.getPrototypeOf(AttdFilter)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.state = {
            search: _attdStore2.default.getState().search,

            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId
        };
        return _this;
    }

    _createClass(AttdFilter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _attdStore2.default.listen(this.onChange);
            _userStore2.default.listen(this.onUserChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _attdStore2.default.unlisten(this.onChange);
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                search: state.search
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var search = e.target.value;
            _attdAction2.default.search(search);
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {}
    }, {
        key: 'render',
        value: function render() {
            var showAllBtn = "";

            showAllBtn = _react2.default.createElement(
                'div',
                { className: '' },
                _react2.default.createElement(
                    _reactRouterDom.Link,
                    { to: '/staff', className: 'btn btn-primary btn-sm' },
                    'Show Employees/Team Attedance'
                )
            );

            return _react2.default.createElement(
                'div',
                { className: 'row atd-i' },
                _react2.default.createElement(
                    'form',
                    { className: 'form-horizontal' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-4 atd-i-wp' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'empName', className: 'col-xs-3 control-label' },
                            'Employee: '
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'input-group input-group-sm' },
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'empName', placeholder: 'Search Employee by Name or Id', value: this.state.search, onChange: this.handleChange }),
                            _react2.default.createElement(
                                'span',
                                { className: 'input-group-btn' },
                                _react2.default.createElement(
                                    'button',
                                    { className: 'btn btn-default', type: 'button', onClick: this.handleSubmit },
                                    'Search'
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-4 atd-i-wp' },
                        showAllBtn
                    )
                )
            );
        }
    }]);

    return AttdFilter;
}(_react2.default.Component);

exports.default = AttdFilter;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _empCard = __webpack_require__(156);

var _empCard2 = _interopRequireDefault(_empCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AttdBody = function (_React$Component) {
    _inherits(AttdBody, _React$Component);

    function AttdBody(props) {
        _classCallCheck(this, AttdBody);

        return _possibleConstructorReturn(this, (AttdBody.__proto__ || Object.getPrototypeOf(AttdBody)).call(this, props));
    }

    _createClass(AttdBody, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var employeeList = "";
            if (this.props.staffs) {
                employeeList = this.props.staffs.map(function (staff, index) {
                    return _react2.default.createElement(_empCard2.default, { staff: staff, key: index, history: _this2.props.history });
                });
            }

            return _react2.default.createElement(
                'div',
                { className: 'atd-bd-wp' },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-em-lt' },
                    employeeList
                )
            );
        }
    }]);

    return AttdBody;
}(_react2.default.Component);

exports.default = AttdBody;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmpCard = function (_React$Component) {
    _inherits(EmpCard, _React$Component);

    function EmpCard(props) {
        _classCallCheck(this, EmpCard);

        var _this = _possibleConstructorReturn(this, (EmpCard.__proto__ || Object.getPrototypeOf(EmpCard)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(EmpCard, [{
        key: 'handleClick',
        value: function handleClick(e) {
            this.props.history.push('/staff/' + this.props.staff.staffId);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-card', onClick: this.handleClick },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-img-wp' },
                    _react2.default.createElement('img', { className: 'atd-img', src: this.props.staff.userImage })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'atd-nm' },
                    this.props.staff.userName
                )
            );
        }
    }]);

    return EmpCard;
}(_react2.default.Component);

exports.default = EmpCard;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _staffHeader = __webpack_require__(158);

var _staffHeader2 = _interopRequireDefault(_staffHeader);

var _staffBody = __webpack_require__(160);

var _staffBody2 = _interopRequireDefault(_staffBody);

var _attdAction = __webpack_require__(19);

var _attdAction2 = _interopRequireDefault(_attdAction);

var _attdStore = __webpack_require__(25);

var _attdStore2 = _interopRequireDefault(_attdStore);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _allBody = __webpack_require__(69);

var _allBody2 = _interopRequireDefault(_allBody);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AttendanceIndividual = function (_React$Component) {
    _inherits(AttendanceIndividual, _React$Component);

    function AttendanceIndividual(props) {
        _classCallCheck(this, AttendanceIndividual);

        var _this = _possibleConstructorReturn(this, (AttendanceIndividual.__proto__ || Object.getPrototypeOf(AttendanceIndividual)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.state = {
            staffAtd: _attdStore2.default.getState().staffAtd,
            selectedYear: _attdStore2.default.getState().selectedYear,
            selectedMonth: _attdStore2.default.getState().selectedMonth,
            processing: _attdStore2.default.getState().processing,
            displayMode: 0,
            role: _userStore2.default.getState().role,

            filterProcessing: _filterStore2.default.getState().processing,
            iniLoadHoliday: _filterStore2.default.getState().iniLoadHoliday,
            holiday: _filterStore2.default.getState().holiday
        };
        return _this;
    }

    _createClass(AttendanceIndividual, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _attdStore2.default.listen(this.onChange);
            _userStore2.default.listen(this.onUserChange);
            _filterStore2.default.listen(this.onFilterChange);
            _menuAction2.default.pageNumber.defer(-1);

            if (!this.state.processing) {
                _attdAction2.default.processing(true);
                _attdAction2.default.getStaffAttendance(this.props.match.params.id, this.state.selectedYear, this.state.selectedMonth);
            }
            if (!this.state.filterProcessing && !this.state.iniLoadHoliday) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getHoliday();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _attdStore2.default.unlisten(this.onChange);
            _userStore2.default.unlisten(this.onUserChange);
            _filterStore2.default.unlisten(this.onFilterChange);
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                role: state.role
            });
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                filterProcessing: state.processing,
                iniLoadHoliday: state.iniLoadHoliday,
                holiday: state.holiday
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                staffAtd: state.staffAtd,
                selectedMonth: state.selectedMonth,
                selectedYear: state.selectedYear,
                processing: state.processing
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.currentTarget.getAttribute('data-index'));

            this.setState({ displayMode: index });
        }
    }, {
        key: 'render',
        value: function render() {
            var bodyDisplay = '';
            if (this.state.displayMode == 0) {
                bodyDisplay = _react2.default.createElement(_allBody2.default, { staffsAtd: this.state.staffAtd != "" ? [this.state.staffAtd] : [], useFor: 1, role: this.state.role, processing: this.state.processing });
            } else {
                bodyDisplay = _react2.default.createElement(_staffBody2.default, { staffAtd: this.state.staffAtd, selectedYear: this.state.selectedYear, selectedMonth: this.state.selectedMonth, holiday: this.state.holiday });
            }

            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 atd' },
                        _react2.default.createElement(_staffHeader2.default, { staffAtd: this.state.staffAtd, staffId: this.props.match.params.id, selectedYear: this.state.selectedYear, selectedMonth: this.state.selectedMonth }),
                        _react2.default.createElement('div', { className: 'divider' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-i-dp' },
                            _react2.default.createElement(
                                'div',
                                { className: 'atd-dis' },
                                'Mode: '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'btn-group', role: 'group' },
                                _react2.default.createElement(
                                    'button',
                                    { className: "btn btn-default " + (this.state.displayMode == 0 ? "active" : ""), 'data-index': '0', onClick: this.handleClick },
                                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-th-list' })
                                ),
                                _react2.default.createElement(
                                    'button',
                                    { className: "btn btn-default " + (this.state.displayMode == 1 ? "active" : ""), 'data-index': '1', onClick: this.handleClick },
                                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-th' })
                                )
                            )
                        ),
                        bodyDisplay
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.filterProcessing })
            );
        }
    }]);

    return AttendanceIndividual;
}(_react2.default.Component);

exports.default = AttendanceIndividual;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _staffFilter = __webpack_require__(159);

var _staffFilter2 = _interopRequireDefault(_staffFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaffHeader = function (_React$Component) {
    _inherits(StaffHeader, _React$Component);

    function StaffHeader(props) {
        _classCallCheck(this, StaffHeader);

        return _possibleConstructorReturn(this, (StaffHeader.__proto__ || Object.getPrototypeOf(StaffHeader)).call(this, props));
    }

    _createClass(StaffHeader, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-hd' },
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(
                        'b',
                        null,
                        'Summary of ',
                        this.props.staffAtd ? this.props.staffAtd.userName : "Employee",
                        '\'s Attendance'
                    )
                ),
                _react2.default.createElement(_staffFilter2.default, { staffId: this.props.staffId, selectedYear: this.props.selectedYear, selectedMonth: this.props.selectedMonth }),
                _react2.default.createElement('div', { className: 'clear' })
            );
        }
    }]);

    return StaffHeader;
}(_react2.default.Component);

exports.default = StaffHeader;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _attdAction = __webpack_require__(19);

var _attdAction2 = _interopRequireDefault(_attdAction);

var _attdStore = __webpack_require__(25);

var _attdStore2 = _interopRequireDefault(_attdStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaffFilter = function (_React$Component) {
    _inherits(StaffFilter, _React$Component);

    function StaffFilter(props) {
        _classCallCheck(this, StaffFilter);

        var _this = _possibleConstructorReturn(this, (StaffFilter.__proto__ || Object.getPrototypeOf(StaffFilter)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handlePrint = _this.handlePrint.bind(_this);
        _this.handleExport = _this.handleExport.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.state = {
            processing: _attdStore2.default.getState().processing,
            iniYear: 2017,
            iniMonth: 11,
            selectedYear: _attdStore2.default.getState().selectedYear,
            selectedMonth: _attdStore2.default.getState().selectedMonth
        };
        return _this;
    }

    _createClass(StaffFilter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _attdStore2.default.listen(this.onChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _attdStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                selectedYear: state.selectedYear,
                selectedMonth: state.selectedMonth
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var value = e.target.value.split(":");
            var selectedYear = parseInt(value[0]);
            var selectedMonth = parseInt(value[1]);
            _attdAction2.default.selectedMonth({ selectedYear: selectedYear, selectedMonth: selectedMonth });

            if (!this.state.processing) {
                _attdAction2.default.processing(true);
                _attdAction2.default.getStaffAttendance(this.props.staffId, selectedYear, selectedMonth);
            }
        }
    }, {
        key: 'handlePrint',
        value: function handlePrint() {
            window.print();
        }
    }, {
        key: 'handleExport',
        value: function handleExport() {
            if (!this.state.processing) {
                _attdAction2.default.processing(true);
                _attdAction2.default.exportStaffAttendance(this.props.staffId, this.state.selectedYear, this.state.selectedMonth);
            }
        }
    }, {
        key: 'renderOption',
        value: function renderOption(yr, mth) {
            var isSelected = yr == this.props.selectedYear && mth == this.props.selectedMonth ? true : false;
            return _react2.default.createElement(
                'option',
                { value: yr + ":" + mth, key: yr + ":" + mth },
                this.props.mthTxt[mth] + " " + yr
            );
        }
    }, {
        key: 'renderOptions',
        value: function renderOptions() {
            var options = [];
            var thisYear = new Date().getFullYear();
            var thisMonth = new Date().getMonth();

            for (var yr = thisYear; yr >= this.state.iniYear; yr--) {
                if (thisYear == this.state.iniYear) {
                    for (var mth = thisMonth; mth >= this.state.iniMonth; mth--) {
                        options = options.concat(this.renderOption(yr, mth));
                    }
                } else if (yr == thisYear) {
                    for (var _mth = thisMonth; _mth >= 0; _mth--) {
                        options = options.concat(this.renderOption(yr, _mth));
                    }
                } else if (yr == this.state.iniYear) {
                    for (var _mth2 = 11; _mth2 >= this.state.iniMonth; _mth2--) {
                        options = options.concat(this.renderOption(yr, _mth2));
                    }
                } else {
                    for (var _mth3 = 11; _mth3 >= 0; _mth3--) {
                        options = options.concat(this.renderOption(yr, _mth3));
                    }
                }
            }
            return options;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'row atd-i' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-5 col-md-5 col-lg-3' },
                    _react2.default.createElement(
                        'form',
                        { className: 'form-horizontal atd-i-wp' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'empName', className: 'col-sm-4 control-label' },
                            'Select Month: '
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'input-group input-group-sm' },
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control', onChange: this.handleChange, value: this.state.selectedYear + ":" + this.state.selectedMonth },
                                this.renderOptions()
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-4' },
                    _react2.default.createElement(
                        'div',
                        { className: 'atd-i-btn' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-primary btn-sm', onClick: this.handleExport },
                            'Export'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'atd-i-btn' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-primary btn-sm', onClick: this.handlePrint },
                            'Print'
                        )
                    )
                )
            );
        }
    }]);

    return StaffFilter;
}(_react2.default.Component);

StaffFilter.defaultProps = {
    mthTxt: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
exports.default = StaffFilter;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _staffCal = __webpack_require__(161);

var _staffCal2 = _interopRequireDefault(_staffCal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaffBody = function (_React$Component) {
    _inherits(StaffBody, _React$Component);

    function StaffBody(props) {
        _classCallCheck(this, StaffBody);

        return _possibleConstructorReturn(this, (StaffBody.__proto__ || Object.getPrototypeOf(StaffBody)).call(this, props));
    }

    _createClass(StaffBody, [{
        key: 'render',
        value: function render() {
            var year = this.props.selectedYear ? this.props.selectedYear : new Date().getFullYear();
            var month = typeof this.props.selectedMonth == 'number' ? this.props.selectedMonth : new Date().getMonth();

            var start_day = new Date(year, month, 1).getDay();
            var last_date = new Date(year, month + 1, 0).getDate();
            var last_wk = Math.ceil((last_date + start_day) / 7);

            return _react2.default.createElement(
                'div',
                { className: 'cal-bd-wp' },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-bd-tt' },
                    _react2.default.createElement(
                        'h3',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            this.props.staffAtd ? this.props.staffAtd.userName : "",
                            ' \xA0 (',
                            this.props.monthTxt[this.props.selectedMonth] + " " + this.props.selectedYear,
                            ')'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cal-bd' },
                    _react2.default.createElement(
                        'table',
                        { className: 'cal-tb' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Sun'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Mon'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Tue'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Wed'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Thu'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Fri'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Sat'
                                )
                            )
                        ),
                        _react2.default.createElement(_staffCal2.default, {
                            holiday: this.props.holiday,
                            year: this.props.selectedYear,
                            month: this.props.selectedMonth,
                            staffAtd: this.props.staffAtd,
                            start_day: start_day,
                            last_date: last_date,
                            last_wk: last_wk
                        })
                    )
                )
            );
        }
    }]);

    return StaffBody;
}(_react2.default.Component);

StaffBody.defaultProps = {
    monthTxt: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
exports.default = StaffBody;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaffCal = function (_React$Component) {
    _inherits(StaffCal, _React$Component);

    function StaffCal(props) {
        _classCallCheck(this, StaffCal);

        return _possibleConstructorReturn(this, (StaffCal.__proto__ || Object.getPrototypeOf(StaffCal)).call(this, props));
    }

    _createClass(StaffCal, [{
        key: 'getTime',
        value: function getTime(day) {
            var startTime = '';
            var endTime = '';
            var type = '';
            var len = this.props.staffAtd && this.props.staffAtd.attendance ? this.props.staffAtd.attendance.length : 0;
            var result = void 0;
            var sTime = void 0,
                eTime = void 0;

            for (var i = 0; i < len; i++) {
                if (this.props.staffAtd.attendance[i].date == day) {
                    var atd = this.props.staffAtd.attendance[i];
                    //if onleave that day
                    if (typeof this.props.staffAtd.attendance[i].type == 'number') {
                        if (atd.type != 7) {
                            type = atd.leaveTxt + " (" + this.props.durationTxt[atd.duration] + ")";
                        } else {

                            type = atd.leaveTxt + " (" + (atd.startTime ? atd.startTime + " ~ " + atd.endTime : "-") + ")";
                        }
                    } else {
                        if (atd.startTime) {
                            if (atd.startTime) {
                                atd.startTime = new Date(atd.startTime);
                                var timeInMinute = atd.startTime.getMinutes() < 10 ? "0" + atd.startTime.getMinutes() : atd.startTime.getMinutes();
                                sTime = atd.startTime.getHours() + ":" + timeInMinute;
                                startTime += startTime != "" ? "\n" + sTime : sTime;
                            } else {
                                startTime += startTime != "" ? "\n" + "--" : "--";
                            }
                            if (atd.endTime) {
                                atd.endTime = new Date(atd.endTime);
                                var timeOutMinute = atd.endTime.getMinutes() < 10 ? "0" + atd.endTime.getMinutes() : atd.endTime.getMinutes();
                                eTime = atd.endTime.getHours() + ":" + timeOutMinute;
                                endTime += endTime != "" ? "\n" + eTime : eTime;
                            } else {
                                endTime += endTime != "" ? "\n" + "--" : "--";
                            }
                        }
                    }
                    result = { type: type, startTime: startTime, endTime: endTime };
                }
            }
            return result;
        }
    }, {
        key: 'isToday',
        value: function isToday(date) {
            var today = new Date();
            if (this.props.year == today.getFullYear() && this.props.month == today.getMonth() && date == today.getDate()) {
                return true;
            }
            return false;
        }
    }, {
        key: 'getHoliday',
        value: function getHoliday(year, month, date) {
            var content = [];
            var isHoliday = false;
            if (this.props.holiday) {
                if (this.props.holiday.holiday) {
                    var s = this.props.holiday;

                    s.holiday.map(function (holiday, index) {
                        if (holiday.year == year && holiday.month == month && holiday.date == date) {
                            isHoliday = true;
                            content = content.concat(_react2.default.createElement(
                                'div',
                                { className: 'a-i-lt', key: index },
                                holiday.title
                            ));
                        }
                    });
                    if (s.event) {
                        s.event.map(function (event, index) {
                            if (event.year == year && event.month == month && event.date == date) {
                                content = content.concat(_react2.default.createElement(
                                    'div',
                                    { className: 'lv-e', key: "e" + index },
                                    _react2.default.createElement(
                                        'b',
                                        null,
                                        event.title
                                    )
                                ));
                            }
                        });
                    }
                }
            }

            return { content: content, isHoliday: isHoliday };
        }
    }, {
        key: 'renderRow',
        value: function renderRow(wk) {
            var day_row = [];
            for (var dy = 0; dy < 7; dy++) {
                if (wk == 0 && dy < this.props.start_day) {
                    day_row = day_row.concat(_react2.default.createElement('td', { className: 'cal-dis', key: "e" + (wk * 7 + dy) }));
                } else if (wk * 7 + dy + 1 - this.props.start_day > this.props.last_date) {
                    day_row = day_row.concat(_react2.default.createElement('td', { className: 'cal-dis', key: "e" + (wk * 7 + dy) }));
                } else {
                    var date = wk * 7 + dy + 1 - this.props.start_day;
                    var isToday = this.isToday(date);
                    var attendance = this.getTime(date);
                    var startTime = void 0,
                        endTime = void 0;
                    if (attendance) {
                        startTime = attendance.startTime ? attendance.startTime : "--";
                        endTime = attendance.endTime ? attendance.endTime : "--";
                    }
                    var displayTime = "";
                    var displayLeave = "";
                    var displayHoliday = "";

                    if (attendance) {
                        if (attendance.startTime) {
                            displayTime = _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'startTime' },
                                    _react2.default.createElement(
                                        'b',
                                        null,
                                        'Time In'
                                    ),
                                    _react2.default.createElement('br', null),
                                    _react2.default.createElement(
                                        'pre',
                                        null,
                                        startTime
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'endTime' },
                                    _react2.default.createElement(
                                        'b',
                                        null,
                                        'Time Out'
                                    ),
                                    _react2.default.createElement('br', null),
                                    _react2.default.createElement(
                                        'pre',
                                        null,
                                        endTime
                                    )
                                )
                            );
                        }
                        if (attendance.type) {
                            displayLeave = _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'a-i-lt' },
                                    attendance.type
                                )
                            );
                        }
                    }

                    displayHoliday = this.getHoliday(this.props.year, this.props.month, date);

                    var className = void 0;
                    if (isToday) {
                        className = "cal-tdy cal-dy ";
                    } else {
                        className = "cal-dy ";
                    }
                    if (displayHoliday.isHoliday) {
                        className += "cal-hdy";
                    }

                    day_row = day_row.concat(_react2.default.createElement(
                        'td',
                        { className: className, key: date },
                        _react2.default.createElement(
                            'div',
                            { className: 'cal-date' },
                            date
                        ),
                        displayHoliday.content,
                        displayLeave,
                        displayTime
                    ));
                }
            }

            return _react2.default.createElement(
                'tr',
                { key: "wk-" + wk },
                day_row
            );
        }
    }, {
        key: 'render',
        value: function render() {

            var calender = [];
            for (var wk = 0; wk < this.props.last_wk; wk++) {
                calender = calender.concat(this.renderRow(wk));
            }

            return _react2.default.createElement(
                'tbody',
                null,
                calender
            );
        }
    }]);

    return StaffCal;
}(_react2.default.Component);

StaffCal.defaultProps = {
    typeTxt: ["Annual Leave", "Medical Leave", "Reservist", "Childcare leave", "Unpaid leave", "Compassionate leave", "Other Leave", "Time-off", "Tele-commuting"],
    durationTxt: ["Full", "Am", "Pm"]
};
exports.default = StaffCal;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _attdAction = __webpack_require__(19);

var _attdAction2 = _interopRequireDefault(_attdAction);

var _attdModal = __webpack_require__(163);

var _attdModal2 = _interopRequireDefault(_attdModal);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

var _http = __webpack_require__(70);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AllList = function (_React$Component) {
    _inherits(AllList, _React$Component);

    function AllList(props) {
        _classCallCheck(this, AllList);

        var _this = _possibleConstructorReturn(this, (AllList.__proto__ || Object.getPrototypeOf(AllList)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        _this.showOption = _this.showOption.bind(_this);
        _this.closeOption = _this.closeOption.bind(_this);
        _this.handleOption = _this.handleOption.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.updateAttandance = _this.updateAttandance.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.state = {
            staffId: "",
            year: "",
            month: "",
            date: "",
            modalClose: false,
            title: "Edit Time in / Time Out",
            timeIn: "",
            timeOut: "",
            dateTxt: "",
            startRemark: "",
            endRemark: "",

            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId
        };
        return _this;
    }

    _createClass(AllList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _userStore2.default.listen(this.onChange);
            window.addEventListener("click", this.closeOption);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _userStore2.default.unlisten(this.onChange);
            window.removeEventListener("click", this.closeOption);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'handleOption',
        value: function handleOption(e) {
            var index = parseInt(e.currentTarget.getAttribute("data-index"));
            var staffId = e.currentTarget.getAttribute("data-staffid");
            var _id = e.currentTarget.getAttribute("data-id");
            var year = e.currentTarget.getAttribute("data-year");
            var month = e.currentTarget.getAttribute("data-month");
            var date = e.currentTarget.getAttribute("data-date");
            var timeIn = e.currentTarget.getAttribute("data-timein");
            var timeOut = e.currentTarget.getAttribute("data-timeout");
            var dateTxt = e.currentTarget.getAttribute("data-datetxt");
            var startRemark = e.currentTarget.getAttribute("data-startremark");
            var endRemark = e.currentTarget.getAttribute("data-endremark");
            this.setState({
                _id: _id,
                staffId: staffId,
                year: year,
                month: month,
                date: date,
                timeIn: timeIn,
                timeOut: timeOut,
                dateTxt: dateTxt,
                startRemark: startRemark,
                endRemark: endRemark,
                modalClose: true
            });

            _attdAction2.default.shouldDDListShow({ index: index, useFor: this.props.useFor, staffId: staffId });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.currentTarget.getAttribute('data-index'));
            index = index + this.props.page * this.props.contentNo;
            _attdAction2.default.shouldListShow({ index: index, useFor: this.props.useFor });
        }
    }, {
        key: 'updateAttandance',
        value: function updateAttandance(timeIn, timeOut, startRemark, endRemark) {
            if (this.props.processing) return;
            var startTime = void 0,
                endTime = void 0;
            if (timeIn) {
                startTime = new Date(this.state.year, this.state.month, this.state.date, timeIn.split(":")[0], timeIn.split(":")[1]).getTime();
            }
            if (timeOut) {
                endTime = new Date(this.state.year, this.state.month, this.state.date, timeOut.split(":")[0], timeOut.split(":")[1]).getTime();
            }
            this.setState({ modalClose: false });
            _attdAction2.default.processing(true);
            _attdAction2.default.updateAttandance(this.state._id, this.state.staffId, this.state.year, this.state.month, this.state.date, startTime, endTime, startRemark, endRemark);
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose() {
            this.setState({
                modalClose: false
            });
        }
    }, {
        key: 'renderNameList',
        value: function renderNameList(staff, index) {
            return _react2.default.createElement(
                'div',
                { className: 'atd-a-nlw', style: { width: this.props.tableWidth + "px" } },
                _react2.default.createElement('i', { className: "atd-a-nli " + (staff.shouldListShow ? "glyphicon glyphicon-minus" : "glyphicon glyphicon-plus"),
                    onClick: this.handleClick, 'data-index': index }),
                _react2.default.createElement(
                    'div',
                    { className: 'atd-a-nl atd-a-n', onClick: this.handleClick, 'data-index': index },
                    staff.userName
                )
            );
        }
    }, {
        key: 'renderDataList',
        value: function renderDataList(staff) {
            var _this2 = this;

            if (!staff.attendance) return;

            var dateList = staff.attendance.map(function (attendance, index) {
                var display1 = "--",
                    display2 = "--",
                    display3 = "--",
                    display4 = "--",
                    display5 = "--";
                var dateTxt = attendance.date + "-" + _this2.props.mthTxt[attendance.month] + "-" + attendance.year;

                if (typeof attendance.type == 'number') {
                    if (attendance.type != 7) {
                        display3 = attendance.leaveTxt + " (" + _this2.props.durationTxt[attendance.duration] + ")";
                    } else {
                        display3 = attendance.leaveTxt + " (" + (attendance.startTime ? attendance.startTime + "~" : "-") + (attendance.endTime ? attendance.endTime : "-") + ")";
                    }
                } else {
                    display3 = "--";
                    if (attendance.startTime) {
                        attendance.startTime = new Date(attendance.startTime);
                        var timeInHour = attendance.startTime.getHours() < 10 ? "0" + attendance.startTime.getHours() : attendance.startTime.getHours();
                        var timeInMinute = attendance.startTime.getMinutes() < 10 ? "0" + attendance.startTime.getMinutes() : attendance.startTime.getMinutes();
                        display1 = timeInHour + ":" + timeInMinute;
                        display4 = attendance.startRemark ? attendance.startRemark : "--";
                    } else {
                        display1 = "--";
                        attendance.startLocation = "--";
                        display4 = "--";
                    }
                    if (attendance.endTime) {
                        attendance.endTime = new Date(attendance.endTime);
                        var timeOutHour = attendance.endTime.getHours() < 10 ? "0" + attendance.endTime.getHours() : attendance.endTime.getHours();
                        var timeOutMinute = attendance.endTime.getMinutes() < 10 ? "0" + attendance.endTime.getMinutes() : attendance.endTime.getMinutes();
                        display2 = timeOutHour + ":" + timeOutMinute;
                        display5 = attendance.endRemark ? attendance.endRemark : "--";
                    } else {
                        display2 = "--";
                        attendance.endLocation = "--";
                        display5 = "--";
                    }
                }

                return _react2.default.createElement(
                    'tr',
                    { key: index },
                    _react2.default.createElement(
                        'td',
                        null,
                        staff.staffId
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        staff.userName
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        dateTxt
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        display1
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        attendance.startLocation
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        display4
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        display2
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        attendance.endLocation
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        display5
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        display3
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        attendance.totalHours ? Math.round(attendance.totalHours * 100) / 100 : "--"
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        attendance.otHours ? Math.round(attendance.otHours * 100) / 100 : "--"
                    ),
                    _react2.default.createElement(
                        'td',
                        null,
                        (_genFunction2.default.hasPermission(_this2.state.permission, 0) && !_genFunction2.default.isUser(_this2.state.userId, staff.staffId) || _genFunction2.default.isSubordinate(_this2.state.subordinate, attendance.staffId)) && typeof attendance.type != 'number' ? _react2.default.createElement('span', { className: 'atd-edit glyphicon glyphicon-option-vertical', 'data-index': index, 'data-id': staff.staffId, onClick: _this2.showOption }) : "",
                        _this2.renderEdit(index, staff, attendance, display1, display2, dateTxt, attendance.startRemark, attendance.endRemark)
                    )
                );
            });

            return _react2.default.createElement(
                'table',
                { className: 'atd-a-tb' },
                _react2.default.createElement(
                    'tbody',
                    { className: "atd-a-tb " + (staff.shouldListShow ? "atd-show" : "atd-hide") },
                    dateList
                )
            );
        }
    }, {
        key: 'showOption',
        value: function showOption(e) {
            e.preventDefault();
            e.stopPropagation();

            var index = parseInt(e.currentTarget.getAttribute('data-index'));
            //index = index + this.props.page * this.props.contentNo;
            var staffId = e.currentTarget.getAttribute("data-id");
            _attdAction2.default.shouldDDListShow({ index: index, useFor: this.props.useFor, staffId: staffId });
        }
    }, {
        key: 'closeOption',
        value: function closeOption() {
            _attdAction2.default.closeListShow();
        }
    }, {
        key: 'renderEdit',
        value: function renderEdit(index, staff, attendance, timeIn, timeOut, dateTxt, startRemark, endRemark) {
            if (!_genFunction2.default.hasPermission(this.state.permission, 0) && !_genFunction2.default.isSubordinate(this.state.subordinate, attendance.staffId)) return;
            if (_genFunction2.default.isUser(this.state.userId, staff.staffId)) return;
            if (typeof attendance.type == 'number') return;

            return _react2.default.createElement(
                'ul',
                { className: "atd-dropdown " + (attendance.shouldDDListShow ? "atd-show" : "atd-hide") },
                _react2.default.createElement(
                    'li',
                    { 'data-staffid': staff.staffId, 'data-id': attendance._id,
                        'data-year': attendance.year, 'data-month': attendance.month,
                        'data-timein': timeIn, 'data-timeout': timeOut, 'data-startremark': startRemark, 'data-endremark': endRemark,
                        'data-date': attendance.date, 'data-index': index, 'data-datetxt': dateTxt,
                        onClick: this.handleOption },
                    'Edit attendance'
                )
            );
        }
    }, {
        key: 'renderTotalHour',
        value: function renderTotalHour(staff) {
            return _react2.default.createElement(
                'div',
                { className: "atd-th " + (staff.shouldListShow ? "atd-show" : "atd-hide"), style: { width: this.props.tableWidth + "px" } },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-th-tt' },
                    'Total Hours Spent On Locations: ',
                    staff.totalHours ? Math.floor(staff.totalHours) : "-",
                    ' hours'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'atd-th-ct' },
                    staff.totalHours ? Math.round((staff.totalHours - Math.floor(staff.totalHours)) * 60) + " minutes" : ""
                )
            );
        }
    }, {
        key: 'renderMainList',
        value: function renderMainList() {
            var _this3 = this;

            if (this.props.staffsAtd.length > 0 && this.props.staffsAtd[0]) {
                return this.props.staffsAtd.map(function (staff, index) {
                    return _react2.default.createElement(
                        'div',
                        { key: index },
                        _this3.renderNameList(staff, index),
                        _this3.renderDataList(staff),
                        _this3.renderTotalHour(staff)
                    );
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var modal = "";
            if (this.state.modalClose) {
                modal = _react2.default.createElement(_attdModal2.default, { modalClose: this.state.modalClose, shouldModalClose: this.shouldModalClose, startRemark: this.state.startRemark,
                    title: this.state.title, dateTxt: this.state.dateTxt, endRemark: this.state.endRemark,
                    callBack: this.updateAttandance, timeIn: this.state.timeIn, timeOut: this.state.timeOut });
            }
            return _react2.default.createElement(
                'div',
                { className: 'atd-abd-wp' },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-em-lt' },
                    this.renderMainList()
                ),
                modal
            );
        }
    }]);

    return AllList;
}(_react2.default.Component);

AllList.defaultProps = {
    mthTxt: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
    typeTxt: ["Annual Leave", "Medical Leave", "Reservist", "Childcare leave", "Unpaid leave", "Compassionate leave", "Other Leave", "Time-off", "Tele-commuting"],
    durationTxt: ["Full", "Am", "Pm"]
};
exports.default = AllList;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AttdModal = function (_React$Component) {
    _inherits(AttdModal, _React$Component);

    function AttdModal(props) {
        _classCallCheck(this, AttdModal);

        var _this = _possibleConstructorReturn(this, (AttdModal.__proto__ || Object.getPrototypeOf(AttdModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.state = {
            txtValue1: "",
            txtValue2: "",
            txtValue3: "",
            txtValue4: "",
            warningMsg: ""
        };
        return _this;
    }

    _createClass(AttdModal, [{
        key: "componentWillMount",
        value: function componentWillMount() {}
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.setState({
                txtValue1: this.props.timeIn,
                txtValue2: this.props.timeOut,
                txtValue3: this.props.startRemark,
                txtValue4: this.props.endRemark,
                warningMsg: ""
            });
        }
    }, {
        key: "handleChange",
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var value = e.target.value;
            if (index == 0) {
                this.setState({ txtValue1: value });
            } else if (index == 1) {
                this.setState({ txtValue2: value });
            } else if (index == 2) {
                this.setState({ txtValue3: value });
            } else if (index == 3) {
                this.setState({ txtValue4: value });
            }
        }
    }, {
        key: "handleSubmit",
        value: function handleSubmit(e) {
            if (this.state.txtValue1 == "") {
                this.setState({ warningMsg: "Time In cannot be empty" });
            } else {
                this.setState({ warningMsg: "" });
                this.props.callBack(this.state.txtValue1, this.state.txtValue2, this.state.txtValue3, this.state.txtValue4);
            }
        }
    }, {
        key: "modalClose",
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: "renderBody",
        value: function renderBody() {
            var body = "";
            body = _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                    "h4",
                    null,
                    this.props.dateTxt
                ),
                _react2.default.createElement(
                    "form",
                    null,
                    _react2.default.createElement(
                        "label",
                        null,
                        " time In"
                    ),
                    _react2.default.createElement("input", { className: "form-control", type: "time", "data-index": "0", onChange: this.handleChange, value: this.state.txtValue1 })
                ),
                _react2.default.createElement(
                    "form",
                    null,
                    _react2.default.createElement(
                        "label",
                        null,
                        " time In Remark"
                    ),
                    _react2.default.createElement("input", { className: "form-control", type: "text", "data-index": "2", onChange: this.handleChange, value: this.state.txtValue3 })
                ),
                _react2.default.createElement(
                    "form",
                    null,
                    _react2.default.createElement(
                        "label",
                        null,
                        " time Out"
                    ),
                    _react2.default.createElement("input", { className: "form-control", type: "time", "data-index": "1", onChange: this.handleChange, value: this.state.txtValue2 })
                ),
                _react2.default.createElement(
                    "form",
                    null,
                    _react2.default.createElement(
                        "label",
                        null,
                        " time Out Remark"
                    ),
                    _react2.default.createElement("input", { className: "form-control", type: "text", "data-index": "3", onChange: this.handleChange, value: this.state.txtValue4 })
                )
            );

            return body;
        }
    }, {
        key: "render",
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            var content = void 0;

            return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement("div", { className: "report-shadow", style: style }),
                _react2.default.createElement(
                    "div",
                    { className: "report-modal", style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        "div",
                        { className: "modal-header" },
                        _react2.default.createElement(
                            "h4",
                            { className: "modal-title" },
                            this.props.title
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "modal-body" },
                        _react2.default.createElement(
                            "div",
                            { className: "warning" },
                            this.state.warningMsg
                        ),
                        this.renderBody()
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "modal-footer" },
                        _react2.default.createElement(
                            "button",
                            { type: "button", className: "btn " + (this.props.action == 3 ? " btn-danger" : "btn-warning"),
                                onClick: this.handleSubmit },
                            this.props.action == 3 ? "Remove" : "Update"
                        ),
                        _react2.default.createElement(
                            "button",
                            { type: "button", className: "btn btn-default", onClick: this.modalClose },
                            "Cancel"
                        )
                    )
                )
            );
        }
    }]);

    return AttdModal;
}(_react2.default.Component);

AttdModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = AttdModal;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer, global, process) {

var capability = __webpack_require__(72);
var inherits = __webpack_require__(27);
var response = __webpack_require__(167);
var stream = __webpack_require__(73);
var toArrayBuffer = __webpack_require__(174);

var IncomingMessage = response.IncomingMessage;
var rStates = response.readyStates;

function decideMode(preferBinary, useFetch) {
	if (capability.fetch && useFetch) {
		return 'fetch';
	} else if (capability.mozchunkedarraybuffer) {
		return 'moz-chunked-arraybuffer';
	} else if (capability.msstream) {
		return 'ms-stream';
	} else if (capability.arraybuffer && preferBinary) {
		return 'arraybuffer';
	} else if (capability.vbArray && preferBinary) {
		return 'text:vbarray';
	} else {
		return 'text';
	}
}

var ClientRequest = module.exports = function (opts) {
	var self = this;
	stream.Writable.call(self);

	self._opts = opts;
	self._body = [];
	self._headers = {};
	if (opts.auth) self.setHeader('Authorization', 'Basic ' + new Buffer(opts.auth).toString('base64'));
	Object.keys(opts.headers).forEach(function (name) {
		self.setHeader(name, opts.headers[name]);
	});

	var preferBinary;
	var useFetch = true;
	if (opts.mode === 'disable-fetch' || 'timeout' in opts) {
		// If the use of XHR should be preferred and includes preserving the 'content-type' header.
		// Force XHR to be used since the Fetch API does not yet support timeouts.
		useFetch = false;
		preferBinary = true;
	} else if (opts.mode === 'prefer-streaming') {
		// If streaming is a high priority but binary compatibility and
		// the accuracy of the 'content-type' header aren't
		preferBinary = false;
	} else if (opts.mode === 'allow-wrong-content-type') {
		// If streaming is more important than preserving the 'content-type' header
		preferBinary = !capability.overrideMimeType;
	} else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') {
		// Use binary if text streaming may corrupt data or the content-type header, or for speed
		preferBinary = true;
	} else {
		throw new Error('Invalid value for opts.mode');
	}
	self._mode = decideMode(preferBinary, useFetch);

	self.on('finish', function () {
		self._onFinish();
	});
};

inherits(ClientRequest, stream.Writable);

ClientRequest.prototype.setHeader = function (name, value) {
	var self = this;
	var lowerName = name.toLowerCase();
	// This check is not necessary, but it prevents warnings from browsers about setting unsafe
	// headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
	// http-browserify did it, so I will too.
	if (unsafeHeaders.indexOf(lowerName) !== -1) return;

	self._headers[lowerName] = {
		name: name,
		value: value
	};
};

ClientRequest.prototype.getHeader = function (name) {
	var header = this._headers[name.toLowerCase()];
	if (header) return header.value;
	return null;
};

ClientRequest.prototype.removeHeader = function (name) {
	var self = this;
	delete self._headers[name.toLowerCase()];
};

ClientRequest.prototype._onFinish = function () {
	var self = this;

	if (self._destroyed) return;
	var opts = self._opts;

	var headersObj = self._headers;
	var body = null;
	if (opts.method !== 'GET' && opts.method !== 'HEAD') {
		if (capability.blobConstructor) {
			body = new global.Blob(self._body.map(function (buffer) {
				return toArrayBuffer(buffer);
			}), {
				type: (headersObj['content-type'] || {}).value || ''
			});
		} else {
			// get utf8 string
			body = Buffer.concat(self._body).toString();
		}
	}

	// create flattened list of headers
	var headersList = [];
	Object.keys(headersObj).forEach(function (keyName) {
		var name = headersObj[keyName].name;
		var value = headersObj[keyName].value;
		if (Array.isArray(value)) {
			value.forEach(function (v) {
				headersList.push([name, v]);
			});
		} else {
			headersList.push([name, value]);
		}
	});

	if (self._mode === 'fetch') {
		global.fetch(self._opts.url, {
			method: self._opts.method,
			headers: headersList,
			body: body || undefined,
			mode: 'cors',
			credentials: opts.withCredentials ? 'include' : 'same-origin'
		}).then(function (response) {
			self._fetchResponse = response;
			self._connect();
		}, function (reason) {
			self.emit('error', reason);
		});
	} else {
		var xhr = self._xhr = new global.XMLHttpRequest();
		try {
			xhr.open(self._opts.method, self._opts.url, true);
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err);
			});
			return;
		}

		// Can't set responseType on really old browsers
		if ('responseType' in xhr) xhr.responseType = self._mode.split(':')[0];

		if ('withCredentials' in xhr) xhr.withCredentials = !!opts.withCredentials;

		if (self._mode === 'text' && 'overrideMimeType' in xhr) xhr.overrideMimeType('text/plain; charset=x-user-defined');

		if ('timeout' in opts) {
			xhr.timeout = opts.timeout;
			xhr.ontimeout = function () {
				self.emit('timeout');
			};
		}

		headersList.forEach(function (header) {
			xhr.setRequestHeader(header[0], header[1]);
		});

		self._response = null;
		xhr.onreadystatechange = function () {
			switch (xhr.readyState) {
				case rStates.LOADING:
				case rStates.DONE:
					self._onXHRProgress();
					break;
			}
		};
		// Necessary for streaming in Firefox, since xhr.response is ONLY defined
		// in onprogress, not in onreadystatechange with xhr.readyState = 3
		if (self._mode === 'moz-chunked-arraybuffer') {
			xhr.onprogress = function () {
				self._onXHRProgress();
			};
		}

		xhr.onerror = function () {
			if (self._destroyed) return;
			self.emit('error', new Error('XHR error'));
		};

		try {
			xhr.send(body);
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err);
			});
			return;
		}
	}
};

/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */
function statusValid(xhr) {
	try {
		var status = xhr.status;
		return status !== null && status !== 0;
	} catch (e) {
		return false;
	}
}

ClientRequest.prototype._onXHRProgress = function () {
	var self = this;

	if (!statusValid(self._xhr) || self._destroyed) return;

	if (!self._response) self._connect();

	self._response._onXHRProgress();
};

ClientRequest.prototype._connect = function () {
	var self = this;

	if (self._destroyed) return;

	self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode);
	self._response.on('error', function (err) {
		self.emit('error', err);
	});

	self.emit('response', self._response);
};

ClientRequest.prototype._write = function (chunk, encoding, cb) {
	var self = this;

	self._body.push(chunk);
	cb();
};

ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function () {
	var self = this;
	self._destroyed = true;
	if (self._response) self._response._destroyed = true;
	if (self._xhr) self._xhr.abort();
	// Currently, there isn't a way to truly abort a fetch.
	// If you like bikeshedding, see https://github.com/whatwg/fetch/issues/27
};

ClientRequest.prototype.end = function (data, encoding, cb) {
	var self = this;
	if (typeof data === 'function') {
		cb = data;
		data = undefined;
	}

	stream.Writable.prototype.end.call(self, data, encoding, cb);
};

ClientRequest.prototype.flushHeaders = function () {};
ClientRequest.prototype.setTimeout = function () {};
ClientRequest.prototype.setNoDelay = function () {};
ClientRequest.prototype.setSocketKeepAlive = function () {};

// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var unsafeHeaders = ['accept-charset', 'accept-encoding', 'access-control-request-headers', 'access-control-request-method', 'connection', 'content-length', 'cookie', 'cookie2', 'date', 'dnt', 'expect', 'host', 'keep-alive', 'origin', 'referer', 'te', 'trailer', 'transfer-encoding', 'upgrade', 'user-agent', 'via'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36).Buffer, __webpack_require__(18), __webpack_require__(26)))

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;

var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
}

revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;

function placeHoldersCount(b64) {
  var len = b64.length;
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4');
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;
}

function byteLength(b64) {
  // base64 is 4/3 + up to two characters of the original data
  return b64.length * 3 / 4 - placeHoldersCount(b64);
}

function toByteArray(b64) {
  var i, l, tmp, placeHolders, arr;
  var len = b64.length;
  placeHolders = placeHoldersCount(b64);

  arr = new Arr(len * 3 / 4 - placeHolders);

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len;

  var L = 0;

  for (i = 0; i < l; i += 4) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[L++] = tmp >> 16 & 0xFF;
    arr[L++] = tmp >> 8 & 0xFF;
    arr[L++] = tmp & 0xFF;
  }

  if (placeHolders === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[L++] = tmp & 0xFF;
  } else if (placeHolders === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[L++] = tmp >> 8 & 0xFF;
    arr[L++] = tmp & 0xFF;
  }

  return arr;
}

function tripletToBase64(num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}

function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
    output.push(tripletToBase64(tmp));
  }
  return output.join('');
}

function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var output = '';
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    output += lookup[tmp >> 2];
    output += lookup[tmp << 4 & 0x3F];
    output += '==';
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    output += lookup[tmp >> 10];
    output += lookup[tmp >> 4 & 0x3F];
    output += lookup[tmp << 2 & 0x3F];
    output += '=';
  }

  parts.push(output);

  return parts.join('');
}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];

  i += d;

  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;

  value = Math.abs(value);

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }

    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128;
};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, Buffer, global) {

var capability = __webpack_require__(72);
var inherits = __webpack_require__(27);
var stream = __webpack_require__(73);

var rStates = exports.readyStates = {
	UNSENT: 0,
	OPENED: 1,
	HEADERS_RECEIVED: 2,
	LOADING: 3,
	DONE: 4
};

var IncomingMessage = exports.IncomingMessage = function (xhr, response, mode) {
	var self = this;
	stream.Readable.call(self);

	self._mode = mode;
	self.headers = {};
	self.rawHeaders = [];
	self.trailers = {};
	self.rawTrailers = [];

	// Fake the 'close' event, but only once 'end' fires
	self.on('end', function () {
		// The nextTick is necessary to prevent the 'request' module from causing an infinite loop
		process.nextTick(function () {
			self.emit('close');
		});
	});

	if (mode === 'fetch') {
		var read = function read() {
			reader.read().then(function (result) {
				if (self._destroyed) return;
				if (result.done) {
					self.push(null);
					return;
				}
				self.push(new Buffer(result.value));
				read();
			}).catch(function (err) {
				self.emit('error', err);
			});
		};

		self._fetchResponse = response;

		self.url = response.url;
		self.statusCode = response.status;
		self.statusMessage = response.statusText;

		response.headers.forEach(function (header, key) {
			self.headers[key.toLowerCase()] = header;
			self.rawHeaders.push(key, header);
		});

		// TODO: this doesn't respect backpressure. Once WritableStream is available, this can be fixed
		var reader = response.body.getReader();

		read();
	} else {
		self._xhr = xhr;
		self._pos = 0;

		self.url = xhr.responseURL;
		self.statusCode = xhr.status;
		self.statusMessage = xhr.statusText;
		var headers = xhr.getAllResponseHeaders().split(/\r?\n/);
		headers.forEach(function (header) {
			var matches = header.match(/^([^:]+):\s*(.*)/);
			if (matches) {
				var key = matches[1].toLowerCase();
				if (key === 'set-cookie') {
					if (self.headers[key] === undefined) {
						self.headers[key] = [];
					}
					self.headers[key].push(matches[2]);
				} else if (self.headers[key] !== undefined) {
					self.headers[key] += ', ' + matches[2];
				} else {
					self.headers[key] = matches[2];
				}
				self.rawHeaders.push(matches[1], matches[2]);
			}
		});

		self._charset = 'x-user-defined';
		if (!capability.overrideMimeType) {
			var mimeType = self.rawHeaders['mime-type'];
			if (mimeType) {
				var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/);
				if (charsetMatch) {
					self._charset = charsetMatch[1].toLowerCase();
				}
			}
			if (!self._charset) self._charset = 'utf-8'; // best guess
		}
	}
};

inherits(IncomingMessage, stream.Readable);

IncomingMessage.prototype._read = function () {};

IncomingMessage.prototype._onXHRProgress = function () {
	var self = this;

	var xhr = self._xhr;

	var response = null;
	switch (self._mode) {
		case 'text:vbarray':
			// For IE9
			if (xhr.readyState !== rStates.DONE) break;
			try {
				// This fails in IE8
				response = new global.VBArray(xhr.responseBody).toArray();
			} catch (e) {}
			if (response !== null) {
				self.push(new Buffer(response));
				break;
			}
		// Falls through in IE8	
		case 'text':
			try {
				// This will fail when readyState = 3 in IE9. Switch mode and wait for readyState = 4
				response = xhr.responseText;
			} catch (e) {
				self._mode = 'text:vbarray';
				break;
			}
			if (response.length > self._pos) {
				var newData = response.substr(self._pos);
				if (self._charset === 'x-user-defined') {
					var buffer = new Buffer(newData.length);
					for (var i = 0; i < newData.length; i++) {
						buffer[i] = newData.charCodeAt(i) & 0xff;
					}self.push(buffer);
				} else {
					self.push(newData, self._charset);
				}
				self._pos = response.length;
			}
			break;
		case 'arraybuffer':
			if (xhr.readyState !== rStates.DONE || !xhr.response) break;
			response = xhr.response;
			self.push(new Buffer(new Uint8Array(response)));
			break;
		case 'moz-chunked-arraybuffer':
			// take whole
			response = xhr.response;
			if (xhr.readyState !== rStates.LOADING || !response) break;
			self.push(new Buffer(new Uint8Array(response)));
			break;
		case 'ms-stream':
			response = xhr.response;
			if (xhr.readyState !== rStates.LOADING) break;
			var reader = new global.MSStreamReader();
			reader.onprogress = function () {
				if (reader.result.byteLength > self._pos) {
					self.push(new Buffer(new Uint8Array(reader.result.slice(self._pos))));
					self._pos = reader.result.byteLength;
				}
			};
			reader.onload = function () {
				self.push(null);
			};
			// reader.onerror = ??? // TODO: this
			reader.readAsArrayBuffer(response);
			break;
	}

	// The ms-stream case handles end separately in reader.onload()
	if (self._xhr.readyState === rStates.DONE && self._mode !== 'ms-stream') {
		self.push(null);
	}
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26), __webpack_require__(36).Buffer, __webpack_require__(18)))

/***/ }),
/* 168 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Buffer = __webpack_require__(42).Buffer;
/*</replacement>*/

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function () {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function () {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function (timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function () {};
Timeout.prototype.close = function () {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function (item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function (item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function (item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout) item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(171);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") {
            callback = new Function("" + callback);
        }
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i + 1];
        }
        // Store and register the task
        var task = { callback: callback, args: args };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function registerImmediate(handle) {
            process.nextTick(function () {
                runIfPresent(handle);
            });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function () {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function onGlobalMessage(event) {
            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function registerImmediate(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function registerImmediate(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function registerImmediate(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function registerImmediate(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();
    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();
    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();
    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();
    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof global === "undefined" ? undefined : global : self);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(26)))

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate(fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config(name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(80);

/*<replacement>*/
var util = __webpack_require__(37);
util.inherits = __webpack_require__(27);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(36).Buffer;

module.exports = function (buf) {
	// If the buffer is backed by a Uint8Array, a faster version will work
	if (buf instanceof Uint8Array) {
		// If the buffer isn't a subarray, return the underlying ArrayBuffer
		if (buf.byteOffset === 0 && buf.byteLength === buf.buffer.byteLength) {
			return buf.buffer;
		} else if (typeof buf.buffer.slice === 'function') {
			// Otherwise we need to get a proper copy
			return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
		}
	}

	if (Buffer.isBuffer(buf)) {
		// This is the slow version that will work with any Buffer
		// implementation (even in old browsers)
		var arrayCopy = new Uint8Array(buf.length);
		var len = buf.length;
		for (var i = 0; i < len; i++) {
			arrayCopy[i] = buf[i];
		}
		return arrayCopy.buffer;
	} else {
		throw new Error('Argument must be a Buffer');
	}
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = extend;

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {};

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }

    return target;
}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  "100": "Continue",
  "101": "Switching Protocols",
  "102": "Processing",
  "200": "OK",
  "201": "Created",
  "202": "Accepted",
  "203": "Non-Authoritative Information",
  "204": "No Content",
  "205": "Reset Content",
  "206": "Partial Content",
  "207": "Multi-Status",
  "208": "Already Reported",
  "226": "IM Used",
  "300": "Multiple Choices",
  "301": "Moved Permanently",
  "302": "Found",
  "303": "See Other",
  "304": "Not Modified",
  "305": "Use Proxy",
  "307": "Temporary Redirect",
  "308": "Permanent Redirect",
  "400": "Bad Request",
  "401": "Unauthorized",
  "402": "Payment Required",
  "403": "Forbidden",
  "404": "Not Found",
  "405": "Method Not Allowed",
  "406": "Not Acceptable",
  "407": "Proxy Authentication Required",
  "408": "Request Timeout",
  "409": "Conflict",
  "410": "Gone",
  "411": "Length Required",
  "412": "Precondition Failed",
  "413": "Payload Too Large",
  "414": "URI Too Long",
  "415": "Unsupported Media Type",
  "416": "Range Not Satisfiable",
  "417": "Expectation Failed",
  "418": "I'm a teapot",
  "421": "Misdirected Request",
  "422": "Unprocessable Entity",
  "423": "Locked",
  "424": "Failed Dependency",
  "425": "Unordered Collection",
  "426": "Upgrade Required",
  "428": "Precondition Required",
  "429": "Too Many Requests",
  "431": "Request Header Fields Too Large",
  "451": "Unavailable For Legal Reasons",
  "500": "Internal Server Error",
  "501": "Not Implemented",
  "502": "Bad Gateway",
  "503": "Service Unavailable",
  "504": "Gateway Timeout",
  "505": "HTTP Version Not Supported",
  "506": "Variant Also Negotiates",
  "507": "Insufficient Storage",
  "508": "Loop Detected",
  "509": "Bandwidth Limit Exceeded",
  "510": "Not Extended",
  "511": "Network Authentication Required"
};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var punycode = __webpack_require__(178);
var util = __webpack_require__(180);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,


// Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,


// RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],


// RFC 2396: characters not allowed for various reasons.
unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),


// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = ['\''].concat(unwise),

// Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,

// protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
  'javascript': true,
  'javascript:': true
},

// protocols that never have a hostname.
hostlessProtocol = {
  'javascript': true,
  'javascript:': true
},

// protocols that always contain a // bit.
slashedProtocol = {
  'http': true,
  'https': true,
  'ftp': true,
  'gopher': true,
  'file': true,
  'http:': true,
  'https:': true,
  'ftp:': true,
  'gopher:': true,
  'file:': true
},
    querystring = __webpack_require__(181);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url();
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + (typeof url === 'undefined' ? 'undefined' : _typeof(url)));
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1) continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function () {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query && util.isObject(this.query) && Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || query && '?' + query || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function (match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function (relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function (relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol') result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift())) {}
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
      isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
      mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname,
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = relative.host || relative.host === '' ? relative.host : result.host;
    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || result.host && srcPath.length;

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function () {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function (root) {

	/** Detect free variables */
	var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;
	var freeModule = ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;
	var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
		root = freeGlobal;
	}

	/**
  * The `punycode` object.
  * @name punycode
  * @type Object
  */
	var punycode,


	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647,
	    // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	    tMin = 1,
	    tMax = 26,
	    skew = 38,
	    damp = 700,
	    initialBias = 72,
	    initialN = 128,
	    // 0x80
	delimiter = '-',
	    // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	    regexNonASCII = /[^\x20-\x7E]/,
	    // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
	    // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},


	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	    floor = Math.floor,
	    stringFromCharCode = String.fromCharCode,


	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
  * A generic error utility function.
  * @private
  * @param {String} type The error type.
  * @returns {Error} Throws a `RangeError` with the applicable error message.
  */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
  * A generic `Array#map` utility function.
  * @private
  * @param {Array} array The array to iterate over.
  * @param {Function} callback The function that gets called for every array
  * item.
  * @returns {Array} A new array of values returned by the callback function.
  */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
  * A simple `Array#map`-like wrapper to work with domain name strings or email
  * addresses.
  * @private
  * @param {String} domain The domain name or email address.
  * @param {Function} callback The function that gets called for every
  * character.
  * @returns {Array} A new string of characters returned by the callback
  * function.
  */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
  * Creates an array containing the numeric code points of each Unicode
  * character in the string. While JavaScript uses UCS-2 internally,
  * this function will convert a pair of surrogate halves (each of which
  * UCS-2 exposes as separate characters) into a single code point,
  * matching UTF-16.
  * @see `punycode.ucs2.encode`
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode.ucs2
  * @name decode
  * @param {String} string The Unicode input string (UCS-2).
  * @returns {Array} The new array of code points.
  */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) {
					// low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
  * Creates a string based on an array of numeric code points.
  * @see `punycode.ucs2.decode`
  * @memberOf punycode.ucs2
  * @name encode
  * @param {Array} codePoints The array of numeric code points.
  * @returns {String} The new Unicode string (UCS-2).
  */
	function ucs2encode(array) {
		return map(array, function (value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
  * Converts a basic code point into a digit/integer.
  * @see `digitToBasic()`
  * @private
  * @param {Number} codePoint The basic numeric code point value.
  * @returns {Number} The numeric value of a basic code point (for use in
  * representing integers) in the range `0` to `base - 1`, or `base` if
  * the code point does not represent a value.
  */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
  * Converts a digit/integer into a basic code point.
  * @see `basicToDigit()`
  * @private
  * @param {Number} digit The numeric value of a basic code point.
  * @returns {Number} The basic code point whose value (when used for
  * representing integers) is `digit`, which needs to be in the range
  * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
  * used; else, the lowercase form is used. The behavior is undefined
  * if `flag` is non-zero and `digit` has no uppercase form.
  */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
  * Bias adaptation function as per section 3.4 of RFC 3492.
  * https://tools.ietf.org/html/rfc3492#section-3.4
  * @private
  */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (; /* no initialization */delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
  * Converts a Punycode string of ASCII-only symbols to a string of Unicode
  * symbols.
  * @memberOf punycode
  * @param {String} input The Punycode string of ASCII-only symbols.
  * @returns {String} The resulting string of Unicode symbols.
  */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,

		/** Cached calculation results */
		baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength;) /* no final expression */{

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base;; /* no condition */k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;
			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);
		}

		return ucs2encode(output);
	}

	/**
  * Converts a string of Unicode symbols (e.g. a domain name label) to a
  * Punycode string of ASCII-only symbols.
  * @memberOf punycode
  * @param {String} input The string of Unicode symbols.
  * @returns {String} The resulting Punycode string of ASCII-only symbols.
  */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],

		/** `inputLength` will hold the number of code points in `input`. */
		inputLength,

		/** Cached calculation results */
		handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base;; /* no condition */k += base) {
						t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;
		}
		return output.join('');
	}

	/**
  * Converts a Punycode string representing a domain name or an email address
  * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
  * it doesn't matter if you call it on a string that has already been
  * converted to Unicode.
  * @memberOf punycode
  * @param {String} input The Punycoded domain name or email address to
  * convert to Unicode.
  * @returns {String} The Unicode representation of the given Punycode
  * string.
  */
	function toUnicode(input) {
		return mapDomain(input, function (string) {
			return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
		});
	}

	/**
  * Converts a Unicode string representing a domain name or an email address to
  * Punycode. Only the non-ASCII parts of the domain name will be converted,
  * i.e. it doesn't matter if you call it with a domain that's already in
  * ASCII.
  * @memberOf punycode
  * @param {String} input The domain name or email address to convert, as a
  * Unicode string.
  * @returns {String} The Punycode representation of the given domain name or
  * email address.
  */
	function toASCII(input) {
		return mapDomain(input, function (string) {
			return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
		'version': '1.4.1',
		/**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if ("function" == 'function' && _typeof(__webpack_require__(81)) == 'object' && __webpack_require__(81)) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}
})(undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(179)(module), __webpack_require__(18)))

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = {
  isString: function isString(arg) {
    return typeof arg === 'string';
  },
  isObject: function isObject(arg) {
    return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null;
  },
  isNull: function isNull(arg) {
    return arg === null;
  },
  isNullOrUndefined: function isNullOrUndefined(arg) {
    return arg == null;
  }
};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(182);
exports.encode = exports.stringify = __webpack_require__(183);

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function (qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr,
        vstr,
        k,
        v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var stringifyPrimitive = function stringifyPrimitive(v) {
  switch (typeof v === 'undefined' ? 'undefined' : _typeof(v)) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function (obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
    return map(objectKeys(obj), function (k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function (v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);
  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map(xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _allHeader = __webpack_require__(185);

var _allHeader2 = _interopRequireDefault(_allHeader);

var _allBody = __webpack_require__(69);

var _allBody2 = _interopRequireDefault(_allBody);

var _attdAction = __webpack_require__(19);

var _attdAction2 = _interopRequireDefault(_attdAction);

var _attdStore = __webpack_require__(25);

var _attdStore2 = _interopRequireDefault(_attdStore);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AttendanceAll = function (_React$Component) {
    _inherits(AttendanceAll, _React$Component);

    function AttendanceAll(props) {
        _classCallCheck(this, AttendanceAll);

        var _this = _possibleConstructorReturn(this, (AttendanceAll.__proto__ || Object.getPrototypeOf(AttendanceAll)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.state = {
            staffsAtd: _attdStore2.default.getState().staffsAtd,
            selectedYear: _attdStore2.default.getState().selectedYear,
            selectedMonth: _attdStore2.default.getState().selectedMonth,
            iniLoad: _attdStore2.default.getState().iniLoad,
            processing: _attdStore2.default.getState().processing,
            role: _userStore2.default.getState().role
        };
        return _this;
    }

    _createClass(AttendanceAll, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _attdStore2.default.listen(this.onChange);
            _userStore2.default.listen(this.onUserChange);
            _menuAction2.default.pageNumber.defer(-1);

            if (!this.state.iniLoad && !this.state.processing) {
                _attdAction2.default.processing(true);
                _attdAction2.default.getAllStaffAttendance(this.state.selectedYear, this.state.selectedMonth);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _attdStore2.default.unlisten(this.onChange);
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                role: state.role
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                staffsAtd: state.staffsAtd,
                selectedYear: state.selectedYear,
                selectedMonth: state.selectedMonth,
                processing: state.processing
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 atd' },
                        _react2.default.createElement(_allHeader2.default, null),
                        _react2.default.createElement('div', { className: 'divider' }),
                        _react2.default.createElement(_allBody2.default, { staffsAtd: this.state.staffsAtd, role: this.state.role, useFor: 0, processing: this.state.processing })
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing })
            );
        }
    }]);

    return AttendanceAll;
}(_react2.default.Component);

exports.default = AttendanceAll;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _allFilter = __webpack_require__(186);

var _allFilter2 = _interopRequireDefault(_allFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AllHeader = function (_React$Component) {
    _inherits(AllHeader, _React$Component);

    function AllHeader(props) {
        _classCallCheck(this, AllHeader);

        return _possibleConstructorReturn(this, (AllHeader.__proto__ || Object.getPrototypeOf(AllHeader)).call(this, props));
    }

    _createClass(AllHeader, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-hd' },
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(
                        'b',
                        null,
                        'Summary of All Employees\' Attendance'
                    )
                ),
                _react2.default.createElement(_allFilter2.default, null),
                _react2.default.createElement('div', { className: 'clear' })
            );
        }
    }]);

    return AllHeader;
}(_react2.default.Component);

exports.default = AllHeader;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _attdAction = __webpack_require__(19);

var _attdAction2 = _interopRequireDefault(_attdAction);

var _attdStore = __webpack_require__(25);

var _attdStore2 = _interopRequireDefault(_attdStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AllFilter = function (_React$Component) {
    _inherits(AllFilter, _React$Component);

    function AllFilter(props) {
        _classCallCheck(this, AllFilter);

        var _this = _possibleConstructorReturn(this, (AllFilter.__proto__ || Object.getPrototypeOf(AllFilter)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleExport = _this.handleExport.bind(_this);
        _this.handlePrint = _this.handlePrint.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.state = {

            processing: _attdStore2.default.getState().processing,
            iniYear: 2017,
            iniMonth: 11,
            selectedYear: _attdStore2.default.getState().selectedYear,
            selectedMonth: _attdStore2.default.getState().selectedMonth
        };
        return _this;
    }

    _createClass(AllFilter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _attdStore2.default.listen(this.onChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _attdStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                selectedYear: state.selectedYear,
                selectedMonth: state.selectedMonth

            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            var value = e.target.value.split(":");
            var selectedYear = parseInt(value[0]);
            var selectedMonth = parseInt(value[1]);
            if (index == 0) {
                _attdAction2.default.selectedMonth({ selectedYear: selectedYear, selectedMonth: selectedMonth });

                if (!this.state.processing) {
                    _attdAction2.default.processing(true);
                    _attdAction2.default.getAllStaffAttendance(selectedYear, selectedMonth);
                }
            }
        }
    }, {
        key: 'handleExport',
        value: function handleExport() {
            if (!this.state.processing) {
                _attdAction2.default.processing(true);
                _attdAction2.default.exportAllStaffAttendance(this.state.selectedYear, this.state.selectedMonth);
            }
        }
    }, {
        key: 'handlePrint',
        value: function handlePrint() {
            window.print();
        }
    }, {
        key: 'renderOption',
        value: function renderOption(yr, mth) {
            var isSelected = yr == this.props.selectedYear && mth == this.props.selectedMonth ? true : false;
            return _react2.default.createElement(
                'option',
                { value: yr + ":" + mth, key: yr + mth },
                this.props.mthTxt[mth] + " " + yr
            );
        }
    }, {
        key: 'renderOptions',
        value: function renderOptions() {
            var options = [];
            var thisYear = new Date().getFullYear();
            var thisMonth = new Date().getMonth();

            for (var yr = thisYear; yr >= this.state.iniYear; yr--) {
                if (thisYear == this.state.iniYear) {
                    for (var mth = thisMonth; mth >= this.state.iniMonth; mth--) {
                        options = options.concat(this.renderOption(yr, mth));
                    }
                } else if (yr == thisYear) {
                    for (var _mth = thisMonth; _mth >= 0; _mth--) {
                        options = options.concat(this.renderOption(yr, _mth));
                    }
                } else if (yr == this.state.iniYear) {
                    for (var _mth2 = 11; _mth2 >= this.state.iniMonth; _mth2--) {
                        options = options.concat(this.renderOption(yr, _mth2));
                    }
                } else {
                    for (var _mth3 = 11; _mth3 >= 0; _mth3--) {
                        options = options.concat(this.renderOption(yr, _mth3));
                    }
                }
            }
            return options;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-i' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-5 col-sm-5 col-lg-3' },
                        _react2.default.createElement(
                            'form',
                            { className: 'form-horizontal atd-i-wp' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'startFrom', className: 'col-sm-4 control-label' },
                                'Select Month: '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group input-group-sm' },
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control atd-sel', name: 'startFrom', 'data-index': '0', onChange: this.handleChange, value: this.state.selectedYear + ":" + this.state.selectedMonth },
                                    this.renderOptions()
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-i-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-primary btn-sm', type: 'button', onClick: this.handlePrint },
                                'Print'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-i-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-primary btn-sm', onClick: this.handleExport },
                                'Export'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return AllFilter;
}(_react2.default.Component);

AllFilter.defaultProps = {
    mthTxt: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
exports.default = AllFilter;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _jpHeader = __webpack_require__(188);

var _jpHeader2 = _interopRequireDefault(_jpHeader);

var _jpBody = __webpack_require__(190);

var _jpBody2 = _interopRequireDefault(_jpBody);

var _jpAction = __webpack_require__(43);

var _jpAction2 = _interopRequireDefault(_jpAction);

var _jpStore = __webpack_require__(55);

var _jpStore2 = _interopRequireDefault(_jpStore);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

var _jpConfirmModal = __webpack_require__(193);

var _jpConfirmModal2 = _interopRequireDefault(_jpConfirmModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JourneyPlanner = function (_React$Component) {
    _inherits(JourneyPlanner, _React$Component);

    function JourneyPlanner(props) {
        _classCallCheck(this, JourneyPlanner);

        var _this = _possibleConstructorReturn(this, (JourneyPlanner.__proto__ || Object.getPrototypeOf(JourneyPlanner)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.hasStatus = _this.hasStatus.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.callBack = _this.callBack.bind(_this);
        _this.handleClaimSubmit = _this.handleClaimSubmit.bind(_this);
        _this.state = {
            staffs: _filterStore2.default.getState().staffs,
            processingFilter: _filterStore2.default.getState().processing,
            iniLoadStaff: _filterStore2.default.getState().iniLoadStaff,
            selectedYear: _jpStore2.default.getState().selectedYear,
            selectedMonth: _jpStore2.default.getState().selectedMonth,
            journeyList: _jpStore2.default.getState().journeyList,
            staffId: _jpStore2.default.getState().staffId,
            processing: _jpStore2.default.getState().processing,
            submitRecord: _jpStore2.default.getState().submitRecord,
            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId,

            modalClose: false,
            action: 0,
            title: ""
        };
        return _this;
    }

    _createClass(JourneyPlanner, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _jpStore2.default.listen(this.onChange);
            _userStore2.default.listen(this.onUserChange);
            _filterStore2.default.listen(this.onFilterChange);
            _menuAction2.default.pageNumber(2);
            _jpAction2.default.warningMsg("");

            if (!this.state.processingFilter && !this.state.iniLoadStaff) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getEmployee();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _jpStore2.default.unlisten(this.onChange);
            _userStore2.default.unlisten(this.onUserChange);
            _filterStore2.default.unlisten(this.onFilterChange);
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                staffs: state.staffs,
                processingFilter: state.processing,
                iniLoadStaff: state.iniLoadStaff
            });
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                journeyList: state.journeyList,
                selectedYear: state.selectedYear,
                selectedMonth: state.selectedMonth,
                processing: state.processing,
                staffId: state.staffId,
                submitRecord: state.submitRecord
            });
        }
    }, {
        key: 'hasStatus',
        value: function hasStatus(status) {
            var hasStatus = false;
            var len = this.state.journeyList.length;
            if (status == 1 || status == 2 || status == 3) {
                for (var i = 0; i < len; i++) {
                    if (status == this.state.journeyList[i].status) {
                        hasStatus = true;
                        break;
                    }
                }
            } else {
                hasStatus = true;
                for (var _i = 0; _i < len; _i++) {
                    if (this.state.journeyList[_i].status == 1 || this.state.journeyList[_i].status == 2 || this.state.journeyList[_i].status == 3) {
                        hasStatus = false;
                        break;
                    }
                }
            }
            return hasStatus;
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            if (this.state.staffId == -1) {
                return _jpAction2.default.warningMsg("Please Select Staff Name");
            }
            if (this.state.processing) return;

            var title = void 0;
            //prompt user first b4 confirm
            if (index == 0) {
                //check if status has 0
                if (!this.hasStatus(1)) {
                    return _jpAction2.default.warningMsg("Claims do no need justification");
                } else {
                    _jpAction2.default.warningMsg("");
                    title = "Mileage Claim Justification";
                }
            } else if (index == 1) {
                if (!this.hasStatus(0)) {
                    return _jpAction2.default.warningMsg("Please make sure all claims are approved");
                } else {
                    _jpAction2.default.warningMsg("");
                    title = "Mileage Claim Submission";
                }
            } else if (index == 2) {
                if (!this.hasStatus(2)) {
                    return _jpAction2.default.warningMsg("No rejected claim");
                } else {
                    _jpAction2.default.warningMsg("");
                    title = "Mileage Claim Reject";
                }
            }
            this.setState({
                action: index,
                title: title,
                modalClose: true
            });
        }
    }, {
        key: 'handleClaimSubmit',
        value: function handleClaimSubmit() {
            _jpAction2.default.claimSubmit(this.state.selectedYear, this.state.selectedMonth);
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({ modalClose: data });
        }
    }, {
        key: 'callBack',
        value: function callBack(action) {
            _jpAction2.default.processing(true);
            _jpAction2.default.warningMsg("");

            if (action == 0) {
                _jpAction2.default.emailJustification(this.state.staffId, this.state.selectedYear, this.state.selectedMonth);
            } else if (action == 1) {
                _jpAction2.default.emailApproved(this.state.staffId, this.state.selectedYear, this.state.selectedMonth);
            } else {
                _jpAction2.default.emailReject(this.state.staffId, this.state.selectedYear, this.state.selectedMonth);
            }
            //reset data
            this.setState({
                modalClose: false,
                action: 0,
                title: ""
            });
        }
    }, {
        key: 'hasSubmit',
        value: function hasSubmit(reminder) {
            var hasSubmit = false;
            for (var i = 0; i < this.state.submitRecord.length; i++) {
                if (reminder == this.state.submitRecord[i].reminder) {
                    hasSubmit = true;
                    break;
                }
            }

            return hasSubmit;
        }
    }, {
        key: 'render',
        value: function render() {
            var adminBtn = "";
            if (_genFunction2.default.hasPermission(this.state.permission, 1)) {
                adminBtn = _react2.default.createElement(
                    'div',
                    { className: 'jp-btn-grp' },
                    this.state.userId == this.state.staffId && _react2.default.createElement(
                        'button',
                        { className: "btn btn-default " + (this.hasSubmit(0) ? "btn-grey" : ""),
                            'data-index': '3', onClick: this.handleClaimSubmit },
                        'Submit Claim'
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: "btn btn-default " + (this.hasSubmit(1) ? "btn-grey" : ""),
                            'data-index': '0', onClick: this.handleClick },
                        'Email to Employee for Justification'
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: "btn btn-default " + (this.hasSubmit(2) ? "btn-grey" : ""),
                            'data-index': '1', onClick: this.handleClick },
                        'Journey Claim Approved'
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: "btn btn-default " + (this.hasSubmit(3) ? "btn-grey" : ""),
                            'data-index': '2', onClick: this.handleClick },
                        'Journey Claim Denied'
                    )
                );
            } else if (this.state.userId == this.state.staffId) {
                adminBtn = _react2.default.createElement(
                    'div',
                    { className: 'jp-btn-grp' },
                    _react2.default.createElement(
                        'button',
                        { className: 'btn btn-default', 'data-index': '3', onClick: this.handleClaimSubmit },
                        'Submit Claim'
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 atd' },
                        _react2.default.createElement(_jpHeader2.default, { staffs: this.state.staffs, iniLoad: this.state.iniLoad }),
                        _react2.default.createElement('div', { className: 'divider' }),
                        _react2.default.createElement(_jpBody2.default, _extends({ journeyList: this.state.journeyList }, this.props)),
                        adminBtn
                    )
                ),
                _react2.default.createElement(_jpConfirmModal2.default, {
                    modalClose: this.state.modalClose,
                    action: this.state.action,
                    callBack: this.callBack,
                    title: this.state.title,
                    shouldModalClose: this.shouldModalClose
                }),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.processingFilter })
            );
        }
    }]);

    return JourneyPlanner;
}(_react2.default.Component);

exports.default = JourneyPlanner;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _jpFilter = __webpack_require__(189);

var _jpFilter2 = _interopRequireDefault(_jpFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JPHeader = function (_React$Component) {
    _inherits(JPHeader, _React$Component);

    function JPHeader(props) {
        _classCallCheck(this, JPHeader);

        return _possibleConstructorReturn(this, (JPHeader.__proto__ || Object.getPrototypeOf(JPHeader)).call(this, props));
    }

    _createClass(JPHeader, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-hd' },
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(
                        'b',
                        null,
                        'Summary of Journey Planner'
                    )
                ),
                _react2.default.createElement(_jpFilter2.default, { staffs: this.props.staffs, iniLoad: this.props.iniLoad }),
                _react2.default.createElement('div', { className: 'clear' })
            );
        }
    }]);

    return JPHeader;
}(_react2.default.Component);

exports.default = JPHeader;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _jpAction = __webpack_require__(43);

var _jpAction2 = _interopRequireDefault(_jpAction);

var _jpStore = __webpack_require__(55);

var _jpStore2 = _interopRequireDefault(_jpStore);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JPFilter = function (_React$Component) {
    _inherits(JPFilter, _React$Component);

    function JPFilter(props) {
        _classCallCheck(this, JPFilter);

        var _this = _possibleConstructorReturn(this, (JPFilter.__proto__ || Object.getPrototypeOf(JPFilter)).call(this, props));

        _this.handleApproveAll = function () {
            if (_this.state.staffId == -1) {
                _jpAction2.default.warningMsg("Please Select Staff Name");
            }
            if (!_this.state.processing && _this.state.staffId != -1) {
                _jpAction2.default.processing(true);
                _jpAction2.default.warningMsg("");
                _jpAction2.default.approveAll(_this.state.staffId, _this.state.selectedYear, _this.state.selectedMonth);
            }
        };

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handlePrint = _this.handlePrint.bind(_this);
        _this.handleExport = _this.handleExport.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.state = {
            processing: _jpStore2.default.getState().processing,
            warningMsg: _jpStore2.default.getState().warningMsg,
            iniYear: 2017,
            iniMonth: 11,
            staffId: _jpStore2.default.getState().staffId,
            selectedYear: _jpStore2.default.getState().selectedYear,
            selectedMonth: _jpStore2.default.getState().selectedMonth,

            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId
        };
        return _this;
    }

    _createClass(JPFilter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _jpStore2.default.listen(this.onChange);
            _userStore2.default.listen(this.onUserChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _jpStore2.default.unlisten(this.onChange);
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                selectedYear: state.selectedYear,
                selectedMonth: state.selectedMonth,
                staffId: state.staffId,
                warningMsg: state.warningMsg
            });
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            var value = e.target.value.split(":");
            var selectedYear = parseInt(value[0]);
            var selectedMonth = parseInt(value[1]);
            if (index == 0) {
                _jpAction2.default.selectMonth({ selectedYear: selectedYear, selectedMonth: selectedMonth });
            } else if (index == 1) {
                _jpAction2.default.staffId({ staffId: value[0] });
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            if (!this.state.processing && this.state.staffId != -1) {
                _jpAction2.default.processing(true);
                _jpAction2.default.warningMsg("");
                _jpAction2.default.clear();
                _jpAction2.default.getJourneyPlanner(this.state.staffId, this.state.selectedYear, this.state.selectedMonth);
                _jpAction2.default.getSubmitRecord(this.state.staffId, this.state.selectedYear, this.state.selectedMonth);
            } else if (this.state.staffId == -1) {
                _jpAction2.default.warningMsg("Please Select Staff Name");
            }
        }
    }, {
        key: 'handleExport',
        value: function handleExport() {
            if (!this.state.processing && this.state.staffId != -1) {
                _jpAction2.default.processing(true);
                _jpAction2.default.warningMsg("");
                _jpAction2.default.exportJourneyPlanner(this.state.staffId, this.state.selectedYear, this.state.selectedMonth);
            } else if (this.state.staffId == -1) {
                _jpAction2.default.warningMsg("Please Select Staff Name");
            }
        }
    }, {
        key: 'handlePrint',
        value: function handlePrint() {
            window.print();
        }
    }, {
        key: 'renderOption',
        value: function renderOption(yr, mth) {
            return _react2.default.createElement(
                'option',
                { value: yr + ":" + mth, key: yr + ":" + mth },
                this.props.mthTxt[mth] + " " + yr
            );
        }
    }, {
        key: 'renderStaff',
        value: function renderStaff(staff, index) {
            return _react2.default.createElement(
                'option',
                { value: staff.staffId, key: index },
                staff.userName
            );
        }
    }, {
        key: 'renderStaffs',
        value: function renderStaffs() {
            var _this2 = this;

            var staffs = this.props.staffs.filter(function (staff) {
                return _genFunction2.default.hasPermission(_this2.state.permission, 1) || _genFunction2.default.isSubordinate(_this2.state.subordinate, staff.staffId) || _genFunction2.default.isUser(_this2.state.userId, staff.staffId);
            });
            staffs = staffs.filter(function (st) {
                return _this2.props.staff2s.indexOf(st.staffId) > -1;
            });
            return staffs.map(function (staff, index) {
                return _this2.renderStaff(staff, index);
            });
        }
    }, {
        key: 'renderOptions',
        value: function renderOptions() {
            var options = [];
            var thisYear = new Date().getFullYear();
            var thisMonth = new Date().getMonth() + 1;
            thisYear = thisMonth == 12 ? thisYear + 1 : thisYear;
            thisMonth = thisMonth % 12;
            for (var yr = thisYear; yr >= this.state.iniYear; yr--) {
                if (thisYear == this.state.iniYear) {
                    for (var mth = thisMonth; mth >= this.state.iniMonth; mth--) {
                        options = options.concat(this.renderOption(yr, mth));
                    }
                } else if (yr == thisYear) {
                    for (var _mth = thisMonth; _mth >= 0; _mth--) {
                        options = options.concat(this.renderOption(yr, _mth));
                    }
                } else if (yr == this.state.iniYear) {
                    for (var _mth2 = 11; _mth2 >= this.state.iniMonth; _mth2--) {
                        options = options.concat(this.renderOption(yr, _mth2));
                    }
                } else {
                    for (var _mth3 = 11; _mth3 >= 0; _mth3--) {
                        options = options.concat(this.renderOption(yr, _mth3));
                    }
                }
            }
            return options;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-i' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-5 col-lg-3' },
                        _react2.default.createElement(
                            'form',
                            { className: 'form-horizontal atd-i-wp' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'startFrom', className: 'col-xs-4 control-label' },
                                'Select Month: '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group input-group-sm' },
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control atd-sel', name: 'startFrom', 'data-index': '0', onChange: this.handleChange, value: this.state.selectedYear + ":" + this.state.selectedMonth },
                                    this.renderOptions()
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-5 col-lg-3' },
                        _react2.default.createElement(
                            'form',
                            { className: 'form-horizontal atd-i-wp' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'staffName', className: 'col-xs-4 control-label' },
                                'Staff Name: '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group input-group-sm' },
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control atd-sel', name: 'staffName', 'data-index': '1', onChange: this.handleChange, defaultValue: this.state.staffId },
                                    _react2.default.createElement('option', { value: -1 }),
                                    this.renderStaffs()
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-i-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-default btn-sm', type: 'button', onClick: this.handleSubmit },
                                'Search'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-i-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-primary btn-sm', onClick: this.handleExport },
                                'Export'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-i-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-primary btn-sm', onClick: this.handlePrint },
                                'Print'
                            )
                        ),
                        (_genFunction2.default.hasPermission(this.state.permission, 1) || _genFunction2.default.isSubordinate(this.state.subordinate, this.state.staffId)) && !_genFunction2.default.isUser(this.state.userId, this.state.staffId) && _react2.default.createElement(
                            'div',
                            { className: 'atd-i-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-primary btn-sm', onClick: this.handleApproveAll },
                                'Approve All'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4 warning' },
                        this.state.warningMsg
                    )
                )
            );
        }
    }]);

    return JPFilter;
}(_react2.default.Component);

JPFilter.defaultProps = {
    mthTxt: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    staff2s: ["A40007", "A40062", "A40139", "A40131", "A40081", "A40032", "A40027", "A40135", "A40012", "A40178", "A40188", "A40184", "A40197", "A40193", "A40200", "A40201", "A40203", "A40205", "A40214", "A40212", "A40215", "A40220", "A40219", "A40225"]
};
exports.default = JPFilter;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jpList = __webpack_require__(191);

var _jpList2 = _interopRequireDefault(_jpList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JPBody = function (_React$Component) {
    _inherits(JPBody, _React$Component);

    function JPBody(props) {
        _classCallCheck(this, JPBody);

        var _this = _possibleConstructorReturn(this, (JPBody.__proto__ || Object.getPrototypeOf(JPBody)).call(this, props));

        _this.onTouchStart = _this.onTouchStart.bind(_this);
        _this.onTouchMove = _this.onTouchMove.bind(_this);
        _this.onTouchEnd = _this.onTouchEnd.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleMouseScroll = _this.handleMouseScroll.bind(_this);
        _this.state = {
            dragging: false,
            refX: 0,
            ini: 0
        };
        return _this;
    }

    _createClass(JPBody, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (document.body.clientWidth > 768) {
                var elem = _reactDom2.default.findDOMNode(this.refs.table);
                elem.addEventListener('mouseup', this.onTouchEnd);
                elem.addEventListener('mouseleave', this.onTouchEnd);
                elem.addEventListener('mousemove', this.onTouchMove);
                elem.addEventListener('mousedown', this.onTouchStart);
                window.addEventListener('wheel', this.handleMouseScroll);
            }
            window.addEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (document.body.clientWidth > 768) {
                var elem = _reactDom2.default.findDOMNode(this.refs.table);
                elem.removeEventListener('mouseup', this.onTouchEnd);
                elem.removeEventListener('mouseleave', this.onTouchEnd);
                elem.removeEventListener('mousemove', this.onTouchMove);
                elem.removeEventListener('mousedown', this.onTouchStart);
                window.removeEventListener('wheel', this.handleMouseScroll);
            }
            window.removeEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'handleMouseScroll',
        value: function handleMouseScroll(e) {
            e.preventDefault();

            if (e.deltaY > 0) {
                //scroll down
                window.scrollBy(0, 50);
            } else {
                //scroll up
                window.scrollBy(0, -50);
            }
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(e) {
            var elem1 = _reactDom2.default.findDOMNode(this.refs.atd);
            var elem2 = _reactDom2.default.findDOMNode(this.refs.table);
            if (elem2.getBoundingClientRect().top < 50) {

                elem1.style.position = "absolute";

                if (document.body.clientWidth > 768) {
                    elem2.style.paddingTop = "60px";
                    elem1.style.top = 50 - elem2.getBoundingClientRect().top + "px";
                } else {
                    elem2.style.paddingTop = "0px";
                    elem1.style.top = -elem2.getBoundingClientRect().top + "px";
                }
            } else {
                elem2.style.paddingTop = "0px";
                elem1.style.position = "relative";
                elem1.style.top = "0px";
            }
        }
    }, {
        key: 'onTouchStart',
        value: function onTouchStart(e) {
            if (!this.state.dragging) {
                var touches = e.changedTouches;
                var refX = void 0;
                if (e.touches) {
                    refX = e.touches[0].clientX;
                } else {
                    refX = e.clientX;
                }
                var ini = _reactDom2.default.findDOMNode(this.refs.table).scrollLeft;
                this.setState({
                    ini: ini,
                    refX: refX,
                    dragging: true
                });
            } else {
                this.setState({
                    dragging: false
                });
            }
        }
    }, {
        key: 'onTouchMove',
        value: function onTouchMove(e) {
            e.preventDefault();
            if (this.state.dragging && e.target) {
                var deltaX = void 0;
                if (e.touches) {
                    deltaX = parseInt(this.state.refX - e.touches[0].clientX);
                } else {
                    deltaX = parseInt(this.state.refX - e.clientX);
                }

                _reactDom2.default.findDOMNode(this.refs.table).scrollLeft = this.state.ini + deltaX;
            } else {
                this.setState({
                    dragging: false
                });
            }
        }
    }, {
        key: 'onTouchEnd',
        value: function onTouchEnd(e) {
            this.setState({
                dragging: false
            });
        }
    }, {
        key: 'render',
        value: function render() {

            return _react2.default.createElement(
                'div',
                { className: 'jp-bd-wp', ref: 'table' },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-em-lt' },
                    _react2.default.createElement(
                        'table',
                        { className: 'jp-tb tb-heading', ref: 'atd' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Date'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Day'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Staff Id'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Name'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Start Time'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'End Time'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Start Location (Google)'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'End Location (Google)'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'ERP'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'ERP receipt'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Parking'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Parking Receipt'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Distance (km)'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Mileage Claim'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Total Claim'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Remark'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Status'
                                ),
                                _react2.default.createElement('th', null)
                            )
                        )
                    ),
                    _react2.default.createElement(_jpList2.default, { journeyList: this.props.journeyList, role: this.props.role })
                )
            );
        }
    }]);

    return JPBody;
}(_react2.default.Component);

exports.default = JPBody;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jpAction = __webpack_require__(43);

var _jpAction2 = _interopRequireDefault(_jpAction);

var _jpStore = __webpack_require__(55);

var _jpStore2 = _interopRequireDefault(_jpStore);

var _jpModal = __webpack_require__(192);

var _jpModal2 = _interopRequireDefault(_jpModal);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _http = __webpack_require__(70);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JPList = function (_React$Component) {
    _inherits(JPList, _React$Component);

    function JPList(props) {
        _classCallCheck(this, JPList);

        var _this = _possibleConstructorReturn(this, (JPList.__proto__ || Object.getPrototypeOf(JPList)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.showOption = _this.showOption.bind(_this);
        _this.handleOption = _this.handleOption.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.handleStatusChange = _this.handleStatusChange.bind(_this);
        _this.updateERP = _this.updateERP.bind(_this);
        _this.closeOption = _this.closeOption.bind(_this);
        //this.updateMileage = this.updateMileage.bind(this);
        _this.updateDistance = _this.updateDistance.bind(_this);
        _this.updateParking = _this.updateParking.bind(_this);
        _this.removeJp = _this.removeJp.bind(_this);
        _this.uploadReceipt = _this.uploadReceipt.bind(_this);
        _this.uploadERPReceipt = _this.uploadERPReceipt.bind(_this);
        _this.updateRemark = _this.updateRemark.bind(_this);
        _this.state = {
            title: "",
            jpId: "",
            action: '',
            parkingImage: "",
            erpImage: "",
            googleStart: "",
            googleEnd: "",
            modalClose: false,
            processing: _jpStore2.default.getState().processing,

            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId
        };
        return _this;
    }

    _createClass(JPList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _jpStore2.default.listen(this.onChange);
            _userStore2.default.listen(this.onUserChange);
            window.addEventListener("click", this.closeOption);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _jpStore2.default.unlisten(this.onChange);
            _userStore2.default.unlisten(this.onUserChange);
            window.removeEventListener("click", this.closeOption);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing
            });
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'handleStatusChange',
        value: function handleStatusChange(e) {
            var id = e.target.getAttribute('data-id');
            var status = parseInt(e.target.value);

            if (!this.state.processing) {
                _jpAction2.default.processing(true);
                _jpAction2.default.updateStatus(id, status);
            }
        }
    }, {
        key: 'handleOption',
        value: function handleOption(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            var id = e.target.getAttribute('data-id');
            var action = parseInt(e.target.getAttribute('data-action'));
            var title = this.props.title[action];
            var parkingImage = "",
                erpImage = "";
            var googleStart = "",
                googleEnd = "";
            if (action == 4) {
                parkingImage = this.props.journeyList[index].parkingImage;
            } else if (action == 7) {
                erpImage = this.props.journeyList[index].erpImage;
            } else if (action == 2) {
                googleStart = this.props.journeyList[index].googleStart;
                googleEnd = this.props.journeyList[index].googleEnd;
            }
            this.setState({
                jpId: id, modalClose: true, action: action, title: title, parkingImage: parkingImage, erpImage: erpImage,
                googleStart: googleStart, googleEnd: googleEnd
            });
            if (action != 4 && action != 7) {
                _jpAction2.default.shouldListShow(index);
            }
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose() {
            this.setState({ modalClose: false });
        }
    }, {
        key: 'updateERP',
        value: function updateERP(value) {
            if (!this.state.processing) {
                _jpAction2.default.processing(true);
                _jpAction2.default.updateERP(this.state.jpId, value);
                this.shouldModalClose();
            }
        }
    }, {
        key: 'updateParking',
        value: function updateParking(value) {
            if (!this.state.processing) {
                _jpAction2.default.processing(true);
                _jpAction2.default.updateParking(this.state.jpId, value);
                this.shouldModalClose();
            }
        }
        /*
        updateMileage(value) {
            if (!this.state.processing) {
                jpAction.processing(true);
                jpAction.updateMileage(this.state.jpId, value);
                this.shouldModalClose();
            }
        }
        */

    }, {
        key: 'updateDistance',
        value: function updateDistance(value, googleStart, googleEnd) {
            if (!this.state.processing) {
                _jpAction2.default.processing(true);
                _jpAction2.default.updateDistance(this.state.jpId, value, googleStart, googleEnd);
                this.shouldModalClose();
            }
        }
    }, {
        key: 'removeJp',
        value: function removeJp() {
            if (!this.state.processing) {
                _jpAction2.default.processing(true);
                _jpAction2.default.removeJp(this.state.jpId);
                this.shouldModalClose();
            }
        }
    }, {
        key: 'uploadReceipt',
        value: function uploadReceipt(value) {
            if (this.state.processing) return;

            var fd = new FormData();
            if (value) {
                if (value.length > 0) {
                    for (var i = 0; i < value.length; i++) {
                        fd.append("images", value[i]);
                    }
                    fd.append("jpId", this.state.jpId);
                    _jpAction2.default.processing(true);
                    _jpAction2.default.uploadReceipt(this.state.jpId, fd);
                    this.shouldModalClose();
                }
            }
        }
    }, {
        key: 'updateRemark',
        value: function updateRemark(value) {
            if (!this.state.processing) {
                _jpAction2.default.processing(true);
                _jpAction2.default.updateRemark(this.state.jpId, value);
                this.shouldModalClose();
            }
        }
    }, {
        key: 'uploadERPReceipt',
        value: function uploadERPReceipt(value) {
            if (this.state.processing) return;

            var fd = new FormData();
            if (value) {
                if (value.length > 0) {
                    for (var i = 0; i < value.length; i++) {
                        fd.append("images", value[i]);
                    }
                    fd.append("jpId", this.state.jpId);
                    _jpAction2.default.processing(true);
                    _jpAction2.default.uploadERPReceipt(this.state.jpId, fd);
                    this.shouldModalClose();
                }
            }
        }
    }, {
        key: 'showOption',
        value: function showOption(e) {
            e.preventDefault();
            e.stopPropagation();
            var index = parseInt(e.currentTarget.getAttribute("data-index"));
            _jpAction2.default.shouldListShow(index);
        }
    }, {
        key: 'closeOption',
        value: function closeOption() {
            _jpAction2.default.closeListShow();
        }
    }, {
        key: 'renderReceipt',
        value: function renderReceipt(jp, index) {
            if (jp.parkingImage) {
                if (jp.parkingImage.length > 0) {
                    return _react2.default.createElement(
                        'div',
                        { 'data-index': index, 'data-id': jp._id, 'data-action': '4', onClick: this.handleOption, style: { cursor: "pointer" } },
                        'View Parking Receipt'
                    );
                } else {
                    return "--";
                }
            } else {
                return "--";
            }
        }
    }, {
        key: 'renderERPReceipt',
        value: function renderERPReceipt(jp, index) {
            if (jp.erpImage) {
                if (jp.erpImage.length > 0) {
                    return _react2.default.createElement(
                        'div',
                        { 'data-index': index, 'data-id': jp._id, 'data-action': '7', onClick: this.handleOption, style: { cursor: "pointer" } },
                        'View ERP Receipt'
                    );
                } else {
                    return "--";
                }
            } else {
                return "--";
            }
        }
    }, {
        key: 'renderDataList',
        value: function renderDataList(jp, index) {
            jp.date = new Date(jp.date);
            jp.startTime = jp.startTime ? new Date(jp.startTime) : "";
            jp.endTime = jp.endTime ? new Date(jp.endTime) : "";
            var date = jp.date.getDate() + "-" + this.props.mthTxt[jp.date.getMonth()] + "-" + jp.date.getFullYear();
            var day = this.props.dayTxt[jp.date.getDay()];
            var timeInHour = "--",
                timeInMinute = "--",
                timeOutHour = "--",
                timeOutMinute = "--";

            if (jp.startTime) {
                timeInHour = jp.startTime.getHours() < 10 ? "0" + jp.startTime.getHours() : jp.startTime.getHours();
                timeInMinute = jp.startTime.getMinutes() < 10 ? "0" + jp.startTime.getMinutes() : jp.startTime.getMinutes();
            }
            if (jp.endTime) {
                timeOutHour = jp.endTime.getHours() < 10 ? "0" + jp.endTime.getHours() : jp.endTime.getHours();
                timeOutMinute = jp.endTime.getMinutes() < 10 ? "0" + jp.endTime.getMinutes() : jp.endTime.getMinutes();
            }

            return _react2.default.createElement(
                'tr',
                { key: index },
                _react2.default.createElement(
                    'td',
                    null,
                    date
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    day
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    jp.staffId
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    jp.userName
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    timeInHour + ":" + timeInMinute
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    timeOutHour + ":" + timeOutMinute
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    jp.googleStart
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    jp.googleEnd
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    jp.erp ? "$" + jp.erp : "-"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.renderERPReceipt(jp, index)
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    jp.parking ? "$" + jp.parking : "-"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.renderReceipt(jp, index)
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    jp.distance / 1000
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    jp.mileageClaim ? "$" + Math.round(jp.mileageClaim * 100) / 100 : "-"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    jp.totalClaim ? "$" + Math.round(jp.totalClaim * 100) / 100 : "-"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    jp.remark ? jp.remark : "-"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.renderStatus(jp._id, jp.status, index, jp.staffId)
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _genFunction2.default.hasPermission(this.state.permission, 1) || _genFunction2.default.isUser(this.state.userId, jp.staffId) || _genFunction2.default.isSubordinate(this.state.subordinate, jp.staffId) ? _react2.default.createElement('span', { className: 'jp-edit glyphicon glyphicon-option-vertical', 'data-index': index, onClick: this.showOption }) : "",
                    this.renderEdit(index, jp)
                )
            );
        }
    }, {
        key: 'renderEdit',
        value: function renderEdit(index, jp) {
            if (_genFunction2.default.hasPermission(this.state.permission, 1) || _genFunction2.default.isUser(this.state.userId, jp.staffId) || _genFunction2.default.isSubordinate(this.state.subordinate, jp.staffId)) {
                if (_genFunction2.default.hasPermission(this.state.permission, 1) || jp.status != 0) {
                    return _react2.default.createElement(
                        'ul',
                        { className: "jp-dropdown " + (jp.shouldListShow ? "jp-show" : "jp-hide") },
                        _react2.default.createElement(
                            'li',
                            { 'data-action': '0', 'data-id': jp._id, 'data-index': index, onClick: this.handleOption },
                            'Edit ERP'
                        ),
                        _react2.default.createElement(
                            'li',
                            { 'data-action': '1', 'data-id': jp._id, 'data-index': index, onClick: this.handleOption },
                            'Edit Parking'
                        ),
                        _genFunction2.default.hasPermission(this.state.permission, 1) && this.state.userId != jp.staffId || _genFunction2.default.isSubordinate(this.state.subordinate, jp.staffId) ? _react2.default.createElement(
                            'li',
                            { 'data-action': '2', 'data-id': jp._id, 'data-index': index, onClick: this.handleOption },
                            'Edit Distance'
                        ) : "",
                        _react2.default.createElement(
                            'li',
                            { 'data-action': '5', 'data-id': jp._id, 'data-index': index, onClick: this.handleOption },
                            'Upload Parking Receipt'
                        ),
                        _react2.default.createElement(
                            'li',
                            { 'data-action': '8', 'data-id': jp._id, 'data-index': index, onClick: this.handleOption },
                            'Upload ERP Receipt'
                        ),
                        _react2.default.createElement(
                            'li',
                            { 'data-action': '6', 'data-id': jp._id, 'data-index': index, onClick: this.handleOption },
                            'Add Remark'
                        ),
                        _react2.default.createElement(
                            'li',
                            { 'data-action': '3', 'data-id': jp._id, 'data-index': index, onClick: this.handleOption },
                            'Remove'
                        )
                    );
                }
            }
        }
    }, {
        key: 'renderStatus',
        value: function renderStatus(jpId, status, index, staffId) {
            if (_genFunction2.default.hasPermission(this.state.permission, 1) && this.state.userId != staffId || _genFunction2.default.isSubordinate(this.state.subordinate, staffId)) {
                return _react2.default.createElement(
                    'select',
                    { className: 'jp-status form-control input-sm', value: status,
                        'data-index': index, 'data-id': jpId, onChange: this.handleStatusChange
                    },
                    _react2.default.createElement(
                        'option',
                        { value: 0 },
                        this.props.statusTxt[0]
                    ),
                    _react2.default.createElement(
                        'option',
                        { value: 1 },
                        this.props.statusTxt[1]
                    ),
                    _react2.default.createElement(
                        'option',
                        { value: 2 },
                        this.props.statusTxt[2]
                    ),
                    _react2.default.createElement(
                        'option',
                        { value: 3 },
                        this.props.statusTxt[3]
                    ),
                    _react2.default.createElement(
                        'option',
                        { value: 4 },
                        this.props.statusTxt[4]
                    )
                );
            } else {
                return this.props.statusTxt[status];
            }
        }
    }, {
        key: 'renderMainList',
        value: function renderMainList() {
            var _this2 = this;

            if (!this.props.journeyList) return;
            return this.props.journeyList.map(function (jp, index) {
                return _this2.renderDataList(jp, index);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var callBack = void 0;
            if (this.state.action == 0) {
                callBack = this.updateERP;
            } else if (this.state.action == 1) {
                callBack = this.updateParking;
            } else if (this.state.action == 2) {
                //callBack = this.updateMileage;
                callBack = this.updateDistance;
            } else if (this.state.action == 3) {
                callBack = this.removeJp;
            } else if (this.state.action == 5) {
                callBack = this.uploadReceipt;
            } else if (this.state.action == 6) {
                callBack = this.updateRemark;
            } else if (this.state.action == 8) {
                callBack = this.uploadERPReceipt;
            }
            var modal = "";
            if (this.state.modalClose) {
                modal = _react2.default.createElement(_jpModal2.default, {
                    modalClose: this.state.modalClose,
                    action: this.state.action,
                    shouldModalClose: this.shouldModalClose,
                    callBack: callBack,
                    title: this.state.title,
                    parkingImage: this.state.parkingImage,
                    erpImage: this.state.erpImage,
                    googleStart: this.state.googleStart,
                    googleEnd: this.state.googleEnd
                });
            }
            return _react2.default.createElement(
                'div',
                { className: 'atd-abd-wp' },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-em-lt' },
                    _react2.default.createElement(
                        'table',
                        { className: 'jp-tb' },
                        _react2.default.createElement(
                            'tbody',
                            { className: "jp-tbd" },
                            this.renderMainList()
                        )
                    )
                ),
                modal
            );
        }
    }]);

    return JPList;
}(_react2.default.Component);

JPList.defaultProps = {
    mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    dayTxt: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    statusTxt: ["Approved", "Need Justification", "Rejected", "Pending", "Removed"],
    title: ["Edit ERP", "Edit Parking", "Edit Distance (meter)", "Remove List", "Parking Receipt", "Upload Parking Receipt", "Add Remark", "ERP Receipt", "Upload ERP Receipt"]
};
exports.default = JPList;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JpModal = function (_React$Component) {
    _inherits(JpModal, _React$Component);

    function JpModal(props) {
        _classCallCheck(this, JpModal);

        var _this = _possibleConstructorReturn(this, (JpModal.__proto__ || Object.getPrototypeOf(JpModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.upLoadImg = _this.upLoadImg.bind(_this);
        _this.handlePictureClick = _this.handlePictureClick.bind(_this);
        _this.state = {
            txtValue1: "",
            txtValue2: "",
            txtValue3: "",
            picIndex: 0,
            warningMsg: ""
        };
        return _this;
    }

    _createClass(JpModal, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.setState({
                txtValue2: this.props.googleStart,
                txtValue3: this.props.googleEnd
            });
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {}
    }, {
        key: "upLoadImg",
        value: function upLoadImg(e) {
            e.preventDefault();
            //let len = e.target.files.length;
            //if (len > 2) {
            //    return this.setState({ warningMsg: "Maximum upload two pictures only" });
            //} else {
            //    this.setState({ warningMsg: "" });
            //}
            //for (let i = 0; i < len; i++) {
            //    let file = e.target.files[i];
            //    this._previewImage(file, i);
            //}
            var file = e.target.files[0];
            this._previewImage(file, 0);
        }
    }, {
        key: "_previewImage",
        value: function _previewImage(file, index) {
            var _this2 = this;

            //to be modified
            var fr = new FileReader();
            fr.onload = function (e) {
                var imgUrl = window.URL.createObjectURL(new Blob([e.target.result]));
                var img = new Image();

                img.onload = function () {
                    _this2.resizeImage(img, index);
                };

                img.src = imgUrl;
            };
            fr.readAsArrayBuffer(file);
        }
    }, {
        key: "dataURItoBlob",
        value: function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = window.atob(dataURI.split(',')[1]);else byteString = unescape(dataURI.split(',')[1]);

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], { type: mimeString });
        }
    }, {
        key: "resizeImage",
        value: function resizeImage(image, index) {
            var oHeight = image.naturalHeight;
            var oWidth = image.naturalWidth;
            var newImage = void 0,
                newSize = void 0;
            var oSize = { oHeight: oHeight, oWidth: oWidth };
            newSize = { width: 500, height: 500 * oHeight / oWidth };

            newImage = this._imgResize(image, newSize, oSize);
            var blobFile = this.state.txtValue1;
            if (blobFile == "") blobFile = [];
            blobFile[index] = this.dataURItoBlob(newImage);
            this.setState({ txtValue1: blobFile });
        }
    }, {
        key: "_imgResize",
        value: function _imgResize(img, newSize, oSize) {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext("2d");
            canvas.width = newSize.width;
            canvas.height = newSize.height;
            ctx.drawImage(img, 0, 0, oSize.oWidth, oSize.oHeight, 0, 0, newSize.width, newSize.height);
            return canvas.toDataURL('image/jpeg', 1);
        }
    }, {
        key: "handleChange",
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute("data-index"));

            if (index == 0) {
                var value = parseFloat(e.target.value);
                this.setState({ txtValue1: value });
            } else if (index == 1) {
                var _value = e.target.value;
                this.setState({ txtValue1: _value });
            } else if (index == 2) {
                this.setState({ txtValue2: e.target.value });
            } else if (index == 3) {
                this.setState({ txtValue3: e.target.value });
            }
        }
    }, {
        key: "handleSubmit",
        value: function handleSubmit(e) {
            this.props.callBack(this.state.txtValue1, this.state.txtValue2, this.state.txtValue3);
        }
    }, {
        key: "handlePictureClick",
        value: function handlePictureClick(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            if (index != this.state.picIndex) {
                this.setState({ picIndex: index });
            }
        }
    }, {
        key: "modalClose",
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: "renderBody",
        value: function renderBody() {
            var contentTitle = "";
            var body = "";
            if (this.props.action == 0 || this.props.action == 1) {
                contentTitle = "Type the amount here";
                body = _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "form",
                        null,
                        _react2.default.createElement("input", { className: "form-control", placeholder: contentTitle, type: "number", "data-index": "0", onChange: this.handleChange })
                    )
                );
            } else if (this.props.action == 2) {
                contentTitle = "Update distance here";
                body = _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "div",
                        { className: "form-group" },
                        _react2.default.createElement(
                            "label",
                            { htmlFor: "distance" },
                            "Distance"
                        ),
                        _react2.default.createElement("input", { className: "form-control", placeholder: contentTitle, type: "number",
                            "data-index": "0", onChange: this.handleChange })
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "form-group" },
                        _react2.default.createElement(
                            "label",
                            { htmlFor: "distance" },
                            "Start Location"
                        ),
                        _react2.default.createElement("input", { className: "form-control", placeholder: contentTitle, type: "text", value: this.state.txtValue2,
                            "data-index": "2", onChange: this.handleChange })
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "form-group" },
                        _react2.default.createElement(
                            "label",
                            { htmlFor: "distance" },
                            "End Location"
                        ),
                        _react2.default.createElement("input", { className: "form-control", placeholder: contentTitle, type: "text", value: this.state.txtValue3,
                            "data-index": "3", onChange: this.handleChange })
                    )
                );
            } else if (this.props.action == 3) {
                contentTitle = "Are you Sure? This list will be remove permanently";
                body = _react2.default.createElement(
                    "div",
                    null,
                    contentTitle
                );
            } else if (this.props.action == 4) {
                body = _react2.default.createElement(
                    "div",
                    { className: "jp-m-fm" },
                    _react2.default.createElement(
                        "div",
                        { className: "jp-m-img-wp" },
                        _react2.default.createElement("img", { className: "jp-m-img", src: this.props.parkingImage[this.state.picIndex] })
                    )
                );
            } else if (this.props.action == 5) {
                body = _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "div",
                        { className: "warning" },
                        this.state.warningMsg
                    ),
                    _react2.default.createElement(
                        "form",
                        null,
                        _react2.default.createElement("input", { className: "form-control", type: "file", name: "myImage", accept: "image/x-png,image/jpeg", onChange: this.upLoadImg })
                    )
                );
            } else if (this.props.action == 6) {
                contentTitle = "Type remark here";
                body = _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "form",
                        null,
                        _react2.default.createElement("input", { className: "form-control", placeholder: contentTitle, type: "text", "data-index": "1", onChange: this.handleChange })
                    )
                );
            } else if (this.props.action == 7) {
                body = _react2.default.createElement(
                    "div",
                    { className: "jp-m-fm" },
                    _react2.default.createElement(
                        "div",
                        { className: "jp-m-img-wp" },
                        _react2.default.createElement("img", { className: "jp-m-img", src: this.props.erpImage[this.state.picIndex] })
                    )
                );
            } else if (this.props.action == 8) {
                body = _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "div",
                        { className: "warning" },
                        this.state.warningMsg
                    ),
                    _react2.default.createElement(
                        "form",
                        null,
                        _react2.default.createElement("input", { className: "form-control", type: "file", name: "myImage", accept: "image/x-png,image/jpeg", onChange: this.upLoadImg })
                    )
                );
            }
            return body;
        }
    }, {
        key: "renderNumber",
        value: function renderNumber() {
            var _this3 = this;

            return this.props.parkingImage.map(function (images, index) {
                var isCurrent = false;
                if (index == _this3.state.picIndex) {
                    isCurrent = true;
                }

                return _react2.default.createElement(
                    "div",
                    { key: index, className: "jp-m-img-no " + (isCurrent ? "jp-img-active" : "jp-img-inactive"),
                        "data-index": index,
                        onClick: _this3.handlePictureClick },
                    index + 1
                );
            });
        }
    }, {
        key: "render",
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            var content = void 0;
            var btn = "";
            if (this.props.action == 4 || this.props.action == 7) {
                btn = _react2.default.createElement(
                    "button",
                    { type: "button", className: "btn btn-default single-btn", onClick: this.modalClose },
                    "Ok"
                );
            } else {
                btn = _react2.default.createElement(
                    "div",
                    { style: { width: "100%" } },
                    _react2.default.createElement(
                        "button",
                        { type: "button", className: "btn " + (this.props.action == 3 ? " btn-danger" : "btn-warning"),
                            onClick: this.handleSubmit },
                        this.props.action == 3 ? "Remove" : "Update"
                    ),
                    _react2.default.createElement(
                        "button",
                        { type: "button", className: "btn btn-default", onClick: this.modalClose },
                        "Cancel"
                    )
                );
            }

            return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement("div", { className: "report-shadow", style: style }),
                _react2.default.createElement(
                    "div",
                    { className: "report-modal", style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        "div",
                        { className: "modal-header" },
                        _react2.default.createElement(
                            "h4",
                            { className: "modal-title" },
                            this.props.title
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "modal-body" },
                        this.renderBody()
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "modal-footer" },
                        btn
                    )
                )
            );
        }
    }]);

    return JpModal;
}(_react2.default.Component);

JpModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = JpModal;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JPconfirmModal = function (_React$Component) {
    _inherits(JPconfirmModal, _React$Component);

    function JPconfirmModal(props) {
        _classCallCheck(this, JPconfirmModal);

        var _this = _possibleConstructorReturn(this, (JPconfirmModal.__proto__ || Object.getPrototypeOf(JPconfirmModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        return _this;
    }

    _createClass(JPconfirmModal, [{
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            this.props.callBack(this.props.action);
            this.modalClose();
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'renderBody',
        value: function renderBody() {
            var body = void 0;
            if (this.props.action == 0) {
                body = "Are you sure to send email to employee for justification?";
            } else if (this.props.action == 1) {
                body = "Please confirm that all mileage claims are approved";
            } else {
                body = "Are you sure to reject the mileage claim?";
            }

            return body;
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'report-modal', style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            this.props.title
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body' },
                        this.renderBody()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-warning', onClick: this.handleSubmit },
                            'Ok'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return JPconfirmModal;
}(_react2.default.Component);

JPconfirmModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = JPconfirmModal;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _reportHeader = __webpack_require__(195);

var _reportHeader2 = _interopRequireDefault(_reportHeader);

var _reportBody = __webpack_require__(197);

var _reportBody2 = _interopRequireDefault(_reportBody);

var _reportAction = __webpack_require__(28);

var _reportAction2 = _interopRequireDefault(_reportAction);

var _reportStore = __webpack_require__(31);

var _reportStore2 = _interopRequireDefault(_reportStore);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Report = function (_React$Component) {
    _inherits(Report, _React$Component);

    function Report(props) {
        var _this$state;

        _classCallCheck(this, Report);

        var _this = _possibleConstructorReturn(this, (Report.__proto__ || Object.getPrototypeOf(Report)).call(this, props));

        _this.onUserChange = function (state) {
            _this.setState({
                permission: state.permission,

                userId: state.staffId
            });
        };

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.state = (_this$state = {
            reports: _reportStore2.default.getState().reports,
            staffs: _filterStore2.default.getState().staffs,

            processingFilter: _filterStore2.default.getState().processing,
            iniLoadStaff: _filterStore2.default.getState().iniLoadStaff,
            iniLoadTeamMember: _filterStore2.default.getState().iniLoadTeamMember,
            teamMember: _filterStore2.default.getState().teamMember,

            teamCondo: _filterStore2.default.getState().teamCondo,
            iniLoadCondo: _filterStore2.default.getState().iniLoadTeamCondo,
            condos: _filterStore2.default.getState().condos
        }, _defineProperty(_this$state, 'iniLoadCondo', _filterStore2.default.getState().iniLoadCondo), _defineProperty(_this$state, 'processing', _reportStore2.default.getState().processing), _defineProperty(_this$state, 'permission', _userStore2.default.getState().permission), _defineProperty(_this$state, 'userId', _userStore2.default.getState().staffId), _this$state);
        return _this;
    }

    _createClass(Report, [{
        key: 'componentWillMount',
        value: function componentWillMount() {}
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            _reportStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);
            _userStore2.default.listen(this.onUserChange);
            _menuAction2.default.pageNumber(4);
            if (!this.state.processingFilter && !this.state.iniLoadStaff) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getEmployee();
            }
            if (!this.state.iniLoadTeamCondo) {
                _filterAction2.default.getTeamCondo();
            }
            if (!this.state.iniLoadCondo) {
                //getMCST first
                _filterAction2.default.processing(true);
                _filterAction2.default.getCondoList();
            }
            if (!this.state.iniLoadTeamMember) {
                _filterAction2.default.getTeamMember();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _reportStore2.default.unlisten(this.onChange);
            _filterStore2.default.unlisten(this.onFilterChange);
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                staffs: state.staffs,
                processingFilter: state.processing,
                iniLoadStaff: state.iniLoadStaff,
                iniLoadTeamCondo: state.iniLoadTeamCondo,
                teamCondo: state.teamCondo,
                iniLoadTeamMember: state.iniLoadTeamMember,
                teamMember: state.teamMember,
                iniLoadCondo: state.iniLoadCondo,
                condos: state.condos
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                reports: state.reports,
                processing: state.processing
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                userId = _state.userId,
                condos = _state.condos,
                teamCondo = _state.teamCondo;

            if (userId == "ITG001") {
                condos = [{
                    condoName: "Thomson Grand",
                    mcst: "4309"
                }];
                teamCondo = [{
                    condoName: "Thomson Grand",
                    mcst: "4309"
                }];
            }
            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 atd' },
                        _react2.default.createElement(_reportHeader2.default, { staffs: this.state.staffs, condos: condos, iniLoad: this.state.iniLoad,
                            teamMember: this.state.teamMember, teamCondo: teamCondo }),
                        _react2.default.createElement('div', { className: 'divider' }),
                        _react2.default.createElement(_reportBody2.default, _extends({ reports: this.state.reports }, this.props))
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.processingFilter })
            );
        }
    }]);

    return Report;
}(_react2.default.Component);

exports.default = Report;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _reportFilter = __webpack_require__(196);

var _reportFilter2 = _interopRequireDefault(_reportFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportHeader = function (_React$Component) {
    _inherits(ReportHeader, _React$Component);

    function ReportHeader(props) {
        _classCallCheck(this, ReportHeader);

        return _possibleConstructorReturn(this, (ReportHeader.__proto__ || Object.getPrototypeOf(ReportHeader)).call(this, props));
    }

    _createClass(ReportHeader, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-hd' },
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(
                        'b',
                        null,
                        'Summary of Incident Report'
                    )
                ),
                _react2.default.createElement(_reportFilter2.default, { staffs: this.props.staffs, condos: this.props.condos, iniLoad: this.props.staffs,
                    teamMember: this.props.teamMember, teamCondo: this.props.teamCondo }),
                _react2.default.createElement('div', { className: 'clear' })
            );
        }
    }]);

    return ReportHeader;
}(_react2.default.Component);

exports.default = ReportHeader;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _reportAction = __webpack_require__(28);

var _reportAction2 = _interopRequireDefault(_reportAction);

var _reportStore = __webpack_require__(31);

var _reportStore2 = _interopRequireDefault(_reportStore);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportFilter = function (_React$Component) {
    _inherits(ReportFilter, _React$Component);

    function ReportFilter(props) {
        _classCallCheck(this, ReportFilter);

        var _this = _possibleConstructorReturn(this, (ReportFilter.__proto__ || Object.getPrototypeOf(ReportFilter)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleRNSubmit = _this.handleRNSubmit.bind(_this);
        _this.handleExport = _this.handleExport.bind(_this);
        _this.handlePrint = _this.handlePrint.bind(_this);
        _this.handleRNChange = _this.handleRNChange.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.handleExportUnresolve = _this.handleExportUnresolve.bind(_this);
        _this.state = {
            processing: _reportStore2.default.getState().processing,
            iniYear: 2017,
            iniMonth: 11,
            staffId: _reportStore2.default.getState().staffId,
            mcst: _reportStore2.default.getState().mcst,
            startYear: _reportStore2.default.getState().startYear,
            startMonth: _reportStore2.default.getState().startMonth,
            endYear: _reportStore2.default.getState().endYear,
            endMonth: _reportStore2.default.getState().endMonth,
            reportNo: _reportStore2.default.getState().reportNo,

            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId
        };
        return _this;
    }

    _createClass(ReportFilter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _reportStore2.default.listen(this.onChange);
            _userStore2.default.listen(this.onUserChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _reportStore2.default.unlisten(this.onChange);
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                startYear: state.startYear,
                startMonth: state.startMonth,
                endYear: state.endYear,
                endMonth: state.endMonth,
                staffId: state.staffId,
                mcst: state.mcst,
                reportNo: state.reportNo
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            var value = e.target.value.split(":");
            var selectedYear = parseInt(value[0]);
            var selectedMonth = parseInt(value[1]);
            if (index == 0) {
                _reportAction2.default.updateSM({ startYear: selectedYear, startMonth: selectedMonth });
            } else if (index == 1) {
                _reportAction2.default.updateEM({ endYear: selectedYear, endMonth: selectedMonth });
            } else if (index == 2) {
                _reportAction2.default.updateUI({ staffId: value[0] });
            } else if (index == 3) {
                _reportAction2.default.updateCI({ mcst: value[0] });
            }
        }
    }, {
        key: 'handleRNChange',
        value: function handleRNChange(e) {
            var value = e.target.value;
            _reportAction2.default.updateRN({ reportNo: value });
        }
    }, {
        key: 'handlePrint',
        value: function handlePrint() {
            window.print();
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            if (!this.state.processing) {
                _reportAction2.default.processing(true);
                _reportAction2.default.getReport(this.state.staffId, this.state.mcst, this.state.startYear, this.state.startMonth, this.state.endYear, this.state.endMonth);
            }
        }
    }, {
        key: 'handleRNSubmit',
        value: function handleRNSubmit() {
            if (this.state.reportNo != '') {
                if (this.state.processing) return;

                _reportAction2.default.processing(true);
                _reportAction2.default.getReportByRN(this.state.reportNo);
            } else {
                _reportAction2.default.warningMsg("Report No cannot be emptied");
            }
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            if (e.key == 'Enter') {
                e.preventDefault();
                this.handleRNSubmit();
            }
        }
    }, {
        key: 'handleExport',
        value: function handleExport() {
            if (!this.state.processing) {
                _reportAction2.default.processing(true);
                _reportAction2.default.exportReport(this.state.staffId, this.state.mcst, this.state.startYear, this.state.startMonth, this.state.endYear, this.state.endMonth);
            }
        }
    }, {
        key: 'handleExportUnresolve',
        value: function handleExportUnresolve() {
            if (!this.state.processing) {
                _reportAction2.default.processing(true);
                _reportAction2.default.exportUnresolvedReport(this.state.staffId, this.state.mcst);
            }
        }
    }, {
        key: 'renderOption',
        value: function renderOption(yr, mth) {
            return _react2.default.createElement(
                'option',
                { value: yr + ":" + mth, key: yr + ":" + mth },
                this.props.mthTxt[mth] + " " + yr
            );
        }
    }, {
        key: 'renderStaff',
        value: function renderStaff(staff, index) {
            return _react2.default.createElement(
                'option',
                { value: staff.staffId, key: index },
                staff.userName
            );
        }
    }, {
        key: 'renderStaffs',
        value: function renderStaffs() {
            var _this2 = this;

            var staffs = this.props.staffs;
            if (staffs.length > 0) {
                staffs = this.props.staffs.filter(function (staff) {
                    return _genFunction2.default.hasPermission(_this2.state.permission, 11) || _genFunction2.default.isSubordinate(_this2.state.subordinate, staff.staffId) || _genFunction2.default.isUser(_this2.state.userId, staff.staffId) || _genFunction2.default.isMember(_this2.props.teamMember, staff.staffId);
                });

                return staffs.map(function (staff, index) {
                    return _this2.renderStaff(staff, index);
                });
            }
        }
    }, {
        key: 'renderCondos',
        value: function renderCondos() {
            var _this3 = this;

            var condos = this.props.condos;
            if (condos.length > 0) {
                condos = condos.filter(function (condo) {
                    return _genFunction2.default.hasPermission(_this3.state.permission, 11) || _genFunction2.default.hasCondo(_this3.props.teamCondo, condo.mcst);
                });

                return condos.map(function (condo, index) {
                    return _react2.default.createElement(
                        'option',
                        { value: condo.mcst, key: index },
                        condo.condoName
                    );
                });
            }
        }
    }, {
        key: 'renderOptions',
        value: function renderOptions() {
            var options = [];
            var thisYear = new Date().getFullYear();
            var thisMonth = new Date().getMonth();

            for (var yr = thisYear; yr >= this.state.iniYear; yr--) {
                if (thisYear == this.state.iniYear) {
                    for (var mth = thisMonth; mth >= this.state.iniMonth; mth--) {
                        options = options.concat(this.renderOption(yr, mth));
                    }
                } else if (yr == thisYear) {
                    for (var _mth = thisMonth; _mth >= 0; _mth--) {
                        options = options.concat(this.renderOption(yr, _mth));
                    }
                } else if (yr == this.state.iniYear) {
                    for (var _mth2 = 11; _mth2 >= this.state.iniMonth; _mth2--) {
                        options = options.concat(this.renderOption(yr, _mth2));
                    }
                } else {
                    for (var _mth3 = 11; _mth3 >= 0; _mth3--) {
                        options = options.concat(this.renderOption(yr, _mth3));
                    }
                }
            }
            return options;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'report-i-1 row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-5 col-lg-3' },
                        _react2.default.createElement(
                            'form',
                            { className: 'form-horizontal atd-i-wp' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'reportNo', className: 'col-xs-4 col-sm-4 control-label' },
                                'Report No: '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group input-group-sm' },
                                _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'reportNo', placeholder: 'Search By Report No',
                                    value: this.state.reportNo, onChange: this.handleRNChange, onKeyPress: this.handleKeyPress }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'input-group-btn' },
                                    _react2.default.createElement(
                                        'button',
                                        { className: 'btn btn-default', type: 'button', onClick: this.handleRNSubmit },
                                        'Filter'
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-5 col-lg-3' },
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-i' },
                            _react2.default.createElement(
                                'form',
                                { className: 'form-horizontal atd-i-wp' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'startFrom', className: 'col-xs-4 col-sm-4 control-label' },
                                    'Start from: '
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-group input-group-sm' },
                                    _react2.default.createElement(
                                        'select',
                                        { className: 'form-control', name: 'startFrom', 'data-index': '0', onChange: this.handleChange, defaultValue: this.state.startYear + ":" + this.state.startMonth },
                                        this.renderOptions()
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'form',
                                { className: 'form-horizontal atd-i-wp' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'endMonth', className: 'col-xs-4 col-sm-4 control-label' },
                                    'Till: '
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-group input-group-sm' },
                                    _react2.default.createElement(
                                        'select',
                                        { className: 'form-control', name: 'endMonth', 'data-index': '1', onChange: this.handleChange, defaultValue: this.state.endYear + ":" + this.state.endMonth },
                                        this.renderOptions()
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-5 col-lg-3' },
                        _react2.default.createElement(
                            'form',
                            { className: 'form-horizontal atd-i-wp' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'staffName', className: 'col-xs-4 col-sm-4 control-label' },
                                'Submit By: '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group input-group-sm' },
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control', name: 'staffName', 'data-index': '2', onChange: this.handleChange, defaultValue: this.state.staffId },
                                    _react2.default.createElement(
                                        'option',
                                        { value: "" },
                                        'Any Staff'
                                    ),
                                    this.renderStaffs()
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'form',
                            { className: 'form-horizontal atd-i-wp' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'condoName', className: 'col-xs-4 col-sm-4 control-label' },
                                'Condo: '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group input-group-sm' },
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control', name: 'condoName', 'data-index': '3', onChange: this.handleChange, defaultValue: this.state.mcst },
                                    _react2.default.createElement(
                                        'option',
                                        { value: "" },
                                        'Any Condo'
                                    ),
                                    this.renderCondos()
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-5 col-lg-3 r-f-btn' },
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-i-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-default btn-sm', type: 'button', onClick: this.handleSubmit },
                                'Search'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-i-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-primary btn-sm', type: 'button', onClick: this.handlePrint },
                                'Print'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-i-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-primary btn-sm', onClick: this.handleExport },
                                'Export'
                            )
                        ),
                        _genFunction2.default.hasPermission(this.state.permission, 11) && _react2.default.createElement(
                            'div',
                            { className: 'atd-i-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-primary btn-sm', onClick: this.handleExportUnresolve },
                                'Export Unresolved Report'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        )
                    )
                )
            );
        }
    }]);

    return ReportFilter;
}(_react2.default.Component);

ReportFilter.defaultProps = {
    mthTxt: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
exports.default = ReportFilter;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reportList = __webpack_require__(198);

var _reportList2 = _interopRequireDefault(_reportList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportBody = function (_React$Component) {
    _inherits(ReportBody, _React$Component);

    function ReportBody(props) {
        _classCallCheck(this, ReportBody);

        var _this = _possibleConstructorReturn(this, (ReportBody.__proto__ || Object.getPrototypeOf(ReportBody)).call(this, props));

        _this.onTouchStart = _this.onTouchStart.bind(_this);
        _this.onTouchMove = _this.onTouchMove.bind(_this);
        _this.onTouchEnd = _this.onTouchEnd.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleMouseScroll = _this.handleMouseScroll.bind(_this);
        _this.state = {
            dragging: false,
            refX: 0,
            ini: 0,
            page: 0,
            contentNo: 50
        };
        return _this;
    }

    _createClass(ReportBody, [{
        key: 'componentDidMount',
        value: function componentDidMount() {

            if (document.body.clientWidth > 768) {
                var elem = _reactDom2.default.findDOMNode(this.refs.table);
                elem.addEventListener('mouseup', this.onTouchEnd);
                elem.addEventListener('mouseleave', this.onTouchEnd);
                elem.addEventListener('mousemove', this.onTouchMove);
                elem.addEventListener('mousedown', this.onTouchStart);

                window.addEventListener('wheel', this.handleMouseScroll);
            }
            window.addEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (document.body.clientWidth > 768) {
                var elem = _reactDom2.default.findDOMNode(this.refs.table);
                elem.removeEventListener('mouseup', this.onTouchEnd);
                elem.removeEventListener('mouseleave', this.onTouchEnd);
                elem.removeEventListener('mousemove', this.onTouchMove);
                elem.removeEventListener('mousedown', this.onTouchStart);

                window.removeEventListener('wheel', this.handleMouseScroll);
            }
            window.removeEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevProps.reports != this.props.reports) {
                this.setState({
                    page: 0
                });
            }
        }
    }, {
        key: 'handleMouseScroll',
        value: function handleMouseScroll(e) {
            e.preventDefault();
            if (e.deltaY > 0) {
                //scroll down
                window.scrollBy(0, 50);
            } else {
                //scroll up
                window.scrollBy(0, -50);
            }
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(e) {
            var elem1 = _reactDom2.default.findDOMNode(this.refs.atd);
            var elem2 = _reactDom2.default.findDOMNode(this.refs.table);
            if (elem2.getBoundingClientRect().top < 50) {

                elem1.style.position = "absolute";

                if (document.body.clientWidth > 768) {
                    elem2.style.paddingTop = "50px";
                    elem1.style.top = 50 - elem2.getBoundingClientRect().top + "px";
                } else {
                    elem2.style.paddingTop = "0px";
                    elem1.style.top = -elem2.getBoundingClientRect().top + "px";
                }
            } else {
                elem2.style.paddingTop = "0px";
                elem1.style.position = "relative";
                elem1.style.top = "0px";
            }
        }
    }, {
        key: 'onTouchStart',
        value: function onTouchStart(e) {
            if (!this.state.dragging) {
                var touches = e.changedTouches;
                var refX = void 0;
                if (e.touches) {
                    refX = e.touches[0].clientX;
                } else {
                    refX = e.clientX;
                }
                var ini = _reactDom2.default.findDOMNode(this.refs.table).scrollLeft;
                this.setState({
                    ini: ini,
                    refX: refX,
                    dragging: true
                });
            } else {
                this.setState({
                    dragging: false
                });
            }
        }
    }, {
        key: 'onTouchMove',
        value: function onTouchMove(e) {
            e.preventDefault();
            if (this.state.dragging && e.target) {
                var deltaX = void 0;
                if (e.touches) {
                    deltaX = parseInt(this.state.refX - e.touches[0].clientX);
                } else {
                    deltaX = parseInt(this.state.refX - e.clientX);
                }

                _reactDom2.default.findDOMNode(this.refs.table).scrollLeft = this.state.ini + deltaX;
            } else {
                this.setState({
                    dragging: false
                });
            }
        }
    }, {
        key: 'onTouchEnd',
        value: function onTouchEnd(e) {
            this.setState({
                dragging: false
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.currentTarget.getAttribute('data-index'));

            if (index != this.state.page) {
                this.setState({ page: index });
            }
        }
    }, {
        key: 'renderPagination',
        value: function renderPagination() {
            if (!this.props.reports) return;
            if (this.props.reports.length == 0) return;

            var pageNo = Math.ceil(this.props.reports.length / this.state.contentNo);

            var pagination = [];
            for (var i = 0; i < pageNo; i++) {
                pagination = pagination.concat(_react2.default.createElement(
                    'li',
                    { className: this.state.page == i ? "active" : "", key: i, 'data-index': i, onClick: this.handleClick },
                    _react2.default.createElement(
                        'a',
                        { href: '#' },
                        i + 1
                    )
                ));
            }
            return _react2.default.createElement(
                'nav',
                { className: 'ctr-pg', style: { maxWidth: this.state.tableWidth + "px" } },
                _react2.default.createElement(
                    'ul',
                    { className: 'pagination' },
                    pagination
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'pagination-title' },
                    'page ',
                    this.state.page + 1 + " of " + pageNo
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var reports = [];
            for (var i = 0 + this.state.contentNo * this.state.page; i < this.state.contentNo + this.state.contentNo * this.state.page; i++) {
                if (i < this.props.reports.length) {
                    reports = reports.concat(this.props.reports[i]);
                }
            }
            return _react2.default.createElement(
                'div',
                null,
                this.renderPagination(),
                _react2.default.createElement(
                    'div',
                    { className: 'atd-bd-wp', ref: 'table' },
                    _react2.default.createElement(
                        'div',
                        { className: 'atd-em-lt' },
                        _react2.default.createElement(
                            'table',
                            { className: 'report-tb tb-heading', ref: 'atd' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Report No'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Date'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Day'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Submitted By'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Estate'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'MCST'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Area'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Category'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Description'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Severity'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Target Completion Date'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Extend'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Reason'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Status'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Resolution'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Resolved By'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Remark'
                                    ),
                                    _react2.default.createElement('th', null)
                                )
                            )
                        ),
                        _react2.default.createElement(_reportList2.default, { reports: reports, history: this.props.history, page: this.state.page, contentNo: this.state.contentNo })
                    )
                ),
                this.renderPagination()
            );
        }
    }]);

    return ReportBody;
}(_react2.default.Component);

exports.default = ReportBody;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reportModal = __webpack_require__(82);

var _reportModal2 = _interopRequireDefault(_reportModal);

var _reportAction = __webpack_require__(28);

var _reportAction2 = _interopRequireDefault(_reportAction);

var _reportStore = __webpack_require__(31);

var _reportStore2 = _interopRequireDefault(_reportStore);

var _util = __webpack_require__(199);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportList = function (_React$Component) {
    _inherits(ReportList, _React$Component);

    function ReportList(props) {
        _classCallCheck(this, ReportList);

        var _this = _possibleConstructorReturn(this, (ReportList.__proto__ || Object.getPrototypeOf(ReportList)).call(this, props));

        _this.handleReportClick = _this.handleReportClick.bind(_this);
        _this.extendIncident = _this.extendIncident.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.resolveIncident = _this.resolveIncident.bind(_this);
        _this.addingRemark = _this.addingRemark.bind(_this);
        _this.removeIncident = _this.removeIncident.bind(_this);
        _this.showOption = _this.showOption.bind(_this);
        _this.closeOption = _this.closeOption.bind(_this);
        _this.handleOption = _this.handleOption.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.state = {
            action: 0,
            modalClose: false,
            reportId: "",
            title: "",
            clientEmail: [],
            processing: _reportStore2.default.getState().processing
        };
        return _this;
    }

    _createClass(ReportList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _reportStore2.default.listen(this.onChange);
            window.addEventListener("click", this.closeOption);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _reportStore2.default.unlisten(this.onChange);
            window.removeEventListener("click", this.closeOption);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing
            });
        }
    }, {
        key: 'showOption',
        value: function showOption(e) {
            e.preventDefault();
            e.stopPropagation();
            var index = parseInt(e.currentTarget.getAttribute("data-index"));
            index = index + this.props.page * this.props.contentNo;
            _reportAction2.default.shouldListShow(index);
        }
    }, {
        key: 'closeOption',
        value: function closeOption() {
            _reportAction2.default.closeListShow();
        }
    }, {
        key: 'handleOption',
        value: function handleOption(e) {
            var _setState;

            e.preventDefault();
            e.stopPropagation();

            var action = parseInt(e.currentTarget.getAttribute("data-action"));
            var reportId = e.currentTarget.getAttribute('data-id');
            var index = parseInt(e.currentTarget.getAttribute('data-index'));

            var title = void 0;
            if (action == 0) {
                title = "Extend Target Date";
            } else if (action == 1) {
                title = "Resolution";
            } else if (action == 2) {
                title = "Add Remark";
            } else {
                title = "Delete Incident";
            }
            var clientEmail = this.props.reports[index].clientEmail;

            _reportAction2.default.shouldListShow(index);

            this.setState((_setState = {
                action: 0,
                modalClose: true,
                reportId: reportId
            }, _defineProperty(_setState, 'action', action), _defineProperty(_setState, 'title', title), _defineProperty(_setState, 'clientEmail', clientEmail), _setState));
        }
    }, {
        key: 'extendIncident',
        value: function extendIncident(day, reason, clientEmail, reportImage) {
            if (this.state.processing) return;
            _reportAction2.default.processing(true);
            var fd = new FormData();
            fd.append("day", day);
            fd.append("reason", reason);
            if (clientEmail) {
                if (clientEmail.length > 0) {
                    for (var i = 0; i < clientEmail.length; i++) {
                        fd.append("clientEmail[]", clientEmail[i]);
                    }
                }
            }
            if (reportImage) {
                if (reportImage.length > 0) {
                    for (var _i = 0; _i < reportImage.length; _i++) {
                        fd.append("images", reportImage[_i]);
                    }
                }
            }
            _reportAction2.default.extendIncident(this.state.reportId, fd);
            this.shouldModalClose(false);
        }
    }, {
        key: 'resolveIncident',
        value: function resolveIncident(resolution, value, clientEmail, reportImage) {
            if (this.state.processing) return;
            _reportAction2.default.processing(true);
            var fd = new FormData();
            fd.append("resolution", resolution);
            if (clientEmail) {
                if (clientEmail.length > 0) {
                    for (var i = 0; i < clientEmail.length; i++) {
                        fd.append("clientEmail[]", clientEmail[i]);
                    }
                }
            }
            if (reportImage) {
                if (reportImage.length > 0) {
                    for (var _i2 = 0; _i2 < reportImage.length; _i2++) {
                        fd.append("images", reportImage[_i2]);
                    }
                }
            }
            _reportAction2.default.resolveIncident(this.state.reportId, fd);
            this.shouldModalClose(false);
        }
    }, {
        key: 'addingRemark',
        value: function addingRemark(remark, value, clientEmail, reportImage) {
            if (this.state.processing) return;
            _reportAction2.default.processing(true);

            var fd = new FormData();
            fd.append("remark", remark);
            if (clientEmail) {
                if (clientEmail.length > 0) {
                    for (var i = 0; i < clientEmail.length; i++) {
                        fd.append("clientEmail[]", clientEmail[i]);
                    }
                }
            }
            if (reportImage) {
                if (reportImage.length > 0) {
                    for (var _i3 = 0; _i3 < reportImage.length; _i3++) {
                        fd.append("images", reportImage[_i3]);
                    }
                }
            }
            _reportAction2.default.addingRemark(this.state.reportId, fd);
            this.shouldModalClose(false);
        }
    }, {
        key: 'removeIncident',
        value: function removeIncident(reason, value, clientEmail, reportImage) {
            if (this.state.processing) return;
            _reportAction2.default.processing(true);
            _reportAction2.default.removeIncident(this.state.reportId, this.state.clientEmail, reason);
            this.shouldModalClose(false);
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({
                modalClose: data
            });
        }
    }, {
        key: 'handleReportClick',
        value: function handleReportClick(e) {
            var reportId = e.currentTarget.getAttribute('data-id');
            this.props.history.push('/report/' + reportId);
        }
    }, {
        key: 'renderDataList',
        value: function renderDataList(report, index) {
            report.date = new Date(report.date);
            report.targetDate = new Date(report.targetDate);
            var date = report.date.getDate() + "-" + this.props.mthTxt[report.date.getMonth()] + "-" + report.date.getFullYear();
            var targetDate = report.targetDate.getDate() + "-" + this.props.mthTxt[report.targetDate.getMonth()] + "-" + report.targetDate.getFullYear();
            var day = this.props.dayTxt[report.date.getDay()];
            var extend = report.extend.length > 0 ? report.extend[report.extend.length - 1].day : "--";
            var reason = report.extend.length > 0 ? report.extend[report.extend.length - 1].reason : "--";
            var remark = report.remarks.length > 0 ? report.remarks[report.remarks.length - 1].remark : "--";

            return _react2.default.createElement(
                'tr',
                { key: index },
                _react2.default.createElement(
                    'td',
                    { 'data-id': report.reportNo, onClick: this.handleReportClick },
                    report.reportNo
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    date
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    day
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    report.userName
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    report.condoName
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    report.mcst
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    report.facility
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    report.category
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'rpt-t' },
                    report.description
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.props.severityTxt[report.severity]
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    targetDate
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    extend
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    reason
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.props.statusTxt[report.status]
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    report.resolution
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    report.resolvedBy
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    remark
                ),
                _react2.default.createElement(
                    'td',
                    { 'data-index': index, onClick: this.showOption },
                    report.status == 1 ? _react2.default.createElement('span', { className: 'rpt-edit glyphicon glyphicon-option-vertical' }) : "",
                    this.renderEdit(index, report)
                )
            );
        }
    }, {
        key: 'renderEdit',
        value: function renderEdit(index, report) {
            if (report.status == 1) {
                return _react2.default.createElement(
                    'ul',
                    { className: "rpt-dropdown " + (report.shouldListShow ? "rpt-show" : "rpt-hide") },
                    _react2.default.createElement(
                        'li',
                        { 'data-action': '0', 'data-id': report._id, 'data-index': index, onClick: this.handleOption },
                        'Extend Target Date'
                    ),
                    _react2.default.createElement(
                        'li',
                        { 'data-action': '1', 'data-id': report._id, 'data-index': index, onClick: this.handleOption },
                        'Resolved'
                    ),
                    _react2.default.createElement(
                        'li',
                        { 'data-action': '2', 'data-id': report._id, 'data-index': index, onClick: this.handleOption },
                        'Add Remark'
                    ),
                    _react2.default.createElement(
                        'li',
                        { 'data-action': '3', 'data-id': report._id, 'data-index': index, onClick: this.handleOption },
                        'Remove'
                    )
                );
            }
        }
    }, {
        key: 'renderMainList',
        value: function renderMainList() {
            var _this2 = this;

            return this.props.reports.map(function (report, index) {
                if (report) {
                    return _this2.renderDataList(report, index);
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var callBack = void 0;
            if (this.state.action == 0) {
                callBack = this.extendIncident;
            } else if (this.state.action == 1) {
                callBack = this.resolveIncident;
            } else if (this.state.action == 2) {
                callBack = this.addingRemark;
            } else {
                callBack = this.removeIncident;
            }
            var modal = void 0;
            if (this.state.modalClose) {
                modal = _react2.default.createElement(_reportModal2.default, {
                    action: this.state.action,
                    callBack: callBack,
                    shouldModalClose: this.shouldModalClose,
                    modalClose: this.state.modalClose,
                    title: this.state.title,
                    clientEmail: this.state.clientEmail
                });
            }
            return _react2.default.createElement(
                'div',
                { className: 'atd-abd-wp' },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-em-lt' },
                    _react2.default.createElement(
                        'table',
                        { className: 'report-tb' },
                        _react2.default.createElement(
                            'tbody',
                            { className: "report-tbd" },
                            this.renderMainList()
                        )
                    )
                ),
                modal
            );
        }
    }]);

    return ReportList;
}(_react2.default.Component);

ReportList.defaultProps = {
    mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    dayTxt: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    severityTxt: ["Low", "Medium", "High", "Critical"],
    statusTxt: ["Closed", "Open", "Removed"]
};
exports.default = ReportList;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function (f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function (x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s':
        return String(args[i++]);
      case '%d':
        return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};

// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function (fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function () {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};

var debugs = {};
var debugEnviron;
exports.debuglog = function (set) {
  if (isUndefined(debugEnviron)) debugEnviron = Object({"NODE_ENV":"production"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function () {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function () {};
    }
  }
  return debugs[set];
};

/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;

// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold': [1, 22],
  'italic': [3, 23],
  'underline': [4, 24],
  'inverse': [7, 27],
  'white': [37, 39],
  'grey': [90, 39],
  'black': [30, 39],
  'blue': [34, 39],
  'cyan': [36, 39],
  'green': [32, 39],
  'magenta': [35, 39],
  'red': [31, 39],
  'yellow': [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};

function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\x1B[' + inspect.colors[style][0] + 'm' + str + '\x1B[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}

function stylizeNoColor(str, styleType) {
  return str;
}

function arrayToHash(array) {
  var hash = {};

  array.forEach(function (val, idx) {
    hash[val] = true;
  });

  return hash;
}

function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect && value && isFunction(value.inspect) &&
  // Filter out the util module, it's inspect function is special
  value.inspect !== exports.inspect &&
  // Also filter out any prototype objects using the circular check.
  !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '',
      array = false,
      braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function (key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}

function formatPrimitive(ctx, value) {
  if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value)) return ctx.stylize('' + value, 'number');
  if (isBoolean(value)) return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value)) return ctx.stylize('null', 'null');
}

function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}

function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function (key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    }
  });
  return output;
}

function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function (line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function (line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}

function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function (prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'symbol' || // ES6 symbol
  typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(200);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}

var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}

// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function () {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(201);

exports._extend = function (origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(26)))

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function isBuffer(arg) {
  return arg && (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function TempCtor() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  };
}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _detailContent = __webpack_require__(203);

var _detailContent2 = _interopRequireDefault(_detailContent);

var _reportAction = __webpack_require__(28);

var _reportAction2 = _interopRequireDefault(_reportAction);

var _reportStore = __webpack_require__(31);

var _reportStore2 = _interopRequireDefault(_reportStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportDetail = function (_React$Component) {
    _inherits(ReportDetail, _React$Component);

    function ReportDetail(props) {
        _classCallCheck(this, ReportDetail);

        var _this = _possibleConstructorReturn(this, (ReportDetail.__proto__ || Object.getPrototypeOf(ReportDetail)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.state = {
            reportDetail: _reportStore2.default.getState().reportDetail
        };
        return _this;
    }

    _createClass(ReportDetail, [{
        key: 'componentWillMount',
        value: function componentWillMount() {}
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            _reportStore2.default.listen(this.onChange);
            _menuAction2.default.pageNumber(-1);
            _reportAction2.default.getDetailReport(this.props.match.params.id);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _reportStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                reportDetail: state.reportDetail
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-8  col-sm-8' },
                        _react2.default.createElement(_detailContent2.default, { reportDetail: this.state.reportDetail })
                    )
                )
            );
        }
    }]);

    return ReportDetail;
}(_react2.default.Component);

exports.default = ReportDetail;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _reportAction = __webpack_require__(28);

var _reportAction2 = _interopRequireDefault(_reportAction);

var _reportStore = __webpack_require__(31);

var _reportStore2 = _interopRequireDefault(_reportStore);

var _reportModal = __webpack_require__(82);

var _reportModal2 = _interopRequireDefault(_reportModal);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportDetail = function (_React$Component) {
    _inherits(ReportDetail, _React$Component);

    function ReportDetail(props) {
        _classCallCheck(this, ReportDetail);

        var _this = _possibleConstructorReturn(this, (ReportDetail.__proto__ || Object.getPrototypeOf(ReportDetail)).call(this, props));

        _this.extendIncident = _this.extendIncident.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.resolveIncident = _this.resolveIncident.bind(_this);
        _this.addingRemark = _this.addingRemark.bind(_this);
        _this.removeIncident = _this.removeIncident.bind(_this);
        _this.handleOption = _this.handleOption.bind(_this);
        _this.handlePrint = _this.handlePrint.bind(_this);
        _this.handleDL = _this.handleDL.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.state = {
            action: 0,
            modalClose: false,
            reportId: "",
            title: "",
            processing: _reportStore2.default.getState().processing
        };
        return _this;
    }

    _createClass(ReportDetail, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _reportStore2.default.listen(this.onChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _reportStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing
            });
        }
    }, {
        key: 'handlePrint',
        value: function handlePrint() {
            window.print();
        }
    }, {
        key: 'handleDL',
        value: function handleDL() {
            if (this.state.processing) return;

            _reportAction2.default.processing(true);
            _reportAction2.default.downloadPDFfile(this.props.reportDetail.reportNo);
        }
    }, {
        key: 'handleOption',
        value: function handleOption(e) {
            var _setState;

            e.preventDefault();
            e.stopPropagation();

            var action = parseInt(e.currentTarget.getAttribute("data-action"));
            var reportId = e.currentTarget.getAttribute('data-id');

            var title = void 0;
            if (action == 0) {
                title = "Extend Target Date";
            } else if (action == 1) {
                title = "Resolution";
            } else if (action == 2) {
                title = "Add Remark";
            } else {
                title = "Delete Incident";
            }

            this.setState((_setState = {
                action: 0,
                modalClose: true,
                reportId: reportId
            }, _defineProperty(_setState, 'action', action), _defineProperty(_setState, 'title', title), _setState));
        }
    }, {
        key: 'extendIncident',
        value: function extendIncident(day, reason, clientEmail, reportImage) {
            if (this.state.processing) return;
            _reportAction2.default.processing(true);
            var fd = new FormData();
            fd.append("day", day);
            fd.append("reason", reason);
            if (clientEmail) {
                if (clientEmail.length > 0) {
                    for (var i = 0; i < clientEmail.length; i++) {
                        fd.append("clientEmail[]", clientEmail[i]);
                    }
                }
            }
            if (reportImage) {
                if (reportImage.length > 0) {
                    for (var _i = 0; _i < reportImage.length; _i++) {
                        fd.append("images", reportImage[_i]);
                    }
                }
            }
            _reportAction2.default.extendIncident(this.state.reportId, fd);
            this.shouldModalClose(false);
        }
    }, {
        key: 'resolveIncident',
        value: function resolveIncident(resolution, value, clientEmail, reportImage) {
            if (this.state.processing) return;
            _reportAction2.default.processing(true);
            var fd = new FormData();
            fd.append("resolution", resolution);
            if (clientEmail) {
                if (clientEmail.length > 0) {
                    for (var i = 0; i < clientEmail.length; i++) {
                        fd.append("clientEmail[]", clientEmail[i]);
                    }
                }
            }
            if (reportImage) {
                if (reportImage.length > 0) {
                    for (var _i2 = 0; _i2 < reportImage.length; _i2++) {
                        fd.append("images", reportImage[_i2]);
                    }
                }
            }
            _reportAction2.default.resolveIncident(this.state.reportId, fd);
            this.shouldModalClose(false);
        }
    }, {
        key: 'addingRemark',
        value: function addingRemark(remark, value, clientEmail, reportImage) {
            if (this.state.processing) return;
            _reportAction2.default.processing(true);

            var fd = new FormData();
            fd.append("remark", remark);
            if (clientEmail) {
                if (clientEmail.length > 0) {
                    for (var i = 0; i < clientEmail.length; i++) {
                        fd.append("clientEmail[]", clientEmail[i]);
                    }
                }
            }
            if (reportImage) {
                if (reportImage.length > 0) {
                    for (var _i3 = 0; _i3 < reportImage.length; _i3++) {
                        fd.append("images", reportImage[_i3]);
                    }
                }
            }
            _reportAction2.default.addingRemark(this.state.reportId, fd);
            this.shouldModalClose(false);
        }
    }, {
        key: 'removeIncident',
        value: function removeIncident() {
            if (this.state.processing) return;
            _reportAction2.default.processing(true);
            _reportAction2.default.removeIncident(this.state.reportId);
            this.shouldModalClose(false);
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({
                modalClose: data
            });
        }
    }, {
        key: 'renderExtend',
        value: function renderExtend() {
            if (!this.props.reportDetail.extend) return;

            var extend = this.props.reportDetail.extend.map(function (extend, index) {
                return _react2.default.createElement(
                    'div',
                    { className: 'ext', key: index },
                    _react2.default.createElement(
                        'h5',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Extension ',
                            index + 1
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ext-wp' },
                        _react2.default.createElement(
                            'div',
                            { className: 'det-tt' },
                            'No of days :'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'det-ct' },
                            extend.day
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ext-wp' },
                        _react2.default.createElement(
                            'div',
                            { className: 'det-tt' },
                            'Reason:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'det-ct' },
                            extend.reason
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ext-wp' },
                        _react2.default.createElement(
                            'div',
                            { className: 'det-tt' },
                            'Extended By :'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'det-ct' },
                            extend.userName
                        )
                    )
                );
            });
            return extend;
        }
    }, {
        key: 'renderRemark',
        value: function renderRemark() {
            if (!this.props.reportDetail.remarks || this.props.reportDetail.remarks.length == 0) return;

            var remark = this.props.reportDetail.remarks.map(function (remark, index) {
                return _react2.default.createElement(
                    'div',
                    { className: 'rmk-wp', key: index },
                    _react2.default.createElement(
                        'div',
                        { className: 'rmk-ct' },
                        index + 1,
                        '. ',
                        remark.remark,
                        ' ',
                        _react2.default.createElement(
                            'b',
                            null,
                            'by ',
                            remark.userName
                        )
                    )
                );
            });
            return _react2.default.createElement(
                'div',
                { className: 'ext' },
                _react2.default.createElement(
                    'h5',
                    null,
                    _react2.default.createElement(
                        'b',
                        null,
                        'Remark:'
                    )
                ),
                remark
            );
        }
    }, {
        key: 'renderEmail',
        value: function renderEmail() {
            var _this2 = this;

            var staffEmail = "",
                contractorEmail = void 0,
                clientEmail = "";
            if (this.props.reportDetail.email) {
                staffEmail = this.props.reportDetail.email.map(function (email, index) {
                    var list = email.userName + " (" + _this2.props.roleTxt[email.role] + ")";
                    return index == 0 ? list : " " + list;
                });
            }
            /*
            if (this.props.reportDetail.contractors) {
                contractorEmail = this.props.reportDetail.contractors.map((contractor, index) => {
                    return (" " + contractor.contractorName);
                });
            }
            */
            if (this.props.reportDetail.clientEmail && this.props.reportDetail.clientEmail != null) {
                clientEmail = this.props.reportDetail.clientEmail.map(function (email, index) {
                    return ", " + email;
                });
            }

            return staffEmail + (clientEmail != "" ? clientEmail : "");
        }
    }, {
        key: 'render',
        value: function render() {
            var detail = this.props.reportDetail;
            detail.date = detail.date ? new Date(detail.date) : "";
            detail.targetDate = detail.targetDate ? new Date(detail.targetDate) : "";
            detail.completionDate = detail.status == 0 && detail.completionDate ? new Date(detail.completionDate) : "";
            var date = detail.date ? detail.date.getDate() + "-" + this.props.mthTxt[detail.date.getMonth()] + "-" + detail.date.getFullYear() : "-";
            var day = detail.date ? this.props.dayTxt[detail.date.getDay()] : "-";
            var callBack = void 0;

            if (this.state.action == 0) {
                callBack = this.extendIncident;
            } else if (this.state.action == 1) {
                callBack = this.resolveIncident;
            } else if (this.state.action == 2) {
                callBack = this.addingRemark;
            } else {
                callBack = this.removeIncident;
            }

            var completeDate = "";
            if (detail.status == 0) {
                if (detail.completionDate) {
                    completeDate = detail.completionDate.getDate() + "-" + this.props.mthTxt[detail.completionDate.getMonth()] + '-' + detail.completionDate.getFullYear();
                }
            } else {
                if (detail.targetDate) {
                    completeDate = detail.targetDate.getDate() + "-" + this.props.mthTxt[detail.targetDate.getMonth()] + "-" + detail.targetDate.getFullYear();
                }
            }

            var modal = void 0;
            if (this.state.modalClose) {
                modal = _react2.default.createElement(_reportModal2.default, {
                    action: this.state.action,
                    callBack: callBack,
                    shouldModalClose: this.shouldModalClose,
                    modalClose: this.state.modalClose,
                    title: this.state.title,
                    clientEmail: this.props.reportDetail.clientEmail
                });
            }
            return _react2.default.createElement(
                'div',
                { id: 'detailReport' },
                _react2.default.createElement(
                    'h1',
                    null,
                    'Incident Report'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6' },
                        _react2.default.createElement(
                            'div',
                            { className: 'det-wp' },
                            _react2.default.createElement(
                                'div',
                                { className: 'det-tt' },
                                'Report No :'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'det-ct' },
                                detail.reportNo
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'det-wp' },
                            _react2.default.createElement(
                                'div',
                                { className: 'det-tt' },
                                'Date :'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'det-ct' },
                                date
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'det-wp' },
                            _react2.default.createElement(
                                'div',
                                { className: 'det-tt' },
                                'Day :'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'det-ct' },
                                day
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'det-wp' },
                            _react2.default.createElement(
                                'div',
                                { className: 'det-tt' },
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    'Condo :'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'det-ct' },
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    detail.condoName,
                                    ' (',
                                    detail.mcst,
                                    ')'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'det-wp' },
                            _react2.default.createElement(
                                'div',
                                { className: 'det-tt' },
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    'Area :'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'det-ct' },
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    detail.facility
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'det-wp' },
                            _react2.default.createElement(
                                'div',
                                { className: 'det-tt' },
                                'Category :'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'det-ct' },
                                detail.category
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6' },
                        _react2.default.createElement(
                            'div',
                            { className: 'det-wp' },
                            _react2.default.createElement(
                                'div',
                                { className: 'det-tt' },
                                'Submitted By :'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'det-ct' },
                                detail.userName
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'det-wp' },
                            _react2.default.createElement(
                                'div',
                                { className: 'det-tt' },
                                'Severity :'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'det-ct' },
                                this.props.severityTxt[detail.severity]
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'det-wp' },
                            _react2.default.createElement(
                                'div',
                                { className: 'det-tt' },
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    'Status :'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'det-ct' },
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    this.props.statusTxt[detail.status]
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'det-wp' },
                            _react2.default.createElement(
                                'div',
                                { className: 'det-tt' },
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    detail.status == 0 ? "Completion Date :" : "Target Completion Date :"
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'det-ct' },
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    completeDate
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'det-wp' },
                            _react2.default.createElement(
                                'div',
                                { className: 'det-tt' },
                                detail.status == 2 ? "Removed Reason" : "Resolution",
                                ' :'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'det-ct' },
                                detail.resolution
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'det-wp' },
                            _react2.default.createElement(
                                'div',
                                { className: 'det-tt' },
                                detail.status == 2 ? "Removed By" : "Resolved By",
                                ' :'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'det-ct' },
                                detail.resolvedBy
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'det-wp' },
                            _react2.default.createElement(
                                'div',
                                { className: 'det-tt' },
                                'Email To :'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'det-ct' },
                                this.renderEmail()
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row', id: 'det-2nd' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'det-imp-wp' },
                            _react2.default.createElement('img', { src: detail.reportImage ? detail.reportImage[0] : "", className: 'det-img' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'det-imp-wp' },
                            _react2.default.createElement('img', { src: detail.reportImage ? detail.reportImage[1] : "", className: 'det-img' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'det-imp-wp' },
                            _react2.default.createElement('img', { src: detail.reportImage ? detail.reportImage[2] : "", className: 'det-img' })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row', id: 'det-3rd' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6' },
                        _react2.default.createElement(
                            'h5',
                            null,
                            _react2.default.createElement(
                                'b',
                                null,
                                'Description :'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'det-des-ct' },
                            detail.description
                        ),
                        this.renderRemark()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6' },
                        this.renderExtend()
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row', id: 'det-4th' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        _react2.default.createElement(
                            'div',
                            { className: 'det-btn-grp' },
                            _react2.default.createElement(
                                'div',
                                { className: 'det-btn-tt' },
                                'Action:'
                            ),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-default', onClick: this.handlePrint },
                                'Print'
                            ),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-default', onClick: this.handleDL },
                                'Download'
                            ),
                            detail.status == 1 ? _react2.default.createElement(
                                'button',
                                { className: 'btn btn-default', 'data-action': '0', 'data-id': detail._id, onClick: this.handleOption },
                                'Extend Target Date'
                            ) : "",
                            detail.status == 1 ? _react2.default.createElement(
                                'button',
                                { className: 'btn btn-default', 'data-action': '1', 'data-id': detail._id, onClick: this.handleOption },
                                'Resolved'
                            ) : "",
                            detail.status == 1 ? _react2.default.createElement(
                                'button',
                                { className: 'btn btn-default', 'data-action': '2', 'data-id': detail._id, onClick: this.handleOption },
                                'Add Remark'
                            ) : ""
                        )
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing }),
                modal
            );
        }
    }]);

    return ReportDetail;
}(_react2.default.Component);

ReportDetail.defaultProps = {
    mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    dayTxt: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    severityTxt: ["Low", "Medium", "High", "Critical"],
    statusTxt: ["Closed", "Open", "Removed"],
    roleTxt: ["Administrative Executive", "Property Executive", "Property Manager", "Human Resource Executive", "Contracts Management Executive", "Accounts Executive", "Accounts Manager", "Information Technology", "Managing Director", "Director", "Other", "Cleaner Supervisor", "Cleaner", "Landscaper", "Electrician", "Caretaker", "Portfolio Manager", "Team Manager", "Senior Admin Executive"]
};
exports.default = ReportDetail;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _leaveHeader = __webpack_require__(205);

var _leaveHeader2 = _interopRequireDefault(_leaveHeader);

var _leaveBody = __webpack_require__(207);

var _leaveBody2 = _interopRequireDefault(_leaveBody);

var _leaveAction = __webpack_require__(20);

var _leaveAction2 = _interopRequireDefault(_leaveAction);

var _leaveStore = __webpack_require__(32);

var _leaveStore2 = _interopRequireDefault(_leaveStore);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _leaveCal = __webpack_require__(210);

var _leaveCal2 = _interopRequireDefault(_leaveCal);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveApp = function (_React$Component) {
    _inherits(LeaveApp, _React$Component);

    function LeaveApp(props) {
        _classCallCheck(this, LeaveApp);

        var _this = _possibleConstructorReturn(this, (LeaveApp.__proto__ || Object.getPrototypeOf(LeaveApp)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.state = {
            staffs: _filterStore2.default.getState().staffs,
            processingFilter: _filterStore2.default.getState().processing,
            iniLoadStaff: _filterStore2.default.getState().iniLoadStaff,
            iniLoadTeamMember: _filterStore2.default.getState().iniLoadTeamMember,
            teamMember: _filterStore2.default.getState().teamMember,
            iniLoadHoliday: _filterStore2.default.getState().iniLoadHoliday,
            holiday: _filterStore2.default.getState().holiday,
            staffId: _userStore2.default.getState().staffId,
            processing: _leaveStore2.default.getState().processing,
            leaves: _leaveStore2.default.getState().leaves,

            startYear: _leaveStore2.default.getState().startYear,
            startMonth: _leaveStore2.default.getState().startMonth,
            displayMode: 0
        };
        return _this;
    }

    _createClass(LeaveApp, [{
        key: 'componentWillMount',
        value: function componentWillMount() {}
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            _leaveStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);
            _userStore2.default.listen(this.onUserChange);
            _menuAction2.default.pageNumber(5);

            if (!this.state.processingFilter && !this.state.iniLoadStaff) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getEmployee();
            }
            if (!this.state.iniLoadTeamMember) {
                _filterAction2.default.getTeamMember();
            }
            if (!this.state.iniLoadHoliday) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getHoliday();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _leaveStore2.default.unlisten(this.onChange);
            _filterStore2.default.unlisten(this.onFilterChange);
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                staffId: state.staffId
            });
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                staffs: state.staffs,
                processingFilter: state.processing,
                iniLoadStaff: state.iniLoadStaff,
                iniLoadTeamMember: state.iniLoadTeamMember,
                teamMember: state.teamMember,
                iniLoadHoliday: state.iniLoadHoliday,
                holiday: state.holiday
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                leaves: state.leaves,
                processing: state.processing,
                startYear: state.startYear,
                startMonth: state.startMonth
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.currentTarget.getAttribute('data-index'));
            this.setState({ displayMode: index });
        }
    }, {
        key: 'render',
        value: function render() {
            var bodyDisplay = '';
            var isOutsider = this.state.staffId && this.state.staffId.includes("TG0");
            var leaves = JSON.parse(JSON.stringify(this.state.leaves));
            if (isOutsider) {
                leaves = leaves.filter(function (lv) {
                    return lv.staffId && lv.staffId.includes("TG0");
                });
            }
            if (this.state.displayMode == 0) {
                bodyDisplay = _react2.default.createElement(_leaveBody2.default, _extends({ leaves: leaves, processing: this.state.processing }, this.props));
            } else {
                bodyDisplay = _react2.default.createElement(_leaveCal2.default, { leaves: leaves, startYear: this.state.startYear, startMonth: this.state.startMonth,
                    holiday: isOutsider ? { holiday: [], event: [], saturdayWork: this.state.holiday.saturdayWork } : this.state.holiday });
            }
            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 atd' },
                        _react2.default.createElement(_leaveHeader2.default, { iniLoad: this.state.iniLoad, staffs: this.state.staffs, leaves: this.state.leaves,
                            teamMember: this.state.teamMember }),
                        _react2.default.createElement('div', { className: 'divider' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-i-dp' },
                            _react2.default.createElement(
                                'div',
                                { className: 'atd-dis' },
                                'Mode: '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'btn-group', role: 'group' },
                                _react2.default.createElement(
                                    'button',
                                    { className: "btn btn-default " + (this.state.displayMode == 0 ? "active" : ""), 'data-index': '0', onClick: this.handleClick },
                                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-th-list' })
                                ),
                                _react2.default.createElement(
                                    'button',
                                    { className: "btn btn-default " + (this.state.displayMode == 1 ? "active" : ""), 'data-index': '1', onClick: this.handleClick },
                                    _react2.default.createElement('span', { className: 'glyphicon glyphicon-th' })
                                )
                            )
                        ),
                        bodyDisplay
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.processingFilter })
            );
        }
    }]);

    return LeaveApp;
}(_react2.default.Component);

exports.default = LeaveApp;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _leaveFilter = __webpack_require__(206);

var _leaveFilter2 = _interopRequireDefault(_leaveFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveHeader = function (_React$Component) {
    _inherits(LeaveHeader, _React$Component);

    function LeaveHeader(props) {
        _classCallCheck(this, LeaveHeader);

        return _possibleConstructorReturn(this, (LeaveHeader.__proto__ || Object.getPrototypeOf(LeaveHeader)).call(this, props));
    }

    _createClass(LeaveHeader, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-hd' },
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(
                        'b',
                        null,
                        'Summary of Leave Application'
                    )
                ),
                _react2.default.createElement(_leaveFilter2.default, { staffs: this.props.staffs, iniLoad: this.props.iniLoad, teamMember: this.props.teamMember }),
                _react2.default.createElement('div', { className: 'clear' })
            );
        }
    }]);

    return LeaveHeader;
}(_react2.default.Component);

exports.default = LeaveHeader;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _leaveAction = __webpack_require__(20);

var _leaveAction2 = _interopRequireDefault(_leaveAction);

var _leaveStore = __webpack_require__(32);

var _leaveStore2 = _interopRequireDefault(_leaveStore);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveFilter = function (_React$Component) {
    _inherits(LeaveFilter, _React$Component);

    function LeaveFilter(props) {
        _classCallCheck(this, LeaveFilter);

        var _this = _possibleConstructorReturn(this, (LeaveFilter.__proto__ || Object.getPrototypeOf(LeaveFilter)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handlePrint = _this.handlePrint.bind(_this);
        _this.handleExport = _this.handleExport.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.state = {
            processing: _leaveStore2.default.getState().processing,
            iniYear: 2017,
            iniMonth: 11,
            staffId: _leaveStore2.default.getState().staffId,
            startYear: _leaveStore2.default.getState().startYear,
            startMonth: _leaveStore2.default.getState().startMonth,
            endYear: _leaveStore2.default.getState().endYear,
            endMonth: _leaveStore2.default.getState().endMonth,
            warningMsg: _leaveStore2.default.getState().warningMsg,

            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId
        };
        return _this;
    }

    _createClass(LeaveFilter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _leaveStore2.default.listen(this.onChange);
            _userStore2.default.listen(this.onUserChange);
            //set default staffId
            this.setState({
                staffId: ""
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _leaveStore2.default.unlisten(this.onChange);
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                startYear: state.startYear,
                startMonth: state.startMonth,
                endYear: state.endYear,
                endMonth: state.endMonth,
                staffId: state.staffId
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            var value = e.target.value.split(":");
            var selectedYear = parseInt(value[0]);
            var selectedMonth = parseInt(value[1]);
            console.log(selectedMonth);
            if (index == 0) {
                _leaveAction2.default.updateSM({ startYear: selectedYear, startMonth: selectedMonth });
            } else if (index == 1) {
                _leaveAction2.default.updateEM({ endYear: selectedYear, endMonth: selectedMonth });
            } else if (index == 2) {
                _leaveAction2.default.updateUI({ staffId: value[0] });
            }
        }
    }, {
        key: 'handlePrint',
        value: function handlePrint() {
            window.print();
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            if (!this.state.processing) {
                _leaveAction2.default.clear();
                _leaveAction2.default.warningMsg("");
                _leaveAction2.default.processing(true);
                _leaveAction2.default.getLA(this.state.staffId, this.state.startYear, this.state.startMonth, this.state.endYear, this.state.endMonth);
            }
        }
    }, {
        key: 'handleExport',
        value: function handleExport() {
            if (!this.state.processing) {

                _leaveAction2.default.warningMsg("");
                _leaveAction2.default.processing(true);
                _leaveAction2.default.exportLA(this.state.staffId, this.state.startYear, this.state.startMonth, this.state.endYear, this.state.endMonth);
            }
        }
    }, {
        key: 'renderOption',
        value: function renderOption(yr, mth) {
            return _react2.default.createElement(
                'option',
                { value: yr + ":" + mth, key: yr * 100 + mth },
                this.props.mthTxt[mth] + " " + yr
            );
        }
    }, {
        key: 'renderStaff',
        value: function renderStaff(staff, index) {
            return _react2.default.createElement(
                'option',
                { value: staff.staffId, key: index },
                staff.userName
            );
        }
    }, {
        key: 'renderStaffs',
        value: function renderStaffs() {
            var _this2 = this;

            var staffs = this.props.staffs.filter(function (staff) {
                return _genFunction2.default.hasPermission(_this2.state.permission, 2) || _genFunction2.default.isSubordinate(_this2.state.subordinate, staff.staffId) || _genFunction2.default.isUser(_this2.state.userId, staff.staffId) || _genFunction2.default.isMember(_this2.props.teamMember, staff.staffId);
            });
            return staffs.map(function (staff, index) {
                return _this2.renderStaff(staff, index);
            });
        }
    }, {
        key: 'renderOptions',
        value: function renderOptions() {
            var options = [];
            var thisYear = new Date(new Date().getFullYear(), new Date().getMonth() + 12).getFullYear();
            var thisMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 12).getMonth();

            for (var yr = thisYear; yr >= this.state.iniYear; yr--) {
                if (thisYear == this.state.iniYear) {
                    for (var mth = thisMonth; mth >= this.state.iniMonth; mth--) {
                        options = options.concat(this.renderOption(yr, mth));
                    }
                } else if (yr == thisYear) {
                    for (var _mth = thisMonth; _mth >= 0; _mth--) {
                        options = options.concat(this.renderOption(yr, _mth));
                    }
                } else if (yr == this.state.iniYear) {
                    for (var _mth2 = 11; _mth2 >= this.state.iniMonth; _mth2--) {
                        options = options.concat(this.renderOption(yr, _mth2));
                    }
                } else {
                    for (var _mth3 = 11; _mth3 >= 0; _mth3--) {
                        options = options.concat(this.renderOption(yr, _mth3));
                    }
                }
            }
            return options;
        }
    }, {
        key: 'render',
        value: function render() {
            var startValue = this.state.startYear + ":" + this.state.startMonth;
            var endValue = this.state.endYear + ":" + this.state.endMonth;
            return _react2.default.createElement(
                'div',
                { className: 'atd-i row' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-md-4 col-lg-3' },
                    _react2.default.createElement(
                        'form',
                        { className: 'form-horizontal atd-i-wp' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'startFrom', className: 'col-xs-4 control-label' },
                            'Start from: '
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'input-group input-group-sm' },
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control atd-sel', name: 'startFrom', 'data-index': '0',
                                    value: startValue,
                                    onChange: this.handleChange },
                                this.renderOptions()
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'form',
                        { className: 'form-horizontal atd-i-wp' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'endMonth', className: 'col-xs-4 control-label' },
                            'Till: '
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'input-group input-group-sm' },
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control atd-sel', name: 'endMonth', 'data-index': '1',
                                    value: endValue,
                                    onChange: this.handleChange },
                                this.renderOptions()
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-md-4 col-lg-3' },
                    _react2.default.createElement(
                        'form',
                        { className: 'form-horizontal atd-i-wp' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'staffName', className: 'col-xs-4 control-label' },
                            'Staff Name: '
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'input-group input-group-sm' },
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control atd-sel', name: 'staffName', 'data-index': '2', onChange: this.handleChange },
                                _react2.default.createElement(
                                    'option',
                                    { value: '' },
                                    'Any Staff'
                                ),
                                this.renderStaffs()
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'atd-0-tp atd-i-btn' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-default btn-sm', type: 'button', onClick: this.handleSubmit },
                            'Search'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'atd-0-tp atd-i-btn' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-primary btn-sm', type: 'button', onClick: this.handlePrint },
                            'Print'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'atd-0-tp atd-i-btn' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-primary btn-sm', onClick: this.handleExport },
                            'Export'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'warning' },
                        this.state.warningMsg
                    )
                )
            );
        }
    }]);

    return LeaveFilter;
}(_react2.default.Component);

LeaveFilter.defaultProps = {
    mthTxt: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
exports.default = LeaveFilter;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _leaveList = __webpack_require__(208);

var _leaveList2 = _interopRequireDefault(_leaveList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveBody = function (_React$Component) {
    _inherits(LeaveBody, _React$Component);

    function LeaveBody(props) {
        _classCallCheck(this, LeaveBody);

        var _this = _possibleConstructorReturn(this, (LeaveBody.__proto__ || Object.getPrototypeOf(LeaveBody)).call(this, props));

        _this.onTouchStart = _this.onTouchStart.bind(_this);
        _this.onTouchMove = _this.onTouchMove.bind(_this);
        _this.onTouchEnd = _this.onTouchEnd.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleMouseScroll = _this.handleMouseScroll.bind(_this);
        _this.state = {
            dragging: false,
            refX: 0,
            ini: 0
        };
        return _this;
    }

    _createClass(LeaveBody, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (document.body.clientWidth > 768) {
                var elem = _reactDom2.default.findDOMNode(this.refs.table);
                elem.addEventListener('mouseup', this.onTouchEnd);
                elem.addEventListener('mouseleave', this.onTouchEnd);
                elem.addEventListener('mousemove', this.onTouchMove);
                elem.addEventListener('mousedown', this.onTouchStart);
                window.addEventListener('wheel', this.handleMouseScroll);
            }
            window.addEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (document.body.clientWidth > 768) {
                var elem = _reactDom2.default.findDOMNode(this.refs.table);
                elem.removeEventListener('mouseup', this.onTouchEnd);
                elem.removeEventListener('mouseleave', this.onTouchEnd);
                elem.removeEventListener('mousemove', this.onTouchMove);
                elem.removeEventListener('mousedown', this.onTouchStart);
                window.removeEventListener('wheel', this.handleMouseScroll);
            }
            window.removeEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'handleMouseScroll',
        value: function handleMouseScroll(e) {
            e.preventDefault();

            if (e.deltaY > 0) {
                //scroll down
                window.scrollBy(0, 50);
            } else {
                //scroll up
                window.scrollBy(0, -50);
            }
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(e) {
            var elem1 = _reactDom2.default.findDOMNode(this.refs.est);
            var elem2 = _reactDom2.default.findDOMNode(this.refs.table);
            console.log(elem2.getBoundingClientRect().top);
            if (elem2.getBoundingClientRect().top <= 50) {

                elem1.style.position = "absolute";

                if (document.body.clientWidth > 768) {
                    elem2.style.paddingTop = "50px";
                    elem1.style.top = 50 - elem2.getBoundingClientRect().top + "px";
                } else {
                    elem2.style.paddingTop = "0px";
                    elem1.style.top = -elem2.getBoundingClientRect().top + "px";
                }
            } else {
                elem2.style.paddingTop = "0px";
                elem1.style.position = "relative";
                elem1.style.top = "0px";
            }
        }
    }, {
        key: 'onTouchStart',
        value: function onTouchStart(e) {
            if (!this.state.dragging) {
                var touches = e.changedTouches;
                var refX = void 0;
                if (e.touches) {
                    refX = e.touches[0].clientX;
                } else {
                    refX = e.clientX;
                }
                var ini = _reactDom2.default.findDOMNode(this.refs.table).scrollLeft;
                this.setState({
                    ini: ini,
                    refX: refX,
                    dragging: true
                });
            } else {
                this.setState({
                    dragging: false
                });
            }
        }
    }, {
        key: 'onTouchMove',
        value: function onTouchMove(e) {
            e.preventDefault();
            if (this.state.dragging && e.target) {
                var deltaX = void 0;
                if (e.touches) {
                    deltaX = parseInt(this.state.refX - e.touches[0].clientX);
                } else {
                    deltaX = parseInt(this.state.refX - e.clientX);
                }

                _reactDom2.default.findDOMNode(this.refs.table).scrollLeft = this.state.ini + deltaX;
            } else {
                this.setState({
                    dragging: false
                });
            }
        }
    }, {
        key: 'onTouchEnd',
        value: function onTouchEnd(e) {
            this.setState({
                dragging: false
            });
        }
    }, {
        key: 'render',
        value: function render() {

            return _react2.default.createElement(
                'div',
                { className: 'atd-bd-wp', ref: 'table' },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-em-lt' },
                    _react2.default.createElement(
                        'table',
                        { className: 'leave-tb tb-heading', ref: 'est' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Date of Application'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Day'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Submitted By'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Start Date'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'End Date'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Type'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Duration'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Status'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'MC'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Receipt'
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    'Remark'
                                ),
                                _react2.default.createElement('th', null)
                            )
                        )
                    ),
                    _react2.default.createElement(_leaveList2.default, { leaves: this.props.leaves, history: this.props.history, processing: this.props.processing })
                )
            );
        }
    }]);

    return LeaveBody;
}(_react2.default.Component);

exports.default = LeaveBody;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _leaveAction = __webpack_require__(20);

var _leaveAction2 = _interopRequireDefault(_leaveAction);

var _leaveModal = __webpack_require__(209);

var _leaveModal2 = _interopRequireDefault(_leaveModal);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveList = function (_React$Component) {
    _inherits(LeaveList, _React$Component);

    function LeaveList(props) {
        _classCallCheck(this, LeaveList);

        var _this = _possibleConstructorReturn(this, (LeaveList.__proto__ || Object.getPrototypeOf(LeaveList)).call(this, props));

        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.showOption = _this.showOption.bind(_this);
        _this.closeOption = _this.closeOption.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.state = {
            id: "",
            title: "",
            modalClose: false,
            action: "",
            leaveImage: "",
            staffId: "",

            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId
        };
        return _this;
    }

    _createClass(LeaveList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _userStore2.default.listen(this.onUserChange);
            window.addEventListener("click", this.closeOption);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _userStore2.default.unlisten(this.onUserChange);
            window.removeEventListener("click", this.closeOption);
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose() {
            this.setState({
                modalClose: false
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var action = parseInt(e.target.getAttribute('data-action'));
            var index = parseInt(e.target.getAttribute('data-index'));
            var staffId = e.target.getAttribute('data-staffid');
            var id = e.target.getAttribute('data-id');
            var leaveImage = "",
                receiptImage = "";
            var title = void 0;
            if (action == 0) {
                title = "Approve Leave";
            } else if (action == 1) {
                title = "Reject Leave";
            } else if (action == 2) {
                title = "Cancel Leave";
            } else if (action == 3) {
                title = "Upload MC";
            } else if (action == 4) {
                title = "Medical Certificate";
                leaveImage = this.props.leaves[index].leaveImage;
            } else if (action == 5) {
                title = "Receipt";
                receiptImage = this.props.leaves[index].receiptImage;
            } else if (action == 6) {
                title = "Upload Receipt";
            }
            this.setState({
                action: action,
                index: index,
                id: id,
                staffId: staffId,
                leaveImage: leaveImage,
                receiptImage: receiptImage,
                title: title,
                modalClose: true
            });
            if (action !== 4) {
                _leaveAction2.default.shouldListShow(index);
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(action, leaveImage) {
            if (action == 4 || action == 5) return this.setState({ modalClose: false });
            if (action != 3 && action != 6) {
                if (this.props.processing) return;

                _leaveAction2.default.processing(true);
                _leaveAction2.default.changeStatus(this.state.id, action, this.state.staffId);
            } else if (action == 3) {
                var fd = new FormData();
                fd.append("images", leaveImage);
                fd.append("_id", this.state.id);
                _leaveAction2.default.processing(true);
                _leaveAction2.default.uploadMC(this.state.id, fd);
            } else if (action == 6) {
                var _fd = new FormData();
                _fd.append("images", leaveImage);
                _fd.append("_id", this.state.id);
                _leaveAction2.default.processing(true);
                _leaveAction2.default.uploadReceipt(this.state.id, _fd);
            }

            this.setState({ modalClose: false });
        }
    }, {
        key: 'showOption',
        value: function showOption(e) {
            e.preventDefault();
            e.stopPropagation();

            var index = parseInt(e.target.getAttribute('data-index'));
            _leaveAction2.default.shouldListShow(index);
        }
    }, {
        key: 'closeOption',
        value: function closeOption() {
            _leaveAction2.default.closeListShow();
        }
    }, {
        key: 'renderDataList',
        value: function renderDataList(leave, index) {
            leave.date = new Date(leave.date);
            leave.startDate = new Date(leave.startDate);
            leave.endDate = new Date(leave.endDate);
            var isSameDate = void 0,
                endDate = void 0,
                apmEnd = void 0;

            var date = leave.date.getDate() + "-" + this.props.mthTxt[leave.date.getMonth()] + "-" + leave.date.getFullYear();
            var day = this.props.dayTxt[leave.date.getDay()];
            var startDate = leave.startDate.getDate() + "-" + this.props.mthTxt[leave.startDate.getMonth()] + "-" + leave.startDate.getFullYear();
            if (leave.type != 7) {
                isSameDate = (leave.endDate.getTime() - leave.startDate.getTime()) / 1000 / 60 / 60 / 24 + 1 <= 1;
                endDate = leave.endDate.getDate() + "-" + this.props.mthTxt[leave.endDate.getMonth()] + "-" + leave.endDate.getFullYear();
                apmEnd = isSameDate ? "-" : this.props.ampTxt[leave.apmEnd];
            } else {
                endDate = startDate;
            }
            var action = '';

            return _react2.default.createElement(
                'tr',
                { key: index },
                _react2.default.createElement(
                    'td',
                    null,
                    date
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    day
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    leave.submittedBy
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    startDate,
                    ' (',
                    leave.type != 7 ? this.props.ampTxt[leave.apmStart] : leave.startTime,
                    ')'
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    endDate,
                    ' (',
                    leave.type != 7 ? apmEnd : leave.endTime,
                    ')'
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    leave.leaveTxt
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    leave.duration
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.props.statusTxt[leave.status]
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.renderLeaveImg(index, leave)
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.renderReceiptImg(index, leave)
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    leave.remark ? leave.remark : "-"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement('span', { className: 'lv-edit glyphicon glyphicon-option-vertical', 'data-index': index, onClick: this.showOption }),
                    this.renderEdit(index, leave)
                )
            );
        }
    }, {
        key: 'renderLeaveImg',
        value: function renderLeaveImg(index, leave) {

            if (leave.leaveImage != null && leave.leaveImage != "") {
                return _react2.default.createElement(
                    'a',
                    { 'data-action': '4', 'data-id': leave._id, 'data-index': index, onClick: this.handleClick },
                    'Medical Certificate'
                );
            } else {
                return _react2.default.createElement(
                    'div',
                    null,
                    '-'
                );
            }
        }
    }, {
        key: 'renderReceiptImg',
        value: function renderReceiptImg(index, leave) {
            if (leave.receiptImage != null && leave.receiptImage != "") {
                return _react2.default.createElement(
                    'a',
                    { 'data-action': '5', 'data-id': leave._id, 'data-index': index, onClick: this.handleClick },
                    'View Receipt'
                );
            } else {
                return _react2.default.createElement(
                    'div',
                    null,
                    '-'
                );
            }
        }
    }, {
        key: 'renderEdit',
        value: function renderEdit(index, leave) {
            var statusOption = [];

            if (_genFunction2.default.hasPermission(this.state.permission, 2) && leave.staffId != this.state.userId || _genFunction2.default.isSubordinate(this.state.subordinate, leave.staffId)) {
                //if date adi expire, should be approve 
                statusOption = [_react2.default.createElement(
                    'li',
                    { 'data-action': '0', key: 0, 'data-staffid': leave.staffId, 'data-id': leave._id, 'data-index': index, onClick: this.handleClick },
                    'Approve'
                ), _react2.default.createElement(
                    'li',
                    { 'data-action': '1', key: 1, 'data-staffid': leave.staffId, 'data-id': leave._id, 'data-index': index, onClick: this.handleClick },
                    'Reject'
                )];
            }
            if (_genFunction2.default.hasPermission(this.state.permission, 2) || leave.staffId == this.state.userId && new Date(leave.startDate).getTime() > new Date().getTime() || leave.staffId == this.state.userId && leave.status == 3 || _genFunction2.default.isSubordinate(this.state.subordinate, leave.staffId)) {

                statusOption = statusOption.concat(_react2.default.createElement(
                    'li',
                    { 'data-action': '2', key: 2, 'data-staffid': leave.staffId, 'data-id': leave._id, 'data-index': index, onClick: this.handleClick },
                    'Cancel'
                ));
            }
            if (leave.type == 1 && (leave.status == 3 || leave.status == 0) && (_genFunction2.default.hasPermission(this.state.permission, 2) || leave.staffId == this.state.userId || _genFunction2.default.isSubordinate(this.state.subordinate, leave.staffId))) {
                statusOption = statusOption.concat(_react2.default.createElement(
                    'li',
                    { 'data-action': '3', key: 3, 'data-staffid': leave.staffId, 'data-id': leave._id, 'data-index': index, onClick: this.handleClick },
                    'Upload MC'
                ));
                statusOption = statusOption.concat(_react2.default.createElement(
                    'li',
                    { 'data-action': '6', key: 6, 'data-staffid': leave.staffId, 'data-id': leave._id, 'data-index': index, onClick: this.handleClick },
                    'Upload Receipt'
                ));
            }
            return _react2.default.createElement(
                'ul',
                { className: "lv-dropdown " + (leave.shouldListShow ? "lv-show" : "lv-hide") },
                statusOption
            );
        }
    }, {
        key: 'renderMainList',
        value: function renderMainList() {
            var _this2 = this;

            return this.props.leaves.map(function (leave, index) {
                return _this2.renderDataList(leave, index);
            });
        }
    }, {
        key: 'render',
        value: function render() {

            return _react2.default.createElement(
                'div',
                { className: 'atd-abd-wp' },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-em-lt' },
                    _react2.default.createElement(
                        'table',
                        { className: 'leave-tb' },
                        _react2.default.createElement(
                            'tbody',
                            { className: "leave-tbd" },
                            this.renderMainList()
                        )
                    )
                ),
                _react2.default.createElement(_leaveModal2.default, {
                    modalClose: this.state.modalClose,
                    shouldModalClose: this.shouldModalClose,
                    title: this.state.title,
                    action: this.state.action,
                    leaveImage: this.state.leaveImage,
                    receiptImage: this.state.receiptImage,
                    callBack: this.handleSubmit
                })
            );
        }
    }]);

    return LeaveList;
}(_react2.default.Component);

LeaveList.defaultProps = {
    mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    dayTxt: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    typeTxt: ["Annual Leave", "Medical Leave", "Reservist", "Childcare leave", "Unpaid leave", "Compassionate leave", "Other Leave", "Time-off", "Tele-commuting"],
    statusTxt: ["Approved", "Rejected", "Cancelled", "Pending"],
    ampTxt: ["Full", "AM", "PM"]
};
exports.default = LeaveList;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveModal = function (_React$Component) {
    _inherits(LeaveModal, _React$Component);

    function LeaveModal(props) {
        _classCallCheck(this, LeaveModal);

        var _this = _possibleConstructorReturn(this, (LeaveModal.__proto__ || Object.getPrototypeOf(LeaveModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.upLoadImg = _this.upLoadImg.bind(_this);
        _this.state = {
            leaveImage: ""
        };
        return _this;
    }

    _createClass(LeaveModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {}
    }, {
        key: 'upLoadImg',
        value: function upLoadImg(e) {
            var action = parseInt(e.target.getAttribute("data-action"));
            var file = e.target.files[0];
            this._previewImage(file, action);
        }
    }, {
        key: '_previewImage',
        value: function _previewImage(file, index) {
            var _this2 = this;

            //to be modified
            var fr = new FileReader();
            fr.onload = function (e) {
                var imgUrl = window.URL.createObjectURL(new Blob([e.target.result]));
                var img = new Image();

                img.onload = function () {
                    _this2.resizeImage(img, index);
                };

                img.src = imgUrl;
            };
            fr.readAsArrayBuffer(file);
        }
    }, {
        key: 'resizeImage',
        value: function resizeImage(image, index) {
            var oHeight = image.naturalHeight;
            var oWidth = image.naturalWidth;
            var newImage = void 0,
                newSize = void 0;
            var oSize = { oHeight: oHeight, oWidth: oWidth };
            newSize = { width: 500, height: 500 * oHeight / oWidth };

            newImage = this._imgResize(image, newSize, oSize);
            var blobFile = this.dataURItoBlob(newImage);
            this.setState({ leaveImage: blobFile });
        }
    }, {
        key: 'dataURItoBlob',
        value: function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = window.atob(dataURI.split(',')[1]);else byteString = unescape(dataURI.split(',')[1]);

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], { type: mimeString });
        }
    }, {
        key: '_imgResize',
        value: function _imgResize(img, newSize, oSize) {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext("2d");
            canvas.width = newSize.width;
            canvas.height = newSize.height;
            ctx.drawImage(img, 0, 0, oSize.oWidth, oSize.oHeight, 0, 0, newSize.width, newSize.height);
            return canvas.toDataURL('image/jpeg', 1);
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            this.props.callBack(this.props.action, this.state.leaveImage);
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'renderBody',
        value: function renderBody() {

            var body = "";
            if (this.props.action == 0 || this.props.action == 1 || this.props.action == 2) {
                body = "Are you sure?";
            } else if (this.props.action == 3 || this.props.action == 6) {
                body = _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement('input', { className: 'form-control', type: 'file', name: 'myImage', accept: 'image/x-png,image/jpeg',
                        'data-action': this.props.action,
                        onChange: this.upLoadImg })
                );
            } else if (this.props.action == 4) {
                body = _react2.default.createElement('img', { className: 'lv-img', src: this.props.leaveImage });
            } else if (this.props.action == 5) {
                body = _react2.default.createElement('img', { className: 'lv-img', src: this.props.receiptImage });
            }
            return body;
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;

            var btn = "";
            if (this.props.action == 0 || this.props.action == 1) {
                btn = "Submit";
            } else if (this.props.action == 2) {
                btn = "Submit";
            } else {
                btn = "Ok";
            }
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'leave-modal', style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            this.props.title
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body' },
                        this.renderBody()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: "btn " + (this.props.action == 2 ? " btn-danger" : "btn-warning"),
                                onClick: this.handleSubmit },
                            btn
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return LeaveModal;
}(_react2.default.Component);

LeaveModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = LeaveModal;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _leaveCalDetail = __webpack_require__(211);

var _leaveCalDetail2 = _interopRequireDefault(_leaveCalDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveCal = function (_React$Component) {
    _inherits(LeaveCal, _React$Component);

    function LeaveCal(props) {
        _classCallCheck(this, LeaveCal);

        return _possibleConstructorReturn(this, (LeaveCal.__proto__ || Object.getPrototypeOf(LeaveCal)).call(this, props));
    }

    _createClass(LeaveCal, [{
        key: 'shortForm',
        value: function shortForm(leaveTxt) {
            var shortForm = "";
            if (/annual/i.test(leaveTxt)) {
                shortForm = "AL";
            } else if (/compassionate/i.test(leaveTxt)) {
                shortForm = "CL";
            } else if (/medical/i.test(leaveTxt)) {
                shortForm = "ML";
            } else if (/time/i.test(leaveTxt)) {
                shortForm = "TO";
            } else if (/tele/i.test(leaveTxt)) {
                shortForm = "TC";
            } else if (/reservist/i.test(leaveTxt)) {
                shortForm = "RL";
            } else if (/unpaid/i.test(leaveTxt)) {
                shortForm = "UP";
            } else if (/other/i.test(leaveTxt)) {
                shortForm = "OL";
            } else if (/childcare/i.test(leaveTxt)) {
                shortForm = "CC";
            } else {
                shortForm = leaveTxt;
            }

            return shortForm;
        }
    }, {
        key: 'isHoliday',
        value: function isHoliday(year, month, date) {
            var isHoliday = false;
            var actualDay = new Date(year, month, date);
            if (this.props.holiday) {
                if (this.props.holiday.holiday) {
                    var s = this.props.holiday;
                    var len = s.holiday.length;
                    for (var i = 0; i < len; i++) {
                        if (s.holiday[i].year == actualDay.getFullYear() && s.holiday[i].month == actualDay.getMonth() && s.holiday[i].date == actualDay.getDate()) {
                            isHoliday = true;
                            break;
                        }
                    }
                }
            }

            return isHoliday;
        }
    }, {
        key: 'arrangeLeave',
        value: function arrangeLeave() {
            var s = this.props.leaves;
            var len = s.length;
            var newLeaves = [];
            for (var i = 0; i < len; i++) {
                //defined leave startYear
                var sd = new Date(s[i].startDate);
                var startYear = sd.getFullYear();
                var startMonth = sd.getMonth();
                var startDate = sd.getDate();

                if (s[i].type != 7) {
                    var ed = new Date(s[i].endDate);
                    var endYear = ed.getFullYear();
                    var endMonth = ed.getMonth();
                    var endDate = ed.getDate();

                    var noDays = parseInt((new Date(endYear, endMonth, endDate).getTime() - new Date(startYear, startMonth, startDate).getTime()) / 1000 / 60 / 60 / 24 + 1);
                    //push those date to attendance
                    for (var j = 0; j < noDays; j++) {

                        var duration = void 0;

                        /*
                        leaveArray = leaveArray.concat({
                            year: new Date(startYear, startMonth, startDate + i).getFullYear(),
                            month: new Date(startYear, startMonth, startDate + i).getMonth(),
                            date: new Date(startYear, startMonth, startDate + i).getDate(),
                            staffId: leave[j].staffId,
                            type: leave[j].type,
                            leaveTxt: leave[j].leaveTxt,
                            duration: duration
                        });
                        */
                        //check if there is saturday or sunday
                        var day = new Date(startYear, startMonth, startDate + j).getDay();
                        var isHoliday = this.isHoliday(startYear, startMonth, startDate + j);
                        if (isHoliday) {
                            continue;
                        } else if (day == 0) {
                            continue;
                        } else if (j == 0 && day == 6) {
                            if (this.props.holiday.saturdayWork == 0) {
                                duration = s[i].apmStart;
                            } else if (this.props.holiday.saturdayWork == 1) {
                                duration = 1;
                            } else {
                                continue;
                            }
                        } else if (j == 0) {
                            duration = s[i].apmStart;
                        } else if (j + 1 == noDays && day == 6) {
                            if (this.props.holiday.saturdayWork == 0) {
                                duration = s[i].apmEnd;
                            } else if (this.props.holiday.saturdayWork == 1) {
                                duration = 1;
                            } else {
                                continue;
                            }
                        } else if (j + 1 == noDays) {
                            duration = s[i].apmEnd;
                        } else if (day == 6) {
                            if (this.props.holiday.saturdayWork == 0) {
                                duration = 0;
                            } else if (this.props.holiday.saturdayWork == 1) {
                                duration = 1;
                            } else {
                                continue;
                            }
                        } else {
                            duration = 0;
                        }

                        var leaveTxt = this.shortForm(s[i].leaveTxt);
                        if (s[i].status == 0 || s[i].status == 3) {
                            newLeaves = newLeaves.concat({
                                year: new Date(startYear, startMonth, startDate + j).getFullYear(),
                                month: new Date(startYear, startMonth, startDate + j).getMonth(),
                                date: new Date(startYear, startMonth, startDate + j).getDate(),
                                //staffId: s[i].staffId,
                                //type: s[i].type,
                                status: s[i].status,
                                leaveTxt: s[i].submittedBy + " - " + leaveTxt + " (" + this.props.apmTxt[duration] + ")"
                                //duration: duration
                            });
                        }
                    }
                } else {
                    if (s[i].status == 0 || s[i].status == 3) {
                        var _leaveTxt = this.shortForm(s[i].leaveTxt);

                        var _isHoliday = this.isHoliday(startYear, startMonth, startDate);
                        if (_isHoliday) {
                            continue;
                        }
                        newLeaves = newLeaves.concat({
                            year: new Date(startYear, startMonth, startDate).getFullYear(),
                            month: new Date(startYear, startMonth, startDate).getMonth(),
                            date: new Date(startYear, startMonth, startDate).getDate(),
                            //staffId: s[i].staffId,
                            //type: s[i].type,
                            status: s[i].status,
                            leaveTxt: s[i].submittedBy + " - " + _leaveTxt + " (" + (s[i].startTime ? s[i].startTime + " ~ " + s[i].endTime : "") + ")"
                            //duration: duration
                        });
                    }
                }
            }

            return newLeaves;
        }
    }, {
        key: 'render',
        value: function render() {
            var year = this.props.startYear ? this.props.startYear : new Date().getFullYear();
            var month = typeof this.props.startMonth == 'number' ? this.props.startMonth : new Date().getMonth();

            var start_day = new Date(year, month, 1).getDay();

            var last_date = new Date(year, month + 1, 0).getDate();
            var last_wk = Math.ceil((last_date + start_day) / 7);
            var newLeaves = this.arrangeLeave();
            return _react2.default.createElement(
                'div',
                { className: 'cal-bd-wp' },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-bd-tt' },
                    _react2.default.createElement(
                        'h3',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Leave Application \xA0 (',
                            this.props.monthTxt[this.props.startMonth] + " " + this.props.startYear,
                            ')'
                        )
                    )
                ),
                _react2.default.createElement(_leaveCalDetail2.default, {
                    holiday: this.props.holiday,
                    year: this.props.startYear,
                    month: this.props.startMonth,
                    newLeaves: newLeaves,
                    start_day: start_day,
                    last_date: last_date,
                    last_wk: last_wk
                })
            );
        }
    }]);

    return LeaveCal;
}(_react2.default.Component);

LeaveCal.defaultProps = {
    monthTxt: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    apmTxt: ["Full", "Am", "Pm"]
};
exports.default = LeaveCal;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _leaveDetailModal = __webpack_require__(212);

var _leaveDetailModal2 = _interopRequireDefault(_leaveDetailModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveCalDetail = function (_React$Component) {
    _inherits(LeaveCalDetail, _React$Component);

    function LeaveCalDetail(props) {
        _classCallCheck(this, LeaveCalDetail);

        var _this = _possibleConstructorReturn(this, (LeaveCalDetail.__proto__ || Object.getPrototypeOf(LeaveCalDetail)).call(this, props));

        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);

        _this.state = {
            detail: [],
            modalClose: false
        };
        return _this;
    }

    _createClass(LeaveCalDetail, [{
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({ modalClose: data });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var date = parseInt(e.target.getAttribute('data-date'));

            var detail = this.getDetail(date);
            this.setState({ detail: detail, modalClose: true });
        }
    }, {
        key: 'isToday',
        value: function isToday(date) {
            var today = new Date();
            if (this.props.year == today.getFullYear() && this.props.month == today.getMonth() && date == today.getDate()) {
                return true;
            }
            return false;
        }
    }, {
        key: 'getDetail',
        value: function getDetail(date) {
            var len = this.props.newLeaves.length;
            var s = this.props.newLeaves;
            var detail = [];
            for (var i = 0; i < len; i++) {
                if (s[i].year == this.props.year && s[i].month == this.props.month && s[i].date == date) {
                    detail = detail.concat({ leaveTxt: s[i].leaveTxt, status: s[i].status });
                }
            }
            return detail;
        }
    }, {
        key: 'renderList',
        value: function renderList(detail, date) {
            var len = detail.length;
            var list = [];
            for (var i = 0; i < (len <= 3 ? len : 3); i++) {
                list = list.concat(_react2.default.createElement(
                    'div',
                    { className: "lv-cal-list " + (detail[i].status == 0 ? "" : "lv-red"), key: i },
                    detail[i].leaveTxt
                ));
            }
            if (len > 3) {
                list = list.concat(_react2.default.createElement(
                    'div',
                    { className: 'lv-cal-list lv-highlight', onClick: this.handleClick, 'data-date': date, key: 4 },
                    'and ',
                    len - 3,
                    ' more'
                ));
            }
            return list;
        }
    }, {
        key: 'getHoliday',
        value: function getHoliday(year, month, date) {
            var content = [];
            var isHoliday = false;
            if (this.props.holiday) {
                if (this.props.holiday.holiday) {
                    var s = this.props.holiday;

                    s.holiday.map(function (holiday, index) {
                        if (holiday.year == year && holiday.month == month && holiday.date == date) {
                            isHoliday = true;
                            content = content.concat(_react2.default.createElement(
                                'div',
                                { className: 'a-i-lt', key: index },
                                holiday.title
                            ));
                        }
                    });
                    if (s.event) {
                        s.event.map(function (event, index) {
                            if (event.year == year && event.month == month && event.date == date) {
                                content = content.concat(_react2.default.createElement(
                                    'div',
                                    { className: 'lv-e', key: "e" + index },
                                    _react2.default.createElement(
                                        'b',
                                        null,
                                        event.title
                                    )
                                ));
                            }
                        });
                    }
                }
            }

            return { content: content, isHoliday: isHoliday };
        }
    }, {
        key: 'renderRow',
        value: function renderRow(wk) {
            var day_row = [];
            for (var dy = 0; dy < 7; dy++) {
                if (wk == 0 && dy < this.props.start_day) {
                    day_row = day_row.concat(_react2.default.createElement('td', { className: 'cal-dis', key: "e" + (wk * 7 + dy) }));
                } else if (wk * 7 + dy + 1 - this.props.start_day > this.props.last_date) {
                    day_row = day_row.concat(_react2.default.createElement('td', { className: 'cal-dis', key: "e" + (wk * 7 + dy) }));
                } else {
                    var date = wk * 7 + dy + 1 - this.props.start_day;
                    var isToday = this.isToday(date);
                    var detail = [];
                    var displayHoliday = this.getHoliday(this.props.year, this.props.month, date);
                    detail = this.getDetail(date);

                    var className = void 0;
                    if (isToday) {
                        className = "cal-tdy cal-dy ";
                    } else {
                        className = "cal-dy ";
                    }
                    if (displayHoliday.isHoliday) {
                        className += "cal-hdy";
                    }
                    day_row = day_row.concat(_react2.default.createElement(
                        'td',
                        { className: className, key: date },
                        _react2.default.createElement(
                            'div',
                            { className: 'cal-date' },
                            date
                        ),
                        displayHoliday.content,
                        this.renderList(detail, date)
                    ));
                }
            }

            return _react2.default.createElement(
                'tr',
                { key: "wk-" + wk },
                day_row
            );
        }
    }, {
        key: 'renderReference',
        value: function renderReference() {
            return _react2.default.createElement(
                'ul',
                { className: 'lv-rf-ul' },
                _react2.default.createElement(
                    'li',
                    null,
                    'AL = Annual Leave'
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    'CL = Compassionate Leave'
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    'ML = Medical Leave'
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    'TO = Time-off'
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    'TC = Tele-commuting'
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    'RL = Reservist'
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    'UP = Unpaid Leave'
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    'CC = Childcare Leave'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {

            var calender = [];
            for (var wk = 0; wk < this.props.last_wk; wk++) {
                calender = calender.concat(this.renderRow(wk));
            }

            return _react2.default.createElement(
                'div',
                { className: 'cal-bd' },
                _react2.default.createElement(
                    'table',
                    { className: 'cal-tb' },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                null,
                                'Sun'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Mon'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Tue'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Wed'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Thu'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Fri'
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                'Sat'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        calender
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cal-bd-list' },
                    this.renderReference()
                ),
                _react2.default.createElement(_leaveDetailModal2.default, { modalClose: this.state.modalClose,
                    shouldModalClose: this.shouldModalClose,
                    detail: this.state.detail })
            );
        }
    }]);

    return LeaveCalDetail;
}(_react2.default.Component);

LeaveCalDetail.defaultProps = {
    typeTxt: ["Annual Leave", "Medical Leave", "Reservist", "Childcare leave", "Unpaid leave", "Compassionate leave", "Other Leave", "Time-off", "Tele-commuting"],
    durationTxt: ["Full", "Am", "Pm"]
};
exports.default = LeaveCalDetail;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveDetailModal = function (_React$Component) {
    _inherits(LeaveDetailModal, _React$Component);

    function LeaveDetailModal(props) {
        _classCallCheck(this, LeaveDetailModal);

        var _this = _possibleConstructorReturn(this, (LeaveDetailModal.__proto__ || Object.getPrototypeOf(LeaveDetailModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);

        _this.state = {
            staffIds: [],
            warningMsg: "",
            staffId: "",
            clientHeight: 200
        };
        return _this;
    }

    _createClass(LeaveDetailModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var clientHeight = _reactDom2.default.findDOMNode(this.refs.modal).clientHeight;
            this.setState({
                clientHeight: clientHeight
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'renderDetail',
        value: function renderDetail() {
            return this.props.detail.map(function (detail, index) {
                return _react2.default.createElement(
                    'li',
                    { className: "pm-li-1 " + (detail.status == 0 ? "" : "lv-red"), key: index },
                    detail.leaveTxt
                );
            });
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'divider' }),
                _react2.default.createElement(
                    'ul',
                    { className: 'pm-ul', style: { height: this.state.clientHeight - 200 + "px", overflow: "auto" } },
                    this.renderDetail()
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'permission-modal', style: { visibility: style.visibility }, ref: 'modal' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            'Leave Summary'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body', style: { height: this.state.clientHeight - 115 + "px" } },
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        ),
                        this.renderContent()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-warning single-btn', onClick: this.handleClick },
                            'Ok'
                        )
                    )
                )
            );
        }
    }]);

    return LeaveDetailModal;
}(_react2.default.Component);

LeaveDetailModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = LeaveDetailModal;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _infoHeader = __webpack_require__(214);

var _infoHeader2 = _interopRequireDefault(_infoHeader);

var _infoBody = __webpack_require__(216);

var _infoBody2 = _interopRequireDefault(_infoBody);

var _leaveAction = __webpack_require__(20);

var _leaveAction2 = _interopRequireDefault(_leaveAction);

var _leaveStore = __webpack_require__(32);

var _leaveStore2 = _interopRequireDefault(_leaveStore);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveInfo = function (_React$Component) {
    _inherits(LeaveInfo, _React$Component);

    function LeaveInfo(props) {
        _classCallCheck(this, LeaveInfo);

        var _this = _possibleConstructorReturn(this, (LeaveInfo.__proto__ || Object.getPrototypeOf(LeaveInfo)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.state = {
            staffs: _filterStore2.default.getState().staffs,
            processingFilter: _filterStore2.default.getState().processing,
            iniLoadStaff: _filterStore2.default.getState().iniLoadStaff,
            processing: _leaveStore2.default.getState().processing,
            search: _leaveStore2.default.getState().search
        };
        return _this;
    }

    _createClass(LeaveInfo, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _leaveStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);
            _menuAction2.default.pageNumber(6);

            if (!this.state.processingFilter && !this.state.iniLoadStaff) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getEmployee();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _leaveStore2.default.unlisten(this.onChange);
            _filterStore2.default.unlisten(this.onFilterChange);
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                staffs: state.staffs,
                processingFilter: state.processing,
                iniLoadStaff: state.iniLoadStaff
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                search: state.search
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var staffs = void 0;
            if (this.state.staffs.length > 0) {
                staffs = this.state.staffs.filter(function (staff) {
                    return staff.userName.toLowerCase().indexOf(_this2.state.search.toLowerCase()) > -1 || staff.staffId.toLowerCase().indexOf(_this2.state.search.toLowerCase()) > -1;
                });
            }
            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 atd' },
                        _react2.default.createElement(_infoHeader2.default, { staffs: this.state.staffs }),
                        _react2.default.createElement('div', { className: 'divider' }),
                        _react2.default.createElement(_infoBody2.default, _extends({ staffs: staffs }, this.props))
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.processingFilter })
            );
        }
    }]);

    return LeaveInfo;
}(_react2.default.Component);

exports.default = LeaveInfo;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _infoFilter = __webpack_require__(215);

var _infoFilter2 = _interopRequireDefault(_infoFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfoHeader = function (_React$Component) {
    _inherits(InfoHeader, _React$Component);

    function InfoHeader(props) {
        _classCallCheck(this, InfoHeader);

        return _possibleConstructorReturn(this, (InfoHeader.__proto__ || Object.getPrototypeOf(InfoHeader)).call(this, props));
    }

    _createClass(InfoHeader, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-hd' },
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(
                        'b',
                        null,
                        'Leave Summary'
                    )
                ),
                _react2.default.createElement(_infoFilter2.default, null),
                _react2.default.createElement('div', { className: 'clear' })
            );
        }
    }]);

    return InfoHeader;
}(_react2.default.Component);

exports.default = InfoHeader;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _leaveAction = __webpack_require__(20);

var _leaveAction2 = _interopRequireDefault(_leaveAction);

var _leaveStore = __webpack_require__(32);

var _leaveStore2 = _interopRequireDefault(_leaveStore);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfoFilter = function (_React$Component) {
    _inherits(InfoFilter, _React$Component);

    function InfoFilter(props) {
        _classCallCheck(this, InfoFilter);

        var _this = _possibleConstructorReturn(this, (InfoFilter.__proto__ || Object.getPrototypeOf(InfoFilter)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.state = {
            search: _leaveStore2.default.getState().search,
            processing: _leaveStore2.default.getState().processing,

            permission: _userStore2.default.getState().permission
        };
        return _this;
    }

    _createClass(InfoFilter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _leaveStore2.default.listen(this.onChange);
            _userStore2.default.listen(this.onUserChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _leaveStore2.default.unlisten(this.onChange);
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                searching: state.searching,
                search: state.search
            });
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission

            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var search = e.target.value;
            _leaveAction2.default.search(search);
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            _leaveAction2.default.search(this.state.search);
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            if (this.state.processing) return;

            _leaveAction2.default.processing(true);
            _leaveAction2.default.exportAllSummary();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'row atd-i' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-md-4' },
                    _react2.default.createElement(
                        'form',
                        { className: 'form-horizontal atd-i-wp' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'empName', className: 'col-xs-3 control-label' },
                            'Employee: '
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'input-group input-group-sm' },
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'empName', placeholder: 'Search Employee by Name or ID', value: this.state.search, onChange: this.handleChange }),
                            _react2.default.createElement(
                                'span',
                                { className: 'input-group-btn' },
                                _react2.default.createElement(
                                    'button',
                                    { className: 'btn btn-default', type: 'button', onClick: this.handleSubmit },
                                    'Search'
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-md-4' },
                    _genFunction2.default.hasPermission(this.state.permission, 2) ? _react2.default.createElement(
                        'button',
                        { className: 'btn btn-primary btn-sm atd-i-wp', onClick: this.handleClick },
                        'Export All Leave Summaries'
                    ) : ""
                )
            );
        }
    }]);

    return InfoFilter;
}(_react2.default.Component);

exports.default = InfoFilter;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _empCard = __webpack_require__(217);

var _empCard2 = _interopRequireDefault(_empCard);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfoBody = function (_React$Component) {
    _inherits(InfoBody, _React$Component);

    function InfoBody(props) {
        _classCallCheck(this, InfoBody);

        var _this = _possibleConstructorReturn(this, (InfoBody.__proto__ || Object.getPrototypeOf(InfoBody)).call(this, props));

        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.state = {
            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId
        };
        return _this;
    }

    _createClass(InfoBody, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _userStore2.default.listen(this.onUserChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var employeeList = void 0;
            var staffs = void 0;
            if (this.props.staffs) {
                staffs = this.props.staffs.filter(function (staff) {
                    return _genFunction2.default.hasPermission(_this2.state.permission, 2) || _genFunction2.default.isSubordinate(_this2.state.subordinate, staff.staffId) || _genFunction2.default.isUser(_this2.state.userId, staff.staffId);
                });
                employeeList = staffs.map(function (staff, index) {
                    return _react2.default.createElement(_empCard2.default, { staff: staff, key: index, history: _this2.props.history });
                });
            }
            return _react2.default.createElement(
                'div',
                { className: 'atd-bd-wp' },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-em-lt' },
                    employeeList
                )
            );
        }
    }]);

    return InfoBody;
}(_react2.default.Component);

exports.default = InfoBody;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmpCard = function (_React$Component) {
    _inherits(EmpCard, _React$Component);

    function EmpCard(props) {
        _classCallCheck(this, EmpCard);

        var _this = _possibleConstructorReturn(this, (EmpCard.__proto__ || Object.getPrototypeOf(EmpCard)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(EmpCard, [{
        key: 'handleClick',
        value: function handleClick(e) {
            this.props.history.push('/leaveInfo/' + this.props.staff.staffId);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-card', onClick: this.handleClick },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-img-wp' },
                    _react2.default.createElement('img', { className: 'atd-img', src: this.props.staff.userImage })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'atd-nm' },
                    this.props.staff.userName
                )
            );
        }
    }]);

    return EmpCard;
}(_react2.default.Component);

exports.default = EmpCard;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _summaryBody = __webpack_require__(219);

var _summaryBody2 = _interopRequireDefault(_summaryBody);

var _leaveAction = __webpack_require__(20);

var _leaveAction2 = _interopRequireDefault(_leaveAction);

var _leaveStore = __webpack_require__(32);

var _leaveStore2 = _interopRequireDefault(_leaveStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveSummary = function (_React$Component) {
    _inherits(LeaveSummary, _React$Component);

    function LeaveSummary(props) {
        _classCallCheck(this, LeaveSummary);

        var _this = _possibleConstructorReturn(this, (LeaveSummary.__proto__ || Object.getPrototypeOf(LeaveSummary)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.state = {
            summary: _leaveStore2.default.getState().summary,
            processing: _leaveStore2.default.getState().processing
        };
        return _this;
    }

    _createClass(LeaveSummary, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _leaveStore2.default.listen(this.onChange);
            _menuAction2.default.pageNumber(6);
            if (!this.state.processing) {
                _leaveAction2.default.processing(true);
                _leaveAction2.default.summaryClear();
                _leaveAction2.default.getSummary(this.props.match.params.id);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _leaveStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                summary: state.summary
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 atd' },
                        _react2.default.createElement(_summaryBody2.default, _extends({ summary: this.state.summary, processing: this.state.processing }, this.props))
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing })
            );
        }
    }]);

    return LeaveSummary;
}(_react2.default.Component);

exports.default = LeaveSummary;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _summaryList = __webpack_require__(220);

var _summaryList2 = _interopRequireDefault(_summaryList);

var _reactRouterDom = __webpack_require__(1);

var _leaveAction = __webpack_require__(20);

var _leaveAction2 = _interopRequireDefault(_leaveAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SummaryBody = function (_React$Component) {
    _inherits(SummaryBody, _React$Component);

    function SummaryBody(props) {
        _classCallCheck(this, SummaryBody);

        var _this = _possibleConstructorReturn(this, (SummaryBody.__proto__ || Object.getPrototypeOf(SummaryBody)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(SummaryBody, [{
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            if (index == 0) {
                window.print();
            } else if (index == 1) {
                if (this.props.processing) return;
                _leaveAction2.default.processing(true);
                _leaveAction2.default.exportSummary(this.props.summary.staffId);
            } else {
                this.props.history.push('/leaveInfo');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var summary = void 0;
            if (this.props.summary.summary) {
                summary = this.props.summary.summary.map(function (summary, index) {
                    return _react2.default.createElement(
                        'th',
                        { key: index },
                        summary.leaveTxt,
                        ' (',
                        summary.type == 7 ? "hrs" : "days",
                        ')'
                    );
                });
            }

            return _react2.default.createElement(
                'div',
                { id: 'leaveSummary' },
                _react2.default.createElement(
                    'h3',
                    null,
                    'Leave Summary'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'sum-1-wp' },
                    _react2.default.createElement(
                        'h4',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            this.props.summary.userName
                        )
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'div',
                        { className: 'sum-wp', style: { width: (this.props.summary.summary ? this.props.summary.summary.length * 110 + 110 : 0) + "px" } },
                        _react2.default.createElement('div', { className: 'sum-l-tt' }),
                        _react2.default.createElement(
                            'table',
                            { className: 'sum-tb' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    summary
                                )
                            )
                        ),
                        _react2.default.createElement(_summaryList2.default, { summary: this.props.summary.summary })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-md-4' },
                            _react2.default.createElement(
                                'button',
                                { type: 'button', className: 'btn btn-primary us-cr',
                                    'data-index': '0', onClick: this.handleClick },
                                'Print'
                            ),
                            _react2.default.createElement(
                                'button',
                                { type: 'button', className: 'btn btn-primary us-cr',
                                    'data-index': '1', onClick: this.handleClick },
                                'Export'
                            ),
                            _react2.default.createElement(
                                'button',
                                { type: 'button', className: 'btn btn-default us-cr',
                                    'data-index': '2', onClick: this.handleClick },
                                'Cancel'
                            )
                        ),
                        _react2.default.createElement('div', { className: 'clear' })
                    )
                )
            );
        }
    }]);

    return SummaryBody;
}(_react2.default.Component);

SummaryBody.defaultProps = {
    typeTxt: ["Annual Leave", "Medical Leave", "Reservist", "Childcare leave", "Unpaid leave", "Compassionate leave", "Other Leave", "Time-off", "Tele-commuting"]
};
exports.default = SummaryBody;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SummaryList = function (_React$Component) {
    _inherits(SummaryList, _React$Component);

    function SummaryList(props) {
        _classCallCheck(this, SummaryList);

        var _this = _possibleConstructorReturn(this, (SummaryList.__proto__ || Object.getPrototypeOf(SummaryList)).call(this, props));

        _this.isWhole = function (number) {
            if (Math.round(number * 100) / 100 == parseInt(number)) {
                return true;
            } else {
                return false;
            }
        };

        return _this;
    }

    _createClass(SummaryList, [{
        key: 'findAnnualTotalAvail',
        value: function findAnnualTotalAvail() {
            var annualTotalAvail = 0;
            var month = new Date().getMonth();

            for (var i = 0; i < this.props.summary.length; i++) {
                if (this.props.summary[i].type == 0) {
                    var remainingDays = (11 - month) * this.props.summary[i].totalGain / 11;
                    annualTotalAvail = remainingDays + this.props.summary[i].leaveGain + this.props.summary[i].bringFwd - this.props.summary[i].used;
                    //annualTotalAvail = this.props.summary[i].totalGain + this.props.summary[i].bringFwd - this.props.summary[i].used;
                }
            }
            return annualTotalAvail;
        }
    }, {
        key: 'renderDataList',
        value: function renderDataList(i) {
            var _this2 = this;

            if (!this.props.summary) return;
            return this.props.summary.sort(function (a, b) {
                return a.type - b.type;
            }).map(function (summary, index) {

                if (i == 0) {
                    if (summary.type != 9) {
                        return _react2.default.createElement(
                            'td',
                            { key: index },
                            summary.totalGain ? _this2.isWhole(summary.totalGain) ? summary.totalGain : summary.totalGain.toFixed(2) : "--"
                        );
                    } else {
                        var available = 0;
                        var annualTotalAvail = _this2.findAnnualTotalAvail();
                        available = Math.min(annualTotalAvail, summary.totalGain - summary.used);
                        var totalGain = available + summary.used;

                        return _react2.default.createElement(
                            'td',
                            { key: index },
                            totalGain ? _this2.isWhole(totalGain) ? totalGain : totalGain.toFixed(2) : "--"
                        );
                    }
                } else if (i == 1) {
                    return _react2.default.createElement(
                        'td',
                        { key: index },
                        summary.bringFwd ? summary.bringFwd : "--"
                    );
                } else if (i == 2) {
                    return _react2.default.createElement(
                        'td',
                        { key: index },
                        summary.leaveGain ? summary.leaveGain : "--"
                    );
                } else if (i == 3) {
                    return _react2.default.createElement(
                        'td',
                        { key: index },
                        summary.used ? summary.used : "--"
                    );
                } else if (i == 4) {
                    if (summary.type == 0) {
                        var _available = summary.bringFwd + summary.leaveGain - summary.used;
                        return _react2.default.createElement(
                            'td',
                            { key: index },
                            _available <= 0 ? "--" : _this2.isWhole(_available) ? _available : _available.toFixed(2)
                        );
                    } else if (summary.type == 9) {
                        var _available2 = 0;
                        var _annualTotalAvail = _this2.findAnnualTotalAvail();
                        _available2 = Math.min(_annualTotalAvail, summary.totalGain - summary.used);

                        return _react2.default.createElement(
                            'td',
                            { key: index },
                            _available2 <= 0 ? "--" : _this2.isWhole(_available2) ? _available2 : _available2.toFixed(2)
                        );
                    } else {
                        var _available3 = summary.totalGain - summary.used;
                        return _react2.default.createElement(
                            'td',
                            { key: index },
                            _available3 <= 0 ? "--" : _this2.isWhole(_available3) ? _available3 : _available3.toFixed(2)
                        );
                    }
                }
            });
        }
    }, {
        key: 'renderMainList',
        value: function renderMainList() {
            var list = [];
            for (var i = 0; i < 5; i++) {
                list = list.concat(_react2.default.createElement(
                    'tr',
                    { key: i },
                    this.renderDataList(i)
                ));
            }
            return list;
        }
    }, {
        key: 'render',
        value: function render() {

            return _react2.default.createElement(
                'div',
                { className: 'sum-wp' },
                _react2.default.createElement(
                    'div',
                    { className: 'sum-l-tt' },
                    _react2.default.createElement(
                        'div',
                        { className: 'sum-li' },
                        'Leave Entitlement'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'sum-li' },
                        'Bring Forward'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'sum-li' },
                        'Leave Gain'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'sum-li' },
                        'Used'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'sum-li' },
                        'Available'
                    )
                ),
                _react2.default.createElement(
                    'table',
                    { className: 'sum-tb' },
                    _react2.default.createElement(
                        'tbody',
                        { className: "leave-tbd" },
                        this.renderMainList()
                    )
                )
            );
        }
    }]);

    return SummaryList;
}(_react2.default.Component);

SummaryList.defaultProps = {
    typeTxt: ["Annual Leave", "Medical Leave", "Reservist", "Childcare leave", "Unpaid leave", "Compassionate leave", "Other Leave", "Time-off", "Tele-commuting"]
};
exports.default = SummaryList;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _userSetAction = __webpack_require__(15);

var _userSetAction2 = _interopRequireDefault(_userSetAction);

var _userSetStore = __webpack_require__(44);

var _userSetStore2 = _interopRequireDefault(_userSetStore);

var _employeeAction = __webpack_require__(33);

var _employeeAction2 = _interopRequireDefault(_employeeAction);

var _employeeStore = __webpack_require__(45);

var _employeeStore2 = _interopRequireDefault(_employeeStore);

var _userSetHeader = __webpack_require__(222);

var _userSetHeader2 = _interopRequireDefault(_userSetHeader);

var _userSetBody = __webpack_require__(224);

var _userSetBody2 = _interopRequireDefault(_userSetBody);

var _userSetForm = __webpack_require__(226);

var _userSetForm2 = _interopRequireDefault(_userSetForm);

var _userEditForm = __webpack_require__(227);

var _userEditForm2 = _interopRequireDefault(_userEditForm);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserSetting = function (_React$Component) {
    _inherits(UserSetting, _React$Component);

    function UserSetting(props) {
        _classCallCheck(this, UserSetting);

        var _this = _possibleConstructorReturn(this, (UserSetting.__proto__ || Object.getPrototypeOf(UserSetting)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.state = {
            warningMsg: _userSetStore2.default.getState().warningMsg,
            usMode: _userSetStore2.default.getState().usMode,
            processing: _userSetStore2.default.getState().processing,
            search: _userSetStore2.default.getState().search,
            updating: _userSetStore2.default.getState().updating,
            staffId: _userSetStore2.default.getState().staffId,
            staffs: _employeeStore2.default.getState().staffs,
            processingFilter: _employeeStore2.default.getState().processing,
            iniLoadStaff: _employeeStore2.default.getState().iniLoadStaff
        };
        return _this;
    }

    _createClass(UserSetting, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _menuAction2.default.pageNumber(10);
            _userSetStore2.default.listen(this.onChange);
            _employeeStore2.default.listen(this.onFilterChange);
            if (!this.state.processingFilter && !this.state.iniLoadStaff) {
                _employeeAction2.default.processing(true);
                _employeeAction2.default.getEmployee();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _userSetStore2.default.unlisten(this.onChange);
            _employeeStore2.default.unlisten(this.onFilterChange);
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                staffs: state.staffs,
                processingFilter: state.processing,
                iniLoadStaff: state.iniLoadStaff
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                warningMsg: state.warningMsg,
                usMode: state.usMode,
                processing: state.processing,
                search: state.search,
                updating: state.updating,
                staffId: state.staffId
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var staffs = void 0;
            if (this.state.staffs.length > 0) {
                staffs = this.state.staffs.filter(function (staff) {
                    return staff.userName.toLowerCase().indexOf(_this2.state.search.toLowerCase()) > -1 || staff.staffId.toLowerCase().indexOf(_this2.state.search.toLowerCase()) > -1;
                });
            }

            var contentDisplay = '';
            if (this.state.usMode == 0) {
                contentDisplay = _react2.default.createElement(_userSetForm2.default, { staffs: this.state.staffs, usMode: this.state.usMode });
            } else {
                if (!this.state.updating) {
                    contentDisplay = _react2.default.createElement(_userSetBody2.default, { staffs: staffs, usMode: this.state.usMode });
                } else {
                    contentDisplay = _react2.default.createElement(_userEditForm2.default, { staffs: this.state.staffs, usMode: this.state.usMode, staffId: this.state.staffId });
                }
            }

            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8' },
                        _react2.default.createElement(_userSetHeader2.default, { staffs: this.state.staffs, processing: this.state.processing, usMode: this.state.usMode, updating: this.state.updating }),
                        contentDisplay
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.processingFilter })
            );
        }
    }]);

    return UserSetting;
}(_react2.default.Component);

exports.default = UserSetting;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _userSetOption = __webpack_require__(223);

var _userSetOption2 = _interopRequireDefault(_userSetOption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserSetHeader = function (_React$Component) {
    _inherits(UserSetHeader, _React$Component);

    function UserSetHeader(props) {
        _classCallCheck(this, UserSetHeader);

        return _possibleConstructorReturn(this, (UserSetHeader.__proto__ || Object.getPrototypeOf(UserSetHeader)).call(this, props));
    }

    _createClass(UserSetHeader, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-hd' },
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(
                        'b',
                        null,
                        'User Management'
                    )
                ),
                _react2.default.createElement(_userSetOption2.default, { staffs: this.props.staffs, processing: this.props.processing, usMode: this.props.usMode, updating: this.props.updating }),
                _react2.default.createElement('div', { className: 'clear' })
            );
        }
    }]);

    return UserSetHeader;
}(_react2.default.Component);

exports.default = UserSetHeader;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _userSetAction = __webpack_require__(15);

var _userSetAction2 = _interopRequireDefault(_userSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserSetOption = function (_React$Component) {
    _inherits(UserSetOption, _React$Component);

    function UserSetOption(props) {
        _classCallCheck(this, UserSetOption);

        var _this = _possibleConstructorReturn(this, (UserSetOption.__proto__ || Object.getPrototypeOf(UserSetOption)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.state = {
            staffId: "",
            search: ""
        };
        return _this;
    }

    _createClass(UserSetOption, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {}
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            e.preventDefault();
            e.stopPropagation();

            var value = e.target.value;
            var index = parseInt(e.target.getAttribute("data-index"));

            this.setState({ search: value });
            _userSetAction2.default.search(value);
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            e.preventDefault();
            e.stopPropagation();

            var index = parseInt(e.currentTarget.getAttribute("data-index"));
            _userSetAction2.default.usMode(index);
            _userSetAction2.default.updating(false);
        }
    }, {
        key: 'renderFilter',
        value: function renderFilter() {
            if (this.props.usMode != 0 && !this.props.updating) {
                return _react2.default.createElement(
                    'div',
                    { className: 'row ' },
                    _react2.default.createElement('div', { className: 'divider' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-5' },
                        _react2.default.createElement(
                            'form',
                            { className: 'form-horizontal atd-i-wp' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'empName', className: 'col-xs-4 control-label' },
                                'Employee: '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group' },
                                _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'empName', placeholder: 'Search Employee by Name or Id', onChange: this.handleChange }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'input-group-btn' },
                                    _react2.default.createElement(
                                        'button',
                                        { className: 'btn btn-default', type: 'button' },
                                        'Search'
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement('div', { className: 'clear' })
                );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'us-o-w' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'us-i-grp' },
                        _react2.default.createElement(
                            'div',
                            { className: "us-o " + (this.props.usMode == 0 ? "us-o-active" : ""), 'data-index': '0', onClick: this.handleClick },
                            _react2.default.createElement('div', { className: 'icon icon-xl icon-addUser' }),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-o-title' },
                                'Create New Account'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: "us-o " + (this.props.usMode != 0 ? "us-o-active" : ""), 'data-index': '1', onClick: this.handleClick },
                            _react2.default.createElement('div', { className: 'icon icon-xl icon-editUser' }),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-o-title' },
                                'Edit/Remove Employee'
                            )
                        )
                    )
                ),
                this.renderFilter()
            );
        }
    }]);

    return UserSetOption;
}(_react2.default.Component);

exports.default = UserSetOption;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _empCard = __webpack_require__(225);

var _empCard2 = _interopRequireDefault(_empCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserSetBody = function (_React$Component) {
    _inherits(UserSetBody, _React$Component);

    function UserSetBody(props) {
        _classCallCheck(this, UserSetBody);

        return _possibleConstructorReturn(this, (UserSetBody.__proto__ || Object.getPrototypeOf(UserSetBody)).call(this, props));
    }

    _createClass(UserSetBody, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var employeeList = this.props.staffs.map(function (staff, index) {
                return _react2.default.createElement(_empCard2.default, { staff: staff, key: index, history: _this2.props.history });
            });
            return _react2.default.createElement(
                'div',
                { className: 'atd-bd-wp' },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-em-lt' },
                    employeeList
                )
            );
        }
    }]);

    return UserSetBody;
}(_react2.default.Component);

exports.default = UserSetBody;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _userSetAction = __webpack_require__(15);

var _userSetAction2 = _interopRequireDefault(_userSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmpCard = function (_React$Component) {
    _inherits(EmpCard, _React$Component);

    function EmpCard(props) {
        _classCallCheck(this, EmpCard);

        var _this = _possibleConstructorReturn(this, (EmpCard.__proto__ || Object.getPrototypeOf(EmpCard)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(EmpCard, [{
        key: 'handleClick',
        value: function handleClick(e) {
            _userSetAction2.default.staffId(this.props.staff.staffId);
            _userSetAction2.default.updating(true);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-card', onClick: this.handleClick },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-img-wp' },
                    _react2.default.createElement('img', { className: 'atd-img', src: this.props.staff.userImage })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'atd-nm' },
                    this.props.staff.userName,
                    _react2.default.createElement(
                        'b',
                        null,
                        this.props.staff.status != 0 ? " - " + this.props.statusTxt[this.props.staff.status] : ""
                    )
                )
            );
        }
    }]);

    return EmpCard;
}(_react2.default.Component);

EmpCard.defaultProps = {
    statusTxt: ["Employed", "Resigned", "Dismissed", "Terminated"]
};
exports.default = EmpCard;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _userSetAction = __webpack_require__(15);

var _userSetAction2 = _interopRequireDefault(_userSetAction);

var _userSetStore = __webpack_require__(44);

var _userSetStore2 = _interopRequireDefault(_userSetStore);

var _userSetImg = __webpack_require__(83);

var _userSetImg2 = _interopRequireDefault(_userSetImg);

var _userSetModal = __webpack_require__(84);

var _userSetModal2 = _interopRequireDefault(_userSetModal);

var _supervisorModal = __webpack_require__(85);

var _supervisorModal2 = _interopRequireDefault(_supervisorModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import UserPermission from './userPermission';

var UserSetForm = function (_React$Component) {
    _inherits(UserSetForm, _React$Component);

    function UserSetForm(props) {
        _classCallCheck(this, UserSetForm);

        var _this = _possibleConstructorReturn(this, (UserSetForm.__proto__ || Object.getPrototypeOf(UserSetForm)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);

        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleUpload = _this.handleUpload.bind(_this);
        _this.handleCheckBox = _this.handleCheckBox.bind(_this);
        _this.addSupervisor = _this.addSupervisor.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.shouldSupModalClose = _this.shouldSupModalClose.bind(_this);
        _this.state = {
            firstName: "",
            middleName: "",
            lastName: "",
            staffId: "",
            typeIdentidy: "",
            identidyNo: "",
            gender: 0,
            dob: "",
            race: 0,
            nationality: "",
            employmentDate: "",
            department: 0,
            role: 0,
            officeExtNo: "",
            email: "",
            password: "",
            confirmPassword: "",
            userImage: "",
            streetName: "",
            blkNo: "",
            unitNo: "",
            postal: "",
            homeTel: "",
            handPhone: "",
            emgName: "",
            emgContactNo: "",
            emgRelationship: "",
            comHandphone: { number: "", model: "", serial: "" },
            comLaptop: { number: "", model: "", serial: "" },
            comCabcard: { number: "", model: "", serial: "" },
            education: "",
            school: "",
            supervisor: [],
            startWork: "09:00",
            endWork: "17:30",
            startLunch: "13:00",
            endLunch: "14:00",
            status: 0,
            //permission: [],
            warningMsg: "",
            //permissionList: userSetStore.getState().permissionList,
            isSucceed: _userSetStore2.default.getState().isSucceed,
            processing: _userSetStore2.default.getState().processing,
            modalClose: false,
            modalDelClose: false,
            otClaim: false,
            remark: ""
        };
        return _this;
    }

    _createClass(UserSetForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _userSetStore2.default.listen(this.onChange);
            /*
            if (!this.state.processing) {
                userSetAction.processing(true);
                userSetAction.getPermissionList();
            }
            */
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _userSetStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.isSucceed && prevState.isSucceed != this.state.isSucceed) {
                this.setState({ modalClose: true });
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            console.log(state);
            this.setState({
                isSucceed: state.isSucceed,
                processing: state.processing
                //permissionList: state.permissionList,
            });
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                staffs: state.staffs,
                processingFilter: state.processing,
                iniLoadStaff: state.iniLoadStaff
            });
        }
    }, {
        key: 'addSupervisor',
        value: function addSupervisor() {
            this.setState({
                modalSupClose: true
            });
        }
    }, {
        key: 'handleEdit',
        value: function handleEdit(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var value = e.target.value;
            var _state = this.state,
                comHandphone = _state.comHandphone,
                comLaptop = _state.comLaptop,
                comCabcard = _state.comCabcard;

            switch (index) {
                case 0:
                    this.setState({ firstName: value });
                    break;
                case 1:
                    this.setState({ middleName: value });
                    break;
                case 2:
                    this.setState({ lastName: value });
                    break;
                case 3:
                    this.setState({ staffId: value });
                    break;
                case 4:
                    this.setState({ identidyNo: value });
                    break;
                case 5:
                    this.setState({ gender: parseInt(value) });
                    break;
                case 6:
                    this.setState({ dob: value });
                    break;
                case 7:
                    this.setState({ race: parseInt(value) });
                    break;
                case 8:
                    this.setState({ nationality: value });
                    break;
                case 9:
                    this.setState({ employmentDate: value });
                    break;
                case 10:
                    this.setState({ department: parseInt(value) });
                    break;
                case 11:
                    this.setState({ role: parseInt(value) });
                    break;
                case 12:
                    this.setState({ officeExtNo: value });
                    break;
                case 13:
                    this.setState({ email: value });
                    break;
                case 14:
                    this.setState({ password: value });
                    break;
                case 15:
                    this.setState({ confirmPassword: value });
                    break;
                case 16:
                    this.setState({ streetName: value });
                    break;
                case 17:
                    this.setState({ blkNo: value });
                    break;
                case 18:
                    this.setState({ unitNo: value });
                    break;
                case 19:
                    this.setState({ postal: value });
                    break;
                case 20:
                    this.setState({ homeTel: value });
                    break;
                case 21:
                    this.setState({ handPhone: value });
                    break;
                case 22:
                    this.setState({ emgName: value });
                    break;
                case 23:
                    this.setState({ emgContactNo: value });
                    break;
                case 24:
                    this.setState({ emgRelationship: value });
                    break;
                case 25:
                    comHandphone.number = value;
                    this.setState({ comHandphone: comHandphone });
                    break;
                case 26:
                    comHandphone.model = value;
                    this.setState({ comHandphone: comHandphone });
                    break;
                case 27:
                    comHandphone.serial = value;
                    this.setState({ comHandphone: comHandphone });
                    break;
                case 28:
                    comLaptop.number = value;
                    this.setState({ comLaptop: comLaptop });
                    break;
                case 29:
                    comLaptop.model = value;
                    this.setState({ comLaptop: comLaptop });
                    break;
                case 30:
                    comLaptop.serial = value;
                    this.setState({ comLaptop: comLaptop });
                    break;
                case 31:
                    comCabcard.number = value;
                    this.setState({ comCabcard: comCabcard });
                    break;
                case 32:
                    comCabcard.model = value;
                    this.setState({ comCabcard: comCabcard });
                    break;
                case 33:
                    comCabcard.serial = value;
                    this.setState({ comCabcard: comCabcard });
                    break;
                case 34:
                    this.setState({ education: parseInt(value) });
                    break;
                case 35:
                    this.setState({ school: value });
                    break;
                case 36:
                    this.setState({ typeIdentidy: value });
                    break;
                case 37:
                    this.setState({ startWork: value });
                    break;
                case 38:
                    this.setState({ endWork: value });
                    break;
                case 39:
                    this.setState({ startLunch: value });
                    break;
                case 40:
                    this.setState({ endLunch: value });
                    break;
                case 41:
                    this.setState({ status: parseInt(value) });
                    break;
                case 42:
                    this.setState({ remark: value });
                    break;
            }
        }
    }, {
        key: 'handleCheckBox',
        value: function handleCheckBox(e) {
            var checked = e.target.checked;
            this.setState({
                otClaim: checked
            });
        }
    }, {
        key: 'handleUpload',
        value: function handleUpload(e) {
            var file = e.target.files[0];
            if (this.checkFileExt(file)) {
                this.previewImage(file);
                this.setState({ warningMsg: '' });
            } else {
                this.setState({ warningMsg: 'Only jpg, jpeg and png are allowed' });
            }
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({ modalClose: data });
        }
    }, {
        key: 'shouldSupModalClose',
        value: function shouldSupModalClose(data) {
            this.setState({ modalSupClose: data });
        }
    }, {
        key: 'checkFileExt',
        value: function checkFileExt(file) {
            var allow_type = ['jpg', 'jpeg', 'png'];
            var ext = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
            var re = false;
            for (var i = 0; i < allow_type.length; i++) {
                if (ext == allow_type[i].toLocaleLowerCase()) {
                    re = true;break;
                }
            }
            return re;
        }
    }, {
        key: 'previewImage',
        value: function previewImage(file) {
            var _this2 = this;

            var userImage = void 0;
            //to be modified
            var fr = new FileReader();
            fr.onload = function (e) {
                userImage = window.URL.createObjectURL(new Blob([e.target.result]));
                _this2.setState({ userImage: userImage });
            };
            fr.readAsArrayBuffer(file);
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {

            if (this.state.processing) return;

            if (!this.validateForm()) return;

            var fd = new FormData();
            //convert image to blob data
            if (this.state.userImage) {
                var blobData = _userSetImg2.default.resizeImage(this.state.userImage);
                fd.append("images", blobData);
            }
            var s = this.state;

            fd.append("firstName", s.firstName);
            fd.append("middleName", s.middleName);
            fd.append("lastName", s.lastName);
            fd.append("staffId", s.staffId);
            fd.append("typeIdentidy", s.typeIdentidy);
            fd.append("identidyNo", s.identidyNo);
            fd.append("gender", s.gender);
            fd.append("dob", s.dob);
            fd.append("race", s.race);
            fd.append("nationality", s.nationality);
            fd.append("employmentDate", s.employmentDate);
            fd.append("department", s.department);
            fd.append("role", s.role);
            fd.append("officeExtNo", s.officeExtNo);
            fd.append("email", s.email);
            fd.append("password", s.password);
            fd.append("streetName", s.streetName);
            fd.append("blkNo", s.blkNo);
            fd.append("unitNo", s.unitNo);
            fd.append("postal", s.postal);
            fd.append("homeTel", s.homeTel);
            fd.append("handPhone", s.handPhone);
            fd.append("emgName", s.emgName);
            fd.append("emgContactNo", s.emgContactNo);
            fd.append("emgRelationship", s.emgRelationship);
            fd.append("comHandphone", JSON.stringify(s.comHandphone));
            fd.append("comLaptop", JSON.stringify(s.comLaptop));
            fd.append("comCabcard", JSON.stringify(s.comCabcard));
            fd.append("education", s.education);
            fd.append("school", s.school);
            fd.append("supervisor", JSON.stringify(s.supervisor));
            fd.append("otClaim", s.otClaim ? 1 : 0);
            fd.append("startWork", s.startWork);
            fd.append("endWork", s.endWork);
            fd.append("startLunch", s.startLunch);
            fd.append("endLunch", s.endLunch);
            fd.append("status", s.status);
            fd.append("remark", s.remark);
            //fd.append("permission", JSON.stringify(s.permission));
            _userSetAction2.default.processing(true);
            _userSetAction2.default.addNewUser(fd);
        }
    }, {
        key: 'validateForm',
        value: function validateForm() {
            var isComplete = false;

            if (this.state.userName == "") {
                this.setState({ warningMsg: "Staff Name cannot be empty" });
            } else if (this.state.email == "") {
                this.setState({ warningMsg: "Email cannot be empty" });
            } else if (!this.validateEmail(this.state.email)) {
                this.setState({ warningMsg: "Email is not Valid" });
            } else if (!this.validatePassword(this.state.password)) {
                this.setState({ warningMsg: "Password must be >= 8 characters and at least One Capital Letter" });
            } else if (this.state.password !== this.state.confirmPassword) {
                this.setState({ warningMsg: "Password is not tallied" });
            } else if (this.state.staffId == "") {
                this.setState({ warningMsg: "Employee Number cannot be emptied" });
            } else if (!this.validateStaffId()) {
                this.setState({ warningMsg: "Employee Number repeated" });
            } else {
                this.setState({ warningMsg: "" });
                isComplete = true;
            }

            return isComplete;
        }
    }, {
        key: 'validateStaffId',
        value: function validateStaffId() {
            var isValid = true;

            var len = this.props.staffs.length;
            for (var i = 0; i < len; i++) {
                if (this.props.staffs.staffId == this.state.staffId) {
                    isValid = false;
                    break;
                }
            }
            return isValid;
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
    }, {
        key: 'validatePassword',
        value: function validatePassword(password) {
            if (password.length < 8) {
                return false;
            } else if (password.match(/[A-Z]/g) == null) {
                return false;
            }
            return true;
        }
    }, {
        key: 'renderDepartment',
        value: function renderDepartment() {
            return this.props.departmentTxt.map(function (department, index) {
                return _react2.default.createElement(
                    'option',
                    { value: index, key: index },
                    department
                );
            });
        }
    }, {
        key: 'renderDesignation',
        value: function renderDesignation() {
            return this.props.roleTxt.map(function (role, index) {
                return _react2.default.createElement(
                    'option',
                    { value: index, key: index },
                    role
                );
            });
        }
    }, {
        key: 'renderSupervisor',
        value: function renderSupervisor(supervisor) {
            if (!supervisor) return;
            var spvr = supervisor.map(function (staff, index) {
                return _react2.default.createElement(
                    'li',
                    { key: index, className: 'us-item' },
                    staff.userName
                );
            });

            return _react2.default.createElement(
                'ol',
                null,
                spvr
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var s = this.state;
            var modal = '';
            if (this.state.modalSupClose) {
                modal = _react2.default.createElement(_supervisorModal2.default, {
                    modalClose: this.state.modalSupClose,
                    shouldModalClose: this.shouldSupModalClose,
                    staffIds: s.supervisor,
                    staffs: this.props.staffs,
                    title: 'Reporting Manager'
                });
            }
            return _react2.default.createElement(
                'div',
                { className: 'userSet-form' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'h3',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Create New Account'
                        )
                    ),
                    _react2.default.createElement(
                        'h4',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Employee Details'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'userName' },
                                'Employee Name'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un', value: s.firstName,
                                placeholder: 'First Name', 'data-index': '0', onChange: this.handleEdit, disabled: s.status != 0 }),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un', value: s.middleName,
                                placeholder: 'Middle Name', 'data-index': '1', onChange: this.handleEdit, disabled: s.status != 0 }),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un', value: s.lastName,
                                placeholder: 'Last Name', 'data-index': '2', onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'staffId' },
                                'Employee Id'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'staffId', value: s.staffId,
                                placeholder: 'Employee Number', 'data-index': '3', onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'typeIdentidy' },
                                'Identity Type'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'typeIdentidy', value: s.typeIdentidy,
                                placeholder: 'E.g. S-pass', 'data-index': '36', onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'identidyNo' },
                                'Identity Number'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'identidyNo', value: s.identidyNo,
                                placeholder: 'e.g: SXXXXXXXI', 'data-index': '4', onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'gender' },
                                'Gender'
                            ),
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control', id: 'gender', 'data-index': '5', value: s.gender, onChange: this.handleEdit,
                                    disabled: s.status != 0 },
                                _react2.default.createElement(
                                    'option',
                                    { value: '0' },
                                    'Male'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '1' },
                                    'Female'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'dob' },
                                'D.O.B'
                            ),
                            _react2.default.createElement('input', { type: 'date', className: 'form-control', id: 'dob', value: s.dob,
                                'data-index': '6', onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'race' },
                                'Race'
                            ),
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control', id: 'race', 'data-index': '7', value: s.race, onChange: this.handleEdit,
                                    disabled: s.status != 0 },
                                _react2.default.createElement(
                                    'option',
                                    { value: '0' },
                                    'Chinese'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '1' },
                                    'Malay'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '2' },
                                    'Indian'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '3' },
                                    'Other'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'nation' },
                                'Nationality'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'nation', value: s.nationality,
                                placeholder: 'Nationality', 'data-index': '8', onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'education' },
                                'Level of Education'
                            ),
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control', id: 'education', 'data-index': '34', value: s.education, onChange: this.handleEdit,
                                    disabled: s.status != 0 },
                                _react2.default.createElement(
                                    'option',
                                    { value: '0' },
                                    'Primary'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '1' },
                                    'N-level'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '2' },
                                    'O-level'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '3' },
                                    'GCE \'A\' Level'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '4' },
                                    'Diploma'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '5' },
                                    'Bachelor'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '6' },
                                    'Master'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '7' },
                                    'Other'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'school' },
                                'Name of School (Highest level)'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'school', value: s.school,
                                placeholder: 'Name of University or polytechnic', 'data-index': '35', onChange: this.handleEdit, disabled: s.status != 0 })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'employmentDate' },
                                'Employment Date'
                            ),
                            _react2.default.createElement('input', { type: 'date', className: 'form-control', id: 'employmentDate', value: s.employmentDate,
                                'data-index': '9', onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'status' },
                                'Employment Status'
                            ),
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control', id: 'status', 'data-index': '41', value: s.status, onChange: this.handleEdit },
                                _react2.default.createElement(
                                    'option',
                                    { value: '0' },
                                    'Employed'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '1' },
                                    'Resigned'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '2' },
                                    'Dismissed'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '3' },
                                    'Terminated'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'department' },
                                'Department'
                            ),
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control', id: 'department', value: s.department, 'data-index': '10', onChange: this.handleEdit,
                                    disabled: s.status != 0 },
                                this.renderDepartment()
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'designation' },
                                'Designation'
                            ),
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control', id: 'designation', value: parseInt(s.role), 'data-index': '11', onChange: this.handleEdit,
                                    disabled: s.status != 0 },
                                this.renderDesignation()
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'officeExtNo' },
                                'Office Ext No.'
                            ),
                            _react2.default.createElement('input', { type: 'number', className: 'form-control', id: 'officeExtNo',
                                placeholder: 'Office Ext No.', 'data-index': '12', value: s.officeExtNo, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'email' },
                                'Email address'
                            ),
                            _react2.default.createElement('input', { type: 'email', className: 'form-control', id: 'email',
                                placeholder: 'Email', 'data-index': '13', value: s.email, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'password' },
                                'Password (For App & Webportal Login)'
                            ),
                            _react2.default.createElement('input', { type: 'password', className: 'form-control', id: 'password',
                                placeholder: 'must be >= 8 and at least one Capital Letter', 'data-index': '14', onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'confirmPassword' },
                                'Confirm Password'
                            ),
                            _react2.default.createElement('input', { type: 'password', className: 'form-control', id: 'confirmPassword',
                                placeholder: 're-type your password', 'data-index': '15', onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'supervisor' },
                                'Reporting Manager'
                            ),
                            this.renderSupervisor(s.supervisor),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-default btn-sm us-edit', onClick: this.addSupervisor },
                                'Edit'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'div',
                                { className: 'checkbox' },
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    _react2.default.createElement('input', { type: 'checkbox', value: s.otClaim, onChange: this.handleCheckBox, checked: s.otClaim, disabled: s.status != 0 }),
                                    _react2.default.createElement('span', { className: 'checkmark' }),
                                    'OT Claim'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'remark' },
                                'Remark'
                            ),
                            _react2.default.createElement('textarea', { className: 'form-control', id: 'remark', rows: '3',
                                placeholder: 'Type Remark Here', 'data-index': '42', value: s.remark, onChange: this.handleEdit,
                                disabled: s.status != 0 })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'userImage' },
                                'Staff Picture Upload'
                            ),
                            _react2.default.createElement('input', { type: 'file', id: 'userImage', onChange: this.handleUpload, disabled: s.status != 0 }),
                            _react2.default.createElement(
                                'p',
                                { className: 'help-block' },
                                'Picture Format (150x200). Accept .jpg, .jpeg, .png format'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ui-pre-w' },
                            _react2.default.createElement('img', { className: 'ui-pre', src: s.userImage, attribute: 'staff Picture Preview' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'startWork' },
                                'Start Work.'
                            ),
                            _react2.default.createElement('input', { type: 'time', className: 'form-control', id: 'startWork',
                                'data-index': '37', value: s.startWork, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'endWork' },
                                'End Work'
                            ),
                            _react2.default.createElement('input', { type: 'time', className: 'form-control', id: 'endWork',
                                'data-index': '38', value: s.endWork, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'startLunch' },
                                'Lunch Time Start'
                            ),
                            _react2.default.createElement('input', { type: 'time', className: 'form-control', id: 'startLunch',
                                'data-index': '39', value: s.startLunch, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'endLunch' },
                                'Lunch Time End'
                            ),
                            _react2.default.createElement('input', { type: 'time', className: 'form-control', id: 'endLunch',
                                'data-index': '40', value: s.endLunch, onChange: this.handleEdit, disabled: s.status != 0 })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'h4',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Residential Address'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'streetName' },
                                'STREET NAME'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'streetName',
                                placeholder: 'e.g. Thomson Road', 'data-index': '16', value: s.streetName, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'blkNo' },
                                'APT/BLK NO.'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'blkNo',
                                placeholder: 'e.g. Blk 184', 'data-index': '17', value: s.blkNo, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'unitNo' },
                                'UNIT NO.'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'unitNo',
                                placeholder: 'e.g. 10-113', 'data-index': '18', value: s.unitNo, onChange: this.handleEdit, disabled: s.status != 0 })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'postal' },
                                'POSTAL CODE'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'postal',
                                placeholder: 'e.g. 611001', 'data-index': '19', value: s.postal, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'homeTel' },
                                'Home Tel.'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'homeTel',
                                placeholder: 'Home Tel', 'data-index': '20', value: s.homeTel, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'handPhone' },
                                'HAND PHONE'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'handPhone',
                                placeholder: 'e.g. 9XXXXXXX', 'data-index': '21', value: s.handPhone, onChange: this.handleEdit, disabled: s.status != 0 })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'us-em-tt' },
                            'Emergency Contact'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'emgName' },
                                'NAME'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'emgName',
                                placeholder: 'Type name here', 'data-index': '22', value: s.emgName, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'emgContactNo' },
                                'CONTACT NO'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'emgContactNo',
                                placeholder: 'e.g. 9XXXXXXX', 'data-index': '23', value: s.emgContactNo, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'emgRelationship' },
                                'RELATIONSHIP'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'emgRelationship',
                                placeholder: 'e.g. brother', 'data-index': '24', value: s.emgRelationship, onChange: this.handleEdit, disabled: s.status != 0 })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'h4',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Company Issue'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'comHandphone' },
                                'HANDPHONE'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un', id: 'comHandphone',
                                placeholder: 'Number', 'data-index': '25', value: s.comHandphone ? s.comHandphone.number : "",
                                onChange: this.handleEdit, disabled: s.status != 0 }),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un',
                                placeholder: 'Model', 'data-index': '26', value: s.comHandphone ? s.comHandphone.model : "",
                                onChange: this.handleEdit, disabled: s.status != 0 }),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un',
                                placeholder: 'Serial', 'data-index': '27', value: s.comHandphone ? s.comHandphone.serial : "",
                                onChange: this.handleEdit, disabled: s.status != 0 })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'comLaptop' },
                                'Laptop'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un', id: 'comLaptop',
                                placeholder: 'Number', 'data-index': '28', value: s.comLaptop ? s.comLaptop.number : "",
                                onChange: this.handleEdit, disabled: s.status != 0 }),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un',
                                placeholder: 'Model', 'data-index': '29', value: s.comLaptop ? s.comLaptop.model : "",
                                onChange: this.handleEdit, disabled: s.status != 0 }),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un',
                                placeholder: 'Serial', 'data-index': '30', value: s.comLaptop ? s.comLaptop.serial : "",
                                onChange: this.handleEdit, disabled: s.status != 0 })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'comCabcard' },
                                'CAB CARD'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un', id: 'comCabcard',
                                placeholder: 'Number', 'data-index': '31', value: s.comCabcard ? s.comCabcard.number : "",
                                onChange: this.handleEdit, disabled: s.status != 0 }),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un',
                                placeholder: 'Model', 'data-index': '32', value: s.comCabcard ? s.comCabcard.model : "",
                                onChange: this.handleEdit, disabled: s.status != 0 }),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un',
                                placeholder: 'Serial', 'data-index': '33', value: s.comCabcard ? s.comCabcard.serial : "",
                                onChange: this.handleEdit, disabled: s.status != 0 })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-warning us-cr',
                                'data-index': '0', onClick: this.handleClick },
                            'Create'
                        )
                    ),
                    _react2.default.createElement('div', { className: 'clear' })
                ),
                _react2.default.createElement(_userSetModal2.default, {
                    modalClose: this.state.modalClose,
                    shouldModalClose: this.shouldModalClose,
                    usMode: this.props.usMode }),
                modal
            );
            /*
            <div className="row">
                <h4><b>Permission</b></h4>
                <UserPermission permission={s.permission} permissionList={this.state.permissionList} />
            </div>
            */
        }
    }]);

    return UserSetForm;
}(_react2.default.Component);

UserSetForm.defaultProps = {
    departmentTxt: ["Accounts", "HR", "Operations", "Management", "IT", "Admin", "A4FM"],
    roleTxt: ["Administrative Executive", "Property Executive", "Property Manager", "Human Resource Executive", "Contracts Management Executive", "Accounts Executive", "Accounts Manager", "Information Technology", "Managing Director", "Director", "Other", "Cleaner Supervisor", "Cleaner", "Landscaper", "Electrician", "Caretaker", "Portfolio Manager", "Team Manager", "Senior Admin Executive"]
};
exports.default = UserSetForm;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _userSetAction = __webpack_require__(15);

var _userSetAction2 = _interopRequireDefault(_userSetAction);

var _userSetStore = __webpack_require__(44);

var _userSetStore2 = _interopRequireDefault(_userSetStore);

var _userSetImg = __webpack_require__(83);

var _userSetImg2 = _interopRequireDefault(_userSetImg);

var _userSetModal = __webpack_require__(84);

var _userSetModal2 = _interopRequireDefault(_userSetModal);

var _userSetModal3 = __webpack_require__(228);

var _userSetModal4 = _interopRequireDefault(_userSetModal3);

var _supervisorModal = __webpack_require__(85);

var _supervisorModal2 = _interopRequireDefault(_supervisorModal);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import UserPermission from './userPermission';

var UserEditForm = function (_React$Component) {
    _inherits(UserEditForm, _React$Component);

    function UserEditForm(props) {
        _classCallCheck(this, UserEditForm);

        var _this = _possibleConstructorReturn(this, (UserEditForm.__proto__ || Object.getPrototypeOf(UserEditForm)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleCheckBox = _this.handleCheckBox.bind(_this);
        _this.handleUpload = _this.handleUpload.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.shouldSupModalClose = _this.shouldSupModalClose.bind(_this);
        _this.shouldDelModalClose = _this.shouldDelModalClose.bind(_this);
        _this.addSupervisor = _this.addSupervisor.bind(_this);
        _this.removeUser = _this.removeUser.bind(_this);
        _this.state = {
            permission: _userStore2.default.getState().permission,

            userDetail: _userSetStore2.default.getState().userDetail,
            isSucceed: _userSetStore2.default.getState().isSucceed,
            processing: _userSetStore2.default.getState().processing,
            //permissionList: userSetStore.getState().permissionList,
            warningMsg: "",

            modalClose: false,
            modalDelClose: false,
            modalSupClose: false,
            action: 3
        };
        return _this;
    }

    _createClass(UserEditForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _userSetStore2.default.listen(this.onChange);
            _userSetAction2.default.clear();

            if (!this.state.processing && _genFunction2.default.hasPermission(this.state.permission, 5)) {
                _userSetAction2.default.processing(true);
                _userSetAction2.default.userDetail(this.props.staffId);
                //userSetAction.getPermissionList();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _userSetStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.isSucceed && prevState.isSucceed != this.state.isSucceed) {
                this.setState({ modalClose: true });
            }
        }
    }, {
        key: 'removeUser',
        value: function removeUser() {
            if (this.state.processing) return;

            _userSetAction2.default.processing(true);
            _userSetAction2.default.removeUser(this.props.staffId);
            //off the modal
            this.shouldDelModalClose(false);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                userDetail: state.userDetail,
                isSucceed: state.isSucceed,
                processing: state.processing
                //permissionList: state.permissionList,
            });
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission
            });
        }
    }, {
        key: 'addSupervisor',
        value: function addSupervisor() {
            this.setState({
                modalSupClose: true
            });
        }
    }, {
        key: 'handleEdit',
        value: function handleEdit(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var value = e.currentTarget.value;
            console.log(value, index);
            var s = this.state.userDetail;
            switch (index) {
                case 0:
                    s.firstName = value;
                    break;
                case 1:
                    s.middleName = value;
                    break;
                case 2:
                    s.lastName = value;
                    break;
                case 3:
                    s.staffId = value;
                    break;
                case 4:
                    s.identidyNo = value;
                    break;
                case 5:
                    s.gender = parseInt(value);
                    break;
                case 6:
                    s.dob = value;
                    break;
                case 7:
                    s.race = parseInt(value);
                    break;
                case 8:
                    s.nationality = value;
                    break;
                case 9:
                    s.employmentDate = value;
                    break;
                case 10:
                    s.department = parseInt(value);
                    break;
                case 11:
                    s.role = parseInt(value);
                    break;
                case 12:
                    s.officeExtNo = value;
                    break;
                case 13:
                    s.email = value;
                    break;
                case 16:
                    s.streetName = value;
                    break;
                case 17:
                    s.blkNo = value;
                    break;
                case 18:
                    s.unitNo = value;
                    break;
                case 19:
                    s.postal = value;
                    break;
                case 20:
                    s.homeTel = value;
                    break;
                case 21:
                    s.handPhone = value;
                    break;
                case 22:
                    s.emgName = value;
                    break;
                case 23:
                    s.emgContactNo = value;
                    break;
                case 24:
                    s.emgRelationship = value;
                    break;
                case 25:
                    s.comHandphone.number = value;
                    break;
                case 26:
                    s.comHandphone.model = value;
                    break;
                case 27:
                    s.comHandphone.serial = value;
                    break;
                case 28:
                    s.comLaptop.number = value;
                    break;
                case 29:
                    s.comLaptop.model = value;
                    break;
                case 30:
                    s.comLaptop.serial = value;
                    break;
                case 31:
                    s.comCabcard.number = value;
                    break;
                case 32:
                    s.comCabcard.model = value;
                    break;
                case 33:
                    s.comCabcard.serial = value;
                    break;
                case 34:
                    s.education = parseInt(value);
                    break;
                case 35:
                    s.school = value;
                    break;
                case 36:
                    s.typeIdentidy = value;
                    break;
                case 37:
                    s.startWork = value;
                    break;
                case 38:
                    s.endWork = value;
                    break;
                case 39:
                    s.startLunch = value;
                    break;
                case 40:
                    s.endLunch = value;
                    break;
                case 41:
                    s.status = parseInt(value);
                    break;
                case 42:
                    s.remark = value;
                    break;
            }

            _userSetAction2.default.updateUserDetail(s);
        }
    }, {
        key: 'handleCheckBox',
        value: function handleCheckBox(e) {
            var checked = e.target.checked;
            var s = this.state.userDetail;
            s.otClaim = checked;
            _userSetAction2.default.updateUserDetail(s);
        }
    }, {
        key: 'handleUpload',
        value: function handleUpload(e) {
            var file = e.target.files[0];
            if (this.checkFileExt(file)) {
                this.previewImage(file);
                this.setState({ warningMsg: '' });
            } else {
                this.setState({ warningMsg: 'Only jpg, jpeg and png are allowed' });
            }
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({ modalClose: data });
        }
    }, {
        key: 'shouldDelModalClose',
        value: function shouldDelModalClose(data) {
            this.setState({ modalDelClose: data });
        }
    }, {
        key: 'shouldSupModalClose',
        value: function shouldSupModalClose(data) {
            this.setState({ modalSupClose: data });
        }
    }, {
        key: 'checkFileExt',
        value: function checkFileExt(file) {
            var allow_type = ['jpg', 'jpeg', 'png'];
            var ext = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
            var re = false;
            for (var i = 0; i < allow_type.length; i++) {
                if (ext == allow_type[i].toLocaleLowerCase()) {
                    re = true;break;
                }
            }
            return re;
        }
    }, {
        key: 'previewImage',
        value: function previewImage(file) {
            var _this2 = this;

            var userImage = void 0;
            //to be modified
            var fr = new FileReader();
            fr.onload = function (e) {
                userImage = window.URL.createObjectURL(new Blob([e.target.result]));
                var s = _this2.state.userDetail;
                s.userImage = userImage;
                _userSetAction2.default.updateUserDetail(s);
            };
            fr.readAsArrayBuffer(file);
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            if (index == 1) {
                return this.setState({
                    modalDelClose: true,
                    action: 4
                });
            }
            if (index == 2) {
                return _userSetAction2.default.updating(false);
            }
            if (this.state.processing) return;

            if (!this.validateForm()) return;

            var fd = new FormData();
            //convert image to blob data
            if (this.state.userDetail.userImage && !/storage.googleapis.com/i.test(this.state.userDetail.userImage) && !/\/public\/img\/default.jpg/i.test(this.state.userDetail.userImage)) {
                var blobData = _userSetImg2.default.resizeImage(this.state.userDetail.userImage);
                fd.append("images", blobData);
            } else {
                fd.append("userImage", this.state.userDetail.userImage);
            }
            var s = this.state.userDetail;

            fd.append("firstName", s.firstName);
            fd.append("middleName", s.middleName);
            fd.append("lastName", s.lastName);
            fd.append("staffId", s.staffId);
            fd.append("identidyNo", s.identidyNo);
            fd.append("typeIdentidy", s.typeIdentidy);
            fd.append("gender", s.gender);
            fd.append("dob", s.dob);
            fd.append("race", s.race);
            fd.append("nationality", s.nationality);
            fd.append("employmentDate", s.employmentDate);
            fd.append("department", s.department);
            fd.append("role", s.role);
            fd.append("officeExtNo", s.officeExtNo);
            fd.append("email", s.email);
            fd.append("streetName", s.streetName);
            fd.append("blkNo", s.blkNo);
            fd.append("unitNo", s.unitNo);
            fd.append("postal", s.postal);
            fd.append("homeTel", s.homeTel);
            fd.append("handPhone", s.handPhone);
            fd.append("emgName", s.emgName);
            fd.append("emgContactNo", s.emgContactNo);
            fd.append("emgRelationship", s.emgRelationship);
            fd.append("comHandphone", JSON.stringify(s.comHandphone));
            fd.append("comLaptop", JSON.stringify(s.comLaptop));
            fd.append("comCabcard", JSON.stringify(s.comCabcard));
            fd.append("education", s.education);
            fd.append("school", s.school);
            fd.append("supervisor", JSON.stringify(s.supervisor));
            fd.append("otClaim", s.otClaim ? 1 : 0);
            fd.append("startWork", s.startWork);
            fd.append("endWork", s.endWork);
            fd.append("startLunch", s.startLunch);
            fd.append("endLunch", s.endLunch);
            fd.append("status", s.status);
            fd.append("remark", s.remark);
            //fd.append("permission", JSON.stringify(s.permission));
            _userSetAction2.default.processing(true);
            _userSetAction2.default.editUser(s.staffId, fd);

            this.setState({ action: 3 });
        }
    }, {
        key: 'validateForm',
        value: function validateForm() {
            var isComplete = false;

            if (this.state.userName == "") {
                this.setState({ warningMsg: "Staff Name cannot be empty" });
            } else if (this.state.email == "") {
                this.setState({ warningMsg: "Email cannot be empty" });
            } else if (!this.validateEmail(this.state.userDetail.email)) {
                this.setState({ warningMsg: "Email is not Valid" });
            } else if (this.state.staffId == "") {
                this.setState({ warningMsg: "Employee Number cannot be emptied" });
            } else {
                this.setState({ warningMsg: "" });
                isComplete = true;
            }

            return isComplete;
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
    }, {
        key: 'validatePassword',
        value: function validatePassword(password) {
            if (password.length < 8) {
                return false;
            } else if (password.match(/[A-Z]/g) == null) {
                return false;
            }
            return true;
        }
    }, {
        key: 'renderDepartment',
        value: function renderDepartment() {
            return this.props.departmentTxt.map(function (department, index) {
                return _react2.default.createElement(
                    'option',
                    { value: index, key: index },
                    department
                );
            });
        }
    }, {
        key: 'renderDesignation',
        value: function renderDesignation() {
            return this.props.roleTxt.map(function (role, index) {
                return _react2.default.createElement(
                    'option',
                    { value: index, key: index },
                    role
                );
            });
        }
    }, {
        key: 'renderSupervisor',
        value: function renderSupervisor(supervisor) {
            if (!supervisor) return;
            var spvr = supervisor.map(function (staff, index) {
                return _react2.default.createElement(
                    'li',
                    { key: index, className: 'us-item' },
                    staff.userName
                );
            });

            return _react2.default.createElement(
                'ol',
                null,
                spvr
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var s = this.state.userDetail;
            if (!s.staffId) return _react2.default.createElement('div', null);
            var modal = '';
            if (this.state.modalSupClose) {
                modal = _react2.default.createElement(_supervisorModal2.default, {
                    modalClose: this.state.modalSupClose,
                    shouldModalClose: this.shouldSupModalClose,
                    staffIds: s.supervisor,
                    staffs: this.props.staffs,
                    title: 'Reporting Manager'
                });
            }

            return _react2.default.createElement(
                'div',
                { className: 'userSet-form' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'h3',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Edit/Remove Account'
                        )
                    ),
                    _react2.default.createElement(
                        'h4',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Employee Details'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'userName' },
                                'Employee Name'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un', value: s.firstName,
                                placeholder: 'First Name', 'data-index': '0', onChange: this.handleEdit, disabled: s.status != 0 }),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un', value: s.middleName,
                                placeholder: 'Middle Name', 'data-index': '1', onChange: this.handleEdit, disabled: s.status != 0 }),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un', value: s.lastName,
                                placeholder: 'Last Name', 'data-index': '2', onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'staffId' },
                                'Employee Id'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'staffId', value: s.staffId,
                                placeholder: 'Employee Number', 'data-index': '3', onChange: this.handleEdit, disabled: true })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'typeIdentidy' },
                                'Identity Type'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'typeIdentidy', value: s.typeIdentidy,
                                placeholder: 'Identidy Type', 'data-index': '36', onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'identidyNo' },
                                'Identity Number'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'identidyNo', value: s.identidyNo,
                                placeholder: 'e.g: SXXXXXXXI', 'data-index': '4', onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'gender' },
                                'Gender'
                            ),
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control', id: 'gender', 'data-index': '5', value: s.gender, onChange: this.handleEdit,
                                    disabled: s.status != 0 },
                                _react2.default.createElement(
                                    'option',
                                    { value: '0' },
                                    'Male'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '1' },
                                    'Female'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'dob' },
                                'D.O.B'
                            ),
                            _react2.default.createElement('input', { type: 'date', className: 'form-control', id: 'dob', value: s.dob,
                                'data-index': '6', onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'race' },
                                'Race'
                            ),
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control', id: 'race', 'data-index': '7', value: s.race, onChange: this.handleEdit,
                                    disabled: s.status != 0 },
                                _react2.default.createElement(
                                    'option',
                                    { value: '0' },
                                    'Chinese'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '1' },
                                    'Malay'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '2' },
                                    'Indian'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '3' },
                                    'Other'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'nation' },
                                'Nationality'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'nation', value: s.nationality,
                                placeholder: 'Nationality', 'data-index': '8', onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'education' },
                                'Level of Education'
                            ),
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control', id: 'education', 'data-index': '34', value: s.education, onChange: this.handleEdit,
                                    disabled: s.status != 0 },
                                _react2.default.createElement(
                                    'option',
                                    { value: '0' },
                                    'Primary'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '1' },
                                    'N-level'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '2' },
                                    'O-level'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '3' },
                                    'GCE \'A\' Level'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '4' },
                                    'Diploma'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '5' },
                                    'Bachelor'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '6' },
                                    'Master'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '7' },
                                    'Other'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'school' },
                                'Name of School (Highest level)'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'school', value: s.school,
                                placeholder: 'Name of University or polytechnic', 'data-index': '35', onChange: this.handleEdit, disabled: s.status != 0 })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'employmentDate' },
                                'Employment Date'
                            ),
                            _react2.default.createElement('input', { type: 'date', className: 'form-control', id: 'employmentDate', value: s.employmentDate,
                                'data-index': '9', onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'status' },
                                'Employment Status'
                            ),
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control', id: 'status', 'data-index': '41', value: s.status, onChange: this.handleEdit },
                                _react2.default.createElement(
                                    'option',
                                    { value: '0' },
                                    'Employed'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '1' },
                                    'Resigned'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '2' },
                                    'Dismissed'
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: '3' },
                                    'Terminated'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'department' },
                                'Department'
                            ),
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control', id: 'department', value: s.department, 'data-index': '10', onChange: this.handleEdit,
                                    disabled: s.status != 0 },
                                this.renderDepartment()
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'designation' },
                                'Designation'
                            ),
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control', id: 'designation', value: s.role, 'data-index': '11', onChange: this.handleEdit,
                                    disabled: s.status != 0 },
                                this.renderDesignation()
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'officeExtNo' },
                                'Office Ext No.'
                            ),
                            _react2.default.createElement('input', { type: 'number', className: 'form-control', id: 'officeExtNo',
                                placeholder: 'Office Ext No.', 'data-index': '12', value: s.officeExtNo, onChange: this.handleEdit,
                                disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'email' },
                                'Email address'
                            ),
                            _react2.default.createElement('input', { type: 'email', className: 'form-control', id: 'email',
                                placeholder: 'Email', 'data-index': '13', value: s.email, onChange: this.handleEdit,
                                disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'supervisor' },
                                'Reporting Manager'
                            ),
                            this.renderSupervisor(s.supervisor),
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-default btn-sm us-edit', onClick: this.addSupervisor },
                                'Edit'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'div',
                                { className: 'checkbox' },
                                _react2.default.createElement(
                                    'label',
                                    null,
                                    _react2.default.createElement('input', { type: 'checkbox', value: s.otClaim, onChange: this.handleCheckBox, checked: s.otClaim, disabled: s.status != 0 }),
                                    _react2.default.createElement('span', { className: 'checkmark' }),
                                    'OT Claim'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'remark' },
                                'Remark'
                            ),
                            _react2.default.createElement('textarea', { className: 'form-control', id: 'remark', rows: '3',
                                placeholder: 'Type Remark Here', 'data-index': '42', value: s.remark, onChange: this.handleEdit,
                                disabled: s.status != 0 })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'userImage' },
                                'Staff Picture Upload'
                            ),
                            _react2.default.createElement('input', { type: 'file', id: 'userImage', onChange: this.handleUpload, disabled: s.status != 0 }),
                            _react2.default.createElement(
                                'p',
                                { className: 'help-block' },
                                'Picture Format (150x200). Accept .jpg, .jpeg, .png format'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ui-pre-w' },
                            _react2.default.createElement('img', { className: 'ui-pre', src: s.userImage, attribute: 'staff Picture Preview' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'startWork' },
                                'Start Work.'
                            ),
                            _react2.default.createElement('input', { type: 'time', className: 'form-control', id: 'startWork',
                                'data-index': '37', value: s.startWork, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'endWork' },
                                'End Work'
                            ),
                            _react2.default.createElement('input', { type: 'time', className: 'form-control', id: 'endWork',
                                'data-index': '38', value: s.endWork, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'startLunch' },
                                'Lunch Time Start'
                            ),
                            _react2.default.createElement('input', { type: 'time', className: 'form-control', id: 'startLunch',
                                'data-index': '39', value: s.startLunch, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'endLunch' },
                                'Lunch Time End'
                            ),
                            _react2.default.createElement('input', { type: 'time', className: 'form-control', id: 'endLunch',
                                'data-index': '40', value: s.endLunch, onChange: this.handleEdit, disabled: s.status != 0 })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'h4',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Residential Address'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'streetName' },
                                'STREET NAME'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'streetName',
                                placeholder: 'e.g. Thomson Road', 'data-index': '16', value: s.streetName, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'blkNo' },
                                'APT/BLK NO.'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'blkNo',
                                placeholder: 'e.g. Blk 184', 'data-index': '17', value: s.blkNo, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'unitNo' },
                                'UNIT NO.'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'unitNo',
                                placeholder: 'e.g. 10-113', 'data-index': '18', value: s.unitNo, onChange: this.handleEdit, disabled: s.status != 0 })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'postal' },
                                'POSTAL CODE'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'postal',
                                placeholder: 'e.g. 611001', 'data-index': '19', value: s.postal, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'homeTel' },
                                'Home Tel.'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'homeTel',
                                placeholder: 'Home Tel', 'data-index': '20', value: s.homeTel, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'handPhone' },
                                'HAND PHONE'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'handPhone',
                                placeholder: 'e.g. 9XXXXXXX', 'data-index': '21', value: s.handPhone, onChange: this.handleEdit, disabled: s.status != 0 })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'us-em-tt' },
                            'Emergency Contact'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'emgName' },
                                'NAME'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'emgName',
                                placeholder: 'Type name here', 'data-index': '22', value: s.emgName, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'emgContactNo' },
                                'CONTACT NO'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'emgContactNo',
                                placeholder: 'e.g. 9XXXXXXX', 'data-index': '23', value: s.emgContactNo, onChange: this.handleEdit, disabled: s.status != 0 })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'emgRelationship' },
                                'RELATIONSHIP'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'emgRelationship',
                                placeholder: 'e.g. brother', 'data-index': '24', value: s.emgRelationship, onChange: this.handleEdit, disabled: s.status != 0 })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'h4',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Company Issue'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'comHandphone' },
                                'HANDPHONE'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un', id: 'comHandphone',
                                placeholder: 'Number', 'data-index': '25', value: s.comHandphone ? s.comHandphone.number : "", onChange: this.handleEdit,
                                disabled: s.status != 0 }),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un',
                                placeholder: 'Model', 'data-index': '26', value: s.comHandphone ? s.comHandphone.model : "", onChange: this.handleEdit,
                                disabled: s.status != 0 }),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un',
                                placeholder: 'Serial', 'data-index': '27', value: s.comHandphone ? s.comHandphone.serial : "", onChange: this.handleEdit,
                                disabled: s.status != 0 })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'comLaptop' },
                                'LAPTOP'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un', id: 'comLaptop',
                                placeholder: 'Number', 'data-index': '28', value: s.comLaptop ? s.comLaptop.number : "", onChange: this.handleEdit,
                                disabled: s.status != 0 }),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un',
                                placeholder: 'Model', 'data-index': '29', value: s.comLaptop ? s.comLaptop.model : "", onChange: this.handleEdit,
                                disabled: s.status != 0 }),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un',
                                placeholder: 'Serial', 'data-index': '30', value: s.comLaptop ? s.comLaptop.serial : "", onChange: this.handleEdit,
                                disabled: s.status != 0 })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'comCabcard' },
                                'CAB CARD'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un', id: 'comCabcard',
                                placeholder: 'Number', 'data-index': '31', value: s.comCabcard ? s.comCabcard.number : "", onChange: this.handleEdit,
                                disabled: s.status != 0 }),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un',
                                placeholder: 'Model', 'data-index': '32', value: s.comCabcard ? s.comCabcard.model : "", onChange: this.handleEdit,
                                disabled: s.status != 0 }),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control us-un',
                                placeholder: 'Serial', 'data-index': '33', value: s.comCabcard ? s.comCabcard.serial : "", onChange: this.handleEdit,
                                disabled: s.status != 0 })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-warning us-cr',
                                'data-index': '0', onClick: this.handleClick },
                            'Update'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default us-cr',
                                'data-index': '2', onClick: this.handleClick },
                            'Cancel'
                        )
                    ),
                    _react2.default.createElement('div', { className: 'clear' })
                ),
                _react2.default.createElement(_userSetModal2.default, {
                    modalClose: this.state.modalClose,
                    shouldModalClose: this.shouldModalClose,
                    usMode: this.state.action }),
                _react2.default.createElement(_userSetModal4.default, {
                    modalClose: this.state.modalDelClose,
                    shouldModalClose: this.shouldDelModalClose,
                    callBack: this.removeUser
                }),
                modal
            );
            /*
            <div className="row">
                <h4><b>Permission</b></h4>
                <UserPermission permission={s.permission} permissionList={this.state.permissionList}/>
            </div>
              <button type="button" className="btn btn-danger us-cr"
                    data-index="1" onClick={this.handleClick}>Remove</button>
            */
        }
    }]);

    return UserEditForm;
}(_react2.default.Component);

UserEditForm.defaultProps = {
    roleTxt: ["Administrative Executive", "Property Executive", "Property Manager", "Human Resource Executive", "Contracts Management Executive", "Accounts Executive", "Accounts Manager", "Information Technology", "Managing Director", "Director", "Other", "Cleaner Supervisor", "Cleaner", "Landscaper", "Electrician", "Caretaker", "Portfolio Manager", "Team Manager", "Senior Admin Executive"],
    departmentTxt: ["Accounts", "HR", "Operations", "Management", "IT", "Admin", "A4FM"]
};
exports.default = UserEditForm;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userSetAction = __webpack_require__(15);

var _userSetAction2 = _interopRequireDefault(_userSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserSetModal2 = function (_React$Component) {
    _inherits(UserSetModal2, _React$Component);

    function UserSetModal2(props) {
        _classCallCheck(this, UserSetModal2);

        var _this = _possibleConstructorReturn(this, (UserSetModal2.__proto__ || Object.getPrototypeOf(UserSetModal2)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        return _this;
    }

    _createClass(UserSetModal2, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {}
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            this.props.callBack();
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'report-modal', style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            'Remove Employee Detail'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body' },
                        'Employee information will be removed permanently. Are you sure?'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default btn-danger', onClick: this.handleSubmit },
                            'Delete'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return UserSetModal2;
}(_react2.default.Component);

UserSetModal2.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = UserSetModal2;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _contractorAction = __webpack_require__(14);

var _contractorAction2 = _interopRequireDefault(_contractorAction);

var _contractorStore = __webpack_require__(29);

var _contractorStore2 = _interopRequireDefault(_contractorStore);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _contractorHeader = __webpack_require__(86);

var _contractorHeader2 = _interopRequireDefault(_contractorHeader);

var _contractorBody = __webpack_require__(233);

var _contractorBody2 = _interopRequireDefault(_contractorBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractorSetting = function (_React$Component) {
    _inherits(ContractorSetting, _React$Component);

    function ContractorSetting(props) {
        _classCallCheck(this, ContractorSetting);

        var _this = _possibleConstructorReturn(this, (ContractorSetting.__proto__ || Object.getPrototypeOf(ContractorSetting)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.state = {
            processingFilter: _filterStore2.default.getState().processing,
            staffs: _filterStore2.default.getState().staffs,
            iniLoadStaff: _filterStore2.default.getState().iniLoadStaff,

            condos: _contractorStore2.default.getState().condos,
            iniLoadCondo: _contractorStore2.default.getState().iniLoadCondo,
            contractors: _contractorStore2.default.getState().contractors,
            processing: _contractorStore2.default.getState().processing,
            updating: _contractorStore2.default.getState().updating,
            search: _contractorStore2.default.getState().search,
            staffId: _contractorStore2.default.getState().staffId,
            mcst: _contractorStore2.default.getState().mcst,
            isNew: _contractorStore2.default.getState().isNew,
            iniEmailReminder: _contractorStore2.default.getState().iniEmailReminder
        };
        return _this;
    }

    _createClass(ContractorSetting, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _menuAction2.default.pageNumber(11);
            _contractorStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);

            if (!this.state.iniLoadCondo && !this.state.processing) {
                _contractorAction2.default.processing(true);
                _contractorAction2.default.getCondoList();
            }
            if (!this.state.iniLoadStaff && !this.state.processingFilter) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getEmployee();
            }
            if (!this.state.iniEmailReminder) {
                _contractorAction2.default.processing(true);
                _contractorAction2.default.getReminder();
            }
            _contractorAction2.default.reset();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _contractorStore2.default.unlisten(this.onChange);
            _filterStore2.default.unlisten(this.onFilterChange);
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                processingFilter: state.processing,

                staffs: state.staffs,
                iniLoadStaff: state.iniLoadStaff
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                contractors: state.contractors,
                iniLoadCondo: state.iniLoadCondo,
                condos: state.condos,
                updating: state.updating,
                search: state.search,
                staffId: state.staffId,
                mcst: state.mcst,
                isNew: state.isNew,
                iniEmailReminder: state.iniEmailReminder
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var body = "",
                header = "";

            if (!this.state.updating) {

                body = _react2.default.createElement(_contractorBody2.default, { contractors: this.state.contractors });
                header = _react2.default.createElement(_contractorHeader2.default, _extends({ condos: this.state.condos, staffs: this.state.staffs, processing: this.state.processing }, this.props, { isSetting: true }));
            }

            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 us-form' },
                        header,
                        _react2.default.createElement('div', { className: 'divider' }),
                        body
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.processingFilter })
            );
        }
    }]);

    return ContractorSetting;
}(_react2.default.Component);

exports.default = ContractorSetting;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _contractorAction = __webpack_require__(14);

var _contractorAction2 = _interopRequireDefault(_contractorAction);

var _contractorStore = __webpack_require__(29);

var _contractorStore2 = _interopRequireDefault(_contractorStore);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

var _modalStaff = __webpack_require__(231);

var _modalStaff2 = _interopRequireDefault(_modalStaff);

var _reminderModal = __webpack_require__(232);

var _reminderModal2 = _interopRequireDefault(_reminderModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractorFilter = function (_React$Component) {
    _inherits(ContractorFilter, _React$Component);

    function ContractorFilter(props) {
        _classCallCheck(this, ContractorFilter);

        var _this = _possibleConstructorReturn(this, (ContractorFilter.__proto__ || Object.getPrototypeOf(ContractorFilter)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        _this.handleFilter = _this.handleFilter.bind(_this);
        _this.handleCondoChange = _this.handleCondoChange.bind(_this);
        _this.handleExpire = _this.handleExpire.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        //this.handleShowAll = this.handleShowAll.bind(this);
        _this.handleCreateContractor = _this.handleCreateContractor.bind(_this);
        _this.handleCreateCondo = _this.handleCreateCondo.bind(_this);
        _this.handleStaffChange = _this.handleStaffChange.bind(_this);
        _this.replaceStaff = _this.replaceStaff.bind(_this);
        _this.handleShowContractor = _this.handleShowContractor.bind(_this);
        _this.handleShowRecipient = _this.handleShowRecipient.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.shouldModalCloseReminder = _this.shouldModalCloseReminder.bind(_this);
        _this.state = {
            searchMode: _contractorStore2.default.getState().searchMode,
            search: _contractorStore2.default.getState().search,
            mcst: _contractorStore2.default.getState().mcst,
            staffId: _contractorStore2.default.getState().staffId,
            reminderEmail: _contractorStore2.default.getState().reminderEmail,
            warningMsg: _contractorStore2.default.getState().warningMsg,

            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId,

            modalClose: false,
            modalCloseReminder: false
        };
        return _this;
    }

    _createClass(ContractorFilter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _contractorStore2.default.listen(this.onChange);
            _userStore2.default.listen(this.onUserChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _contractorStore2.default.unlisten(this.onChange);
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                mcst: state.mcst,
                search: state.search,
                warningMsg: state.warningMsg,
                staffId: state.staffId,
                searchMode: state.searchMode,
                reminderEmail: state.reminderEmail
            });
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'handleSearch',
        value: function handleSearch(e) {
            var value = e.target.value;
            _contractorAction2.default.search(value);
            _contractorAction2.default.updating(false);

            _contractorAction2.default.warningMsg("");
            _contractorAction2.default.isNew(false);
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            if (e.key == 'Enter') {
                e.preventDefault();
                this.handleFilter();
            }
        }
    }, {
        key: 'handleCondoChange',
        value: function handleCondoChange(e) {
            var value = e.target.value;
            _contractorAction2.default.mcst(value);
        }
    }, {
        key: 'handleStaffChange',
        value: function handleStaffChange(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            var value = e.target.value;
            if (index == 4) {
                _contractorAction2.default.staffId(value);
            } else if (index == 5) {
                _contractorAction2.default.oldStaffId(value);
            } else {
                _contractorAction2.default.newStaffId(value);
            }
        }
    }, {
        key: 'handleShowRecipient',
        value: function handleShowRecipient() {
            this.setState({ modalCloseReminder: true });
        }
        /*
        handleShowAll() {
          
           if (this.props.processing) return;
             contractorAction.processing(true);
           contractorAction.getAllContractor();
           contractorAction.searchMode(1);
             contractorAction.updating(false);
           contractorAction.warningMsg("");
           contractorAction.isNew(false);
           
        }
        */

    }, {
        key: 'handleShowContractor',
        value: function handleShowContractor() {
            if (this.props.processing) return;

            _contractorAction2.default.processing(true);
            _contractorAction2.default.listClear();
            _contractorAction2.default.getContractorByFilter(this.state.mcst, this.state.staffId);
            _contractorAction2.default.searchMode(3);
            //clear service
            _contractorAction2.default.search("");

            _contractorAction2.default.updating(false);
            _contractorAction2.default.warningMsg("");
            _contractorAction2.default.isNew(false);
        }
    }, {
        key: 'handleFilter',
        value: function handleFilter(e) {
            if (this.props.processing) return;
            if (this.state.search == "") return _contractorAction2.default.warningMsg("Empty Input");
            _contractorAction2.default.processing(true);
            _contractorAction2.default.listClear();
            _contractorAction2.default.getContractorByService(this.state.search);
            _contractorAction2.default.searchMode(0);
            //clear staffId and mcst
            _contractorAction2.default.staffId("");
            _contractorAction2.default.mcst("");

            _contractorAction2.default.updating(false);
            _contractorAction2.default.warningMsg("");
            _contractorAction2.default.isNew(false);
        }
    }, {
        key: 'handleExpire',
        value: function handleExpire() {
            if (this.props.processing) return;

            _contractorAction2.default.processing(true);
            _contractorAction2.default.listClear();
            _contractorAction2.default.getExpireContractor(this.state.mcst, this.state.staffId);
            _contractorAction2.default.searchMode(2);
            //clear service
            _contractorAction2.default.search("");

            _contractorAction2.default.updating(false);
            _contractorAction2.default.warningMsg("");
            _contractorAction2.default.isNew(false);
        }
    }, {
        key: 'handleExportCheckList',
        value: function handleExportCheckList() {
            _contractorAction2.default.processing(true);
            _contractorAction2.default.exportCondoCheckList();
        }
    }, {
        key: 'handleCreateContractor',
        value: function handleCreateContractor() {
            this.props.history.push('/newContractor');
        }
    }, {
        key: 'handleCreateCondo',
        value: function handleCreateCondo() {
            this.props.history.push('/newCondo');
        }
    }, {
        key: 'replaceStaff',
        value: function replaceStaff() {
            this.setState({ modalClose: true });
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({
                modalClose: data
            });
        }
    }, {
        key: 'shouldModalCloseReminder',
        value: function shouldModalCloseReminder(data) {
            this.setState({
                modalCloseReminder: data
            });
        }
    }, {
        key: 'renderStaffs',
        value: function renderStaffs() {
            return this.props.staffs.map(function (staff, index) {
                return _react2.default.createElement(
                    'option',
                    { value: staff.staffId, key: index },
                    staff.userName
                );
            });
        }
    }, {
        key: 'renderCondos',
        value: function renderCondos() {
            return this.props.condos.map(function (condo, index) {
                return _react2.default.createElement(
                    'option',
                    { value: condo.mcst, key: index },
                    condo.condoName
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var newContractor = "";
            var modal = '';
            if (this.state.modalCloseReminder) {
                modal = _react2.default.createElement(_reminderModal2.default, {
                    modalClose: this.state.modalCloseReminder,
                    shouldModalClose: this.shouldModalCloseReminder,
                    reminderEmail: this.state.reminderEmail,
                    processing: this.state.processing,
                    staffs: this.props.staffs,
                    title: 'Add Recipient'
                });
            }

            if (this.props.isSetting && _genFunction2.default.hasPermission(this.state.permission, 6)) {
                /*
                        <div className="atd-i-btn">
                            <button className="btn btn-default btn-sm" onClick={this.handleShowAll}>Show All Contractors/Condos</button>
                        </div>
                */
                newContractor = _react2.default.createElement(
                    'div',
                    { className: 'col-sm-8' },
                    _react2.default.createElement(
                        'div',
                        { className: 'atd-i-btn' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-info btn-sm', onClick: this.handleCreateContractor },
                            'Add New Contractor'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'atd-i-btn' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-info btn-sm', onClick: this.handleCreateCondo },
                            'Add New Condo'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'atd-i-btn' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-info btn-sm', onClick: this.replaceStaff },
                            'Replace Staff'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'atd-i-btn' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-info btn-sm', onClick: this.handleShowRecipient },
                            'Add Recipient'
                        )
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'warning' },
                    this.state.warningMsg
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'report-i-1 row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4 col-lg-4' },
                        _react2.default.createElement(
                            'form',
                            { className: 'form-horizontal atd-i-wp' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'contractorName', className: 'col-xs-6 col-md-6 col-lg-5 control-label' },
                                'Contractor Service: '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group input-group-sm' },
                                _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'contractorName', placeholder: 'Search By Services',
                                    value: this.state.search, onChange: this.handleSearch, onKeyPress: this.handleKeyPress }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'input-group-btn' },
                                    _react2.default.createElement(
                                        'button',
                                        { className: 'btn btn-default', type: 'button', onClick: this.handleFilter },
                                        'Filter'
                                    )
                                )
                            )
                        )
                    ),
                    newContractor
                ),
                _react2.default.createElement(
                    'div',
                    { className: ' row' },
                    _react2.default.createElement(
                        'h5',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Filter Contractor By:'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4 col-lg-4' },
                        _react2.default.createElement(
                            'form',
                            { className: 'form-horizontal atd-i-wp' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'staff', className: 'col-xs-6 col-md-6 col-lg-5 control-label' },
                                'Staff: '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group input-group-sm' },
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control atd-sel', name: 'staff', 'data-index': '4', onChange: this.handleStaffChange, value: this.state.staffId },
                                    _react2.default.createElement(
                                        'option',
                                        { value: '' },
                                        'Any Staff'
                                    ),
                                    this.renderStaffs()
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'form',
                            { className: 'form-horizontal atd-i-wp' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'condoName', className: 'col-xs-6 col-md-6 col-lg-5 control-label' },
                                'Estate: '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group input-group-sm' },
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control atd-sel', name: 'condoName', 'data-index': '3', onChange: this.handleCondoChange, value: this.state.mcst },
                                    _react2.default.createElement(
                                        'option',
                                        { value: '' },
                                        'Any Condo'
                                    ),
                                    this.renderCondos()
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-8 col-lg-8' },
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-i-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-default btn-sm', onClick: this.handleShowContractor },
                                'Show Contractors/Condos'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-i-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-default btn-sm', onClick: this.handleExpire },
                                'Contracts Expiring/Expired'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-i-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-default btn-sm', onClick: this.handleExportCheckList },
                                'Export Condo CheckList'
                            )
                        )
                    )
                ),
                _react2.default.createElement(_modalStaff2.default, { processing: this.props.processing, modalClose: this.state.modalClose,
                    shouldModalClose: this.shouldModalClose, staffs: this.props.staffs
                }),
                modal
            );
        }
    }]);

    return ContractorFilter;
}(_react2.default.Component);

exports.default = ContractorFilter;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _contractorAction = __webpack_require__(14);

var _contractorAction2 = _interopRequireDefault(_contractorAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalStaff = function (_React$Component) {
    _inherits(ModalStaff, _React$Component);

    function ModalStaff(props) {
        _classCallCheck(this, ModalStaff);

        var _this = _possibleConstructorReturn(this, (ModalStaff.__proto__ || Object.getPrototypeOf(ModalStaff)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.state = {
            oldStaffId: "",
            newStaffId: "",
            warningMsg: ""
        };
        return _this;
    }

    _createClass(ModalStaff, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'handleClick',
        value: function handleClick(e) {

            if (this.props.processing) return;
            if (this.state.newStaffId == "" || this.state.oldStaffId == "") return this.setState({ warningMsg: "Staff cannot be emptied" });

            _contractorAction2.default.processing(true);
            _contractorAction2.default.replaceStaff(this.state.oldStaffId, this.state.newStaffId);
            this.modalClose();
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'handleEdit',
        value: function handleEdit(e) {

            var index = parseInt(e.target.getAttribute('data-index'));
            var value = e.target.value;
            if (index == 0) {
                this.setState({ oldStaffId: value });
            } else {
                this.setState({ newStaffId: value });
            }
        }
    }, {
        key: 'renderStaffs',
        value: function renderStaffs() {
            return this.props.staffs.map(function (staff, index) {
                return _react2.default.createElement(
                    'option',
                    { value: staff.staffId, key: index },
                    staff.userName
                );
            });
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            var body = "";

            body = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'form',
                    { className: 'form-horizontal atd-i-wp' },
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'oldStaff', className: 'col-xs-4 control-label' },
                        'From: '
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'input-group input-group-sm' },
                        _react2.default.createElement(
                            'select',
                            { className: 'form-control atd-sel', name: 'oldStaff', 'data-index': '0', onChange: this.handleEdit, value: this.state.oldStaffId },
                            _react2.default.createElement('option', { value: '' }),
                            this.renderStaffs()
                        )
                    )
                ),
                _react2.default.createElement(
                    'form',
                    { className: 'form-horizontal atd-i-wp' },
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'newStaff', className: 'col-xs-4  control-label' },
                        'Replace To: '
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'input-group input-group-sm' },
                        _react2.default.createElement(
                            'select',
                            { className: 'form-control atd-sel', name: 'newStaff', 'data-index': '1', onChange: this.handleEdit, value: this.state.newStaffId },
                            _react2.default.createElement('option', { value: '' }),
                            this.renderStaffs()
                        )
                    )
                )
            );

            return body;
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'report-modal', style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            'Replace Employee Duty'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body' },
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        ),
                        this.renderContent()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-warning', onClick: this.handleClick },
                            'Replace'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return ModalStaff;
}(_react2.default.Component);

ModalStaff.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = ModalStaff;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _contractorAction = __webpack_require__(14);

var _contractorAction2 = _interopRequireDefault(_contractorAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReminderModal = function (_React$Component) {
    _inherits(ReminderModal, _React$Component);

    function ReminderModal(props) {
        _classCallCheck(this, ReminderModal);

        var _this = _possibleConstructorReturn(this, (ReminderModal.__proto__ || Object.getPrototypeOf(ReminderModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleCheck = _this.handleCheck.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.state = {
            reminderEmail: [],
            warningMsg: "",
            staffId: "",
            clientHeight: 200
        };
        return _this;
    }

    _createClass(ReminderModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var clientHeight = _reactDom2.default.findDOMNode(this.refs.modal).clientHeight;
            this.setState({
                reminderEmail: this.props.reminderEmail,
                clientHeight: clientHeight
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            this.setState({
                staffId: e.target.value
            });
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(e) {
            e.preventDefault();
            e.stopPropagation();

            if (e.deltaY > 0) {
                //scroll down
                _reactDom2.default.findDOMNode(this.refs.staffList).scrollTop += 50;
            } else {
                //scroll up
                _reactDom2.default.findDOMNode(this.refs.staffList).scrollTop -= 50;
            }
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            if (this.props.processing) return;

            _contractorAction2.default.processing(true);
            //update
            _contractorAction2.default.updateReminder(this.state.reminderEmail);
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'handleCheck',
        value: function handleCheck(e) {
            var checked = e.target.checked;
            var staffId = e.target.value;
            var userName = e.target.getAttribute('data-username');

            var reminderEmail = this.state.reminderEmail;
            if (checked) {
                reminderEmail.push({
                    staffId: staffId,
                    userName: userName
                });
            } else {
                //remove from list
                var len = reminderEmail.length;
                for (var i = 0; i < len; i++) {
                    if (reminderEmail[i].staffId == staffId) {
                        reminderEmail.splice(i, 1);
                        break;
                    }
                }
            }
            this.setState({
                reminderEmail: reminderEmail
            });
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'checkStaff',
        value: function checkStaff(staff) {
            var isCheck = false;
            var len = this.state.reminderEmail.length;
            for (var i = 0; i < len; i++) {
                if (this.state.reminderEmail[i].staffId == staff.staffId) {
                    isCheck = true;
                    break;
                }
            }
            return isCheck;
        }
    }, {
        key: 'renderDetail',
        value: function renderDetail(staff, index) {
            //check if this facility is included;
            var isCheck = this.checkStaff(staff);

            return _react2.default.createElement(
                'li',
                { className: 'pm-li-1', key: index },
                _react2.default.createElement(
                    'div',
                    { className: 'checkbox' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', { type: 'checkbox', value: staff.staffId, 'data-username': staff.userName, onChange: this.handleCheck, checked: isCheck }),
                        _react2.default.createElement('span', { className: 'checkmark' }),
                        staff.userName
                    )
                )
            );
        }
    }, {
        key: 'renderList',
        value: function renderList(staffs) {
            var _this2 = this;

            return staffs.map(function (staff, index) {
                return _this2.renderDetail(staff, index);
            });
        }
    }, {
        key: 'renderStaff',
        value: function renderStaff() {
            var _this3 = this;

            if (this.props.staffs.length > 0) {
                var staffs = this.props.staffs.filter(function (staff) {
                    return staff.userName.toLowerCase().indexOf(_this3.state.staffId.toLowerCase()) > -1 || staff.staffId.toLowerCase().indexOf(_this3.state.staffId.toLowerCase()) > -1;
                });

                return this.renderList(staffs);
            }
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'staffFilter' },
                            'Staff:'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'staffFilter', placeholder: 'Search By name or ID', onChange: this.handleChange })
                    )
                ),
                _react2.default.createElement('div', { className: 'divider' }),
                _react2.default.createElement(
                    'ul',
                    { className: 'pm-ul', ref: 'staffList',
                        style: { height: this.state.clientHeight - 200 + "px", overflow: "auto" }, onWheel: this.handleScroll },
                    this.renderStaff()
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'permission-modal', style: { visibility: style.visibility }, ref: 'modal' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            this.props.title
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body', style: { height: this.state.clientHeight - 115 + "px" } },
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        ),
                        this.renderContent()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-warning', onClick: this.handleClick },
                            'Done'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return ReminderModal;
}(_react2.default.Component);

ReminderModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = ReminderModal;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(1);

var _contractorList = __webpack_require__(234);

var _contractorList2 = _interopRequireDefault(_contractorList);

var _contractorAction = __webpack_require__(14);

var _contractorAction2 = _interopRequireDefault(_contractorAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractorBody = function (_React$Component) {
    _inherits(ContractorBody, _React$Component);

    function ContractorBody(props) {
        _classCallCheck(this, ContractorBody);

        var _this = _possibleConstructorReturn(this, (ContractorBody.__proto__ || Object.getPrototypeOf(ContractorBody)).call(this, props));

        _this.onTouchStart = _this.onTouchStart.bind(_this);
        _this.onTouchMove = _this.onTouchMove.bind(_this);
        _this.onTouchEnd = _this.onTouchEnd.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleMouseScroll = _this.handleMouseScroll.bind(_this);
        _this.state = {
            tableWidth: 300,
            dragging: false,
            refX: 0,
            ini: 0,
            page: 0,
            contentNo: 10
        };
        return _this;
    }

    _createClass(ContractorBody, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var tableWidth = _reactDom2.default.findDOMNode(this.refs.ctr).clientWidth;
            this.setState({
                tableWidth: tableWidth
            });
            if (document.body.clientWidth > 768) {
                var elem = _reactDom2.default.findDOMNode(this.refs.table);
                elem.addEventListener('mouseup', this.onTouchEnd);
                elem.addEventListener('mouseleave', this.onTouchEnd);
                elem.addEventListener('mousemove', this.onTouchMove);
                elem.addEventListener('mousedown', this.onTouchStart);
                window.addEventListener('wheel', this.handleMouseScroll);
            }
            window.addEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (document.body.clientWidth > 768) {
                var elem = _reactDom2.default.findDOMNode(this.refs.table);
                elem.removeEventListener('mouseup', this.onTouchEnd);
                elem.removeEventListener('mouseleave', this.onTouchEnd);
                elem.removeEventListener('mousemove', this.onTouchMove);
                elem.removeEventListener('mousedown', this.onTouchStart);
                window.removeEventListener('wheel', this.handleMouseScroll);
            }
            window.removeEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevProps.contractors != this.props.contractors) {
                this.setState({
                    page: 0
                });
            }
        }
    }, {
        key: 'handleMouseScroll',
        value: function handleMouseScroll(e) {

            e.preventDefault();

            if (e.deltaY > 0) {
                //scroll down
                window.scrollBy(0, 50);
            } else {
                //scroll up
                window.scrollBy(0, -50);
            }
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(e) {
            var elem1 = _reactDom2.default.findDOMNode(this.refs.ctr);
            var elem2 = _reactDom2.default.findDOMNode(this.refs.table);
            if (elem2.getBoundingClientRect().top < 50) {

                elem1.style.position = "absolute";

                if (document.body.clientWidth > 768) {
                    elem2.style.paddingTop = "50px";
                    elem1.style.top = 50 - elem2.getBoundingClientRect().top + "px";
                } else {
                    elem2.style.paddingTop = "0px";
                    elem1.style.top = -elem2.getBoundingClientRect().top + "px";
                }
            } else {
                elem1.style.position = "relative";
                elem1.style.top = "0px";
                elem2.style.paddingTop = "0px";
            }
        }
    }, {
        key: 'onTouchStart',
        value: function onTouchStart(e) {
            if (!this.state.dragging) {
                var touches = e.changedTouches;
                var refX = void 0;
                if (e.touches) {
                    refX = e.touches[0].clientX;
                } else {
                    refX = e.clientX;
                }
                var ini = _reactDom2.default.findDOMNode(this.refs.table).scrollLeft;
                this.setState({
                    ini: ini,
                    refX: refX,
                    dragging: true
                });
            } else {
                this.setState({
                    dragging: false
                });
            }
        }
    }, {
        key: 'onTouchMove',
        value: function onTouchMove(e) {
            e.preventDefault();
            if (this.state.dragging && e.target) {
                var deltaX = void 0;
                if (e.touches) {
                    deltaX = parseInt(this.state.refX - e.touches[0].clientX);
                } else {
                    deltaX = parseInt(this.state.refX - e.clientX);
                }

                _reactDom2.default.findDOMNode(this.refs.table).scrollLeft = this.state.ini + deltaX;
            } else {
                this.setState({
                    dragging: false
                });
            }
        }
    }, {
        key: 'onTouchEnd',
        value: function onTouchEnd(e) {
            this.setState({
                dragging: false
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.currentTarget.getAttribute('data-index'));

            if (index != this.state.page) {
                this.setState({ page: index });
            }
        }
    }, {
        key: 'renderPagination',
        value: function renderPagination() {
            if (!this.props.contractors) return;
            if (this.props.contractors.length == 0) return;

            var pageNo = Math.ceil(this.props.contractors.length / this.state.contentNo);

            var pagination = [];
            for (var i = 0; i < pageNo; i++) {
                pagination = pagination.concat(_react2.default.createElement(
                    'li',
                    { className: this.state.page == i ? "active" : "", key: i, 'data-index': i, onClick: this.handleClick },
                    _react2.default.createElement(
                        'a',
                        { href: '#' },
                        i + 1
                    )
                ));
            }
            return _react2.default.createElement(
                'nav',
                { className: 'ctr-pg' },
                _react2.default.createElement(
                    'ul',
                    { className: 'pagination' },
                    pagination
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'pagination-title' },
                    'page ',
                    this.state.page + 1 + " of " + pageNo
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var contractors = [];
            for (var i = 0 + this.state.contentNo * this.state.page; i < this.state.contentNo + this.state.contentNo * this.state.page; i++) {
                if (i < this.props.contractors.length) {
                    contractors = contractors.concat(this.props.contractors[i]);
                }
            }

            return _react2.default.createElement(
                'div',
                null,
                this.renderPagination(),
                _react2.default.createElement(
                    'div',
                    { className: 'est-bd-wp', ref: 'table' },
                    _react2.default.createElement(
                        'div',
                        { className: 'ctr-bd' },
                        _react2.default.createElement(
                            'table',
                            { className: 'ctr-tb tb-heading', ref: 'ctr' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'MCST'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Estate'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'No of Units'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Address'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'ManageBy'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Manager'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Contractor'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Service'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Description'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Last Visit'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Contractor Address'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Contact Name'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Telephone'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Fax'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Contractor Email'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Status'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Contract Start Date'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Contract End Date'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'First Reminder'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Second Reminder'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Contract Due In (days)'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Amount'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Remark'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(_contractorList2.default, { contractors: contractors, tableWidth: this.state.tableWidth,
                            page: this.state.page, contentNo: this.state.contentNo })
                    )
                ),
                this.renderPagination()
            );
        }
    }]);

    return ContractorBody;
}(_react2.default.Component);

ContractorBody.defaultProps = {
    monthTxt: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]
};
exports.default = ContractorBody;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _contractorAction = __webpack_require__(14);

var _contractorAction2 = _interopRequireDefault(_contractorAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractorList = function (_React$Component) {
    _inherits(ContractorList, _React$Component);

    function ContractorList(props) {
        _classCallCheck(this, ContractorList);

        var _this = _possibleConstructorReturn(this, (ContractorList.__proto__ || Object.getPrototypeOf(ContractorList)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(ContractorList, [{
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.currentTarget.getAttribute("data-index"));
            index = index + this.props.page * this.props.contentNo;
            _contractorAction2.default.shouldConListShow(index);
        }
    }, {
        key: 'renderPE',
        value: function renderPE(manageBy) {
            if (!manageBy) return;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'b',
                    null,
                    manageBy.userName
                ),
                _react2.default.createElement('br', null),
                '(',
                this.props.roleTxt[manageBy.role],
                ')',
                _react2.default.createElement('br', null),
                manageBy.email,
                _react2.default.createElement('br', null),
                manageBy.handPhone
            );
        }
    }, {
        key: 'renderAddress',
        value: function renderAddress(streetName, blkNo, unitNo, postal) {
            return _react2.default.createElement(
                'div',
                null,
                streetName ? streetName + " , \n" : "",
                blkNo ? "#" + blkNo + "-" : "",
                unitNo ? unitNo + ", \n" : "",
                postal
            );
        }
    }, {
        key: 'generateDateFormat',
        value: function generateDateFormat(date) {
            if (date) {
                return date.getDate() + "-" + this.props.mthTxt[date.getMonth()] + "-" + date.getFullYear();
            }
        }
        /*
        <th>MCST</th>
        <th>ESTATE</th>
        <th>ManageBy</th>
        <th>Contractor</th>
        <th>contractor Email</th>
        <th>contact Name</th>
        <th>fax</th>
        <th>addresses</th>
        <th>status</th>
        <th>service</th>
        <th>description</th>
        <th>remark</th>
        <th>Contract Start Date</th>
        <th>Contract End Date</th>
        <th>Amount</th>
        <th>First Reminder</th>
        <th>Second Reminder</th>
        */

    }, {
        key: 'renderDataList',
        value: function renderDataList(condo, contractor, service, index, index1, index2) {
            var contractStartDate = service.contractStartDate ? this.generateDateFormat(new Date(service.contractStartDate)) : "";
            var contractEndDate = service.contractEndDate ? this.generateDateFormat(new Date(service.contractEndDate)) : "";
            var firstReminder = service.firstReminder ? this.generateDateFormat(new Date(service.firstReminder)) : "";
            var secReminder = service.secondReminder ? this.generateDateFormat(new Date(service.secondReminder)) : "";
            var lastVisit = service.lastVisit ? this.generateDateFormat(new Date(service.lastVisit)) : "";
            var dueDays = 0;
            if (service.contractEndDate) {
                dueDays = Math.ceil((new Date(service.contractEndDate).getTime() - new Date().getTime()) / 1000 / 3600 / 24);
            }

            return _react2.default.createElement(
                'tr',
                { key: index2 },
                _react2.default.createElement(
                    'td',
                    null,
                    condo.mcst
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/condoSet/' + condo.mcst },
                        condo.condoName
                    )
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    condo.noUnit
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    condo.address,
                    ', ',
                    condo.postal
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.renderPE(condo.manageBy)
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.renderPE(condo.supervisor)
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/contractorSet/' + contractor._id },
                        contractor.contractorName
                    )
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    service.service
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    service.description
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    lastVisit ? lastVisit : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.renderAddress(contractor.streetName, contractor.blkNo, contractor.unitNo, contractor.postal)
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    contractor.contactName ? contractor.contactName : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    contractor.telephone ? contractor.telephone : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    contractor.fax ? contractor.fax : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    contractor.contractorEmail
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    typeof service.status == 'number' ? this.props.statusTxt[service.status] : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    contractStartDate
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    contractEndDate
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    firstReminder ? firstReminder : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    secReminder ? secReminder : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    dueDays ? dueDays : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    service.amount ? "$" + service.amount : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    service.remark ? service.remark : "--"
                )
            );
        }
        /*
            _id: "123",
            mcst: 1234,
            condoName: "Condo A",
            manageBy: [
                { staffId: "A0001", userName: "Ho Kok Liang", role: 0, email: "HKL@gmail.com" }, 
                { staffId: "A0002", userName: "Tan Kai Lee", role: 1, email: "TKL@gmail.com" }
            ],
            contractors: [
                {
                    _id: "A124",
                    contractorName: "E&T Cleaning Services Pte Ltd",
                    contractorEmail: "crankpwr@singnet.com.sg",
                    telephone: 91112222,
                    contactName: "",
                    fax: "",
                    addresses: [
                        { address: "Blk 446 Hougang Ave 8", unitNo: "B1-1635", postal: "530446" }
                    ],
                    status: 0,
                    contract: [
                        { 
                            service: "Cleaning", description: "Cleaning", remark: "",
                            contractStartDate: new Date("2016-11-15"),contractEndDate: new Date("2017-11-14"), 
                            amount: 2400, firstReminder: new Date("2017-11-14"), secondReminder: new Date("2017-11-28") 
                        },
                        { 
                            service: "Electric", description: "Electric", remark: "",
                            contractStartDate: new Date("2016-11-15"),contractEndDate: new Date("2017-11-14"), 
                            amount: 400 , firstReminder: new Date("2017-11-14"), secondReminder: new Date("2017-11-28")
                        }
                    ]
                }
                */

    }, {
        key: 'renderContractorList',
        value: function renderContractorList(condo, contractor, index, index1) {
            var _this2 = this;

            if (!contractor.contract) {
                return this.renderDataList(condo, contractor, "", index, index1, -1);
            } else {
                return contractor.contract.map(function (service, index2) {
                    return _this2.renderDataList(condo, contractor, service, index, index1, index2);
                });
            }
        }
    }, {
        key: 'renderDataLists',
        value: function renderDataLists(condo, index) {
            var _this3 = this;

            var body = void 0;
            if (!condo.contractors || condo.contractors.length == 0) {
                body = this.renderContractorList(condo, [], index, -1);
            } else {
                body = condo.contractors.map(function (contractor, index1) {
                    return _this3.renderContractorList(condo, contractor, index, index1);
                });
            }

            return _react2.default.createElement(
                'table',
                { className: "ctr-tb " + (condo.shouldListShow ? "est-show" : "est-hide") },
                _react2.default.createElement(
                    'tbody',
                    { className: 'ctr-tbd' },
                    body
                )
            );
        }
    }, {
        key: 'renderNameList',
        value: function renderNameList(condo, index) {
            return _react2.default.createElement(
                'div',
                { className: 'est-a-nlw', style: { width: this.props.tableWidth + "px" } },
                _react2.default.createElement('i', { className: "est-a-nli " + (condo.shouldListShow ? "glyphicon glyphicon-minus" : "glyphicon glyphicon-plus"),
                    onClick: this.handleClick, 'data-index': index }),
                _react2.default.createElement(
                    'div',
                    { className: 'est-a-nl est-a-n', onClick: this.handleClick, 'data-index': index },
                    condo.condoName,
                    ' (',
                    condo.mcst,
                    ')'
                )
            );
        }
    }, {
        key: 'renderMainList',
        value: function renderMainList() {
            var _this4 = this;

            return this.props.contractors.map(function (condo, index) {
                return _react2.default.createElement(
                    'div',
                    { key: index },
                    _this4.renderNameList(condo, index),
                    _this4.renderDataLists(condo, index)
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-abd-wp' },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-em-lt' },
                    this.renderMainList()
                )
            );
        }
    }]);

    return ContractorList;
}(_react2.default.Component);

ContractorList.defaultProps = {
    mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    statusTxt: ["Active", "In-Active", "Terminated", "Ad hoc"],
    roleTxt: ["Administrative Executive", "Property Executive", "Property Manager", "Human Resource Executive", "Contracts Management Executive", "Accounts Executive", "Accounts Manager", "Information Technology", "Managing Director", "Director", "Other", "Cleaner Supervisor", "Cleaner", "Landscaper", "Electrician", "Caretaker", "Portfolio Manager", "Team Manager", "Senior Admin Executive"]
};
exports.default = ContractorList;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _leaveSetForm = __webpack_require__(236);

var _leaveSetForm2 = _interopRequireDefault(_leaveSetForm);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _leaveSetAction = __webpack_require__(22);

var _leaveSetAction2 = _interopRequireDefault(_leaveSetAction);

var _leaveSetStore = __webpack_require__(46);

var _leaveSetStore2 = _interopRequireDefault(_leaveSetStore);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _leaveSetBody = __webpack_require__(238);

var _leaveSetBody2 = _interopRequireDefault(_leaveSetBody);

var _leaveSetHeader = __webpack_require__(240);

var _leaveSetHeader2 = _interopRequireDefault(_leaveSetHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveSetting = function (_React$Component) {
    _inherits(LeaveSetting, _React$Component);

    function LeaveSetting(props) {
        _classCallCheck(this, LeaveSetting);

        var _this = _possibleConstructorReturn(this, (LeaveSetting.__proto__ || Object.getPrototypeOf(LeaveSetting)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.state = {
            staffs: _filterStore2.default.getState().staffs,
            processingFilter: _filterStore2.default.getState().processing,
            iniLoadStaff: _filterStore2.default.getState().iniLoadStaff,
            processing: _leaveSetStore2.default.getState().processing,
            search: _leaveSetStore2.default.getState().search,
            staffId: _leaveSetStore2.default.getState().staffId,
            updating: _leaveSetStore2.default.getState().updating,
            userName: _leaveSetStore2.default.getState().userName,
            modalClose: false
        };
        return _this;
    }

    _createClass(LeaveSetting, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _leaveSetStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);
            _menuAction2.default.pageNumber(13);
            if (!this.state.processingFilter && !this.state.iniLoadStaff) {
                _filterAction2.default.processing.defer(true);
                _filterAction2.default.getEmployee.defer();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _leaveSetStore2.default.unlisten(this.onChange);
            _filterStore2.default.unlisten(this.onFilterChange);
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({ modalClose: data });
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                staffs: state.staffs,
                processingFilter: state.processing,
                iniLoadStaff: state.iniLoadStaff
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                search: state.search,
                staffId: state.staffId,
                updating: state.updating,
                userName: state.userName
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var body = '';

            if (this.state.updating) {
                body = _react2.default.createElement(_leaveSetForm2.default, { staffId: this.state.staffId, userName: this.state.userName, processing: this.state.processing });
            } else {
                var staffs = void 0;
                if (this.state.staffs.length > 0) {
                    staffs = this.state.staffs.filter(function (staff) {
                        return staff.userName.toLowerCase().indexOf(_this2.state.search.toLowerCase()) > -1 || staff.staffId.toLowerCase().indexOf(_this2.state.search.toLowerCase()) > -1;
                    });
                }

                body = _react2.default.createElement(_leaveSetBody2.default, { staffs: staffs });
            }

            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 us-form' },
                        _react2.default.createElement(_leaveSetHeader2.default, { staffs: this.state.staffs, processing: this.state.processing }),
                        _react2.default.createElement('div', { className: 'divider' }),
                        body
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.processingFilter })
            );
        }
    }]);

    return LeaveSetting;
}(_react2.default.Component);

exports.default = LeaveSetting;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _leaveSetAction = __webpack_require__(22);

var _leaveSetAction2 = _interopRequireDefault(_leaveSetAction);

var _leaveSetStore = __webpack_require__(46);

var _leaveSetStore2 = _interopRequireDefault(_leaveSetStore);

var _leaveSetModal = __webpack_require__(237);

var _leaveSetModal2 = _interopRequireDefault(_leaveSetModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveSetForm = function (_React$Component) {
    _inherits(LeaveSetForm, _React$Component);

    function LeaveSetForm(props) {
        _classCallCheck(this, LeaveSetForm);

        var _this = _possibleConstructorReturn(this, (LeaveSetForm.__proto__ || Object.getPrototypeOf(LeaveSetForm)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.handleEditUsed = _this.handleEditUsed.bind(_this);
        _this.handleBringFwd = _this.handleBringFwd.bind(_this);
        _this.handleMaxBringFwd = _this.handleMaxBringFwd.bind(_this);
        _this.handleLeaveGain = _this.handleLeaveGain.bind(_this);
        _this.removeType = _this.removeType.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.state = {
            leaves: _leaveSetStore2.default.getState().leaves,
            processing: _leaveSetStore2.default.getState().processing,
            maxBringFwd: _leaveSetStore2.default.getState().maxBringFwd,
            action: "",
            type: "",
            modalClose: false
        };
        return _this;
    }

    _createClass(LeaveSetForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _leaveSetStore2.default.listen(this.onChange);
            if (!this.state.processing) {
                _leaveSetAction2.default.processing(true);
                _leaveSetAction2.default.getLeaveTotal(this.props.staffId);
                _leaveSetAction2.default.getMaxBringFwd();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _leaveSetStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                leaves: state.leaves,
                processing: state.processing,
                maxBringFwd: state.maxBringFwd
            });
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({ modalClose: data });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            if (index == 1) {
                return _leaveSetAction2.default.updating(false);
            } else if (index == 2) {
                return this.setState({
                    modalClose: true,
                    action: 1
                });
            }
            if (this.state.processing) return;

            _leaveSetAction2.default.processing(true);
            _leaveSetAction2.default.updateLeaveTotal(this.props.staffId, this.state.leaves, this.state.maxBringFwd);
        }
    }, {
        key: 'handleEdit',
        value: function handleEdit(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            var value = parseFloat(e.target.value);
            _leaveSetAction2.default.totalGain({ type: index, value: value });
        }
    }, {
        key: 'handleEditUsed',
        value: function handleEditUsed(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            var value = parseFloat(e.target.value);
            _leaveSetAction2.default.used({ type: index, value: value });
        }
    }, {
        key: 'handleBringFwd',
        value: function handleBringFwd(e) {
            var value = parseFloat(e.target.value);
            _leaveSetAction2.default.bringFwd({ type: 0, value: value });
        }
    }, {
        key: 'handleMaxBringFwd',
        value: function handleMaxBringFwd(e) {
            var value = parseFloat(e.target.value);
            _leaveSetAction2.default.maxBringFwd(value);
        }
    }, {
        key: 'handleLeaveGain',
        value: function handleLeaveGain(e) {
            var value = parseFloat(e.target.value);
            _leaveSetAction2.default.leaveGain({ type: 0, value: value });
        }
    }, {
        key: 'removeType',
        value: function removeType(e) {
            var type = parseInt(e.currentTarget.getAttribute('data-type'));
            this.setState({
                action: 0,
                type: type,
                modalClose: true
            });
        }
    }, {
        key: 'renderInput',
        value: function renderInput() {
            var _this2 = this;

            var inputTxt = '',
                bringFwd = void 0,
                leaveGain = void 0;
            inputTxt = this.state.leaves.sort(function (a, b) {
                return a.type - b.type;
            }).map(function (leave, index) {
                if (leave.type == 0) {
                    bringFwd = _react2.default.createElement('input', { type: 'number', className: 'form-control', id: 'ls-fwd', key: index,
                        'data-index': leave.type, value: leave.bringFwd, onChange: _this2.handleBringFwd });

                    leaveGain = _react2.default.createElement('input', { type: 'number', className: 'form-control', id: 'ls-lg', key: index,
                        'data-index': leave.type, value: leave.leaveGain, onChange: _this2.handleLeaveGain });
                }
                return _react2.default.createElement(
                    'div',
                    { className: 'row', key: index },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'div',
                                { className: 'ls-t-wp' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: "ls-" + index },
                                    leave.leaveTxt
                                ),
                                leave.type > 9 ? _react2.default.createElement(
                                    'button',
                                    { className: 'btn btn-danger btn-xs ls-rm', 'data-type': leave.type, onClick: _this2.removeType },
                                    'Remove'
                                ) : ""
                            ),
                            _react2.default.createElement('input', { type: 'number', className: 'form-control', id: "ls-" + index,
                                'data-index': leave.type, value: leave.totalGain, onChange: _this2.handleEdit })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-2' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'ls-lg' },
                            'Used (',
                            leave.type != 7 ? "days" : "hours",
                            ')'
                        ),
                        _react2.default.createElement('input', { type: 'number', className: 'form-control', id: "ls-" + index,
                            'data-index': leave.type, value: leave.used, onChange: _this2.handleEditUsed })
                    ),
                    leave.type == 0 ? _react2.default.createElement(
                        'div',
                        { className: 'col-sm-2' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'ls-fwd' },
                            'Bring Forward'
                        ),
                        bringFwd
                    ) : "",
                    leave.type == 0 ? _react2.default.createElement(
                        'div',
                        { className: 'col-sm-2' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'ls-lg' },
                            'Leave Gain'
                        ),
                        leaveGain
                    ) : "",
                    leave.type == 0 ? _react2.default.createElement(
                        'div',
                        { className: 'col-sm-3' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mx-fwd' },
                            'Maximum Bring Forward day (Apply to All)'
                        ),
                        _react2.default.createElement('input', { type: 'number', className: 'form-control', id: 'mx-fwd',
                            value: _this2.state.maxBringFwd, onChange: _this2.handleMaxBringFwd })
                    ) : ""
                );
            });
            return inputTxt;
        }
    }, {
        key: 'render',
        value: function render() {

            var modal = void 0;
            if (this.state.modalClose) {
                modal = _react2.default.createElement(_leaveSetModal2.default, { action: this.state.action, shouldModalClose: this.shouldModalClose, modalClose: this.state.modalClose,
                    type: this.state.type, processing: this.state.processing });
            }
            return _react2.default.createElement(
                'div',
                { className: 'lv-wp' },
                _react2.default.createElement(
                    'h4',
                    null,
                    this.props.userName + " (" + this.props.staffId + ")",
                    '\'s Leave Setting'
                ),
                this.renderInput(),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-12' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default us-cr', 'data-index': '0', onClick: this.handleClick },
                            'Save'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default us-cr', 'data-index': '1', onClick: this.handleClick },
                            'Back'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-warning us-cr', 'data-index': '2', onClick: this.handleClick },
                            'Add new type of Leave'
                        )
                    )
                ),
                modal
            );
        }
    }]);

    return LeaveSetForm;
}(_react2.default.Component);

LeaveSetForm.defaultProps = {
    typeTxt: ["Annual Leave", "Medical Leave", "Reservist", "Childcare leave", "Unpaid leave", "Compassionate leave", "Other Leave", "Time-off", "Tele-commuting"]
};
exports.default = LeaveSetForm;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _leaveSetAction = __webpack_require__(22);

var _leaveSetAction2 = _interopRequireDefault(_leaveSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveSetModal = function (_React$Component) {
    _inherits(LeaveSetModal, _React$Component);

    function LeaveSetModal(props) {
        _classCallCheck(this, LeaveSetModal);

        var _this = _possibleConstructorReturn(this, (LeaveSetModal.__proto__ || Object.getPrototypeOf(LeaveSetModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.state = {
            txtValue1: "",
            txtValue2: 0,
            warningMsg: ""
        };
        return _this;
    }

    _createClass(LeaveSetModal, [{
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var value = e.target.value;
            if (index == 0) {
                this.setState({ txtValue1: value });
            } else {
                this.setState({ txtValue2: parseFloat(value) });
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            if (this.props.action == 1 && this.state.txtValue1 == "") {
                return this.setState({ warningMsg: "Please enter the leave title" });
            }
            if (this.props.processing) return;
            this.setState({ warningMsg: "" });
            _leaveSetAction2.default.processing(true);
            if (this.props.action == 0) {
                _leaveSetAction2.default.removeLeave(this.props.type);
            } else {
                _leaveSetAction2.default.addLeave(this.state.txtValue1, this.state.txtValue2);
            }
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'renderBody',
        value: function renderBody() {
            var body = "";
            if (this.props.action == 0) {
                body = _react2.default.createElement(
                    'div',
                    null,
                    'This type of leave will be removed permanently! Are you sure?'
                );
            } else if (this.props.action == 1) {
                body = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'form',
                        null,
                        _react2.default.createElement(
                            'label',
                            null,
                            'Name of Leave'
                        ),
                        _react2.default.createElement('input', { className: 'form-control', type: 'text', 'data-index': '0', onChange: this.handleChange, value: this.state.txtValue1 })
                    ),
                    _react2.default.createElement(
                        'form',
                        null,
                        _react2.default.createElement(
                            'label',
                            null,
                            'Default Leave Balance (days)'
                        ),
                        _react2.default.createElement('input', { className: 'form-control', type: 'number', 'data-index': '1', onChange: this.handleChange, value: this.state.txtValue2 })
                    )
                );
            }
            return body;
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            var content = void 0;
            var title = void 0;
            if (this.props.action == 0) {
                title = "Warning";
            } else {
                title = "Add new type of leave";
            }
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'report-modal', style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            title
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body' },
                        this.state.warningMsg,
                        this.renderBody()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: "btn " + (this.props.action == 0 ? " btn-danger" : "btn-warning"),
                                onClick: this.handleSubmit },
                            this.props.action == 0 ? "Remove" : "Add"
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return LeaveSetModal;
}(_react2.default.Component);

LeaveSetModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = LeaveSetModal;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _empCard = __webpack_require__(239);

var _empCard2 = _interopRequireDefault(_empCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveSetBody = function (_React$Component) {
    _inherits(LeaveSetBody, _React$Component);

    function LeaveSetBody(props) {
        _classCallCheck(this, LeaveSetBody);

        return _possibleConstructorReturn(this, (LeaveSetBody.__proto__ || Object.getPrototypeOf(LeaveSetBody)).call(this, props));
    }

    _createClass(LeaveSetBody, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var employeeList = void 0;
            if (this.props.staffs) {
                employeeList = this.props.staffs.map(function (staff, index) {
                    return _react2.default.createElement(_empCard2.default, { staff: staff, key: index, history: _this2.props.history });
                });
            }
            return _react2.default.createElement(
                'div',
                { className: 'atd-bd-wp' },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-em-lt' },
                    employeeList
                )
            );
        }
    }]);

    return LeaveSetBody;
}(_react2.default.Component);

exports.default = LeaveSetBody;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _leaveSetAction = __webpack_require__(22);

var _leaveSetAction2 = _interopRequireDefault(_leaveSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmpCard = function (_React$Component) {
    _inherits(EmpCard, _React$Component);

    function EmpCard(props) {
        _classCallCheck(this, EmpCard);

        var _this = _possibleConstructorReturn(this, (EmpCard.__proto__ || Object.getPrototypeOf(EmpCard)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(EmpCard, [{
        key: 'handleClick',
        value: function handleClick(e) {
            _leaveSetAction2.default.staffId(this.props.staff.staffId);
            _leaveSetAction2.default.userName(this.props.staff.userName);
            _leaveSetAction2.default.updating(true);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-card', onClick: this.handleClick },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-img-wp' },
                    _react2.default.createElement('img', { className: 'atd-img', src: this.props.staff.userImage })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'atd-nm' },
                    this.props.staff.userName
                )
            );
        }
    }]);

    return EmpCard;
}(_react2.default.Component);

exports.default = EmpCard;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _leaveSetFilter = __webpack_require__(241);

var _leaveSetFilter2 = _interopRequireDefault(_leaveSetFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveSetHeader = function (_React$Component) {
    _inherits(LeaveSetHeader, _React$Component);

    function LeaveSetHeader(props) {
        _classCallCheck(this, LeaveSetHeader);

        return _possibleConstructorReturn(this, (LeaveSetHeader.__proto__ || Object.getPrototypeOf(LeaveSetHeader)).call(this, props));
    }

    _createClass(LeaveSetHeader, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-hd' },
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(
                        'b',
                        null,
                        'Leave Management'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-md-6' },
                    _react2.default.createElement(_leaveSetFilter2.default, { processing: this.props.processing })
                ),
                _react2.default.createElement('div', { className: 'clear' })
            );
        }
    }]);

    return LeaveSetHeader;
}(_react2.default.Component);

exports.default = LeaveSetHeader;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _leaveSetAction = __webpack_require__(22);

var _leaveSetAction2 = _interopRequireDefault(_leaveSetAction);

var _leaveSetStore = __webpack_require__(46);

var _leaveSetStore2 = _interopRequireDefault(_leaveSetStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveSetFilter = function (_React$Component) {
    _inherits(LeaveSetFilter, _React$Component);

    function LeaveSetFilter(props) {
        _classCallCheck(this, LeaveSetFilter);

        var _this = _possibleConstructorReturn(this, (LeaveSetFilter.__proto__ || Object.getPrototypeOf(LeaveSetFilter)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.onChange = _this.onChange.bind(_this);

        _this.state = {
            search: _leaveSetStore2.default.getState().search
        };
        return _this;
    }

    _createClass(LeaveSetFilter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _leaveSetStore2.default.listen(this.onChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _leaveSetStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                search: state.search
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var search = e.target.value;
            _leaveSetAction2.default.search(search);
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            var value = _reactDom2.default.findDOMNode(this.refs.empName).value;
            _leaveSetAction2.default.search(value);
            _leaveSetAction2.default.updating(false);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'row atd-i' },
                _react2.default.createElement(
                    'form',
                    { className: 'form-horizontal atd-i-wp' },
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'empName', className: 'col-xs-4 control-label' },
                        'Employee: '
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'input-group' },
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', ref: 'empName', id: 'empName', placeholder: 'Search Employee by Name or Id', value: this.state.search, onChange: this.handleChange }),
                        _react2.default.createElement(
                            'span',
                            { className: 'input-group-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-default', type: 'button', onClick: this.handleSubmit },
                                'Search'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return LeaveSetFilter;
}(_react2.default.Component);

exports.default = LeaveSetFilter;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(1);

var _userAction = __webpack_require__(21);

var _userAction2 = _interopRequireDefault(_userAction);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserLogin = function (_React$Component) {
    _inherits(UserLogin, _React$Component);

    function UserLogin(props) {
        _classCallCheck(this, UserLogin);

        var _this = _possibleConstructorReturn(this, (UserLogin.__proto__ || Object.getPrototypeOf(UserLogin)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.state = {
            warningMsg: _userStore2.default.getState().warningMsg,
            processing: _userStore2.default.getState().processing,
            isNewUser: _userStore2.default.getState().isNewUser,
            isUserLogin: _userStore2.default.getState().isUserLogin,
            token: _userStore2.default.getState().token,
            staffId: "",
            password: ""
        };
        return _this;
    }

    _createClass(UserLogin, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _userStore2.default.listen(this.onChange);
            if (this.state.isUserLogin) {
                this.props.history.push('/attendance');
            }
            _userAction2.default.warningMsg.defer('');
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _userStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                warningMsg: state.warningMsg,
                processing: state.processing,
                isNewUser: state.isNewUser,
                token: state.token,
                isUserLogin: state.isUserLogin
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (!prevState.isUserLogin && this.state.isUserLogin != prevState.isUserLogin) {
                if (this.state.isNewUser) {
                    this.props.history.push('/resetPassword/' + this.state.token);
                } else {
                    this.props.history.push('/attendance');
                }
            }
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var value = e.target.value;

            if (index == 0) {
                this.setState({ staffId: value });
            } else {
                this.setState({ password: value });
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            var staffInput = _reactDom2.default.findDOMNode(this.refs.staffId);
            var pwdInput = _reactDom2.default.findDOMNode(this.refs.pwd);
            try {
                staffInput.reportValidity();
                pwdInput.reportValidity();
            } catch (e) {}

            if (!staffInput.checkValidity()) return;
            if (!pwdInput.checkValidity()) return;

            if (this.state.processing) return;

            if (this.state.staffId != '' && this.state.password != '') {
                _userAction2.default.processing(true);
                _userAction2.default.userLogin(this.state.staffId, this.state.password);
            }
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            if (e.key == 'Enter') {
                this.handleSubmit();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'ul-w' },
                _react2.default.createElement(
                    'h2',
                    null,
                    ' A4 International '
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ul-tt' },
                    'Admin Web Portal'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ul-warning' },
                    this.state.warningMsg
                ),
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ul-in' },
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', ref: 'staffId', placeholder: 'Staff Id', 'data-index': '0', onChange: this.handleChange, required: true })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ul-in' },
                            _react2.default.createElement('input', { type: 'password', className: 'form-control', ref: 'pwd', placeholder: 'Password', 'data-index': '1',
                                onChange: this.handleChange, onKeyPress: this.handleKeyPress, required: true })
                        )
                    ),
                    _react2.default.createElement(
                        'button',
                        { type: 'button', className: 'btn btn-default', onClick: this.handleSubmit },
                        'Submit'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ul-set' },
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/forgotPassword', className: 'ul-fp' },
                        'Forgot Password'
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing })
            );
        }
    }]);

    return UserLogin;
}(_react2.default.Component);

exports.default = UserLogin;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(1);

var _userAction = __webpack_require__(21);

var _userAction2 = _interopRequireDefault(_userAction);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ForgotPassword = function (_React$Component) {
    _inherits(ForgotPassword, _React$Component);

    function ForgotPassword(props) {
        _classCallCheck(this, ForgotPassword);

        var _this = _possibleConstructorReturn(this, (ForgotPassword.__proto__ || Object.getPrototypeOf(ForgotPassword)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.state = {
            warningMsg: _userStore2.default.getState().warningMsg,
            processing: _userStore2.default.getState().processing,
            isfgPwdSend: _userStore2.default.getState().isfgPwdSend,
            email: ""
        };
        return _this;
    }

    _createClass(ForgotPassword, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _userStore2.default.listen(this.onChange);
            _userAction2.default.warningMsg('');
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _this2 = this;

            if (!prevState.isfgPwdSend && this.state.isfgPwdSend != prevState.isfgPwdSend) {

                window.setTimeout(function () {
                    _this2.props.history.push('/');
                }, 3000);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _userStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                warningMsg: state.warningMsg,
                processing: state.processing,
                isfgPwdSend: state.isfgPwdSend
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var value = e.target.value;
            this.setState({ email: value });
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            if (e.key == 'Enter') {
                e.preventDefault();
                this.handleSubmit();
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            var email = _reactDom2.default.findDOMNode(this.refs.email);
            try {
                email.reportValidity();
            } catch (e) {}

            if (!email.checkValidity()) return;

            if (this.state.processing) return;

            if (!this.validateEmail(this.state.email)) {
                _userAction2.default.warningMsg("Invalid Email");
            } else {
                _userAction2.default.processing(true);
                _userAction2.default.forgotPassword(this.state.email);
            }
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'ul-w' },
                _react2.default.createElement(
                    'h2',
                    null,
                    ' A4 International '
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ul-tt' },
                    'Forgot Password'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ul-warning' },
                    this.state.warningMsg
                ),
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ul-in' },
                            _react2.default.createElement('input', { type: 'email', ref: 'email', className: 'form-control', placeholder: 'Your Email Address',
                                onChange: this.handleChange, onKeyPress: this.handleKeyPress, required: true })
                        )
                    ),
                    _react2.default.createElement(
                        'button',
                        { type: 'button', className: 'btn btn-default', onClick: this.handleSubmit },
                        'Send'
                    )
                )
            );
        }
    }]);

    return ForgotPassword;
}(_react2.default.Component);

exports.default = ForgotPassword;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(1);

var _userAction = __webpack_require__(21);

var _userAction2 = _interopRequireDefault(_userAction);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResetPassword = function (_React$Component) {
    _inherits(ResetPassword, _React$Component);

    function ResetPassword(props) {
        _classCallCheck(this, ResetPassword);

        var _this = _possibleConstructorReturn(this, (ResetPassword.__proto__ || Object.getPrototypeOf(ResetPassword)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.state = {
            warningMsg: _userStore2.default.getState().warningMsg,
            processing: _userStore2.default.getState().processing,
            isPwdReset: _userStore2.default.getState().isPwdReset,
            newPassword: "",
            confirmPassword: ""
        };
        return _this;
    }

    _createClass(ResetPassword, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _userStore2.default.listen(this.onChange);
            _userAction2.default.warningMsg.defer('');
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _userStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _this2 = this;

            if (!prevState.isPwdReset && this.state.isPwdReset != prevState.isPwdReset) {
                console.log('repeat');
                _userAction2.default.warningMsg.defer("Password Successfully Reset. You will be redirected to login page in 3 seconds ");
                window.setTimeout(function () {
                    _this2.props.history.push('/attendance');
                }, 3000);
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                warningMsg: state.warningMsg,
                processing: state.processing,
                isPwdReset: state.isPwdReset
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var value = e.target.value;

            if (index == 0) {
                this.setState({ newPassword: value });
            } else {
                this.setState({ confirmPassword: value });
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            var npwd = _reactDom2.default.findDOMNode(this.refs.npwd);
            var cpwd = _reactDom2.default.findDOMNode(this.refs.cpwd);
            try {
                npwd.reportValidity();
                cpwd.reportValidity();
            } catch (e) {}

            if (!npwd.checkValidity()) return;
            if (!cpwd.checkValidity()) return;

            if (this.state.processing) return;

            if (!this.validatePassword(this.state.newPassword)) return;

            if (this.state.newPassword != this.state.confirmPassword) {
                return _userAction2.default.warningMsg("Password not tally");
            }

            _userAction2.default.processing(true);
            _userAction2.default.resetPassword(this.props.match.params.token, this.state.newPassword);
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            if (e.key == 'Enter') {
                e.preventDefault();
                this.handleSubmit();
            }
        }
    }, {
        key: 'validatePassword',
        value: function validatePassword(password) {
            if (password.length < 8) {
                _userAction2.default.warningMsg("Password length must be minimum 8 characters");
                return false;
            } else if (password.match(/[A-Z]/g) == null) {
                _userAction2.default.warningMsg("Password must be at least one Capital letter");
                return false;
            }
            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'ul-w' },
                _react2.default.createElement(
                    'h2',
                    null,
                    ' A4 International '
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ul-tt' },
                    'Reset Password'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ul-warning' },
                    this.state.warningMsg
                ),
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ul-in' },
                            _react2.default.createElement('input', { type: 'password', ref: 'npwd', className: 'form-control',
                                placeholder: 'New Password', 'data-index': '0', onChange: this.handleChange, required: true })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ul-in' },
                            _react2.default.createElement('input', { type: 'password', ref: 'cpwd', className: 'form-control',
                                placeholder: 'Confirm New Password', 'data-index': '1', onChange: this.handleChange,
                                onKeyPress: this.handleKeyPress, required: true })
                        )
                    ),
                    _react2.default.createElement(
                        'button',
                        { type: 'button', className: 'btn btn-default', onClick: this.handleSubmit },
                        'Change'
                    )
                )
            );
        }
    }]);

    return ResetPassword;
}(_react2.default.Component);

exports.default = ResetPassword;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(1);

var _userAction = __webpack_require__(21);

var _userAction2 = _interopRequireDefault(_userAction);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChangePassword = function (_React$Component) {
    _inherits(ChangePassword, _React$Component);

    function ChangePassword(props) {
        _classCallCheck(this, ChangePassword);

        var _this = _possibleConstructorReturn(this, (ChangePassword.__proto__ || Object.getPrototypeOf(ChangePassword)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.state = {
            warningMsg: _userStore2.default.getState().warningMsg,
            processing: _userStore2.default.getState().processing,
            isPasswordChange: _userStore2.default.getState().isPasswordChange,
            isUserLogin: _userStore2.default.getState().isUserLogin,
            currentPassword: "",
            newPassword: "",
            confirmPassword: ""
        };
        return _this;
    }
    //token id this.props.match.params.token


    _createClass(ChangePassword, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _userStore2.default.listen(this.onChange);
            _userAction2.default.warningMsg('');
            if (!this.state.isUserLogin) {
                this.props.history.push('/');
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _userStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (!prevState.isPasswordChange && this.state.isPasswordChange != prevState.isPasswordChange) {
                this.props.history.push('/attendance');
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                warningMsg: state.warningMsg,
                processing: state.processing,
                isPasswordChange: state.isPasswordChange,
                isUserLogin: state.isUserLogin
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var value = e.target.value;

            if (index == 0) {
                this.setState({ currentPassword: value });
            } else if (index == 1) {
                this.setState({ newPassword: value });
            } else {
                this.setState({ confirmPassword: value });
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            var npwd = _reactDom2.default.findDOMNode(this.refs.npwd);
            var cpwd = _reactDom2.default.findDOMNode(this.refs.cpwd);
            var cfpwd = _reactDom2.default.findDOMNode(this.refs.cfpwd);
            try {
                npwd.reportValidity();
                cpwd.reportValidity();
                cfpwd.reportValidity();
            } catch (e) {}

            if (!npwd.checkValidity()) return;
            if (!cpwd.checkValidity()) return;
            if (!cfpwd.checkValidity()) return;

            if (this.state.processing) return;

            if (!this.validatePassword(this.state.newPassword)) return;

            if (this.state.newPassword != this.state.confirmPassword) {
                return _userAction2.default.warningMsg("Password not tally");
            }

            _userAction2.default.processing(true);
            _userAction2.default.changePassword(this.state.currentPassword, this.state.newPassword);
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            if (e.key == 'Enter') {
                e.preventDefault();
                this.handleSubmit();
            }
        }
    }, {
        key: 'validatePassword',
        value: function validatePassword(password) {
            if (password.length < 8) {
                _userAction2.default.warningMsg("Password length must be minimum 8 characters");
                return false;
            } else if (password.match(/[A-Z]/g) == null) {
                _userAction2.default.warningMsg("Password must be at least one Capital letter");
                return false;
            }
            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'ul-w' },
                _react2.default.createElement(
                    'h2',
                    null,
                    ' A4 International '
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ul-tt' },
                    'Reset Password'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ul-warning' },
                    this.state.warningMsg
                ),
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ul-in' },
                            _react2.default.createElement('input', { type: 'password', ref: 'cpwd', className: 'form-control',
                                placeholder: 'Current Password', 'data-index': '0', onChange: this.handleChange, required: true })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ul-in' },
                            _react2.default.createElement('input', { type: 'password', ref: 'npwd', className: 'form-control',
                                placeholder: 'New Password', 'data-index': '1', onChange: this.handleChange, required: true })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ul-in' },
                            _react2.default.createElement('input', { type: 'password', ref: 'cfpwd', className: 'form-control',
                                placeholder: 'Confirm New Password', 'data-index': '2', onChange: this.handleChange,
                                onKeyPress: this.handleKeyPress, required: true })
                        )
                    ),
                    _react2.default.createElement(
                        'button',
                        { type: 'button', className: 'btn btn-default', onClick: this.handleSubmit },
                        'Change'
                    )
                )
            );
        }
    }]);

    return ChangePassword;
}(_react2.default.Component);

exports.default = ChangePassword;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _estateHeader = __webpack_require__(247);

var _estateHeader2 = _interopRequireDefault(_estateHeader);

var _estateBody = __webpack_require__(249);

var _estateBody2 = _interopRequireDefault(_estateBody);

var _emAction = __webpack_require__(38);

var _emAction2 = _interopRequireDefault(_emAction);

var _emStore = __webpack_require__(87);

var _emStore2 = _interopRequireDefault(_emStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Estate = function (_React$Component) {
    _inherits(Estate, _React$Component);

    function Estate(props) {
        var _this$state;

        _classCallCheck(this, Estate);

        var _this = _possibleConstructorReturn(this, (Estate.__proto__ || Object.getPrototypeOf(Estate)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.state = (_this$state = {
            staffs: _filterStore2.default.getState().staffs,
            processingFilter: _filterStore2.default.getState().processing,
            iniLoadStaff: _filterStore2.default.getState().iniLoadStaff,
            iniLoadTeamMember: _filterStore2.default.getState().iniLoadTeamMember,
            teamMember: _filterStore2.default.getState().teamMember,

            teamCondo: _filterStore2.default.getState().teamCondo,
            iniLoadCondo: _filterStore2.default.getState().iniLoadTeamCondo,
            condos: _filterStore2.default.getState().condos
        }, _defineProperty(_this$state, 'iniLoadCondo', _filterStore2.default.getState().iniLoadCondo), _defineProperty(_this$state, 'estate', _emStore2.default.getState().estate), _defineProperty(_this$state, 'processing', _emStore2.default.getState().processing), _this$state);
        return _this;
    }

    _createClass(Estate, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _emStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);
            if (!this.state.processingFilter && !this.state.iniLoadStaff) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getEmployee();
            }
            if (!this.state.iniLoadTeamCondo) {
                _filterAction2.default.getTeamCondo();
            }

            if (!this.state.iniLoadTeamMember) {
                _filterAction2.default.getTeamMember();
            }
            if (!this.state.iniLoadCondo) {
                //getMCST first
                _filterAction2.default.processing(true);
                _filterAction2.default.getCondoList();
            }
            _menuAction2.default.pageNumber(3);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _emStore2.default.unlisten(this.onChange);
            _filterStore2.default.unlisten(this.onFilterChange);
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState(_defineProperty({
                staffs: state.staffs,
                processingFilter: state.processing,
                iniLoadStaff: state.iniLoadStaff,
                iniLoadTeamCondo: state.iniLoadTeamCondo,
                condos: state.teamCondo,
                iniLoadTeamMember: state.iniLoadTeamMember,
                teamMember: state.teamMember,
                iniLoadCondo: state.iniLoadCondo
            }, 'condos', state.condos));
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                estate: state.estate
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_navBar2.default, this.props),
                _react2.default.createElement(
                    'div',
                    { className: 'container-fluid content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(_sideMenu2.default, this.props),
                        _react2.default.createElement(
                            'div',
                            { className: ' col-md-10  col-sm-8 atd' },
                            _react2.default.createElement(_estateHeader2.default, { staffs: this.state.staffs, condos: this.state.condos,
                                teamCondo: this.state.teamCondo, teamMember: this.state.teamMember }),
                            _react2.default.createElement('div', { className: 'divider' }),
                            _react2.default.createElement(_estateBody2.default, _extends({ estate: this.state.estate }, this.props))
                        )
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.processingFilter })
            );
        }
    }]);

    return Estate;
}(_react2.default.Component);

exports.default = Estate;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _estateFilter = __webpack_require__(248);

var _estateFilter2 = _interopRequireDefault(_estateFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EstateHeader = function (_React$Component) {
    _inherits(EstateHeader, _React$Component);

    function EstateHeader(props) {
        _classCallCheck(this, EstateHeader);

        return _possibleConstructorReturn(this, (EstateHeader.__proto__ || Object.getPrototypeOf(EstateHeader)).call(this, props));
    }

    _createClass(EstateHeader, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-hd' },
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(
                        'b',
                        null,
                        'Summary of Estate Manager'
                    )
                ),
                _react2.default.createElement(_estateFilter2.default, { staffs: this.props.staffs, condos: this.props.condos,
                    teamMember: this.props.teamMember, teamCondo: this.props.teamCondo }),
                _react2.default.createElement('div', { className: 'clear' })
            );
        }
    }]);

    return EstateHeader;
}(_react2.default.Component);

exports.default = EstateHeader;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _emAction = __webpack_require__(38);

var _emAction2 = _interopRequireDefault(_emAction);

var _emStore = __webpack_require__(87);

var _emStore2 = _interopRequireDefault(_emStore);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EstateFilter = function (_React$Component) {
    _inherits(EstateFilter, _React$Component);

    function EstateFilter(props) {
        _classCallCheck(this, EstateFilter);

        var _this = _possibleConstructorReturn(this, (EstateFilter.__proto__ || Object.getPrototypeOf(EstateFilter)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handlePrint = _this.handlePrint.bind(_this);
        _this.handleExport = _this.handleExport.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.state = {
            processing: _emStore2.default.getState().processing,
            warningMsg: _emStore2.default.getState().warningMsg,
            iniYear: 2017,
            iniMonth: 11,
            staffId: _emStore2.default.getState().staffId,
            mcst: _emStore2.default.getState().mcst,
            selectedYear: _emStore2.default.getState().selectedYear,
            selectedMonth: _emStore2.default.getState().selectedMonth,

            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId
        };
        return _this;
    }

    _createClass(EstateFilter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _emStore2.default.listen(this.onChange);
            _userStore2.default.listen(this.onUserChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _emStore2.default.unlisten(this.onChange);
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                selectedYear: state.selectedYear,
                selectedMonth: state.selectedMonth,
                staffId: state.staffId,
                mcst: state.mcst,
                warningMsg: state.warningMsg
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            var value = e.target.value.split(":");
            var selectedYear = parseInt(value[0]);
            var selectedMonth = parseInt(value[1]);
            if (index == 2) {
                _emAction2.default.selectMonth({ selectedYear: selectedYear, selectedMonth: selectedMonth });
            } else if (index == 1) {
                _emAction2.default.mcst({ mcst: value[0] });
            } else {
                _emAction2.default.staffId({ staffId: value[0] });
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            /*
            if(this.state.staffId == -1 && this.state.mcst == "" ){
                return emAction.warningMsg("Please select either staff name or condo name");
            }
            */
            if (this.state.processing) return;

            _emAction2.default.warningMsg("");
            _emAction2.default.processing(true);
            _emAction2.default.getEstate(this.state.staffId, this.state.mcst, this.state.selectedYear, this.state.selectedMonth);
        }
    }, {
        key: 'handlePrint',
        value: function handlePrint() {
            window.print();
        }
    }, {
        key: 'handleExport',
        value: function handleExport() {
            /*
            if(this.state.staffId == -1 || this.state.mcst == "" ){
                return emAction.warningMsg("Please select either staff name or condo name");
            }
            */
            if (this.state.processing) return;

            _emAction2.default.warningMsg("");
            _emAction2.default.processing(true);
            _emAction2.default.exportEstate(this.state.staffId, this.state.mcst, this.state.selectedYear, this.state.selectedMonth);
        }
    }, {
        key: 'renderStaffs',
        value: function renderStaffs() {
            var _this2 = this;

            var staffs = this.props.staffs;
            if (staffs.length > 0) {
                staffs = this.props.staffs.filter(function (staff) {
                    return _genFunction2.default.hasPermission(_this2.state.permission, 11) || _genFunction2.default.isSubordinate(_this2.state.subordinate, staff.staffId) || _genFunction2.default.isUser(_this2.state.userId, staff.staffId) || _genFunction2.default.isMember(_this2.props.teamMember, staff.staffId);
                });

                return staffs.map(function (staff, index) {
                    return _this2.renderStaff(staff, index);
                });
            }
        }
    }, {
        key: 'renderCondos',
        value: function renderCondos() {
            var _this3 = this;

            var condos = this.props.condos;
            if (condos.length > 0) {
                condos = condos.filter(function (condo) {
                    return _genFunction2.default.hasPermission(_this3.state.permission, 11) || _genFunction2.default.hasCondo(_this3.props.teamCondo, condo.mcst);
                });

                return condos.map(function (condo, index) {
                    return _react2.default.createElement(
                        'option',
                        { value: condo.mcst, key: index },
                        condo.condoName
                    );
                });
            }
        }
    }, {
        key: 'renderStaff',
        value: function renderStaff(staff, index) {
            return _react2.default.createElement(
                'option',
                { value: staff.staffId, key: index },
                staff.userName
            );
        }
    }, {
        key: 'renderOption',
        value: function renderOption(yr, mth) {
            var isSelected = yr == this.props.selectedYear && mth == this.props.selectedMonth ? true : false;
            return _react2.default.createElement(
                'option',
                { value: yr + ":" + mth, key: yr + mth },
                this.props.mthTxt[mth] + " " + yr
            );
        }
    }, {
        key: 'renderOptions',
        value: function renderOptions() {
            var options = [];
            var thisYear = new Date().getFullYear();
            var thisMonth = new Date().getMonth();

            for (var yr = thisYear; yr >= this.state.iniYear; yr--) {
                if (thisYear == this.state.iniYear) {
                    for (var mth = thisMonth; mth >= this.state.iniMonth; mth--) {
                        options = options.concat(this.renderOption(yr, mth));
                    }
                } else if (yr == thisYear) {
                    for (var _mth = thisMonth; _mth >= 0; _mth--) {
                        options = options.concat(this.renderOption(yr, _mth));
                    }
                } else if (yr == this.state.iniYear) {
                    for (var _mth2 = 11; _mth2 >= this.state.iniMonth; _mth2--) {
                        options = options.concat(this.renderOption(yr, _mth2));
                    }
                } else {
                    for (var _mth3 = 11; _mth3 >= 0; _mth3--) {
                        options = options.concat(this.renderOption(yr, _mth3));
                    }
                }
            }
            return options;
        }
    }, {
        key: 'render',
        value: function render() {

            return _react2.default.createElement(
                'div',
                { className: 'atd-i' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-5 col-lg-3' },
                        _react2.default.createElement(
                            'form',
                            { className: 'form-horizontal atd-i-wp' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'staffName', className: 'col-xs-4 control-label' },
                                'Staff Name: '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group input-group-sm' },
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control atd-sel', id: 'staffName', name: 'staffName', 'data-index': '0', onChange: this.handleChange, defaultValue: this.state.staffId },
                                    _react2.default.createElement(
                                        'option',
                                        { value: '' },
                                        'Any Staff'
                                    ),
                                    this.renderStaffs()
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'form',
                            { className: 'form-horizontal atd-i-wp' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'condoName', className: 'col-xs-4 control-label' },
                                'Condo Name: '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group input-group-sm' },
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control atd-sel', id: 'condoName', name: 'condoName', 'data-index': '1', onChange: this.handleChange, defaultValue: this.state.mcst },
                                    _react2.default.createElement(
                                        'option',
                                        { value: '' },
                                        'Any Condo'
                                    ),
                                    this.renderCondos()
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-5 col-lg-3' },
                        _react2.default.createElement(
                            'form',
                            { className: 'form-horizontal atd-i-wp' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'month', className: 'col-xs-4 control-label' },
                                'Select Month: '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group input-group-sm' },
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control atd-sel', id: 'month', name: 'month', 'data-index': '2', onChange: this.handleChange, defaultValue: this.state.startYear + ":" + this.state.startMonth },
                                    this.renderOptions()
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-0-tp atd-i-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-default btn-sm', type: 'button', onClick: this.handleSubmit },
                                'Search'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-0-tp atd-i-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-primary btn-sm', onClick: this.handleExport },
                                'Export'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'atd-0-tp atd-i-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-primary btn-sm', onClick: this.handlePrint },
                                'Print'
                            )
                        )
                    )
                )
            );
        }
    }]);

    return EstateFilter;
}(_react2.default.Component);

EstateFilter.defaultProps = {
    mthTxt: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
exports.default = EstateFilter;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(1);

var _estateList = __webpack_require__(250);

var _estateList2 = _interopRequireDefault(_estateList);

var _emAction = __webpack_require__(38);

var _emAction2 = _interopRequireDefault(_emAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EstateBody = function (_React$Component) {
    _inherits(EstateBody, _React$Component);

    function EstateBody(props) {
        _classCallCheck(this, EstateBody);

        var _this = _possibleConstructorReturn(this, (EstateBody.__proto__ || Object.getPrototypeOf(EstateBody)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleMouseScroll = _this.handleMouseScroll.bind(_this);
        _this.state = {
            tableWidth: 300,
            page: 0,
            contentNo: 10
        };
        return _this;
    }

    _createClass(EstateBody, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var tableWidth = _reactDom2.default.findDOMNode(this.refs.est).clientWidth;
            this.setState({
                tableWidth: tableWidth
            });
            if (document.body.clientWidth > 768) {
                window.addEventListener('wheel', this.handleMouseScroll);
            }
            window.addEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (document.body.clientWidth > 768) {
                window.removeEventListener('wheel', this.handleMouseScroll);
            }
            window.removeEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevProps.estate != this.props.estate) {
                this.setState({
                    page: 0
                });
            }
        }
    }, {
        key: 'handleMouseScroll',
        value: function handleMouseScroll(e) {
            e.preventDefault();

            if (e.deltaY > 0) {
                //scroll down
                window.scrollBy(0, 50);
            } else {
                //scroll up
                window.scrollBy(0, -50);
            }
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(e) {
            var elem1 = _reactDom2.default.findDOMNode(this.refs.est);
            var elem2 = _reactDom2.default.findDOMNode(this.refs.table);
            if (elem2.getBoundingClientRect().top < 30) {

                elem1.style.position = "absolute";

                if (document.body.clientWidth > 768) {
                    elem2.style.paddingTop = "50px";
                    elem1.style.top = 50 - elem2.getBoundingClientRect().top + "px";
                } else {
                    elem2.style.paddingTop = "0px";
                    elem1.style.top = -elem2.getBoundingClientRect().top + "px";
                }
            } else {
                elem1.style.position = "relative";
                elem1.style.top = "0px";
                elem2.style.paddingTop = "0px";
            }
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var value = parseInt(e.target.value);
            _emAction2.default.sortByStatus(value);
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.currentTarget.getAttribute('data-index'));
            if (index != this.state.page) {
                this.setState({ page: index });
            }
        }
    }, {
        key: 'renderPagination',
        value: function renderPagination() {
            if (!this.props.estate) return;
            if (this.props.estate.length == 0) return;

            var pageNo = Math.ceil(this.props.estate.length / this.state.contentNo);

            var pagination = [];
            for (var i = 0; i < pageNo; i++) {
                pagination = pagination.concat(_react2.default.createElement(
                    'li',
                    { className: this.state.page == i ? "active" : "", key: i, 'data-index': i, onClick: this.handleClick },
                    _react2.default.createElement(
                        'a',
                        { href: '#' },
                        i + 1
                    )
                ));
            }
            return _react2.default.createElement(
                'nav',
                { className: 'ctr-pg', style: { maxWidth: this.state.tableWidth + "px" } },
                _react2.default.createElement(
                    'ul',
                    { className: 'pagination' },
                    pagination
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'pagination-title' },
                    'page ',
                    this.state.page + 1 + " of " + pageNo
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var year = this.props.selectedYear ? this.props.selectedYear : new Date().getFullYear();
            var month = this.props.selectedMonth ? this.props.selectedMonth : new Date().getMonth();

            var start_day = new Date(year, month, 1).getDay();
            var last_date = new Date(year, month + 1, 0).getDate();
            var last_wk = Math.ceil((last_date + start_day) / 7);

            var estate = [];
            for (var i = 0 + this.state.contentNo * this.state.page; i < this.state.contentNo + this.state.contentNo * this.state.page; i++) {
                if (i < this.props.estate.length) {
                    estate = estate.concat(this.props.estate[i]);
                }
            }
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'form',
                    { className: 'form-horizontal em-sort', style: { maxWidth: this.state.tableWidth + "px" } },
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'sort', className: 'col-xs-4 control-label' },
                        'Sort Status By:'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'input-group input-group-sm' },
                        _react2.default.createElement(
                            'select',
                            { className: 'form-control atd-sel', id: 'sort', name: 'sort', onChange: this.handleChange },
                            _react2.default.createElement('option', { value: '' }),
                            _react2.default.createElement(
                                'option',
                                { value: '1' },
                                'Not Ok'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: '2' },
                                'Resolved'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: '0' },
                                'Ok'
                            )
                        )
                    )
                ),
                this.renderPagination(),
                _react2.default.createElement(
                    'div',
                    { className: 'est-bd-wp', ref: 'table' },
                    _react2.default.createElement(
                        'div',
                        { className: 'est-bd' },
                        _react2.default.createElement(
                            'table',
                            { className: 'est-tb tb-heading', ref: 'est' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Estate'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'MCST'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'PE'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Date'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Day'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Time'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Area'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Category'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Status'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Incident Report'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(_estateList2.default, { estate: estate, tableWidth: this.state.tableWidth,
                            page: this.state.page, contentNo: this.state.contentNo })
                    )
                ),
                this.renderPagination()
            );
        }
    }]);

    return EstateBody;
}(_react2.default.Component);

EstateBody.defaultProps = {
    monthTxt: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
exports.default = EstateBody;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _emAction = __webpack_require__(38);

var _emAction2 = _interopRequireDefault(_emAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EstateList = function (_React$Component) {
    _inherits(EstateList, _React$Component);

    function EstateList(props) {
        _classCallCheck(this, EstateList);

        var _this = _possibleConstructorReturn(this, (EstateList.__proto__ || Object.getPrototypeOf(EstateList)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(EstateList, [{
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.currentTarget.getAttribute("data-index"));
            index = index + this.props.page * this.props.contentNo;
            _emAction2.default.shouldListShow(index);
        }
    }, {
        key: 'renderDataList',
        value: function renderDataList(est, index) {
            est.date = new Date(est.date);
            est.time = new Date(est.time);
            var date = est.date.getDate() + "-" + this.props.mthTxt[est.date.getMonth()] + "-" + est.date.getFullYear();
            var day = this.props.dayTxt[est.date.getDay()];
            var timeInHour = est.time.getHours() < 10 ? "0" + est.time.getHours() : est.time.getHours();
            var timeInMinute = est.time.getMinutes() < 10 ? "0" + est.time.getMinutes() : est.time.getMinutes();
            var time = timeInHour + ":" + timeInMinute;
            return _react2.default.createElement(
                'tr',
                { key: index },
                _react2.default.createElement(
                    'td',
                    null,
                    est.condoName
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    est.mcst
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    est.userName
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    date
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    day
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    time
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    est.facility
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    est.category
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.props.statusTxt[est.status]
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.renderReportNo(est)
                )
            );
        }
    }, {
        key: 'renderReportNo',
        value: function renderReportNo(est) {
            if (!Array.isArray(est.reportNo)) {
                return _react2.default.createElement(
                    _reactRouterDom.Link,
                    { to: "/report/" + est.reportNo },
                    est.reportNo
                );
            } else {
                return est.reportNo.map(function (reportNo, index) {
                    return _react2.default.createElement(
                        'div',
                        { key: index },
                        _react2.default.createElement(
                            _reactRouterDom.Link,
                            { to: "/report/" + reportNo },
                            reportNo
                        )
                    );
                });
            }
        }
    }, {
        key: 'renderDataLists',
        value: function renderDataLists(est, index) {
            var _this2 = this;

            var body = est.estate.map(function (est1, index1) {
                return _this2.renderDataList(est1, index1);
            });

            return _react2.default.createElement(
                'table',
                { className: "est-tb " + (est.shouldListShow ? "est-show" : "est-hide") },
                _react2.default.createElement(
                    'tbody',
                    { className: 'est-tbd' },
                    body
                )
            );
        }
    }, {
        key: 'renderNameList',
        value: function renderNameList(est, index) {
            return _react2.default.createElement(
                'div',
                { className: 'est-a-nlw', onClick: this.handleClick, 'data-index': index, style: { width: this.props.tableWidth + "px" } },
                _react2.default.createElement('i', { className: "est-a-nli " + (est.shouldListShow ? "glyphicon glyphicon-minus" : "glyphicon glyphicon-plus") }),
                _react2.default.createElement(
                    'div',
                    { className: 'est-a-nl est-a-n' },
                    est.condoName,
                    ' (',
                    est.mcst,
                    ')',
                    _react2.default.createElement(
                        'span',
                        { className: 'badge' },
                        est.incident
                    )
                )
            );
        }
    }, {
        key: 'renderMainList',
        value: function renderMainList() {
            var _this3 = this;

            return this.props.estate.map(function (est, index) {
                return _react2.default.createElement(
                    'div',
                    { key: index },
                    _this3.renderNameList(est, index),
                    _this3.renderDataLists(est, index)
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-abd-wp' },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-em-lt' },
                    this.renderMainList()
                )
            );
        }
    }]);

    return EstateList;
}(_react2.default.Component);

EstateList.defaultProps = {
    mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    dayTxt: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    statusTxt: ["OK", "Not Ok", "Resolved"]
};
exports.default = EstateList;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _employeeAction = __webpack_require__(33);

var _employeeAction2 = _interopRequireDefault(_employeeAction);

var _employeeStore = __webpack_require__(45);

var _employeeStore2 = _interopRequireDefault(_employeeStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _employeeHeader = __webpack_require__(252);

var _employeeHeader2 = _interopRequireDefault(_employeeHeader);

var _employeeProfile = __webpack_require__(254);

var _employeeProfile2 = _interopRequireDefault(_employeeProfile);

var _employeeBody = __webpack_require__(255);

var _employeeBody2 = _interopRequireDefault(_employeeBody);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Employee = function (_React$Component) {
    _inherits(Employee, _React$Component);

    function Employee(props) {
        _classCallCheck(this, Employee);

        var _this = _possibleConstructorReturn(this, (Employee.__proto__ || Object.getPrototypeOf(Employee)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.state = {
            staffs: _employeeStore2.default.getState().staffs,
            iniLoadStaff: _employeeStore2.default.getState().iniLoadStaff,
            search: _employeeStore2.default.getState().search,
            displayDetail: _employeeStore2.default.getState().displayDetail,
            staffId: _employeeStore2.default.getState().staffId,
            processing: _employeeStore2.default.getState().processing,

            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId
        };
        return _this;
    }

    _createClass(Employee, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _employeeStore2.default.listen(this.onChange);
            _userStore2.default.listen(this.onUserChange);
            if (!this.state.processing && !this.state.iniLoadStaff) {
                _employeeAction2.default.processing(true);
                _employeeAction2.default.getEmployee();
            }

            _menuAction2.default.pageNumber(7);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _employeeStore2.default.unlisten(this.onChange);
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                search: state.search,
                displayDetail: state.displayDetail,
                staffId: state.staffId,
                staffs: state.staffs,
                iniLoadStaff: state.iniLoadStaff
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var body = void 0;

            if (this.state.displayDetail) {
                body = _react2.default.createElement(_employeeProfile2.default, { processing: this.state.processing, staffId: this.state.staffId });
            } else {
                var staffs = void 0;
                if (this.state.staffs.length > 0) {
                    staffs = this.state.staffs.filter(function (staff) {
                        return _genFunction2.default.hasPermission(_this2.state.permission, 4) || _genFunction2.default.isSubordinate(_this2.state.subordinate, staff.staffId) || _genFunction2.default.isUser(_this2.state.userId, staff.staffId);
                    });
                    staffs = staffs.filter(function (staff) {
                        return staff.userName.toLowerCase().indexOf(_this2.state.search.toLowerCase()) > -1 || staff.staffId.toLowerCase().indexOf(_this2.state.search.toLowerCase()) > -1;
                    });
                }

                body = _react2.default.createElement(_employeeBody2.default, { staffs: staffs });
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_navBar2.default, this.props),
                _react2.default.createElement(
                    'div',
                    { className: 'container-fluid content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(_sideMenu2.default, this.props),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-md-10  col-sm-8 atd' },
                            _react2.default.createElement(_employeeHeader2.default, { processing: this.state.processing }),
                            _react2.default.createElement('div', { className: 'divider' }),
                            body
                        )
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.processingFilter })
            );
        }
    }]);

    return Employee;
}(_react2.default.Component);

exports.default = Employee;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _employeeFilter = __webpack_require__(253);

var _employeeFilter2 = _interopRequireDefault(_employeeFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmployeeHeader = function (_React$Component) {
    _inherits(EmployeeHeader, _React$Component);

    function EmployeeHeader(props) {
        _classCallCheck(this, EmployeeHeader);

        return _possibleConstructorReturn(this, (EmployeeHeader.__proto__ || Object.getPrototypeOf(EmployeeHeader)).call(this, props));
    }

    _createClass(EmployeeHeader, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-hd' },
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(
                        'b',
                        null,
                        'Employee Detail'
                    )
                ),
                _react2.default.createElement(_employeeFilter2.default, { processing: this.props.processing }),
                _react2.default.createElement('div', { className: 'clear' })
            );
        }
    }]);

    return EmployeeHeader;
}(_react2.default.Component);

exports.default = EmployeeHeader;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _employeeAction = __webpack_require__(33);

var _employeeAction2 = _interopRequireDefault(_employeeAction);

var _employeeStore = __webpack_require__(45);

var _employeeStore2 = _interopRequireDefault(_employeeStore);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmployeeFilter = function (_React$Component) {
    _inherits(EmployeeFilter, _React$Component);

    function EmployeeFilter(props) {
        _classCallCheck(this, EmployeeFilter);

        var _this = _possibleConstructorReturn(this, (EmployeeFilter.__proto__ || Object.getPrototypeOf(EmployeeFilter)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.handleExport = _this.handleExport.bind(_this);
        _this.state = {
            search: _employeeStore2.default.getState().search,

            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId
        };
        return _this;
    }

    _createClass(EmployeeFilter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _employeeStore2.default.listen(this.onChange);
            _userStore2.default.listen(this.onUserChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _employeeStore2.default.unlisten(this.onChange);
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                search: state.search
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var search = e.target.value;
            _employeeAction2.default.search(search);
        }
    }, {
        key: 'handleExport',
        value: function handleExport() {
            if (this.props.processing) return;

            _employeeAction2.default.processing(true);
            _employeeAction2.default.exportProfile();
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            var value = _reactDom2.default.findDOMNode(this.refs.empName).value;
            _employeeAction2.default.search(value);
            _employeeAction2.default.displayDetail(false);
            if (role == 0) {}
        }
    }, {
        key: 'render',
        value: function render() {
            var exportAll = void 0;
            if (_genFunction2.default.hasPermission(this.state.permission, 4)) {
                exportAll = _react2.default.createElement(
                    'div',
                    { className: 'atd-i-wp' },
                    _react2.default.createElement(
                        'button',
                        { className: 'btn btn-primary btn-sm', type: 'button', onClick: this.handleExport },
                        'Export All Employees'
                    )
                );
            }
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-4' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row atd-i' },
                        _react2.default.createElement(
                            'form',
                            { className: 'form-horizontal atd-i-wp' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'empName', className: 'col-xs-3 control-label' },
                                'Employee: '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'input-group input-group-sm' },
                                _react2.default.createElement('input', { type: 'text', className: 'form-control', ref: 'empName', id: 'empName', placeholder: 'Search Employee by Name or Id', value: this.state.search, onChange: this.handleChange }),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'input-group-btn' },
                                    _react2.default.createElement(
                                        'button',
                                        { className: 'btn btn-default', type: 'button', onClick: this.handleSubmit },
                                        'Search'
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-4' },
                    exportAll
                )
            );
        }
    }]);

    return EmployeeFilter;
}(_react2.default.Component);

exports.default = EmployeeFilter;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _employeeAction = __webpack_require__(33);

var _employeeAction2 = _interopRequireDefault(_employeeAction);

var _employeeStore = __webpack_require__(45);

var _employeeStore2 = _interopRequireDefault(_employeeStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmployeeProfile = function (_React$Component) {
    _inherits(EmployeeProfile, _React$Component);

    function EmployeeProfile(props) {
        _classCallCheck(this, EmployeeProfile);

        var _this = _possibleConstructorReturn(this, (EmployeeProfile.__proto__ || Object.getPrototypeOf(EmployeeProfile)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.state = {
            userDetail: _employeeStore2.default.getState().userDetail
        };

        return _this;
    }

    _createClass(EmployeeProfile, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _employeeStore2.default.listen(this.onChange);
            if (!this.state.processing) {
                _employeeAction2.default.clear();
                _employeeAction2.default.processing(true);
                _employeeAction2.default.userDetail(this.props.staffId);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _employeeStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({ userDetail: state.userDetail });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            if (index == 0) {
                window.print();
            } else if (index == 2) {
                _employeeAction2.default.displayDetail(false);
            } else {
                if (!this.state.processing) {
                    _employeeAction2.default.processing(true);
                    _employeeAction2.default.getEmployeeExport(this.props.staffId);
                }
            }
        }
    }, {
        key: 'renderSupervisor',
        value: function renderSupervisor(supervisor) {
            if (!supervisor) return;
            var spvr = supervisor.map(function (staff, index) {
                return _react2.default.createElement(
                    'li',
                    { key: index, className: 'us-item' },
                    staff.userName
                );
            });

            return _react2.default.createElement(
                'ol',
                null,
                spvr
            );
        }
    }, {
        key: 'renderPermission',
        value: function renderPermission(permission) {
            if (!permission) return;
            var pms = permission.map(function (permission, index) {
                return _react2.default.createElement(
                    'li',
                    { className: 'us-pms', key: index },
                    permission.title
                );
            });

            return _react2.default.createElement(
                'ul',
                { className: 'us-ul' },
                pms
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var s = this.state.userDetail;
            return _react2.default.createElement(
                'div',
                { className: 'emp-bd-wp' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'h3',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Employee Profile'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'userName' },
                                'Employee Name'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.userName
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'staffId' },
                                'Employee Id'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.staffId ? s.staffId : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'identidyType' },
                                'Identity Type'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.identidyType ? s.identidyType : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'identidyNo' },
                                'Identity Number'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.identidyNo ? s.identidyNo : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'gender' },
                                'Gender'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.gender ? this.props.genderTxt[s.gender] : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'dob' },
                                'D.O.B'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.dob ? s.dob : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'race' },
                                'Race'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.race ? this.props.raceTxt[s.race] : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'nation' },
                                'Nationality'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.nationality ? s.nationality : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'education' },
                                'Level of Education'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.education ? this.props.educationTxt[s.education] : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'school' },
                                'Name of School (Highest Level)'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.school ? s.school : "--"
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'employmentDate' },
                                'Employment Date'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.employmentDate ? s.employmentDate : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'status' },
                                'Employment Status'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                this.props.statusTxt[s.status]
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'department' },
                                'Department'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.department ? this.props.departmentTxt[s.department] : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'designation' },
                                'Designation'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.role ? this.props.roleTxt[parseInt(s.role)] : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'officeExtNo' },
                                'Office Ext No.'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.officeExtNo ? s.officeExtNo : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'email' },
                                'Email address'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.email ? s.email : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'supervisor' },
                                'Reporting Manager'
                            ),
                            this.renderSupervisor(s.supervisor)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'OT Claim'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.otClaim ? "Yes" : "No"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'remark' },
                                'Remark'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.remark ? s.remark : "--"
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ui-pre-w' },
                            _react2.default.createElement('img', { className: 'ui-pre', src: s.userImage, attribute: 'staff Picture Preview' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'startWork' },
                                'Start Work'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.startWork ? s.startWork : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'endWork' },
                                'End Work'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.endWork ? s.endWork : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'startLunch' },
                                'Lunch Time Start'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.startLunch ? s.startLunch : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'endLunch' },
                                'Lunch Time End'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.endLunch ? s.endLunch : "--"
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'h4',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Residential Address'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'streetName' },
                                'STREET NAME'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.streetName ? s.streetName : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'blkNo' },
                                'APT/BLK NO.'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.blkNo ? s.blkNo : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'unitNo' },
                                'UNIT NO.'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.unitNo ? s.unitNo : "--"
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'postal' },
                                'POSTAL CODE'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.postal ? s.postal : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'homeTel' },
                                'Home Tel.'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.homeTel ? s.homeTel : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'handPhone' },
                                'HAND PHONE'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.handPhone ? s.handPhone : "--"
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'us-em-tt' },
                            'Emergency Contact'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'emgName' },
                                'NAME'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.emgName ? s.emgName : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'emgContactNo' },
                                'CONTACT NO'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.emgContactNo ? s.emgContactNo : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'emgRelationship' },
                                'RELATIONSHIP'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-item' },
                                s.emgRelationship ? s.emgRelationship : "--"
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'h4',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Company Issue'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'comHandphone' },
                                'HANDPHONE'
                            ),
                            _react2.default.createElement(
                                'label',
                                null,
                                'Number'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-un1' },
                                s.comHandphone ? s.comHandphone.number : "N/A"
                            ),
                            _react2.default.createElement(
                                'label',
                                null,
                                'Model'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-un1' },
                                s.comHandphone ? s.comHandphone.model : "N/A"
                            ),
                            _react2.default.createElement(
                                'label',
                                null,
                                'Serial'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-un1' },
                                s.comHandphone ? s.comHandphone.serial : "N/A"
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'comLaptop' },
                                'Laptop'
                            ),
                            _react2.default.createElement(
                                'label',
                                null,
                                'Number'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-un1' },
                                s.comLaptop ? s.comLaptop.number : "N/A"
                            ),
                            _react2.default.createElement(
                                'label',
                                null,
                                'Model'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-un1' },
                                s.comLaptop ? s.comLaptop.model : "N/A"
                            ),
                            _react2.default.createElement(
                                'label',
                                null,
                                'Serial'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-un1' },
                                s.comLaptop ? s.comLaptop.serial : "N/A"
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'comCabcard' },
                                'CAB CARD'
                            ),
                            _react2.default.createElement(
                                'label',
                                null,
                                'Number'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-un1' },
                                s.comCabcard ? s.comCabcard.number : "N/A"
                            ),
                            _react2.default.createElement(
                                'label',
                                null,
                                'Model'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-un1' },
                                s.comCabcard ? s.comCabcard.model : "N/A"
                            ),
                            _react2.default.createElement(
                                'label',
                                null,
                                'Serial'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'us-un1' },
                                s.comCabcard ? s.comCabcard.serial : "N/A"
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-primary us-cr',
                                'data-index': '0', onClick: this.handleClick },
                            'Print'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-primary us-cr',
                                'data-index': '1', onClick: this.handleClick },
                            'Export'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default us-cr',
                                'data-index': '2', onClick: this.handleClick },
                            'Back'
                        )
                    ),
                    _react2.default.createElement('div', { className: 'clear' })
                )
            );
            /*
            <div className="row emp-pms">
                <h4><b>Permission Granted</b></h4>
                <div className="col-md-12">
                    {this.renderPermission(s.permission)}
                </div>
            </div>
            */
        }
    }]);

    return EmployeeProfile;
}(_react2.default.Component);

EmployeeProfile.defaultProps = {
    roleTxt: ["Administrative Executive", "Property Executive", "Property Manager", "Human Resource Executive", "Contracts Management Executive", "Accounts Executive", "Accounts Manager", "Information Technology", "Managing Director", "Director", "Other", "Cleaner Supervisor", "Cleaner", "Landscaper", "Electrician", "Caretaker", "Portfolio Manager", "Team Manager", "Senior Admin Executive"],
    departmentTxt: ["Accounts", "HR", "Operations", "Management", "IT", "Admin", "A4FM"],
    statusTxt: ["Employed", "Resigned", "Dismissed", "Terminated"],
    genderTxt: ["Male", "Female"],
    raceTxt: ["Chinese", "Malay", "Indian", "Other"],
    educationTxt: ["Primary", "N-level", "O-Level", "GCE 'A' Level", "Diploma", "Bachelor", "Master", "Other"]
};
exports.default = EmployeeProfile;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _empCard = __webpack_require__(256);

var _empCard2 = _interopRequireDefault(_empCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmployeeBody = function (_React$Component) {
    _inherits(EmployeeBody, _React$Component);

    function EmployeeBody(props) {
        _classCallCheck(this, EmployeeBody);

        return _possibleConstructorReturn(this, (EmployeeBody.__proto__ || Object.getPrototypeOf(EmployeeBody)).call(this, props));
    }

    _createClass(EmployeeBody, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var employeeList = void 0;
            if (this.props.staffs) {
                employeeList = this.props.staffs.map(function (staff, index) {
                    return _react2.default.createElement(_empCard2.default, { staff: staff, key: index, history: _this2.props.history });
                });
            }
            return _react2.default.createElement(
                'div',
                { className: 'atd-bd-wp' },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-em-lt' },
                    employeeList
                )
            );
        }
    }]);

    return EmployeeBody;
}(_react2.default.Component);

exports.default = EmployeeBody;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _employeeAction = __webpack_require__(33);

var _employeeAction2 = _interopRequireDefault(_employeeAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmpCard = function (_React$Component) {
    _inherits(EmpCard, _React$Component);

    function EmpCard(props) {
        _classCallCheck(this, EmpCard);

        var _this = _possibleConstructorReturn(this, (EmpCard.__proto__ || Object.getPrototypeOf(EmpCard)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(EmpCard, [{
        key: 'handleClick',
        value: function handleClick(e) {
            _employeeAction2.default.staffId(this.props.staff.staffId);
            _employeeAction2.default.displayDetail(true);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-card', onClick: this.handleClick },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-img-wp' },
                    _react2.default.createElement('img', { className: 'atd-img', src: this.props.staff.userImage })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'atd-nm' },
                    this.props.staff.userName,
                    _react2.default.createElement(
                        'b',
                        null,
                        this.props.staff.status != 0 ? " - " + this.props.statusTxt[this.props.staff.status] : ""
                    )
                )
            );
        }
    }]);

    return EmpCard;
}(_react2.default.Component);

EmpCard.defaultProps = {
    statusTxt: ["Employed", "Resigned", "Dismissed", "Terminated"]
};
exports.default = EmpCard;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _contractorAction = __webpack_require__(14);

var _contractorAction2 = _interopRequireDefault(_contractorAction);

var _contractorStore = __webpack_require__(29);

var _contractorStore2 = _interopRequireDefault(_contractorStore);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _contractorHeader = __webpack_require__(86);

var _contractorHeader2 = _interopRequireDefault(_contractorHeader);

var _contractorBody = __webpack_require__(258);

var _contractorBody2 = _interopRequireDefault(_contractorBody);

var _contractorDisplay = __webpack_require__(88);

var _contractorDisplay2 = _interopRequireDefault(_contractorDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Contractor = function (_React$Component) {
    _inherits(Contractor, _React$Component);

    function Contractor(props) {
        _classCallCheck(this, Contractor);

        var _this = _possibleConstructorReturn(this, (Contractor.__proto__ || Object.getPrototypeOf(Contractor)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.state = {
            staffs: _filterStore2.default.getState().staffs,
            iniLoadStaff: _filterStore2.default.getState().iniLoadStaff,
            processingFilter: _filterStore2.default.getState().processing,
            contractors: _contractorStore2.default.getState().contractors,
            processing: _contractorStore2.default.getState().processing,

            condos: _contractorStore2.default.getState().condos,
            iniLoadCondo: _contractorStore2.default.getState().iniLoadCondo,
            updating: _contractorStore2.default.getState().updating,
            staffId: _contractorStore2.default.getState().staffId,
            mcst: _contractorStore2.default.getState().mcst,
            search: _contractorStore2.default.getState().search,
            contractorId: _contractorStore2.default.getState().contractorId,
            searchMode: _contractorStore2.default.getState().searchMode

        };
        return _this;
    }

    _createClass(Contractor, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _menuAction2.default.pageNumber(8);
            _contractorStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);

            if (!this.state.iniLoadCondo && !this.state.processing) {
                _contractorAction2.default.processing(true);
                _contractorAction2.default.getCondoList();
            }
            if (!this.state.iniLoadStaff) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getEmployee();
            }

            _contractorAction2.default.reset();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _contractorStore2.default.unlisten(this.onChange);
            _filterStore2.default.unlisten(this.onFilterChange);
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                processingFilter: state.processing,
                staffs: state.staffs,
                iniLoadStaff: state.iniLoadStaff
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                iniLoadCondo: state.iniLoadCondo,
                condos: state.condos,
                iniLoad: state.iniLoad,
                processing: state.processing,
                contractors: state.contractors,
                updating: state.updating,
                search: state.search,
                contractorId: state.contractorId,
                mcst: state.mcst,
                staffId: state.staffId,
                searchMode: state.searchMode
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            if (index == 0) {
                window.print();
            } else if (index == 1) {
                _contractorAction2.default.processing(true);
                _contractorAction2.default.getExportContractorList(this.state.searchMode, this.state.mcst, this.state.staffId, this.state.search);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var contractorList = void 0,
                body = "",
                header = "";

            if (!this.state.updating) {
                header = _react2.default.createElement(_contractorHeader2.default, { condos: this.state.condos, staffs: this.state.staffs, processing: this.state.processing });
                body = _react2.default.createElement(_contractorBody2.default, { contractors: this.state.contractors });
            } else {
                body =
                //new contractor
                _react2.default.createElement(_contractorDisplay2.default, { processing: this.state.processing });
            }

            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 us-form' },
                        header,
                        _react2.default.createElement('div', { className: 'divider' }),
                        body,
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-4' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'warning' },
                                    this.state.warningMsg
                                ),
                                _react2.default.createElement(
                                    'button',
                                    { type: 'button', className: 'btn btn-primary us-cr',
                                        'data-index': '0', onClick: this.handleClick },
                                    'Print'
                                ),
                                _react2.default.createElement(
                                    'button',
                                    { type: 'button', className: 'btn btn-primary us-cr',
                                        'data-index': '1', onClick: this.handleClick },
                                    'Export'
                                )
                            ),
                            _react2.default.createElement('div', { className: 'clear' })
                        )
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.processingFilter })
            );
        }
    }]);

    return Contractor;
}(_react2.default.Component);

exports.default = Contractor;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(1);

var _contractorList = __webpack_require__(259);

var _contractorList2 = _interopRequireDefault(_contractorList);

var _contractorAction = __webpack_require__(14);

var _contractorAction2 = _interopRequireDefault(_contractorAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractorBody = function (_React$Component) {
    _inherits(ContractorBody, _React$Component);

    function ContractorBody(props) {
        _classCallCheck(this, ContractorBody);

        var _this = _possibleConstructorReturn(this, (ContractorBody.__proto__ || Object.getPrototypeOf(ContractorBody)).call(this, props));

        _this.onTouchStart = _this.onTouchStart.bind(_this);
        _this.onTouchMove = _this.onTouchMove.bind(_this);
        _this.onTouchEnd = _this.onTouchEnd.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleMouseScroll = _this.handleMouseScroll.bind(_this);
        _this.state = {
            tableWidth: 300,
            dragging: false,
            refX: 0,
            ini: 0,
            page: 0,
            contentNo: 10
        };
        return _this;
    }

    _createClass(ContractorBody, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var tableWidth = _reactDom2.default.findDOMNode(this.refs.ctr).clientWidth;
            this.setState({
                tableWidth: tableWidth
            });
            if (document.body.clientWidth > 768) {
                var elem = _reactDom2.default.findDOMNode(this.refs.table);
                elem.addEventListener('mouseup', this.onTouchEnd);
                elem.addEventListener('mouseleave', this.onTouchEnd);
                elem.addEventListener('mousemove', this.onTouchMove);
                elem.addEventListener('mousedown', this.onTouchStart);
                window.addEventListener('wheel', this.handleMouseScroll);
            }
            window.addEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (document.body.clientWidth > 768) {
                var elem = _reactDom2.default.findDOMNode(this.refs.table);
                elem.removeEventListener('mouseup', this.onTouchEnd);
                elem.removeEventListener('mouseleave', this.onTouchEnd);
                elem.removeEventListener('mousemove', this.onTouchMove);
                elem.removeEventListener('mousedown', this.onTouchStart);
                window.removeEventListener('wheel', this.handleMouseScroll);
            }
            window.removeEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevProps.contractors != this.props.contractors) {
                this.setState({
                    page: 0
                });
            }
        }
    }, {
        key: 'handleMouseScroll',
        value: function handleMouseScroll(e) {
            e.preventDefault();
            if (e.deltaY > 0) {
                //scroll down
                window.scrollBy(0, 50);
            } else {
                //scroll up
                window.scrollBy(0, -50);
            }
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.currentTarget.getAttribute('data-index'));

            if (index != this.state.page) {
                this.setState({ page: index });
            }
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(e) {
            var elem1 = _reactDom2.default.findDOMNode(this.refs.ctr);
            var elem2 = _reactDom2.default.findDOMNode(this.refs.table);
            if (elem2.getBoundingClientRect().top < 50) {

                elem1.style.position = "absolute";

                if (document.body.clientWidth > 600) {
                    elem2.style.paddingTop = "50px";
                    elem1.style.top = 50 - elem2.getBoundingClientRect().top + "px";
                } else {
                    elem2.style.paddingTop = "0px";
                    elem1.style.top = -elem2.getBoundingClientRect().top + "px";
                }
            } else {
                elem1.style.position = "relative";
                elem1.style.top = "0px";
                elem2.style.paddingTop = "0px";
            }
        }
    }, {
        key: 'onTouchStart',
        value: function onTouchStart(e) {
            if (!this.state.dragging) {
                var touches = e.changedTouches;
                var refX = void 0;
                if (e.touches) {
                    refX = e.touches[0].clientX;
                } else {
                    refX = e.clientX;
                }
                var ini = _reactDom2.default.findDOMNode(this.refs.table).scrollLeft;
                this.setState({
                    ini: ini,
                    refX: refX,
                    dragging: true
                });
            } else {
                this.setState({
                    dragging: false
                });
            }
        }
    }, {
        key: 'onTouchMove',
        value: function onTouchMove(e) {
            e.preventDefault();
            if (this.state.dragging && e.target) {
                var deltaX = void 0;
                if (e.touches) {
                    deltaX = parseInt(this.state.refX - e.touches[0].clientX);
                } else {
                    deltaX = parseInt(this.state.refX - e.clientX);
                }

                _reactDom2.default.findDOMNode(this.refs.table).scrollLeft = this.state.ini + deltaX;
            } else {
                this.setState({
                    dragging: false
                });
            }
        }
    }, {
        key: 'onTouchEnd',
        value: function onTouchEnd(e) {
            this.setState({
                dragging: false
            });
        }
    }, {
        key: 'renderPagination',
        value: function renderPagination() {
            if (!this.props.contractors) return;
            if (this.props.contractors.length == 0) return;

            var pageNo = Math.ceil(this.props.contractors.length / this.state.contentNo);

            var pagination = [];
            for (var i = 0; i < pageNo; i++) {
                pagination = pagination.concat(_react2.default.createElement(
                    'li',
                    { className: this.state.page == i ? "active" : "", key: i, 'data-index': i, onClick: this.handleClick },
                    _react2.default.createElement(
                        'a',
                        { href: '#' },
                        i + 1
                    )
                ));
            }
            return _react2.default.createElement(
                'nav',
                { className: 'ctr-pg' },
                _react2.default.createElement(
                    'ul',
                    { className: 'pagination' },
                    pagination
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'pagination-title' },
                    'page ',
                    this.state.page + 1 + " of " + pageNo
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var contractors = [];
            for (var i = 0 + this.state.contentNo * this.state.page; i < this.state.contentNo + this.state.contentNo * this.state.page; i++) {
                if (i < this.props.contractors.length) {
                    contractors = contractors.concat(this.props.contractors[i]);
                }
            }
            return _react2.default.createElement(
                'div',
                null,
                this.renderPagination(),
                _react2.default.createElement(
                    'div',
                    { className: 'est-bd-wp', ref: 'table' },
                    _react2.default.createElement(
                        'div',
                        { className: 'ctr-bd' },
                        _react2.default.createElement(
                            'table',
                            { className: 'ctr-tb tb-heading', ref: 'ctr' },
                            _react2.default.createElement(
                                'thead',
                                null,
                                _react2.default.createElement(
                                    'tr',
                                    null,
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'MCST'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Estate'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'No of Units'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Address'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'ManageBy'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Manager'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Contractor'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Service'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Description'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Last Visit'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Contractor Address'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Contact Name'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Telephone'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Fax'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Contractor Email'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Status'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Contract Start Date'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Contract End Date'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'First Reminder'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Second Reminder'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Contract Due In (days)'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Amount'
                                    ),
                                    _react2.default.createElement(
                                        'th',
                                        null,
                                        'Remark'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(_contractorList2.default, { contractors: contractors, tableWidth: this.state.tableWidth,
                            page: this.state.page, contentNo: this.state.contentNo })
                    )
                ),
                this.renderPagination()
            );
        }
    }]);

    return ContractorBody;
}(_react2.default.Component);

ContractorBody.defaultProps = {
    monthTxt: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]
};
exports.default = ContractorBody;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _contractorAction = __webpack_require__(14);

var _contractorAction2 = _interopRequireDefault(_contractorAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractorList = function (_React$Component) {
    _inherits(ContractorList, _React$Component);

    function ContractorList(props) {
        _classCallCheck(this, ContractorList);

        var _this = _possibleConstructorReturn(this, (ContractorList.__proto__ || Object.getPrototypeOf(ContractorList)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(ContractorList, [{
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.currentTarget.getAttribute("data-index"));
            index = index + this.props.page * this.props.contentNo;
            _contractorAction2.default.shouldConListShow(index);
        }
    }, {
        key: 'renderPE',
        value: function renderPE(manageBy) {
            if (!manageBy) return;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'b',
                    null,
                    manageBy.userName
                ),
                _react2.default.createElement('br', null),
                '(',
                this.props.roleTxt[manageBy.role],
                ')',
                _react2.default.createElement('br', null),
                manageBy.email,
                _react2.default.createElement('br', null),
                manageBy.handPhone
            );
        }
    }, {
        key: 'renderAddress',
        value: function renderAddress(streetName, blkNo, unitNo, postal) {
            return _react2.default.createElement(
                'div',
                null,
                streetName ? streetName + " , \n" : "",
                blkNo ? "#" + blkNo + "-" : "",
                unitNo ? unitNo + ", \n" : "",
                postal
            );
        }
    }, {
        key: 'generateDateFormat',
        value: function generateDateFormat(date) {
            if (date) {
                return date.getDate() + "-" + this.props.mthTxt[date.getMonth()] + "-" + date.getFullYear();
            }
        }
    }, {
        key: 'renderDataList',
        value: function renderDataList(condo, contractor, service, index, index1, index2) {
            var contractStartDate = service.contractStartDate ? this.generateDateFormat(new Date(service.contractStartDate)) : "";
            var contractEndDate = service.contractEndDate ? this.generateDateFormat(new Date(service.contractEndDate)) : "";
            var firstReminder = service.firstReminder ? this.generateDateFormat(new Date(service.firstReminder)) : "";
            var secReminder = service.secondReminder ? this.generateDateFormat(new Date(service.secondReminder)) : "";
            var lastVisit = service.lastVisit ? this.generateDateFormat(new Date(service.lastVisit)) : "";
            var dueDays = 0;
            if (service.contractEndDate) {
                dueDays = Math.ceil((new Date(service.contractEndDate).getTime() - new Date().getTime()) / 1000 / 3600 / 24);
            }
            console.log(service);
            return _react2.default.createElement(
                'tr',
                { key: index2 },
                _react2.default.createElement(
                    'td',
                    null,
                    condo.mcst
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/condo/' + condo.mcst },
                        condo.condoName
                    )
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    condo.noUnit
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    condo.address,
                    ', ',
                    condo.postal
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.renderPE(condo.manageBy)
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.renderPE(condo.supervisor)
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/contractor/' + contractor._id },
                        contractor.contractorName
                    )
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    service.service
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    service.description
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    lastVisit ? lastVisit : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    this.renderAddress(contractor.streetName, contractor.blkNo, contractor.unitNo, contractor.postal)
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    contractor.contactName ? contractor.contactName : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    contractor.telephone ? contractor.telephone : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    contractor.fax ? contractor.fax : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    contractor.contractorEmail
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    typeof service.status == 'number' ? this.props.statusTxt[service.status] : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    contractStartDate
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    contractEndDate
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    firstReminder ? firstReminder : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    secReminder ? secReminder : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    dueDays ? dueDays : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    service.amount ? "$" + service.amount : "--"
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    service.remark ? service.remark : "--"
                )
            );
        }
    }, {
        key: 'renderContractorList',
        value: function renderContractorList(condo, contractor, index, index1) {
            var _this2 = this;

            if (!contractor.contract) {
                return this.renderDataList(condo, contractor, "", index, index1, -1);
            } else {
                return contractor.contract.map(function (service, index2) {
                    return _this2.renderDataList(condo, contractor, service, index, index1, index2);
                });
            }
        }
    }, {
        key: 'renderDataLists',
        value: function renderDataLists(condo, index) {
            var _this3 = this;

            var body = void 0;
            if (!condo.contractors || condo.contractors.length == 0) {
                body = this.renderContractorList(condo, [], index, -1);
            } else {
                body = condo.contractors.map(function (contractor, index1) {
                    return _this3.renderContractorList(condo, contractor, index, index1);
                });
            }

            return _react2.default.createElement(
                'table',
                { className: "ctr-tb " + (condo.shouldListShow ? "est-show" : "est-hide") },
                _react2.default.createElement(
                    'tbody',
                    { className: 'ctr-tbd' },
                    body
                )
            );
        }
    }, {
        key: 'renderNameList',
        value: function renderNameList(condo, index) {
            return _react2.default.createElement(
                'div',
                { className: 'est-a-nlw', style: { width: this.props.tableWidth + "px" } },
                _react2.default.createElement('i', { className: "est-a-nli " + (condo.shouldListShow ? "glyphicon glyphicon-minus" : "glyphicon glyphicon-plus"),
                    onClick: this.handleClick, 'data-index': index }),
                _react2.default.createElement(
                    'div',
                    { className: 'ctr-tt-1 est-a-nl est-a-n', onClick: this.handleClick, 'data-index': index },
                    condo.condoName,
                    ' (',
                    condo.mcst,
                    ')'
                )
            );
        }
    }, {
        key: 'renderMainList',
        value: function renderMainList() {
            var _this4 = this;

            return this.props.contractors.map(function (condo, index) {
                return _react2.default.createElement(
                    'div',
                    { key: index },
                    _this4.renderNameList(condo, index),
                    _this4.renderDataLists(condo, index)
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'atd-abd-wp' },
                _react2.default.createElement(
                    'div',
                    { className: 'atd-em-lt' },
                    this.renderMainList()
                )
            );
        }
    }]);

    return ContractorList;
}(_react2.default.Component);

ContractorList.defaultProps = {
    mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    statusTxt: ["Active", "In-Active", "Terminated", "Ad hoc"],
    roleTxt: ["Administrative Executive", "Property Executive", "Property Manager", "Human Resource Executive", "Contracts Management Executive", "Accounts Executive", "Accounts Manager", "Information Technology", "Managing Director", "Director", "Other", "Cleaner Supervisor", "Cleaner", "Landscaper", "Electrician", "Caretaker", "Portfolio Manager", "Team Manager", "Senior Admin Executive"]
};
exports.default = ContractorList;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _condoSetAction = __webpack_require__(23);

var _condoSetAction2 = _interopRequireDefault(_condoSetAction);

var _condoSetStore = __webpack_require__(39);

var _condoSetStore2 = _interopRequireDefault(_condoSetStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CondoDisplay = function (_React$Component) {
    _inherits(CondoDisplay, _React$Component);

    function CondoDisplay(props) {
        _classCallCheck(this, CondoDisplay);

        var _this = _possibleConstructorReturn(this, (CondoDisplay.__proto__ || Object.getPrototypeOf(CondoDisplay)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.state = {
            condo: _condoSetStore2.default.getState().condo,
            processing: _condoSetStore2.default.getState().processing,
            warningMsg: ""

        };
        return _this;
    }

    _createClass(CondoDisplay, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _condoSetStore2.default.listen(this.onChange);
            _menuAction2.default.pageNumber({ selectedActivity: -1, selectedCategory: 0 });
            _condoSetAction2.default.clear();
            if (!this.state.processing) {
                _condoSetAction2.default.processing(true);
                _condoSetAction2.default.getCondo(this.props.match.params.id);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _condoSetStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                condo: state.condo,
                processing: state.processing
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            if (index == 0) {
                window.print();
            } else if (index == 1) {
                if (this.props.processing) return;

                _condoSetAction2.default.processing(true);
                _condoSetAction2.default.exportCondo(this.props.match.params.id);
            } else {
                this.props.history.push('/contractor');
            }
        }
    }, {
        key: 'generateDateFormat',
        value: function generateDateFormat(date) {
            if (date) {
                return date.getDate() + "-" + this.props.mthTxt[date.getMonth()] + "-" + date.getFullYear();
            }
        }
    }, {
        key: 'renderDetail',
        value: function renderDetail(staff) {
            //address: "Blk 446 Hougang Ave 8", unitNo: "B1-1635", postal: "530446"
            if (!staff) return;
            return _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'ct-li-group-1' },
                    _react2.default.createElement(
                        'label',
                        null,
                        'Employee Name:'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-ct' },
                        staff.userName
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ct-li-group-1' },
                    _react2.default.createElement(
                        'label',
                        null,
                        'Role:'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-ct' },
                        this.props.roleTxt[staff.role]
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ct-li-group-1' },
                    _react2.default.createElement(
                        'label',
                        null,
                        'Email:'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-ct' },
                        staff.email
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ct-li-group-1' },
                    _react2.default.createElement(
                        'label',
                        null,
                        'Handphone:'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-ct' },
                        staff.handPhone ? staff.handPhone : "--"
                    )
                )
            );
        }
    }, {
        key: 'renderStaff',
        value: function renderStaff(staff) {
            var managed = this.renderDetail(staff);
            return _react2.default.createElement(
                'ul',
                { className: 'ct-aul' },
                managed
            );
        }
    }, {
        key: 'renderConDetail',
        value: function renderConDetail(contractor) {
            var _this2 = this;

            var content = _react2.default.createElement(
                'div',
                { className: 'cd-ct1 ' },
                _react2.default.createElement(
                    'div',
                    { className: 'ct-col-1' },
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'email:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            contractor.contractorEmail
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-li-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            'telephone:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-ct' },
                            contractor.telephone
                        )
                    )
                )
            );
            var contentList = contractor.contract.map(function (detail, index) {
                var contractStartDate = detail.contractStartDate ? _this2.generateDateFormat(new Date(detail.contractStartDate)) : "";
                var contractEndDate = detail.contractEndDate ? _this2.generateDateFormat(new Date(detail.contractEndDate)) : "";
                var firstReminder = detail.firstReminder ? _this2.generateDateFormat(new Date(detail.firstReminder)) : "";
                var secReminder = detail.secondReminder ? _this2.generateDateFormat(new Date(detail.secondReminder)) : "";
                var lastVisit = detail.lastVisit ? _this2.generateDateFormat(new Date(detail.lastVisit)) : "";
                var dueDays = 0;
                if (detail.contractEndDate) {
                    dueDays = Math.ceil((new Date(detail.contractEndDate).getTime() - new Date().getTime()) / 1000 / 3600 / 24);
                }
                return _react2.default.createElement(
                    'li',
                    { key: index },
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-col-1' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Service:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                detail.service
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Description:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                detail.description
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Last Visit:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                lastVisit ? lastVisit : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Remark:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                detail.remark ? detail.remark : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Amount (SGD):'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                detail.amount ? "$" + detail.amount : "--"
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-col-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Status'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                typeof detail.status == 'number' ? _this2.props.ctrStatusTxt[detail.status] : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Contract Start Date:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                contractStartDate ? contractStartDate : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Contract End Date:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                contractEndDate ? contractEndDate : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Contract Due In (days):'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: "ct-li-ct " + (dueDays >= 0 ? "ct-green" : "ct-red") },
                                dueDays ? dueDays : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'First Reminder:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                firstReminder ? firstReminder : "--"
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-li-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Second Reminder:'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ct-li-ct' },
                                secReminder ? secReminder : "--"
                            )
                        )
                    )
                );
            });
            return _react2.default.createElement(
                'div',
                { className: 'cd-wp' },
                content,
                _react2.default.createElement(
                    'ul',
                    { className: 'ct-cul ' },
                    contentList
                )
            );
        }
    }, {
        key: 'renderContractor',
        value: function renderContractor() {
            var _this3 = this;

            var s = this.state.condo;

            return s.contractors.map(function (contractor, index) {
                return _react2.default.createElement(
                    'div',
                    { key: index },
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-cli', key: index },
                        _react2.default.createElement(
                            'div',
                            { className: 'ct-cn' },
                            contractor.contractorName
                        )
                    ),
                    _this3.renderConDetail(contractor)
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var s = this.state.condo;

            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(_loading2.default, _extends({}, this.props, { processing: this.state.processing })),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 us-form' },
                        _react2.default.createElement(
                            'div',
                            { className: 'condo-form' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-6' },
                                    _react2.default.createElement(
                                        'h4',
                                        null,
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            'Estate Details'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'mcst' },
                                            'MCST'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'ct-item' },
                                            s.mcst
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'condoName' },
                                            'Estate Name'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'ct-item' },
                                            s.condoName
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'noUnit' },
                                            'No of Units'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'ct-item' },
                                            s.noUnit
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'address' },
                                            'Address'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'ct-item' },
                                            s.address
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'postal' },
                                            'Postal'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'ct-item' },
                                            s.postal
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'status' },
                                            'Status'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'ct-item' },
                                            this.props.statusTxt[s.status]
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'manageBy' },
                                        'Managed By:'
                                    ),
                                    this.renderStaff(s.manageBy),
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'manageBy' },
                                        'Manager:'
                                    ),
                                    this.renderStaff(s.supervisor)
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-6' },
                                    _react2.default.createElement(
                                        'h5',
                                        null,
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            'Contractors'
                                        )
                                    ),
                                    this.renderContractor()
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-4' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'warning' },
                                        this.state.warningMsg
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-primary us-cr',
                                            'data-index': '0', onClick: this.handleClick },
                                        'Print'
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-primary us-cr',
                                            'data-index': '1', onClick: this.handleClick },
                                        'Export'
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-default us-cr',
                                            'data-index': '2', onClick: this.handleClick },
                                        'Cancel'
                                    )
                                ),
                                _react2.default.createElement('div', { className: 'clear' })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return CondoDisplay;
}(_react2.default.Component);

CondoDisplay.defaultProps = {
    mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    roleTxt: ["Administrative Executive", "Property Executive", "Property Manager", "Human Resource Executive", "Contracts Management Executive", "Accounts Executive", "Accounts Manager", "Information Technology", "Managing Director", "Director", "Other", "Cleaner Supervisor", "Cleaner", "Landscaper", "Electrician", "Caretaker", "Portfolio Manager", "Team Manager", "Senior Admin Executive"],
    statusTxt: ["Active", "In-Active"],
    ctrStatusTxt: ["Active", "In-Active", "Terminated", "Ad hoc"]
};
exports.default = CondoDisplay;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _contractorAction = __webpack_require__(14);

var _contractorAction2 = _interopRequireDefault(_contractorAction);

var _contractorStore = __webpack_require__(29);

var _contractorStore2 = _interopRequireDefault(_contractorStore);

var _contractorCondoForm = __webpack_require__(89);

var _contractorCondoForm2 = _interopRequireDefault(_contractorCondoForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractorNewForm = function (_React$Component) {
    _inherits(ContractorNewForm, _React$Component);

    function ContractorNewForm(props) {
        _classCallCheck(this, ContractorNewForm);

        var _this = _possibleConstructorReturn(this, (ContractorNewForm.__proto__ || Object.getPrototypeOf(ContractorNewForm)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleCheck = _this.handleCheck.bind(_this);
        _this.state = {
            processingFilter: _filterStore2.default.getState().processing,
            condos: _filterStore2.default.getState().condos,
            iniLoadCondo: _filterStore2.default.getState().iniLoadCondo,

            contractor: _contractorStore2.default.getState().contractor,
            processing: _contractorStore2.default.getState().processing,
            warningMsg: ""
        };
        return _this;
    }

    _createClass(ContractorNewForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _contractorStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);
            _contractorAction2.default.clear();
            _menuAction2.default.pageNumber({ selectedActivity: -1, selectedCategory: 1 });
            if (!this.state.iniLoadCondo && !this.state.processingFilter) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getCondoList();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _contractorStore2.default.unlisten(this.onChange);
            _filterStore2.default.unlisten(this.onFilterChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                contractor: state.contractor,
                processing: state.processing
            });
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                processingFilter: state.processing,
                iniLoadCondo: state.iniLoadCondo,
                condos: state.condos
            });
        }
    }, {
        key: 'handleCheck',
        value: function handleCheck(e) {
            var checked = e.target.checked;

            var s = this.state.contractor;
            s.isGSTRegister = checked;
            _contractorAction2.default.contractor(s);
        }
    }, {
        key: 'handleEdit',
        value: function handleEdit(e) {
            var index = parseInt(e.target.getAttribute('data-index'));

            var value = e.target.value;
            var s = this.state.contractor;

            switch (index) {
                case 0:
                    s.contractorName = value;
                    break;
                case 1:
                    s.telephone = value;
                    break;
                case 2:
                    s.fax = value;
                    break;
                case 3:
                    s.contractorEmail = value;
                    break;
                case 4:
                    s.contactName = value;
                    break;
                /*
                case 5:
                    s.status = parseInt(value);
                    break;
                */
                case 6:
                    s.streetName = value;
                    break;
                case 7:
                    s.blkNo = value;
                    break;
                case 8:
                    s.unitNo = value;
                    break;
                case 9:
                    s.postal = parseInt(value);
                    break;
            }

            _contractorAction2.default.contractor(s);
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            if (index == 1) {
                this.props.history.push('/contractorSetting');
            } else if (index == 0) {
                if (this.props.processing) return;

                _contractorAction2.default.processing(true);
                _contractorAction2.default.addContractor(this.state.contractor);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var s = this.state.contractor;

            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(_loading2.default, _extends({}, this.props, { processing: this.state.processing || this.state.processingFilter })),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 us-form' },
                        _react2.default.createElement(
                            'div',
                            { className: 'contractorSet-form' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'h3',
                                    null,
                                    _react2.default.createElement(
                                        'b',
                                        null,
                                        'Add New Contractor'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    _react2.default.createElement(
                                        'h4',
                                        null,
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            'Contractor Details'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'contractorName' },
                                            'Name of Contractor'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.contractorName, id: 'contractorName',
                                            placeholder: 'Type the name of contractor here', 'data-index': '0', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'telephone' },
                                            'Telephone'
                                        ),
                                        _react2.default.createElement('input', { type: 'number', className: 'form-control', value: s.telephone, id: 'telephone',
                                            placeholder: 'e.g. 9XXX XXXX', 'data-index': '1', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'fax' },
                                            'Fax'
                                        ),
                                        _react2.default.createElement('input', { type: 'number', className: 'form-control', value: s.fax, id: 'fax',
                                            placeholder: 'e.g. 9XXX XXXX', 'data-index': '2', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'contractorEmail' },
                                            'Contractor Email'
                                        ),
                                        _react2.default.createElement('input', { type: 'email', className: 'form-control', value: s.contractorEmail, id: 'contractorEmail',
                                            placeholder: 'Type contractor email here', 'data-index': '3', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'contactName' },
                                            'Contact Name'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.contactName, id: 'contactName',
                                            placeholder: 'Type contact name here', 'data-index': '4', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'totalAmount' },
                                            'Total Contract Amount (SGD)'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.totalAmount, id: 'totalAmount',
                                            disabled: true })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'streetName' },
                                            'Street Name/Building Name'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.streetName, id: 'streetName', 'data-index': '6',
                                            onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'blkNo' },
                                            'Block No.'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.blkNo, id: 'blkNo', 'data-index': '7',
                                            onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'unitNo' },
                                            'Unit No.'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.unitNo, id: 'unitNo', 'data-index': '8',
                                            onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'postal' },
                                            'Postal'
                                        ),
                                        _react2.default.createElement('input', { type: 'number', className: 'form-control', value: s.postal, id: 'postal', 'data-index': '9',
                                            onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'checkbox' },
                                            _react2.default.createElement(
                                                'label',
                                                null,
                                                _react2.default.createElement('input', { type: 'checkbox',
                                                    onChange: this.handleCheck, checked: s.isGSTRegister }),
                                                _react2.default.createElement('span', { className: 'checkmark' }),
                                                'GST registered Company'
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    _react2.default.createElement(_contractorCondoForm2.default, { contractor: s, condos: this.state.condos })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-4' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'warning' },
                                        this.state.warningMsg
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-warning us-cr',
                                            'data-index': '0', onClick: this.handleClick },
                                        'Create'
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-default us-cr',
                                            'data-index': '1', onClick: this.handleClick },
                                        'Cancel'
                                    )
                                ),
                                _react2.default.createElement('div', { className: 'clear' })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ContractorNewForm;
}(_react2.default.Component);

ContractorNewForm.defaultProps = {
    statusTxt: ["Active", "In-Active", "Terminated", "Ad hoc", "Unknown"]
};
exports.default = ContractorNewForm;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userSetAction = __webpack_require__(15);

var _userSetAction2 = _interopRequireDefault(_userSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalCondo = function (_React$Component) {
    _inherits(ModalCondo, _React$Component);

    function ModalCondo(props) {
        _classCallCheck(this, ModalCondo);

        var _this = _possibleConstructorReturn(this, (ModalCondo.__proto__ || Object.getPrototypeOf(ModalCondo)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.state = {
            txtValue1: "",
            txtValue2: "",
            txtValue3: "",
            txtValue4: "",
            txtValue5: "",
            txtValue6: "",
            txtValue7: "",
            txtValue8: 0,
            warningMsg: ""
        };
        return _this;
    }

    _createClass(ModalCondo, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.action == 3) {
                var condoIndex = this.findIndex();
                this.setState({
                    txtValue1: this.props.contracts[condoIndex].contract[this.props.index].service,
                    txtValue2: this.props.contracts[condoIndex].contract[this.props.index].description,
                    txtValue3: this.props.contracts[condoIndex].contract[this.props.index].remark,
                    txtValue4: this.props.contracts[condoIndex].contract[this.props.index].amount,
                    txtValue5: this.props.contracts[condoIndex].contract[this.props.index].contractStartDate,
                    txtValue6: this.props.contracts[condoIndex].contract[this.props.index].contractEndDate,
                    txtValue7: this.props.contracts[condoIndex].contract[this.props.index].lastVisit,
                    txtValue8: this.props.contracts[condoIndex].contract[this.props.index].status,
                    warningMsg: ""
                });
            } else {
                this.setState({
                    txtValue1: "",
                    txtValue2: "",
                    txtValue3: "",
                    txtValue4: "",
                    txtValue5: "",
                    txtValue6: "",
                    txtValue7: "",
                    txtValue8: 0,
                    warningMsg: ""
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {}
    }, {
        key: 'findIndex',
        value: function findIndex() {
            var len = this.props.contracts.length;
            var pos = void 0;
            for (var i = 0; i < len; i++) {
                if (this.props.contracts[i].mcst == this.props.mcst) {
                    pos = i;
                    break;
                }
            }
            return pos;
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            if (this.props.action == 0) {
                if (this.checkRepeat()) return;
                if (this.state.txtValue1 == '') return this.setState({ warningMsg: "Please select condo" });
            } else if (this.props.action == 1 || this.props.action == 3) {
                if (this.checkEmpty()) return;
            }

            this.props.callBack(this.state.txtValue1, this.state.txtValue2, this.state.txtValue3, this.state.txtValue4, this.state.txtValue5, this.state.txtValue6, this.state.txtValue7, this.state.txtValue8);
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {

            this.props.shouldModalClose(false);
        }
    }, {
        key: 'checkRepeat',
        value: function checkRepeat() {
            var contracts = this.props.contracts;

            var len = contracts.length;
            var isRepeat = false;
            for (var i = 0; i < len; i++) {
                if (contracts[i].mcst == this.state.txtValue1) {
                    isRepeat = true;
                    this.setState({ warningMsg: "The selected condo has been added. Not necessary to add new one" });
                    break;
                }
            }
            return isRepeat;
        }
    }, {
        key: 'checkEmpty',
        value: function checkEmpty() {
            var isEmpty = false;
            if (this.state.txtValue1 == "") {
                isEmpty = true;
                this.setState({ warningMsg: "Service cannot be emptied" });
            }
            return isEmpty;
        }
    }, {
        key: 'findCondoName',
        value: function findCondoName(value) {
            var len = this.props.condos.length;
            var condoName = "";
            for (var i = 0; i < len; i++) {
                if (this.props.condos[i].mcst == value) {
                    condoName = this.props.condos[i].condoName;
                    break;
                }
            }
            return condoName;
        }
    }, {
        key: 'handleEdit',
        value: function handleEdit(e) {
            var index = void 0,
                value = void 0,
                condoName = void 0;
            if (this.props.action == 0) {
                value = e.target.value;
                condoName = this.findCondoName(value);
                this.setState({ txtValue1: value, txtValue2: condoName });
            } else if (this.props.action == 1 || this.props.action == 3) {
                index = parseInt(e.target.getAttribute('data-index'));
                value = e.target.value;
                if (index == 0) {
                    this.setState({ txtValue1: value });
                } else if (index == 1) {
                    this.setState({ txtValue2: value });
                } else if (index == 2) {
                    this.setState({ txtValue3: value });
                } else if (index == 3) {
                    this.setState({ txtValue4: parseFloat(value) });
                } else if (index == 4) {
                    this.setState({ txtValue5: value ? new Date(value) : "" });
                } else if (index == 5) {
                    this.setState({ txtValue6: value ? new Date(value) : "" });
                } else if (index == 6) {
                    this.setState({ txtValue7: value ? new Date(value) : "" });
                } else if (index == 7) {
                    this.setState({ txtValue8: parseInt(value) });
                }
            }
        }
    }, {
        key: 'renderCondoList',
        value: function renderCondoList() {
            return this.props.condos.map(function (condo, index) {
                return _react2.default.createElement(
                    'option',
                    { value: condo.mcst, key: index },
                    condo.condoName,
                    ' (',
                    condo.mcst,
                    ')'
                );
            });
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            var body = "";
            var action = this.props.action;

            if (action == 0) {
                body = _react2.default.createElement(
                    'select',
                    { className: 'form-control', 'data-index': '0', onChange: this.handleEdit },
                    _react2.default.createElement('option', { value: '' }),
                    this.renderCondoList()
                );
            } else if (action == 1) {

                var contractStartDate = "",
                    contractEndDate = "",
                    lastVisit = "";
                var _state = this.state,
                    txtValue5 = _state.txtValue5,
                    txtValue6 = _state.txtValue6,
                    txtValue7 = _state.txtValue7;

                if (txtValue5) {
                    contractStartDate = txtValue5.getFullYear() + "-" + (txtValue5.getMonth() + 1 < 10 ? "0" + (txtValue5.getMonth() + 1) : txtValue5.getMonth() + 1) + "-" + (txtValue5.getDate() < 10 ? "0" + txtValue5.getDate() : txtValue5.getDate());
                }
                if (txtValue6) {
                    contractEndDate = txtValue6.getFullYear() + "-" + (txtValue6.getMonth() + 1 < 10 ? "0" + (txtValue6.getMonth() + 1) : txtValue6.getMonth() + 1) + "-" + (txtValue6.getDate() < 10 ? "0" + txtValue6.getDate() : txtValue6.getDate());
                }
                if (txtValue7) {
                    lastVisit = txtValue7.getFullYear() + "-" + (txtValue7.getMonth() + 1 < 10 ? "0" + (txtValue7.getMonth() + 1) : txtValue7.getMonth() + 1) + "-" + (txtValue7.getDate() < 10 ? "0" + txtValue7.getDate() : txtValue7.getDate());
                }

                body = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mService' },
                            'Service'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.txtValue1, id: 'mService',
                            'data-index': '0', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mDescription' },
                            'Description'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.txtValue2, id: 'mDescription',
                            'data-index': '1', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mLastVisit' },
                            'Last Visit'
                        ),
                        _react2.default.createElement('input', { type: 'date', className: 'form-control', value: lastVisit, id: 'mLastVisit',
                            'data-index': '6', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mStatus' },
                            'Status'
                        ),
                        _react2.default.createElement(
                            'select',
                            { className: 'form-control', id: 'status', 'data-index': '7', value: this.state.txtValue8, onChange: this.handleEdit },
                            this.renderStatusOption()
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mRemark' },
                            'Remark'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.txtValue3, id: 'mRemark',
                            'data-index': '2', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mRemark' },
                            'Contract Start Date'
                        ),
                        _react2.default.createElement('input', { type: 'date', className: 'form-control', value: contractStartDate, id: 'mRemark',
                            'data-index': '4', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mRemark' },
                            'Contract End Date'
                        ),
                        _react2.default.createElement('input', { type: 'date', className: 'form-control', value: contractEndDate, id: 'mRemark',
                            'data-index': '5', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mAmount' },
                            'Amount (SGD)'
                        ),
                        _react2.default.createElement('input', { ttype: 'number', className: 'form-control', value: this.state.txtValue4, id: 'mAmount',
                            'data-index': '3', onChange: this.handleEdit })
                    )
                );
            } else if (action == 2) {
                body = _react2.default.createElement(
                    'div',
                    null,
                    'This contractor will be removed from this condo. Are you sure? '
                );
            } else if (action == 3) {
                var _contractStartDate = "",
                    _contractEndDate = "",
                    _lastVisit = "";
                var _state2 = this.state,
                    _txtValue = _state2.txtValue5,
                    _txtValue2 = _state2.txtValue6,
                    _txtValue3 = _state2.txtValue7;

                if (_txtValue) {
                    _txtValue = new Date(_txtValue);
                    _contractStartDate = _txtValue.getFullYear() + "-" + (_txtValue.getMonth() + 1 < 10 ? "0" + (_txtValue.getMonth() + 1) : _txtValue.getMonth() + 1) + "-" + (_txtValue.getDate() < 10 ? "0" + _txtValue.getDate() : _txtValue.getDate());
                }
                if (_txtValue2) {
                    _txtValue2 = new Date(_txtValue2);
                    _contractEndDate = _txtValue2.getFullYear() + "-" + (_txtValue2.getMonth() + 1 < 10 ? "0" + (_txtValue2.getMonth() + 1) : _txtValue2.getMonth() + 1) + "-" + (_txtValue2.getDate() < 10 ? "0" + _txtValue2.getDate() : _txtValue2.getDate());
                }
                if (_txtValue3) {
                    _txtValue3 = new Date(_txtValue3);
                    _lastVisit = _txtValue3.getFullYear() + "-" + (_txtValue3.getMonth() + 1 < 10 ? "0" + (_txtValue3.getMonth() + 1) : _txtValue3.getMonth() + 1) + "-" + (_txtValue3.getDate() < 10 ? "0" + _txtValue3.getDate() : _txtValue3.getDate());
                }
                body = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mService' },
                            'Service'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.txtValue1, id: 'mService',
                            'data-index': '0', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mDescription' },
                            'Description'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.txtValue2, id: 'mDescription',
                            'data-index': '1', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mLastVisit' },
                            'Last Visit'
                        ),
                        _react2.default.createElement('input', { type: 'date', className: 'form-control', value: _lastVisit, id: 'mLastVisit',
                            'data-index': '6', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mStatus' },
                            'Status'
                        ),
                        _react2.default.createElement(
                            'select',
                            { className: 'form-control', id: 'status', 'data-index': '7', value: this.state.txtValue8, onChange: this.handleEdit },
                            this.renderStatusOption()
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mRemark' },
                            'Remark'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.txtValue3, id: 'mRemark',
                            'data-index': '2', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mRemark' },
                            'Contract Start Date'
                        ),
                        _react2.default.createElement('input', { type: 'date', className: 'form-control', value: _contractStartDate, id: 'mRemark',
                            'data-index': '4', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mRemark' },
                            'Contract End Date'
                        ),
                        _react2.default.createElement('input', { type: 'date', className: 'form-control', value: _contractEndDate, id: 'mRemark',
                            'data-index': '5', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mAmount' },
                            'Amount (SGD)'
                        ),
                        _react2.default.createElement('input', { type: 'number', className: 'form-control', value: this.state.txtValue4, id: 'mAmount',
                            'data-index': '3', onChange: this.handleEdit })
                    )
                );
            } else {
                body = _react2.default.createElement(
                    'div',
                    null,
                    'Are you sure to remove this services?'
                );
            }
            return body;
        }
    }, {
        key: 'renderStatusOption',
        value: function renderStatusOption() {
            return this.props.statusTxt.map(function (status, index) {
                return _react2.default.createElement(
                    'option',
                    { value: index, key: index },
                    status
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            var btnTxt = "";

            if (this.props.action == 0) {
                btnTxt = "Add Estate";
            } else if (this.props.action == 1) {
                btnTxt = "Add Service";
            } else if (this.props.action == 2) {
                btnTxt = "Remove Estate";
            } else if (this.props.action == 3) {
                btnTxt = "Edit";
            } else {
                btnTxt = "Remove Service";
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'report-modal', style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            this.props.title
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body' },
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        ),
                        this.renderContent()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: "btn " + (this.props.action == 2 || this.props.action == 4 ? "btn-danger" : "btn-warning"),
                                onClick: this.handleClick },
                            btnTxt
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return ModalCondo;
}(_react2.default.Component);

ModalCondo.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    },
    statusTxt: ["Active", "In-Active", "Terminated", "Ad hoc"]
};
exports.default = ModalCondo;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _condoSetAction = __webpack_require__(23);

var _condoSetAction2 = _interopRequireDefault(_condoSetAction);

var _condoSetStore = __webpack_require__(39);

var _condoSetStore2 = _interopRequireDefault(_condoSetStore);

var _condoCheckListForm = __webpack_require__(90);

var _condoCheckListForm2 = _interopRequireDefault(_condoCheckListForm);

var _contractorForm = __webpack_require__(91);

var _contractorForm2 = _interopRequireDefault(_contractorForm);

var _modalCondo = __webpack_require__(92);

var _modalCondo2 = _interopRequireDefault(_modalCondo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CondoNewForm = function (_React$Component) {
    _inherits(CondoNewForm, _React$Component);

    function CondoNewForm(props) {
        _classCallCheck(this, CondoNewForm);

        var _this = _possibleConstructorReturn(this, (CondoNewForm.__proto__ || Object.getPrototypeOf(CondoNewForm)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);

        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.callBack = _this.callBack.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.state = {
            staffs: _filterStore2.default.getState().staffs,
            processingFilter: _filterStore2.default.getState().processing,
            iniLoadStaff: _filterStore2.default.getState().iniLoadStaff,
            condos: _filterStore2.default.getState().condos,
            iniLoadCondo: _filterStore2.default.getState().iniLoadCondo,
            iniLoadContractor: _filterStore2.default.getState().iniLoadContractor,
            contractors: _filterStore2.default.getState().contractors,

            condo: _condoSetStore2.default.getState().condo,
            checkList: _condoSetStore2.default.getState().checkList,
            processing: _condoSetStore2.default.getState().processing,
            warningMsg: "",
            modalClose: false
        };
        return _this;
    }

    _createClass(CondoNewForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _condoSetStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);

            _condoSetAction2.default.clear();
            if (!this.state.processing) {
                _condoSetAction2.default.processing(true);
                //get checklist
                _condoSetAction2.default.getCheckList();
            }

            if (!this.state.processingFilter && !this.state.iniLoadStaff) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getEmployee();
            }
            if (!this.state.iniLoadCondo) {
                _filterAction2.default.getCondoList();
            }
            //get Contractor
            if (!this.state.iniLoadContractor) {
                _filterAction2.default.getContractors();
            }

            _menuAction2.default.pageNumber({ selectedActivity: -1, selectedCategory: 0 });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _filterStore2.default.unlisten(this.onFilterChange);
            _condoSetStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                condo: state.condo,
                checkList: state.checkList,
                processing: state.processing
            });
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                staffs: state.staffs,
                processingFilter: state.processing,
                iniLoadStaff: state.iniLoadStaff,
                iniLoadCondo: state.iniLoadCondo,
                condos: state.condos,
                iniLoadContractor: state.iniLoadContractor,
                contractors: state.contractors
            });
        }
    }, {
        key: 'callBack',
        value: function callBack() {
            if (this.state.processing) return;
            //check if coordinate is correct or not
            if (this.state.condo.geoLocation.coordinates[0] < -180 || this.state.condo.geoLocation.coordinates[0] > 180 || this.state.condo.geoLocation.coordinates[1] < -90 || this.state.condo.geoLocation.coordinates[1] > 90) {
                return this.setState({ warningMsg: "The Geo Location is out of bound. Please check the longitude and latitude" });
            }
            if (this.state.condo.postal == "") {
                return this.setState({ warningMsg: "Postal code cannot be empty" });
            }

            _condoSetAction2.default.processing(true);
            _condoSetAction2.default.removeCondo(this.state.condo);
            this.shouldModalClose(false);
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({
                modalClose: data
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var s = this.state.condo;
            var index = parseInt(e.target.getAttribute("data-index"));

            if (index == 0) {
                s.manageBy = { staffId: e.target.value };
            } else {
                s.supervisor = { staffId: e.target.value };
            }

            _condoSetAction2.default.condo(s);
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            if (index == 0) {
                if (this.props.processing) return;
                _condoSetAction2.default.processing(true);
                _condoSetAction2.default.addCondo(this.state.condo);
            } else {
                this.props.history.push('/contractorSetting');
            }
        }
    }, {
        key: 'handleEdit',
        value: function handleEdit(e) {
            var index = parseInt(e.target.getAttribute('data-index'));

            var value = e.target.value;
            var s = this.state.condo;

            switch (index) {
                case 0:
                    s.mcst = value;
                    break;
                case 1:
                    s.condoName = value;
                    break;
                case 2:
                    s.noUnit = parseInt(value);
                    break;
                case 3:
                    s.geoLocation.coordinates[0] = parseFloat(value);
                    break;
                case 4:
                    s.geoLocation.coordinates[1] = parseFloat(value);
                    break;
                case 5:
                    s.address = value;
                    break;
                case 6:
                    s.postal = value;
                    break;
                case 7:
                    s.radius = parseInt(value);
                    break;
                case 8:
                    s.status = parseInt(value);
                    break;
            }

            _condoSetAction2.default.condo(s);
        }
    }, {
        key: 'renderStaff',
        value: function renderStaff() {
            return this.state.staffs.map(function (staff, index) {
                return _react2.default.createElement(
                    'option',
                    { value: staff.staffId, key: index },
                    staff.userName
                );
            });
        }
    }, {
        key: 'renderStatusOption',
        value: function renderStatusOption() {
            return this.props.statusTxt.map(function (status, index) {
                return _react2.default.createElement(
                    'option',
                    { value: index, key: index },
                    status
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var s = this.state.condo;

            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(_loading2.default, _extends({}, this.props, { processing: this.state.processing || this.state.processingFilter })),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 us-form' },
                        _react2.default.createElement(
                            'div',
                            { className: 'contractorSet-form' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-4' },
                                    _react2.default.createElement(
                                        'h4',
                                        null,
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            'Estate Details'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'mcst' },
                                            'MCST'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.mcst, id: 'mcst',
                                            placeholder: 'Type MCST here', 'data-index': '0', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'condoName' },
                                            'Estate Name'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.condoName, id: 'condoName',
                                            placeholder: 'Type Estate Name here', 'data-index': '1', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'noUnit' },
                                            'No of Units'
                                        ),
                                        _react2.default.createElement('input', { type: 'number', className: 'form-control', value: s.noUnit, id: 'noUnit',
                                            placeholder: '', 'data-index': '2', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { id: 'geoLocation' },
                                            'Geo Location'
                                        ),
                                        _react2.default.createElement('input', { type: 'number', className: 'form-control us-un', value: s.geoLocation.coordinates[1], id: 'lat',
                                            placeholder: 'lattitude', 'data-index': '4', onChange: this.handleEdit }),
                                        _react2.default.createElement('input', { type: 'number', className: 'form-control us-un', value: s.geoLocation.coordinates[0], id: 'lng',
                                            placeholder: 'longitude', 'data-index': '3', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'radius' },
                                            'Radius (meter)'
                                        ),
                                        _react2.default.createElement('input', { type: 'number', className: 'form-control', value: s.radius, id: 'radius',
                                            placeholder: '', 'data-index': '7', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'address' },
                                            'Address'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.address, id: 'address',
                                            placeholder: '', 'data-index': '5', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'postal' },
                                            'Postal'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.postal, id: 'postal',
                                            placeholder: '', 'data-index': '6', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'status' },
                                            'Status'
                                        ),
                                        _react2.default.createElement(
                                            'select',
                                            { className: 'form-control', id: 'status', 'data-index': '8', value: s.status, onChange: this.handleEdit },
                                            this.renderStatusOption()
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-4' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'postal' },
                                            'ManageBy'
                                        ),
                                        _react2.default.createElement(
                                            'select',
                                            { className: 'form-control atd-sel', name: 'employee', 'data-index': '0', onChange: this.handleChange, value: s.manageBy.staffId },
                                            _react2.default.createElement('option', { value: '' }),
                                            this.renderStaff()
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'postal' },
                                            'Reporting Manager'
                                        ),
                                        _react2.default.createElement(
                                            'select',
                                            { className: 'form-control atd-sel', name: 'employee', 'data-index': '1', onChange: this.handleChange, value: s.supervisor.staffId },
                                            _react2.default.createElement('option', { value: '' }),
                                            this.renderStaff()
                                        )
                                    ),
                                    _react2.default.createElement(_contractorForm2.default, { condo: this.state.condo, contractors: this.state.contractors, processing: this.state.processing })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-4' },
                                    _react2.default.createElement(_condoCheckListForm2.default, { checkList: this.state.checkList, condo: this.state.condo })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-4' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'warning' },
                                        this.state.warningMsg
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-warning us-cr',
                                            'data-index': '0', onClick: this.handleClick },
                                        'Create'
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-default us-cr',
                                            'data-index': '1', onClick: this.handleClick },
                                        'Cancel'
                                    )
                                ),
                                _react2.default.createElement('div', { className: 'clear' })
                            ),
                            _react2.default.createElement(_modalCondo2.default, { modalClose: this.state.modalClose, shouldModalClose: this.shouldModalClose, callBack: this.callBack })
                        )
                    )
                )
            );
        }
    }]);

    return CondoNewForm;
}(_react2.default.Component);

CondoNewForm.defaultProps = {
    statusTxt: ["Active", "In-Active"]
};
exports.default = CondoNewForm;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userSetAction = __webpack_require__(15);

var _userSetAction2 = _interopRequireDefault(_userSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalContractor = function (_React$Component) {
    _inherits(ModalContractor, _React$Component);

    function ModalContractor(props) {
        _classCallCheck(this, ModalContractor);

        var _this = _possibleConstructorReturn(this, (ModalContractor.__proto__ || Object.getPrototypeOf(ModalContractor)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.state = {
            txtValue1: "",
            txtValue2: "",
            txtValue3: "",
            txtValue4: "",
            txtValue5: "",
            txtValue6: "",
            txtValue7: "",
            txtValue8: 0,
            warningMsg: ""
        };
        return _this;
    }

    _createClass(ModalContractor, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.action == 3) {
                var contractorIndex = this.findIndex();
                this.setState({
                    txtValue1: this.props.condo.contractors[contractorIndex].contract[this.props.index].service,
                    txtValue2: this.props.condo.contractors[contractorIndex].contract[this.props.index].description,
                    txtValue3: this.props.condo.contractors[contractorIndex].contract[this.props.index].remark,
                    txtValue4: this.props.condo.contractors[contractorIndex].contract[this.props.index].amount,
                    txtValue5: this.props.condo.contractors[contractorIndex].contract[this.props.index].contractStartDate,
                    txtValue6: this.props.condo.contractors[contractorIndex].contract[this.props.index].contractEndDate,
                    txtValue7: this.props.condo.contractors[contractorIndex].contract[this.props.index].lastVisit,
                    txtValue8: this.props.condo.contractors[contractorIndex].contract[this.props.index].status,
                    warningMsg: ""
                });
            } else {
                this.setState({
                    txtValue1: "",
                    txtValue2: "",
                    txtValue3: "",
                    txtValue4: "",
                    txtValue5: "",
                    txtValue6: "",
                    txtValue7: "",
                    txtValue8: 0,
                    warningMsg: ""
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {}
    }, {
        key: 'findIndex',
        value: function findIndex() {
            var len = this.props.condo.contractors.length;
            var pos = void 0;
            for (var i = 0; i < len; i++) {
                if (this.props.condo.contractors[i]._id == this.props.contractorId) {
                    pos = i;
                    break;
                }
            }
            return pos;
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            if (this.props.action == 0) {
                if (this.checkRepeat()) return;
                if (this.state.txtValue1 == '') return this.setState({ warningMsg: "Please select contractor" });
            } else if (this.props.action == 1 || this.props.action == 3) {
                if (this.checkEmpty()) return;
            }

            this.props.callBack(this.state.txtValue1, this.state.txtValue2, this.state.txtValue3, this.state.txtValue4, this.state.txtValue5, this.state.txtValue6, this.state.txtValue7, this.state.txtValue8);
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {

            this.props.shouldModalClose(false);
        }
    }, {
        key: 'checkRepeat',
        value: function checkRepeat() {
            var contractors = this.props.condo.contractors;

            var len = contractors.length;
            var isRepeat = false;
            for (var i = 0; i < len; i++) {
                if (contractors[i]._id == this.state.txtValue1._id) {
                    isRepeat = true;
                    this.setState({ warningMsg: "The selected contractors has been added." });
                    break;
                }
            }
            return isRepeat;
        }
    }, {
        key: 'checkEmpty',
        value: function checkEmpty() {
            var isEmpty = false;
            if (this.state.txtValue1 == "") {
                isEmpty = true;
                this.setState({ warningMsg: "Service cannot be emptied" });
            }
            return isEmpty;
        }
    }, {
        key: 'findContractor',
        value: function findContractor(value) {
            var len = this.props.contractors.length;
            var contractor = "";
            for (var i = 0; i < len; i++) {
                if (this.props.contractors[i]._id == value) {
                    contractor = this.props.contractors[i];
                    break;
                }
            }
            return contractor;
        }
    }, {
        key: 'handleEdit',
        value: function handleEdit(e) {
            var index = void 0,
                value = void 0,
                contractor = void 0;
            if (this.props.action == 0) {
                value = e.target.value;
                contractor = this.findContractor(value);
                this.setState({ txtValue1: contractor });
            } else if (this.props.action == 1 || this.props.action == 3) {
                index = parseInt(e.target.getAttribute('data-index'));
                value = e.target.value;
                if (index == 0) {
                    this.setState({ txtValue1: value });
                } else if (index == 1) {
                    this.setState({ txtValue2: value });
                } else if (index == 2) {
                    this.setState({ txtValue3: value });
                } else if (index == 3) {
                    this.setState({ txtValue4: parseFloat(value) });
                } else if (index == 4) {
                    this.setState({ txtValue5: value ? new Date(value) : "" });
                } else if (index == 5) {
                    this.setState({ txtValue6: value ? new Date(value) : "" });
                } else if (index == 6) {
                    this.setState({ txtValue7: value ? new Date(value) : "" });
                } else if (index == 7) {
                    this.setState({ txtValue8: parseInt(value) });
                }
            }
        }
    }, {
        key: 'renderContractor',
        value: function renderContractor() {
            return this.props.contractors.map(function (contractor, index) {
                return _react2.default.createElement(
                    'option',
                    { value: contractor._id, key: index },
                    contractor.contractorName
                );
            });
        }
    }, {
        key: 'renderStatusOption',
        value: function renderStatusOption() {
            return this.props.statusTxt.map(function (status, index) {
                return _react2.default.createElement(
                    'option',
                    { value: index, key: index },
                    status
                );
            });
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            var body = "";
            var action = this.props.action;

            if (action == 0) {
                body = _react2.default.createElement(
                    'select',
                    { className: 'form-control', 'data-index': '0', onChange: this.handleEdit },
                    _react2.default.createElement('option', { value: '' }),
                    this.renderContractor()
                );
            } else if (action == 1) {
                var contractStartDate = "",
                    contractEndDate = "",
                    lastVisit = "";
                var _state = this.state,
                    txtValue5 = _state.txtValue5,
                    txtValue6 = _state.txtValue6,
                    txtValue7 = _state.txtValue7;

                if (txtValue5) {
                    contractStartDate = txtValue5.getFullYear() + "-" + (txtValue5.getMonth() + 1 < 10 ? "0" + (txtValue5.getMonth() + 1) : txtValue5.getMonth() + 1) + "-" + (txtValue5.getDate() < 10 ? "0" + txtValue5.getDate() : txtValue5.getDate());
                }
                if (txtValue6) {
                    contractEndDate = txtValue6.getFullYear() + "-" + (txtValue6.getMonth() + 1 < 10 ? "0" + (txtValue6.getMonth() + 1) : txtValue6.getMonth() + 1) + "-" + (txtValue6.getDate() < 10 ? "0" + txtValue6.getDate() : txtValue6.getDate());
                }

                if (txtValue7) {

                    lastVisit = txtValue7.getFullYear() + "-" + (txtValue7.getMonth() + 1 < 10 ? "0" + (txtValue7.getMonth() + 1) : txtValue7.getMonth() + 1) + "-" + (txtValue7.getDate() < 10 ? "0" + txtValue7.getDate() : txtValue7.getDate());
                }
                body = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mService' },
                            'Service'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.txtValue1, id: 'mService',
                            'data-index': '0', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mDescription' },
                            'Description'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.txtValue2, id: 'mDescription',
                            'data-index': '1', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mLastVisit' },
                            'Last Visit'
                        ),
                        _react2.default.createElement('input', { type: 'date', className: 'form-control', value: lastVisit, id: 'mLastVisit',
                            'data-index': '6', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mStatus' },
                            'Status'
                        ),
                        _react2.default.createElement(
                            'select',
                            { className: 'form-control', id: 'status', 'data-index': '7', value: this.state.txtValue8, onChange: this.handleEdit },
                            this.renderStatusOption()
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mRemark' },
                            'Remark'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.txtValue3, id: 'mRemark',
                            'data-index': '2', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mRemark' },
                            'Contract Start Date'
                        ),
                        _react2.default.createElement('input', { type: 'date', className: 'form-control', value: contractStartDate, id: 'mRemark',
                            'data-index': '4', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mRemark' },
                            'Contract End Date'
                        ),
                        _react2.default.createElement('input', { type: 'date', className: 'form-control', value: contractEndDate, id: 'mRemark',
                            'data-index': '5', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mAmount' },
                            'Amount (SGD)'
                        ),
                        _react2.default.createElement('input', { ttype: 'number', className: 'form-control', value: this.state.txtValue4, id: 'mAmount',
                            'data-index': '3', onChange: this.handleEdit })
                    )
                );
            } else if (action == 2) {
                body = _react2.default.createElement(
                    'div',
                    null,
                    'This contractor will be removed from this condo. Are you sure? '
                );
            } else if (action == 3) {
                var _contractStartDate = "",
                    _contractEndDate = "",
                    _lastVisit = "";
                var _state2 = this.state,
                    _txtValue = _state2.txtValue5,
                    _txtValue2 = _state2.txtValue6,
                    _txtValue3 = _state2.txtValue7;

                if (_txtValue) {
                    _txtValue = new Date(_txtValue);
                    _contractStartDate = _txtValue.getFullYear() + "-" + (_txtValue.getMonth() + 1 < 10 ? "0" + (_txtValue.getMonth() + 1) : _txtValue.getMonth() + 1) + "-" + (_txtValue.getDate() < 10 ? "0" + _txtValue.getDate() : _txtValue.getDate());
                }
                if (_txtValue2) {
                    _txtValue2 = new Date(_txtValue2);
                    _contractEndDate = _txtValue2.getFullYear() + "-" + (_txtValue2.getMonth() + 1 < 10 ? "0" + (_txtValue2.getMonth() + 1) : _txtValue2.getMonth() + 1) + "-" + (_txtValue2.getDate() < 10 ? "0" + _txtValue2.getDate() : _txtValue2.getDate());
                }

                if (_txtValue3) {
                    _txtValue3 = new Date(_txtValue3);
                    _lastVisit = _txtValue3.getFullYear() + "-" + (_txtValue3.getMonth() + 1 < 10 ? "0" + (_txtValue3.getMonth() + 1) : _txtValue3.getMonth() + 1) + "-" + (_txtValue3.getDate() < 10 ? "0" + _txtValue3.getDate() : _txtValue3.getDate());
                }
                body = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mService' },
                            'Service'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.txtValue1, id: 'mService',
                            'data-index': '0', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mDescription' },
                            'Description'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.txtValue2, id: 'mDescription',
                            'data-index': '1', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mLastVisit' },
                            'Last Visit'
                        ),
                        _react2.default.createElement('input', { type: 'date', className: 'form-control', value: _lastVisit, id: 'mLastVisit',
                            'data-index': '6', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mStatus' },
                            'Status'
                        ),
                        _react2.default.createElement(
                            'select',
                            { className: 'form-control', id: 'status', 'data-index': '7', value: this.state.txtValue8, onChange: this.handleEdit },
                            this.renderStatusOption()
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mRemark' },
                            'Remark'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: this.state.txtValue3, id: 'mRemark',
                            'data-index': '2', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mRemark' },
                            'Contract Start Date'
                        ),
                        _react2.default.createElement('input', { type: 'date', className: 'form-control', value: _contractStartDate, id: 'mRemark',
                            'data-index': '4', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mRemark' },
                            'Contract End Date'
                        ),
                        _react2.default.createElement('input', { type: 'date', className: 'form-control', value: _contractEndDate, id: 'mRemark',
                            'data-index': '5', onChange: this.handleEdit })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'mAmount' },
                            'Amount (SGD)'
                        ),
                        _react2.default.createElement('input', { type: 'number', className: 'form-control', value: this.state.txtValue4, id: 'mAmount',
                            'data-index': '3', onChange: this.handleEdit })
                    )
                );
            } else {
                body = _react2.default.createElement(
                    'div',
                    null,
                    'Are you sure to remove this services?'
                );
            }
            return body;
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            var btnTxt = "";

            if (this.props.action == 0) {
                btnTxt = "Add Contractor";
            } else if (this.props.action == 1) {
                btnTxt = "Add Service";
            } else if (this.props.action == 2) {
                btnTxt = "Remove Contractor";
            } else if (this.props.action == 3) {
                btnTxt = "Edit";
            } else {
                btnTxt = "Remove Service";
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'report-modal', style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            this.props.title
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body' },
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        ),
                        this.renderContent()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: "btn " + (this.props.action == 2 || this.props.action == 4 ? "btn-danger" : "btn-warning"), onClick: this.handleClick },
                            btnTxt
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return ModalContractor;
}(_react2.default.Component);

ModalContractor.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    },
    statusTxt: ["Active", "In-Active", "Terminated", "Ad hoc"]
};
exports.default = ModalContractor;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _condoSetAction = __webpack_require__(23);

var _condoSetAction2 = _interopRequireDefault(_condoSetAction);

var _condoSetStore = __webpack_require__(39);

var _condoSetStore2 = _interopRequireDefault(_condoSetStore);

var _condoCheckListForm = __webpack_require__(90);

var _condoCheckListForm2 = _interopRequireDefault(_condoCheckListForm);

var _contractorForm = __webpack_require__(91);

var _contractorForm2 = _interopRequireDefault(_contractorForm);

var _modalCondo = __webpack_require__(92);

var _modalCondo2 = _interopRequireDefault(_modalCondo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CondoForm = function (_React$Component) {
    _inherits(CondoForm, _React$Component);

    function CondoForm(props) {
        _classCallCheck(this, CondoForm);

        var _this = _possibleConstructorReturn(this, (CondoForm.__proto__ || Object.getPrototypeOf(CondoForm)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);

        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.callBack = _this.callBack.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.state = {
            staffs: _filterStore2.default.getState().staffs,
            processingFilter: _filterStore2.default.getState().processing,
            iniLoadStaff: _filterStore2.default.getState().iniLoadStaff,
            condos: _filterStore2.default.getState().condos,
            iniLoadCondo: _filterStore2.default.getState().iniLoadCondo,
            iniLoadContractor: _filterStore2.default.getState().iniLoadContractor,
            contractors: _filterStore2.default.getState().contractors,

            prevMCST: _condoSetStore2.default.getState().prevMCST,
            condo: _condoSetStore2.default.getState().condo,
            checkList: _condoSetStore2.default.getState().checkList,
            processing: _condoSetStore2.default.getState().processing,
            warningMsg: "",
            modalClose: false
        };
        return _this;
    }

    _createClass(CondoForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _condoSetStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);

            _condoSetAction2.default.clear();
            if (!this.state.processing) {
                _condoSetAction2.default.processing(true);
                _condoSetAction2.default.getCondo(this.props.match.params.id);
                //get checklist
                _condoSetAction2.default.getCheckList();
            }

            if (!this.state.processingFilter && !this.state.iniLoadStaff) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getEmployee();
            }
            if (!this.state.iniLoadCondo) {
                _filterAction2.default.getCondoList();
            }
            //get Contractor
            if (!this.state.iniLoadContractor) {
                _filterAction2.default.getContractors();
            }

            _menuAction2.default.pageNumber({ selectedActivity: -1, selectedCategory: 0 });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _filterStore2.default.unlisten(this.onFilterChange);
            _condoSetStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                condo: state.condo,
                checkList: state.checkList,
                processing: state.processing,
                prevMCST: state.prevMCST
            });
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                staffs: state.staffs,
                processingFilter: state.processing,
                iniLoadStaff: state.iniLoadStaff,
                iniLoadCondo: state.iniLoadCondo,
                condos: state.condos,
                iniLoadContractor: state.iniLoadContractor,
                contractors: state.contractors
            });
        }
    }, {
        key: 'callBack',
        value: function callBack() {
            if (this.state.processing) return;

            _condoSetAction2.default.processing(true);
            _condoSetAction2.default.removeCondo(this.state.condo);
            this.shouldModalClose(false);
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({
                modalClose: data
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var s = this.state.condo;
            var index = parseInt(e.target.getAttribute("data-index"));

            if (index == 0) {
                s.manageBy = { staffId: e.target.value };
            } else {
                s.supervisor = { staffId: e.target.value };
            }

            _condoSetAction2.default.condo(s);
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            if (index == 0) {
                if (this.props.processing) return;
                //check if coordinate is correct or not
                if (this.state.condo.geoLocation.coordinates[0] < -180 || this.state.condo.geoLocation.coordinates[0] > 180 || this.state.condo.geoLocation.coordinates[1] < -90 || this.state.condo.geoLocation.coordinates[1] > 90) {
                    return this.setState({ warningMsg: "The Geo Location is out of bound. Please check the longitude and latitude" });
                }
                if (this.state.condo.postal == "") {
                    return this.setState({ warningMsg: "Postal code cannot be empty" });
                }
                _condoSetAction2.default.processing(true);
                _condoSetAction2.default.updateCondo(this.state.condo, this.state.prevMCST);
            } else if (index == 1) {
                this.setState({ modalClose: true });
            } else {
                this.props.history.push('/contractorSetting');
            }
        }
    }, {
        key: 'handleEdit',
        value: function handleEdit(e) {
            var index = parseInt(e.target.getAttribute('data-index'));

            var value = e.target.value;
            var s = this.state.condo;

            switch (index) {
                case 0:
                    s.mcst = value;
                    break;
                case 1:
                    s.condoName = value;
                    break;
                case 2:
                    s.noUnit = parseInt(value);
                    break;
                case 3:
                    s.geoLocation.coordinates[0] = parseFloat(value);
                    break;
                case 4:
                    s.geoLocation.coordinates[1] = parseFloat(value);
                    break;
                case 5:
                    s.address = value;
                    break;
                case 6:
                    s.postal = value;
                    break;
                case 7:
                    s.radius = parseInt(value);
                    break;
                case 8:
                    s.status = parseInt(value);
                    break;
            }

            _condoSetAction2.default.condo(s);
        }
    }, {
        key: 'renderStaff',
        value: function renderStaff() {
            return this.state.staffs.map(function (staff, index) {
                return _react2.default.createElement(
                    'option',
                    { value: staff.staffId, key: index },
                    staff.userName
                );
            });
        }
    }, {
        key: 'renderStatusOption',
        value: function renderStatusOption() {
            return this.props.statusTxt.map(function (status, index) {
                return _react2.default.createElement(
                    'option',
                    { value: index, key: index },
                    status
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var s = this.state.condo;

            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(_loading2.default, _extends({}, this.props, { processing: this.state.processing || this.state.processingFilter })),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 us-form' },
                        _react2.default.createElement(
                            'div',
                            { className: 'contractorSet-form' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-4' },
                                    _react2.default.createElement(
                                        'h4',
                                        null,
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            'Estate Details'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'mcst' },
                                            'MCST'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.mcst, id: 'mcst',
                                            placeholder: 'Type MCST here', 'data-index': '0', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'condoName' },
                                            'Estate Name'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.condoName, id: 'condoName',
                                            placeholder: 'Type Estate Name here', 'data-index': '1', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'noUnit' },
                                            'No of Units'
                                        ),
                                        _react2.default.createElement('input', { type: 'number', className: 'form-control', value: s.noUnit, id: 'noUnit',
                                            placeholder: '', 'data-index': '2', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { id: 'geoLocation' },
                                            'Geo Location'
                                        ),
                                        _react2.default.createElement('input', { type: 'number', className: 'form-control us-un', value: s.geoLocation.coordinates[1], id: 'lat',
                                            placeholder: 'lattitude', 'data-index': '4', onChange: this.handleEdit }),
                                        _react2.default.createElement('input', { type: 'number', className: 'form-control us-un', value: s.geoLocation.coordinates[0], id: 'lng',
                                            placeholder: 'longitude', 'data-index': '3', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'radius' },
                                            'Radius (meter)'
                                        ),
                                        _react2.default.createElement('input', { type: 'number', className: 'form-control', value: s.radius, id: 'radius',
                                            placeholder: '', 'data-index': '7', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'address' },
                                            'Address'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.address, id: 'address',
                                            placeholder: '', 'data-index': '5', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'postal' },
                                            'Postal'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.postal, id: 'postal',
                                            placeholder: '', 'data-index': '6', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'status' },
                                            'Status'
                                        ),
                                        _react2.default.createElement(
                                            'select',
                                            { className: 'form-control', id: 'status', 'data-index': '8', value: s.status, onChange: this.handleEdit },
                                            this.renderStatusOption()
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-4' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'postal' },
                                            'ManageBy'
                                        ),
                                        _react2.default.createElement(
                                            'select',
                                            { className: 'form-control atd-sel', name: 'employee', 'data-index': '0', onChange: this.handleChange, value: s.manageBy ? s.manageBy.staffId : "" },
                                            _react2.default.createElement('option', { value: '' }),
                                            this.renderStaff()
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'postal' },
                                            'Reporting Manager'
                                        ),
                                        _react2.default.createElement(
                                            'select',
                                            { className: 'form-control atd-sel', name: 'employee', 'data-index': '1', onChange: this.handleChange, value: s.supervisor ? s.supervisor.staffId : "" },
                                            _react2.default.createElement('option', { value: '' }),
                                            this.renderStaff()
                                        )
                                    ),
                                    _react2.default.createElement(_contractorForm2.default, { condo: this.state.condo, contractors: this.state.contractors, processing: this.state.processing })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-4' },
                                    _react2.default.createElement(_condoCheckListForm2.default, { checkList: this.state.checkList, condo: this.state.condo })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-4' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'warning' },
                                        this.state.warningMsg
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-warning us-cr',
                                            'data-index': '0', onClick: this.handleClick },
                                        'Update'
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-default us-cr',
                                            'data-index': '2', onClick: this.handleClick },
                                        'Cancel'
                                    )
                                ),
                                _react2.default.createElement('div', { className: 'clear' })
                            ),
                            _react2.default.createElement(_modalCondo2.default, { modalClose: this.state.modalClose, shouldModalClose: this.shouldModalClose, callBack: this.callBack })
                        )
                    )
                )
            );
        }
        /*
        <button type="button" className="btn btn-danger us-cr"
            data-index="1" onClick={this.handleClick}>Remove</button>
            */

    }]);

    return CondoForm;
}(_react2.default.Component);

CondoForm.defaultProps = {
    statusTxt: ["Active", "In-active"]
};
exports.default = CondoForm;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _contractorAction = __webpack_require__(14);

var _contractorAction2 = _interopRequireDefault(_contractorAction);

var _contractorStore = __webpack_require__(29);

var _contractorStore2 = _interopRequireDefault(_contractorStore);

var _contractorCondoForm = __webpack_require__(89);

var _contractorCondoForm2 = _interopRequireDefault(_contractorCondoForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContractorForm = function (_React$Component) {
    _inherits(ContractorForm, _React$Component);

    function ContractorForm(props) {
        _classCallCheck(this, ContractorForm);

        var _this = _possibleConstructorReturn(this, (ContractorForm.__proto__ || Object.getPrototypeOf(ContractorForm)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleCheck = _this.handleCheck.bind(_this);
        _this.state = {
            processingFilter: _filterStore2.default.getState().processing,
            condos: _filterStore2.default.getState().condos,
            iniLoadCondo: _filterStore2.default.getState().iniLoadCondo,

            contractor: _contractorStore2.default.getState().contractor,
            processing: _contractorStore2.default.getState().processing,
            warningMsg: ""
        };
        return _this;
    }

    _createClass(ContractorForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _contractorStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);
            _contractorAction2.default.clear();
            _menuAction2.default.pageNumber({ selectedActivity: -1, selectedCategory: 1 });
            if (!this.state.iniLoadCondo && !this.state.processingFilter) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getCondoList();
            }

            _contractorAction2.default.processing(true);
            _contractorAction2.default.getContractor(this.props.match.params.id);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _contractorStore2.default.unlisten(this.onChange);
            _filterStore2.default.unlisten(this.onFilterChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                contractor: state.contractor,
                processing: state.processing
            });
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                processingFilter: state.processing,
                iniLoadCondo: state.iniLoadCondo,
                condos: state.condos
            });
        }
    }, {
        key: 'handleCheck',
        value: function handleCheck(e) {
            var checked = e.target.checked;

            var s = this.state.contractor;
            s.isGSTRegister = checked;
            _contractorAction2.default.contractor(s);
        }
    }, {
        key: 'handleEdit',
        value: function handleEdit(e) {
            var index = parseInt(e.target.getAttribute('data-index'));

            var value = e.target.value;
            var s = this.state.contractor;

            switch (index) {
                case 0:
                    s.contractorName = value;
                    break;
                case 1:
                    s.telephone = value;
                    break;
                case 2:
                    s.fax = value;
                    break;
                case 3:
                    s.contractorEmail = value;
                    break;
                case 4:
                    s.contactName = value;
                    break;
                /*    
                case 5:
                    s.status = parseInt(value);
                    break;
                */
                case 6:
                    s.streetName = value;
                    break;
                case 7:
                    s.blkNo = value;
                    break;
                case 8:
                    s.unitNo = value;
                    break;
                case 9:
                    s.postal = parseInt(value);
                    break;
            }

            _contractorAction2.default.contractor(s);
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            if (index == 2) {
                this.props.history.push('/contractorSetting');
            } else if (index == 0) {
                if (this.props.processing) return;

                _contractorAction2.default.processing(true);
                _contractorAction2.default.updateContractor(this.state.contractor);
            } else if (index == 1) {
                if (this.props.processing) return;

                _contractorAction2.default.processing(true);
                _contractorAction2.default.removeContractor(this.props.match.params.id);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var s = this.state.contractor;

            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(_loading2.default, _extends({}, this.props, { processing: this.state.processing || this.state.processingFilter })),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 us-form' },
                        _react2.default.createElement(
                            'div',
                            { className: 'contractorSet-form' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'h3',
                                    null,
                                    _react2.default.createElement(
                                        'b',
                                        null,
                                        'Edit Contractor'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    _react2.default.createElement(
                                        'h4',
                                        null,
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            'Contractor Details'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'contractorName' },
                                            'Name of Contractor'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.contractorName, id: 'contractorName',
                                            placeholder: 'Type the name of contractor here', 'data-index': '0', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'telephone' },
                                            'Telephone'
                                        ),
                                        _react2.default.createElement('input', { type: 'number', className: 'form-control', value: s.telephone, id: 'telephone',
                                            placeholder: 'e.g. 9XXX XXXX', 'data-index': '1', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'fax' },
                                            'Fax'
                                        ),
                                        _react2.default.createElement('input', { type: 'number', className: 'form-control', value: s.fax, id: 'fax',
                                            placeholder: 'e.g. 9XXX XXXX', 'data-index': '2', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'contractorEmail' },
                                            'Contractor Email'
                                        ),
                                        _react2.default.createElement('input', { type: 'email', className: 'form-control', value: s.contractorEmail, id: 'contractorEmail',
                                            placeholder: 'Type contractor email here', 'data-index': '3', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'contactName' },
                                            'Contact Name'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.contactName, id: 'contactName',
                                            placeholder: 'Type contact name here', 'data-index': '4', onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'totalAmount' },
                                            'Total Contract Amount (SGD)'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.totalAmount, id: 'totalAmount',
                                            disabled: true })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'streetName' },
                                            'Street Name/Building Name'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.streetName, id: 'streetName', 'data-index': '6',
                                            onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'blkNo' },
                                            'Block No.'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.blkNo, id: 'blkNo', 'data-index': '7',
                                            onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'unitNo' },
                                            'Unit No.'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.unitNo, id: 'unitNo', 'data-index': '8',
                                            onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'postal' },
                                            'Postal'
                                        ),
                                        _react2.default.createElement('input', { type: 'number', className: 'form-control', value: s.postal, id: 'postal', 'data-index': '9',
                                            onChange: this.handleEdit })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'checkbox' },
                                            _react2.default.createElement(
                                                'label',
                                                null,
                                                _react2.default.createElement('input', { type: 'checkbox',
                                                    onChange: this.handleCheck, checked: s.isGSTRegister }),
                                                _react2.default.createElement('span', { className: 'checkmark' }),
                                                'GST registered Company'
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    _react2.default.createElement(_contractorCondoForm2.default, { contractor: s, condos: this.state.condos })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-4' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'warning' },
                                        this.state.warningMsg
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-warning us-cr',
                                            'data-index': '0', onClick: this.handleClick },
                                        'Update'
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-default us-cr',
                                            'data-index': '2', onClick: this.handleClick },
                                        'Cancel'
                                    )
                                ),
                                _react2.default.createElement('div', { className: 'clear' })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ContractorForm;
}(_react2.default.Component);

ContractorForm.defaultProps = {
    mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    statusTxt: ["Active", "In-Active", "Terminated", "Ad hoc", "Unknown"]

};
exports.default = ContractorForm;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _condoSetAction = __webpack_require__(23);

var _condoSetAction2 = _interopRequireDefault(_condoSetAction);

var _condoSetStore = __webpack_require__(39);

var _condoSetStore2 = _interopRequireDefault(_condoSetStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _modalCheckList = __webpack_require__(268);

var _modalCheckList2 = _interopRequireDefault(_modalCheckList);

var _modalUpdated = __webpack_require__(269);

var _modalUpdated2 = _interopRequireDefault(_modalUpdated);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckListForm = function (_React$Component) {
    _inherits(CheckListForm, _React$Component);

    function CheckListForm(props) {
        _classCallCheck(this, CheckListForm);

        var _this = _possibleConstructorReturn(this, (CheckListForm.__proto__ || Object.getPrototypeOf(CheckListForm)).call(this, props));

        _this.handleToggle = _this.handleToggle.bind(_this);
        _this.handleRemoveFacility = _this.handleRemoveFacility.bind(_this);
        _this.handleEditCategory = _this.handleEditCategory.bind(_this);
        _this.handleNewFacility = _this.handleNewFacility.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.shouldUpdateModalClose = _this.shouldUpdateModalClose.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.callBack = _this.callBack.bind(_this);
        _this.state = {
            modalClose: false,
            modalUpdateClose: false,
            action: "",
            title: "",
            index: "",
            processing: _condoSetStore2.default.getState().processing,
            checkList: _condoSetStore2.default.getState().checkList,
            isCLUpdate: _condoSetStore2.default.getState().isCLUpdate
        };
        return _this;
    }

    _createClass(CheckListForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _condoSetStore2.default.listen(this.onChange);
            _condoSetAction2.default.clear();
            _menuAction2.default.pageNumber(12);
            //load checkList
            if (!this.state.processing) {
                _condoSetAction2.default.processing(true);
                _condoSetAction2.default.getCheckList();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _condoSetStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.isCLUpdate != prevState.isCLUpdate && this.state.isCLUpdate) {
                this.setState({ title: "SuccessFul", modalUpdateClose: true });
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                checkList: state.checkList,
                isCLUpdate: state.isCLUpdate,
                processing: state.processing
            });
        }
    }, {
        key: 'handleToggle',
        value: function handleToggle(e) {
            var index = parseInt(e.currentTarget.getAttribute('data-index'));
            _condoSetAction2.default.shouldListShowCL2(index);
        }
    }, {
        key: 'handleRemoveFacility',
        value: function handleRemoveFacility(e) {
            e.preventDefault();
            e.stopPropagation();
            var index = parseInt(e.target.getAttribute('data-index'));
            var title = "Remove " + this.state.checkList[index].facility;
            var action = 0;

            this.setState({ title: title, action: action, index: index, modalClose: true });
        }
    }, {
        key: 'handleEditCategory',
        value: function handleEditCategory(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            var title = "Edit " + this.state.checkList[index].facility;
            var action = 1;

            this.setState({ title: title, action: action, index: index, modalClose: true });
        }
    }, {
        key: 'handleNewFacility',
        value: function handleNewFacility() {
            var title = "Add New Facility";
            var action = 2;

            this.setState({ title: title, action: action, modalClose: true });
        }
    }, {
        key: 'handleClick',
        value: function handleClick() {
            if (this.state.processing) return;

            _condoSetAction2.default.processing(true);
            _condoSetAction2.default.updateCheckList(this.state.checkList);
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({
                modalClose: data
            });
        }
    }, {
        key: 'shouldUpdateModalClose',
        value: function shouldUpdateModalClose(data) {
            this.setState({
                modalUpdateClose: data
            });
            _condoSetAction2.default.isCLUpdate(false);
        }
    }, {
        key: 'callBack',
        value: function callBack(cl, nf) {
            if (this.state.action == 1) {
                _condoSetAction2.default.checkList(cl);
            } else if (this.state.action == 0) {

                var checkList = this.state.checkList;
                //remove from database
                if (checkList[this.state.index]._id) {
                    _condoSetAction2.default.removeCheckList(checkList[this.state.index]._id);
                }
                //remove from checklist
                checkList.splice(this.state.index, 1);
                _condoSetAction2.default.checkList(checkList);
            } else if (this.state.action == 2) {
                var _checkList = this.state.checkList;

                //update checklist
                _checkList.push({
                    facility: nf,
                    categories: []
                });
            } else if (this.state.action == 3) {
                _condoSetAction2.default.isCLUpdate(false);
            }
            this.shouldModalClose(false);
        }
    }, {
        key: 'renderDes',
        value: function renderDes(description) {
            if (!description) return;
            return description.map(function (des, index) {
                return _react2.default.createElement(
                    'li',
                    { className: 'cl-ol-li', key: index },
                    des
                );
            });
        }
    }, {
        key: 'renderCategory',
        value: function renderCategory(checkList) {
            var _this2 = this;

            if (!checkList.categories) return;
            return checkList.categories.map(function (ct, index) {
                return _react2.default.createElement(
                    'div',
                    { key: index },
                    _react2.default.createElement(
                        'div',
                        { className: 'cl-ct-tt' },
                        ct.category
                    ),
                    _react2.default.createElement(
                        'ol',
                        { className: 'cl-ol' },
                        _this2.renderDes(ct.description)
                    )
                );
            });
        }
    }, {
        key: 'renderFacility',
        value: function renderFacility(checkList, index) {
            return _react2.default.createElement(
                'li',
                { className: 'cl-li-1', key: index },
                _react2.default.createElement(
                    'div',
                    { className: 'cl-tt', 'data-index': index, onClick: this.handleToggle },
                    _react2.default.createElement('span', { className: "cl-icon glyphicon " + (checkList.shouldListShow ? "glyphicon-minus" : "glyphicon-plus") }),
                    checkList.facility,
                    _react2.default.createElement(
                        'div',
                        { className: 'ct-btn-grp' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-xs btn-danger', 'data-index': index, onClick: this.handleRemoveFacility },
                            'Remove'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: "cl-ct " + (checkList.shouldListShow ? "ct-show" : "ct-hide") },
                    _react2.default.createElement(
                        'button',
                        { className: 'cl-li-edit btn btn-default btn-xs', 'data-index': index, onClick: this.handleEditCategory },
                        'Edit'
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            'Category'
                        )
                    ),
                    this.renderCategory(checkList)
                )
            );
        }
    }, {
        key: 'renderCheckList',
        value: function renderCheckList() {
            var _this3 = this;

            var s = this.state;
            var checkList = s.checkList.map(function (checkList, index) {
                return _this3.renderFacility(checkList, index);
            });

            return _react2.default.createElement(
                'ul',
                { className: 'cl-fc' },
                checkList
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var modal = "";
            if (this.state.modalClose) {
                modal = _react2.default.createElement(_modalCheckList2.default, {
                    checkList: this.state.checkList,
                    modalClose: this.state.modalClose,
                    shouldModalClose: this.shouldModalClose,
                    action: this.state.action,
                    title: this.state.title,
                    index: this.state.index,
                    callBack: this.callBack,
                    editCheckList: this.state.editCheckList,
                    newFacility: this.state.newFacility
                });
            }
            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(_loading2.default, _extends({}, this.props, { processing: this.state.processing })),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 us-form' },
                        _react2.default.createElement(
                            'div',
                            { className: 'checkList-form' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-8' },
                                    _react2.default.createElement(
                                        'h4',
                                        null,
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            'Master Check List'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-warning',
                                            'data-index': '0', onClick: this.handleNewFacility },
                                        'Add Facility'
                                    ),
                                    this.renderCheckList()
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-4' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn btn-warning us-cr',
                                            'data-index': '0', onClick: this.handleClick },
                                        'Update'
                                    )
                                ),
                                _react2.default.createElement('div', { className: 'clear' })
                            ),
                            modal,
                            _react2.default.createElement(_modalUpdated2.default, { shouldModalClose: this.shouldUpdateModalClose, modalClose: this.state.modalUpdateClose })
                        )
                    )
                )
            );
        }
    }]);

    return CheckListForm;
}(_react2.default.Component);

exports.default = CheckListForm;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _condoSetAction = __webpack_require__(23);

var _condoSetAction2 = _interopRequireDefault(_condoSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalCheckList = function (_React$Component) {
    _inherits(ModalCheckList, _React$Component);

    function ModalCheckList(props) {
        _classCallCheck(this, ModalCheckList);

        var _this = _possibleConstructorReturn(this, (ModalCheckList.__proto__ || Object.getPrototypeOf(ModalCheckList)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleCategoryEdit = _this.handleCategoryEdit.bind(_this);
        _this.handleDescriptionEdit = _this.handleDescriptionEdit.bind(_this);
        _this.handleFacility = _this.handleFacility.bind(_this);
        _this.desKey = _this.desKey.bind(_this);
        _this.catKey = _this.catKey.bind(_this);
        _this.state = {
            checkList: "",
            newFacility: "",
            warningMsg: "",
            height: 300
        };
        return _this;
    }

    _createClass(ModalCheckList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var checkList = this.props.checkList;
            this.setState({
                checkList: checkList
            });
            var modal = _reactDom2.default.findDOMNode(this.refs.modal);
            var height = modal.clientHeight;
            this.setState({
                height: height
            });
        }
    }, {
        key: 'handleCategoryEdit',
        value: function handleCategoryEdit(e) {
            var categoryIndex = e.target.getAttribute('data-category');
            var checkList = this.state.checkList;

            if (categoryIndex != -1) {
                var value = e.target.value;

                checkList[this.props.index].categories[categoryIndex].category = value;
                this.setState({ checkList: checkList });
                if (value == "") {
                    if (checkList[this.props.index].categories[categoryIndex].description.length == 0) {
                        checkList[this.props.index].categories.splice(categoryIndex, 1);
                        this.setState({ checkList: checkList });
                    }
                }
                this.updateFacility();
            } else {
                var _value = e.target.value;
                if (_value != '') {
                    if (!checkList[this.props.index].categories) checkList[this.props.index].categories = [];

                    checkList[this.props.index].categories.push({
                        category: _value,
                        description: []
                    });
                    this.setState({ checkList: checkList });
                    e.target.value = "";
                    this.updateFacility();
                }
            }
        }
    }, {
        key: 'handleFacility',
        value: function handleFacility(e) {
            var value = e.target.value;
            this.setState({ newFacility: value });
        }
    }, {
        key: 'updateFacility',
        value: function updateFacility() {
            var editCheckList = this.props.editCheckList;
            var len = editCheckList.length;
            var isRepeat = false;
            for (var i = 0; i < len; i++) {
                if (this.props.editCheckList[i].facility == this.props.checkList[this.props.index].facility) {
                    editCheckList[i] = this.state.checkList[this.props.index];
                    _condoSetAction2.default.editCheckList(editCheckList);
                    isRepeat = true;
                    break;
                }
            }

            if (!isRepeat) {
                editCheckList.push(this.state.checkList[this.props.index]);
            }
        }
    }, {
        key: 'catKey',
        value: function catKey(e) {
            if (e.key == 'Enter') {
                this.handleCategoryEdit(e);
            }
        }
    }, {
        key: 'desKey',
        value: function desKey(e) {
            if (e.key == 'Enter') {
                this.handleDescriptionEdit(e);
            }
        }
    }, {
        key: 'handleDescriptionEdit',
        value: function handleDescriptionEdit(e) {
            var categoryIndex = e.target.getAttribute('data-category');
            var desIndex = e.target.getAttribute('data-des');
            var checkList = this.state.checkList;
            var value = e.target.value;

            if (desIndex != -1) {
                if (value != '') {
                    checkList[this.props.index].categories[categoryIndex].description[desIndex] = value;
                    this.setState({ checkList: checkList });
                } else {
                    checkList[this.props.index].categories[categoryIndex].description.splice(desIndex, 1);
                    this.setState({ checkList: checkList });
                }
                this.updateFacility();
            } else {
                if (value != '') {
                    checkList[this.props.index].categories[categoryIndex].description.push(value);
                    this.setState({ checkList: checkList });
                    e.target.value = "";
                    this.updateFacility();
                }
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            this.props.callBack(this.state.checkList, this.state.newFacility);
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'renderDescription',
        value: function renderDescription(ct, category) {
            var _this2 = this;

            var description = ct.description.map(function (des, index) {
                return _react2.default.createElement(
                    'div',
                    { className: 'form-group input-group-sm', key: index },
                    _react2.default.createElement('input', { type: 'text', className: 'form-control', value: des,
                        placeholder: 'Type description here', 'data-category': category, 'data-des': index, onChange: _this2.handleDescriptionEdit })
                );
            });
            return _react2.default.createElement(
                'div',
                null,
                description,
                _react2.default.createElement(
                    'div',
                    { className: 'form-group input-group-sm' },
                    _react2.default.createElement('input', { type: 'text', className: 'form-control',
                        placeholder: 'New description here', 'data-category': category, 'data-des': -1, onKeyDown: this.desKey, onBlur: this.handleDescriptionEdit })
                )
            );
        }
    }, {
        key: 'renderCategory',
        value: function renderCategory() {
            var _this3 = this;

            if (!this.state.checkList) return;
            var categories = this.state.checkList[this.props.index].categories;
            var content = void 0;
            if (categories) {
                content = categories.map(function (ct, index) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'cl-wp', key: index },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Category'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', value: ct.category, id: 'category',
                                placeholder: 'Type category here', 'data-category': index, onChange: _this3.handleCategoryEdit })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'cl-ds-wp' },
                            _react2.default.createElement(
                                'label',
                                null,
                                'Description'
                            ),
                            _this3.renderDescription(ct, index)
                        )
                    );
                });
            }
            return _react2.default.createElement(
                'div',
                null,
                content,
                _react2.default.createElement(
                    'div',
                    { className: 'cl-wp' },
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'condoName' },
                            'New Category'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'newCategory',
                            placeholder: 'New category', 'data-category': -1, onKeyDown: this.catKey, onBlur: this.handleCategoryEdit })
                    )
                )
            );
        }
    }, {
        key: 'renderFacility',
        value: function renderFacility() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'condoName' },
                        'New Facility'
                    ),
                    _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'newCategory',
                        placeholder: 'New Facility', onChange: this.handleFacility })
                )
            );
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            if (this.props.action == 0) {
                return _react2.default.createElement(
                    'div',
                    null,
                    'Are you sure to remove?'
                );
            } else if (this.props.action == 1) {
                return this.renderCategory();
            } else {
                return this.renderFacility();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            var btnTxt = "";
            if (this.props.action == 0) {
                btnTxt = "Delete";
            } else if (this.props.action == 1) {
                btnTxt = "Update";
            } else if (this.props.action == 2) {
                btnTxt = "Add";
            }
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'checkList-modal', style: { visibility: style.visibility }, ref: 'modal' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            this.props.title
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body', style: { height: this.state.height - 75 - 40 + "px" } },
                        this.renderContent()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: "btn " + (this.props.action != 0 ? "btn-info" : "btn-danger"), onClick: this.handleSubmit },
                            btnTxt
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return ModalCheckList;
}(_react2.default.Component);

ModalCheckList.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = ModalCheckList;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalUpdated = function (_React$Component) {
    _inherits(ModalUpdated, _React$Component);

    function ModalUpdated(props) {
        _classCallCheck(this, ModalUpdated);

        var _this = _possibleConstructorReturn(this, (ModalUpdated.__proto__ || Object.getPrototypeOf(ModalUpdated)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        return _this;
    }

    _createClass(ModalUpdated, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {}
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'report-modal', style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            'Updated'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body' },
                        'Succesfully'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-info single-btn', onClick: this.modalClose },
                            'Ok'
                        )
                    )
                )
            );
        }
    }]);

    return ModalUpdated;
}(_react2.default.Component);

ModalUpdated.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = ModalUpdated;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _permissionAction = __webpack_require__(56);

var _permissionAction2 = _interopRequireDefault(_permissionAction);

var _permissionStore = __webpack_require__(271);

var _permissionStore2 = _interopRequireDefault(_permissionStore);

var _permissionModal = __webpack_require__(272);

var _permissionModal2 = _interopRequireDefault(_permissionModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PermissionSetting = function (_React$Component) {
    _inherits(PermissionSetting, _React$Component);

    function PermissionSetting(props) {
        _classCallCheck(this, PermissionSetting);

        var _this = _possibleConstructorReturn(this, (PermissionSetting.__proto__ || Object.getPrototypeOf(PermissionSetting)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.callBack = _this.callBack.bind(_this);
        _this.state = {
            staffs: _filterStore2.default.getState().staffs,
            processingFilter: _filterStore2.default.getState().processing,
            iniLoadStaff: _filterStore2.default.getState().iniLoadStaff,

            processing: _permissionStore2.default.getState().processing,
            isSucceed: _permissionStore2.default.getState().isSucceed,
            permission: _permissionStore2.default.getState().permission,

            staffIds: [],
            title: "",
            index: "",
            permissionId: "",
            modalClose: false
        };
        return _this;
    }

    _createClass(PermissionSetting, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _permissionStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);
            _menuAction2.default.pageNumber(14);
            if (!this.state.processing) {
                _permissionAction2.default.processing(true);
                _permissionAction2.default.getPermission();
            }
            if (!this.state.processingFilter && !this.state.iniLoadStaff) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getEmployee();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _permissionStore2.default.unlisten(this.onChange);
            _filterStore2.default.unlisten(this.onFilterChange);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.isSucceed && prevState.isSucceed != this.state.isSucceed) {
                this.setState({ modalClose: true });
            }
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({ modalClose: data });
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                staffs: state.staffs,
                processingFilter: state.processing,
                iniLoadStaff: state.iniLoadStaff
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                isSucceed: state.isSucceed,
                permission: state.permission
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var permissionId = e.target.getAttribute('data-id');
            var index = parseInt(e.target.getAttribute('data-index'));
            var staffIds = this.state.permission[index].staffIds;
            var title = this.state.permission[index].title;
            this.setState({
                permissionId: permissionId,
                staffIds: staffIds,
                index: index,
                title: title,
                modalClose: true
            });
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            if (this.state.processing) return;

            _permissionAction2.default.processing(true);
            _permissionAction2.default.updatePermission(this.state.permission);
        }
    }, {
        key: 'callBack',
        value: function callBack(staffIds) {
            var permission = this.state.permission;
            if (permission[this.state.index].permissionId == this.state.permissionId) {
                permission[this.state.index].staffIds = staffIds;
            }
            _permissionAction2.default.permission(permission);
            this.setState({ modalClose: false });
        }
    }, {
        key: 'renderList',
        value: function renderList(staffIds) {
            return staffIds.map(function (staff, index) {
                return _react2.default.createElement(
                    'div',
                    { className: 'pm-st', key: index },
                    staff.userName
                );
            });
        }
    }, {
        key: 'renderPermission',
        value: function renderPermission() {
            var _this2 = this;

            return this.state.permission.map(function (perm, index) {
                return _react2.default.createElement(
                    'div',
                    { className: 'pm-wp', key: index },
                    _react2.default.createElement(
                        'div',
                        { className: 'pm-tt-wp' },
                        _react2.default.createElement(
                            'div',
                            { className: 'pm-tt' },
                            perm.title
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'pm-ct' },
                            perm.description
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-default btn-sm pm-edit',
                                'data-id': perm.permissionId, 'data-index': index, onClick: _this2.handleClick
                            },
                            'Edit'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'pm-st-wp' },
                        _react2.default.createElement(
                            'div',
                            { className: 'pm-st-tt' },
                            'Users granted permission:'
                        ),
                        _this2.renderList(perm.staffIds)
                    )
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var modal = '';
            if (this.state.modalClose) {
                modal = _react2.default.createElement(_permissionModal2.default, {
                    modalClose: this.state.modalClose,
                    shouldModalClose: this.shouldModalClose,
                    staffIds: this.state.staffIds,
                    staffs: this.state.staffs,
                    title: this.state.title,
                    callBack: this.callBack
                });
            }
            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 us-form' },
                        _react2.default.createElement(
                            'h4',
                            null,
                            _react2.default.createElement(
                                'b',
                                null,
                                'Permission Management'
                            )
                        ),
                        this.renderPermission(),
                        _react2.default.createElement(
                            'div',
                            { className: 'pm-btn-group' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-danger', onClick: this.handleSubmit },
                                'Save'
                            )
                        )
                    )
                ),
                modal,
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.processingFilter })
            );
        }
    }]);

    return PermissionSetting;
}(_react2.default.Component);

exports.default = PermissionSetting;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _permissionAction = __webpack_require__(56);

var _permissionAction2 = _interopRequireDefault(_permissionAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var permissionStore = function () {
    function permissionStore() {
        _classCallCheck(this, permissionStore);

        this.bindActions(_permissionAction2.default);
        this.processing = false;
        this.permission = [];
    }

    _createClass(permissionStore, [{
        key: 'onProcessing',
        value: function onProcessing(data) {
            this.processing = data;
        }
    }, {
        key: 'onIsSucceed',
        value: function onIsSucceed(data) {
            this.isSucceed = data;
        }
    }, {
        key: 'onPermission',
        value: function onPermission(data) {
            this.permission = data;
        }
    }]);

    return permissionStore;
}();

exports.default = _alt2.default.createStore(permissionStore, 'permissionStore');

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _permissionAction = __webpack_require__(56);

var _permissionAction2 = _interopRequireDefault(_permissionAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PermissionModal = function (_React$Component) {
    _inherits(PermissionModal, _React$Component);

    function PermissionModal(props) {
        _classCallCheck(this, PermissionModal);

        var _this = _possibleConstructorReturn(this, (PermissionModal.__proto__ || Object.getPrototypeOf(PermissionModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleCheck = _this.handleCheck.bind(_this);
        _this.state = {
            staffIds: [],
            warningMsg: "",
            staffId: "",
            clientHeight: 200
        };
        return _this;
    }

    _createClass(PermissionModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var clientHeight = _reactDom2.default.findDOMNode(this.refs.modal).clientHeight;
            this.setState({
                staffIds: this.props.staffIds,
                clientHeight: clientHeight
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            this.setState({
                staffId: e.target.value
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            this.props.callBack(this.state.staffIds);
        }
    }, {
        key: 'handleCheck',
        value: function handleCheck(e) {
            var checked = e.target.checked;
            var staffId = e.target.value;
            var userName = e.target.getAttribute('data-username');

            var staffIds = this.state.staffIds;
            if (checked) {
                staffIds.push({
                    staffId: staffId,
                    userName: userName
                });
            } else {
                //remove from list
                var len = staffIds.length;
                for (var i = 0; i < len; i++) {
                    if (staffIds[i].staffId == staffId) {
                        staffIds.splice(i, 1);
                        break;
                    }
                }
            }
            this.setState({
                staffIds: staffIds
            });
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'checkStaff',
        value: function checkStaff(staff) {
            var isCheck = false;
            var len = this.state.staffIds.length;
            for (var i = 0; i < len; i++) {
                if (this.state.staffIds[i].staffId == staff.staffId) {
                    isCheck = true;
                    break;
                }
            }
            return isCheck;
        }
    }, {
        key: 'renderDetail',
        value: function renderDetail(staff, index) {
            //check if this facility is included;
            var isCheck = this.checkStaff(staff);

            return _react2.default.createElement(
                'li',
                { className: 'pm-li-1', key: index },
                _react2.default.createElement(
                    'div',
                    { className: 'checkbox' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', { type: 'checkbox', value: staff.staffId, 'data-username': staff.userName, onChange: this.handleCheck, checked: isCheck }),
                        _react2.default.createElement('span', { className: 'checkmark' }),
                        staff.userName
                    )
                )
            );
        }
    }, {
        key: 'renderList',
        value: function renderList(staffs) {
            var _this2 = this;

            return staffs.map(function (staff, index) {
                return _this2.renderDetail(staff, index);
            });
        }
    }, {
        key: 'renderStaff',
        value: function renderStaff() {
            var _this3 = this;

            if (this.props.staffs.length > 0) {
                var staffs = this.props.staffs.filter(function (staff) {
                    return staff.userName.toLowerCase().indexOf(_this3.state.staffId.toLowerCase()) > -1 || staff.staffId.toLowerCase().indexOf(_this3.state.staffId.toLowerCase()) > -1;
                });

                return this.renderList(staffs);
            }
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'staffFilter' },
                            'Staff:'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'staffFilter', placeholder: 'Search By name or ID', onChange: this.handleChange })
                    )
                ),
                _react2.default.createElement('div', { className: 'divider' }),
                _react2.default.createElement(
                    'ul',
                    { className: 'pm-ul', style: { height: this.state.clientHeight - 200 + "px", overflow: "auto" } },
                    this.renderStaff()
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'permission-modal', style: { visibility: style.visibility }, ref: 'modal' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            this.props.title
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body', style: { height: this.state.clientHeight - 115 + "px" } },
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        ),
                        this.renderContent()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-warning', onClick: this.handleClick },
                            'Done'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return PermissionModal;
}(_react2.default.Component);

PermissionModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = PermissionModal;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jpSetAction = __webpack_require__(57);

var _jpSetAction2 = _interopRequireDefault(_jpSetAction);

var _jpSetStore = __webpack_require__(274);

var _jpSetStore2 = _interopRequireDefault(_jpSetStore);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _emailModal = __webpack_require__(275);

var _emailModal2 = _interopRequireDefault(_emailModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JourneySetting = function (_React$Component) {
    _inherits(JourneySetting, _React$Component);

    function JourneySetting(props) {
        _classCallCheck(this, JourneySetting);

        var _this = _possibleConstructorReturn(this, (JourneySetting.__proto__ || Object.getPrototypeOf(JourneySetting)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.removeEmail = _this.removeEmail.bind(_this);
        _this.addEmail = _this.addEmail.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);

        _this.state = {
            processing: _jpSetStore2.default.getState().processing,
            conversionRate: _jpSetStore2.default.getState().conversionRate,
            emails: _jpSetStore2.default.getState().emails,
            modalClose: false
        };
        return _this;
    }

    _createClass(JourneySetting, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _jpSetStore2.default.listen(this.onChange);
            _menuAction2.default.pageNumber(9);
            if (!this.state.processing) {
                _jpSetAction2.default.processing(true);
                _jpSetAction2.default.getConversion();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _jpSetStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                conversionRate: state.conversionRate,
                emails: state.emails,
                processing: state.processing
            });
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({
                modalClose: data
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var conversionRate = parseFloat(e.target.value);

            _jpSetAction2.default.conversionRate(conversionRate);
        }
    }, {
        key: 'removeEmail',
        value: function removeEmail(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            _jpSetAction2.default.removeEmail(index);
        }
    }, {
        key: 'addEmail',
        value: function addEmail() {
            this.setState({ modalClose: true });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            if (this.state.processing) return;

            _jpSetAction2.default.processing(true);
            _jpSetAction2.default.updateJourneySetting(this.state.conversionRate, this.state.emails);
        }
    }, {
        key: 'renderEmails',
        value: function renderEmails() {
            var _this2 = this;

            var emails = this.state.emails.map(function (email, index) {
                return _react2.default.createElement(
                    'li',
                    { className: 'list-group-item', key: index },
                    _react2.default.createElement(
                        'div',
                        { className: 'jps-em' },
                        email
                    ),
                    _react2.default.createElement('div', { className: 'jps-rev glyphicon glyphicon-remove', 'data-index': index, onClick: _this2.removeEmail })
                );
            });

            return _react2.default.createElement(
                'ul',
                { className: 'list-group' },
                emails
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 us-form' },
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-3' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'atd-hd' },
                                    _react2.default.createElement(
                                        'h4',
                                        null,
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            'Journey Planner Management'
                                        )
                                    )
                                ),
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(
                                    'form',
                                    { className: 'atd-i-wp' },
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'conversionRate', className: 'control-label' },
                                        'Conversion Rate (SGD/km):'
                                    ),
                                    _react2.default.createElement('input', { type: 'number', className: 'form-control', id: 'conversionRate',
                                        value: this.state.conversionRate, onChange: this.handleChange })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-3' },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { htmlFor: 'emails', className: 'control-label' },
                                        'Email Groups:'
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { className: 'btn btn-default btn-xs jps-add ', onClick: this.addEmail },
                                        'Add'
                                    )
                                ),
                                _react2.default.createElement(
                                    'small',
                                    null,
                                    'Users to receive notification when claims approved '
                                ),
                                this.renderEmails()
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-3' },
                                _react2.default.createElement(
                                    'button',
                                    { className: 'btn btn-warning', onClick: this.handleClick },
                                    'Save'
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(_emailModal2.default, { modalClose: this.state.modalClose, shouldModalClose: this.shouldModalClose }),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing })
            );
        }
    }]);

    return JourneySetting;
}(_react2.default.Component);

exports.default = JourneySetting;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _jpSetAction = __webpack_require__(57);

var _jpSetAction2 = _interopRequireDefault(_jpSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var jpSetStore = function () {
    function jpSetStore() {
        _classCallCheck(this, jpSetStore);

        this.bindActions(_jpSetAction2.default);
        this.processing = false;
        this.conversionRate = 0;
        this.emails = [];
    }

    _createClass(jpSetStore, [{
        key: 'onProcessing',
        value: function onProcessing(data) {
            this.processing = data;
        }
    }, {
        key: 'onConversionRate',
        value: function onConversionRate(data) {
            this.conversionRate = data;
        }
    }, {
        key: 'onEmails',
        value: function onEmails(data) {
            this.emails = data;
        }
    }, {
        key: 'onRemoveEmail',
        value: function onRemoveEmail(data) {
            this.emails.splice(data, 1);
        }
    }, {
        key: 'onAddEmail',
        value: function onAddEmail(data) {
            this.emails = this.emails.concat(data);
        }
    }]);

    return jpSetStore;
}();

exports.default = _alt2.default.createStore(jpSetStore, 'jpSetStore');

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jpSetAction = __webpack_require__(57);

var _jpSetAction2 = _interopRequireDefault(_jpSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmailModal = function (_React$Component) {
    _inherits(EmailModal, _React$Component);

    function EmailModal(props) {
        _classCallCheck(this, EmailModal);

        var _this = _possibleConstructorReturn(this, (EmailModal.__proto__ || Object.getPrototypeOf(EmailModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.state = {
            txtValue1: ""

        };
        return _this;
    }

    _createClass(EmailModal, [{
        key: 'handleChange',
        value: function handleChange(e) {
            var value = e.target.value;
            this.setState({ txtValue1: value });
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            _jpSetAction2.default.addEmail(this.state.txtValue1);
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'renderBody',
        value: function renderBody() {
            var body = "";
            body = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                        'label',
                        null,
                        'Email'
                    ),
                    _react2.default.createElement('input', { className: 'form-control', type: 'email', onChange: this.handleChange, value: this.state.txtValue1 })
                )
            );

            return body;
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            var content = void 0;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'report-modal', style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            'Add Email'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body' },
                        this.renderBody()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: "btn btn-warning",
                                onClick: this.handleSubmit },
                            'Add'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return EmailModal;
}(_react2.default.Component);

EmailModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = EmailModal;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(1);

var _userAction = __webpack_require__(21);

var _userAction2 = _interopRequireDefault(_userAction);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResetForgotPassword = function (_React$Component) {
    _inherits(ResetForgotPassword, _React$Component);

    function ResetForgotPassword(props) {
        _classCallCheck(this, ResetForgotPassword);

        var _this = _possibleConstructorReturn(this, (ResetForgotPassword.__proto__ || Object.getPrototypeOf(ResetForgotPassword)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.state = {
            warningMsg: _userStore2.default.getState().warningMsg,
            processing: _userStore2.default.getState().processing,
            isfgPwdReset: _userStore2.default.getState().isfgPwdReset,
            newPassword: "",
            confirmPassword: ""
        };
        return _this;
    }

    _createClass(ResetForgotPassword, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _userStore2.default.listen(this.onChange);
            _userAction2.default.warningMsg('');
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _userStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _this2 = this;

            if (!prevState.isfgPwdReset && this.state.isfgPwdReset != prevState.isfgPwdReset) {
                console.log('repeat');
                _userAction2.default.warningMsg.defer("Password Successfully Reset. You will be redirected to login page in 3 seconds ");
                window.setTimeout(function () {
                    _this2.props.history.push('/');
                }, 3000);
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                warningMsg: state.warningMsg,
                processing: state.processing,
                isfgPwdReset: state.isfgPwdReset
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var value = e.target.value;

            if (index == 0) {
                this.setState({ newPassword: value });
            } else {
                this.setState({ confirmPassword: value });
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            var npwd = _reactDom2.default.findDOMNode(this.refs.npwd);
            var cpwd = _reactDom2.default.findDOMNode(this.refs.cpwd);
            try {
                npwd.reportValidity();
                cpwd.reportValidity();
            } catch (e) {}

            if (!npwd.checkValidity()) return;
            if (!cpwd.checkValidity()) return;

            if (this.state.processing) return;

            if (!this.validatePassword(this.state.newPassword)) return;

            if (this.state.newPassword != this.state.confirmPassword) {
                return _userAction2.default.warningMsg("Password not tally");
            }

            _userAction2.default.processing(true);
            _userAction2.default.resetFgPassword(this.props.match.params.token, this.state.newPassword);
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            if (e.key == 'Enter') {
                e.preventDefault();
                this.handleSubmit();
            }
        }
    }, {
        key: 'validatePassword',
        value: function validatePassword(password) {
            if (password.length < 8) {
                _userAction2.default.warningMsg("Password length must be minimum 8 characters");
                return false;
            } else if (password.match(/[A-Z]/g) == null) {
                _userAction2.default.warningMsg("Password must be at least one Capital letter");
                return false;
            }
            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'ul-w' },
                _react2.default.createElement(
                    'h2',
                    null,
                    ' A4 International '
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ul-tt' },
                    'Reset Password'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ul-warning' },
                    this.state.warningMsg
                ),
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ul-in' },
                            _react2.default.createElement('input', { type: 'password', ref: 'npwd', className: 'form-control',
                                placeholder: 'New Password', 'data-index': '0', onChange: this.handleChange, required: true })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'ul-in' },
                            _react2.default.createElement('input', { type: 'password', ref: 'cpwd', className: 'form-control',
                                placeholder: 'Confirm New Password', 'data-index': '1', onChange: this.handleChange,
                                onKeyPress: this.handleKeyPress, required: true })
                        )
                    ),
                    _react2.default.createElement(
                        'button',
                        { type: 'button', className: 'btn btn-default', onClick: this.handleSubmit },
                        'Change'
                    )
                )
            );
        }
    }]);

    return ResetForgotPassword;
}(_react2.default.Component);

exports.default = ResetForgotPassword;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _checkPtsAction = __webpack_require__(47);

var _checkPtsAction2 = _interopRequireDefault(_checkPtsAction);

var _checkPtsStore = __webpack_require__(278);

var _checkPtsStore2 = _interopRequireDefault(_checkPtsStore);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _CheckPtsModal = __webpack_require__(279);

var _CheckPtsModal2 = _interopRequireDefault(_CheckPtsModal);

var _checkIPModal = __webpack_require__(280);

var _checkIPModal2 = _interopRequireDefault(_checkIPModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckPtsSetting = function (_React$Component) {
    _inherits(CheckPtsSetting, _React$Component);

    function CheckPtsSetting(props) {
        _classCallCheck(this, CheckPtsSetting);

        var _this = _possibleConstructorReturn(this, (CheckPtsSetting.__proto__ || Object.getPrototypeOf(CheckPtsSetting)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.editIP = _this.editIP.bind(_this);
        _this.addIP = _this.addIP.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.shouldModalCloseIP = _this.shouldModalCloseIP.bind(_this);
        _this.addLocation = _this.addLocation.bind(_this);
        _this.editLocation = _this.editLocation.bind(_this);
        _this.removeLocation = _this.removeLocation.bind(_this);
        _this.removedIP = _this.removedIP.bind(_this);
        _this.state = {
            processing: _checkPtsStore2.default.getState().processing,
            //radius: checkPtsStore.getState().radius,
            checkPoint: _checkPtsStore2.default.getState().checkPoint,
            removedCheckPoint: _checkPtsStore2.default.getState().removedCheckPoint,
            IP: _checkPtsStore2.default.getState().IP,
            removedIP: _checkPtsStore2.default.getState().removedIP,
            modalClose: false,
            modalCloseIP: false,
            index: ""
        };
        return _this;
    }

    _createClass(CheckPtsSetting, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _checkPtsStore2.default.listen(this.onChange);
            _menuAction2.default.pageNumber(15);
            if (!this.state.processing) {
                _checkPtsAction2.default.processing(true);
                //checkPtsAction.getRadius();
                _checkPtsAction2.default.getCheckPoints();
                _checkPtsAction2.default.getIP();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _checkPtsStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                //radius: state.radius,
                checkPoint: state.checkPoint,
                removedCheckPoint: state.removedCheckPoint,
                IP: state.IP,
                removedIP: state.removedIP
            });
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({
                modalClose: data
            });
        }
    }, {
        key: 'shouldModalCloseIP',
        value: function shouldModalCloseIP(data) {
            this.setState({
                modalCloseIP: data
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            if (this.state.processing) return;

            _checkPtsAction2.default.processing(true);
            //checkPtsAction.updateRadius(this.state.radius);
            _checkPtsAction2.default.updateCheckPoint(this.state.checkPoint, this.state.removedCheckPoint, this.state.IP, this.state.removedIP);
        }
    }, {
        key: 'editIP',
        value: function editIP(e) {
            var index = parseInt(e.currentTarget.getAttribute("data-index"));
            this.setState({ index: index, modalCloseIP: true });
        }
    }, {
        key: 'removedIP',
        value: function removedIP(e) {
            var index = parseInt(e.currentTarget.getAttribute("data-index"));

            var IP = this.state.IP;
            var removedIP = this.state.removedIP;

            if (this.state.IP[index]._id) {
                removedIP = removedIP.concat(this.state.IP[index]);
            }
            IP.splice(index, 1);
            _checkPtsAction2.default.ip(IP);
            _checkPtsAction2.default.removedIP(removedIP);
        }
    }, {
        key: 'addIP',
        value: function addIP(e) {
            this.setState({
                index: "",
                modalCloseIP: true
            });
        }
    }, {
        key: 'addLocation',
        value: function addLocation(e) {
            this.setState({
                index: "",
                modalClose: true
            });
        }
    }, {
        key: 'removeLocation',
        value: function removeLocation(e) {
            var index = parseInt(e.currentTarget.getAttribute("data-index"));

            var checkPoint = this.state.checkPoint;
            var removedCheckPoint = this.state.removedCheckPoint;
            //check if index has id
            if (this.state.checkPoint[index]._id) {
                removedCheckPoint = removedCheckPoint.concat(this.state.checkPoint[index]);
            }
            checkPoint.splice(index, 1);
            _checkPtsAction2.default.checkPoint(checkPoint);
            _checkPtsAction2.default.removedCheckPoint(removedCheckPoint);
        }
    }, {
        key: 'editLocation',
        value: function editLocation(e) {
            var index = parseInt(e.currentTarget.getAttribute("data-index"));
            this.setState({ index: index, modalClose: true });
        }
    }, {
        key: 'renderIP',
        value: function renderIP() {
            var _this2 = this;

            return this.state.IP.map(function (ip, index) {
                return _react2.default.createElement(
                    'div',
                    { className: 'cp-wp', key: index },
                    _react2.default.createElement('div', { className: 'jps-rev glyphicon glyphicon-remove', 'data-index': index, onClick: _this2.removedIP }),
                    _react2.default.createElement(
                        'div',
                        { className: 'cp-title' },
                        ip.officeName
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'cp-coordinate' },
                        _react2.default.createElement(
                            'label',
                            { className: 'control-label' },
                            'IP Range'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'cp-lng' },
                            'Lower Range: \xA0',
                            ip.lowerRange.length > 0 ? ip.lowerRange[0] + " . " + ip.lowerRange[1] + " . " + ip.lowerRange[2] + " . " + ip.lowerRange[3] : ""
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'cp-lat' },
                            'Upper Range: \xA0',
                            ip.upperRange.length > 0 ? ip.upperRange[0] + " . " + ip.upperRange[1] + " . " + ip.upperRange[2] + " . " + ip.upperRange[3] : ""
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'btn btn-default btn-xs cp-edit', 'data-index': index, onClick: _this2.editIP },
                        'Edit'
                    )
                );
            });
        }
    }, {
        key: 'renderLocation',
        value: function renderLocation() {
            var _this3 = this;

            var location = this.state.checkPoint.map(function (location, index) {
                return _react2.default.createElement(
                    'div',
                    { className: 'cp-wp', key: index },
                    _react2.default.createElement('div', { className: 'jps-rev glyphicon glyphicon-remove', 'data-index': index, onClick: _this3.removeLocation }),
                    _react2.default.createElement(
                        'div',
                        { className: 'cp-title' },
                        location.location
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'cp-coordinate' },
                        _react2.default.createElement(
                            'label',
                            { className: 'control-label' },
                            'Coordinates'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'cp-lng' },
                            'Longitude: \xA0',
                            location.geoLocation.coordinates[0]
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'cp-lat' },
                            'Latitude: \xA0',
                            location.geoLocation.coordinates[1]
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'cp-radius' },
                        _react2.default.createElement(
                            'div',
                            { className: 'cp-radius' },
                            'Radius (meter): ',
                            location.radius ? location.radius : 0
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'btn btn-default btn-xs cp-edit', 'data-index': index, onClick: _this3.editLocation },
                        'Edit'
                    )
                );
            });

            return location;
        }
    }, {
        key: 'render',
        value: function render() {
            var modal = void 0,
                modalIP = void 0;
            if (this.state.modalClose) {
                modal = _react2.default.createElement(_CheckPtsModal2.default, { modalClose: this.state.modalClose, shouldModalClose: this.shouldModalClose, index: this.state.index,
                    checkPoint: this.state.checkPoint, removedCheckPoint: this.state.removedCheckPoint });
            }
            if (this.state.modalCloseIP) {
                modalIP = _react2.default.createElement(_checkIPModal2.default, { modalClose: this.state.modalCloseIP, shouldModalClose: this.shouldModalCloseIP, index: this.state.index,
                    IP: this.state.IP, removedIP: this.state.removedIP });
            }
            var s = this.state;
            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 us-form' },
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'atd-hd' },
                                    _react2.default.createElement(
                                        'h4',
                                        null,
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            'Location Management'
                                        )
                                    ),
                                    _react2.default.createElement('br', null)
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'control-label' },
                                        'Locations:'
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { className: 'btn btn-default btn-xs jps-add ', onClick: this.addLocation },
                                        'Add'
                                    )
                                ),
                                _react2.default.createElement(
                                    'small',
                                    null,
                                    'Employee time in/out location (Other than managing estate) '
                                ),
                                this.renderLocation()
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'control-label' },
                                        'IP Address'
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { className: 'btn btn-default btn-xs jps-add ', onClick: this.addIP },
                                        'Add'
                                    )
                                ),
                                _react2.default.createElement(
                                    'small',
                                    null,
                                    'Employee time in/out IP address (for web portal)'
                                ),
                                this.renderIP()
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-3' },
                                _react2.default.createElement('br', null),
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(
                                    'button',
                                    { className: 'btn btn-warning', onClick: this.handleClick },
                                    'Save'
                                )
                            )
                        )
                    )
                ),
                modal,
                modalIP,
                _react2.default.createElement(_loading2.default, { processing: this.state.processing })
            );
            /*
            <div className="col-sm-4">
                <div className="atd-hd">
                    <h4><b>Location Management</b></h4>
                </div>
                <br />
                  <div className="form-group">
                    <label htmlFor="radius">Maximum Estate Radius</label>
                    <small><br />Estates are detectable within the radius (meter)</small>
                    <input type="number" className="form-control" id="radius" value={this.state.radius}
                        placeholder="meter" onChange={this.handleEdit} />
                </div>
              </div>
            */
        }
    }]);

    return CheckPtsSetting;
}(_react2.default.Component);

exports.default = CheckPtsSetting;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alt = __webpack_require__(2);

var _alt2 = _interopRequireDefault(_alt);

var _checkPtsAction = __webpack_require__(47);

var _checkPtsAction2 = _interopRequireDefault(_checkPtsAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var checkPtsStore = function () {
    function checkPtsStore() {
        _classCallCheck(this, checkPtsStore);

        this.bindActions(_checkPtsAction2.default);
        this.processing = false;
        //this.radius = 0;
        this.checkPoint = [];
        this.removedCheckPoint = [];
        this.IP = [];
        this.removedIP = [];
    }

    _createClass(checkPtsStore, [{
        key: 'onProcessing',
        value: function onProcessing(data) {
            this.processing = data;
        }
    }, {
        key: 'onClear',
        value: function onClear(data) {
            this.checkPoint = [];
            this.removedCheckPoint = [];
            //this.radius = 0;
        }
    }, {
        key: 'onCheckPoint',
        value: function onCheckPoint(data) {
            this.checkPoint = data;
        }
    }, {
        key: 'onRemovedCheckPoint',
        value: function onRemovedCheckPoint(data) {
            this.removedCheckPoint = data;
        }
    }, {
        key: 'onRadius',
        value: function onRadius(data) {
            this.radius = data;
        }
    }, {
        key: 'onIp',
        value: function onIp(data) {
            this.IP = data;
        }
    }, {
        key: 'onRemovedIP',
        value: function onRemovedIP(data) {
            this.removedIP = data;
        }
    }]);

    return checkPtsStore;
}();

exports.default = _alt2.default.createStore(checkPtsStore, 'checkPtsStore');

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _checkPtsAction = __webpack_require__(47);

var _checkPtsAction2 = _interopRequireDefault(_checkPtsAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckPtsModal = function (_React$Component) {
    _inherits(CheckPtsModal, _React$Component);

    function CheckPtsModal(props) {
        _classCallCheck(this, CheckPtsModal);

        var _this = _possibleConstructorReturn(this, (CheckPtsModal.__proto__ || Object.getPrototypeOf(CheckPtsModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.state = {
            _id: "",
            location: "",
            lat: "",
            lng: "",
            radius: "",
            warningMsg: ""
        };
        return _this;
    }

    _createClass(CheckPtsModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (typeof this.props.index == 'number' && this.props.index != null) {
                this.setState({
                    _id: this.props.checkPoint[this.props.index]._id,
                    location: this.props.checkPoint[this.props.index].location,
                    lng: this.props.checkPoint[this.props.index].geoLocation.coordinates[0],
                    lat: this.props.checkPoint[this.props.index].geoLocation.coordinates[1],
                    radius: this.props.checkPoint[this.props.index].radius
                });
            }
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var value = e.target.value;
            if (index == 0) {
                this.setState({ location: value });
            } else if (index == 1) {
                this.setState({ lng: parseFloat(value) });
            } else if (index == 2) {
                this.setState({ lat: parseFloat(value) });
            } else {
                this.setState({ radius: parseInt(value) });
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            if (this.state.location == "" || this.state.lat == "" || this.state.lng == "") {
                return this.setState({ warningMsg: "Please fill in all the information" });
            } else if (this.state.lng < -180 || this.state.lng > 180) {
                return this.setState({ warningMsg: "Longtitude value out of bound" });
            } else if (this.state.lat < -90 || this.state.lat > 90) {
                return this.setState({ warningMsg: "Latitude value out of bound" });
            } else if (this.state.radius == "") {
                return this.setState({ warningMsg: "Please fill in radius" });
            } else {
                var checkPoint = this.props.checkPoint;
                if (typeof this.props.index == "number" && this.props.index != null) {

                    if (checkPoint[this.props.index]._id == this.state._id) {
                        checkPoint[this.props.index].location = this.state.location;
                        checkPoint[this.props.index].geoLocation.coordinates = [this.state.lng, this.state.lat];
                        checkPoint[this.props.index].radius = this.state.radius;
                    }
                } else {
                    checkPoint = checkPoint.concat({
                        location: this.state.location,
                        geoLocation: {
                            type: "Point",
                            coordinates: [this.state.lng, this.state.lat]
                        },
                        radius: this.state.radius
                    });
                }
                _checkPtsAction2.default.checkPoint(checkPoint);
                this.props.shouldModalClose(false);
            }
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'renderBody',
        value: function renderBody() {
            var body = "";
            body = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                        'label',
                        null,
                        'Location:'
                    ),
                    _react2.default.createElement('input', { className: 'form-control', type: 'text', onChange: this.handleChange, value: this.state.location, 'data-index': '0' })
                ),
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                        'label',
                        null,
                        'Lng:'
                    ),
                    _react2.default.createElement('input', { className: 'form-control', type: 'number', onChange: this.handleChange, value: this.state.lng, 'data-index': '1' })
                ),
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                        'label',
                        null,
                        'Lat:'
                    ),
                    _react2.default.createElement('input', { className: 'form-control', type: 'number', onChange: this.handleChange, value: this.state.lat, 'data-index': '2' })
                ),
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                        'label',
                        null,
                        'Radius (meter):'
                    ),
                    _react2.default.createElement('input', { className: 'form-control', type: 'number', onChange: this.handleChange, value: this.state.radius, 'data-index': '3' })
                )
            );

            return body;
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            var content = void 0;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'report-modal', style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            'Add/Edit Location'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body' },
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        ),
                        this.renderBody()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: "btn btn-warning",
                                onClick: this.handleSubmit },
                            'Add'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return CheckPtsModal;
}(_react2.default.Component);

CheckPtsModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = CheckPtsModal;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _checkPtsAction = __webpack_require__(47);

var _checkPtsAction2 = _interopRequireDefault(_checkPtsAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckIPModal = function (_React$Component) {
    _inherits(CheckIPModal, _React$Component);

    function CheckIPModal(props) {
        _classCallCheck(this, CheckIPModal);

        var _this = _possibleConstructorReturn(this, (CheckIPModal.__proto__ || Object.getPrototypeOf(CheckIPModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.state = {
            _id: "",
            upperRange: [-1, -1, -1, -1],
            lowerRange: [-1, -1, -1, -1],
            officeName: "",
            warningMsg: ""
        };
        return _this;
    }

    _createClass(CheckIPModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (typeof this.props.index == "number" && this.props.index != null) {
                this.setState({
                    _id: this.props.IP[this.props.index]._id,
                    officeName: this.props.IP[this.props.index].officeName,
                    lowerRange: this.props.IP[this.props.index].lowerRange,
                    upperRange: this.props.IP[this.props.index].upperRange
                });
            }
        }
    }, {
        key: 'handleEdit',
        value: function handleEdit(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var pos = parseInt(e.target.getAttribute("data-pos"));
            var value = e.target.value;
            if (index == 0) {
                this.setState({ officeName: value });
            } else if (index == 1) {
                var lowerRange = this.state.lowerRange;
                lowerRange[pos] = parseInt(value);
                this.setState({ lowerRange: lowerRange });
            } else if (index == 2) {
                var upperRange = this.state.upperRange;
                upperRange[pos] = parseInt(value);
                this.setState({ upperRange: upperRange });
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            if (this.state.officeName == "" || this.state.lowerRange[0] < 0 || this.state.lowerRange[0] == "" || this.state.lowerRange[1] < 0 || this.state.lowerRange[1] == "" || this.state.lowerRange[2] < 0 || this.state.lowerRange[2] == "" || this.state.lowerRange[3] < 0 || this.state.lowerRange[3] == "" || this.state.upperRange[0] < 0 || this.state.upperRange[0] == "" || this.state.upperRange[1] < 0 || this.state.upperRange[1] == "" || this.state.upperRange[2] < 0 || this.state.upperRange[2] == "" || this.state.upperRange[3] < 0 || this.state.upperRange[3] == "") {
                return this.setState({ warningMsg: "Please fill in all the information" });
            } else {
                var IP = this.props.IP;
                if (typeof this.props.index == 'number' && this.props.index != null) {

                    if (IP[this.props.index]._id == this.state._id) {
                        IP[this.props.index].officeName = this.state.officeName;
                        IP[this.props.index].lowerRange = this.state.lowerRange;
                        IP[this.props.index].upperRange = this.state.upperRange;
                    }
                } else {
                    IP = IP.concat({
                        officeName: this.state.officeName,
                        lowerRange: this.state.lowerRange,
                        upperRange: this.state.upperRange
                    });
                }
                _checkPtsAction2.default.ip(IP);
                this.props.shouldModalClose(false);
            }
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'renderBody',
        value: function renderBody() {
            var body = "";
            var s = this.state;
            body = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'officeName' },
                        'Location Name'
                    ),
                    _react2.default.createElement('input', { type: 'text', className: 'form-control', value: s.officeName,
                        placeholder: 'Type Office Name Here', 'data-index': '0', 'data-pos': '0', onChange: this.handleEdit })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'form-group form-group-sm cp-ip-1' },
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'lowerRange' },
                        'IP range (Lower):'
                    ),
                    _react2.default.createElement('input', { type: 'number', className: 'form-control cp-ip', value: s.lowerRange[0] != -1 ? s.lowerRange[0] : "",
                        placeholder: '122', 'data-index': '1', 'data-pos': '0', onChange: this.handleEdit }),
                    _react2.default.createElement('input', { type: 'number', className: 'form-control cp-ip', value: s.lowerRange[1] != -1 ? s.lowerRange[1] : "",
                        placeholder: '122', 'data-index': '1', 'data-pos': '1', onChange: this.handleEdit }),
                    _react2.default.createElement('input', { type: 'number', className: 'form-control cp-ip', value: s.lowerRange[2] != -1 ? s.lowerRange[2] : "",
                        placeholder: '122', 'data-index': '1', 'data-pos': '2', onChange: this.handleEdit }),
                    _react2.default.createElement('input', { type: 'number', className: 'form-control cp-ip', value: s.lowerRange[3] != -1 ? s.lowerRange[3] : "",
                        placeholder: '122', 'data-index': '1', 'data-pos': '3', onChange: this.handleEdit })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'form-group form-group-sm cp-ip-1' },
                    _react2.default.createElement(
                        'label',
                        { htmlFor: 'upperRange' },
                        'IP range (Upper):'
                    ),
                    _react2.default.createElement('input', { type: 'number', className: 'form-control cp-ip', value: s.upperRange[0] != -1 ? s.upperRange[0] : "",
                        placeholder: '122', 'data-index': '2', 'data-pos': '0', onChange: this.handleEdit }),
                    _react2.default.createElement('input', { type: 'number', className: 'form-control cp-ip', value: s.upperRange[1] != -1 ? s.upperRange[1] : "",
                        placeholder: '122', 'data-index': '2', 'data-pos': '1', onChange: this.handleEdit }),
                    _react2.default.createElement('input', { type: 'number', className: 'form-control cp-ip', value: s.upperRange[2] != -1 ? s.upperRange[2] : "",
                        placeholder: '122', 'data-index': '2', 'data-pos': '2', onChange: this.handleEdit }),
                    _react2.default.createElement('input', { type: 'number', className: 'form-control cp-ip', value: s.upperRange[3] != -1 ? s.upperRange[3] : "",
                        placeholder: '122', 'data-index': '2', 'data-pos': '3', onChange: this.handleEdit })
                )
            );

            return body;
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            var content = void 0;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'report-modal', style: { visibility: style.visibility } },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            'Add/Edit IP'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body' },
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        ),
                        this.renderBody()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: "btn btn-warning",
                                onClick: this.handleSubmit },
                            'Add'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return CheckIPModal;
}(_react2.default.Component);

CheckIPModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = CheckIPModal;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _attdAction = __webpack_require__(19);

var _attdAction2 = _interopRequireDefault(_attdAction);

var _attdStore = __webpack_require__(25);

var _attdStore2 = _interopRequireDefault(_attdStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AttendanceCheck = function (_React$Component) {
    _inherits(AttendanceCheck, _React$Component);

    function AttendanceCheck(props) {
        _classCallCheck(this, AttendanceCheck);

        var _this = _possibleConstructorReturn(this, (AttendanceCheck.__proto__ || Object.getPrototypeOf(AttendanceCheck)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.punchBtn = _this.punchBtn.bind(_this);
        _this.handleRemark = _this.handleRemark.bind(_this);
        _this.handleError = _this.handleError.bind(_this);
        _this.state = {
            processing: _attdStore2.default.getState().processing,
            attendanceId: _attdStore2.default.getState().attendanceId,
            startWorkHr: _attdStore2.default.getState().startWorkHr,
            startWorkMin: _attdStore2.default.getState().startWorkMin,
            endWorkHr: _attdStore2.default.getState().endWorkHr,
            endWorkMin: _attdStore2.default.getState().endWorkMin,
            remark: "",
            canSubmit: _attdStore2.default.getState().canSubmit
        };
        return _this;
    }

    _createClass(AttendanceCheck, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _attdStore2.default.listen(this.onChange);
            if (!this.state.processing) {
                _attdAction2.default.processing(true);
                _attdAction2.default.checkInitAttendance();
            }

            _menuAction2.default.pageNumber.defer(-1);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _attdStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'handleRemark',
        value: function handleRemark(e) {
            var value = e.target.value;
            this.setState({
                remark: value
            });
        }
    }, {
        key: 'handleError',
        value: function handleError() {
            _modalAction2.default.modalContent({
                title: "Error",
                content: "Sorry, no position available."
            });
            _modalAction2.default.modalClose(true);
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                attendanceId: state.attendanceId,
                startWorkHr: state.startWorkHr,
                startWorkMin: state.startWorkMin,
                endWorkHr: state.endWorkHr,
                endWorkMin: state.endWorkMin,
                canSubmit: state.canSubmit
            });
        }
    }, {
        key: 'punchBtn',
        value: function punchBtn(e) {
            var today = new Date();
            var s = this.state;
            var timeInCheck = new Date(today.getFullYear(), today.getMonth(), today.getDate(), s.startWorkHr, s.startWorkMin);
            var timeOutCheck = new Date(today.getFullYear(), today.getMonth(), today.getDate(), s.endWorkHr, s.endWorkMin);
            if (!this.state.canSubmit) {
                _modalAction2.default.modalContent({
                    title: "Warning",
                    content: "Please Time Out previous day first"
                });
                _modalAction2.default.modalClose(true);
                return;
            }
            if (this.state.attendanceId) {
                //if timeOutearlier
                if (today.getTime() < timeOutCheck.getTime()) {
                    if (this.state.remark == "") {
                        _modalAction2.default.modalContent({
                            title: "Warning",
                            content: "Remark cannot be empty"
                        });
                        _modalAction2.default.modalClose(true);
                        return;
                    }
                }
                _attdAction2.default.processing(true);
                _attdAction2.default.timeOut(this.state.attendanceId, this.state.remark);
            } else {
                if (today.getTime() > timeInCheck.getTime()) {
                    if (this.state.remark == "") {
                        _modalAction2.default.modalContent({
                            title: "Warning",
                            content: "Remark cannot be empty"
                        });
                        _modalAction2.default.modalClose(true);
                        return;
                    }
                }
                _attdAction2.default.processing(true);
                _attdAction2.default.timeIn(this.state.remark);
            }
            this.setState({ remark: "" });
        }
    }, {
        key: 'remarkShow',
        value: function remarkShow() {
            var today = new Date();
            var s = this.state;
            var timeInCheck = new Date(today.getFullYear(), today.getMonth(), today.getDate(), s.startWorkHr, s.startWorkMin);
            var timeOutCheck = new Date(today.getFullYear(), today.getMonth(), today.getDate(), s.endWorkHr, s.endWorkMin);
            if (today.getTime() > timeInCheck.getTime() && (this.state.attendanceId == "" || this.state.attendanceId == null)) {
                return (
                    //You have checked in later than your regular start Time. Please state your reason here
                    _react2.default.createElement('textarea', { rows: '4', placeholder: 'Add remark here',
                        style: { resize: "none", width: "300px" }, onChange: this.handleRemark,
                        value: this.state.remark })
                );
            } else if (today.getTime() < timeOutCheck.getTime()) {
                return (
                    //You have checked out earlier than your regular end Time. Please state your reason here
                    _react2.default.createElement('textarea', { rows: '4', placeholder: 'Add remark here',
                        style: { resize: "none", width: "300px" }, onChange: this.handleRemark,
                        value: this.state.remark })
                );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_navBar2.default, this.props),
                _react2.default.createElement(
                    'div',
                    { className: 'container-fluid content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(_sideMenu2.default, this.props),
                        _react2.default.createElement(
                            'div',
                            { className: ' col-md-10  col-sm-8 atd' },
                            _react2.default.createElement(
                                'h4',
                                null,
                                'Attendance (Time In/Time Out)'
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                new Date().toDateString()
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'warning' },
                                this.state.warningMsg
                            ),
                            this.remarkShow(),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'button',
                                    { className: 'atd-pc-1 btn btn-default', onClick: this.punchBtn },
                                    this.state.attendanceId ? "Time Out" : "Time In"
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.processingFilter })
            );
        }
    }]);

    return AttendanceCheck;
}(_react2.default.Component);

exports.default = AttendanceCheck;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(1);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _leaveAction = __webpack_require__(20);

var _leaveAction2 = _interopRequireDefault(_leaveAction);

var _leaveStore = __webpack_require__(32);

var _leaveStore2 = _interopRequireDefault(_leaveStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveApply = function (_React$Component) {
    _inherits(LeaveApply, _React$Component);

    function LeaveApply(props) {
        _classCallCheck(this, LeaveApply);

        var _this = _possibleConstructorReturn(this, (LeaveApply.__proto__ || Object.getPrototypeOf(LeaveApply)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.upLoadImg = _this.upLoadImg.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.handleTimeEdit = _this.handleTimeEdit.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.clear = _this.clear.bind(_this);
        _this.state = {
            processing: _leaveStore2.default.getState().processing,
            summary: _leaveStore2.default.getState().summary.summary,
            isLeaveSuccess: _leaveStore2.default.getState().isLeaveSuccess,
            filterProcessing: _filterStore2.default.getState().processing,
            iniLoadHoliday: _filterStore2.default.getState().iniLoadHoliday,
            holiday: _filterStore2.default.getState().holiday,
            leave: {
                type: 0,
                startYear: 0,
                startMonth: 0,
                startDate: 0,
                endYear: 0,
                endMonth: 0,
                endDate: 0,
                apmStart: 0,
                apmEnd: 0,
                startTime: "",
                endTime: "",
                duration: 0,
                reason: "",
                leaveImage: ""
            }
        };
        return _this;
    }

    _createClass(LeaveApply, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _leaveStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);
            if (!this.state.processing) {
                _leaveAction2.default.processing(true);
                _leaveAction2.default.getSummary(this.props.match.params.staffId);
                _leaveAction2.default.isLeaveSuccess(false);
            }
            if (!this.state.filterProcessing && !this.state.iniLoadHoliday) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getHoliday();
            }

            _menuAction2.default.pageNumber.defer(-1);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _leaveStore2.default.unlisten(this.onChange);
            _filterStore2.default.unlisten(this.onFilterChange);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.isLeaveSuccess && prevState.isLeaveSuccess != this.state.isLeaveSuccess) {
                window.setTimeout(function () {
                    window.location.reload();
                }, 3000);
            }
        }
    }, {
        key: 'clear',
        value: function clear() {
            this.setState({
                leave: {
                    type: 0,
                    startYear: 0,
                    startMonth: 0,
                    startDate: 0,
                    endYear: 0,
                    endMonth: 0,
                    endDate: 0,
                    apmStart: 0,
                    apmEnd: 0,
                    duration: 0,
                    reason: ""
                }
            });
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                filterProcessing: state.processing,
                iniLoadHoliday: state.iniLoadHoliday,
                holiday: state.holiday
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                summary: state.summary.summary,
                isLeaveSuccess: state.isLeaveSuccess
            });
        }
    }, {
        key: 'upLoadImg',
        value: function upLoadImg(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var file = e.target.files[0];
            this._previewImage(file, index);
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var s = this.state.leave;
            if (index == 0) {
                //type
                s.type = parseInt(e.target.value);
            } else if (index == 2) {
                s.apmStart = parseInt(e.target.value);
            } else if (index == 4) {
                s.apmEnd = parseInt(e.target.value);
            }

            this.setState({
                leave: s
            });
            this.calculateDuration();
        }
    }, {
        key: 'handleTimeEdit',
        value: function handleTimeEdit(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var s = this.state.leave;
            if (index == 7) {
                s.startTime = e.target.value;
            } else if (index == 8) {
                s.endTime = e.target.value;
            }

            this.setState({ leave: s });
            this.calculateDuration();
        }
    }, {
        key: 'handleEdit',
        value: function handleEdit(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var s = this.state.leave;
            var data = void 0;
            if (index == 1) {
                data = e.target.value.split("-");
                s.startYear = parseInt(data[0]);
                s.startMonth = parseInt(data[1]) - 1;
                s.startDate = parseInt(data[2]);
            } else if (index == 3) {
                data = e.target.value.split("-");
                s.endYear = parseInt(data[0]);
                s.endMonth = parseInt(data[1]) - 1;
                s.endDate = parseInt(data[2]);
            } else if (index == 5) {
                data = e.target.value;
                s.reason = data;
            }
            this.setState({ leave: s });
            this.calculateDuration();
        }
    }, {
        key: 'isHoliday',
        value: function isHoliday(year, month, date) {
            var isHoliday = false;
            if (this.state.holiday) {
                if (this.state.holiday.holiday) {
                    var s = this.state.holiday;
                    var len = s.holiday.length;
                    for (var i = 0; i < len; i++) {
                        if (s.holiday[i].year == year && s.holiday[i].month == month && s.holiday[i].date == date) {
                            isHoliday = true;
                            break;
                        }
                    }
                }
            }

            return isHoliday;
        }
    }, {
        key: 'calculateDuration',
        value: function calculateDuration() {
            var s = this.state.leave;
            if (s.startYear != 0 && s.endYear != 0) {
                var sDate = new Date(s.startYear, s.startMonth, s.startDate);
                var eDate = new Date(s.endYear, s.endMonth, s.endDate);
                var duration = 0;

                //if start and end are same day
                if (s.startYear == s.endYear && s.startMonth == s.endMonth && s.startDate == s.endDate) {
                    s.apmEnd = 0;
                }

                var noDays = parseInt(eDate.getTime() - sDate.getTime()) / 1000 / 60 / 60 / 24 + 1;
                if (noDays > 0) {
                    for (var j = 0; j < noDays; j++) {
                        var day = new Date(s.startYear, s.startMonth, s.startDate + j).getDay();
                        var isHoliday = this.isHoliday(s.startYear, s.startMonth, s.startDate + j);
                        if (isHoliday) {} else if (j == 0 && day == 6) {
                            if (this.state.holiday.saturdayWork == 0) {
                                if (s.apmStart == 1 || s.apmStart == 2) {
                                    duration += 0.5;
                                } else {
                                    duration += 1;
                                }
                            } else if (this.state.holiday.saturdayWork == 1) {
                                duration += 0.5;
                                s.apmStart = 1;
                            } else if (this.state.holiday.saturdayWork == 2) {
                                s.apmStart = 0;
                            }
                        } else if (j == 0 && day == 0) {
                            //sun
                            s.apmStart = 0;
                        } else if (j == 0 && (s.apmStart == 1 || s.apmStart == 2)) {
                            duration += 0.5;
                        } else if (j == 0 && s.apmStart == 0) {
                            duration += 1;
                        } else if (j + 1 == noDays && day == 6) {
                            if (this.state.holiday.saturdayWork == 0) {
                                if (s.apmEnd == 1 || s.apmEnd == 2) {
                                    duration += 0.5;
                                } else {
                                    duration += 1;
                                }
                            } else if (this.state.holiday.saturdayWork == 1) {
                                duration += 0.5;
                                s.apmEnd = 1;
                            } else if (this.state.holiday.saturdayWork == 2) {
                                s.apmEnd = 1;
                            }
                        } else if (j + 1 == noDays && day == 0) {
                            s.apmEnd = 0;
                        } else if (j + 1 == noDays && (s.apmEnd == 1 || s.apmEnd == 2)) {
                            duration += 0.5;
                        } else if (j == 0 && s.apmEnd == 0) {
                            duration += 1;
                        } else if (day == 6) {
                            if (this.state.holiday.saturdayWork == 0) {
                                duration += 1;
                            } else if (this.state.holiday.saturdayWork == 1) {
                                duration += 0.5;
                            }
                        } else if (day == 0) {} else {
                            duration += 1;
                        }
                    }
                }

                //if end date less than start date
                if (noDays <= 0) {
                    _modalAction2.default.modalContent({ title: "Warning", content: "End Date must be greater than start Date" });
                    _modalAction2.default.modalClose(true);
                    s.endYear = 0;
                    s.endMonth = 0;
                    s.endDate = 0;
                    s.apmEnd = 0;
                    this.setState({ leave: s });
                    return;
                }
                //s.duration = duration - minus;
                s.duration = duration;
                this.setState({ leave: s });
            } else if (s.type == 7) {

                if (s.startTime && s.endTime) {
                    var _sDate = new Date(s.startYear, s.startMonth, s.startDate, parseInt(s.startTime.split(":")[0]), parseInt(s.startTime.split(":")[1]));
                    var _eDate = new Date(s.startYear, s.startMonth, s.startDate, parseInt(s.endTime.split(":")[0]), parseInt(s.endTime.split(":")[1]));
                    var _duration = 0;
                    var _isHoliday = this.isHoliday(s.startYear, s.startMonth, s.startDate);
                    if (!_isHoliday) {
                        _duration = (_eDate.getTime() - _sDate.getTime()) / 1000 / 60 / 60;

                        if (_duration <= 0) {
                            _modalAction2.default.modalContent({ title: "Warning", content: "End Time must be greater than Start Time" });
                            _modalAction2.default.modalClose(true);
                            s.endTime = "";
                            _duration = 0;
                        }
                    }
                    s.duration = _duration;
                }

                this.setState({ leave: s });
            }
        }
    }, {
        key: '_previewImage',
        value: function _previewImage(file, index) {
            var _this2 = this;

            //to be modified
            var fr = new FileReader();
            fr.onload = function (e) {
                var imgUrl = window.URL.createObjectURL(new Blob([e.target.result]));
                var img = new Image();

                img.onload = function () {
                    _this2.resizeImage(img, index);
                };

                img.src = imgUrl;
            };
            fr.readAsArrayBuffer(file);
        }
    }, {
        key: 'resizeImage',
        value: function resizeImage(image, index) {
            var oHeight = image.naturalHeight;
            var oWidth = image.naturalWidth;
            var newImage = void 0,
                newSize = void 0;
            var oSize = { oHeight: oHeight, oWidth: oWidth };
            newSize = { width: 500, height: 500 * oHeight / oWidth };

            newImage = this._imgResize(image, newSize, oSize);
            var blobFile = this.dataURItoBlob(newImage);
            var leave = this.state.leave;
            if (index == 0) {
                leave.leaveImage = blobFile;
            } else if (index == 1) {
                leave.receiptImage = blobFile;
            }
            this.setState({ leave: leave });
        }
    }, {
        key: 'dataURItoBlob',
        value: function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = window.atob(dataURI.split(',')[1]);else byteString = unescape(dataURI.split(',')[1]);

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], { type: mimeString });
        }
    }, {
        key: '_imgResize',
        value: function _imgResize(img, newSize, oSize) {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext("2d");
            canvas.width = newSize.width;
            canvas.height = newSize.height;
            ctx.drawImage(img, 0, 0, oSize.oWidth, oSize.oHeight, 0, 0, newSize.width, newSize.height);
            return canvas.toDataURL('image/jpeg', 1);
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            //check available
            var s = this.state.leave;
            var available = void 0;
            var len = this.state.summary.length;
            var summary = this.state.summary;
            if (s.type != 7) {
                if (s.startYear == 0 || s.startDate == 0 || s.endYear == 0 || s.endDate == 0) {
                    //show warning
                    _modalAction2.default.modalContent({ title: "Warning", content: "Please select Date" });
                    _modalAction2.default.modalClose(true);
                    return;
                }
            } else if (s.type == 7) {
                if (s.startYear == 0 || s.startDate == 0 || s.startTime == "" || s.endTime == "") {
                    //show warning
                    _modalAction2.default.modalContent({ title: "Warning", content: "Please fill up Start Date, Start Time and End Time" });
                    _modalAction2.default.modalClose(true);
                    return;
                }
            }

            for (var i = 0; i < len; i++) {
                if (s.type == 0 && s.type == summary[i].type) {
                    available = summary[i].leaveGain + summary[i].bringFwd - summary[i].used;
                } else if (s.type == 9 && s.type == summary[i].type) {
                    var annualTotalAvail = this.findAnnualTotalAvail();
                    available = Math.min(annualTotalAvail, summary[i].totalGain - summary[i].used);
                } else if (s.type != 4 && s.type != 6 && s.type == summary[i].type) {
                    available = summary[i].totalGain - summary[i].used;
                }
            }
            if (s.type != 4 && s.type != 6) {
                console.log(available);
                if (available < s.duration) {
                    //show warning
                    _modalAction2.default.modalContent({ title: "Warning", content: "Your leave balance is not enough" });
                    _modalAction2.default.modalClose(true);
                    return;
                }
            } else if (s.reason == "") {
                _modalAction2.default.modalContent({ title: "Warning", content: "Reason is needed for unpaid leave or other leave" });
                _modalAction2.default.modalClose(true);
                return;
            }
            //submit
            var fd = new FormData();
            if (s.leaveImage) {
                fd.append("images", s.leaveImage);
            }
            if (s.receiptImage) {
                fd.append("receipt", s.receiptImage);
            }
            fd.append("type", s.type);
            fd.append("startYear", s.startYear);
            fd.append("startMonth", s.startMonth);
            fd.append("startDate", s.startDate);
            fd.append("endYear", s.endYear);
            fd.append("endMonth", s.endMonth);
            fd.append("endDate", s.endDate);
            fd.append("apmStart", s.apmStart);
            fd.append("apmEnd", s.apmEnd);
            fd.append("duration", s.duration);
            fd.append("reason", s.reason);
            fd.append("startTime", s.startTime);
            fd.append("endTime", s.endTime);

            _leaveAction2.default.processing(true);
            _leaveAction2.default.applyLeave(fd);
            this.clear();
        }
    }, {
        key: 'findAnnualTotalAvail',
        value: function findAnnualTotalAvail() {
            var annualTotalAvail = 0;
            var month = new Date().getMonth();
            var summary = this.state.summary;
            //need to loop to find
            for (var i = 0; i < summary.length; i++) {
                if (summary[i].type == 0) {
                    var remainingDays = (11 - month) * summary[i].totalGain / 11;
                    annualTotalAvail = remainingDays + summary[i].leaveGain + summary[i].bringFwd - summary[i].used;
                    break;
                    //annualTotalAvail = this.state.summary[i].totalGain + this.state.summary[i].bringFwd - this.state.summary[i].used;
                }
            }
            return annualTotalAvail;
        }
    }, {
        key: 'renderType',
        value: function renderType() {
            var _this3 = this;

            var annualTotalAvail = 0;
            if (this.state.summary) {
                return this.state.summary.map(function (summary, index) {
                    var available = void 0;
                    if (summary.type == 0) {
                        available = summary.leaveGain + summary.bringFwd - summary.used;
                    } else if (summary.type == 9) {
                        annualTotalAvail = _this3.findAnnualTotalAvail();
                        available = Math.min(annualTotalAvail, summary.totalGain - summary.used);
                    } else if (summary.type != 4 && summary.type != 6) {
                        available = summary.totalGain - summary.used;
                    } else if (summary.type == 4 || summary.type == 6) {
                        return _react2.default.createElement(
                            'option',
                            { value: summary.type, key: index },
                            summary.leaveTxt
                        );
                    }

                    if (summary.type == 7) {
                        return _react2.default.createElement(
                            'option',
                            { value: summary.type, key: index },
                            summary.leaveTxt,
                            ' (',
                            available + (available <= 1 ? " hour" : " hours"),
                            ')'
                        );
                    }
                    return _react2.default.createElement(
                        'option',
                        { value: summary.type, key: index },
                        summary.leaveTxt,
                        ' (',
                        available + (available <= 1 ? " day" : " days"),
                        ')'
                    );
                });
            }
        }
    }, {
        key: 'renderAPM',
        value: function renderAPM() {
            var _this4 = this;

            var index = [0, 1, 2];
            return index.map(function (index) {
                return _react2.default.createElement(
                    'option',
                    { value: index, key: index },
                    _this4.props.apmTxt[index]
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var s = this.state.leave;
            var sDate = "";
            var eDate = "";
            if (s.startDate != 0) {
                var startDate = s.startDate < 10 ? "0" + s.startDate : s.startDate;
                var startMonth = s.startMonth + 1 < 10 ? "0" + (s.startMonth + 1) : s.startMonth + 1;
                sDate = s.startYear + "-" + startMonth + "-" + startDate;
            }
            if (s.endDate != 0) {
                var endDate = s.endDate < 10 ? "0" + s.endDate : s.endDate;
                var endMonth = s.endMonth + 1 < 10 ? "0" + (s.endMonth + 1) : s.endMonth + 1;
                eDate = s.endYear + "-" + endMonth + "-" + endDate;
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_navBar2.default, this.props),
                _react2.default.createElement(
                    'div',
                    { className: 'container-fluid content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(_sideMenu2.default, this.props),
                        _react2.default.createElement(
                            'div',
                            { className: ' col-md-10  col-sm-8 atd' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-4' },
                                    _react2.default.createElement(
                                        'h4',
                                        null,
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            'Apply Leave'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'type' },
                                            'Type'
                                        ),
                                        _react2.default.createElement(
                                            'select',
                                            { className: 'form-control atd-sel', name: 'type', 'data-index': '0',
                                                onChange: this.handleChange, value: s.type },
                                            this.renderType()
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'startDate' },
                                            'Start Date'
                                        ),
                                        _react2.default.createElement('input', { type: 'date', className: 'form-control', value: sDate, id: 'startDate',
                                            placeholder: 'Pick a date', 'data-index': '1', onChange: this.handleEdit })
                                    ),
                                    s.type != 7 ? _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'apmStart' },
                                                'AM/PM'
                                            ),
                                            _react2.default.createElement(
                                                'select',
                                                { className: 'form-control atd-sel', name: 'apmStart', 'data-index': '2',
                                                    onChange: this.handleChange, value: s.apmStart },
                                                this.renderAPM()
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'endDate' },
                                                'End Date'
                                            ),
                                            _react2.default.createElement('input', { type: 'date', className: 'form-control', value: eDate, id: 'endDate',
                                                placeholder: 'Pick a date', 'data-index': '3', onChange: this.handleEdit,
                                                disabled: s.startDate == 0 })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'apmEnd' },
                                                'AM/PM'
                                            ),
                                            _react2.default.createElement(
                                                'select',
                                                { className: 'form-control atd-sel', name: 'apmEnd', 'data-index': '4',
                                                    onChange: this.handleChange, value: s.apmEnd,
                                                    disabled: s.endDate == 0 || s.startDate == s.endDate && s.startMonth == s.endMonth && s.startYear == s.endYear },
                                                this.renderAPM()
                                            )
                                        )
                                    ) : _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'endDate' },
                                                'Start Time'
                                            ),
                                            _react2.default.createElement('input', { type: 'time', className: 'form-control', value: s.startTime, id: 'startTime',
                                                'data-index': '7', onChange: this.handleTimeEdit,
                                                disabled: s.startDate == 0 })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'endTime' },
                                                'End Time'
                                            ),
                                            _react2.default.createElement('input', { type: 'time', className: 'form-control', value: s.endTime, id: 'endTime',
                                                'data-index': '8', onChange: this.handleTimeEdit,
                                                disabled: s.startDate == 0, step: '1800' })
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'reason' },
                                            'Reason'
                                        ),
                                        _react2.default.createElement('textarea', { rows: '3', name: 'reason', onChange: this.handleEdit, 'data-index': '5', value: s.reason,
                                            style: { width: "100%", resize: "none" }, step: '1800' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'duration' },
                                            'Duration (',
                                            s.type == 7 ? "hour" : "day",
                                            ')'
                                        ),
                                        _react2.default.createElement('input', { type: 'number', className: 'form-control', value: s.duration, id: 'endDate',
                                            placeholder: 'duration', 'data-index': '6', onChange: this.handleEdit,
                                            disabled: true })
                                    ),
                                    s.type == 1 ? _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'uploadMC' },
                                                'Upload MC'
                                            ),
                                            _react2.default.createElement('input', { type: 'file', name: 'uploadMC', accept: 'image/*', 'data-index': '0', onChange: this.upLoadImg })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            _react2.default.createElement(
                                                'label',
                                                { htmlFor: 'uploadMC' },
                                                'Upload Receipt'
                                            ),
                                            _react2.default.createElement('input', { type: 'file', name: 'uploadMC', accept: 'image/*', 'data-index': '1', onChange: this.upLoadImg })
                                        )
                                    ) : ""
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-4' },
                                    _react2.default.createElement(
                                        'button',
                                        { className: 'btn btn-default', onClick: this.handleSubmit },
                                        'Apply'
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.filterProcessing })
            );
        }
    }]);

    return LeaveApply;
}(_react2.default.Component);

LeaveApply.defaultProps = {
    apmTxt: ["Full Day", "AM", "PM"]
};
exports.default = LeaveApply;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _reportAction = __webpack_require__(28);

var _reportAction2 = _interopRequireDefault(_reportAction);

var _reportStore = __webpack_require__(31);

var _reportStore2 = _interopRequireDefault(_reportStore);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportCreate = function (_React$Component) {
    _inherits(ReportCreate, _React$Component);

    function ReportCreate(props) {
        _classCallCheck(this, ReportCreate);

        var _this = _possibleConstructorReturn(this, (ReportCreate.__proto__ || Object.getPrototypeOf(ReportCreate)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.handleEmailClick = _this.handleEmailClick.bind(_this);
        _this.handleEmailRemove = _this.handleEmailRemove.bind(_this);
        _this.handleEmailChange = _this.handleEmailChange.bind(_this);
        _this.handleCtrCheck = _this.handleCtrCheck.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.upLoadImg = _this.upLoadImg.bind(_this);
        _this.state = {
            report: {
                mcst: "",
                condoName: "",
                facility: "",
                category: "",
                severity: 0,
                description: "",
                reportImage: [],
                clientEmail: [],
                contractorIds: []
            },
            email: "",
            warningMsg: "",
            processing: _reportStore2.default.getState().processing,
            processingFilter: _filterStore2.default.getState().processing,
            condos: _filterStore2.default.getState().condos,
            iniLoadCondo: _filterStore2.default.getState().iniLoadCondo,
            facility: _reportStore2.default.getState().facility,
            contractors: _reportStore2.default.getState().contractors,
            isReportCreated: _reportStore2.default.getState().isReportCreated
        };
        return _this;
    }

    _createClass(ReportCreate, [{
        key: 'componentWillMount',
        value: function componentWillMount() {}
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            _reportStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);
            _menuAction2.default.pageNumber(-1);
            _reportAction2.default.isReportCreated(false);
            if (!this.state.iniLoadCondo && !this.state.processingFilter) {
                //getMCST first
                _filterAction2.default.processing(true);
                _filterAction2.default.getCondoList();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _reportStore2.default.unlisten(this.onChange);
            _filterStore2.default.unlisten(this.onFilterChange);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevState.isReportCreated != this.state.isReportCreated && this.state.isReportCreated) {
                window.setTimeout(function () {
                    window.location.reload();
                }, 3000);
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                facility: state.facility,
                contractors: state.contractors,
                isReportCreated: state.isReportCreated
            });
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                processingFilter: state.processing,
                iniLoadCondo: state.iniLoadCondo,
                condos: state.condos
            });
        }
    }, {
        key: 'upLoadImg',
        value: function upLoadImg(e) {
            e.preventDefault();
            var len = e.target.files.length;
            if (len > 3) {
                return this.setState({ warningMsg: "Maximum upload 3 pictures only" });
            } else {
                this.setState({ warningMsg: "" });
            }
            for (var i = 0; i < len; i++) {
                var file = e.target.files[i];
                this._previewImage(file, i);
            }
            //let file = e.target.files[0];
            //this._previewImage(file, 0);
        }
    }, {
        key: '_previewImage',
        value: function _previewImage(file, index) {
            var _this2 = this;

            //to be modified
            var fr = new FileReader();
            fr.onload = function (e) {
                var imgUrl = window.URL.createObjectURL(new Blob([e.target.result]));
                var img = new Image();

                img.onload = function () {
                    _this2.resizeImage(img, index);
                };

                img.src = imgUrl;
            };
            fr.readAsArrayBuffer(file);
        }
    }, {
        key: 'dataURItoBlob',
        value: function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = window.atob(dataURI.split(',')[1]);else byteString = unescape(dataURI.split(',')[1]);

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], { type: mimeString });
        }
    }, {
        key: 'resizeImage',
        value: function resizeImage(image, index) {
            var oHeight = image.naturalHeight;
            var oWidth = image.naturalWidth;
            var newImage = void 0,
                newSize = void 0;
            var oSize = { oHeight: oHeight, oWidth: oWidth };
            newSize = { width: 500, height: 500 * oHeight / oWidth };

            newImage = this._imgResize(image, newSize, oSize);
            var s = this.state.report;
            if (s.reportImage == "") s.reportImage = [];
            s.reportImage[index] = this.dataURItoBlob(newImage);
            this.setState({ report: s });
        }
    }, {
        key: '_imgResize',
        value: function _imgResize(img, newSize, oSize) {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext("2d");
            canvas.width = newSize.width;
            canvas.height = newSize.height;
            ctx.drawImage(img, 0, 0, oSize.oWidth, oSize.oHeight, 0, 0, newSize.width, newSize.height);
            return canvas.toDataURL('image/jpeg', 1);
        }
    }, {
        key: 'getCondoName',
        value: function getCondoName(mcst) {
            var len = this.state.condos.length;
            var condoName = void 0;
            for (var i = 0; i < len; i++) {
                if (this.state.condos[i].mcst == mcst) {
                    condoName = this.state.condos[i].condoName;

                    break;
                }
            }
            return condoName;
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.currentTarget.getAttribute("data-index"));
            var value = e.target.value;
            var s = this.state.report;
            if (index == 0) {
                //selected condo
                //render facility and render contractor

                if (value != "") {
                    if (value != this.state.report.mcst) {
                        _reportAction2.default.processing(true);
                        _reportAction2.default.getFacility(value);
                        _reportAction2.default.getContractor(value);

                        s.mcst = value;
                        s.condoName = this.getCondoName(value);
                        s.facility = "";
                        s.category = "";
                        s.severity = 0;
                        s.description = "";
                        s.reportImage = [];
                        s.clientEmail = [];
                        s.contractorIds = [];
                        this.setState({ report: s });
                    }
                }
            } else if (index == 1) {
                //select facility
                if (s.facility != value) {
                    s.facility = value;
                    s.category = "";
                    this.setState({ report: s });
                }
            } else if (index == 2) {
                //select category
                s.category = value;
                this.setState({ report: s });
            } else if (index == 3) {
                s.severity = parseInt(value);
                this.setState({ report: s });
            }
        }
    }, {
        key: 'handleEdit',
        value: function handleEdit(e) {
            var index = parseInt(e.currentTarget.getAttribute("data-index"));
            var value = void 0;
            var s = this.state.report;
            if (index == 2) {
                value = e.target.value;
                s.category = value;
                this.setState({ report: s });
            } else if (index == 4) {
                value = e.target.value;
                s.description = value;
                this.setState({ report: s });
            }
        }
    }, {
        key: 'handleCtrCheck',
        value: function handleCtrCheck(e) {
            var checked = e.target.checked;
            var contractorId = e.target.value;

            var s = this.state.report;
            if (checked) {
                if (s.contractorIds != "") {
                    s.contractorIds = s.contractorIds.concat(contractorId);
                } else {
                    s.contractorIds = [contractorId];
                }
            } else {
                //remove from list
                var len = s.contractorIds.length;
                for (var i = 0; i < len; i++) {
                    if (s.contractorIds[i] == contractorId) {
                        s.contractorIds.splice(i, 1);
                        break;
                    }
                }
            }
            this.setState({
                report: s
            });
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {

            var s = this.state.report;
            if (s.facility == "" || s.category == "") {
                //check if category is empty or not
                return this.setState({ warningMsg: "Please select facility and category" });
            }

            if (s.description == "" && s.reportImage == "") {
                return this.setState({ warningMsg: "Please either type the description or upload the image" });
            }

            var fd = new FormData();
            fd.append("category", s.category);
            fd.append("facility", s.facility);
            fd.append("mcst", s.mcst);
            fd.append("condoName", s.condoName);
            fd.append("severity", s.severity);
            fd.append("description", s.description);
            if (s.reportImage) {
                for (var i = 0; i < s.reportImage.length; i++) {
                    fd.append("images", s.reportImage[i]);
                }
            }
            if (s.clientEmail) {
                for (var _i = 0; _i < s.clientEmail.length; _i++) {
                    fd.append("clientEmail[]", s.clientEmail[_i]);
                }
            }
            if (s.contractorIds) {
                for (var _i2 = 0; _i2 < s.contractorIds.length; _i2++) {
                    fd.append("contractorIds[]", s.contractorIds[_i2]);
                }
            }
            _reportAction2.default.processing(true);
            _reportAction2.default.createReport(fd);
        }
    }, {
        key: 'renderCondo',
        value: function renderCondo() {
            return this.state.condos.map(function (condo, index) {
                return _react2.default.createElement(
                    'option',
                    { value: condo.mcst, key: index },
                    condo.condoName + " (" + condo.mcst + ")"
                );
            });
        }
    }, {
        key: 'renderFacility',
        value: function renderFacility() {
            if (this.state.facility) {
                return this.state.facility.map(function (facility, index) {
                    return _react2.default.createElement(
                        'option',
                        { value: facility.facility, key: index },
                        facility.facility
                    );
                });
            }
        }
    }, {
        key: 'renderCategory',
        value: function renderCategory() {
            var s = this.state.report;
            if (this.state.facility) {
                return this.state.facility.map(function (facility) {
                    if (facility.facility == s.facility) {
                        return facility.categories.map(function (category, index2) {
                            return _react2.default.createElement(
                                'option',
                                { value: category.category, key: index2 },
                                category.category
                            );
                        });
                    }
                });
            }
        }
    }, {
        key: 'renderImage',
        value: function renderImage() {
            var s = this.state.report;
            if (s.reportImage) {
                return s.reportImage.map(function (image, index) {
                    //convert from blob to img
                    var imageformat = URL.createObjectURL(image);
                    return _react2.default.createElement(
                        'div',
                        { className: 'rp-img-prev', key: index },
                        _react2.default.createElement('img', { className: 'rp-img', src: imageformat })
                    );
                });
            }
        }
    }, {
        key: 'handleEmailChange',
        value: function handleEmailChange(e) {
            var value = e.target.value;
            this.setState({ email: value });
        }
    }, {
        key: 'handleEmailRemove',
        value: function handleEmailRemove(e) {
            e.preventDefault();
            var index = parseInt(e.currentTarget.getAttribute("data-index"));
            var s = this.state.report;
            s.clientEmail.splice(index, 1);
            this.setState({ report: s });
        }
    }, {
        key: 'handleEmailClick',
        value: function handleEmailClick(e) {
            if (this.state.email != "") {
                var s = this.state.report;
                s.clientEmail = s.clientEmail.concat(this.state.email);
                this.setState({ report: s, email: "" });
            }
        }
    }, {
        key: 'renderEmail',
        value: function renderEmail() {
            return _react2.default.createElement(
                'div',
                { className: 'form-group' },
                _react2.default.createElement(
                    'label',
                    null,
                    'Recipients to receive notification'
                ),
                _react2.default.createElement(
                    'form',
                    { autoComplete: 'on', style: { marginTop: "10px", marginBottom: "10px" } },
                    _react2.default.createElement(
                        'div',
                        { className: 'input-group', style: { marginBottom: "10px" } },
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', placeholder: 'Email', value: this.state.email,
                            onChange: this.handleEmailChange, autoComplete: 'on' }),
                        _react2.default.createElement(
                            'span',
                            { className: 'input-group-btn' },
                            _react2.default.createElement(
                                'button',
                                { className: 'btn btn-default', type: 'button', onClick: this.handleEmailClick },
                                'Add'
                            )
                        )
                    ),
                    this.renderEmailList()
                )
            );
        }
    }, {
        key: 'renderEmailList',
        value: function renderEmailList() {
            var _this3 = this;

            return this.state.report.clientEmail.map(function (email, index) {
                return _react2.default.createElement(
                    'div',
                    { className: 'rp-em', key: index },
                    _react2.default.createElement(
                        'div',
                        { className: 'rp-em-1' },
                        email
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'rp-em-2 btn btn-xs btn-danger', 'data-index': index, onClick: _this3.handleEmailRemove },
                        'Remove'
                    )
                );
            });
        }
    }, {
        key: 'checkContractor',
        value: function checkContractor(contractor) {
            var isCheck = false;
            var s = this.state.report;
            var len = s.contractorIds.length;
            for (var i = 0; i < len; i++) {
                if (s.contractorIds[i] == contractor._id) {
                    isCheck = true;
                    break;
                }
            }
            return isCheck;
        }
    }, {
        key: 'renderContractor',
        value: function renderContractor() {
            var _this4 = this;

            if (this.state.contractors) {
                return this.state.contractors.map(function (contractor, index) {
                    //check if this facility is included;
                    var isCheck = _this4.checkContractor(contractor);

                    return _react2.default.createElement(
                        'li',
                        { className: 'pm-li-1', key: index },
                        _react2.default.createElement(
                            'div',
                            { className: 'checkbox' },
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement('input', { type: 'checkbox', value: contractor._id,
                                    onChange: _this4.handleCtrCheck, checked: isCheck }),
                                _react2.default.createElement('span', { className: 'checkmark' }),
                                contractor.contractorName + " (" + contractor.service + ")"
                            )
                        )
                    );
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var s = this.state.report;
            var category = void 0;
            if (s.facility.toUpperCase() == "OTHERS") {
                category = _react2.default.createElement('input', { className: 'form-control', name: 'facility', value: s.category, 'data-index': '2', type: 'text', onChange: this.handleEdit });
            } else {
                category = _react2.default.createElement(
                    'select',
                    { className: 'form-control atd-sel', name: 'facility', 'data-index': '2', onChange: this.handleChange,
                        value: s.category ? s.category : "", disabled: this.state.category == "" || s.facility == "" },
                    _react2.default.createElement('option', { value: '' }),
                    this.renderCategory()
                );
            }
            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.processingFilter }),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 us-form' },
                        _react2.default.createElement(
                            'div',
                            { className: 'contractorSet-form' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-4' },
                                    _react2.default.createElement(
                                        'h4',
                                        null,
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            'Create Incident Report'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'warning' },
                                        this.state.warningMsg
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'estate' },
                                            'Estate'
                                        ),
                                        _react2.default.createElement(
                                            'select',
                                            { className: 'form-control atd-sel', name: 'estate', 'data-index': '0', onChange: this.handleChange,
                                                value: s.mcst ? s.mcst : "" },
                                            _react2.default.createElement('option', { value: '' }),
                                            this.renderCondo()
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'facility' },
                                            'Facility'
                                        ),
                                        _react2.default.createElement(
                                            'select',
                                            { className: 'form-control atd-sel', name: 'facility', 'data-index': '1', onChange: this.handleChange,
                                                value: s.facility ? s.facility : "", disabled: this.state.facility == "" },
                                            _react2.default.createElement('option', { value: '' }),
                                            this.renderFacility()
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'category' },
                                            'Category'
                                        ),
                                        category
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'severity' },
                                            'Severity'
                                        ),
                                        _react2.default.createElement(
                                            'select',
                                            { className: 'form-control atd-sel', name: 'facility', 'data-index': '3', onChange: this.handleChange,
                                                value: s.severity ? s.severity : "" },
                                            _react2.default.createElement(
                                                'option',
                                                { value: '0' },
                                                'Low'
                                            ),
                                            _react2.default.createElement(
                                                'option',
                                                { value: '1' },
                                                'Medium'
                                            ),
                                            _react2.default.createElement(
                                                'option',
                                                { value: '2' },
                                                'High'
                                            ),
                                            _react2.default.createElement(
                                                'option',
                                                { value: '3' },
                                                'Critical'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'description' },
                                            'Description'
                                        ),
                                        _react2.default.createElement('textarea', { className: 'form-control atd-sel', style: { resize: "none" }, name: 'description', 'data-index': '4',
                                            onChange: this.handleEdit, rows: '3', value: s.description ? s.description : "" })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'description' },
                                            'Images'
                                        ),
                                        _react2.default.createElement('input', { className: 'form-control', type: 'file', name: 'myImage', accept: 'image/x-png,image/jpeg',
                                            onChange: this.upLoadImg, multiple: true })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'rpt-img-prev' },
                                        this.renderImage()
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-4' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        _react2.default.createElement(
                                            'label',
                                            { htmlFor: 'Contrator' },
                                            'Contractors to receive notification for quotation'
                                        ),
                                        this.renderContractor()
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-4' },
                                    this.renderEmail()
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-4' },
                                    _react2.default.createElement(
                                        'button',
                                        { className: 'btn btn-default', onClick: this.handleSubmit },
                                        'Create'
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ReportCreate;
}(_react2.default.Component);

exports.default = ReportCreate;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _userSetAction = __webpack_require__(15);

var _userSetAction2 = _interopRequireDefault(_userSetAction);

var _userSetStore = __webpack_require__(44);

var _userSetStore2 = _interopRequireDefault(_userSetStore);

var _teamModal = __webpack_require__(285);

var _teamModal2 = _interopRequireDefault(_teamModal);

var _teamCreateModal = __webpack_require__(286);

var _teamCreateModal2 = _interopRequireDefault(_teamCreateModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TeamSetting = function (_React$Component) {
    _inherits(TeamSetting, _React$Component);

    function TeamSetting(props) {
        _classCallCheck(this, TeamSetting);

        var _this = _possibleConstructorReturn(this, (TeamSetting.__proto__ || Object.getPrototypeOf(TeamSetting)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.handleMemberEdit = _this.handleMemberEdit.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.shouldModalCloseTC = _this.shouldModalCloseTC.bind(_this);
        _this.handleSave = _this.handleSave.bind(_this);
        _this.state = {
            warningMsg: _userSetStore2.default.getState().warningMsg,
            processing: _userSetStore2.default.getState().processing,
            team: _userSetStore2.default.getState().team,
            removedTeam: _userSetStore2.default.getState().removedTeam,
            staffs: _filterStore2.default.getState().staffs,
            processingFilter: _filterStore2.default.getState().processing,
            iniLoadStaff: _filterStore2.default.getState().iniLoadStaff,

            modalClose: false,
            index: "",

            modalCloseTC: false,
            action: 0,
            title: ""
        };
        return _this;
    }

    _createClass(TeamSetting, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _menuAction2.default.pageNumber(16);
            _userSetStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);
            if (!this.state.processingFilter && !this.state.iniLoadStaff) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getEmployee();
            }
            if (!this.state.processing) {
                _userSetAction2.default.processing(true);
                _userSetAction2.default.getTeam();
            }
            _userSetAction2.default.removedTeam([]);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _userSetStore2.default.unlisten(this.onChange);
            _filterStore2.default.unlisten(this.onFilterChange);
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                staffs: state.staffs,
                processingFilter: state.processing,
                iniLoadStaff: state.iniLoadStaff
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                warningMsg: state.warningMsg,
                processing: state.processing,
                team: state.team,
                removedTeam: state.removedTeam
            });
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({
                modalClose: data
            });
        }
    }, {
        key: 'shouldModalCloseTC',
        value: function shouldModalCloseTC(data) {
            this.setState({
                modalCloseTC: data
            });
        }
    }, {
        key: 'renderTeamMember',
        value: function renderTeamMember(member) {
            return member.map(function (member, index) {
                return _react2.default.createElement(
                    'div',
                    { className: 'tm-mb', key: index },
                    index + 1 + ". " + member.userName
                );
            });
        }
    }, {
        key: 'handleEdit',
        value: function handleEdit(e) {
            //0 is create
            //1 is remove
            var action = parseInt(e.currentTarget.getAttribute("data-action"));
            var index = parseInt(e.currentTarget.getAttribute("data-index"));
            var title = void 0;
            if (action == 0) {
                title = "Create New Team";
            } else {
                title = "Remove Team";
            }
            this.setState({
                title: title,
                action: action,
                index: index,
                modalCloseTC: true
            });
        }
    }, {
        key: 'handleSave',
        value: function handleSave(e) {
            if (this.state.processing) return;

            _userSetAction2.default.processing(true);
            _userSetAction2.default.updateTeam(this.state.team, this.state.removedTeam);
        }
    }, {
        key: 'handleMemberEdit',
        value: function handleMemberEdit(e) {
            var index = parseInt(e.currentTarget.getAttribute('data-index'));
            this.setState({ index: index, modalClose: true });
        }
    }, {
        key: 'renderDetail',
        value: function renderDetail(team, index) {
            return _react2.default.createElement(
                'div',
                { className: 'col-sm-3', key: index },
                _react2.default.createElement(
                    'div',
                    { className: 'tm' },
                    _react2.default.createElement(
                        'div',
                        { className: 'tm-btn-grp' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-default btn-xs', 'data-index': index,
                                onClick: this.handleMemberEdit },
                            'Edit Team'
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-warning btn-xs', 'data-index': index, 'data-action': '1',
                                onClick: this.handleEdit },
                            'Remove Team'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'tm-nm' },
                        _react2.default.createElement(
                            'b',
                            null,
                            team.teamName
                        )
                    ),
                    this.renderTeamMember(team.teamMember)
                )
            );
        }
    }, {
        key: 'renderRow',
        value: function renderRow(i) {
            var detailContent = [];
            for (var j = 0; j < 4; j++) {
                if (j + i * 4 < this.state.team.length) {
                    detailContent = detailContent.concat(this.renderDetail(this.state.team[j + i * 4], j + i * 4));
                } else {
                    break;
                }
            }
            return detailContent;
        }
    }, {
        key: 'renderTeam',
        value: function renderTeam() {
            var teamContent = [];

            for (var i = 0; i < Math.ceil(this.state.team.length / 4); i++) {
                teamContent = teamContent.concat(_react2.default.createElement(
                    'div',
                    { className: 'row', key: i },
                    this.renderRow(i)
                ));
            }
            return teamContent;
        }
    }, {
        key: 'render',
        value: function render() {
            var modal = "",
                modal2 = "";
            if (this.state.modalClose) {
                modal = _react2.default.createElement(_teamModal2.default, {
                    modalClose: this.state.modalClose,
                    shouldModalClose: this.shouldModalClose,
                    team: this.state.team,
                    index: this.state.index,
                    staffs: this.state.staffs
                });
            }
            if (this.state.modalCloseTC) {
                modal2 = _react2.default.createElement(_teamCreateModal2.default, {
                    modalClose: this.state.modalCloseTC,
                    shouldModalClose: this.shouldModalCloseTC,
                    title: this.state.title,
                    team: this.state.team,
                    removedTeam: this.state.removedTeam,
                    action: this.state.action,
                    index: this.state.index
                });
            }
            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 us-form' },
                        _react2.default.createElement(
                            'h4',
                            null,
                            _react2.default.createElement(
                                'b',
                                null,
                                'Team Management'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12' },
                                _react2.default.createElement(
                                    'button',
                                    { className: 'btn btn-default', onClick: this.handleEdit, 'data-action': '0', 'data-index': '' },
                                    'Create Team'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'tm-wp' },
                                    this.renderTeam()
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-12' },
                                _react2.default.createElement(
                                    'button',
                                    { className: 'btn btn-default', onClick: this.handleSave },
                                    'Save'
                                )
                            )
                        )
                    ),
                    modal,
                    modal2
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.processingFilter })
            );
        }
    }]);

    return TeamSetting;
}(_react2.default.Component);

exports.default = TeamSetting;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _userSetAction = __webpack_require__(15);

var _userSetAction2 = _interopRequireDefault(_userSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TeamModal = function (_React$Component) {
    _inherits(TeamModal, _React$Component);

    function TeamModal(props) {
        _classCallCheck(this, TeamModal);

        var _this = _possibleConstructorReturn(this, (TeamModal.__proto__ || Object.getPrototypeOf(TeamModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleCheck = _this.handleCheck.bind(_this);
        _this.state = {
            team: "",
            warningMsg: "",
            staffId: "",
            clientHeight: 200
        };
        return _this;
    }

    _createClass(TeamModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var clientHeight = _reactDom2.default.findDOMNode(this.refs.modal).clientHeight;

            this.setState({
                team: this.props.team,
                clientHeight: clientHeight
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.currentTarget.getAttribute("data-index"));
            if (index == 0) {
                var team = this.state.team;
                team[this.props.index].teamName = e.target.value;
                this.setState({
                    team: team
                });
            } else {
                this.setState({
                    staffId: e.target.value
                });
            }
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            //update to server
            _userSetAction2.default.team(this.state.team);
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'handleCheck',
        value: function handleCheck(e) {
            var checked = e.target.checked;
            var staffId = e.target.value;
            var userName = e.target.getAttribute('data-username');

            var team = this.state.team;
            if (checked) {
                team[this.props.index].teamMember.push({
                    staffId: staffId,
                    userName: userName
                });
            } else {
                //remove from list
                var len = team[this.props.index].teamMember.length;
                for (var i = 0; i < len; i++) {
                    if (team[this.props.index].teamMember[i].staffId == staffId) {
                        team[this.props.index].teamMember.splice(i, 1);
                        break;
                    }
                }
            }
            this.setState({
                team: team
            });
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'checkStaff',
        value: function checkStaff(staff) {
            var isCheck = false;
            if (this.state.team[this.props.index]) {
                var len = this.state.team[this.props.index].teamMember.length;
                for (var i = 0; i < len; i++) {
                    if (this.state.team[this.props.index].teamMember[i].staffId == staff.staffId) {
                        isCheck = true;
                        break;
                    }
                }
            }
            return isCheck;
        }
    }, {
        key: 'renderDetail',
        value: function renderDetail(staff, index) {
            //check if this facility is included;
            var isCheck = this.checkStaff(staff);

            return _react2.default.createElement(
                'li',
                { className: 'pm-li-1', key: index },
                _react2.default.createElement(
                    'div',
                    { className: 'checkbox' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', { type: 'checkbox', value: staff.staffId, 'data-username': staff.userName, onChange: this.handleCheck, checked: isCheck }),
                        _react2.default.createElement('span', { className: 'checkmark' }),
                        staff.userName
                    )
                )
            );
        }
    }, {
        key: 'renderList',
        value: function renderList(staffs) {
            var _this2 = this;

            return staffs.map(function (staff, index) {
                return _this2.renderDetail(staff, index);
            });
        }
    }, {
        key: 'renderStaff',
        value: function renderStaff() {
            var _this3 = this;

            if (this.props.staffs.length > 0) {
                var staffs = this.props.staffs.filter(function (staff) {
                    return staff.userName.toLowerCase().indexOf(_this3.state.staffId.toLowerCase()) > -1 || staff.staffId.toLowerCase().indexOf(_this3.state.staffId.toLowerCase()) > -1;
                });

                return this.renderList(staffs);
            }
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'teamName' },
                            'Team Name'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'teamName', placeholder: 'Type Team Name Here',
                            value: this.state.team[this.props.index] ? this.state.team[this.props.index].teamName : "",
                            onChange: this.handleChange, 'data-index': '0' })
                    )
                ),
                _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'staffFilter' },
                            'Staff:'
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'staffFilter', placeholder: 'Search By name or ID',
                            onChange: this.handleChange, 'data-index': '1' })
                    )
                ),
                _react2.default.createElement('div', { className: 'divider' }),
                _react2.default.createElement(
                    'ul',
                    { className: 'pm-ul', style: { height: this.state.clientHeight - 280 + "px", overflow: "auto" } },
                    this.renderStaff()
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'permission-modal', style: { visibility: style.visibility }, ref: 'modal' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            'Edit Team'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body', style: { height: this.state.clientHeight - 115 + "px" } },
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        ),
                        this.renderContent()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-warning', onClick: this.handleClick },
                            'Done'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return TeamModal;
}(_react2.default.Component);

TeamModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = TeamModal;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(9);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _userSetAction = __webpack_require__(15);

var _userSetAction2 = _interopRequireDefault(_userSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TeamCreateModal = function (_React$Component) {
    _inherits(TeamCreateModal, _React$Component);

    function TeamCreateModal(props) {
        _classCallCheck(this, TeamCreateModal);

        var _this = _possibleConstructorReturn(this, (TeamCreateModal.__proto__ || Object.getPrototypeOf(TeamCreateModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.state = {
            team: [],
            warningMsg: "",
            teamName: ""
        };
        return _this;
    }

    _createClass(TeamCreateModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var value = e.target.value;
            this.setState({
                teamName: value
            });
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            if (e.key == 'Enter') {
                e.preventDefault();
                this.handleClick();
            }
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            //update to server
            var action = this.props.action;
            if (action == 0) {
                var team = this.props.team;
                if (this.state.teamName == "") {
                    return this.setState({ warningMsg: "Team Name cannot be empty" });
                }
                team.push({
                    teamName: this.state.teamName,
                    teamMember: []
                });
                _userSetAction2.default.team(team);
            } else {
                //push to removedTeam if have id
                if (this.props.team[this.props.index]._id) {
                    var removedTeam = this.props.removedTeam;
                    removedTeam.push(this.props.team[this.props.index]._id);
                    _userSetAction2.default.removedTeam(removedTeam);
                }

                var _team = this.props.team;
                _team.splice(this.props.index, 1);
                _userSetAction2.default.team(_team);
            }
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            if (this.props.action == 0) {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'form',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'teamName' },
                                'Team Name:'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'teamName', placeholder: 'Type New Team Name',
                                onChange: this.handleChange, onKeyPress: this.handleKeyPress })
                        )
                    )
                );
            } else {
                return _react2.default.createElement(
                    'div',
                    null,
                    'Are you sure to remove ',
                    this.props.team[this.props.index].teamName,
                    '?'
                );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'report-modal', style: { visibility: style.visibility }, ref: 'modal' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            this.props.title
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body', style: { height: this.state.clientHeight - 115 + "px" } },
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        ),
                        this.renderContent()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: "btn " + (this.props.action == 0 ? "btn-info" : "btn-warning"),
                                onClick: this.handleClick },
                            this.props.action == 0 ? "Create" : "Remove"
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return TeamCreateModal;
}(_react2.default.Component);

TeamCreateModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    }
};
exports.default = TeamCreateModal;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

var _leaveAtdStore = __webpack_require__(58);

var _leaveAtdStore2 = _interopRequireDefault(_leaveAtdStore);

var _leaveStaffApply = __webpack_require__(288);

var _leaveStaffApply2 = _interopRequireDefault(_leaveStaffApply);

var _atdStaffApply = __webpack_require__(289);

var _atdStaffApply2 = _interopRequireDefault(_atdStaffApply);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveAtdApply = function (_React$Component) {
    _inherits(LeaveAtdApply, _React$Component);

    function LeaveAtdApply(props) {
        _classCallCheck(this, LeaveAtdApply);

        var _this = _possibleConstructorReturn(this, (LeaveAtdApply.__proto__ || Object.getPrototypeOf(LeaveAtdApply)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.handleMode = _this.handleMode.bind(_this);
        _this.state = {
            staffs: _filterStore2.default.getState().staffs,
            processingFilter: _filterStore2.default.getState().processing,
            iniLoadStaff: _filterStore2.default.getState().iniLoadStaff,

            processing: _leaveAtdStore2.default.getState().processing,

            mode: 0
        };
        return _this;
    }

    _createClass(LeaveAtdApply, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _filterStore2.default.listen(this.onFilterChange);
            _leaveAtdStore2.default.listen(this.onChange);
            if (!this.state.processingFilter && !this.state.iniLoadStaff) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getEmployee();
            }

            _menuAction2.default.pageNumber(-1);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _filterStore2.default.unlisten(this.onFilterChange);
            _leaveAtdStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'handleMode',
        value: function handleMode(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            if (index == this.state.mode) return;

            this.setState({ mode: index });
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                staffs: state.staffs,
                processingFilter: state.processing,
                iniLoadStaff: state.iniLoadStaff

            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var body = "";
            if (this.state.mode == 0) {
                body = _react2.default.createElement(_leaveStaffApply2.default, { staffs: this.state.staffs,
                    processing: this.state.processing });
            } else {
                body = _react2.default.createElement(_atdStaffApply2.default, { staffs: this.state.staffs,
                    processing: this.state.processing });
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_navBar2.default, this.props),
                _react2.default.createElement(
                    'div',
                    { className: 'container-fluid content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(_sideMenu2.default, this.props),
                        _react2.default.createElement(
                            'div',
                            { className: ' col-md-10  col-sm-8 atd' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-12' },
                                    _react2.default.createElement(
                                        'h4',
                                        null,
                                        _react2.default.createElement(
                                            'b',
                                            null,
                                            'Apply Leave/Attendance for Staff'
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-12' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'lva-b' },
                                        _react2.default.createElement(
                                            'button',
                                            { className: "btn btn-default" + (this.state.mode == 0 ? " active" : ""),
                                                'data-index': '0', onClick: this.handleMode },
                                            'Apply Leave'
                                        ),
                                        _react2.default.createElement(
                                            'button',
                                            { className: "btn btn-default" + (this.state.mode == 1 ? " active" : ""),
                                                'data-index': '1', onClick: this.handleMode },
                                            'Apply Attendance'
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-sm-12' },
                                    body
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(_loading2.default, { processing: this.state.processing || this.state.processingFilter })
            );
        }
    }]);

    return LeaveAtdApply;
}(_react2.default.Component);

exports.default = LeaveAtdApply;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

var _leaveAtdStore = __webpack_require__(58);

var _leaveAtdStore2 = _interopRequireDefault(_leaveAtdStore);

var _leaveAtdAction = __webpack_require__(59);

var _leaveAtdAction2 = _interopRequireDefault(_leaveAtdAction);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

var _filterAction = __webpack_require__(8);

var _filterAction2 = _interopRequireDefault(_filterAction);

var _filterStore = __webpack_require__(12);

var _filterStore2 = _interopRequireDefault(_filterStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveStaffApply = function (_React$Component) {
    _inherits(LeaveStaffApply, _React$Component);

    function LeaveStaffApply(props) {
        _classCallCheck(this, LeaveStaffApply);

        var _this = _possibleConstructorReturn(this, (LeaveStaffApply.__proto__ || Object.getPrototypeOf(LeaveStaffApply)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.upLoadImg = _this.upLoadImg.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.handleTimeEdit = _this.handleTimeEdit.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.clear = _this.clear.bind(_this);
        _this.state = {
            summary: _leaveAtdStore2.default.getState().summary.summary,
            isLeaveSuccess: _leaveAtdStore2.default.getState().isLeaveSuccess,
            staffId: _leaveAtdStore2.default.getState().staffId,

            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId,

            filterProcessing: _filterStore2.default.getState().processing,
            iniLoadHoliday: _filterStore2.default.getState().iniLoadHoliday,
            holiday: _filterStore2.default.getState().holiday,

            leave: {
                type: 0,
                startYear: 0,
                startMonth: 0,
                startDate: 0,
                endYear: 0,
                endMonth: 0,
                endDate: 0,
                apmStart: 0,
                apmEnd: 0,
                startTime: "",
                endTime: "",
                duration: 0,
                reason: "",
                leaveImage: ""
            }
        };
        return _this;
    }

    _createClass(LeaveStaffApply, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _leaveAtdStore2.default.listen(this.onChange);
            _filterStore2.default.listen(this.onFilterChange);
            _userStore2.default.listen(this.onUserChange);
            _leaveAtdAction2.default.staffId.defer("");

            if (!this.state.filterProcessing && !this.state.iniLoadHoliday) {
                _filterAction2.default.processing(true);
                _filterAction2.default.getHoliday();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _leaveAtdStore2.default.unlisten(this.onChange);
            _filterStore2.default.unlisten(this.onFilterChange);
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'onFilterChange',
        value: function onFilterChange(state) {
            this.setState({
                filterProcessing: state.processing,
                iniLoadHoliday: state.iniLoadHoliday,
                holiday: state.holiday
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.isLeaveSuccess && prevState.isLeaveSuccess != this.state.isLeaveSuccess) {
                window.setTimeout(function () {
                    window.location.reload();
                }, 3000);
            }
        }
    }, {
        key: 'clear',
        value: function clear() {
            _leaveAtdAction2.default.staffId("");
            _leaveAtdAction2.default.summary([]);
            this.setState({
                leave: {
                    type: 0,
                    startYear: 0,
                    startMonth: 0,
                    startDate: 0,
                    endYear: 0,
                    endMonth: 0,
                    endDate: 0,
                    apmStart: 0,
                    apmEnd: 0,
                    duration: 0,
                    reason: ""
                }
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                summary: state.summary,
                isLeaveSuccess: state.isLeaveSuccess,
                staffId: state.staffId
            });
        }
    }, {
        key: 'upLoadImg',
        value: function upLoadImg(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var file = e.target.files[0];
            this._previewImage(file, index);
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var s = this.state.leave;
            if (index == 0) {
                //type
                s.type = parseInt(e.target.value);
            } else if (index == 2) {
                s.apmStart = parseInt(e.target.value);
            } else if (index == 4) {
                s.apmEnd = parseInt(e.target.value);
            } else if (index == 9) {
                if (!this.props.processing && e.target.value != "") {
                    if (this.state.staffId != e.target.value) {
                        _leaveAtdAction2.default.staffId(e.target.value);
                        _leaveAtdAction2.default.processing(true);
                        _leaveAtdAction2.default.getSummary(e.target.value);
                    }
                }
                return;
            }

            this.setState({
                leave: s
            });
            this.calculateDuration();
        }
    }, {
        key: 'handleTimeEdit',
        value: function handleTimeEdit(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var s = this.state.leave;
            if (index == 7) {
                s.startTime = e.target.value;
            } else if (index == 8) {
                s.endTime = e.target.value;
            }

            this.setState({ leave: s });
            this.calculateDuration();
        }
    }, {
        key: 'handleEdit',
        value: function handleEdit(e) {
            var index = parseInt(e.target.getAttribute("data-index"));
            var s = this.state.leave;
            var data = void 0;
            if (index == 1) {
                data = e.target.value.split("-");
                s.startYear = parseInt(data[0]);
                s.startMonth = parseInt(data[1]) - 1;
                s.startDate = parseInt(data[2]);
            } else if (index == 3) {
                data = e.target.value.split("-");
                s.endYear = parseInt(data[0]);
                s.endMonth = parseInt(data[1]) - 1;
                s.endDate = parseInt(data[2]);
            } else if (index == 5) {
                data = e.target.value;
                s.reason = data;
            }
            this.setState({ leave: s });
            this.calculateDuration();
        }
    }, {
        key: 'isHoliday',
        value: function isHoliday(year, month, date) {
            var isHoliday = false;
            if (this.state.holiday) {
                if (this.state.holiday.holiday) {
                    var s = this.state.holiday;
                    var len = s.holiday.length;
                    for (var i = 0; i < len; i++) {
                        if (s.holiday[i].year == year && s.holiday[i].month == month && s.holiday[i].date == date) {
                            isHoliday = true;
                            break;
                        }
                    }
                }
            }

            return isHoliday;
        }
    }, {
        key: 'calculateDuration',
        value: function calculateDuration() {
            var s = this.state.leave;
            if (s.startYear != 0 && s.endYear != 0) {
                var sDate = new Date(s.startYear, s.startMonth, s.startDate);
                var eDate = new Date(s.endYear, s.endMonth, s.endDate);
                var duration = 0;
                //duration = (eDate.getTime() - sDate.getTime()) / 1000 / 60 / 60 / 24 + 1;
                //if start and end are same day
                if (s.startYear == s.endYear && s.startMonth == s.endMonth && s.startDate == s.endDate) {
                    s.apmEnd = 0;
                }
                /*
                let minus = 0;
                if (s.apmStart != 0) {
                    minus += 0.5;
                }
                if (s.apmEnd != 0) {
                    minus += 0.5;
                }
                */
                var noDays = parseInt(eDate.getTime() - sDate.getTime()) / 1000 / 60 / 60 / 24 + 1;
                if (noDays > 0) {
                    for (var j = 0; j < noDays; j++) {
                        var day = new Date(s.startYear, s.startMonth, s.startDate + j).getDay();
                        var isHoliday = this.isHoliday(s.startYear, s.startMonth, s.startDate + j);
                        if (isHoliday) {} else if (j == 0 && day == 6) {
                            if (this.state.holiday.saturdayWork == 0) {
                                if (s.apmStart == 1 || s.apmStart == 2) {
                                    duration += 0.5;
                                } else {
                                    duration += 1;
                                }
                            } else if (this.state.holiday.saturdayWork == 1) {
                                duration += 0.5;
                                s.apmStart = 1;
                            } else if (this.state.holiday.saturdayWork == 2) {
                                s.apmStart = 1;
                            }
                        } else if (j == 0 && day == 0) {
                            //sun
                            s.apmStart = 0;
                        } else if (j == 0 && (s.apmStart == 1 || s.apmStart == 2)) {
                            duration += 0.5;
                        } else if (j == 0 && s.apmStart == 0) {
                            duration += 1;
                        } else if (j + 1 == noDays && day == 6) {
                            if (this.state.holiday.saturdayWork == 0) {
                                if (s.apmEnd == 1 || s.apmEnd == 2) {
                                    duration += 0.5;
                                } else {
                                    duration += 1;
                                }
                            } else if (this.state.holiday.saturdayWork == 1) {
                                duration += 0.5;
                                s.apmEnd = 1;
                            } else if (this.state.holiday.saturdayWork == 2) {
                                s.apmEnd = 1;
                            }
                        } else if (j + 1 == noDays && day == 0) {
                            s.apmEnd = 0;
                        } else if (j + 1 == noDays && (s.apmEnd == 1 || s.apmEnd == 2)) {
                            duration += 0.5;
                        } else if (j == 0 && s.apmEnd == 0) {
                            duration += 1;
                        } else if (day == 6) {
                            if (this.state.holiday.saturdayWork == 0) {
                                duration += 1;
                            } else if (this.state.holiday.saturdayWork == 1) {
                                duration += 0.5;
                            }
                        } else if (day == 0) {} else {
                            duration += 1;
                        }
                    }
                }
                console.log(duration);
                //if end date less than start date
                if (noDays <= 0) {
                    _modalAction2.default.modalContent({ title: "Warning", content: "End Date must be greater than start Date" });
                    _modalAction2.default.modalClose(true);
                    s.endYear = 0;
                    s.endMonth = 0;
                    s.endDate = 0;
                    s.apmEnd = 0;
                    this.setState({ leave: s });
                    return;
                }
                //s.duration = duration - minus;
                s.duration = duration;
                this.setState({ leave: s });
            } else if (s.type == 7) {

                if (s.startTime && s.endTime) {
                    var _sDate = new Date(s.startYear, s.startMonth, s.startDate, parseInt(s.startTime.split(":")[0]), parseInt(s.startTime.split(":")[1]));
                    var _eDate = new Date(s.startYear, s.startMonth, s.startDate, parseInt(s.endTime.split(":")[0]), parseInt(s.endTime.split(":")[1]));
                    var _duration = 0;
                    var _isHoliday = this.isHoliday(s.startYear, s.startMonth, s.startDate);
                    if (!_isHoliday) {
                        _duration = (_eDate.getTime() - _sDate.getTime()) / 1000 / 60 / 60;

                        if (_duration <= 0) {
                            _modalAction2.default.modalContent({ title: "Warning", content: "End Time must be greater than Start Time" });
                            _modalAction2.default.modalClose(true);
                            s.endTime = "";
                            _duration = 0;
                        }
                    }

                    s.duration = _duration;
                }

                this.setState({ leave: s });
            }
        }
    }, {
        key: '_previewImage',
        value: function _previewImage(file, index) {
            var _this2 = this;

            //to be modified
            var fr = new FileReader();
            fr.onload = function (e) {
                var imgUrl = window.URL.createObjectURL(new Blob([e.target.result]));
                var img = new Image();

                img.onload = function () {
                    _this2.resizeImage(img, index);
                };

                img.src = imgUrl;
            };
            fr.readAsArrayBuffer(file);
        }
    }, {
        key: 'resizeImage',
        value: function resizeImage(image, index) {
            var oHeight = image.naturalHeight;
            var oWidth = image.naturalWidth;
            var newImage = void 0,
                newSize = void 0;
            var oSize = { oHeight: oHeight, oWidth: oWidth };
            newSize = { width: 500, height: 500 * oHeight / oWidth };

            newImage = this._imgResize(image, newSize, oSize);
            var blobFile = this.dataURItoBlob(newImage);
            var leave = this.state.leave;
            if (index == 0) {
                leave.leaveImage = blobFile;
            } else if (index == 1) {
                leave.receiptImage = blobFile;
            }
            this.setState({ leave: leave });
        }
    }, {
        key: 'dataURItoBlob',
        value: function dataURItoBlob(dataURI) {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = window.atob(dataURI.split(',')[1]);else byteString = unescape(dataURI.split(',')[1]);

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], { type: mimeString });
        }
    }, {
        key: '_imgResize',
        value: function _imgResize(img, newSize, oSize) {
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext("2d");
            canvas.width = newSize.width;
            canvas.height = newSize.height;
            ctx.drawImage(img, 0, 0, oSize.oWidth, oSize.oHeight, 0, 0, newSize.width, newSize.height);
            return canvas.toDataURL('image/jpeg', 1);
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            //check available
            var s = this.state.leave;
            var available = void 0;
            var len = this.state.summary.length;
            var summary = this.state.summary;
            if (this.state.staffId == "") {
                _modalAction2.default.modalContent({ title: "Warning", content: "Please select staff name" });
                _modalAction2.default.modalClose(true);
                return;
            }
            if (s.type != 7) {
                if (s.startYear == 0 || s.startDate == 0 || s.endYear == 0 || s.endDate == 0) {
                    //show warning
                    _modalAction2.default.modalContent({ title: "Warning", content: "Please select Date" });
                    _modalAction2.default.modalClose(true);
                    return;
                }
            } else if (s.type == 7) {
                if (s.startYear == 0 || s.startDate == 0 || s.startTime == "" || s.endTime == "") {
                    //show warning
                    _modalAction2.default.modalContent({ title: "Warning", content: "Please fill up Start Date, Start Time and End Time" });
                    _modalAction2.default.modalClose(true);
                    return;
                }
            }

            for (var i = 0; i < len; i++) {
                if (s.type == 0 && s.type == summary[i].type) {
                    available = summary[i].leaveGain + summary[i].bringFwd - summary[i].used;
                } else if (s.type == 9 && s.type == summary[i].type) {
                    var annualTotalAvail = this.findAnnualTotalAvail();
                    available = Math.min(annualTotalAvail, summary[i].totalGaim - summary[i].used);
                } else if (s.type != 4 && s.type != 6 && s.type == summary[i].type) {
                    available = summary[i].totalGain - summary[i].used;
                }
            }
            if (s.type != 4 && s.type != 6) {
                if (available < s.duration) {
                    //show warning
                    _modalAction2.default.modalContent({ title: "Warning", content: "Your leave balance is not enough" });
                    _modalAction2.default.modalClose(true);
                    return;
                }
            } else if (s.reason == "") {
                _modalAction2.default.modalContent({ title: "Warning", content: "Reason is needed for unpaid leave or other leave" });
                _modalAction2.default.modalClose(true);
                return;
            }
            //submit
            var fd = new FormData();
            if (s.leaveImage) {
                fd.append("images", s.leaveImage);
            }
            if (s.receiptImage) {
                fd.append("receipt", s.receiptImage);
            }
            fd.append("staffId", this.state.staffId);
            fd.append("type", s.type);
            fd.append("startYear", s.startYear);
            fd.append("startMonth", s.startMonth);
            fd.append("startDate", s.startDate);
            fd.append("endYear", s.endYear);
            fd.append("endMonth", s.endMonth);
            fd.append("endDate", s.endDate);
            fd.append("apmStart", s.apmStart);
            fd.append("apmEnd", s.apmEnd);
            fd.append("duration", s.duration);
            fd.append("reason", s.reason);
            fd.append("startTime", s.startTime);
            fd.append("endTime", s.endTime);

            _leaveAtdAction2.default.processing(true);
            _leaveAtdAction2.default.applyStaffLeave(fd);
            this.clear();
        }
    }, {
        key: 'findAnnualTotalAvail',
        value: function findAnnualTotalAvail() {
            var annualTotalAvail = 0;
            //need to loop to find
            for (var i = 0; i < this.state.summary.length; i++) {
                if (this.state.summary[i].type == 0) {
                    annualTotalAvail = this.state.summary[i].totalGain + this.state.summary[i].bringFwd - this.state.summary[i].used;
                }
            }
            return annualTotalAvail;
        }
    }, {
        key: 'renderType',
        value: function renderType() {
            var _this3 = this;

            var annualTotalAvail = 0;
            if (this.state.summary) {
                return this.state.summary.map(function (summary, index) {
                    var available = void 0;
                    if (summary.type == 0) {
                        available = summary.leaveGain + summary.bringFwd - summary.used;
                        annualTotalAvail = summary.totalGain + summary.bringFwd - summary.used;
                    } else if (summary.type == 9) {
                        if (annualTotalAvail == 0) {
                            annualTotalAvail = _this3.findAnnualTotalAvail();
                        }
                        available = Math.min(annualTotalAvail, summary.totalGain - summary.used);
                    } else if (summary.type != 4 && summary.type != 6) {
                        available = summary.totalGain - summary.used;
                    } else if (summary.type == 4 || summary.type == 6) {
                        return _react2.default.createElement(
                            'option',
                            { value: summary.type, key: index },
                            summary.leaveTxt
                        );
                    }

                    if (summary.type == 7) {
                        return _react2.default.createElement(
                            'option',
                            { value: summary.type, key: index },
                            summary.leaveTxt,
                            ' (',
                            available + (available <= 1 ? " hour" : " hours"),
                            ')'
                        );
                    }
                    return _react2.default.createElement(
                        'option',
                        { value: summary.type, key: index },
                        summary.leaveTxt,
                        ' (',
                        available + (available <= 1 ? " day" : " days"),
                        ')'
                    );
                });
            }
        }
    }, {
        key: 'renderAPM',
        value: function renderAPM() {
            var _this4 = this;

            var index = [0, 1, 2];
            return index.map(function (index) {
                return _react2.default.createElement(
                    'option',
                    { value: index, key: index },
                    _this4.props.apmTxt[index]
                );
            });
        }
    }, {
        key: 'renderStaffs',
        value: function renderStaffs() {
            var _this5 = this;

            var staffs = this.props.staffs;
            if (staffs.length > 0) {
                staffs = this.props.staffs.filter(function (staff) {
                    return _genFunction2.default.hasPermission(_this5.state.permission, 11) || _genFunction2.default.isSubordinate(_this5.state.subordinate, staff.staffId);
                });

                return staffs.map(function (staff, index) {
                    return _this5.renderStaff(staff, index);
                });
            }
        }
    }, {
        key: 'renderStaff',
        value: function renderStaff(staff, index) {
            return _react2.default.createElement(
                'option',
                { value: staff.staffId, key: index },
                staff.userName
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var s = this.state.leave;
            var sDate = "";
            var eDate = "";
            if (s.startDate != 0) {
                var startDate = s.startDate < 10 ? "0" + s.startDate : s.startDate;
                var startMonth = s.startMonth + 1 < 10 ? "0" + (s.startMonth + 1) : s.startMonth + 1;
                sDate = s.startYear + "-" + startMonth + "-" + startDate;
            }
            if (s.endDate != 0) {
                var endDate = s.endDate < 10 ? "0" + s.endDate : s.endDate;
                var endMonth = s.endMonth + 1 < 10 ? "0" + (s.endMonth + 1) : s.endMonth + 1;
                eDate = s.endYear + "-" + endMonth + "-" + endDate;
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'staffName' },
                                'Staff Name: '
                            ),
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control atd-sel', id: 'staffName', name: 'staffName', 'data-index': '9',
                                    onChange: this.handleChange, value: this.state.staffId },
                                _react2.default.createElement('option', { value: '' }),
                                this.renderStaffs()
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'type' },
                                'Type'
                            ),
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control atd-sel', name: 'type', 'data-index': '0',
                                    onChange: this.handleChange, value: s.type, disabled: this.state.staffId == "" },
                                this.renderType()
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'startDate' },
                                'Start Date'
                            ),
                            _react2.default.createElement('input', { type: 'date', className: 'form-control', value: sDate, id: 'startDate',
                                placeholder: 'Pick a date', 'data-index': '1', onChange: this.handleEdit, disabled: this.state.staffId == "" })
                        ),
                        s.type != 7 ? _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'apmStart' },
                                    'AM/PM'
                                ),
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control atd-sel', name: 'apmStart', 'data-index': '2',
                                        onChange: this.handleChange, value: s.apmStart, disabled: this.state.staffId == "" },
                                    this.renderAPM()
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'endDate' },
                                    'End Date'
                                ),
                                _react2.default.createElement('input', { type: 'date', className: 'form-control', value: eDate, id: 'endDate',
                                    placeholder: 'Pick a date', 'data-index': '3', onChange: this.handleEdit,
                                    disabled: s.startDate == 0 })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'apmEnd' },
                                    'AM/PM'
                                ),
                                _react2.default.createElement(
                                    'select',
                                    { className: 'form-control atd-sel', name: 'apmEnd', 'data-index': '4',
                                        onChange: this.handleChange, value: s.apmEnd,
                                        disabled: s.endDate == 0 || s.startDate == s.endDate && s.startMonth == s.endMonth && s.startYear == s.endYear },
                                    this.renderAPM()
                                )
                            )
                        ) : _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'endDate' },
                                    'Start Time'
                                ),
                                _react2.default.createElement('input', { type: 'time', className: 'form-control', value: s.startTime, id: 'startTime',
                                    'data-index': '7', onChange: this.handleTimeEdit,
                                    disabled: s.startDate == 0 })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'endTime' },
                                    'End Time'
                                ),
                                _react2.default.createElement('input', { type: 'time', className: 'form-control', value: s.endTime, id: 'endTime',
                                    'data-index': '8', onChange: this.handleTimeEdit,
                                    disabled: s.startDate == 0, step: '1800' })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'reason' },
                                'Reason'
                            ),
                            _react2.default.createElement('textarea', { rows: '3', name: 'reason', onChange: this.handleEdit, 'data-index': '5', value: s.reason,
                                style: { width: "100%", resize: "none" }, step: '1800' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'duration' },
                                'Duration (',
                                s.type == 7 ? "hour" : "day",
                                ')'
                            ),
                            _react2.default.createElement('input', { type: 'number', className: 'form-control', value: s.duration, id: 'endDate',
                                placeholder: 'duration', 'data-index': '6', onChange: this.handleEdit,
                                disabled: true })
                        ),
                        s.type == 1 ? _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'uploadMC' },
                                    'Upload MC'
                                ),
                                _react2.default.createElement('input', { type: 'file', name: 'uploadMC', accept: 'image/*', 'data-index': '0', onChange: this.upLoadImg })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group' },
                                _react2.default.createElement(
                                    'label',
                                    { htmlFor: 'uploadMC' },
                                    'Upload Receipt'
                                ),
                                _react2.default.createElement('input', { type: 'file', name: 'uploadMC', accept: 'image/*', 'data-index': '1', onChange: this.upLoadImg })
                            )
                        ) : ""
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-default', onClick: this.handleSubmit },
                            'Apply'
                        )
                    )
                )
            );
        }
    }]);

    return LeaveStaffApply;
}(_react2.default.Component);

LeaveStaffApply.defaultProps = {
    apmTxt: ["Full Day", "AM", "PM"]
};
exports.default = LeaveStaffApply;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

var _leaveAtdStore = __webpack_require__(58);

var _leaveAtdStore2 = _interopRequireDefault(_leaveAtdStore);

var _leaveAtdAction = __webpack_require__(59);

var _leaveAtdAction2 = _interopRequireDefault(_leaveAtdAction);

var _userStore = __webpack_require__(7);

var _userStore2 = _interopRequireDefault(_userStore);

var _genFunction = __webpack_require__(10);

var _genFunction2 = _interopRequireDefault(_genFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AtdStaffApply = function (_React$Component) {
    _inherits(AtdStaffApply, _React$Component);

    function AtdStaffApply(props) {
        _classCallCheck(this, AtdStaffApply);

        var _this = _possibleConstructorReturn(this, (AtdStaffApply.__proto__ || Object.getPrototypeOf(AtdStaffApply)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.state = {
            permission: _userStore2.default.getState().permission,
            subordinate: _userStore2.default.getState().subordinate,
            userId: _userStore2.default.getState().staffId,
            isAtdSuccess: _leaveAtdStore2.default.getState().isAtdSuccess,
            staffId: _leaveAtdStore2.default.getState().staffId,
            date: "",
            startTime: "",
            startLocation: "",
            startRemark: "",
            endTime: "",
            endLocation: "",
            endRemark: ""

        };
        return _this;
    }

    _createClass(AtdStaffApply, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _leaveAtdStore2.default.listen(this.onChange);
            _userStore2.default.listen(this.onUserChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _leaveAtdStore2.default.unlisten(this.onChange);
            _userStore2.default.unlisten(this.onUserChange);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.isAtdSuccess && prevState.isAtdSuccess != this.state.isAtdSuccess) {
                window.setTimeout(function () {
                    window.location.reload();
                }, 3000);
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                staffId: state.staffId,
                isAtdSuccess: state.isAtdSuccess
            });
        }
    }, {
        key: 'onUserChange',
        value: function onUserChange(state) {
            this.setState({
                permission: state.permission,
                subordinate: state.subordinate,
                userId: state.staffId
            });
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            if (index == 0) {
                _leaveAtdAction2.default.staffId(e.target.value);
            } else if (index == 1) {
                this.setState({
                    date: e.target.value
                });
            } else if (index == 2) {
                this.setState({
                    startTime: e.target.value
                });
            } else if (index == 3) {
                this.setState({
                    startLocation: e.target.value
                });
            } else if (index == 4) {
                this.setState({
                    startRemark: e.target.value
                });
            } else if (index == 5) {
                this.setState({
                    endTime: e.target.value
                });
            } else if (index == 6) {
                this.setState({
                    endLocation: e.target.value
                });
            } else if (index == 7) {
                this.setState({
                    endRemark: e.target.value
                });
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            var s = this.state;
            var sDate = s.date;
            var date = void 0,
                month = void 0,
                year = void 0,
                startTime = void 0,
                endTime = void 0;

            if (sDate == "") {
                _modalAction2.default.modalContent({ title: "Warning", content: "Please select Date" });
                _modalAction2.default.modalClose(true);
                return;
            } else if (s.startTime == "" || s.endTime == "") {
                _modalAction2.default.modalContent({ title: "Warning", content: "Please Start Time and End Time cannot be empty" });
                _modalAction2.default.modalClose(true);
                return;
            } else if (s.staffId == "") {
                _modalAction2.default.modalContent({ title: "Warning", content: "Please select Staff" });
                _modalAction2.default.modalClose(true);
                return;
            }
            date = parseInt(sDate.split("-")[2]);
            month = parseInt(sDate.split("-")[1]) - 1;
            year = parseInt(sDate.split("-")[0]);

            startTime = new Date(year, month, date, s.startTime.split(":")[0], s.startTime.split(":")[1]);
            endTime = new Date(year, month, date, s.endTime.split(":")[0], s.endTime.split(":")[1]);

            if (endTime.getTime() < startTime.getTime()) {
                _modalAction2.default.modalContent({ title: "Warning", content: "End Time must be greater than Start Time" });
                _modalAction2.default.modalClose(true);
                return;
            }

            if (!this.props.processing) {
                _leaveAtdAction2.default.processing(true);
                _leaveAtdAction2.default.markAttendate(s.staffId, year, month, date, startTime, s.startLocation, s.startRemark, endTime, s.endLocation, s.endRemark);
            }
        }
    }, {
        key: 'renderStaffs',
        value: function renderStaffs() {
            var _this2 = this;

            var staffs = this.props.staffs;
            if (staffs.length > 0) {
                staffs = this.props.staffs.filter(function (staff) {
                    return _genFunction2.default.hasPermission(_this2.state.permission, 11) && _this2.state.userId != staff.staffId || _genFunction2.default.isSubordinate(_this2.state.subordinate, staff.staffId) && _this2.state.userId != staff.staffId;
                });

                return staffs.map(function (staff, index) {
                    return _this2.renderStaff(staff, index);
                });
            }
        }
    }, {
        key: 'renderStaff',
        value: function renderStaff(staff, index) {
            return _react2.default.createElement(
                'option',
                { value: staff.staffId, key: index },
                staff.userName
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var s = this.state;
            var today = new Date();
            var max = today.getFullYear() + "-" + (today.getMonth() + 1 < 10 ? "0" + (today.getMonth() + 1) : today.getMonth() + 1) + "-" + (today.getDate() < 10 ? "0" + today.getDate() : today.getDate());
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'staffName' },
                                'Staff Name: '
                            ),
                            _react2.default.createElement(
                                'select',
                                { className: 'form-control atd-sel', id: 'staffName', name: 'staffName', 'data-index': '0',
                                    onChange: this.handleChange, value: s.staffId },
                                _react2.default.createElement('option', { value: '' }),
                                this.renderStaffs()
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'date' },
                                'Date'
                            ),
                            _react2.default.createElement('input', { className: 'form-control atd-sel', type: 'date', name: 'date', 'data-index': '1',
                                onChange: this.handleChange, value: s.date, disabled: s.staffId == "", max: max })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'startTime' },
                                'Start Time'
                            ),
                            _react2.default.createElement('input', { className: 'form-control atd-sel', type: 'time', name: 'startTime', 'data-index': '2',
                                onChange: this.handleChange, value: s.startTime, disabled: s.staffId == "" })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'startLocation' },
                                'Start Location'
                            ),
                            _react2.default.createElement('input', { className: 'form-control atd-sel', type: 'text', name: 'startLocation', 'data-index': '3',
                                onChange: this.handleChange, value: s.startLocation, disabled: s.staffId == "" })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'date' },
                                'Start Remark'
                            ),
                            _react2.default.createElement('input', { className: 'form-control atd-sel', type: 'text', name: 'startRemark', 'data-index': '4',
                                onChange: this.handleChange, value: s.startRemark, disabled: s.staffId == "" })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'endTime' },
                                'End Time'
                            ),
                            _react2.default.createElement('input', { className: 'form-control atd-sel', type: 'time', name: 'endTime', 'data-index': '5',
                                onChange: this.handleChange, value: s.endTime, disabled: s.staffId == "" })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'endLocation' },
                                'End Location'
                            ),
                            _react2.default.createElement('input', { className: 'form-control atd-sel', type: 'text', name: 'endLocation', 'data-index': '6',
                                onChange: this.handleChange, value: s.endLocation, disabled: s.staffId == "" })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'endRemark' },
                                'End Remark'
                            ),
                            _react2.default.createElement('input', { className: 'form-control atd-sel', type: 'text', name: 'endRemark', 'data-index': '7',
                                onChange: this.handleChange, value: s.endRemark, disabled: s.staffId == "" })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-4' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-default', onClick: this.handleSubmit },
                            'Apply'
                        )
                    )
                )
            );
        }
    }]);

    return AtdStaffApply;
}(_react2.default.Component);

exports.default = AtdStaffApply;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _sideMenu = __webpack_require__(4);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _navBar = __webpack_require__(6);

var _navBar2 = _interopRequireDefault(_navBar);

var _menuAction = __webpack_require__(3);

var _menuAction2 = _interopRequireDefault(_menuAction);

var _leaveSetAction = __webpack_require__(22);

var _leaveSetAction2 = _interopRequireDefault(_leaveSetAction);

var _leaveSetStore = __webpack_require__(46);

var _leaveSetStore2 = _interopRequireDefault(_leaveSetStore);

var _loading = __webpack_require__(5);

var _loading2 = _interopRequireDefault(_loading);

var _holidayModal = __webpack_require__(291);

var _holidayModal2 = _interopRequireDefault(_holidayModal);

var _modalAction = __webpack_require__(11);

var _modalAction2 = _interopRequireDefault(_modalAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HolidaySetting = function (_React$Component) {
    _inherits(HolidaySetting, _React$Component);

    function HolidaySetting(props) {
        _classCallCheck(this, HolidaySetting);

        var _this = _possibleConstructorReturn(this, (HolidaySetting.__proto__ || Object.getPrototypeOf(HolidaySetting)).call(this, props));

        _this.handleEventAdd = function (e) {
            var index = 0;
            var action = 3;
            var title = "Add Event";

            _this.setState({
                index: index,
                action: action,
                title: title,
                modalClose: true
            });
        };

        _this.handleEventRemove = function (e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            var title = "Remove Event";
            var action = 2;
            _this.setState({
                index: index,
                action: action,
                title: title,
                modalClose: true
            });
        };

        _this.renderEvent = function () {
            if (!_this.state.holiday.event) return;

            return _this.state.holiday.event.map(function (event, index) {
                var year = void 0,
                    month = void 0,
                    date = void 0;
                year = event.year;
                month = event.month;
                date = event.date;
                var hDate = date + "-" + _this.props.mthTxt[month] + "-" + year;
                return _react2.default.createElement(
                    'div',
                    { className: 'col-sm-3', key: index },
                    _react2.default.createElement(
                        'div',
                        { className: 'hd-wp' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-danger btn-xs hd-btn-1', 'data-index': index, onClick: _this.handleEventRemove },
                            'Remove'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'hd-title' },
                            _react2.default.createElement(
                                'b',
                                null,
                                event.title
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'hd-date' },
                            hDate
                        )
                    )
                );
            });
        };

        _this.onChange = _this.onChange.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.handleRemove = _this.handleRemove.bind(_this);
        _this.shouldModalClose = _this.shouldModalClose.bind(_this);
        _this.handleAdd = _this.handleAdd.bind(_this);
        _this.handleSave = _this.handleSave.bind(_this);
        _this.state = {
            processing: _leaveSetStore2.default.getState().processing,
            holiday: _leaveSetStore2.default.getState().holiday,
            isHolidayUpdated: _leaveSetStore2.default.getState().isHolidayUpdated,
            modalClose: false,
            action: 0,
            title: "",
            index: ""
        };
        return _this;
    }

    _createClass(HolidaySetting, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _menuAction2.default.pageNumber(17);
            _leaveSetStore2.default.listen(this.onChange);
            if (!this.state.processing) {
                _leaveSetAction2.default.processing(true);
                _leaveSetAction2.default.getHoliday();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _leaveSetStore2.default.unlisten(this.onChange);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.isHolidayUpdated && prevState.isHolidayUpdated != this.state.isHolidayUpdated) {
                window.setTimeout(function () {
                    window.location.reload();
                }, 3000);
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(state) {
            this.setState({
                processing: state.processing,
                holiday: state.holiday,
                isHolidayUpdated: state.isHolidayUpdated
            });
        }
    }, {
        key: 'shouldModalClose',
        value: function shouldModalClose(data) {
            this.setState({
                modalClose: data
            });
        }
    }, {
        key: 'handleEdit',
        value: function handleEdit(e) {
            var index = parseInt(e.target.value);

            var holiday = this.state.holiday;
            holiday.saturdayWork = index;
            _leaveSetAction2.default.holiday(holiday);
        }
    }, {
        key: 'handleAdd',
        value: function handleAdd(e) {
            var index = 0;
            var action = 0;
            var title = "Add Holiday";

            this.setState({
                index: index,
                action: action,
                title: title,
                modalClose: true
            });
        }
    }, {
        key: 'handleSave',
        value: function handleSave(e) {
            if (this.state.processing) return;

            //updateholiday;
            if (typeof this.state.holiday.saturdayWork != 'number') {
                _modalAction2.default.modalContent({ title: "Warning", content: "Please select Saturday Work" });
                _modalAction2.default.modalClose(true);
                return;
            }
            _leaveSetAction2.default.processing(true);
            _leaveSetAction2.default.updateHoliday(this.state.holiday);
        }
    }, {
        key: 'handleRemove',
        value: function handleRemove(e) {
            var index = parseInt(e.target.getAttribute('data-index'));
            var title = "Remove Holiday";
            var action = 1;
            this.setState({
                index: index,
                action: action,
                title: title,
                modalClose: true
            });
        }
    }, {
        key: 'renderOption',
        value: function renderOption() {
            return this.props.saturdayWork.map(function (sat, index) {
                return _react2.default.createElement(
                    'option',
                    { value: index, key: index },
                    sat
                );
            });
        }
    }, {
        key: 'renderHoliday',
        value: function renderHoliday() {
            var _this2 = this;

            if (!this.state.holiday.holiday) return;

            return this.state.holiday.holiday.map(function (holiday, index) {
                var year = void 0,
                    month = void 0,
                    date = void 0;
                year = holiday.year;
                month = holiday.month;
                date = holiday.date;
                var hDate = date + "-" + _this2.props.mthTxt[month] + "-" + year;
                return _react2.default.createElement(
                    'div',
                    { className: 'col-sm-3', key: index },
                    _react2.default.createElement(
                        'div',
                        { className: 'hd-wp' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-danger btn-xs hd-btn-1', 'data-index': index, onClick: _this2.handleRemove },
                            'Remove'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'hd-title' },
                            _react2.default.createElement(
                                'b',
                                null,
                                holiday.title
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'hd-date' },
                            hDate
                        )
                    )
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var s = this.state.holiday;
            var modal = void 0;
            if (this.state.modalClose) {
                modal = _react2.default.createElement(_holidayModal2.default, { modalClose: this.state.modalClose, shouldModalClose: this.shouldModalClose,
                    title: this.state.title, action: this.state.action, index: this.state.index, holiday: this.state.holiday });
            }

            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_navBar2.default, this.props),
                    _react2.default.createElement(_sideMenu2.default, this.props),
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 us-form' },
                        _react2.default.createElement(
                            'h4',
                            null,
                            _react2.default.createElement(
                                'b',
                                null,
                                'Holiday Management'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group' },
                                    _react2.default.createElement(
                                        'label',
                                        null,
                                        ' Saturday Working'
                                    ),
                                    _react2.default.createElement(
                                        'select',
                                        { className: 'form-control', id: 'saturdayWork', onChange: this.handleEdit,
                                            value: typeof s.saturdayWork == 'number' ? s.saturdayWork : "" },
                                        _react2.default.createElement('option', { value: '' }),
                                        this.renderOption()
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement('div', { className: 'divider' }),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'control-label' },
                                        'Holiday:'
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { className: 'btn btn-default btn-xs jps-add ', onClick: this.handleAdd },
                                        'Add Holiday'
                                    )
                                ),
                                _react2.default.createElement(
                                    'small',
                                    null,
                                    'Holidays fall on Sunday should change to Monday '
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            this.renderHoliday()
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement('div', { className: 'divider' }),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'control-label' },
                                        'Event:'
                                    ),
                                    _react2.default.createElement(
                                        'button',
                                        { className: 'btn btn-default btn-xs jps-add ', onClick: this.handleEventAdd },
                                        'Add Event'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            this.renderEvent()
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-3' },
                                _react2.default.createElement(
                                    'button',
                                    { className: 'btn btn-default', onClick: this.handleSave },
                                    'Save'
                                )
                            )
                        )
                    )
                ),
                modal,
                _react2.default.createElement(_loading2.default, { processing: this.state.processing })
            );
        }
    }]);

    return HolidaySetting;
}(_react2.default.Component);

HolidaySetting.defaultProps = {
    saturdayWork: ["Full Day", "Half Day", "Off Day"],
    mthTxt: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]
};
exports.default = HolidaySetting;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _leaveSetAction = __webpack_require__(22);

var _leaveSetAction2 = _interopRequireDefault(_leaveSetAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HolidayModal = function (_React$Component) {
    _inherits(HolidayModal, _React$Component);

    function HolidayModal(props) {
        _classCallCheck(this, HolidayModal);

        var _this = _possibleConstructorReturn(this, (HolidayModal.__proto__ || Object.getPrototypeOf(HolidayModal)).call(this, props));

        _this.modalClose = _this.modalClose.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.state = {
            month: 0,
            year: 0,
            date: 0,
            title: "",
            warningMsg: ""
        };
        return _this;
    }

    _createClass(HolidayModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var index = parseInt(e.currentTarget.getAttribute("data-index"));
            if (index == 0) {
                var sDate = e.target.value;
                var year = void 0,
                    month = void 0,
                    date = void 0;
                year = parseInt(sDate.split("-")[0]);
                month = parseInt(sDate.split("-")[1]) - 1;
                date = parseInt(sDate.split("-")[2]);

                this.setState({
                    year: year, month: month, date: date
                });
            } else {
                var title = e.target.value;
                this.setState({
                    title: title
                });
            }
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            if (this.props.action == 0) {
                //update to server
                if (this.state.date == 0 || this.state.year == 0) {
                    return this.setState({ warningMsg: "Please select Date" });
                }
                if (this.state.title == "") {
                    return this.setState({ warningMsg: "Name of holiday cannot be empty" });
                }
                var holiday = this.props.holiday;
                if (holiday.holiday) {
                    holiday.holiday = holiday.holiday.concat({
                        year: this.state.year,
                        month: this.state.month,
                        date: this.state.date,
                        title: this.state.title
                    });
                } else {
                    holiday.holiday = [{
                        year: this.state.year,
                        month: this.state.month,
                        date: this.state.date,
                        title: this.state.title
                    }];
                }
                _leaveSetAction2.default.holiday(holiday);
                this.props.shouldModalClose(false);
            } else if (this.props.action == 1) {
                var _holiday = this.props.holiday;
                _holiday.holiday.splice(this.props.index, 1);
                _leaveSetAction2.default.holiday(_holiday);
                this.props.shouldModalClose(false);
            } else if (this.props.action == 2) {
                var _holiday2 = this.props.holiday;
                _holiday2.event.splice(this.props.index, 1);
                _leaveSetAction2.default.holiday(_holiday2);
                this.props.shouldModalClose(false);
            } else {
                //update to server
                if (this.state.date == 0 || this.state.year == 0) {
                    return this.setState({ warningMsg: "Please select Date" });
                }
                if (this.state.title == "") {
                    return this.setState({ warningMsg: "Name of Event cannot be empty" });
                }
                var _holiday3 = this.props.holiday;
                if (_holiday3.event) {
                    _holiday3.event = _holiday3.event.concat({
                        year: this.state.year,
                        month: this.state.month,
                        date: this.state.date,
                        title: this.state.title
                    });
                } else {
                    _holiday3.event = [{
                        year: this.state.year,
                        month: this.state.month,
                        date: this.state.date,
                        title: this.state.title
                    }];
                }
                _leaveSetAction2.default.holiday(_holiday3);
                this.props.shouldModalClose(false);
            }
        }
    }, {
        key: 'modalClose',
        value: function modalClose() {
            this.props.shouldModalClose(false);
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            var s = this.state;
            var dates = void 0;
            if (s.year != 0) {
                dates = s.year + "-" + (s.month + 1 < 10 ? "0" + (s.month + 1) : s.month + 1) + "-" + (s.date < 10 ? "0" + s.date : s.date);
            }
            if (this.props.action == 0) {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'form',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'title' },
                                'Holiday:'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'title', placeholder: 'Type Holiday Here',
                                value: this.state.title,
                                onChange: this.handleChange, 'data-index': '1' })
                        )
                    ),
                    _react2.default.createElement(
                        'form',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'date' },
                                'Date:'
                            ),
                            _react2.default.createElement('input', { type: 'date', className: 'form-control', id: 'date', value: dates ? dates : "",
                                onChange: this.handleChange, 'data-index': '0' })
                        )
                    )
                );
            } else if (this.props.action == 1) {
                var _s = this.props.holiday.holiday[this.props.index];
                var _dates = void 0;
                _dates = _s.date + "-" + this.props.mthTxt[_s.month] + "-" + _s.year;
                return _react2.default.createElement(
                    'div',
                    null,
                    'Are you sure to remove ',
                    this.props.holiday.holiday[this.props.index].title,
                    ' on ',
                    _dates,
                    '?'
                );
            } else if (this.props.action == 2) {
                var _s2 = this.props.holiday.event[this.props.index];
                var _dates2 = void 0;
                _dates2 = _s2.date + "-" + this.props.mthTxt[_s2.month] + "-" + _s2.year;
                return _react2.default.createElement(
                    'div',
                    null,
                    'Are you sure to remove ',
                    this.props.holiday.event[this.props.index].title,
                    ' on ',
                    _dates2,
                    '?'
                );
            } else {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'form',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'title' },
                                'Event:'
                            ),
                            _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'title', placeholder: 'Type Event Here',
                                value: this.state.title,
                                onChange: this.handleChange, 'data-index': '1' })
                        )
                    ),
                    _react2.default.createElement(
                        'form',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'date' },
                                'Date:'
                            ),
                            _react2.default.createElement('input', { type: 'date', className: 'form-control', id: 'date', value: dates ? dates : "",
                                onChange: this.handleChange, 'data-index': '0' })
                        )
                    )
                );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: 'report-shadow', style: style }),
                _react2.default.createElement(
                    'div',
                    { className: 'report-modal', style: { visibility: style.visibility }, ref: 'modal' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'modal-title' },
                            this.props.title
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body' },
                        _react2.default.createElement(
                            'div',
                            { className: 'warning' },
                            this.state.warningMsg
                        ),
                        this.renderContent()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-footer' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-warning', onClick: this.handleClick },
                            'Done'
                        ),
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'btn btn-default', onClick: this.modalClose },
                            'Cancel'
                        )
                    )
                )
            );
        }
    }]);

    return HolidayModal;
}(_react2.default.Component);

HolidayModal.defaultProps = {
    styleHide: {
        visibility: 'hidden',
        background: 'rgba(0,0,0,0)'
    },
    styleShow: {
        visibility: 'visible',
        background: 'rgba(0,0,0,0.5)'
    },
    mthTxt: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]
};
exports.default = HolidayModal;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Policy = function (_React$Component) {
    _inherits(Policy, _React$Component);

    function Policy(props) {
        _classCallCheck(this, Policy);

        return _possibleConstructorReturn(this, (Policy.__proto__ || Object.getPrototypeOf(Policy)).call(this, props));
    }

    _createClass(Policy, [{
        key: 'componentWillMount',
        value: function componentWillMount() {}
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'container-fluid content' },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: ' col-md-10  col-sm-8 atd' },
                        _react2.default.createElement(
                            'h3',
                            null,
                            'Privacy Policy'
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            'This SERVICE is provided by A4 International and is intended for use as is.',
                            _react2.default.createElement('br', null),
                            'This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at A4 International unless otherwise defined in this Privacy Policy.',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'b',
                                null,
                                'Information Collection and Use'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to user\'s photos. ',
                            _react2.default.createElement('br', null),
                            'The information that we request will be retained by us and used as described in this privacy policy.',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'The app does use third party services that may collect information used to identify you.',
                            _react2.default.createElement('br', null),
                            'Link to privacy policy of third party service providers used by the app',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'a',
                                { href: 'https://policies.google.com/privacy' },
                                'Google Play Services'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'b',
                                null,
                                'Log Data'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (\u201CIP\u201D) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'b',
                                null,
                                'Cookies'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device\'s internal memory.',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'This Service does not use these \u201Ccookies\u201D explicitly. However, the app may use third party code and libraries that use \u201Ccookies\u201D to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'b',
                                null,
                                'Service Providers'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'We may employ third-party companies and individuals due to the following reasons:',
                            _react2.default.createElement('br', null),
                            'To facilitate our Service;',
                            _react2.default.createElement('br', null),
                            'To provide the Service on our behalf;',
                            _react2.default.createElement('br', null),
                            'To perform Service-related services; or',
                            _react2.default.createElement('br', null),
                            'To assist us in analyzing how our Service is used.',
                            _react2.default.createElement('br', null),
                            'We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'b',
                                null,
                                'Security'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'b',
                                null,
                                'Changes to This Privacy Policy'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement('br', null),
                            'We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.'
                        )
                    )
                )
            );
        }
    }]);

    return Policy;
}(_react2.default.Component);

exports.default = Policy;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// client.js